var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { r as registerInstance, g as getElement, h, c as createEvent, H as Host, e as environments } from './core-8cdfd18b.js';
import { c as commonjsGlobal, a as createCommonjsModule, u as unwrapExports } from './_commonjsHelpers-1572f81d.js';
var ContextConsumer = /** @class */ (function () {
    function ContextConsumer(hostRef) {
        registerInstance(this, hostRef);
        this.context = {};
        this.renderer = function () { return null; };
    }
    ContextConsumer.prototype.connectedCallback = function () {
        if (this.subscribe != null) {
            this.unsubscribe = this.subscribe(this.el, 'context');
        }
    };
    ContextConsumer.prototype.disconnectedCallback = function () {
        if (this.unsubscribe != null) {
            this.unsubscribe();
        }
    };
    ContextConsumer.prototype.render = function () {
        return this.renderer(Object.assign({}, this.context));
    };
    Object.defineProperty(ContextConsumer.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    return ContextConsumer;
}());
var DemoShell = /** @class */ (function () {
    function DemoShell(hostRef) {
        registerInstance(this, hostRef);
    }
    DemoShell.prototype.componentDidLoad = function () {
        // const { shellEl, scopeEl, searchEl, navEl } = this;
        var _g = this, shellEl = _g.shellEl, navEl = _g.navEl;
        // scopeEl.base = ' ';
        // const OMNIBAR = (window as any).OMNIBAR;
        // scopeEl.selected = `v${OMNIBAR.version}`;
        shellEl.pageId = "home";
        // window.onhashchange = function() {
        //   shellEl.pageId = window.location.hash;
        // };
        var rootPath = window.location.protocol + "//" + window.location.host + "/";
        shellEl.postLogoutRedirectUri = "https://google.com";
        shellEl.environment = "dev";
        shellEl.isUnifiedLogin = true;
        shellEl.silentRefreshUri = rootPath + "omnibar-silent-refresh.html";
        // shellEl.logoutRedirectUrl = "https://google.com"
        navEl.items = [
            {
                title: "Home",
                url: "/",
                icon: "places-home-1",
                pageId: "home"
            },
            {
                title: "Users",
                url: "#/people/users",
                icon: "user",
                pageId: "users",
                items: [
                    {
                        title: "Details",
                        items: [
                            {
                                title: "Products",
                                url: "#/",
                                pageId: "products",
                                items: [
                                    {
                                        title: "OneSite",
                                        url: "#/",
                                        pageId: "onesite",
                                        favorite: true
                                    },
                                    {
                                        title: "Unified Login",
                                        url: "#/",
                                        pageId: "ul",
                                        favorite: false
                                    }
                                ]
                            },
                            {
                                title: "Contacts",
                                url: "#/",
                                pageId: "contacts"
                            }
                        ]
                    },
                    {
                        title: "Activity",
                        url: "#/",
                        pageId: "activity",
                        badgeCount: 2
                    }
                ]
            },
            {
                title: "Roles & Rights",
                url: "page2.html",
                icon: "key-1",
                pageId: "roles"
            },
            {
                title: "Settings",
                url: "#/settings",
                icon: "cog-gear-settings",
                pageId: "settings",
                items: [
                    {
                        title: "Company",
                        url: "#/settings/company",
                        icon: "building-4",
                        pageId: "company"
                    },
                    {
                        title: "Access",
                        url: "#/settings/access",
                        icon: "lock-1",
                        pageId: "access"
                    }
                ]
            },
            {
                title: "Property Photos",
                url: "page2.html",
                icon: "property-photos",
                iconKind: "product",
                badgeCount: 3,
                pageId: "photos"
            }
        ];
        var scope = document.querySelector('omnibar-scope');
        scope.items = [
            {
                text: 'Item 1',
                description: 'Item 1 description',
                value: 'item-1',
                meta: {
                    region: 'GST',
                    propertyId: '123',
                },
            },
            {
                text: 'Item 2 - Grouping',
                value: 'item-2',
                meta: {
                    region: 'GST',
                },
                items: [
                    {
                        text: 'Item 2-1',
                        description: 'This is Item 2-1',
                        value: 'item-2-1',
                        selected: true,
                        meta: {
                            region: 'GST',
                            propertyId: '124',
                        },
                    },
                    {
                        text: 'Item 2-2',
                        description: 'This is Item 2-2',
                        value: 'item-2-2',
                        meta: {
                            region: 'GST',
                            propertyId: '125',
                        },
                    }
                ]
            },
            {
                text: 'Item 3',
                // description: 'This is Item 3',
                value: 'item-3',
                selected: true,
                meta: {
                    region: 'GST',
                    propertyId: '125',
                },
            },
            {
                text: 'Item 4',
                // description: 'This is Item 4',
                value: 'item-4',
                meta: {
                    region: 'ABC',
                    propertyId: '126',
                },
            },
            {
                text: 'Item 5',
                // description: 'This is Item 5',
                value: 'item-5',
                meta: {
                    region: 'ABC',
                    propertyId: '127',
                },
            },
            {
                text: 'Item 6',
                // description: 'This is Item 6',
                value: 'item-6',
                meta: {
                    region: 'ABC',
                    propertyId: '128',
                },
            },
            {
                text: 'Item 7',
                // description: 'This is Item 7',
                value: 'item-7',
            },
            {
                text: 'Item 8',
                // description: 'This is Item 8',
                value: 'item-8',
                meta: {
                    propertyId: '130',
                },
            }
        ];
    };
    DemoShell.prototype.handleViewNotifications = function () {
        console.log('Show My Notifications Aside');
    };
    DemoShell.prototype.handleChangeCompany = function (ev) {
        console.log(ev);
    };
    DemoShell.prototype.handleChangePersona = function (ev) {
        console.log('omnibarChangePersona', ev);
    };
    DemoShell.prototype.handleOmnibarLogout = function (ev) {
        console.log(ev.detail.logoutUrl);
    };
    DemoShell.prototype.handleSearchQuery = function (ev) {
        if (ev.detail.length >= 3)
            console.log("searchQuery", ev.detail);
    };
    DemoShell.prototype.handleSearchSubmit = function (ev) {
        console.log("searchSubmit", ev.detail);
    };
    DemoShell.prototype.handleNavigate = function (ev) {
        this.shellEl.pageId = ev.detail.pageId;
        this.pageHeaderEl.pageTitle = ev.detail.title;
        this.currentPage = ev.detail.title;
        console.log('navigate', ev.detail);
    };
    DemoShell.prototype.handleNavFavItemClicked = function (ev) {
        console.log('navFavItemClick', ev.detail);
    };
    DemoShell.prototype.render = function () {
        var _this_1 = this;
        return (h("omnibar-shell", { ref: function (el) { return _this_1.shellEl = el; }, "product-code": "CIMPL", "product-center-short-name": "6", "logout-url": "#logout", "follow-logout-href": "false" }, h("omnibar-navigation", { ref: function (el) { return _this_1.navEl = el; }, "follow-href": "false", slot: "navigation" }), h("omnibar-scope", { ref: function (el) { return _this_1.scopeEl = el; }, slot: "scope", product: "RAUL 3 Omnibar", base: "RealPage", selector: true, searchable: true }), h("omnibar-search", { ref: function (el) { return _this_1.searchEl = el; }, slot: "search", placeholder: "Your placeholder text..." }), h("omnibar-unified-menu", { slot: "unified-menu", "user-name": "RealPage User", "user-title": "Employee" }, h("omnibar-unified-switcher", { slot: "switcher" }), h("omnibar-unified-notifications", { slot: "notifications" }), h("omnibar-unified-help", { slot: "help", "help-query": "pg=ul-home&vr=40&scrver=350" }), h("omnibar-unified-vendors", { slot: "vendors", company: "Company Name" }), h("omnibar-unified-menu-item", { "menu-name": "Shopping", icon: "omnibar-shopping-cart", "badge-count": "5" }, h("div", { class: "my-cart dropdown" }, h("p", null, "You have ", h("b", null, "5"), " products in your cart. ", h("a", { href: "#" }, "Click here"), " to check out!"))), h("a", { href: "#/foo", slot: "user" }, h("omnibar-user-menu-item", { "menu-name": "Link to Foo" }, "Link to Foo")), h("omnibar-user-menu-item", { slot: "user", id: "no-link", "menu-name": "No Link" }, "No Link")), h("header", { slot: "header" }, h("omnibar-page-header", { ref: function (el) { return _this_1.pageHeaderEl = el; }, "page-title": "Omnibar Demo" }, h("omnibar-page-crumb", null, h("a", { href: "/" }, "RealPage")), h("omnibar-page-crumb", null, this.currentPage ? this.currentPage : 'Omnibar Demo'))), h("main", { slot: "page" }, h("section", { class: "o-p-4" }, "Omnibar Demo", h("omnibar-context-help", { "help-query": "pg=ul-home&vr=40&scrver=350" })))));
    };
    return DemoShell;
}());
var OmnibarActionMenu = /** @class */ (function () {
    function class_1(hostRef) {
        registerInstance(this, hostRef);
        /**
         * If set to true, the last action will be separated with a divider
         */
        this.emphasizeFinal = false;
        /**
         * Disables actions
         */
        this.disabled = false;
        this.optionSelected = createEvent(this, "optionSelected", 7);
    }
    /**
     * Method to programatically close the menu
     */
    class_1.prototype.closeMenu = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.dropdownMenu.closeMenu();
                return [2 /*return*/];
            });
        });
    };
    class_1.prototype.render = function () {
        var _this_1 = this;
        return (h("omnibar-dropdown-menu", { items: this.items, color: 'active', dividers: false, emphasizeFinal: this.emphasizeFinal, disabled: this.disabled, ref: function (el) { return _this_1.dropdownMenu = el; } }, h("omnibar-icon", { icon: 'navigation-show-more-vertical', slot: "toggle" }), h("slot", null)));
    };
    Object.defineProperty(class_1, "style", {
        get: function () { return "omnibar-action-menu omnibar-icon{font-size:1.25rem}omnibar-action-menu .o-dropdown-menu--show omnibar-icon{color:#0076cc}omnibar-action-menu .o-dropdown-menu__menu-item :not(.o-dropdown-menu__menu-item--disabled) .o-dropdown-menu__menu-item__label{color:#0076cc!important}omnibar-action-menu .o-dropdown-menu__menu-item :not(.o-dropdown-menu__menu-item--disabled) .o-dropdown-menu__menu-item__label:hover{text-decoration:underline!important}omnibar-dropdown-menu .o-dropdown-menu{opacity:1;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative;display:inline-block}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__toggle{position:relative;height:100%;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__toggle:focus{outline:none}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__toggle:focus .o-dropdown-menu__toggle__focus-utility{outline:1px solid #0076cc}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__toggle .o-dropdown-menu__toggle__focus-utility{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__toggle .o-dropdown-menu__toggle__focus-utility:focus{outline:none}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown{position:absolute;display:none;border-radius:.125rem;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.1),0 1px 2px 0 rgba(0,0,0,.06);box-shadow:0 1px 3px 0 rgba(0,0,0,.1),0 1px 2px 0 rgba(0,0,0,.06);padding-top:.5rem;padding-bottom:.5rem;background-color:#fff;max-width:180px;z-index:2000}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown--show{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown--default{top:32px;right:0;left:auto}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown--top{bottom:32px;right:0;left:auto}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown--right{left:0;right:auto}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown omnibar-action-menu-item .o-dropdown-menu-item{color:#37474f;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;text-decoration:none;min-height:32px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;opacity:1!important}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown omnibar-action-menu-item .o-dropdown-menu-item .o-dropdown-menu-item__focus-utility{border-width:1px;border-color:transparent;width:100%;min-height:32px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:distribute;justify-content:space-around}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown omnibar-action-menu-item .o-dropdown-menu-item .o-dropdown-menu-item__focus-utility:focus{outline:none}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown omnibar-action-menu-item .o-dropdown-menu-item .o-dropdown-menu-item__focus-utility .o-dropdown-menu__menu-item__label{color:#37474f;opacity:1!important}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown omnibar-action-menu-item .o-dropdown-menu-item .o-dropdown-menu-item__focus-utility .o-dropdown-menu__menu-item__label:hover{text-decoration:underline}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown omnibar-action-menu-item .o-dropdown-menu-item:focus{outline:none}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown omnibar-action-menu-item .o-dropdown-menu-item:focus .o-dropdown-menu-item__focus-utility{border-width:1px;border-color:#0076cc}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown omnibar-action-menu-item .o-dropdown-menu-item .o-dropdown-menu__menu-item__container{color:#37474f;width:100%;padding:0 8px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown omnibar-action-menu-item .o-dropdown-menu-item .o-dropdown-menu__menu-item__container .o-dropdown-menu__menu-item__label{padding:0 8px;line-height:18px!important;font-size:12px!important;text-transform:capitalize;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown omnibar-action-menu-item .o-dropdown-menu-item--disabled{pointer-events:none}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown omnibar-action-menu-item .o-dropdown-menu-item--disabled .o-dropdown-menu__menu-item__label{color:#9ba3a7!important}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown omnibar-action-menu-item .o-dropdown-menu-item--disabled:focus{outline:none}omnibar-dropdown-menu .o-dropdown-menu--color-active .o-dropdown-menu__menu-item__container{color:#0076cc}omnibar-dropdown-menu .o-dropdown-menu--emphasize-final omnibar-action-menu-item:last-child .o-dropdown-menu__menu-item:before{border-top-width:1px;border-color:#f7f8f9;content:\"\";display:block;width:100%;margin-top:8px;margin-bottom:8px}omnibar-dropdown-menu .o-dropdown-menu--dividers .o-dropdown-menu__dropdown{padding:0}omnibar-dropdown-menu .o-dropdown-menu--dividers .o-dropdown-menu__dropdown .o-dropdown-menu__menu-item{border-bottom-width:1px;border-color:#f7f8f9}omnibar-dropdown-menu .o-dropdown-menu--dividers .o-dropdown-menu__dropdown .o-dropdown-menu__menu-item:last-child{border-bottom:none}"; },
        enumerable: true,
        configurable: true
    });
    return class_1;
}());
var MenuItem = function (props) {
    var title = props.title, icon = props.icon, payload = props.payload, url = props.url, disabled = props.disabled, onClickCallback = props.onClickCallback, onBlurCallback = props.onBlurCallback, event = props.event;
    var Tag = (url && !disabled) ? 'a' : 'div';
    return (h(Tag, { class: {
            'o-dropdown-menu__menu-item': true,
            'o-dropdown-menu__menu-item--disabled': disabled,
        }, onClick: function (e) {
            if (onClickCallback) {
                onClickCallback(e, payload);
            }
            //@ts-ignore
            event.emit(e, payload);
        }, onKeyDown: function (e) {
            if (e.key === 'Enter') {
                if (onClickCallback) {
                    onClickCallback(e, payload);
                }
            }
            //@ts-ignore
            event.emit(e, payload);
        }, onBlur: function (e) {
            if (onBlurCallback) {
                onBlurCallback(e, payload);
            }
        }, role: url ? undefined : 'button', tabindex: disabled ? undefined : 0, href: url ? disabled ? '#' : url : undefined, title: title }, h("div", { class: 'o-dropdown-menu-item__focus-utility', tabindex: disabled ? undefined : -1 }, h("div", { class: 'o-dropdown-menu__menu-item__container' }, icon &&
        h("div", { class: 'o-dropdown-menu__menu-item__icon' }, h("omnibar-icon", { icon: icon })), h("div", { class: 'o-dropdown-menu__menu-item__label' }, title, h("slot", null))))));
};
var OmnibarActionMenuItem = /** @class */ (function () {
    function OmnibarActionMenuItem(hostRef) {
        registerInstance(this, hostRef);
        this.clickCallback = createEvent(this, "clickCallback", 7);
        this.blurCallback = createEvent(this, "blurCallback", 7);
        this.optionSelected = createEvent(this, "optionSelected", 7);
    }
    OmnibarActionMenuItem.prototype.render = function () {
        var _this_1 = this;
        return (h(MenuItem, { url: this.url, disabled: this.disabled, payload: this.payload, onClickCallback: function () { return _this_1.clickCallback.emit(); }, onBlurCallback: function () { return _this_1.blurCallback.emit(); }, event: this.optionSelected }, h("slot", null)));
    };
    return OmnibarActionMenuItem;
}());
var OmnibarAside = /** @class */ (function () {
    function class_2(hostRef) {
        registerInstance(this, hostRef);
        this.visible = false;
        this.expanded = false;
        this.focused = false;
        this.size = 'medium';
        this.omnibarAsideOpen = createEvent(this, "omnibarAsideOpen", 7);
        this.omnibarAsideClose = createEvent(this, "omnibarAsideClose", 7);
    }
    class_2.prototype.componentDidLoad = function () {
        this.dialogTransitionDuration = parseFloat(window.getComputedStyle(this.dialogEl).transitionDuration) * 1000;
    };
    class_2.prototype.handleOmnibarAsideOpen = function (e) {
        var _this_1 = this;
        if (this.el !== e.target) {
            requestAnimationFrame(function () {
                _this_1.dialogWidth = _this_1.dialogEl.offsetWidth;
                _this_1.secondaryDialogWidth = e.target.querySelector('.o-aside__dialog').offsetWidth;
            });
            this.blur();
        }
    };
    class_2.prototype.handleOmnibarAsideClose = function (e) {
        if (this.el !== e.target) {
            this.secondaryDialogWidth = 0;
            this.focus();
        }
    };
    /**
     * Opens the aside.
     * @returns {Promise<void>}
     */
    class_2.prototype.open = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_g) {
                this.asideTrigger = document.activeElement;
                this.visible = true;
                requestAnimationFrame(function () { return _this_1.expanded = true; });
                this.focus();
                this.omnibarAsideOpen.emit();
                document.body.classList.add('no-scroll');
                return [2 /*return*/];
            });
        });
    };
    /**
     * Closes the aside.
     * @returns {Promise<void>}
     */
    class_2.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_g) {
                this.expanded = false;
                setTimeout(function () { return _this_1.visible = false; }, this.dialogTransitionDuration);
                this.blur();
                if (this.asideTrigger) {
                    this.asideTrigger.focus();
                }
                this.omnibarAsideClose.emit();
                document.body.classList.remove('no-scroll');
                return [2 /*return*/];
            });
        });
    };
    class_2.prototype.dialogOffsetX = function () {
        return -(this.secondaryDialogWidth - this.dialogWidth + 40);
    };
    class_2.prototype.focus = function () {
        var _this_1 = this;
        requestAnimationFrame(function () {
            _this_1.focused = true;
            _this_1.asideEl.focus();
        });
    };
    class_2.prototype.blur = function () {
        var _this_1 = this;
        requestAnimationFrame(function () {
            _this_1.focused = false;
            _this_1.asideEl.blur();
        });
    };
    class_2.prototype.render = function () {
        var _this_1 = this;
        return (h(Host, { visible: this.visible, expanded: this.expanded }, h("div", { class: "o-aside", role: "dialog", tabindex: "-1", "aria-hidden": !this.visible, onKeyDown: function (e) { return e.key === 'Escape' && _this_1.focused ? _this_1.close() : null; }, ref: function (el) { return _this_1.asideEl = el; } }, h("slot", { name: "secondary-aside" }), h("div", { class: "o-aside__backdrop", onClick: function () { return _this_1.close(); } }), h("div", { class: "o-aside__dialog", role: "document", style: { transform: this.secondaryDialogWidth ? "translateX(" + this.dialogOffsetX() + "px)" : null }, ref: function (el) { return _this_1.dialogEl = el; } }, h("slot", null)))));
    };
    Object.defineProperty(class_2.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_2, "style", {
        get: function () { return "omnibar-aside{display:block}omnibar-aside .o-aside{display:none;position:fixed;left:0;top:0;width:100%;height:100%;overflow:hidden;outline:0;z-index:5000;color:#37474f}omnibar-aside .o-aside__backdrop{position:absolute;left:0;top:0;width:100%;height:100%;background-color:#37474f;cursor:pointer;opacity:0;-webkit-transition:opacity .15s linear;transition:opacity .15s linear}omnibar-aside .o-aside__dialog{position:absolute;right:0;top:0;height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;background-color:#fff;border-left-width:1px;border-color:#ebedee;-webkit-transition:background-color .35s ease,-webkit-transform .35s ease;transition:background-color .35s ease,-webkit-transform .35s ease;transition:transform .35s ease,background-color .35s ease;transition:transform .35s ease,background-color .35s ease,-webkit-transform .35s ease;-webkit-transform:translateX(100%);transform:translateX(100%)}omnibar-aside .o-aside--visible{display:block}omnibar-aside .o-aside--visible>.o-aside__backdrop{opacity:.5}omnibar-aside .o-aside--visible>.o-aside__dialog{-webkit-transform:translateX(0);transform:translateX(0)}omnibar-aside[visible]>.o-aside{display:block}omnibar-aside[expanded]>.o-aside>.o-aside__backdrop{opacity:.5}omnibar-aside[expanded]>.o-aside>.o-aside__dialog{-webkit-transform:translateX(0);transform:translateX(0)}omnibar-aside[expanded]>.o-aside>omnibar-aside[expanded]~.o-aside__dialog{background-color:#ebedee}omnibar-aside[expanded]>.o-aside>omnibar-aside[expanded] .o-aside__backdrop{opacity:0}omnibar-aside[size=small]>.o-aside>.o-aside__dialog{width:100%}\@media (min-width:640px){omnibar-aside[size=small]>.o-aside>.o-aside__dialog{width:22.5rem}}omnibar-aside[size=medium]>.o-aside>.o-aside__dialog{width:100%}\@media (min-width:768px){omnibar-aside[size=medium]>.o-aside>.o-aside__dialog{width:37.5rem}}omnibar-aside[size=large]>.o-aside>.o-aside__dialog{width:100%}\@media (min-width:1024px){omnibar-aside[size=large]>.o-aside>.o-aside__dialog{width:64rem}}"; },
        enumerable: true,
        configurable: true
    });
    return class_2;
}());
var OmnibarAsideActions = /** @class */ (function () {
    function OmnibarAsideActions(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarAsideActions.prototype.render = function () {
        return (h("slot", null));
    };
    Object.defineProperty(OmnibarAsideActions, "style", {
        get: function () { return "omnibar-aside-actions{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:end;justify-content:flex-end}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarAsideActions;
}());
var OmnibarAsideBody = /** @class */ (function () {
    function OmnibarAsideBody(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarAsideBody.prototype.render = function () {
        return (h("slot", null));
    };
    Object.defineProperty(OmnibarAsideBody, "style", {
        get: function () { return "omnibar-aside-body{display:block;-ms-flex:1 1 0%;flex:1 1 0%;height:100%;padding-left:1rem;padding-right:1rem;padding-bottom:1.25rem;overflow-y:auto}\@media (min-width:768px){omnibar-aside-body{padding-left:2.5rem;padding-right:2.5rem}}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarAsideBody;
}());
var OmnibarAsideFooter = /** @class */ (function () {
    function OmnibarAsideFooter(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarAsideFooter.prototype.render = function () {
        return (h("slot", null));
    };
    Object.defineProperty(OmnibarAsideFooter, "style", {
        get: function () { return "omnibar-aside-footer{display:block;padding:1rem;border-top-width:1px;border-color:#ebedee}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarAsideFooter;
}());
var OmnibarAsideHeader = /** @class */ (function () {
    function OmnibarAsideHeader(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarAsideHeader.prototype.render = function () {
        return (h("slot", null));
    };
    Object.defineProperty(OmnibarAsideHeader, "style", {
        get: function () { return "omnibar-aside-header{display:block;padding-left:1rem;padding-right:1rem;padding-top:2.5rem;padding-bottom:1.25rem}\@media (min-width:768px){omnibar-aside-header{padding-left:2.5rem;padding-right:2.5rem}}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarAsideHeader;
}());
var OmnibarAsideSubtitle = /** @class */ (function () {
    function OmnibarAsideSubtitle(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarAsideSubtitle.prototype.render = function () {
        return (h("slot", null));
    };
    Object.defineProperty(OmnibarAsideSubtitle, "style", {
        get: function () { return "omnibar-aside-subtitle{display:block;font-size:.875rem;line-height:1.25;margin-bottom:.5rem;color:rgba(55,71,79,.8);margin-bottom:0;margin-top:.25rem}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarAsideSubtitle;
}());
var OmnibarAsideTitle = /** @class */ (function () {
    function OmnibarAsideTitle(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarAsideTitle.prototype.render = function () {
        return (h("slot", null));
    };
    Object.defineProperty(OmnibarAsideTitle, "style", {
        get: function () { return "omnibar-aside-title{display:block;font-size:1.25rem;font-weight:600;line-height:1.25;margin-bottom:.5rem;margin-bottom:0}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarAsideTitle;
}());
var RaulBulkActionBar = /** @class */ (function () {
    function RaulBulkActionBar(hostRef) {
        registerInstance(this, hostRef);
        this.buttonWidths = [];
        this.toggleOverflow = false;
        this.selectedCount = 0;
        this.totalRecords = 0;
        this.open = false;
        this.showTray = false;
        this.bulkActionsClose = createEvent(this, "bulkActionsClose", 7);
        this.bulkActionsSelectAll = createEvent(this, "bulkActionsSelectAll", 7);
    }
    RaulBulkActionBar.prototype.openChanged = function () {
        var _this_1 = this;
        if (this.open) {
            this.getButtonWidths();
            this.handelMoreButtons(this.bulkActionEl, this.buttonWidths, this.bulkActionEl.querySelectorAll('.o-bulk-actions__left omnibar-button, .o-bulk-actions__more-tray omnibar-button'));
            setTimeout(function () {
                _this_1.toggleOverflow = true;
            }, 350);
        }
        else {
            this.toggleOverflow = false;
            // Reset buttons
            setTimeout(function () {
                _this_1.buttonWidths = [];
                _this_1.handelMoreButtons(_this_1.bulkActionEl, _this_1.buttonWidths, _this_1.bulkActionEl.querySelectorAll('.o-bulk-actions__left omnibar-button, .o-bulk-actions__more-tray omnibar-button'));
            }, 350);
        }
    };
    RaulBulkActionBar.prototype.handleResize = function () {
        if (this.buttonWidths.length > 0)
            this.handelMoreButtons(this.bulkActionEl, this.buttonWidths, this.bulkActionEl.querySelectorAll('.o-bulk-actions__left omnibar-button, .o-bulk-actions__more-tray omnibar-button'));
    };
    RaulBulkActionBar.prototype.getButtonWidths = function () {
        var _this_1 = this;
        var buttons = this.bulkActionEl.querySelectorAll('.o-bulk-actions__left omnibar-button, .o-bulk-actions__more-tray omnibar-button');
        this.buttonWidths = [];
        buttons.forEach(function (button) {
            var thisButton = button;
            _this_1.buttonWidths.push(thisButton.offsetWidth);
        });
    };
    RaulBulkActionBar.prototype.closeBar = function () {
        this.open = this.showTray = false;
        this.bulkActionsClose.emit();
    };
    RaulBulkActionBar.prototype.debounce = function (func, delay) {
        var inDebounce;
        return function () {
            var context = this;
            var args = arguments;
            clearTimeout(inDebounce);
            inDebounce = setTimeout(function () { return func.apply(context, args); }, delay);
        };
    };
    RaulBulkActionBar.prototype.toggleTray = function () {
        this.showTray = !this.showTray;
    };
    RaulBulkActionBar.prototype.handelMoreButtons = function (element, buttonWidths, buttons) {
        var _this_1 = this;
        window.addEventListener('click', function (e) {
            var tray = _this_1.moreTray;
            // @ts-ignore
            if (tray && (!tray.contains(e.target) || e.target.classList.contains('r-button__element'))) {
                _this_1.showTray = false;
            }
        }, true);
        var leftSideWidth = element.querySelector('.o-bulk-actions__left').offsetWidth;
        this.buttonsInTray = [];
        var buttonsNotInTray = [];
        var visibleButtonTotalWidth = 0;
        var maxButtonWidth = Math.max.apply(Math, buttonWidths);
        buttons.forEach(function (button, index) {
            if (!button.classList.contains('o-bulk-actions__button-more')) {
                visibleButtonTotalWidth = visibleButtonTotalWidth + buttonWidths[index] + 8;
                if ((visibleButtonTotalWidth + maxButtonWidth) > leftSideWidth) {
                    _this_1.buttonsInTray.push(button);
                }
                else {
                    buttonsNotInTray.push(button);
                }
            }
        });
        this.buttonsInTray.forEach(function (button) {
            _this_1.moreTray.appendChild(button);
        });
        buttonsNotInTray.forEach(function (button) {
            element.querySelector('.o-bulk-actions__buttons-wrapper').appendChild(button);
        });
        if (this.buttonsInTray.length > 0) {
            element.querySelector('.o-bulk-actions__button-more').classList.add('o-bulk-actions__button-more--show');
        }
        else {
            element.querySelector('.o-bulk-actions__button-more').classList.remove('o-bulk-actions__button-more--show');
        }
    };
    RaulBulkActionBar.prototype.render = function () {
        var _this_1 = this;
        return (h("div", { class: {
                'o-bulk-actions': true,
                'o-bulk-actions--expanded': this.open,
                'o-overflow-visible': this.toggleOverflow,
                'o-overflow-hidden': !this.toggleOverflow,
            }, ref: function (el) { return _this_1.bulkActionEl = el; } }, h("div", { class: "o-bulk-actions__wrapper" }, h("div", { class: "o-bulk-actions__left" }, h("div", { class: "o-bulk-actions__buttons-wrapper" }, h("slot", null)), h("div", { class: "o-bulk-actions__more" }, h("omnibar-button", { class: "o-bulk-actions__button-more", variant: "reverse", size: "small", onClick: function () { return _this_1.toggleTray(); } }, "More"), h("div", { class: {
                'o-bulk-actions__more-tray': true,
                'o-bulk-actions__more-tray--show': this.showTray,
            }, ref: function (el) { return _this_1.moreTray = el; } }))), h("div", { class: "o-bulk-actions__right" }, h("button", { type: "button", class: "o-bulk-actions__select-all", onClick: function () { return _this_1.bulkActionsSelectAll.emit(); } }, "Select all ", this.totalRecords, " records"), h("span", { class: "o-bulk-actions__selected-count" }, this.selectedCount, " Selected"), h("button", { type: "button", class: "o-bulk-actions__close", onClick: function () { return _this_1.closeBar(); } }, h("omnibar-icon", { icon: "close" }))))));
    };
    Object.defineProperty(RaulBulkActionBar, "watchers", {
        get: function () {
            return {
                "open": ["openChanged"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RaulBulkActionBar, "style", {
        get: function () { return "omnibar-bulk-action-bar{display:block}omnibar-bulk-action-bar .o-bulk-actions{bottom:0;color:#fff;left:0;position:fixed;width:100%;z-index:40;max-height:0;-webkit-transition:max-height .35s;transition:max-height .35s}omnibar-bulk-action-bar .o-bulk-actions--expanded{max-height:3rem}\@media (min-width:768px){omnibar-bulk-action-bar .o-bulk-actions{position:relative;bottom:auto}}omnibar-bulk-action-bar .o-bulk-actions__wrapper{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;position:relative;padding:.5rem;background-color:#0076cc;height:3rem}omnibar-bulk-action-bar .o-bulk-actions__left{display:-ms-flexbox;display:flex;margin-right:auto;-ms-flex-positive:1;flex-grow:1}omnibar-bulk-action-bar .o-bulk-actions__buttons-wrapper{display:inline-block}omnibar-bulk-action-bar .o-bulk-actions__buttons-wrapper .o-button{margin-right:.5rem}omnibar-bulk-action-bar .o-bulk-actions__more{display:inline-block;position:relative}omnibar-bulk-action-bar .o-bulk-actions__button-more{visibility:hidden}omnibar-bulk-action-bar .o-bulk-actions__button-more--show{visibility:visible}omnibar-bulk-action-bar .o-bulk-actions__right{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;font-size:.75rem;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;max-width:265px;min-width:55px}omnibar-bulk-action-bar .o-bulk-actions__selected-count{font-size:.75rem}omnibar-bulk-action-bar .o-bulk-actions__select-all{padding-top:0;padding-bottom:0;padding-left:.75rem;padding-right:.75rem;display:none}omnibar-bulk-action-bar .o-bulk-actions__select-all:hover{text-decoration:underline}omnibar-bulk-action-bar .o-bulk-actions__select-all:after{display:inline-block;margin-left:.5rem;content:\"|\"}\@media only screen and (min-width:768px){omnibar-bulk-action-bar .o-bulk-actions__select-all{display:inline-block}}omnibar-bulk-action-bar .o-bulk-actions__close{padding:.75rem}omnibar-bulk-action-bar .o-bulk-actions__close omnibar-icon{font-size:.875rem}omnibar-bulk-action-bar .o-bulk-actions__more-tray{left:0;overflow:hidden;padding-top:.5rem;padding-left:.5rem;padding-right:0;padding-bottom:0;position:fixed;width:100%;background:#37474f;bottom:-100%;min-height:48px;-webkit-transition:bottom .35s;transition:bottom .35s;z-index:-1}omnibar-bulk-action-bar .o-bulk-actions__more-tray--show{bottom:48px}omnibar-bulk-action-bar .o-bulk-actions__more-tray omnibar-button{margin-bottom:.5rem;margin-right:.5rem}\@media (min-width:768px){omnibar-bulk-action-bar .o-bulk-actions__more-tray{background-color:#fff;border-radius:.125rem;bottom:auto;display:none;padding-top:.5rem;padding-bottom:.5rem;padding-left:0;padding-right:0;position:absolute;right:auto;vertical-align:middle;-webkit-box-shadow:0 8px 16px 0 rgba(82,97,115,.18);box-shadow:0 8px 16px 0 rgba(82,97,115,.18);top:36px;width:180px;z-index:2000}omnibar-bulk-action-bar .o-bulk-actions__more-tray--show{display:block;bottom:auto}omnibar-bulk-action-bar .o-bulk-actions__more-tray omnibar-button{display:block;margin-right:0}omnibar-bulk-action-bar .o-bulk-actions__more-tray omnibar-button .o-button--reverse .o-button__content{-ms-flex-align:center;align-items:center;background-color:transparent;display:-ms-flexbox;display:flex;font-size:.75rem;font-weight:400;-ms-flex-pack:start;justify-content:flex-start;padding-top:0;padding-bottom:0;padding-left:1rem;padding-right:1rem;color:#37474f;min-height:32px}omnibar-bulk-action-bar .o-bulk-actions__more-tray omnibar-button .o-button--reverse .o-button__focus-ring *{display:none}omnibar-bulk-action-bar .o-bulk-actions__more-tray omnibar-button .o-button--reverse .o-button__element:hover~.o-button__content{background-color:transparent;text-decoration:underline}omnibar-bulk-action-bar .o-bulk-actions__more-tray omnibar-button .o-button--reverse .o-button__content:before{border-color:#0076cc!important;border-radius:0!important;top:2px!important;right:2px!important;bottom:2px!important;left:2px!important}}"; },
        enumerable: true,
        configurable: true
    });
    return RaulBulkActionBar;
}());
function ripple(event, el) {
    var rippleAnimationDuration = 600;
    var rippleRemoveTimeout = rippleAnimationDuration + 50;
    var _g = el.getBoundingClientRect(), left = _g.left, top = _g.top, width = _g.width, height = _g.height;
    var rippleSize = width > height ? width : height;
    var rippleOffset = {
        left: left + window.scrollX,
        top: top + window.scrollY
    };
    var rippleX = event.pageX - rippleOffset.left - rippleSize / 2;
    var rippleY = event.pageY - rippleOffset.top - rippleSize / 2;
    var rippleSpan = document.createElement('span');
    rippleSpan.className = 'o-ripple';
    rippleSpan.style.borderRadius = '50%';
    rippleSpan.style.backgroundColor = 'currentColor';
    rippleSpan.style.transform = 'scale(0)';
    rippleSpan.style.position = 'absolute';
    rippleSpan.style.opacity = '0.3';
    rippleSpan.style.transition = "all 0." + rippleAnimationDuration + "s linear";
    rippleSpan.style.width = rippleSize + 'px';
    rippleSpan.style.height = rippleSize + 'px';
    rippleSpan.style.top = rippleY + 'px';
    rippleSpan.style.left = rippleX + 'px';
    el.appendChild(rippleSpan);
    setTimeout(function () {
        rippleSpan.style.transform = 'scale(2)';
        rippleSpan.style.opacity = '0';
    });
    setTimeout(function () {
        rippleSpan.remove();
    }, rippleRemoveTimeout);
}
var OmnibarButton = /** @class */ (function () {
    function OmnibarButton(hostRef) {
        registerInstance(this, hostRef);
        this.iconOnly = false;
        /**
         * Determines the primary appearance of the button based on its purpose.
         */
        this.variant = "secondary";
        /**
         * Determines the primary appearance of the button based on its purpose.
         */
        this.size = "default";
        /**
         * Controls whether this button is disabled.
         */
        this.disabled = false;
        /**
         * Adds `add` icon.
         */
        this.add = false;
        /**
         * Adds `delete` icon.
         */
        this.delete = false;
    }
    OmnibarButton.prototype.componentDidLoad = function () {
        if (!this.btnTextEl.innerHTML) {
            this.iconOnly = true;
        }
    };
    OmnibarButton.prototype.render = function () {
        var _g;
        var _this_1 = this;
        var renderAddOrDeleteIcon = function () {
            return _this_1.add ? h("omnibar-icon", { icon: "add-2" }) : _this_1.delete ? h("omnibar-icon", { icon: "remove-2" }) : null;
        };
        var renderIcon = function () {
            return _this_1.icon && !(_this_1.add || _this_1.delete) ? h("omnibar-icon", { icon: _this_1.icon, kind: _this_1.iconKind }) : null;
        };
        var renderButton = function () {
            var ButtonTypeTag = _this_1.href ? 'a' : _this_1.type ? 'input' : 'button';
            return (h(ButtonTypeTag, { class: "o-button__element", type: _this_1.type ? _this_1.type : _this_1.href ? null : 'button', href: _this_1.href && !_this_1.disabled ? _this_1.href : null, "aria-disabled": _this_1.disabled, disabled: _this_1.disabled, value: _this_1.value, onMouseDown: function (e) { return ripple(e, _this_1.focusRingEl); } }));
        };
        return (h("div", { class: (_g = {
                    'o-button': true
                },
                _g["o-button--" + this.variant] = !!this.variant,
                _g["o-button--" + this.size] = !!this.size,
                _g) }, h("div", { class: "o-button__focus-ring", ref: function (el) { return _this_1.focusRingEl = el; } }), renderButton(), h("div", { class: {
                'o-button__content': true,
                'o-button__content--icon-only': this.iconOnly
            } }, renderAddOrDeleteIcon(), renderIcon(), h("span", { ref: function (el) { return _this_1.btnTextEl = el; } }, h("slot", null)))));
    };
    Object.defineProperty(OmnibarButton, "style", {
        get: function () { return "omnibar-button{display:inline-block}omnibar-button[type=button],omnibar-button[type=reset],omnibar-button[type=submit]{-webkit-appearance:none;-moz-appearance:none;appearance:none}omnibar-button .o-button{position:relative}omnibar-button .o-button__content{position:relative;font-size:.875rem;font-weight:500;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:2.5rem;padding-left:1rem;padding-right:1rem;border-radius:9999px;white-space:nowrap;min-width:5rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,color .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,color .15s ease-in-out;border:1px solid transparent}omnibar-button .o-button__content omnibar-icon{margin-right:.5rem;margin-top:-1px;font-size:1.25rem}omnibar-button .o-button__content--icon-only{padding:0;min-width:40px}omnibar-button .o-button__content--icon-only omnibar-icon{margin-right:0}omnibar-button .o-button__element{-webkit-appearance:none;-moz-appearance:none;appearance:none;position:absolute;top:0;right:0;bottom:0;left:0;cursor:pointer;opacity:0;height:100%;width:100%;z-index:10;border-radius:9999px}omnibar-button .o-button__element[aria-disabled],omnibar-button .o-button__element[disabled]{pointer-events:none}body[modality=keyboard] omnibar-button .o-button__element:focus~.o-button__content:before{position:absolute;border-width:1px;border-color:transparent;border-radius:9999px;content:\"\";bottom:-4px;left:-4px;right:-4px;top:-4px}omnibar-button .o-button__focus-ring{position:absolute;top:0;right:0;bottom:0;left:0;overflow:hidden;height:100%;width:100%;z-index:10;border-radius:9999px}omnibar-button .o-button--small .o-button__content{font-size:.75rem;height:2rem}omnibar-button .o-button--small .o-button__content--icon-only{min-width:2rem}omnibar-button .o-button--small .o-button__content omnibar-icon{font-size:1rem}body[modality=keyboard] omnibar-button .o-button--control .o-button__element:focus~.o-button__content:before,omnibar-button .o-button--control .o-button__content,omnibar-button .o-button--control .o-button__element,omnibar-button .o-button--control .o-button__focus-ring{border-radius:.125rem}omnibar-button .o-button--primary .o-button__content{color:#fff;background-color:#0076cc;border-color:#0076cc}omnibar-button .o-button--primary .o-button__focus-ring{color:#fff}omnibar-button .o-button--primary .o-button__element:hover~.o-button__content{background-color:#0069b7;border-color:#0069b7}omnibar-button .o-button--primary .o-button__element[aria-disabled]~.o-button__content,omnibar-button .o-button--primary .o-button__element[disabled]~.o-button__content{background-color:#ebedee;border-color:#ebedee;color:#9ba3a7}body[modality=keyboard] omnibar-button .o-button--primary .o-button__element:focus~.o-button__content:before{border-color:#0076cc}omnibar-button .o-button--secondary .o-button__content{color:#0076cc;background-color:#fff;border-color:#0076cc}omnibar-button .o-button--secondary .o-button__focus-ring{color:#0076cc}omnibar-button .o-button--secondary .o-button__element:hover~.o-button__content{border-color:#0069b7;color:#0069b7}omnibar-button .o-button--secondary .o-button__element[aria-disabled]~.o-button__content,omnibar-button .o-button--secondary .o-button__element[disabled]~.o-button__content{border-color:#c6ccd0;color:#9ba3a7}body[modality=keyboard] omnibar-button .o-button--secondary .o-button__element:focus~.o-button__content:before{border-color:#0076cc}omnibar-button .o-button--danger .o-button__content{color:#fff;background-color:#d01a1f;border-color:#d01a1f}omnibar-button .o-button--danger .o-button__focus-ring{color:#fff}omnibar-button .o-button--danger .o-button__element:hover~.o-button__content{background-color:#ba171b;border-color:#ba171b}omnibar-button .o-button--danger .o-button__element[aria-disabled]~.o-button__content,omnibar-button .o-button--danger .o-button__element[disabled]~.o-button__content{background-color:#ebedee;border-color:#ebedee;color:#9ba3a7}body[modality=keyboard] omnibar-button .o-button--danger .o-button__element:focus~.o-button__content:before{border-color:#d01a1f}omnibar-button .o-button--text .o-button__content,omnibar-button .o-button--text .o-button__focus-ring{color:#0076cc}omnibar-button .o-button--text .o-button__element:hover~.o-button__content{background-color:#e5f4ff}omnibar-button .o-button--text .o-button__element[aria-disabled]~.o-button__content,omnibar-button .o-button--text .o-button__element[disabled]~.o-button__content{color:#9ba3a7}body[modality=keyboard] omnibar-button .o-button--text .o-button__element:focus~.o-button__content:before{border-color:#0076cc}omnibar-button .o-button--reverse .o-button__content{color:#fff;background-color:rgba(55,71,79,.2)}omnibar-button .o-button--reverse .o-button__focus-ring{color:#fff}omnibar-button .o-button--reverse .o-button__element:hover~.o-button__content{background-color:rgba(55,71,79,.4)}omnibar-button .o-button--reverse .o-button__element[aria-disabled]~.o-button__content,omnibar-button .o-button--reverse .o-button__element[disabled]~.o-button__content{color:#9ba3a7}body[modality=keyboard] omnibar-button .o-button--reverse .o-button__element:focus~.o-button__content:before{border-color:#fff}omnibar-button .o-button--control .o-button__content{background-color:#fff;border-color:#c6ccd0}omnibar-button .o-button--control .o-button__element:hover~.o-button__content{border-color:#c6ccd0;color:#0076cc}omnibar-button .o-button--control .o-button__element[aria-disabled]~.o-button__content,omnibar-button .o-button--control .o-button__element[disabled]~.o-button__content{border-color:#c6ccd0;color:#9ba3a7}body[modality=keyboard] omnibar-button .o-button--control .o-button__element:focus~.o-button__content:before{border-color:#0076cc}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarButton;
}());
var createProviderConsumer = function (defaultState, consumerRender) {
    var listeners = new Map();
    var currentState = defaultState;
    var updateListener = function (fields, instance) {
        if (Array.isArray(fields)) {
            __spreadArrays(fields).forEach(function (fieldName) {
                instance[fieldName] = currentState[fieldName];
            });
        }
        else {
            instance[fields] = Object.assign({}, currentState);
        }
    };
    var subscribe = function (instance, propList) {
        if (!listeners.has(instance)) {
            listeners.set(instance, propList);
            updateListener(propList, instance);
        }
        return function () {
            if (listeners.has(instance)) {
                listeners.delete(instance);
            }
        };
    };
    var Provider = function (_g, children) {
        var state = _g.state;
        currentState = state;
        listeners.forEach(updateListener);
        return children;
    };
    var Consumer = function (props, children) {
        // The casting on subscribe is to allow for crossover through the stencil compiler
        // In the future we should allow for generics in components.
        return consumerRender(subscribe, children[0]);
    };
    var injectProps = function (Cstr, fieldList) {
        var CstrPrototype = Cstr.prototype;
        var cstrConnectedCallback = CstrPrototype.connectedCallback;
        var cstrDisconnectedCallback = CstrPrototype.disconnectedCallback;
        CstrPrototype.connectedCallback = function () {
            subscribe(this, fieldList);
            if (cstrConnectedCallback) {
                return cstrConnectedCallback.call(this);
            }
        };
        CstrPrototype.disconnectedCallback = function () {
            listeners.delete(this);
            if (cstrDisconnectedCallback) {
                cstrDisconnectedCallback.call(this);
            }
        };
    };
    return {
        Provider: Provider,
        Consumer: Consumer,
        injectProps: injectProps
    };
};
var ShellTunnel = createProviderConsumer({}, function (subscribe, child) { return (h("context-consumer", { subscribe: subscribe, renderer: child })); });
function withAuth(token, opts) {
    if (opts === void 0) { opts = {}; }
    var headers = {
        'Content-Type': 'application/json',
        'Pragma': 'no-cache'
    };
    if (token) {
        headers['Authorization'] = "Bearer " + token;
    }
    return Object.assign({ cache: 'no-store', headers: headers }, opts);
}
function buildUrl(base, path) {
    var sanitizedBase = base.substr(-1) === '/' ? base.slice(0, -1) : base;
    return "" + sanitizedBase + path;
}
function buildQueryString(json) {
    return '?' +
        Object
            .keys(json)
            .map(function (key) {
            if (json[key] != null) {
                if (key === 'onlineHelpQuery') {
                    return json[key];
                }
                else {
                    return encodeURIComponent(key) + '=' +
                        encodeURIComponent(json[key]);
                }
            }
        })
            .filter(function (param) { return param != null; })
            .join('&');
}
function omnibarFetch(url, options) {
    return window.fetch(url, options || {}).then(function (res) {
        if (res.ok) {
            return res.json();
        }
        else {
            if (res.status === 401) {
                var omnibar = document.querySelector('omnibar-shell');
                omnibar.authErrorFetch();
            }
            console.error(res.statusText);
        }
    });
}
var UnityClient = /** @class */ (function () {
    function UnityClient(server, _g) {
        var accessToken = _g.accessToken, authErrorCallback = _g.authErrorCallback;
        this.server = server;
        this.accessToken = accessToken;
        this.authErrorCallback = authErrorCallback;
    }
    UnityClient.prototype.getUserProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        endpoint = buildUrl(this.server, '/apienterprise/user/products');
                        return [4 /*yield*/, omnibarFetch(endpoint, withAuth(this.accessToken))];
                    case 1: return [2 /*return*/, _g.sent()];
                }
            });
        });
    };
    UnityClient.prototype.getUserPersonas = function () {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, response;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        endpoint = buildUrl(this.server, '/apienterprise/user/personas');
                        return [4 /*yield*/, window.fetch(endpoint, withAuth(this.accessToken))];
                    case 1:
                        response = _g.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _g.sent()];
                    case 3:
                        if (response.status === 401)
                            this.authErrorCallback();
                        throw Error(response.statusText);
                }
            });
        });
    };
    UnityClient.prototype.getUserProducts = function (realPageId) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        endpoint = buildUrl(this.server, "/api/user/" + realPageId + "/products");
                        return [4 /*yield*/, omnibarFetch(endpoint, withAuth(this.accessToken))];
                    case 1: return [2 /*return*/, _g.sent()];
                }
            });
        });
    };
    return UnityClient;
}());
var MockUnityClient = /** @class */ (function () {
    function MockUnityClient() {
    }
    MockUnityClient.prototype.getUserProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                console.info('[OMNIBAR][info] getUserProfile');
                return [2 /*return*/, {
                        "user": {
                            "fullName": "RealPage User",
                            "title": "Employee",
                            "companyName": "RealPage",
                            "realPageId": "b9569d01-e4fa-4ee3-9c15-377ca0cc418b",
                            "personaId": 2139
                        },
                        "products": {
                            "favorites": [],
                            "property Management": [
                                {
                                    "id": 26,
                                    "name": "Unified Amenities",
                                    "url": "https://www-dev.realpage.com/home/product/26/2139",
                                    "description": "Unified Amenities",
                                    "label": "unified-amenities",
                                    "familyId": 100,
                                    "familyName": "Property Management",
                                    "isNewTab": false,
                                    "isFavorite": false,
                                    "isResource": false,
                                    "status": 8
                                },
                                {
                                    "id": 16,
                                    "name": "Vendor Credentialing",
                                    "url": "https://www-dev.realpage.com/home/product/16/2139",
                                    "description": "RealPage Vendor Credentialing software is a web-based tracking platform that provides a full-service solution that manages vendor compliance and ensures they continue to work within your guidelines.",
                                    "label": "vendor-services",
                                    "familyId": 100,
                                    "familyName": "Property Management",
                                    "isNewTab": true,
                                    "isFavorite": false,
                                    "isResource": false,
                                    "status": 8
                                }
                            ],
                            "resident Services": [
                                {
                                    "id": 17,
                                    "name": "Resident Portals",
                                    "url": "https://www-dev.realpage.com/home/product/17/2139",
                                    "description": "The RealPage Resident Portals engages residents, boost renewals, and provides.",
                                    "label": "resident-portals",
                                    "familyId": 200,
                                    "familyName": "Resident Services",
                                    "isNewTab": true,
                                    "isFavorite": false,
                                    "isResource": false,
                                    "status": 8
                                }
                            ]
                        },
                        "resources": null
                    }];
            });
        });
    };
    return MockUnityClient;
}());
var HelpClient = /** @class */ (function () {
    function HelpClient(server, _g) {
        var _this_1 = this;
        var accessToken = _g.accessToken, authErrorCallback = _g.authErrorCallback, productCode = _g.productCode, isUnifiedLogin = _g.isUnifiedLogin, demo = _g.demo;
        this.getHelpMenuData = function (queryParams) { return __awaiter(_this_1, void 0, void 0, function () {
            var authHelpPath, noAuthHelpPath, queryString, endpoint;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        authHelpPath = this.isUnifiedLogin && this.accessToken ? "/" + this.apiVersion + "/" + this.productCode + "/simon-menu" : null;
                        noAuthHelpPath = !this.isUnifiedLogin ? "/" + this.apiVersion + "/nonunity/" + this.productCode + "/simon-menu" : null;
                        queryString = buildQueryString(Object.assign(Object.assign({}, queryParams), { ts: Math.floor(new Date().getTime()) }));
                        if (authHelpPath)
                            endpoint = buildUrl(this.server, authHelpPath + queryString);
                        if (noAuthHelpPath)
                            endpoint = buildUrl(this.server, noAuthHelpPath + queryString);
                        if (!endpoint) return [3 /*break*/, 2];
                        return [4 /*yield*/, omnibarFetch(endpoint, withAuth(this.accessToken))];
                    case 1: return [2 /*return*/, _g.sent()];
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        this.trackVideoProgress = function (video, progress) { return __awaiter(_this_1, void 0, void 0, function () {
            var endpoint, response;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (this.demo)
                            return [2 /*return*/]; // TODO: REMOVE AFTER DEMO
                        endpoint = buildUrl(this.server, "/" + this.apiVersion + "/" + this.productCode + "/trace");
                        return [4 /*yield*/, window.fetch(endpoint, withAuth(this.accessToken, {
                                method: 'POST',
                                body: JSON.stringify({
                                    type: "Videos",
                                    watchedPercentage: progress,
                                    items: [
                                        video
                                    ],
                                })
                            }))];
                    case 1:
                        response = _g.sent();
                        return [2 /*return*/, response];
                }
            });
        }); };
        this.trackViewed = function (type, items) { return __awaiter(_this_1, void 0, void 0, function () {
            var endpoint, response;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (this.demo)
                            return [2 /*return*/]; // TODO: REMOVE AFTER DEMO
                        endpoint = buildUrl(this.server, "/" + this.apiVersion + "/" + this.productCode + "/trace");
                        return [4 /*yield*/, window.fetch(endpoint, withAuth(this.accessToken, {
                                method: 'POST',
                                body: JSON.stringify({
                                    type: type,
                                    items: items,
                                })
                            }))];
                    case 1:
                        response = _g.sent();
                        return [2 /*return*/, response];
                }
            });
        }); };
        this.viewedHelpDropdown = function () { return __awaiter(_this_1, void 0, void 0, function () {
            var endpoint, response;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        endpoint = buildUrl(this.server, "/" + this.apiVersion + "/" + this.productCode + "/trace");
                        return [4 /*yield*/, window.fetch(endpoint, withAuth(this.accessToken, {
                                method: 'POST',
                                body: JSON.stringify({})
                            }))];
                    case 1:
                        response = _g.sent();
                        return [2 /*return*/, response];
                }
            });
        }); };
        this.apiVersion = 'v1';
        this.server = server;
        this.accessToken = accessToken;
        this.authErrorCallback = authErrorCallback;
        this.productCode = productCode;
        this.isUnifiedLogin = isUnifiedLogin;
        this.demo = demo; // TODO: REMOVE AFTER DEMO
    }
    return HelpClient;
}());
var MockHelpClient = /** @class */ (function () {
    function MockHelpClient() {
    }
    MockHelpClient.prototype.getHelpMenuData = function (queryParams) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                console.info('[OMNIBAR][info] getHelpMenuData', { queryParams: queryParams });
                return [2 /*return*/, {
                        "enabled": true,
                        "badgeCount": 2,
                        "toastSuggestion": {
                            "action": "Play",
                            "title": "I have a new video to show you.",
                            "body": "Do you want to see it?",
                            "yesText": "Let’s Go",
                            "noText": "Not Now",
                            "url": null,
                            "type": "Videos",
                            "items": [{
                                    "source": "6E0FA75F-223D-4444-8354-95735DA980D5",
                                    "title": "Welcome to Migration Tool",
                                    "subTitle": "Introductory video",
                                    "url": "https://learning.realpage.com/downloads/Simon/ProductIntro/MigrationToolFinal.mp4",
                                    "isViewed": false
                                }]
                        },
                        "knowledgeBase": {
                            "title": "Product Support Knowledge Base",
                            "url": "https://realpage.secure.force.com/knowledgebase",
                            "type": "KnowledgeBase"
                        },
                        "onlineHelp": {
                            "title": "Online Help",
                            "url": "https://devhelp.onesitedev.realpage.com/?pg=ul-home&vr=40&scrver=350",
                            "type": "OnlineHelp",
                            "items": [
                                {
                                    "source": "ul-home",
                                    "title": "How &amp; to Get Here",
                                    "subTitle": null,
                                    "url": "https://devhelp.onesitedev.realpage.com/OneSiteHTMLHelp/RPUP/40/index.asp#130126.htm",
                                    "isViewed": false
                                },
                                {
                                    "source": "ul-home",
                                    "title": "Opening a Product",
                                    "subTitle": null,
                                    "url": "https://devhelp.onesitedev.realpage.com/OneSiteHTMLHelp/RPUP/40/index.asp#130072.htm",
                                    "isViewed": false
                                },
                                {
                                    "source": "ul-home",
                                    "title": "Saving Favorite Products",
                                    "subTitle": null,
                                    "url": "https://devhelp.onesitedev.realpage.com/OneSiteHTMLHelp/RPUP/40/index.asp#130127.htm",
                                    "isViewed": false
                                }
                            ]
                        },
                        "releaseNotes": {
                            "title": "Product Updates",
                            "url": "https://updates.realpage.com/view-releases?product_ids=80&min_release_date=1557792000&max_release_date=1559606400",
                            "type": "ReleaseNotes",
                            "items": [
                                {
                                    "source": "1558605600",
                                    "title": "Upcoming Release May 23",
                                    "subTitle": "View the release notes",
                                    "url": "https://updates.realpage.com/view-releases?product_ids=80&release_dates=1558605600",
                                    "isViewed": false
                                }
                            ]
                        },
                        "videos": {
                            "title": "Videos",
                            "url": "https://helpcenterdev.realpage.com/videos",
                            "type": "Videos"
                        },
                        "all": {
                            "title": "View More Simon Content",
                            "url": "https://helpcenterdev.realpage.com",
                            "type": "All"
                        },
                        "videos-Old": {
                            "url": "",
                            "type": "Videos",
                            "items": [
                                {
                                    "source": "19f83ac4-cda5-4502-89cd-5176c2db9c6c",
                                    "title": "Meet Simon",
                                    "subTitle": "Introductory video",
                                    "url": "https://learning.realpage.com/downloads/Review/SimonIntroduction.mp4",
                                    "isViewed": false
                                },
                                {
                                    "source": "daa36d10-88b0-493a-8e75-c2c73d266f7e",
                                    "title": "Welcome to Unified Platform",
                                    "subTitle": "Introductory video",
                                    "url": "https://learning.realpage.com/downloads/Simon/ProductIntro/UnifiedPlatformIntroductionFinal.mp4",
                                    "isViewed": true
                                }
                            ]
                        }
                    }];
            });
        });
    };
    MockHelpClient.prototype.trackVideoProgress = function (video, progress) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                console.info('[OMNIBAR][info] trackVideoProgress', { video: video, progress: progress });
                return [2 /*return*/];
            });
        });
    };
    MockHelpClient.prototype.trackViewed = function (type, items) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                console.info('[OMNIBAR][info] trackViewed', { type: type, items: items });
                return [2 /*return*/];
            });
        });
    };
    MockHelpClient.prototype.viewedHelpDropdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                console.info('[OMNIBAR][info] viewedHelpDropdown');
                return [2 /*return*/, {
                        "type": null,
                        "watchedPercentage": 0,
                        "badgeCount": 0,
                        "items": null
                    }];
            });
        });
    };
    return MockHelpClient;
}());
var VendorClient = /** @class */ (function () {
    function VendorClient(server) {
        this.server = server;
    }
    VendorClient.prototype.getVendorMarketplaceLinkForUser = function (name, title, company, companyId, productCode) {
        var payload = btoa("\n      {\n        \"name\": \"" + name + "\",\n        \"title\": \"" + title + "\",\n        \"company\": \"" + company + "\",\n        \"companyId\": \"" + companyId + "\",\n        \"productCode\": \"" + productCode + "\",\n        \"timestamp\": \"" + Date.now().toString() + "\"\n      }\n    ");
        return buildUrl(this.server, "?src=" + payload);
    };
    return VendorClient;
}());
var MockVendorClient = /** @class */ (function () {
    function MockVendorClient() {
    }
    MockVendorClient.prototype.getVendorMarketplaceLinkForUser = function (_name, _title, _company, _productCode) {
        return 'https://www.realpage.com/';
    };
    return MockVendorClient;
}());
var MockNotificationsClient = /** @class */ (function () {
    function MockNotificationsClient() {
    }
    MockNotificationsClient.prototype.getNotificationCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                console.info('[OMNIBAR][info] getNotificationCount');
                return [2 /*return*/, 10];
            });
        });
    };
    MockNotificationsClient.prototype.getToast = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                return [2 /*return*/, {
                        // "notification": {
                        //   "product": "Product Name",
                        //   "notificationName": "Notification",
                        //   "createdDateAsString": "MM/DD/YYYY HH:MM AM/PM",
                        //   "message": "System Down until Tomorrow",
                        //   "notificationId": 1234,
                        //   "read": null,
                        //   "severity": "High"
                        // },
                        "notificationCount": 4
                    }];
            });
        });
    };
    MockNotificationsClient.prototype.getNotifications = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                console.info('[OMNIBAR][info] getNotifications');
                return [2 /*return*/, {
                        "notificationsCount": 10,
                        "notifications": [
                            {
                                "notificationId": 87,
                                "product": "Administration",
                                "notificationName": "New Property Added",
                                "created": 1574264840642,
                                "createdDateAsString": "Just now",
                                "message": "Meadow Bay has been added to your list. Meadow Bay has been added to your list. Meadow Bay has been added to your list. Meadow Bay has been added to your list. Meadow Bay has been added to your list.",
                                "redirectUrl": null,
                                "read": null,
                                "severity": "Normal",
                                "actions": [{ "id": 0, "categoryId": 0, "actionId": 2, "actionName": "View", "properties": [{ "propertyId": 1, "propertyValue": "https://www.lead2lease.com/mail.com" }, { "propertyId": 2, "propertyValue": "Put" }] }]
                            },
                            {
                                "notificationId": 84,
                                "product": "Business Intelligence",
                                "notificationName": "Occupancy Alert",
                                "created": 1566831714642,
                                "createdDateAsString": "10 mins ago",
                                "message": "Alamo Plaza has an occupancy of 90%",
                                "redirectUrl": null,
                                "read": null,
                                "severity": "High"
                            },
                            {
                                "notificationId": 81,
                                "product": "OneSite",
                                "notificationName": "Rent Payment Received!",
                                "created": 1566831712569,
                                "createdDateAsString": "Yesterday at 11:20 AM",
                                "message": "Rent paid for John Smith, Unit 1-102",
                                "redirectUrl": null,
                                "read": null,
                                "severity": "Normal"
                            },
                            {
                                "notificationId": 80,
                                "product": "Administration",
                                "notificationName": "New Property Added",
                                "created": 1566832542797,
                                "createdDateAsString": "Just now",
                                "message": "Meadow Bay has been added to your list. Meadow Bay has been added to your list. Meadow Bay has been added to your list. Meadow Bay has been added to your list. Meadow Bay has been added to your list.",
                                "redirectUrl": null,
                                "read": null,
                                "severity": "Normal"
                            },
                            {
                                "notificationId": 79,
                                "product": "Business Intelligence",
                                "notificationName": "Occupancy Alert",
                                "created": 1566831714642,
                                "createdDateAsString": "10 mins ago",
                                "message": "Alamo Plaza has an occupancy of 90%",
                                "redirectUrl": null,
                                "read": null,
                                "severity": "High"
                            }
                        ]
                    }];
            });
        });
    };
    return MockNotificationsClient;
}());
var NotificationsClient = /** @class */ (function () {
    function NotificationsClient(server, _g) {
        var accessToken = _g.accessToken, authErrorCallback = _g.authErrorCallback;
        this.server = server;
        this.accessToken = accessToken;
        this.authErrorCallback = authErrorCallback;
    }
    NotificationsClient.prototype.getNotifications = function () {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        endpoint = buildUrl(this.server, "/User/notifications/group");
                        return [4 /*yield*/, omnibarFetch(endpoint, withAuth(this.accessToken))];
                    case 1: return [2 /*return*/, _g.sent()];
                }
            });
        });
    };
    NotificationsClient.prototype.getFilteredNotifications = function (params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var endpoint;
            return __generator(this, function (_g) {
                endpoint = new URL(buildUrl(this.server, '/User/notifications'));
                Object.keys(params).forEach(function (key) { return endpoint.searchParams.append(key, params[key]); });
                return [2 /*return*/, omnibarFetch(endpoint, withAuth(this.accessToken))];
            });
        });
    };
    NotificationsClient.prototype.getNotificationCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        endpoint = buildUrl(this.server, "/User/notifications/Count");
                        return [4 /*yield*/, omnibarFetch(endpoint, withAuth(this.accessToken))];
                    case 1: return [2 /*return*/, _g.sent()];
                }
            });
        });
    };
    NotificationsClient.prototype.getToast = function () {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        endpoint = buildUrl(this.server, "/api/user/toast-notifications");
                        return [4 /*yield*/, omnibarFetch(endpoint, withAuth(this.accessToken))];
                    case 1: return [2 /*return*/, _g.sent()];
                }
            });
        });
    };
    NotificationsClient.prototype.getLookupData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        endpoint = buildUrl(this.server, "/Lookup");
                        return [4 /*yield*/, omnibarFetch(endpoint, withAuth(this.accessToken))];
                    case 1: return [2 /*return*/, _g.sent()];
                }
            });
        });
    };
    NotificationsClient.prototype.geProductsByUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        endpoint = buildUrl(this.server, "/User/notifications/products");
                        return [4 /*yield*/, omnibarFetch(endpoint, withAuth(this.accessToken))];
                    case 1: return [2 /*return*/, _g.sent()];
                }
            });
        });
    };
    NotificationsClient.prototype.updateNotificationsStatus = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        endpoint = buildUrl(this.server, "/User/notifications");
                        return [4 /*yield*/, omnibarFetch(endpoint, Object.assign(Object.assign({}, withAuth(this.accessToken)), { method: 'PATCH', body: JSON.stringify(request) }))];
                    case 1: return [2 /*return*/, _g.sent()];
                }
            });
        });
    };
    NotificationsClient.prototype.updateAllNotificationsStatus = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        endpoint = buildUrl(this.server, "/User/notifications/All");
                        return [4 /*yield*/, omnibarFetch(endpoint, Object.assign(Object.assign({}, withAuth(this.accessToken)), { method: 'PATCH', body: JSON.stringify(request) }))];
                    case 1: return [2 /*return*/, _g.sent()];
                }
            });
        });
    };
    NotificationsClient.prototype.getPlatformAlertProductTilesCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        endpoint = buildUrl(this.server, "/PlatformAlerts/active/count");
                        return [4 /*yield*/, omnibarFetch(endpoint, withAuth(this.accessToken))];
                    case 1: return [2 /*return*/, _g.sent()];
                }
            });
        });
    };
    NotificationsClient.prototype.getNotificationCountbyProductCode = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        endpoint = buildUrl(this.server, "/PlatformAlerts/active/count?productTileCode=" + code);
                        return [4 /*yield*/, omnibarFetch(endpoint, withAuth(this.accessToken))];
                    case 1: return [2 /*return*/, _g.sent()];
                }
            });
        });
    };
    NotificationsClient.prototype.getPlatformAlertProductTileAlerts = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        endpoint = buildUrl(this.server, "/PlatformAlerts/active?productTileCode=" + code);
                        return [4 /*yield*/, omnibarFetch(endpoint, withAuth(this.accessToken))];
                    case 1: return [2 /*return*/, _g.sent()];
                }
            });
        });
    };
    NotificationsClient.prototype.getPlatformAlertRealpageAlerts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        endpoint = buildUrl(this.server, "/PlatformAlerts/active?isRealPage=true");
                        return [4 /*yield*/, omnibarFetch(endpoint, withAuth(this.accessToken))];
                    case 1: return [2 /*return*/, _g.sent()];
                }
            });
        });
    };
    NotificationsClient.prototype.getProductCategories = function () {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        endpoint = buildUrl(this.server, "/User/preferences/categories");
                        return [4 /*yield*/, omnibarFetch(endpoint, withAuth(this.accessToken))];
                    case 1: return [2 /*return*/, _g.sent()];
                }
            });
        });
    };
    return NotificationsClient;
}());
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var ENVIRONMENTS = ['mock', 'local', 'dev', 'qa', 'sat', 'uat', 'load', 'demo', 'training', 'preprod', 'prod'];
function isLoggedIn(user) {
    return (user != null && !user.expired) || sessionStorage.getItem("profile") !== null;
}
function getClientSettings(config) {
    var environment = config.environment, servers = config.servers, silentRefreshUri = config.silentRefreshUri, postLogoutRedirectUri = config.postLogoutRedirectUri;
    if (!ENVIRONMENTS.includes(config.environment)) {
        console.warn("[OMNIBAR] " + config.environment + " is not a valid environment value. Please checks the docs.");
    }
    var server = Object.assign(Object.assign({}, environments[environment]), servers);
    return {
        authority: server.identity,
        client_id: "omnibarclient",
        response_type: "id_token token",
        scope: "openid userinfoapi enterpriseapi",
        filterProtocolClaims: true,
        loadUserInfo: true,
        automaticSilentRenew: true,
        silent_redirect_uri: silentRefreshUri,
        post_logout_redirect_uri: postLogoutRedirectUri
    };
}
function createClient(service, config) {
    var environment = config.environment, servers = config.servers, rest = __rest(config, ["environment", "servers"]);
    if (!ENVIRONMENTS.includes(config.environment)) {
        console.warn("[OMNIBAR] " + config.environment + " is not a valid environment value. Please checks the docs.");
    }
    var server = Object.assign(Object.assign({}, environments[environment]), servers)[service];
    switch (service) {
        case 'unity': {
            return server ?
                new UnityClient(server, rest) :
                new MockUnityClient();
        }
        case 'help': {
            return server ?
                new HelpClient(server, rest) :
                new MockHelpClient();
        }
        case 'vendor': {
            return server ?
                new VendorClient(server) :
                new MockVendorClient();
        }
        case 'notifications': {
            return server ?
                new NotificationsClient(server, rest) :
                new MockNotificationsClient();
        }
        case 'notificationsignalr': {
            return server ?
                new NotificationsClient(server, rest) :
                new MockNotificationsClient();
        }
        default: {
            throw new Error('Invalid api client');
        }
    }
}
var OmnibarChangeCompanyModal = /** @class */ (function () {
    function class_3(hostRef) {
        registerInstance(this, hostRef);
        this.opened = false;
        this.omnibarChangeCompany = createEvent(this, "omnibarChangeCompany", 7);
        this.closeChangeCompanyModal = createEvent(this, "closeChangeCompanyModal", 7);
    }
    class_3.prototype.apiConfigChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_g) {
                if (this.api.accessToken || this.api.environment) {
                    this.userApiClient = createClient('unity', this.api);
                    this.userApiClient.getUserPersonas().then(function (data) {
                        _this_1.userPersonas = data.data;
                    });
                    this.userApiClient.getUserProfile().then(function (profile) {
                        _this_1.realPageId = profile.user.realPageId;
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    class_3.prototype.componentDidLoad = function () {
        this.newPersona = this.personaId;
    };
    class_3.prototype.changeCompany = function () {
        if (this.newPersona != this.personaId) {
            if (this.productCode === 'UL') {
                this.omnibarChangeCompany.emit(this.newPersona);
                this.close();
            }
            else {
                var sessionkeys = Object.keys(sessionStorage);
                sessionkeys.forEach(function (s) {
                    if (s.includes('oidc.user:'))
                        sessionStorage.removeItem(s);
                });
                window.location.href = environments[this.api.environment].unityHome + "/access/" + this.realPageId + "|" + this.newPersona + "/?productCode=" + this.productCode;
                this.close();
            }
        }
        else {
            this.close();
        }
    };
    class_3.prototype.close = function () {
        this.closeChangeCompanyModal.emit();
    };
    class_3.prototype.createCompanyList = function () {
        var list = [];
        this.userPersonas.forEach(function (item) {
            list.push({ text: item.companyName, value: item.personas[0].personaId });
        });
        return list;
    };
    class_3.prototype.inputChange = function (event) {
        this.newPersona = event.target['value'];
    };
    class_3.prototype.render = function () {
        var _this_1 = this;
        var renderCompanySelect = function () {
            var items = [];
            for (var _g = 0, _h = _this_1.createCompanyList(); _g < _h.length; _g++) {
                var item = _h[_g];
                items.push(h("option", { selected: item.value == _this_1.personaId, value: item.value }, item.text));
            }
            return (h("div", { class: "o-w-full o-mb-4" }, h("omnibar-simple-select", null, h("select", { id: "changeCompany", name: "changeCompany", onChange: function (event) { return _this_1.inputChange(event); } }, items))));
        };
        return (h("omnibar-modal", null, h("omnibar-modal-header", { "modal-title": "Change Company" }), h("omnibar-modal-body", null, h("div", { class: "o-w-full o-pt-4" }, this.userPersonas && renderCompanySelect(), "Changing company will terminate your active sessions for open tabs in ", this.unityCompany, ". Select Ok to continue.")), h("omnibar-modal-footer", null, h("omnibar-button", { variant: "secondary", size: "small", onClick: function () { return _this_1.close(); } }, "Cancel"), h("omnibar-button", { variant: "primary", size: "small", onClick: function () { return _this_1.changeCompany(); } }, "Ok"))));
    };
    Object.defineProperty(class_3, "watchers", {
        get: function () {
            return {
                "api": ["apiConfigChanged"]
            };
        },
        enumerable: true,
        configurable: true
    });
    return class_3;
}());
ShellTunnel.injectProps(OmnibarChangeCompanyModal, ['api', 'productCode', 'unityProducts', 'unityCompany', 'logoutUrl']);
var OmnibarCheckbox = /** @class */ (function () {
    function OmnibarCheckbox(hostRef) {
        registerInstance(this, hostRef);
        /**
         * If `true`, the checkbox border will become red. This can be useful for form validations.
         */
        this.invalid = false;
        /**
         * If `true`, the checkbox size will be small.
         */
        this.small = false;
    }
    OmnibarCheckbox.prototype.render = function () {
        return (h("div", { class: {
                'o-checkbox': true,
                'o-checkbox--invalid': this.invalid,
                'o-checkbox--small': this.small
            } }, h("label", { class: "o-checkbox__label" }, h("slot", null), h("div", { class: "o-checkbox__label__icon" }), this.labelText &&
            h("div", { class: "o-checkbox__label__text" }, this.labelText))));
    };
    Object.defineProperty(OmnibarCheckbox.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OmnibarCheckbox, "style", {
        get: function () { return "omnibar-checkbox{display:inline-block;vertical-align:middle}omnibar-checkbox .o-checkbox__label{display:-ms-flexbox;display:flex;position:relative;cursor:pointer}omnibar-checkbox .o-checkbox__label input[type=checkbox]{position:absolute;width:0;height:0;opacity:0;z-index:-10}omnibar-checkbox .o-checkbox__label input[type=checkbox]:checked~.o-checkbox__label__icon,omnibar-checkbox .o-checkbox__label input[type=checkbox]:indeterminate~.o-checkbox__label__icon{background-color:#0076cc;border-color:#0076cc}omnibar-checkbox .o-checkbox__label input[type=checkbox]:checked~.o-checkbox__label__icon:after{position:absolute;border-top-width:2px;border-left-width:2px;border-color:#fff;content:\"\";height:13px;left:7px;top:14px;-webkit-transform:rotate(-135deg);transform:rotate(-135deg);-webkit-transform-origin:0 0;transform-origin:0 0;width:7px}omnibar-checkbox .o-checkbox__label input[type=checkbox]:indeterminate~.o-checkbox__label__icon:after{position:absolute;border-top-width:2px;border-color:#fff;left:50%;top:50%;content:\"\";-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:.6em}omnibar-checkbox .o-checkbox__label input[type=checkbox]:disabled~.o-checkbox__label__icon{background-color:#ebedee;border-color:#ebedee}omnibar-checkbox .o-checkbox__label input[type=checkbox]:disabled:checked~.o-checkbox__label__icon:after,omnibar-checkbox .o-checkbox__label input[type=checkbox]:disabled:indeterminate~.o-checkbox__label__icon:after{border-color:#9ba3a7}body[modality] omnibar-checkbox .o-checkbox__label input[type=checkbox]:focus~.o-checkbox__label__icon:before{position:absolute;border-radius:.125rem;top:-3px;right:-3px;bottom:-3px;left:-3px;content:\"\";-webkit-box-shadow:0 0 0 1px #0076cc;box-shadow:0 0 0 1px #0076cc}omnibar-checkbox .o-checkbox__label__icon{background-color:#fff;border-width:1px;border-color:#c6ccd0;border-radius:.125rem;width:1.25rem;height:1.25rem;position:relative;font-size:1.25rem;-webkit-transition:background-color .15s linear,border-color .15s linear;transition:background-color .15s linear,border-color .15s linear}omnibar-checkbox .o-checkbox__label__text{margin-left:.5rem;word-break:break-all}omnibar-checkbox .o-checkbox--small .o-checkbox__label__icon{height:14px;width:14px;font-size:14px}omnibar-checkbox .o-checkbox--small .o-checkbox__label input[type=checkbox]:checked~.o-checkbox__label__icon:after{height:10px;width:5px;left:4px;top:10px}omnibar-checkbox .o-checkbox--invalid .o-checkbox__label__icon{border-color:#d01a1f}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarCheckbox;
}());
var Dot = function (props) { return h("div", { class: "o-container-loader__dot", style: { animationDelay: props.animationDelay } }); };
var OmnibarContainerLoader = /** @class */ (function () {
    function OmnibarContainerLoader(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarContainerLoader.prototype.render = function () {
        return (h("div", { class: 'o-container-loader__container' }, h("div", { class: 'o-container-loader__dots-container' }, Array.from({ length: 3 }).map(function (_, index) { return h(Dot, { animationDelay: index * 333 + "ms" }); }))));
    };
    Object.defineProperty(OmnibarContainerLoader, "style", {
        get: function () { return "omnibar-container-loader{display:block}omnibar-container-loader .o-container-loader__container{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;z-index:50;background:hsla(0,0%,100%,.8)}omnibar-container-loader .o-container-loader__container .o-container-loader__dots-container{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between;opacity:1;width:50px}omnibar-container-loader .o-container-loader__container .o-container-loader__dot{background-color:#c6ccd0;height:10px;width:10px;border-radius:50%;-webkit-animation:color_change 1s linear infinite;animation:color_change 1s linear infinite}\@-webkit-keyframes color_change{0%{background-color:#0076cc}20%{background-color:#0076cc}50%{background-color:#c6ccd0}to{background-color:#c6ccd0}}\@keyframes color_change{0%{background-color:#0076cc}20%{background-color:#0076cc}50%{background-color:#c6ccd0}to{background-color:#c6ccd0}}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarContainerLoader;
}());
var OmnibarContextHelp = /** @class */ (function () {
    function class_4(hostRef) {
        registerInstance(this, hostRef);
        this.authenticated = false;
        this.helpQuery = null;
        this.helpPageUrl = null;
        this.disabled = false;
        // OneSite specific params
        this.helpPm = null;
        this.helpSi = null;
        this.helpCs = null;
        this.onlineHelp = null;
    }
    class_4.prototype.apiConfigChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                if (!this.api.environment)
                    return [2 /*return*/];
                // Make API calls here
                this.apiClient = createClient('help', this.api);
                this.loadOnlineHelpOnly();
                return [2 /*return*/];
            });
        });
    };
    class_4.prototype.helpQueryChanged = function () {
        this.loadOnlineHelpOnly();
    };
    class_4.prototype.loadOnlineHelpOnly = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!this.demo && this.disabled || !this.apiClient)
                            return [2 /*return*/];
                        if (!this.helpQuery)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.apiClient.getHelpMenuData(Object.assign({
                                onlineHelpQuery: this.helpQuery,
                                include: 'onlinehelp',
                            }, this.oneSiteParams()))];
                    case 1:
                        resp = _g.sent();
                        this.onlineHelp = resp ? resp.onlineHelp : null;
                        return [2 /*return*/];
                }
            });
        });
    };
    class_4.prototype.onlineHelpUrl = function () {
        return this.helpPageUrl || (this.onlineHelp ? this.onlineHelp.url : (this.api.environment ? environments[this.api.environment]['helpUri'] + "?" + this.helpQuery : "http://onesitehelp.realpage.com/?" + this.helpQuery));
    };
    class_4.prototype.oneSiteParams = function () {
        return {
            pm: this.helpPm,
            si: this.helpSi,
            cs: this.helpCs,
        };
    };
    class_4.prototype.render = function () {
        var _this_1 = this;
        var renderContextOnlineHelp = function () {
            return (h("omnibar-unified-menu-item", { url: _this_1.onlineHelpUrl(), target: "_contextHelp", icon: "omnibar-help" }));
        };
        return (h("div", { class: {
                'o-omnibar-context-help o-inline-block': true,
                'o-demo': this.demo,
            } }, renderContextOnlineHelp()));
    };
    Object.defineProperty(class_4, "watchers", {
        get: function () {
            return {
                "api": ["apiConfigChanged"],
                "helpQuery": ["helpQueryChanged"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_4, "style", {
        get: function () { return ".o-omnibar-context-help .o-unified-menu-item-menu__close{display:none}.o-omnibar-context-help .omnibar-unified-menu-item{color:#000;opacity:.5}"; },
        enumerable: true,
        configurable: true
    });
    return class_4;
}());
ShellTunnel.injectProps(OmnibarContextHelp, ['api', 'pageId', 'authenticated']);
var UP_KEY = ['ArrowUp', 'Up'];
var DOWN_KEY = ['ArrowDown', 'Down'];
var LEFT_KEY = ['ArrowLeft', 'Left'];
var RIGHT_KEY = ['ArrowRight', 'Right'];
var NAVIGATION_KEYS = __spreadArrays(UP_KEY, DOWN_KEY, LEFT_KEY, RIGHT_KEY);
var ESCAPE_KEY = ['Escape', 'Esc'];
var ENTER_KEY = 'Enter';
var TAB_KEY = 'Tab';
//
// isElementInViewport
// Checks if the element completely fits within the current viewport
//
function isElementInViewport(el) {
    el.style.display = 'block';
    var rect = el.getBoundingClientRect();
    el.style.display = '';
    var bounds = getViewportDimensions();
    return (rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= bounds.height &&
        rect.right <= bounds.width);
}
//
// getViewportDimensions
// Returns the viewport's dimensions
//
function getViewportDimensions() {
    return {
        height: window.innerHeight,
        width: window.innerWidth,
    };
}
//
// getScreenSize
// Returns the viewport's size label based on width
//
function getScreenSize() {
    var width = getViewportDimensions().width;
    if (width >= screens.xl) {
        return 'xl';
    }
    else if (width >= screens.lg) {
        return 'lg';
    }
    else if (width >= screens.md) {
        return 'md';
    }
    else {
        return 'sm';
    }
}
/**
 * Keep this in sync with tailwind screens theme.
 */
var screens = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
};
function isScreen(size) {
    var width = getViewportDimensions().width;
    if (size === 'sm') {
        return width > screens.sm;
    }
    else if (size === 'md') {
        return width > screens.md;
    }
    else if (size === 'lg') {
        return width > screens.lg;
    }
    else if (size === 'xl') {
        return width >= screens.xl;
    }
}
//
// elementBlockHeight
// Returns element's height
function elementBlockHeight(el) {
    var height = el.offsetHeight;
    var originalDisplay = el.style.display;
    if (height === 0) {
        el.style.display = 'block';
        height = el.offsetHeight;
        el.style.display = originalDisplay;
    }
    return height;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var isObject_1 = isObject;
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;
/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();
var _root = root;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function () {
    return _root.Date.now();
};
var now_1 = now;
/** Built-in value references. */
var Symbol$1 = _root.Symbol;
var _Symbol = Symbol$1;
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;
/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    }
    catch (e) { }
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) {
            value[symToStringTag] = tag;
        }
        else {
            delete value[symToStringTag];
        }
    }
    return result;
}
var _getRawTag = getRawTag;
/** Used for built-in method references. */
var objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
    return nativeObjectToString$1.call(value);
}
var _objectToString = objectToString;
/** `Object#toString` result references. */
var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return (symToStringTag$1 && symToStringTag$1 in Object(value))
        ? _getRawTag(value)
        : _objectToString(value);
}
var _baseGetTag = baseGetTag;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var isObjectLike_1 = isObjectLike;
/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return typeof value == 'symbol' ||
        (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}
var isSymbol_1 = isSymbol;
/** Used as references for various `Number` constants. */
var NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
    if (typeof value == 'number') {
        return value;
    }
    if (isSymbol_1(value)) {
        return NAN;
    }
    if (isObject_1(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject_1(other) ? (other + '') : other;
    }
    if (typeof value != 'string') {
        return value === 0 ? value : +value;
    }
    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
}
var toNumber_1 = toNumber;
/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
    }
    wait = toNumber_1(wait) || 0;
    if (isObject_1(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber_1(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing
            ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
            : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
            (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
    }
    function timerExpired() {
        var time = now_1();
        if (shouldInvoke(time)) {
            return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
            return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) {
            clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now_1());
    }
    function debounced() {
        var time = now_1(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) {
                return leadingEdge(lastCallTime);
            }
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) {
            timerId = setTimeout(timerExpired, wait);
        }
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var debounce_1 = debounce;
var hookCallback;
function hooks() {
    return hookCallback.apply(null, arguments);
}
// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback(callback) {
    hookCallback = callback;
}
function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}
function isObject$1(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}
function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    }
    else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}
function isUndefined(input) {
    return input === void 0;
}
function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}
function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}
function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}
function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}
function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }
    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }
    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }
    return a;
}
function createUTC(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}
function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
    };
}
function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}
var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
}
else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;
        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }
        return false;
    };
}
function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));
        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}
function createInvalid(flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }
    return m;
}
// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];
function copyConfig(to, from) {
    var i, prop, val;
    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }
    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }
    return to;
}
var updateInProgress = false;
// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}
function isMoment(obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}
function absFloor(number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    }
    else {
        return Math.floor(number);
    }
}
function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion, value = 0;
    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }
    return value;
}
// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}
function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
        (typeof console !== 'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}
function deprecate(msg, fn) {
    var firstTime = true;
    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                }
                else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}
var deprecations = {};
function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}
hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;
function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}
function set(config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        }
        else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
        '|' + (/\d{1,2}/).source);
}
function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject$1(parentConfig[prop]) && isObject$1(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            }
            else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            }
            else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
            !hasOwnProp(childConfig, prop) &&
            isObject$1(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}
function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}
var keys;
if (Object.keys) {
    keys = Object.keys;
}
else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}
var defaultCalendar = {
    sameDay: '[Today at] LT',
    nextDay: '[Tomorrow at] LT',
    nextWeek: 'dddd [at] LT',
    lastDay: '[Yesterday at] LT',
    lastWeek: '[Last] dddd [at] LT',
    sameElse: 'L'
};
function calendar(key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}
var defaultLongDateFormat = {
    LTS: 'h:mm:ss A',
    LT: 'h:mm A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    LLL: 'MMMM D, YYYY h:mm A',
    LLLL: 'dddd, MMMM D, YYYY h:mm A'
};
function longDateFormat(key) {
    var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
    if (format || !formatUpper) {
        return format;
    }
    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });
    return this._longDateFormat[key];
}
var defaultInvalidDate = 'Invalid date';
function invalidDate() {
    return this._invalidDate;
}
var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
function ordinal(number) {
    return this._ordinal.replace('%d', number);
}
var defaultRelativeTime = {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    ss: '%d seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years'
};
function relativeTime(number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}
function pastFuture(diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}
var aliases = {};
function addUnitAlias(unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}
function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}
function normalizeObjectUnits(inputObject) {
    var normalizedInput = {}, normalizedProp, prop;
    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }
    return normalizedInput;
}
var priorities = {};
function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}
function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({ unit: u, priority: priorities[u] });
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}
function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}
var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
var formatFunctions = {};
var formatTokenFunctions = {};
// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken(token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}
function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}
function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;
    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        }
        else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }
    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}
// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }
    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
    return formatFunctions[format](m);
}
function expandFormat(format, locale) {
    var i = 5;
    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }
    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }
    return format;
}
var match1 = /\d/; //       0 - 9
var match2 = /\d\d/; //      00 - 99
var match3 = /\d{3}/; //     000 - 999
var match4 = /\d{4}/; //    0000 - 9999
var match6 = /[+-]?\d{6}/; // -999999 - 999999
var match1to2 = /\d\d?/; //       0 - 99
var match3to4 = /\d\d\d\d?/; //     999 - 9999
var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3 = /\d{1,3}/; //       0 - 999
var match1to4 = /\d{1,4}/; //       0 - 9999
var match1to6 = /[+-]?\d{1,6}/; // -999999 - 999999
var matchUnsigned = /\d+/; //       0 - inf
var matchSigned = /[+-]?\d+/; //    -inf - inf
var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
var regexes = {};
function addRegexToken(token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}
function getParseRegexForToken(token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }
    return regexes[token](config._strict, config._locale);
}
// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}
function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}
var tokens = {};
function addParseToken(token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}
function addWeekParseToken(token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}
function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}
var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;
// FORMATTING
addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});
addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});
addFormatToken(0, ['YYYY', 4], 0, 'year');
addFormatToken(0, ['YYYYY', 5], 0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
// ALIASES
addUnitAlias('year', 'y');
// PRIORITIES
addUnitPriority('year', 1);
// PARSING
addRegexToken('Y', matchSigned);
addRegexToken('YY', match1to2, match2);
addRegexToken('YYYY', match1to4, match4);
addRegexToken('YYYYY', match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);
addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});
// HELPERS
function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}
function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}
// HOOKS
hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};
// MOMENTS
var getSetYear = makeGetSet('FullYear', true);
function getIsLeapYear() {
    return isLeapYear(this.year());
}
function makeGetSet(unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        }
        else {
            return get(this, unit);
        }
    };
}
function get(mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}
function set$1(mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}
// MOMENTS
function stringGet(units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}
function stringSet(units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    }
    else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}
function mod(n, x) {
    return ((n % x) + x) % x;
}
var indexOf;
if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
}
else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}
function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}
// FORMATTING
addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});
addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});
addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});
// ALIASES
addUnitAlias('month', 'M');
// PRIORITY
addUnitPriority('month', 8);
// PARSING
addRegexToken('M', match1to2);
addRegexToken('MM', match1to2, match2);
addRegexToken('MMM', function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});
addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});
addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    }
    else {
        getParsingFlags(config).invalidMonth = input;
    }
});
// LOCALES
var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths(m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}
var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort(m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}
function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }
    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
        else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
        else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}
function localeMonthsParse(monthName, format, strict) {
    var i, mom, regex;
    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }
    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }
    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        }
        else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        }
        else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}
// MOMENTS
function setMonth(mom, value) {
    var dayOfMonth;
    if (!mom.isValid()) {
        // No op
        return mom;
    }
    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        }
        else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }
    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}
function getSetMonth(value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    }
    else {
        return get(this, 'Month');
    }
}
function getDaysInMonth() {
    return daysInMonth(this.year(), this.month());
}
var defaultMonthsShortRegex = matchWord;
function monthsShortRegex(isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        }
        else {
            return this._monthsShortRegex;
        }
    }
    else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}
var defaultMonthsRegex = matchWord;
function monthsRegex(isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        }
        else {
            return this._monthsRegex;
        }
    }
    else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}
function computeMonthsParse() {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }
    var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }
    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}
function createDate(y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date;
    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        date = new Date(y + 400, m, d, h, M, s, ms);
        if (isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
    }
    else {
        date = new Date(y, m, d, h, M, s, ms);
    }
    return date;
}
function createUTCDate(y) {
    var date;
    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        var args = Array.prototype.slice.call(arguments);
        // preserve leap years using a full 400 year cycle, then reset
        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));
        if (isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
    }
    else {
        date = new Date(Date.UTC.apply(null, arguments));
    }
    return date;
}
// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    fwd = 7 + dow - doy, 
    // first-week day local weekday -- which local weekday is fwd
    fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    }
    else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    }
    else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }
    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}
function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    }
    else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    }
    else {
        resYear = mom.year();
        resWeek = week;
    }
    return {
        week: resWeek,
        year: resYear
    };
}
function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}
// FORMATTING
addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
// ALIASES
addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');
// PRIORITIES
addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);
// PARSING
addRegexToken('w', match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W', match1to2);
addRegexToken('WW', match1to2, match2);
addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});
// HELPERS
// LOCALES
function localeWeek(mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}
var defaultLocaleWeek = {
    dow: 0,
    doy: 6 // The week that contains Jan 6th is the first week of the year.
};
function localeFirstDayOfWeek() {
    return this._week.dow;
}
function localeFirstDayOfYear() {
    return this._week.doy;
}
// MOMENTS
function getSetWeek(input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}
function getSetISOWeek(input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}
// FORMATTING
addFormatToken('d', 0, 'do', 'day');
addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});
addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});
addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});
addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');
// ALIASES
addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');
// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);
// PARSING
addRegexToken('d', match1to2);
addRegexToken('e', match1to2);
addRegexToken('E', match1to2);
addRegexToken('dd', function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd', function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd', function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});
addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    }
    else {
        getParsingFlags(config).invalidWeekday = input;
    }
});
addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});
// HELPERS
function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }
    if (!isNaN(input)) {
        return parseInt(input, 10);
    }
    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }
    return null;
}
function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}
// LOCALES
function shiftWeekdays(ws, n) {
    return ws.slice(n, 7).concat(ws.slice(0, n));
}
var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays(m, format) {
    var weekdays = isArray(this._weekdays) ? this._weekdays :
        this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
    return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
        : (m) ? weekdays[m.day()] : weekdays;
}
var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort(m) {
    return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
        : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}
var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin(m) {
    return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
        : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}
function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];
        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }
    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
        else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
        else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
        else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
        else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}
function localeWeekdaysParse(weekdayName, format, strict) {
    var i, mom, regex;
    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        }
        else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        }
        else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        }
        else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}
// MOMENTS
function getSetDayOfWeek(input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    }
    else {
        return day;
    }
}
function getSetLocaleDayOfWeek(input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}
function getSetISODayOfWeek(input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.
    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    }
    else {
        return this.day() || 7;
    }
}
var defaultWeekdaysRegex = matchWord;
function weekdaysRegex(isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        }
        else {
            return this._weekdaysRegex;
        }
    }
    else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}
var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex(isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        }
        else {
            return this._weekdaysShortRegex;
        }
    }
    else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}
var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex(isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        }
        else {
            return this._weekdaysMinRegex;
        }
    }
    else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}
function computeWeekdaysParse() {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }
    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }
    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;
    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}
// FORMATTING
function hFormat() {
    return this.hours() % 12 || 12;
}
function kFormat() {
    return this.hours() || 24;
}
addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);
addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});
addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});
addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});
addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});
function meridiem(token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}
meridiem('a', true);
meridiem('A', false);
// ALIASES
addUnitAlias('hour', 'h');
// PRIORITY
addUnitPriority('hour', 13);
// PARSING
function matchMeridiem(isStrict, locale) {
    return locale._meridiemParse;
}
addRegexToken('a', matchMeridiem);
addRegexToken('A', matchMeridiem);
addRegexToken('H', match1to2);
addRegexToken('h', match1to2);
addRegexToken('k', match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);
addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);
addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});
// LOCALES
function localeIsPM(input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}
var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem(hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    }
    else {
        return isLower ? 'am' : 'AM';
    }
}
// MOMENTS
// Setting the hour should keep the time, because the user explicitly
// specified which hour they want. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,
    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,
    week: defaultLocaleWeek,
    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,
    meridiemParse: defaultLocaleMeridiemParse
};
// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;
function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}
// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;
    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return globalLocale;
}
function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
        module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        }
        catch (e) { }
    }
    return locales[name];
}
// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale(key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }
        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
        else {
            if ((typeof console !== 'undefined') && console.warn) {
                //warn user if arguments are passed but the locale could not be set
                console.warn('Locale ' + key + ' not found. Did you forget to load it?');
            }
        }
    }
    return globalLocale._abbr;
}
function defineLocale(name, config) {
    if (config !== null) {
        var locale, parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' +
                'an existing locale. moment.defineLocale(localeName, ' +
                'config) should only be used for creating a new locale ' +
                'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        }
        else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            }
            else {
                locale = loadLocale(config.parentLocale);
                if (locale != null) {
                    parentConfig = locale._config;
                }
                else {
                    if (!localeFamilies[config.parentLocale]) {
                        localeFamilies[config.parentLocale] = [];
                    }
                    localeFamilies[config.parentLocale].push({
                        name: name,
                        config: config
                    });
                    return null;
                }
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));
        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }
        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);
        return locales[name];
    }
    else {
        // useful for testing
        delete locales[name];
        return null;
    }
}
function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;
        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    }
    else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            }
            else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}
// returns locale data
function getLocale(key) {
    var locale;
    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }
    if (!key) {
        return globalLocale;
    }
    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }
    return chooseLocale(key);
}
function listLocales() {
    return keys(locales);
}
function checkOverflow(m) {
    var overflow;
    var a = m._a;
    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH] < 0 || a[MONTH] > 11 ? MONTH :
                a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                    a[HOUR] < 0 || a[HOUR] > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                        a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE :
                            a[SECOND] < 0 || a[SECOND] > 59 ? SECOND :
                                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                                    -1;
        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }
        getParsingFlags(m).overflow = overflow;
    }
    return m;
}
// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}
function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}
// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray(config) {
    var i, date, input = [], currentDate, expectedWeekday, yearToUse;
    if (config._d) {
        return;
    }
    currentDate = currentDateArray(config);
    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }
    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }
        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }
    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }
    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }
    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
        config._a[MINUTE] === 0 &&
        config._a[SECOND] === 0 &&
        config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }
    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }
    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}
function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;
        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    }
    else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;
        var curWeek = weekOfYear(createLocal(), dow, doy);
        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
        // Default to current week.
        week = defaults(w.w, curWeek.week);
        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        }
        else if (w.e != null) {
            // local weekday -- counting starts from beginning of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        }
        else {
            // default to beginning of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    }
    else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    }
    else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}
// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];
// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];
var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
// date from iso format
function configFromISO(config) {
    var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat;
    if (match) {
        getParsingFlags(config).iso = true;
        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            }
            else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    }
    else {
        config._isValid = false;
    }
}
// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];
    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }
    return result;
}
function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    }
    else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}
function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
}
function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}
var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};
function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    }
    else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    }
    else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}
// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }
        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);
        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        getParsingFlags(config).rfc2822 = true;
    }
    else {
        config._isValid = false;
    }
}
// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);
    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }
    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    }
    else {
        return;
    }
    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    }
    else {
        return;
    }
    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}
hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
    config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
});
// constant that refers to the ISO standard
hooks.ISO_8601 = function () { };
// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () { };
// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;
    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0;
    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }
    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }
    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }
    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
    configFromArray(config);
    checkOverflow(config);
}
function meridiemFixWrap(locale, hour, meridiem) {
    var isPm;
    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    }
    else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    }
    else {
        // this is not supposed to happen
        return hour;
    }
}
// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig, bestMoment, scoreToBeat, i, currentScore;
    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }
    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);
        if (!isValid(tempConfig)) {
            continue;
        }
        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;
        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
        getParsingFlags(tempConfig).score = currentScore;
        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }
    extend(config, bestMoment || tempConfig);
}
function configFromObject(config) {
    if (config._d) {
        return;
    }
    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });
    configFromArray(config);
}
function createFromConfig(config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }
    return res;
}
function prepareConfig(config) {
    var input = config._i, format = config._f;
    config._locale = config._locale || getLocale(config._l);
    if (input === null || (format === undefined && input === '')) {
        return createInvalid({ nullInput: true });
    }
    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }
    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    }
    else if (isDate(input)) {
        config._d = input;
    }
    else if (isArray(format)) {
        configFromStringAndArray(config);
    }
    else if (format) {
        configFromStringAndFormat(config);
    }
    else {
        configFromInput(config);
    }
    if (!isValid(config)) {
        config._d = null;
    }
    return config;
}
function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    }
    else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    }
    else if (typeof input === 'string') {
        configFromString(config);
    }
    else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    }
    else if (isObject$1(input)) {
        configFromObject(config);
    }
    else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    }
    else {
        hooks.createFromInputFallback(config);
    }
}
function createLocalOrUTC(input, format, locale, strict, isUTC) {
    var c = {};
    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }
    if ((isObject$1(input) && isObjectEmpty(input)) ||
        (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;
    return createFromConfig(c);
}
function createLocal(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}
var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
    var other = createLocal.apply(null, arguments);
    if (this.isValid() && other.isValid()) {
        return other < this ? this : other;
    }
    else {
        return createInvalid();
    }
});
var prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
    var other = createLocal.apply(null, arguments);
    if (this.isValid() && other.isValid()) {
        return other > this ? this : other;
    }
    else {
        return createInvalid();
    }
});
// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}
// TODO: Use [].sort instead?
function min() {
    var args = [].slice.call(arguments, 0);
    return pickBy('isBefore', args);
}
function max() {
    var args = [].slice.call(arguments, 0);
    return pickBy('isAfter', args);
}
var now$1 = function () {
    return Date.now ? Date.now() : +(new Date());
};
var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }
    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }
    return true;
}
function isValid$1() {
    return this._isValid;
}
function createInvalid$1() {
    return createDuration(NaN);
}
function Duration(duration) {
    var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
    this._isValid = isDurationValid(normalizedInput);
    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;
    this._data = {};
    this._locale = getLocale();
    this._bubble();
}
function isDuration(obj) {
    return obj instanceof Duration;
}
function absRound(number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    }
    else {
        return Math.round(number);
    }
}
// FORMATTING
function offset(token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}
offset('Z', ':');
offset('ZZ', '');
// PARSING
addRegexToken('Z', matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});
// HELPERS
// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;
function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);
    if (matches === null) {
        return null;
    }
    var chunk = matches[matches.length - 1] || [];
    var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);
    return minutes === 0 ?
        0 :
        parts[0] === '+' ? minutes : -minutes;
}
// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    }
    else {
        return createLocal(input).local();
    }
}
function getDateOffset(m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}
// HOOKS
// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () { };
// MOMENTS
// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset(input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0, localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        }
        else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            }
            else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    }
    else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}
function getSetZone(input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }
        this.utcOffset(input, keepLocalTime);
        return this;
    }
    else {
        return -this.utcOffset();
    }
}
function setOffsetToUTC(keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}
function setOffsetToLocal(keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;
        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}
function setOffsetToParsedOffset() {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    }
    else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}
function hasAlignedHourOffset(input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;
    return (this.utcOffset() - input) % 60 === 0;
}
function isDaylightSavingTime() {
    return (this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset());
}
function isDaylightSavingTimeShifted() {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }
    var c = {};
    copyConfig(c, this);
    c = prepareConfig(c);
    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    }
    else {
        this._isDSTShifted = false;
    }
    return this._isDSTShifted;
}
function isLocal() {
    return this.isValid() ? !this._isUTC : false;
}
function isUtcOffset() {
    return this.isValid() ? this._isUTC : false;
}
function isUtc() {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}
// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function createDuration(input, key) {
    var duration = input, 
    // matching against regexp is expensive, do it on demand
    match = null, sign, ret, diffRes;
    if (isDuration(input)) {
        duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
    }
    else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        }
        else {
            duration.milliseconds = input;
        }
    }
    else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y: 0,
            d: toInt(match[DATE]) * sign,
            h: toInt(match[HOUR]) * sign,
            m: toInt(match[MINUTE]) * sign,
            s: toInt(match[SECOND]) * sign,
            ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    }
    else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y: parseIso(match[2], sign),
            M: parseIso(match[3], sign),
            w: parseIso(match[4], sign),
            d: parseIso(match[5], sign),
            h: parseIso(match[6], sign),
            m: parseIso(match[7], sign),
            s: parseIso(match[8], sign)
        };
    }
    else if (duration == null) { // checks for null or undefined
        duration = {};
    }
    else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }
    ret = new Duration(duration);
    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }
    return ret;
}
createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;
function parseIso(inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}
function positiveMomentsDifference(base, other) {
    var res = {};
    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }
    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
    return res;
}
function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return { milliseconds: 0, months: 0 };
    }
    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    }
    else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }
    return res;
}
// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val;
            val = period;
            period = tmp;
        }
        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}
function addSubtract(mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
    if (!mom.isValid()) {
        // No op
        return;
    }
    updateOffset = updateOffset == null ? true : updateOffset;
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}
var add = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');
function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
        diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                    diff < 2 ? 'nextDay' :
                        diff < 7 ? 'nextWeek' : 'sameElse';
}
function calendar$1(time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse';
    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}
function clone() {
    return new Moment(this);
}
function isAfter(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units) || 'millisecond';
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    }
    else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}
function isBefore(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units) || 'millisecond';
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    }
    else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}
function isBetween(from, to, units, inclusivity) {
    var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
    if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
    }
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
}
function isSame(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input), inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units) || 'millisecond';
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    }
    else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}
function isSameOrAfter(input, units) {
    return this.isSame(input, units) || this.isAfter(input, units);
}
function isSameOrBefore(input, units) {
    return this.isSame(input, units) || this.isBefore(input, units);
}
function diff(input, units, asFloat) {
    var that, zoneDelta, output;
    if (!this.isValid()) {
        return NaN;
    }
    that = cloneWithOffset(input, this);
    if (!that.isValid()) {
        return NaN;
    }
    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
    units = normalizeUnits(units);
    switch (units) {
        case 'year':
            output = monthDiff(this, that) / 12;
            break;
        case 'month':
            output = monthDiff(this, that);
            break;
        case 'quarter':
            output = monthDiff(this, that) / 3;
            break;
        case 'second':
            output = (this - that) / 1e3;
            break; // 1000
        case 'minute':
            output = (this - that) / 6e4;
            break; // 1000 * 60
        case 'hour':
            output = (this - that) / 36e5;
            break; // 1000 * 60 * 60
        case 'day':
            output = (this - that - zoneDelta) / 864e5;
            break; // 1000 * 60 * 60 * 24, negate dst
        case 'week':
            output = (this - that - zoneDelta) / 6048e5;
            break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }
    return asFloat ? output : absFloor(output);
}
function monthDiff(a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()), 
    // b is in (anchor - 1 month, anchor + 1 month)
    anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    }
    else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }
    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}
hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
function toString() {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}
function toISOString(keepOffset) {
    if (!this.isValid()) {
        return null;
    }
    var utc = keepOffset !== true;
    var m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
            return this.toDate().toISOString();
        }
        else {
            return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
    }
    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
}
/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect() {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';
    return this.format(prefix + year + datetime + suffix);
}
function format(inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}
function from(time, withoutSuffix) {
    if (this.isValid() &&
        ((isMoment(time) && time.isValid()) ||
            createLocal(time).isValid())) {
        return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
    }
    else {
        return this.localeData().invalidDate();
    }
}
function fromNow(withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}
function to(time, withoutSuffix) {
    if (this.isValid() &&
        ((isMoment(time) && time.isValid()) ||
            createLocal(time).isValid())) {
        return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
    }
    else {
        return this.localeData().invalidDate();
    }
}
function toNow(withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}
// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale(key) {
    var newLocaleData;
    if (key === undefined) {
        return this._locale._abbr;
    }
    else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}
var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
    if (key === undefined) {
        return this.localeData();
    }
    else {
        return this.locale(key);
    }
});
function localeData() {
    return this._locale;
}
var MS_PER_SECOND = 1000;
var MS_PER_MINUTE = 60 * MS_PER_SECOND;
var MS_PER_HOUR = 60 * MS_PER_MINUTE;
var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
// actual modulo - handles negative numbers (for dates before 1970):
function mod$1(dividend, divisor) {
    return (dividend % divisor + divisor) % divisor;
}
function localStartOfDate(y, m, d) {
    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
    }
    else {
        return new Date(y, m, d).valueOf();
    }
}
function utcStartOfDate(y, m, d) {
    // Date.UTC remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
    }
    else {
        return Date.UTC(y, m, d);
    }
}
function startOf(units) {
    var time;
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
    }
    var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
    switch (units) {
        case 'year':
            time = startOfDate(this.year(), 0, 1);
            break;
        case 'quarter':
            time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
            break;
        case 'month':
            time = startOfDate(this.year(), this.month(), 1);
            break;
        case 'week':
            time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
            break;
        case 'isoWeek':
            time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
            break;
        case 'day':
        case 'date':
            time = startOfDate(this.year(), this.month(), this.date());
            break;
        case 'hour':
            time = this._d.valueOf();
            time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
            break;
        case 'minute':
            time = this._d.valueOf();
            time -= mod$1(time, MS_PER_MINUTE);
            break;
        case 'second':
            time = this._d.valueOf();
            time -= mod$1(time, MS_PER_SECOND);
            break;
    }
    this._d.setTime(time);
    hooks.updateOffset(this, true);
    return this;
}
function endOf(units) {
    var time;
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
    }
    var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
    switch (units) {
        case 'year':
            time = startOfDate(this.year() + 1, 0, 1) - 1;
            break;
        case 'quarter':
            time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
            break;
        case 'month':
            time = startOfDate(this.year(), this.month() + 1, 1) - 1;
            break;
        case 'week':
            time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
            break;
        case 'isoWeek':
            time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
            break;
        case 'day':
        case 'date':
            time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
            break;
        case 'hour':
            time = this._d.valueOf();
            time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
            break;
        case 'minute':
            time = this._d.valueOf();
            time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
            break;
        case 'second':
            time = this._d.valueOf();
            time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
            break;
    }
    this._d.setTime(time);
    hooks.updateOffset(this, true);
    return this;
}
function valueOf() {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}
function unix() {
    return Math.floor(this.valueOf() / 1000);
}
function toDate() {
    return new Date(this.valueOf());
}
function toArray() {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}
function toObject() {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}
function toJSON() {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}
function isValid$2() {
    return isValid(this);
}
function parsingFlags() {
    return extend({}, getParsingFlags(this));
}
function invalidAt() {
    return getParsingFlags(this).overflow;
}
function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}
// FORMATTING
addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});
addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});
function addWeekYearFormatToken(token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}
addWeekYearFormatToken('gggg', 'weekYear');
addWeekYearFormatToken('ggggg', 'weekYear');
addWeekYearFormatToken('GGGG', 'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');
// ALIASES
addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');
// PRIORITY
addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);
// PARSING
addRegexToken('G', matchSigned);
addRegexToken('g', matchSigned);
addRegexToken('GG', match1to2, match2);
addRegexToken('gg', match1to2, match2);
addRegexToken('GGGG', match1to4, match4);
addRegexToken('gggg', match1to4, match4);
addRegexToken('GGGGG', match1to6, match6);
addRegexToken('ggggg', match1to6, match6);
addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});
addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});
// MOMENTS
function getSetWeekYear(input) {
    return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
}
function getSetISOWeekYear(input) {
    return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
}
function getISOWeeksInYear() {
    return weeksInYear(this.year(), 1, 4);
}
function getWeeksInYear() {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}
function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    }
    else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}
function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}
// FORMATTING
addFormatToken('Q', 0, 'Qo', 'quarter');
// ALIASES
addUnitAlias('quarter', 'Q');
// PRIORITY
addUnitPriority('quarter', 7);
// PARSING
addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});
// MOMENTS
function getSetQuarter(input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}
// FORMATTING
addFormatToken('D', ['DD', 2], 'Do', 'date');
// ALIASES
addUnitAlias('date', 'D');
// PRIORITY
addUnitPriority('date', 9);
// PARSING
addRegexToken('D', match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
        (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
        locale._dayOfMonthOrdinalParseLenient;
});
addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});
// MOMENTS
var getSetDayOfMonth = makeGetSet('Date', true);
// FORMATTING
addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
// ALIASES
addUnitAlias('dayOfYear', 'DDD');
// PRIORITY
addUnitPriority('dayOfYear', 4);
// PARSING
addRegexToken('DDD', match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});
// HELPERS
// MOMENTS
function getSetDayOfYear(input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}
// FORMATTING
addFormatToken('m', ['mm', 2], 0, 'minute');
// ALIASES
addUnitAlias('minute', 'm');
// PRIORITY
addUnitPriority('minute', 14);
// PARSING
addRegexToken('m', match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);
// MOMENTS
var getSetMinute = makeGetSet('Minutes', false);
// FORMATTING
addFormatToken('s', ['ss', 2], 0, 'second');
// ALIASES
addUnitAlias('second', 's');
// PRIORITY
addUnitPriority('second', 15);
// PARSING
addRegexToken('s', match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);
// MOMENTS
var getSetSecond = makeGetSet('Seconds', false);
// FORMATTING
addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});
addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});
addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});
// ALIASES
addUnitAlias('millisecond', 'ms');
// PRIORITY
addUnitPriority('millisecond', 16);
// PARSING
addRegexToken('S', match1to3, match1);
addRegexToken('SS', match1to3, match2);
addRegexToken('SSS', match1to3, match3);
var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}
function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}
for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS
var getSetMillisecond = makeGetSet('Milliseconds', false);
// FORMATTING
addFormatToken('z', 0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');
// MOMENTS
function getZoneAbbr() {
    return this._isUTC ? 'UTC' : '';
}
function getZoneName() {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}
var proto = Moment.prototype;
proto.add = add;
proto.calendar = calendar$1;
proto.clone = clone;
proto.diff = diff;
proto.endOf = endOf;
proto.format = format;
proto.from = from;
proto.fromNow = fromNow;
proto.to = to;
proto.toNow = toNow;
proto.get = stringGet;
proto.invalidAt = invalidAt;
proto.isAfter = isAfter;
proto.isBefore = isBefore;
proto.isBetween = isBetween;
proto.isSame = isSame;
proto.isSameOrAfter = isSameOrAfter;
proto.isSameOrBefore = isSameOrBefore;
proto.isValid = isValid$2;
proto.lang = lang;
proto.locale = locale;
proto.localeData = localeData;
proto.max = prototypeMax;
proto.min = prototypeMin;
proto.parsingFlags = parsingFlags;
proto.set = stringSet;
proto.startOf = startOf;
proto.subtract = subtract;
proto.toArray = toArray;
proto.toObject = toObject;
proto.toDate = toDate;
proto.toISOString = toISOString;
proto.inspect = inspect;
proto.toJSON = toJSON;
proto.toString = toString;
proto.unix = unix;
proto.valueOf = valueOf;
proto.creationData = creationData;
proto.year = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week = proto.weeks = getSetWeek;
proto.isoWeek = proto.isoWeeks = getSetISOWeek;
proto.weeksInYear = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.date = getSetDayOfMonth;
proto.day = proto.days = getSetDayOfWeek;
proto.weekday = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset = getSetOffset;
proto.utc = setOffsetToUTC;
proto.local = setOffsetToLocal;
proto.parseZone = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST = isDaylightSavingTime;
proto.isLocal = isLocal;
proto.isUtcOffset = isUtcOffset;
proto.isUtc = isUtc;
proto.isUTC = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
function createUnix(input) {
    return createLocal(input * 1000);
}
function createInZone() {
    return createLocal.apply(null, arguments).parseZone();
}
function preParsePostFormat(string) {
    return string;
}
var proto$1 = Locale.prototype;
proto$1.calendar = calendar;
proto$1.longDateFormat = longDateFormat;
proto$1.invalidDate = invalidDate;
proto$1.ordinal = ordinal;
proto$1.preparse = preParsePostFormat;
proto$1.postformat = preParsePostFormat;
proto$1.relativeTime = relativeTime;
proto$1.pastFuture = pastFuture;
proto$1.set = set;
proto$1.months = localeMonths;
proto$1.monthsShort = localeMonthsShort;
proto$1.monthsParse = localeMonthsParse;
proto$1.monthsRegex = monthsRegex;
proto$1.monthsShortRegex = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;
proto$1.weekdays = localeWeekdays;
proto$1.weekdaysMin = localeWeekdaysMin;
proto$1.weekdaysShort = localeWeekdaysShort;
proto$1.weekdaysParse = localeWeekdaysParse;
proto$1.weekdaysRegex = weekdaysRegex;
proto$1.weekdaysShortRegex = weekdaysShortRegex;
proto$1.weekdaysMinRegex = weekdaysMinRegex;
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;
function get$1(format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}
function listMonthsImpl(format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }
    format = format || '';
    if (index != null) {
        return get$1(format, index, field, 'month');
    }
    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}
// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl(localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
    }
    else {
        format = localeSorted;
        index = format;
        localeSorted = false;
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
    }
    var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0;
    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }
    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}
function listMonths(format, index) {
    return listMonthsImpl(format, index, 'months');
}
function listMonthsShort(format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}
function listWeekdays(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}
function listWeekdaysShort(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}
function listWeekdaysMin(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}
getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function (number) {
        var b = number % 10, output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                    (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});
// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
var mathAbs = Math.abs;
function abs() {
    var data = this._data;
    this._milliseconds = mathAbs(this._milliseconds);
    this._days = mathAbs(this._days);
    this._months = mathAbs(this._months);
    data.milliseconds = mathAbs(data.milliseconds);
    data.seconds = mathAbs(data.seconds);
    data.minutes = mathAbs(data.minutes);
    data.hours = mathAbs(data.hours);
    data.months = mathAbs(data.months);
    data.years = mathAbs(data.years);
    return this;
}
function addSubtract$1(duration, input, value, direction) {
    var other = createDuration(input, value);
    duration._milliseconds += direction * other._milliseconds;
    duration._days += direction * other._days;
    duration._months += direction * other._months;
    return duration._bubble();
}
// supports only 2.0-style add(1, 's') or add(duration)
function add$1(input, value) {
    return addSubtract$1(this, input, value, 1);
}
// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1(input, value) {
    return addSubtract$1(this, input, value, -1);
}
function absCeil(number) {
    if (number < 0) {
        return Math.floor(number);
    }
    else {
        return Math.ceil(number);
    }
}
function bubble() {
    var milliseconds = this._milliseconds;
    var days = this._days;
    var months = this._months;
    var data = this._data;
    var seconds, minutes, hours, years, monthsFromDays;
    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
        (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }
    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;
    seconds = absFloor(milliseconds / 1000);
    data.seconds = seconds % 60;
    minutes = absFloor(seconds / 60);
    data.minutes = minutes % 60;
    hours = absFloor(minutes / 60);
    data.hours = hours % 24;
    days += absFloor(hours / 24);
    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));
    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;
    data.days = days;
    data.months = months;
    data.years = years;
    return this;
}
function daysToMonths(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}
function monthsToDays(months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}
function as(units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;
    units = normalizeUnits(units);
    if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        switch (units) {
            case 'month': return months;
            case 'quarter': return months / 3;
            case 'year': return months / 12;
        }
    }
    else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week': return days / 7 + milliseconds / 6048e5;
            case 'day': return days + milliseconds / 864e5;
            case 'hour': return days * 24 + milliseconds / 36e5;
            case 'minute': return days * 1440 + milliseconds / 6e4;
            case 'second': return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}
// TODO: Use this.as('ms')?
function valueOf$1() {
    if (!this.isValid()) {
        return NaN;
    }
    return (this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6);
}
function makeAs(alias) {
    return function () {
        return this.as(alias);
    };
}
var asMilliseconds = makeAs('ms');
var asSeconds = makeAs('s');
var asMinutes = makeAs('m');
var asHours = makeAs('h');
var asDays = makeAs('d');
var asWeeks = makeAs('w');
var asMonths = makeAs('M');
var asQuarters = makeAs('Q');
var asYears = makeAs('y');
function clone$1() {
    return createDuration(this);
}
function get$2(units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}
function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}
var milliseconds = makeGetter('milliseconds');
var seconds = makeGetter('seconds');
var minutes = makeGetter('minutes');
var hours = makeGetter('hours');
var days = makeGetter('days');
var months = makeGetter('months');
var years = makeGetter('years');
function weeks() {
    return absFloor(this.days() / 7);
}
var round = Math.round;
var thresholds = {
    ss: 44,
    s: 45,
    m: 45,
    h: 22,
    d: 26,
    M: 11 // months to year
};
// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}
function relativeTime$1(posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds = round(duration.as('s'));
    var minutes = round(duration.as('m'));
    var hours = round(duration.as('h'));
    var days = round(duration.as('d'));
    var months = round(duration.as('M'));
    var years = round(duration.as('y'));
    var a = seconds <= thresholds.ss && ['s', seconds] ||
        seconds < thresholds.s && ['ss', seconds] ||
        minutes <= 1 && ['m'] ||
        minutes < thresholds.m && ['mm', minutes] ||
        hours <= 1 && ['h'] ||
        hours < thresholds.h && ['hh', hours] ||
        days <= 1 && ['d'] ||
        days < thresholds.d && ['dd', days] ||
        months <= 1 && ['M'] ||
        months < thresholds.M && ['MM', months] ||
        years <= 1 && ['y'] || ['yy', years];
    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}
// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding(roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof (roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}
// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold(threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}
function humanize(withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }
    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);
    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }
    return locale.postformat(output);
}
var abs$1 = Math.abs;
function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}
function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }
    var seconds = abs$1(this._milliseconds) / 1000;
    var days = abs$1(this._days);
    var months = abs$1(this._months);
    var minutes, hours, years;
    // 3600 seconds -> 60 minutes -> 1 hour
    minutes = absFloor(seconds / 60);
    hours = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;
    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;
    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();
    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }
    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}
var proto$2 = Duration.prototype;
proto$2.isValid = isValid$1;
proto$2.abs = abs;
proto$2.add = add$1;
proto$2.subtract = subtract$1;
proto$2.as = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds = asSeconds;
proto$2.asMinutes = asMinutes;
proto$2.asHours = asHours;
proto$2.asDays = asDays;
proto$2.asWeeks = asWeeks;
proto$2.asMonths = asMonths;
proto$2.asQuarters = asQuarters;
proto$2.asYears = asYears;
proto$2.valueOf = valueOf$1;
proto$2._bubble = bubble;
proto$2.clone = clone$1;
proto$2.get = get$2;
proto$2.milliseconds = milliseconds;
proto$2.seconds = seconds;
proto$2.minutes = minutes;
proto$2.hours = hours;
proto$2.days = days;
proto$2.weeks = weeks;
proto$2.months = months;
proto$2.years = years;
proto$2.humanize = humanize;
proto$2.toISOString = toISOString$1;
proto$2.toString = toISOString$1;
proto$2.toJSON = toISOString$1;
proto$2.locale = locale;
proto$2.localeData = localeData;
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;
// FORMATTING
addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');
// PARSING
addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});
//! moment.js
hooks.version = '2.24.0';
setHookCallback(createLocal);
hooks.fn = proto;
hooks.min = min;
hooks.max = max;
hooks.now = now$1;
hooks.utc = createUTC;
hooks.unix = createUnix;
hooks.months = listMonths;
hooks.isDate = isDate;
hooks.locale = getSetGlobalLocale;
hooks.invalid = createInvalid;
hooks.duration = createDuration;
hooks.isMoment = isMoment;
hooks.weekdays = listWeekdays;
hooks.parseZone = createInZone;
hooks.localeData = getLocale;
hooks.isDuration = isDuration;
hooks.monthsShort = listMonthsShort;
hooks.weekdaysMin = listWeekdaysMin;
hooks.defineLocale = defineLocale;
hooks.updateLocale = updateLocale;
hooks.locales = listLocales;
hooks.weekdaysShort = listWeekdaysShort;
hooks.normalizeUnits = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat = getCalendarFormat;
hooks.prototype = proto;
// currently HTML5 input type only supports 24-hour formats
hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
    DATE: 'YYYY-MM-DD',
    TIME: 'HH:mm',
    TIME_SECONDS: 'HH:mm:ss',
    TIME_MS: 'HH:mm:ss.SSS',
    WEEK: 'GGGG-[W]WW',
    MONTH: 'YYYY-MM' // <input type="month" />
};
var pikaday = createCommonjsModule(function (module, exports) {
    /*!
     * Pikaday
     *
     * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/Pikaday/Pikaday
     */
    (function (root, factory) {
        var moment;
        {
            // CommonJS module
            // Load moment.js as an optional dependency
            try {
                moment = hooks;
            }
            catch (e) { }
            module.exports = factory(moment);
        }
    }(commonjsGlobal, function (moment) {
        /**
         * feature detection and helper functions
         */
        var hasMoment = typeof moment === 'function', hasEventListeners = !!window.addEventListener, document = window.document, sto = window.setTimeout, addEvent = function (el, e, callback, capture) {
            if (hasEventListeners) {
                el.addEventListener(e, callback, !!capture);
            }
            else {
                el.attachEvent('on' + e, callback);
            }
        }, removeEvent = function (el, e, callback, capture) {
            if (hasEventListeners) {
                el.removeEventListener(e, callback, !!capture);
            }
            else {
                el.detachEvent('on' + e, callback);
            }
        }, trim = function (str) {
            return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
        }, hasClass = function (el, cn) {
            return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
        }, addClass = function (el, cn) {
            if (!hasClass(el, cn)) {
                el.className = (el.className === '') ? cn : el.className + ' ' + cn;
            }
        }, removeClass = function (el, cn) {
            el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
        }, isArray = function (obj) {
            return (/Array/).test(Object.prototype.toString.call(obj));
        }, isDate = function (obj) {
            return (/Date/).test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
        }, isWeekend = function (date) {
            var day = date.getDay();
            return day === 0 || day === 6;
        }, isLeapYear = function (year) {
            // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
            return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
        }, getDaysInMonth = function (year, month) {
            return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
        }, setToStartOfDay = function (date) {
            if (isDate(date))
                date.setHours(0, 0, 0, 0);
        }, compareDates = function (a, b) {
            // weak date comparison (use setToStartOfDay(date) to ensure correct result)
            return a.getTime() === b.getTime();
        }, extend = function (to, from, overwrite) {
            var prop, hasProp;
            for (prop in from) {
                hasProp = to[prop] !== undefined;
                if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
                    if (isDate(from[prop])) {
                        if (overwrite) {
                            to[prop] = new Date(from[prop].getTime());
                        }
                    }
                    else if (isArray(from[prop])) {
                        if (overwrite) {
                            to[prop] = from[prop].slice(0);
                        }
                    }
                    else {
                        to[prop] = extend({}, from[prop], overwrite);
                    }
                }
                else if (overwrite || !hasProp) {
                    to[prop] = from[prop];
                }
            }
            return to;
        }, fireEvent = function (el, eventName, data) {
            var ev;
            if (document.createEvent) {
                ev = document.createEvent('HTMLEvents');
                ev.initEvent(eventName, true, false);
                ev = extend(ev, data);
                el.dispatchEvent(ev);
            }
            else if (document.createEventObject) {
                ev = document.createEventObject();
                ev = extend(ev, data);
                el.fireEvent('on' + eventName, ev);
            }
        }, adjustCalendar = function (calendar) {
            if (calendar.month < 0) {
                calendar.year -= Math.ceil(Math.abs(calendar.month) / 12);
                calendar.month += 12;
            }
            if (calendar.month > 11) {
                calendar.year += Math.floor(Math.abs(calendar.month) / 12);
                calendar.month -= 12;
            }
            return calendar;
        }, 
        /**
         * defaults and localisation
         */
        defaults = {
            // bind the picker to a form field
            field: null,
            // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
            bound: undefined,
            // data-attribute on the input field with an aria assistance tekst (only applied when `bound` is set)
            ariaLabel: 'Use the arrow keys to pick a date',
            // position of the datepicker, relative to the field (default to bottom & left)
            // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
            position: 'bottom left',
            // automatically fit in the viewport even if it means repositioning from the position option
            reposition: true,
            // the default output format for `.toString()` and `field` value
            format: 'YYYY-MM-DD',
            // the toString function which gets passed a current date object and format
            // and returns a string
            toString: null,
            // used to create date object from current input string
            parse: null,
            // the initial date to view when first opened
            defaultDate: null,
            // make the `defaultDate` the initial selected value
            setDefaultDate: false,
            // first day of week (0: Sunday, 1: Monday etc)
            firstDay: 0,
            // the default flag for moment's strict date parsing
            formatStrict: false,
            // the minimum/earliest date that can be selected
            minDate: null,
            // the maximum/latest date that can be selected
            maxDate: null,
            // number of years either side, or array of upper/lower range
            yearRange: 10,
            // show week numbers at head of row
            showWeekNumber: false,
            // Week picker mode
            pickWholeWeek: false,
            // used internally (don't config outside)
            minYear: 0,
            maxYear: 9999,
            minMonth: undefined,
            maxMonth: undefined,
            startRange: null,
            endRange: null,
            isRTL: false,
            // Additional text to append to the year in the calendar title
            yearSuffix: '',
            // Render the month after year in the calendar title
            showMonthAfterYear: false,
            // Render days of the calendar grid that fall in the next or previous month
            showDaysInNextAndPreviousMonths: false,
            // Allows user to select days that fall in the next or previous month
            enableSelectionDaysInNextAndPreviousMonths: false,
            // how many months are visible
            numberOfMonths: 1,
            // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
            // only used for the first display or when a selected date is not visible
            mainCalendar: 'left',
            // Specify a DOM element to render the calendar in
            container: undefined,
            // Blur field when date is selected
            blurFieldOnSelect: true,
            // internationalization
            i18n: {
                previousMonth: 'Previous Month',
                nextMonth: 'Next Month',
                months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
            },
            // Theme Classname
            theme: null,
            // events array
            events: [],
            // callback function
            onSelect: null,
            onOpen: null,
            onClose: null,
            onDraw: null,
            // Enable keyboard input
            keyboardInput: true
        }, 
        /**
         * templating functions to abstract HTML rendering
         */
        renderDayName = function (opts, day, abbr) {
            day += opts.firstDay;
            while (day >= 7) {
                day -= 7;
            }
            return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
        }, renderDay = function (opts) {
            var arr = [];
            var ariaSelected = 'false';
            if (opts.isEmpty) {
                if (opts.showDaysInNextAndPreviousMonths) {
                    arr.push('is-outside-current-month');
                    if (!opts.enableSelectionDaysInNextAndPreviousMonths) {
                        arr.push('is-selection-disabled');
                    }
                }
                else {
                    return '<td class="is-empty"></td>';
                }
            }
            if (opts.isDisabled) {
                arr.push('is-disabled');
            }
            if (opts.isToday) {
                arr.push('is-today');
            }
            if (opts.isSelected) {
                arr.push('is-selected');
                ariaSelected = 'true';
            }
            if (opts.hasEvent) {
                arr.push('has-event');
            }
            if (opts.isInRange) {
                arr.push('is-inrange');
            }
            if (opts.isStartRange) {
                arr.push('is-startrange');
            }
            if (opts.isEndRange) {
                arr.push('is-endrange');
            }
            return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '" aria-selected="' + ariaSelected + '">' +
                '<button class="pika-button pika-day" type="button" ' +
                'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' +
                opts.day +
                '</button>' +
                '</td>';
        }, renderWeek = function (d, m, y) {
            // Lifted from http://javascript.about.com/library/blweekyear.htm, lightly modified.
            var onejan = new Date(y, 0, 1), weekNum = Math.ceil((((new Date(y, m, d) - onejan) / 86400000) + onejan.getDay() + 1) / 7);
            return '<td class="pika-week">' + weekNum + '</td>';
        }, renderRow = function (days, isRTL, pickWholeWeek, isRowSelected) {
            return '<tr class="pika-row' + (pickWholeWeek ? ' pick-whole-week' : '') + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
        }, renderBody = function (rows) {
            return '<tbody>' + rows.join('') + '</tbody>';
        }, renderHead = function (opts) {
            var i, arr = [];
            if (opts.showWeekNumber) {
                arr.push('<th></th>');
            }
            for (i = 0; i < 7; i++) {
                arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
            }
            return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
        }, renderTitle = function (instance, c, year, month, refYear, randId) {
            var i, j, arr, opts = instance._o, isMinYear = year === opts.minYear, isMaxYear = year === opts.maxYear, html = '<div id="' + randId + '" class="pika-title" role="heading" aria-live="assertive">', monthHtml, yearHtml, prev = true, next = true;
            for (arr = [], i = 0; i < 12; i++) {
                arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' +
                    (i === month ? ' selected="selected"' : '') +
                    ((isMinYear && i < opts.minMonth) || (isMaxYear && i > opts.maxMonth) ? 'disabled="disabled"' : '') + '>' +
                    opts.i18n.months[i] + '</option>');
            }
            monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select pika-select-month" tabindex="-1">' + arr.join('') + '</select></div>';
            if (isArray(opts.yearRange)) {
                i = opts.yearRange[0];
                j = opts.yearRange[1] + 1;
            }
            else {
                i = year - opts.yearRange;
                j = 1 + year + opts.yearRange;
            }
            for (arr = []; i < j && i <= opts.maxYear; i++) {
                if (i >= opts.minYear) {
                    arr.push('<option value="' + i + '"' + (i === year ? ' selected="selected"' : '') + '>' + (i) + '</option>');
                }
            }
            yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + arr.join('') + '</select></div>';
            if (opts.showMonthAfterYear) {
                html += yearHtml + monthHtml;
            }
            else {
                html += monthHtml + yearHtml;
            }
            if (isMinYear && (month === 0 || opts.minMonth >= month)) {
                prev = false;
            }
            if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
                next = false;
            }
            if (c === 0) {
                html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
            }
            if (c === (instance._o.numberOfMonths - 1)) {
                html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
            }
            return html += '</div>';
        }, renderTable = function (opts, data, randId) {
            return '<table cellpadding="0" cellspacing="0" class="pika-table" role="grid" aria-labelledby="' + randId + '">' + renderHead(opts) + renderBody(data) + '</table>';
        }, 
        /**
         * Pikaday constructor
         */
        Pikaday = function (options) {
            var self = this, opts = self.config(options);
            self._onMouseDown = function (e) {
                if (!self._v) {
                    return;
                }
                e = e || window.event;
                var target = e.target || e.srcElement;
                if (!target) {
                    return;
                }
                if (!hasClass(target, 'is-disabled')) {
                    if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty') && !hasClass(target.parentNode, 'is-disabled')) {
                        self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')));
                        if (opts.bound) {
                            sto(function () {
                                self.hide();
                                if (opts.blurFieldOnSelect && opts.field) {
                                    opts.field.blur();
                                }
                            }, 100);
                        }
                    }
                    else if (hasClass(target, 'pika-prev')) {
                        self.prevMonth();
                    }
                    else if (hasClass(target, 'pika-next')) {
                        self.nextMonth();
                    }
                }
                if (!hasClass(target, 'pika-select')) {
                    // if this is touch event prevent mouse events emulation
                    if (e.preventDefault) {
                        e.preventDefault();
                    }
                    else {
                        e.returnValue = false;
                        return false;
                    }
                }
                else {
                    self._c = true;
                }
            };
            self._onChange = function (e) {
                e = e || window.event;
                var target = e.target || e.srcElement;
                if (!target) {
                    return;
                }
                if (hasClass(target, 'pika-select-month')) {
                    self.gotoMonth(target.value);
                }
                else if (hasClass(target, 'pika-select-year')) {
                    self.gotoYear(target.value);
                }
            };
            self._onKeyChange = function (e) {
                e = e || window.event;
                if (self.isVisible()) {
                    switch (e.keyCode) {
                        case 13:
                        case 27:
                            if (opts.field) {
                                opts.field.blur();
                            }
                            break;
                        case 37:
                            e.preventDefault();
                            self.adjustDate('subtract', 1);
                            break;
                        case 38:
                            self.adjustDate('subtract', 7);
                            break;
                        case 39:
                            self.adjustDate('add', 1);
                            break;
                        case 40:
                            self.adjustDate('add', 7);
                            break;
                    }
                }
            };
            self._onInputChange = function (e) {
                var date;
                if (e.firedBy === self) {
                    return;
                }
                if (opts.parse) {
                    date = opts.parse(opts.field.value, opts.format);
                }
                else if (hasMoment) {
                    date = moment(opts.field.value, opts.format, opts.formatStrict);
                    date = (date && date.isValid()) ? date.toDate() : null;
                }
                else {
                    date = new Date(Date.parse(opts.field.value));
                }
                if (isDate(date)) {
                    self.setDate(date);
                }
                if (!self._v) {
                    self.show();
                }
            };
            self._onInputFocus = function () {
                self.show();
            };
            self._onInputClick = function () {
                self.show();
            };
            self._onInputBlur = function () {
                // IE allows pika div to gain focus; catch blur the input field
                var pEl = document.activeElement;
                do {
                    if (hasClass(pEl, 'pika-single')) {
                        return;
                    }
                } while ((pEl = pEl.parentNode));
                if (!self._c) {
                    self._b = sto(function () {
                        self.hide();
                    }, 50);
                }
                self._c = false;
            };
            self._onClick = function (e) {
                e = e || window.event;
                var target = e.target || e.srcElement, pEl = target;
                if (!target) {
                    return;
                }
                if (!hasEventListeners && hasClass(target, 'pika-select')) {
                    if (!target.onchange) {
                        target.setAttribute('onchange', 'return;');
                        addEvent(target, 'change', self._onChange);
                    }
                }
                do {
                    if (hasClass(pEl, 'pika-single') || pEl === opts.trigger) {
                        return;
                    }
                } while ((pEl = pEl.parentNode));
                if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
                    self.hide();
                }
            };
            self.el = document.createElement('div');
            self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');
            addEvent(self.el, 'mousedown', self._onMouseDown, true);
            addEvent(self.el, 'touchend', self._onMouseDown, true);
            addEvent(self.el, 'change', self._onChange);
            if (opts.keyboardInput) {
                addEvent(document, 'keydown', self._onKeyChange);
            }
            if (opts.field) {
                if (opts.container) {
                    opts.container.appendChild(self.el);
                }
                else if (opts.bound) {
                    document.body.appendChild(self.el);
                }
                else {
                    opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
                }
                addEvent(opts.field, 'change', self._onInputChange);
                if (!opts.defaultDate) {
                    if (hasMoment && opts.field.value) {
                        opts.defaultDate = moment(opts.field.value, opts.format).toDate();
                    }
                    else {
                        opts.defaultDate = new Date(Date.parse(opts.field.value));
                    }
                    opts.setDefaultDate = true;
                }
            }
            var defDate = opts.defaultDate;
            if (isDate(defDate)) {
                if (opts.setDefaultDate) {
                    self.setDate(defDate, true);
                }
                else {
                    self.gotoDate(defDate);
                }
            }
            else {
                self.gotoDate(new Date());
            }
            if (opts.bound) {
                this.hide();
                self.el.className += ' is-bound';
                addEvent(opts.trigger, 'click', self._onInputClick);
                addEvent(opts.trigger, 'focus', self._onInputFocus);
                addEvent(opts.trigger, 'blur', self._onInputBlur);
            }
            else {
                this.show();
            }
        };
        /**
         * public Pikaday API
         */
        Pikaday.prototype = {
            /**
             * configure functionality
             */
            config: function (options) {
                if (!this._o) {
                    this._o = extend({}, defaults, true);
                }
                var opts = extend(this._o, options, true);
                opts.isRTL = !!opts.isRTL;
                opts.field = (opts.field && opts.field.nodeName) ? opts.field : null;
                opts.theme = (typeof opts.theme) === 'string' && opts.theme ? opts.theme : null;
                opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);
                opts.trigger = (opts.trigger && opts.trigger.nodeName) ? opts.trigger : opts.field;
                opts.disableWeekends = !!opts.disableWeekends;
                opts.disableDayFn = (typeof opts.disableDayFn) === 'function' ? opts.disableDayFn : null;
                var nom = parseInt(opts.numberOfMonths, 10) || 1;
                opts.numberOfMonths = nom > 4 ? 4 : nom;
                if (!isDate(opts.minDate)) {
                    opts.minDate = false;
                }
                if (!isDate(opts.maxDate)) {
                    opts.maxDate = false;
                }
                if ((opts.minDate && opts.maxDate) && opts.maxDate < opts.minDate) {
                    opts.maxDate = opts.minDate = false;
                }
                if (opts.minDate) {
                    this.setMinDate(opts.minDate);
                }
                if (opts.maxDate) {
                    this.setMaxDate(opts.maxDate);
                }
                if (isArray(opts.yearRange)) {
                    var fallback = new Date().getFullYear() - 10;
                    opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
                    opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
                }
                else {
                    opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
                    if (opts.yearRange > 100) {
                        opts.yearRange = 100;
                    }
                }
                return opts;
            },
            /**
             * return a formatted string of the current selection (using Moment.js if available)
             */
            toString: function (format) {
                format = format || this._o.format;
                if (!isDate(this._d)) {
                    return '';
                }
                if (this._o.toString) {
                    return this._o.toString(this._d, format);
                }
                if (hasMoment) {
                    return moment(this._d).format(format);
                }
                return this._d.toDateString();
            },
            /**
             * return a Moment.js object of the current selection (if available)
             */
            getMoment: function () {
                return hasMoment ? moment(this._d) : null;
            },
            /**
             * set the current selection from a Moment.js object (if available)
             */
            setMoment: function (date, preventOnSelect) {
                if (hasMoment && moment.isMoment(date)) {
                    this.setDate(date.toDate(), preventOnSelect);
                }
            },
            /**
             * return a Date object of the current selection
             */
            getDate: function () {
                return isDate(this._d) ? new Date(this._d.getTime()) : null;
            },
            /**
             * set the current selection
             */
            setDate: function (date, preventOnSelect) {
                if (!date) {
                    this._d = null;
                    if (this._o.field) {
                        this._o.field.value = '';
                        fireEvent(this._o.field, 'change', { firedBy: this });
                    }
                    return this.draw();
                }
                if (typeof date === 'string') {
                    date = new Date(Date.parse(date));
                }
                if (!isDate(date)) {
                    return;
                }
                var min = this._o.minDate, max = this._o.maxDate;
                if (isDate(min) && date < min) {
                    date = min;
                }
                else if (isDate(max) && date > max) {
                    date = max;
                }
                this._d = new Date(date.getTime());
                setToStartOfDay(this._d);
                this.gotoDate(this._d);
                if (this._o.field) {
                    this._o.field.value = this.toString();
                    fireEvent(this._o.field, 'change', { firedBy: this });
                }
                if (!preventOnSelect && typeof this._o.onSelect === 'function') {
                    this._o.onSelect.call(this, this.getDate());
                }
            },
            /**
             * change view to a specific date
             */
            gotoDate: function (date) {
                var newCalendar = true;
                if (!isDate(date)) {
                    return;
                }
                if (this.calendars) {
                    var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1), lastVisibleDate = new Date(this.calendars[this.calendars.length - 1].year, this.calendars[this.calendars.length - 1].month, 1), visibleDate = date.getTime();
                    // get the end of the month
                    lastVisibleDate.setMonth(lastVisibleDate.getMonth() + 1);
                    lastVisibleDate.setDate(lastVisibleDate.getDate() - 1);
                    newCalendar = (visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate);
                }
                if (newCalendar) {
                    this.calendars = [{
                            month: date.getMonth(),
                            year: date.getFullYear()
                        }];
                    if (this._o.mainCalendar === 'right') {
                        this.calendars[0].month += 1 - this._o.numberOfMonths;
                    }
                }
                this.adjustCalendars();
            },
            adjustDate: function (sign, days) {
                var day = this.getDate() || new Date();
                var difference = parseInt(days) * 24 * 60 * 60 * 1000;
                var newDay;
                if (sign === 'add') {
                    newDay = new Date(day.valueOf() + difference);
                }
                else if (sign === 'subtract') {
                    newDay = new Date(day.valueOf() - difference);
                }
                this.setDate(newDay);
            },
            adjustCalendars: function () {
                this.calendars[0] = adjustCalendar(this.calendars[0]);
                for (var c = 1; c < this._o.numberOfMonths; c++) {
                    this.calendars[c] = adjustCalendar({
                        month: this.calendars[0].month + c,
                        year: this.calendars[0].year
                    });
                }
                this.draw();
            },
            gotoToday: function () {
                this.gotoDate(new Date());
            },
            /**
             * change view to a specific month (zero-index, e.g. 0: January)
             */
            gotoMonth: function (month) {
                if (!isNaN(month)) {
                    this.calendars[0].month = parseInt(month, 10);
                    this.adjustCalendars();
                }
            },
            nextMonth: function () {
                this.calendars[0].month++;
                this.adjustCalendars();
            },
            prevMonth: function () {
                this.calendars[0].month--;
                this.adjustCalendars();
            },
            /**
             * change view to a specific full year (e.g. "2012")
             */
            gotoYear: function (year) {
                if (!isNaN(year)) {
                    this.calendars[0].year = parseInt(year, 10);
                    this.adjustCalendars();
                }
            },
            /**
             * change the minDate
             */
            setMinDate: function (value) {
                if (value instanceof Date) {
                    setToStartOfDay(value);
                    this._o.minDate = value;
                    this._o.minYear = value.getFullYear();
                    this._o.minMonth = value.getMonth();
                }
                else {
                    this._o.minDate = defaults.minDate;
                    this._o.minYear = defaults.minYear;
                    this._o.minMonth = defaults.minMonth;
                    this._o.startRange = defaults.startRange;
                }
                this.draw();
            },
            /**
             * change the maxDate
             */
            setMaxDate: function (value) {
                if (value instanceof Date) {
                    setToStartOfDay(value);
                    this._o.maxDate = value;
                    this._o.maxYear = value.getFullYear();
                    this._o.maxMonth = value.getMonth();
                }
                else {
                    this._o.maxDate = defaults.maxDate;
                    this._o.maxYear = defaults.maxYear;
                    this._o.maxMonth = defaults.maxMonth;
                    this._o.endRange = defaults.endRange;
                }
                this.draw();
            },
            setStartRange: function (value) {
                this._o.startRange = value;
            },
            setEndRange: function (value) {
                this._o.endRange = value;
            },
            /**
             * refresh the HTML
             */
            draw: function (force) {
                if (!this._v && !force) {
                    return;
                }
                var opts = this._o, minYear = opts.minYear, maxYear = opts.maxYear, minMonth = opts.minMonth, maxMonth = opts.maxMonth, html = '', randId;
                if (this._y <= minYear) {
                    this._y = minYear;
                    if (!isNaN(minMonth) && this._m < minMonth) {
                        this._m = minMonth;
                    }
                }
                if (this._y >= maxYear) {
                    this._y = maxYear;
                    if (!isNaN(maxMonth) && this._m > maxMonth) {
                        this._m = maxMonth;
                    }
                }
                randId = 'pika-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);
                for (var c = 0; c < opts.numberOfMonths; c++) {
                    html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId) + '</div>';
                }
                this.el.innerHTML = html;
                if (opts.bound) {
                    if (opts.field.type !== 'hidden') {
                        sto(function () {
                            opts.trigger.focus();
                        }, 1);
                    }
                }
                if (typeof this._o.onDraw === 'function') {
                    this._o.onDraw(this);
                }
                if (opts.bound) {
                    // let the screen reader user know to use arrow keys
                    opts.field.setAttribute('aria-label', opts.ariaLabel);
                }
            },
            adjustPosition: function () {
                var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect, leftAligned, bottomAligned;
                if (this._o.container)
                    return;
                this.el.style.position = 'absolute';
                field = this._o.trigger;
                pEl = field;
                width = this.el.offsetWidth;
                height = this.el.offsetHeight;
                viewportWidth = window.innerWidth || document.documentElement.clientWidth;
                viewportHeight = window.innerHeight || document.documentElement.clientHeight;
                scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
                leftAligned = true;
                bottomAligned = true;
                if (typeof field.getBoundingClientRect === 'function') {
                    clientRect = field.getBoundingClientRect();
                    left = clientRect.left + window.pageXOffset;
                    top = clientRect.bottom + window.pageYOffset;
                }
                else {
                    left = pEl.offsetLeft;
                    top = pEl.offsetTop + pEl.offsetHeight;
                    while ((pEl = pEl.offsetParent)) {
                        left += pEl.offsetLeft;
                        top += pEl.offsetTop;
                    }
                }
                // default position is bottom & left
                if ((this._o.reposition && left + width > viewportWidth) ||
                    (this._o.position.indexOf('right') > -1 &&
                        left - width + field.offsetWidth > 0)) {
                    left = left - width + field.offsetWidth;
                    leftAligned = false;
                }
                if ((this._o.reposition && top + height > viewportHeight + scrollTop) ||
                    (this._o.position.indexOf('top') > -1 &&
                        top - height - field.offsetHeight > 0)) {
                    top = top - height - field.offsetHeight;
                    bottomAligned = false;
                }
                this.el.style.left = left + 'px';
                this.el.style.top = top + 'px';
                addClass(this.el, leftAligned ? 'left-aligned' : 'right-aligned');
                addClass(this.el, bottomAligned ? 'bottom-aligned' : 'top-aligned');
                removeClass(this.el, !leftAligned ? 'left-aligned' : 'right-aligned');
                removeClass(this.el, !bottomAligned ? 'bottom-aligned' : 'top-aligned');
            },
            /**
             * render HTML for a particular month
             */
            render: function (year, month, randId) {
                var opts = this._o, now = new Date(), days = getDaysInMonth(year, month), before = new Date(year, month, 1).getDay(), data = [], row = [];
                setToStartOfDay(now);
                if (opts.firstDay > 0) {
                    before -= opts.firstDay;
                    if (before < 0) {
                        before += 7;
                    }
                }
                var previousMonth = month === 0 ? 11 : month - 1, nextMonth = month === 11 ? 0 : month + 1, yearOfPreviousMonth = month === 0 ? year - 1 : year, yearOfNextMonth = month === 11 ? year + 1 : year, daysInPreviousMonth = getDaysInMonth(yearOfPreviousMonth, previousMonth);
                var cells = days + before, after = cells;
                while (after > 7) {
                    after -= 7;
                }
                cells += 7 - after;
                var isWeekSelected = false;
                for (var i = 0, r = 0; i < cells; i++) {
                    var day = new Date(year, month, 1 + (i - before)), isSelected = isDate(this._d) ? compareDates(day, this._d) : false, isToday = compareDates(day, now), hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false, isEmpty = i < before || i >= (days + before), dayNumber = 1 + (i - before), monthNumber = month, yearNumber = year, isStartRange = opts.startRange && compareDates(opts.startRange, day), isEndRange = opts.endRange && compareDates(opts.endRange, day), isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange, isDisabled = (opts.minDate && day < opts.minDate) ||
                        (opts.maxDate && day > opts.maxDate) ||
                        (opts.disableWeekends && isWeekend(day)) ||
                        (opts.disableDayFn && opts.disableDayFn(day));
                    if (isEmpty) {
                        if (i < before) {
                            dayNumber = daysInPreviousMonth + dayNumber;
                            monthNumber = previousMonth;
                            yearNumber = yearOfPreviousMonth;
                        }
                        else {
                            dayNumber = dayNumber - days;
                            monthNumber = nextMonth;
                            yearNumber = yearOfNextMonth;
                        }
                    }
                    var dayConfig = {
                        day: dayNumber,
                        month: monthNumber,
                        year: yearNumber,
                        hasEvent: hasEvent,
                        isSelected: isSelected,
                        isToday: isToday,
                        isDisabled: isDisabled,
                        isEmpty: isEmpty,
                        isStartRange: isStartRange,
                        isEndRange: isEndRange,
                        isInRange: isInRange,
                        showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths,
                        enableSelectionDaysInNextAndPreviousMonths: opts.enableSelectionDaysInNextAndPreviousMonths
                    };
                    if (opts.pickWholeWeek && isSelected) {
                        isWeekSelected = true;
                    }
                    row.push(renderDay(dayConfig));
                    if (++r === 7) {
                        if (opts.showWeekNumber) {
                            row.unshift(renderWeek(i - before, month, year));
                        }
                        data.push(renderRow(row, opts.isRTL, opts.pickWholeWeek, isWeekSelected));
                        row = [];
                        r = 0;
                        isWeekSelected = false;
                    }
                }
                return renderTable(opts, data, randId);
            },
            isVisible: function () {
                return this._v;
            },
            show: function () {
                if (!this.isVisible()) {
                    this._v = true;
                    this.draw();
                    removeClass(this.el, 'is-hidden');
                    if (this._o.bound) {
                        addEvent(document, 'click', this._onClick);
                        this.adjustPosition();
                    }
                    if (typeof this._o.onOpen === 'function') {
                        this._o.onOpen.call(this);
                    }
                }
            },
            hide: function () {
                var v = this._v;
                if (v !== false) {
                    if (this._o.bound) {
                        removeEvent(document, 'click', this._onClick);
                    }
                    this.el.style.position = 'static'; // reset
                    this.el.style.left = 'auto';
                    this.el.style.top = 'auto';
                    addClass(this.el, 'is-hidden');
                    this._v = false;
                    if (v !== undefined && typeof this._o.onClose === 'function') {
                        this._o.onClose.call(this);
                    }
                }
            },
            /**
             * GAME OVER
             */
            destroy: function () {
                var opts = this._o;
                this.hide();
                removeEvent(this.el, 'mousedown', this._onMouseDown, true);
                removeEvent(this.el, 'touchend', this._onMouseDown, true);
                removeEvent(this.el, 'change', this._onChange);
                if (opts.keyboardInput) {
                    removeEvent(document, 'keydown', this._onKeyChange);
                }
                if (opts.field) {
                    removeEvent(opts.field, 'change', this._onInputChange);
                    if (opts.bound) {
                        removeEvent(opts.trigger, 'click', this._onInputClick);
                        removeEvent(opts.trigger, 'focus', this._onInputFocus);
                        removeEvent(opts.trigger, 'blur', this._onInputBlur);
                    }
                }
                if (this.el.parentNode) {
                    this.el.parentNode.removeChild(this.el);
                }
            }
        };
        return Pikaday;
    }));
});
var global$1 = (typeof global !== "undefined" ? global :
    typeof self !== "undefined" ? self :
        typeof window !== "undefined" ? window : {});
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
var timeoutDuration = function () {
    var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
    for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
        if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
            return 1;
        }
    }
    return 0;
}();
function microtaskDebounce(fn) {
    var called = false;
    return function () {
        if (called) {
            return;
        }
        called = true;
        window.Promise.resolve().then(function () {
            called = false;
            fn();
        });
    };
}
function taskDebounce(fn) {
    var scheduled = false;
    return function () {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function () {
                scheduled = false;
                fn();
            }, timeoutDuration);
        }
    };
}
var supportsMicroTasks = isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce$1 = supportsMicroTasks ? microtaskDebounce : taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction$1(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) {
        return [];
    }
    // NOTE: 1 DOM access here
    var window = element.ownerDocument.defaultView;
    var css = window.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
    if (element.nodeName === 'HTML') {
        return element;
    }
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) {
        return document.body;
    }
    switch (element.nodeName) {
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
        return element;
    }
    return getScrollParent(getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
    if (version === 11) {
        return isIE11;
    }
    if (version === 10) {
        return isIE10;
    }
    return isIE11 || isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
    if (!element) {
        return document.documentElement;
    }
    var noOffsetParent = isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while (offsetParent === noOffsetParent && element.nextElementSibling) {
        offsetParent = (element = element.nextElementSibling).offsetParent;
    }
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
        return element ? element.ownerDocument.documentElement : document.documentElement;
    }
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
        return getOffsetParent(offsetParent);
    }
    return offsetParent;
}
function isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') {
        return false;
    }
    return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
    if (node.parentNode !== null) {
        return getRoot(node.parentNode);
    }
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
        return document.documentElement;
    }
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if (isOffsetContainer(commonAncestorContainer)) {
            return commonAncestorContainer;
        }
        return getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = getRoot(element1);
    if (element1root.host) {
        return findCommonOffsetParent(element1root.host, element2);
    }
    else {
        return findCommonOffsetParent(element1, getRoot(element2).host);
    }
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = getScroll(element, 'top');
    var scrollLeft = getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */
function getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}
function getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function getWindowSizes(document) {
    var body = document.body;
    var html = document.documentElement;
    var computedStyle = isIE(10) && getComputedStyle(html);
    return {
        height: getSize('Height', body, html, computedStyle),
        width: getSize('Width', body, html, computedStyle)
    };
}
var classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
};
var createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var defineProperty = function (obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    }
    else {
        obj[key] = value;
    }
    return obj;
};
var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
    return _extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if (isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = getScroll(element, 'top');
            var scrollLeft = getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        }
        else {
            rect = element.getBoundingClientRect();
        }
    }
    catch (e) { }
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = getStyleComputedProperty(element);
        horizScrollbar -= getBordersSize(styles, 'x');
        vertScrollbar -= getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return getClientRect(result);
}
function getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = getBoundingClientRect(children);
    var parentRect = getBoundingClientRect(parent);
    var scrollParent = getScrollParent(children);
    var styles = getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop, 10);
        var marginLeft = parseFloat(styles.marginLeft, 10);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
        offsets = includeScroll(offsets, parent);
    }
    return offsets;
}
function getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        return false;
    }
    if (getStyleComputedProperty(element, 'position') === 'fixed') {
        return true;
    }
    var parentNode = getParentNode(element);
    if (!parentNode) {
        return false;
    }
    return isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */
function getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || isIE()) {
        return document.documentElement;
    }
    var el = element.parentElement;
    while (el && getStyleComputedProperty(el, 'transform') === 'none') {
        el = el.parentElement;
    }
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = { top: 0, left: 0 };
    var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === 'viewport') {
        boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    }
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = getScrollParent(getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') {
                boundariesNode = popper.ownerDocument.documentElement;
            }
        }
        else if (boundariesElement === 'window') {
            boundariesNode = popper.ownerDocument.documentElement;
        }
        else {
            boundariesNode = boundariesElement;
        }
        var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
            var _getWindowSizes = getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        }
        else {
            // for all the other DOM elements, this one is good
            boundaries = offsets;
        }
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) {
        return placement;
    }
    var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function (key) {
        return _extends({
            key: key
        }, rects[key], {
            area: getArea(rects[key])
        });
    }).sort(function (a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function (_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
    return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
    var window = element.ownerDocument.defaultView;
    var styles = window.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
    var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
    return placement.replace(/left|right|bottom|top/g, function (matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) {
        popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    }
    else {
        popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
    }
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) {
        return arr.find(check);
    }
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) {
        return arr.findIndex(function (cur) {
            return cur[prop] === value;
        });
    }
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = find(arr, function (obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function (modifier) {
        if (modifier['function']) {
            // eslint-disable-line dot-notation
            console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        }
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && isFunction$1(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = getClientRect(data.offsets.popper);
            data.offsets.reference = getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) {
        return;
    }
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    }
    else {
        this.options.onUpdate(data);
    }
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function (_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
    var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for (var i = 0; i < prefixes.length; i++) {
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') {
            return toCheck;
        }
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if (isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) {
        this.popper.parentNode.removeChild(this.popper);
    }
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, { passive: true });
    if (!isBody) {
        attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
    }
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
    // Scroll event listener on scroll parents
    var scrollElement = getScrollParent(reference);
    attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
    if (!this.state.eventsEnabled) {
        this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
    }
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
    // Remove resize event listener on window
    getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function (target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
    Object.keys(styles).forEach(function (prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
            unit = 'px';
        }
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function (prop) {
        var value = attributes[prop];
        if (value !== false) {
            element.setAttribute(prop, attributes[prop]);
        }
        else {
            element.removeAttribute(prop);
        }
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) {
        setStyles(data.arrowElement, data.arrowStyles);
    }
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) {
        console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    }
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = getOffsetParent(data.instance.popper);
    var offsetParentRect = getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') {
            top = -offsetParent.clientHeight + offsets.bottom;
        }
        else {
            top = -offsetParentRect.height + offsets.bottom;
        }
    }
    else {
        top = offsets.top;
    }
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') {
            left = -offsetParent.clientWidth + offsets.right;
        }
        else {
            left = -offsetParentRect.width + offsets.right;
        }
    }
    else {
        left = offsets.left;
    }
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    }
    else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = _extends({}, attributes, data.attributes);
    data.styles = _extends({}, styles, data.styles);
    data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = find(modifiers, function (_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function (modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
        return data;
    }
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) {
            return data;
        }
    }
    else {
        // if the arrowElement isn't a query selector we must check that the
        // provided DOM node is child of its popper node
        if (!data.instance.popper.contains(arrowElement)) {
            console.warn('WARNING: `arrow.element` must be child of its popper element!');
            return data;
        }
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = ['left', 'right'].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) {
        data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    }
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) {
        data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    }
    data.offsets.popper = getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
    if (variation === 'end') {
        return 'start';
    }
    else if (variation === 'start') {
        return 'end';
    }
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = validPlacements.indexOf(placement);
    var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if (isModifierEnabled(data.instance.modifiers, 'inner')) {
        return data;
    }
    if (data.flipped && data.placement === data.originalPlacement) {
        // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
        return data;
    }
    var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch (options.behavior) {
        case BEHAVIORS.FLIP:
            flipOrder = [placement, placementOpposite];
            break;
        case BEHAVIORS.CLOCKWISE:
            flipOrder = clockwise(placement);
            break;
        case BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function (step, index) {
        if (placement !== step || flipOrder.length === index + 1) {
            return data;
        }
        placement = data.placement.split('-')[0];
        placementOpposite = getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) {
                placement = flipOrder[index + 1];
            }
            if (flippedVariation) {
                variation = getOppositeVariation(variation);
            }
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) {
        data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    }
    if (popper[opSide] > floor(reference[side])) {
        data.offsets.popper[opSide] = floor(reference[side]);
    }
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) {
        return str;
    }
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch (unit) {
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = getClientRect(element);
        return rect[measurement] / 100 * value;
    }
    else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') {
            size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        }
        else {
            size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        }
        return size / 100 * value;
    }
    else {
        // if is an explicit pixel unit, we get rid of the unit and keep the value
        // if is an implicit unit, it's px, and we return just the value
        return value;
    }
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [0, 0];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function (frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf(find(fragments, function (frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
        console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    }
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function (op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op
            // This aggregates any `+` or `-` sign that aren't considered operators
            // e.g.: 10 + +5 => [10, +, +5]
            .reduce(function (a, b) {
            if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            }
            else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            }
            else {
                return a.concat(b);
            }
        }, [])
            // Here we convert the string values into number values (in px)
            .map(function (str) {
            return toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function (op, index) {
        op.forEach(function (frag, index2) {
            if (isNumeric(frag)) {
                offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
            }
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset$1(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if (isNumeric(+offset)) {
        offsets = [+offset, 0];
    }
    else {
        offsets = parseOffset(offset, popper, reference, basePlacement);
    }
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    }
    else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    }
    else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    }
    else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) {
        boundariesElement = getOffsetParent(boundariesElement);
    }
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
                value = Math.max(popper[placement], boundaries[placement]);
            }
            return defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
                value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            }
            return defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function (placement) {
        var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = _extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: defineProperty({}, side, reference[side]),
            end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
    if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
        return data;
    }
    var refRect = data.offsets.reference;
    var bound = find(data.instance.modifiers, function (modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) {
            return data;
        }
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    }
    else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) {
            return data;
        }
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
    var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = getOppositePlacement(placement);
    data.offsets.popper = getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */
/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
    /**
     * Modifier used to shift the popper on the start or end of its reference
     * element.<br />
     * It will read the variation of the `placement` property.<br />
     * It can be one either `-end` or `-start`.
     * @memberof modifiers
     * @inner
     */
    shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */
        order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: shift
    },
    /**
     * The `offset` modifier can shift your popper on both its axis.
     *
     * It accepts the following units:
     * - `px` or unit-less, interpreted as pixels
     * - `%` or `%r`, percentage relative to the length of the reference element
     * - `%p`, percentage relative to the length of the popper element
     * - `vw`, CSS viewport width unit
     * - `vh`, CSS viewport height unit
     *
     * For length is intended the main axis relative to the placement of the popper.<br />
     * This means that if the placement is `top` or `bottom`, the length will be the
     * `width`. In case of `left` or `right`, it will be the `height`.
     *
     * You can provide a single value (as `Number` or `String`), or a pair of values
     * as `String` divided by a comma or one (or more) white spaces.<br />
     * The latter is a deprecated method because it leads to confusion and will be
     * removed in v2.<br />
     * Additionally, it accepts additions and subtractions between different units.
     * Note that multiplications and divisions aren't supported.
     *
     * Valid examples are:
     * ```
     * 10
     * '10%'
     * '10, 10'
     * '10%, 10'
     * '10 + 10%'
     * '10 - 5vh + 3%'
     * '-10px + 5vh, 5px - 6%'
     * ```
     * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
     * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
     * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
     *
     * @memberof modifiers
     * @inner
     */
    offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */
        order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: offset$1,
        /** @prop {Number|String} offset=0
         * The offset value as described in the modifier description
         */
        offset: 0
    },
    /**
     * Modifier used to prevent the popper from being positioned outside the boundary.
     *
     * A scenario exists where the reference itself is not within the boundaries.<br />
     * We can say it has "escaped the boundaries" — or just "escaped".<br />
     * In this case we need to decide whether the popper should either:
     *
     * - detach from the reference and remain "trapped" in the boundaries, or
     * - if it should ignore the boundary and "escape with its reference"
     *
     * When `escapeWithReference` is set to`true` and reference is completely
     * outside its boundaries, the popper will overflow (or completely leave)
     * the boundaries in order to remain attached to the edge of the reference.
     *
     * @memberof modifiers
     * @inner
     */
    preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */
        order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: preventOverflow,
        /**
         * @prop {Array} [priority=['left','right','top','bottom']]
         * Popper will try to prevent overflow following these priorities by default,
         * then, it could overflow on the left and on top of the `boundariesElement`
         */
        priority: ['left', 'right', 'top', 'bottom'],
        /**
         * @prop {number} padding=5
         * Amount of pixel used to define a minimum distance between the boundaries
         * and the popper. This makes sure the popper always has a little padding
         * between the edges of its container
         */
        padding: 5,
        /**
         * @prop {String|HTMLElement} boundariesElement='scrollParent'
         * Boundaries used by the modifier. Can be `scrollParent`, `window`,
         * `viewport` or any DOM element.
         */
        boundariesElement: 'scrollParent'
    },
    /**
     * Modifier used to make sure the reference and its popper stay near each other
     * without leaving any gap between the two. Especially useful when the arrow is
     * enabled and you want to ensure that it points to its reference element.
     * It cares only about the first axis. You can still have poppers with margin
     * between the popper and its reference element.
     * @memberof modifiers
     * @inner
     */
    keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */
        order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: keepTogether
    },
    /**
     * This modifier is used to move the `arrowElement` of the popper to make
     * sure it is positioned between the reference element and its popper element.
     * It will read the outer size of the `arrowElement` node to detect how many
     * pixels of conjunction are needed.
     *
     * It has no effect if no `arrowElement` is provided.
     * @memberof modifiers
     * @inner
     */
    arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */
        order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
        element: '[x-arrow]'
    },
    /**
     * Modifier used to flip the popper's placement when it starts to overlap its
     * reference element.
     *
     * Requires the `preventOverflow` modifier before it in order to work.
     *
     * **NOTE:** this modifier will interrupt the current update cycle and will
     * restart it if it detects the need to flip the placement.
     * @memberof modifiers
     * @inner
     */
    flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */
        order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: flip,
        /**
         * @prop {String|Array} behavior='flip'
         * The behavior used to change the popper's placement. It can be one of
         * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
         * placements (with optional variations)
         */
        behavior: 'flip',
        /**
         * @prop {number} padding=5
         * The popper will flip if it hits the edges of the `boundariesElement`
         */
        padding: 5,
        /**
         * @prop {String|HTMLElement} boundariesElement='viewport'
         * The element which will define the boundaries of the popper position.
         * The popper will never be placed outside of the defined boundaries
         * (except if `keepTogether` is enabled)
         */
        boundariesElement: 'viewport',
        /**
         * @prop {Boolean} flipVariations=false
         * The popper will switch placement variation between `-start` and `-end` when
         * the reference element overlaps its boundaries.
         *
         * The original placement should have a set variation.
         */
        flipVariations: false,
        /**
         * @prop {Boolean} flipVariationsByContent=false
         * The popper will switch placement variation between `-start` and `-end` when
         * the popper element overlaps its reference boundaries.
         *
         * The original placement should have a set variation.
         */
        flipVariationsByContent: false
    },
    /**
     * Modifier used to make the popper flow toward the inner of the reference element.
     * By default, when this modifier is disabled, the popper will be placed outside
     * the reference element.
     * @memberof modifiers
     * @inner
     */
    inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */
        order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
        enabled: false,
        /** @prop {ModifierFn} */
        fn: inner
    },
    /**
     * Modifier used to hide the popper when its reference element is outside of the
     * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
     * be used to hide with a CSS selector the popper when its reference is
     * out of boundaries.
     *
     * Requires the `preventOverflow` modifier before it in order to work.
     * @memberof modifiers
     * @inner
     */
    hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */
        order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: hide
    },
    /**
     * Computes the style that will be applied to the popper element to gets
     * properly positioned.
     *
     * Note that this modifier will not touch the DOM, it just prepares the styles
     * so that `applyStyle` modifier can apply it. This separation is useful
     * in case you need to replace `applyStyle` with a custom implementation.
     *
     * This modifier has `850` as `order` value to maintain backward compatibility
     * with previous versions of Popper.js. Expect the modifiers ordering method
     * to change in future major versions of the library.
     *
     * @memberof modifiers
     * @inner
     */
    computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */
        order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: computeStyle,
        /**
         * @prop {Boolean} gpuAcceleration=true
         * If true, it uses the CSS 3D transformation to position the popper.
         * Otherwise, it will use the `top` and `left` properties
         */
        gpuAcceleration: true,
        /**
         * @prop {string} [x='bottom']
         * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
         * Change this if your popper should grow in a direction different from `bottom`
         */
        x: 'bottom',
        /**
         * @prop {string} [x='left']
         * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
         * Change this if your popper should grow in a direction different from `right`
         */
        y: 'right'
    },
    /**
     * Applies the computed styles to the popper element.
     *
     * All the DOM manipulations are limited to this modifier. This is useful in case
     * you want to integrate Popper.js inside a framework or view library and you
     * want to delegate all the DOM manipulations to it.
     *
     * Note that if you disable this modifier, you must make sure the popper element
     * has its position set to `absolute` before Popper.js can do its work!
     *
     * Just disable this modifier and define your own to achieve the desired effect.
     *
     * @memberof modifiers
     * @inner
     */
    applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */
        order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: applyStyle,
        /** @prop {Function} */
        onLoad: applyStyleOnLoad,
        /**
         * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
         * @prop {Boolean} gpuAcceleration=true
         * If true, it uses the CSS 3D transformation to position the popper.
         * Otherwise, it will use the `top` and `left` properties
         */
        gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */
/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
    /**
     * Popper's placement.
     * @prop {Popper.placements} placement='bottom'
     */
    placement: 'bottom',
    /**
     * Set this to true if you want popper to position it self in 'fixed' mode
     * @prop {Boolean} positionFixed=false
     */
    positionFixed: false,
    /**
     * Whether events (resize, scroll) are initially enabled.
     * @prop {Boolean} eventsEnabled=true
     */
    eventsEnabled: true,
    /**
     * Set to true if you want to automatically remove the popper when
     * you call the `destroy` method.
     * @prop {Boolean} removeOnDestroy=false
     */
    removeOnDestroy: false,
    /**
     * Callback called when the popper is created.<br />
     * By default, it is set to no-op.<br />
     * Access Popper.js instance with `data.instance`.
     * @prop {onCreate}
     */
    onCreate: function onCreate() { },
    /**
     * Callback called when the popper is updated. This callback is not called
     * on the initialization/creation of the popper, but only on subsequent
     * updates.<br />
     * By default, it is set to no-op.<br />
     * Access Popper.js instance with `data.instance`.
     * @prop {onUpdate}
     */
    onUpdate: function onUpdate() { },
    /**
     * List of modifiers used to modify the offsets before they are applied to the popper.
     * They provide most of the functionalities of Popper.js.
     * @prop {modifiers}
     */
    modifiers: modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */
/**
 * @callback onUpdate
 * @param {dataObject} data
 */
// Utils
// Methods
var Popper = function () {
    /**
     * Creates a new Popper.js instance.
     * @class Popper
     * @param {Element|referenceObject} reference - The reference element used to position the popper
     * @param {Element} popper - The HTML / XML element used as the popper
     * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
     * @return {Object} instance - The generated Popper.js instance
     */
    function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        classCallCheck(this, Popper);
        this.scheduleUpdate = function () {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = debounce$1(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = _extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
            _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
            return _extends({
                name: name
            }, _this.options.modifiers[name]);
        })
            // sort the modifiers by order
            .sort(function (a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function (modifierOptions) {
            if (modifierOptions.enabled && isFunction$1(modifierOptions.onLoad)) {
                modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
            }
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) {
            // setup event listeners, they will take care of update the position in specific situations
            this.enableEventListeners();
        }
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    createClass(Popper, [{
            key: 'update',
            value: function update$$1() {
                return update.call(this);
            }
        }, {
            key: 'destroy',
            value: function destroy$$1() {
                return destroy.call(this);
            }
        }, {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return enableEventListeners.call(this);
            }
        }, {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return disableEventListeners.call(this);
            }
            /**
             * Schedules an update. It will run on the next UI update available.
             * @method scheduleUpdate
             * @memberof Popper
             */
            /**
             * Collection of utilities useful when writing custom modifiers.
             * Starting from version 1.7, this method is available only if you
             * include `popper-utils.js` before `popper.js`.
             *
             * **DEPRECATION**: This way to access PopperUtils is deprecated
             * and will be removed in v2! Use the PopperUtils module directly instead.
             * Due to the high instability of the methods contained in Utils, we can't
             * guarantee them to follow semver. Use them at your own risk!
             * @static
             * @private
             * @type {Object}
             * @deprecated since version 1.8
             * @member Utils
             * @memberof Popper
             */
        }]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */
Popper.Utils = (typeof window !== 'undefined' ? window : global$1).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
var OmnibarDatePicker = /** @class */ (function () {
    function class_5(hostRef) {
        registerInstance(this, hostRef);
        this.todayDate = new Date(new Date().setHours(0, 0, 0, 0));
        this.draftStartDate = null;
        this.draftEndDate = null;
        this.opened = false;
        this.inline = false;
        /**
         * Allow the selection of date range
         */
        this.range = false;
        this.autoClose = true;
        /**
         * Input placeholder text
         */
        this.placeholder = '';
        /**
         * Disable the input
         */
        this.disabled = false;
        /**
         * Prevent weekends selection
         */
        this.disableWeekends = false;
        /**
         * Label text
         */
        this.label = '';
        /**
         * Puts the input in an error state and shows the error message
         */
        this.error = '';
        /**
         * Hint text
         */
        this.hint = '';
        this.i18n = i18n;
        this.disableDayFn = function (_) { };
        this.view = 'days';
        /**
         Date picker model (ISO 8601 format, YY-mm-dd or YY-mm)
         */
        this.value = !this.range ? '' : ['', ''];
        this.omnibarOpen = createEvent(this, "omnibarOpen", 7);
        this.omnibarClose = createEvent(this, "omnibarClose", 7);
        this.omnibarChange = createEvent(this, "omnibarChange", 7);
        this.omnibarFocus = createEvent(this, "omnibarFocus", 7);
        this.omnibarBlur = createEvent(this, "omnibarBlur", 7);
    }
    class_5.prototype.openedChanged = function () {
        this.opened && isScreen('sm') ? this.createPopper() : this.destroyPopper();
        if (this.opened && !isScreen('sm'))
            this.inputEl.blur();
    };
    class_5.prototype.minDateChanged = function () {
        this.pikaday.setMinDate(new Date(this.minDate));
    };
    class_5.prototype.maxDateChanged = function () {
        this.pikaday.setMaxDate(new Date(this.maxDate));
    };
    class_5.prototype.handleFocusin = function () {
        if (!this.inline && !this.opened && this.el.contains(document.activeElement)) {
            this.open();
        }
    };
    class_5.prototype.handleClickOutside = function (e) {
        if (!this.inline && this.opened && !this.el.contains(e.target) && isScreen('sm')) {
            this.close();
        }
    };
    /*
      Bugged in Safari versions.
      
      @Listen('focusout')
      handleFocusout() {
  
        if (!this.inline && this.opened && !this.el.contains(document.activeElement) && isScreen('sm')) {
          this.close()
        }
      }
    */
    class_5.prototype.handlekeyDown = function (e) {
        if (this.inline || this.opened) {
            if (UP_KEY.includes(e.key)) {
                this.focusDate(e, 'up');
            }
            else if (DOWN_KEY.includes(e.key)) {
                this.focusDate(e, 'down');
            }
            else if (LEFT_KEY.includes(e.key)) {
                this.focusDate(e, 'left');
            }
            else if (RIGHT_KEY.includes(e.key)) {
                this.focusDate(e, 'right');
            }
            else if (e.key === ENTER_KEY) {
                this.handleEnterKeyPress(e);
            }
            else if (ESCAPE_KEY.includes(e.key) && !this.inline) {
                this.close();
            }
        }
    };
    class_5.prototype.handleDebouncedResize = function () {
        if (this.opened) {
            isScreen('sm') ? this.createPopper() : this.destroyPopper();
        }
    };
    class_5.prototype.componentWillLoad = function () {
        this.handleDebouncedResize = debounce_1(this.handleDebouncedResize, 200);
    };
    class_5.prototype.componentDidLoad = function () {
        this.createPikaday();
        this.setCalendar();
        this.setInitialFocusedDate();
    };
    class_5.prototype.componentDidUnload = function () {
        this.destroyPikaday();
        this.destroyPopper();
    };
    class_5.prototype.open = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.opened = true;
                if (isScreen('sm')) {
                    this.createPopper();
                }
                this.omnibarOpen.emit(this.eventDetail());
                return [2 /*return*/];
            });
        });
    };
    class_5.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.opened = false;
                this.inputEl.blur();
                if (isScreen('sm')) {
                    this.destroyPopper();
                }
                this.omnibarClose.emit(this.eventDetail());
                return [2 /*return*/];
            });
        });
    };
    class_5.prototype.clearDate = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                if (!this.range) {
                    this._setDate(null);
                }
                else {
                    this._setStartDate(null);
                    this._setEndDate(null);
                    this.pikaday.setDate(null);
                }
                this.close();
                this.omnibarChange.emit(this.eventDetail());
                return [2 /*return*/];
            });
        });
    };
    class_5.prototype.setDate = function (date) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.pikaday.setDate(date);
                return [2 /*return*/];
            });
        });
    };
    class_5.prototype.setStartDate = function (date) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.pikaday.setDate(date);
                return [2 /*return*/];
            });
        });
    };
    class_5.prototype.setEndDate = function (date) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.pikaday.setDate(date);
                return [2 /*return*/];
            });
        });
    };
    class_5.prototype.activeMonth = function () {
        return this.pikaday ? this.i18n['months'][this.calendar['month']] : null;
    };
    class_5.prototype.activeYear = function () {
        return this.pikaday ? this.calendar['year'] : null;
    };
    class_5.prototype.years = function () {
        var yearsLength = 12;
        var firstYear = (Math.floor(this.activeYear() / 10) * 10) - 1;
        var years = [];
        for (var i = 0; i < yearsLength; i++) {
            years.push(firstYear + i);
        }
        return years;
    };
    class_5.prototype.selectedDate = function () {
        return this.value ? new Date(this.value) : null;
    };
    class_5.prototype._setDate = function (date) {
        this.value = date ? date.toISOString() : '';
        this.pikaday.setDate(date, true);
    };
    class_5.prototype.startDate = function () {
        return Array.isArray(this.value) && this.value[0] ? new Date(this.value[0]) : null;
    };
    class_5.prototype._setStartDate = function (date) {
        this.value = [date ? date.toISOString() : '', this.value[1]];
        this.pikaday.setStartRange(date);
        this.pikaday.draw(true);
    };
    class_5.prototype.endDate = function () {
        return Array.isArray(this.value) && this.value[1] ? new Date(this.value[1]) : null;
    };
    class_5.prototype._setEndDate = function (date) {
        this.value = [this.value[0], date ? date.toISOString() : ''];
        this.pikaday.setEndRange(date);
        this.pikaday.draw(true);
    };
    class_5.prototype.isView = function (view) {
        return this.view === view;
    };
    class_5.prototype.formattedDay = function (day) {
        return !this.opened ? day : day < 10 ? "0" + day : day;
    };
    class_5.prototype.formattedMonth = function (month) {
        return !this.opened ? this.i18n['months'][month].slice(0, 3) : month < 9 ? "0" + (month + 1) : month + 1;
    };
    class_5.prototype.dateToString = function (date) {
        var day = date.getDate();
        var month = date.getMonth();
        var year = date.getFullYear();
        return !this.opened
            ? this.formattedMonth(month) + " " + this.formattedDay(day) + ", " + year
            : this.formattedMonth(month) + "/" + this.formattedDay(day) + "/" + year;
    };
    class_5.prototype.dateRangeToString = function () {
        if (this.startDate() && this.endDate()) {
            var startDay = this.startDate().getDate();
            var startMonth = this.startDate().getMonth();
            var startYear = this.startDate().getFullYear();
            var endDay = this.endDate().getDate();
            var endMonth = this.endDate().getMonth();
            var endYear = this.endDate().getFullYear();
            var sameYear = startYear === endYear;
            if (!this.opened) {
                if (sameYear) {
                    return this.formattedMonth(startMonth) + " " + this.formattedDay(startDay) + " - " + this.formattedMonth(endMonth) + " " + this.formattedDay(endDay) + ", " + startYear;
                }
                else {
                    return this.formattedMonth(startMonth) + " " + this.formattedDay(startDay) + ", " + startYear + " - " + this.formattedMonth(endMonth) + " " + this.formattedDay(endDay) + ", " + endYear;
                }
            }
            else {
                return this.formattedMonth(startMonth) + "/" + this.formattedDay(startDay) + "/" + startYear + " - " + this.formattedMonth(endMonth) + "/" + this.formattedDay(endDay) + "/" + endYear;
            }
        }
        else {
            return '';
        }
    };
    class_5.prototype.computedPlaceholder = function () {
        return !this.opened
            ? this.placeholder
            : !this.range ? 'mm/dd/yyyy' : 'mm/dd/yyyy - mm/dd/yyyy';
    };
    class_5.prototype.inputValue = function () {
        return this.value
            ? !this.range ? this.dateToString(this.selectedDate()) : this.dateRangeToString()
            : '';
    };
    class_5.prototype.calendarButtonText = function () {
        return this.isView('days')
            ? this.activeMonth() + " " + this.activeYear()
            : this.isView('months') ? this.activeYear()
                : this.years()[0] + " - " + this.years()[this.years().length - 1];
    };
    class_5.prototype.eventDetail = function () {
        if (!this.range) {
            return this.selectedDate();
        }
        else {
            return {
                startDate: this.startDate(),
                endDate: this.endDate()
            };
        }
    };
    class_5.prototype.createPikaday = function () {
        var _this_1 = this;
        if (!this.pikaday) {
            this.pikaday = new pikaday(Object.assign(Object.assign({}, pikadayOptions), { minDate: new Date(this.minDate), maxDate: new Date(this.maxDate), i18n: this.i18n, disableWeekends: this.disableWeekends, disableDayFn: function (date) { return _this_1.disableDayFn(date); }, onDraw: function () { return _this_1.handlePikadayDraw(); }, onSelect: function (value) { return _this_1.handlePikadaySelect(value); } }));
            this.pikadayContainerEl.appendChild(this.pikaday.el);
        }
    };
    class_5.prototype.destroyPikaday = function () {
        if (this.pikaday) {
            this.pikaday.destroy();
            this.pikaday = null;
        }
    };
    class_5.prototype.createPopper = function () {
        var _this_1 = this;
        if (!this.popper) {
            requestAnimationFrame(function () {
                _this_1.popper = new Popper(_this_1.inputEl, _this_1.menuEl, { placement: 'bottom-start' });
            });
        }
    };
    class_5.prototype.destroyPopper = function () {
        if (this.popper) {
            this.popper.destroy();
            this.popper = null;
        }
    };
    class_5.prototype.handlePikadayDraw = function () {
        var _this_1 = this;
        requestAnimationFrame(function () {
            Array.from(_this_1.pikadayContainerEl.querySelectorAll('.pika-day')).forEach(function (button) { return button.tabIndex = -1; });
            _this_1.setCalendar();
        });
    };
    class_5.prototype.handlePikadaySelect = function (selectedDate) {
        if (!this.range) {
            this.value = selectedDate.toISOString();
        }
        else {
            if ((!this.startDate() && !this.endDate()) || (this.startDate() && this.endDate())) {
                this._setEndDate(null);
                this._setStartDate(selectedDate);
            }
            else if (this.startDate() && !this.endDate()) {
                var isStartDate = this.startDate().getTime() > selectedDate.getTime();
                this._setEndDate(isStartDate ? this.startDate() : selectedDate);
                this._setStartDate(isStartDate ? selectedDate : this.startDate());
            }
        }
        if (this.autoClose && !this.inline && isScreen('sm') && (!this.range || (this.range && this.startDate() && this.endDate()))) {
            this.close();
        }
        this.omnibarChange.emit(this.eventDetail());
    };
    class_5.prototype.handlePikadayMouseOver = function (e) {
        if (e.target.classList.contains('pika-day')) {
            var _g = e.target.dataset, day = _g.pikaDay, month = _g.pikaMonth, year = _g.pikaYear;
            var date = new Date(parseInt(year), parseInt(month), parseInt(day));
            this.highlightDate(date);
        }
    };
    class_5.prototype.handlePikadayMouseLeave = function () {
        this.draftEndDate = null;
        this.draftStartDate = null;
        this.pikaday.setEndRange(this.endDate());
        this.pikaday.setStartRange(this.startDate());
        this.pikaday.draw(true);
    };
    class_5.prototype.handleInputChange = function (e) {
        if (!this.range) {
            var date = new Date(e.target.value);
            if (date.getTime()) {
                this._setDate(date);
            }
            else if (e.target.value === '') {
                this.clearDate();
            }
        }
        else {
            var dateStrings = e.target.value.split(' - ');
            var startDate = new Date(dateStrings[0]);
            var endDate = new Date(dateStrings[1]);
            if (startDate.getTime() && endDate.getTime()) {
                this.pikaday.setDate(endDate);
                this._setStartDate(startDate);
                this._setEndDate(endDate);
            }
            else if (e.target.value === '') {
                this.clearDate();
            }
        }
    };
    class_5.prototype.highlightStartDate = function (date) {
        this.draftStartDate = date;
        this.pikaday.setStartRange(date);
    };
    class_5.prototype.highlightEndDate = function (date) {
        this.draftEndDate = date;
        this.pikaday.setEndRange(date);
    };
    class_5.prototype.highlightDate = function (date) {
        var _this_1 = this;
        var isSameDraftStartDate = function () { return _this_1.draftStartDate.getTime() === date.getTime(); };
        var isSameDraftEndDate = function () { return _this_1.draftEndDate.getTime() === date.getTime(); };
        if (this.startDate() && !this.endDate()) {
            var isStartDate = this.startDate().getTime() > date.getTime();
            if (isStartDate && (!this.draftStartDate || !isSameDraftStartDate())) {
                this.highlightStartDate(date);
                this.highlightEndDate(this.startDate());
                this.pikaday.draw(true);
            }
            else if (!isStartDate && (!this.draftEndDate || !isSameDraftEndDate())) {
                this.highlightStartDate(this.startDate());
                this.highlightEndDate(date);
                this.pikaday.draw(true);
            }
        }
    };
    class_5.prototype.setCalendar = function () {
        if (this.pikaday) {
            this.calendar = Object.assign({}, this.pikaday.calendars[0]);
        }
    };
    class_5.prototype.setInitialFocusedDate = function () {
        this.focusedDate = new Date(this.calendar['year'], this.calendar['month']);
    };
    class_5.prototype.showView = function (view) {
        this.view = view;
        this.inputEl.focus();
    };
    class_5.prototype.focusDate = function (e, direction) {
        var _this_1 = this;
        e.preventDefault();
        var verticalDirection = direction === 'up' || direction === 'down';
        var increment = direction === 'down' || direction === 'right';
        if (document.activeElement !== this.inputEl) {
            this.inline ? this.containerEl.focus() : this.inputEl.focus();
        }
        if (this.isView('days')) {
            var value = verticalDirection ? 7 : 1;
            var day = increment ? this.focusedDate.getDate() + value : this.focusedDate.getDate() - value;
            this.pikaday.gotoDate(new Date(this.focusedDate.setDate(day)));
            Array.from(this.el.querySelectorAll('.pika-day')).forEach(function (dayEl) {
                var _g = dayEl.dataset, day = _g.pikaDay, month = _g.pikaMonth, year = _g.pikaYear;
                var date = new Date(parseInt(year), parseInt(month), parseInt(day));
                var isFocused = date.getTime() === _this_1.focusedDate.getTime();
                dayEl.parentElement.classList.toggle('is-focused', isFocused);
            });
            this.highlightDate(this.focusedDate);
        }
        else if (this.isView('months')) {
            var value = verticalDirection ? 4 : 1;
            var month = increment ? this.focusedDate.getMonth() + value : this.focusedDate.getMonth() - value;
            this.focusedDate.setMonth(month);
            this.pikaday.gotoDate(this.focusedDate);
        }
        else if (this.isView('years')) {
            var value = verticalDirection ? 4 : 1;
            var year = increment ? this.focusedDate.getFullYear() + value : this.focusedDate.getFullYear() - value;
            this.focusedDate.setFullYear(year);
            this.pikaday.gotoDate(this.focusedDate);
        }
    };
    class_5.prototype.handleArrowButtonClick = function (direction) {
        if (this.isView('days')) {
            direction === 'prev' ? this.pikaday.prevMonth() : this.pikaday.nextMonth();
        }
        else if (this.view === 'months') {
            this.pikaday.gotoYear(direction === 'prev' ? this.activeYear() - 1 : this.activeYear() + 1);
        }
        else {
            this.pikaday.gotoYear(direction === 'prev' ? this.activeYear() - 12 : this.activeYear() + 12);
        }
        this.focusedDate = new Date(this.calendar['year'], this.calendar['month']);
    };
    class_5.prototype.handleCalendarButtonClick = function () {
        if (this.isView('days')) {
            this.showView('months');
        }
        else if (this.isView('months')) {
            this.showView('years');
        }
    };
    class_5.prototype.handleEnterKeyPress = function (e) {
        if (!e.target.classList.contains('o-date-picker__header__button')) {
            if (this.isView('days')) {
                this.pikaday.setDate(this.focusedDate);
            }
            else if (this.isView('months')) {
                this.handleMonthButtonClick(this.focusedDate.getMonth());
            }
            else if (this.isView('years')) {
                this.handleYearButtonClick(this.focusedDate.getFullYear());
            }
        }
    };
    class_5.prototype.handleMonthButtonClick = function (month) {
        this.pikaday.gotoMonth(month);
        this.showView('days');
    };
    class_5.prototype.handleYearButtonClick = function (year) {
        this.pikaday.gotoYear(year);
        this.showView('months');
    };
    class_5.prototype.render = function () {
        var _this_1 = this;
        var renderDatePickerHeader = function () {
            return [
                h("button", { type: "button", class: "o-date-picker__header__button o-date-picker__header__arrow-button", onClick: function () { return _this_1.handleArrowButtonClick('prev'); } }, h("omnibar-icon", { icon: "arrow-left-v" })),
                h("button", { type: "button", class: "o-date-picker__header__button o-date-picker__header__calendar-button", disabled: _this_1.isView('years'), onClick: function () { return _this_1.handleCalendarButtonClick(); } }, _this_1.calendarButtonText()),
                h("button", { type: "button", class: "o-date-picker__header__button o-date-picker__header__arrow-button", onClick: function () { return _this_1.handleArrowButtonClick('next'); } }, h("omnibar-icon", { icon: "arrow-right-v" })),
            ];
        };
        var renderDatePickerBody = function () {
            return [
                h("div", { class: {
                        'o-date-picker__days': true,
                        'has-range-selected': !!((_this_1.startDate() && _this_1.endDate()) || (_this_1.draftStartDate && _this_1.draftEndDate))
                    }, style: { display: _this_1.view !== 'days' ? 'none' : null }, onMouseOver: _this_1.range ? function (e) { return _this_1.handlePikadayMouseOver(e); } : null, onMouseLeave: _this_1.range ? function () { return _this_1.handlePikadayMouseLeave(); } : null, ref: function (el) { return _this_1.pikadayContainerEl = el; } }),
                h("div", { class: "o-date-picker__months", style: { display: _this_1.view !== 'months' ? 'none' : null } }, _this_1.pikaday && _this_1.i18n['months'].map(function (month, index) { return h("div", { class: {
                        'o-date-picker__month': true,
                        'is-focused': _this_1.focusedDate && index === _this_1.focusedDate.getMonth(),
                        'is-today': index === _this_1.todayDate.getMonth() && _this_1.activeYear() === _this_1.todayDate.getFullYear(),
                        'is-selected': _this_1.selectedDate() && index === _this_1.selectedDate().getMonth() && _this_1.activeYear() === _this_1.selectedDate().getFullYear()
                    }, "aria-selected": month === _this_1.activeMonth() }, h("button", { type: "button", class: "o-date-picker__month__button", tabindex: "-1", onClick: function () { return _this_1.handleMonthButtonClick(index); } }, month.slice(0, 3).toUpperCase())); })),
                h("div", { class: "o-date-picker__years", style: { display: _this_1.view !== 'years' ? 'none' : null } }, _this_1.pikaday && _this_1.years().map(function (year) { return h("div", { class: {
                        'o-date-picker__year': true,
                        'is-today': year === _this_1.todayDate.getFullYear(),
                        'is-selected': _this_1.selectedDate() && year === _this_1.selectedDate().getFullYear(),
                        'is-focused': _this_1.focusedDate && year === _this_1.focusedDate.getFullYear()
                    }, "aria-selected": year === _this_1.activeYear() }, h("button", { type: "button", class: "o-date-picker__year__button", tabindex: "-1", onClick: function () { return _this_1.handleYearButtonClick(year); } }, year)); }))
            ];
        };
        var renderDatePickerContent = function () {
            return (h("div", { class: "o-date-picker__container", tabindex: _this_1.inline ? '0' : null, ref: function (el) { return _this_1.containerEl = el; } }, h("div", { class: "o-date-picker__header" }, renderDatePickerHeader()), h("div", { class: "o-date-picker__body" }, renderDatePickerBody())));
        };
        var renderDatePickerMenuMobileHeader = function () {
            return (h("div", { class: "o-date-picker__menu__mobile-header" }, h("div", { class: "o-date-picker__menu__mobile-header__col" }, h("button", { class: "o-date-picker__menu__mobile-header__button o-date-picker__menu__mobile-header__button--left" }, h("span", { onClick: function () { return _this_1.close(); } }, "Cancel"))), h("div", { class: "o-date-picker__menu__mobile-header__col o-date-picker__menu__mobile-header__col--center" }, h("div", { class: "o-date-picker__menu__mobile-header__label" }, _this_1.label)), h("div", { class: "o-date-picker__menu__mobile-header__col o-date-picker__menu__mobile-header__col--right" }, h("button", { class: "o-date-picker__menu__mobile-header__button" }, h("span", { onClick: function () { return _this_1.close(); } }, "Done")))));
        };
        var renderDatePickerMenuMobileActions = function () {
            return (h("div", { class: "o-date-picker__menu__mobile-actions" }, h("omnibar-button", { variant: "primary", class: "o-date-picker__menu__mobile-actions__clear-button", onClick: function () { return _this_1.clearDate(); } }, "Clear")));
        };
        var renderDatePicker = function () {
            if (_this_1.inline) {
                return renderDatePickerContent();
            }
            else {
                return (h("div", { class: "o-date-picker__menu", ref: function (el) { return _this_1.menuEl = el; } }, renderDatePickerMenuMobileHeader(), renderDatePickerContent(), renderDatePickerMenuMobileActions()));
            }
        };
        var renderInput = function () {
            if (_this_1.inline) {
                return (h("input", { type: "hidden", value: _this_1.inputValue(), ref: function (el) { return _this_1.inputEl = el; } }));
            }
            else {
                return (h("omnibar-input", { label: _this_1.label, hint: _this_1.hint, error: _this_1.error }, h("input", { type: "text", autocomplete: "off", disabled: _this_1.disabled, placeholder: _this_1.computedPlaceholder(), value: _this_1.inputValue(), onChange: function (e) { return _this_1.handleInputChange(e); }, onFocus: function () { return _this_1.omnibarFocus.emit(_this_1.eventDetail()); }, onBlur: function () { return _this_1.omnibarBlur.emit(_this_1.eventDetail()); }, ref: function (el) { return _this_1.inputEl = el; } }), _this_1.opened && ((!_this_1.range && _this_1.value) || (_this_1.range && _this_1.value[0]))
                    ? h("button", { class: "o-date-picker__clear__button", onClick: function () { return _this_1.clearDate(); } }, h("omnibar-icon", { class: "o-date-picker__clear__icon", icon: "remove-2" }))
                    : h("omnibar-icon", { class: "o-date-picker__calendar-icon", icon: "calendar-2" })));
            }
        };
        return (h(Host, null, renderInput(), renderDatePicker()));
    };
    Object.defineProperty(class_5.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_5, "watchers", {
        get: function () {
            return {
                "opened": ["openedChanged"],
                "minDate": ["minDateChanged"],
                "maxDate": ["maxDateChanged"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_5, "style", {
        get: function () { return "omnibar-date-picker{display:block}omnibar-date-picker .o-date-picker__calendar-icon,omnibar-date-picker .o-date-picker__clear__button{position:absolute;color:#9ba3a7;top:50%;right:.75rem;-webkit-transform:translateY(-50%);transform:translateY(-50%)}omnibar-date-picker .o-date-picker__calendar-icon{font-size:1.25rem}omnibar-date-picker .o-date-picker__clear__button{font-size:.875rem}omnibar-date-picker .o-date-picker__menu{display:none;background-color:#fff;border-width:1px;border-color:#ebedee;-webkit-box-shadow:0 8px 16px 0 rgba(82,97,115,.18);box-shadow:0 8px 16px 0 rgba(82,97,115,.18);border-radius:.125rem;margin-top:.5rem;margin-bottom:.5rem;z-index:50}omnibar-date-picker .o-date-picker__menu__mobile-actions,omnibar-date-picker .o-date-picker__menu__mobile-header{display:none}omnibar-date-picker .o-date-picker__container{background-color:#fff;width:16rem;border-radius:.125rem;padding:1rem}[modality=keyboard] omnibar-date-picker .o-date-picker__container:focus{outline:0;-webkit-box-shadow:0 0 0 1px #0076cc;box-shadow:0 0 0 1px #0076cc}omnibar-date-picker .o-date-picker__header{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;padding-left:.5rem;padding-right:.5rem}omnibar-date-picker .o-date-picker__header__button:hover{background-color:#e5f4ff}[modality=keyboard] omnibar-date-picker .o-date-picker__header__button:focus{outline:0;-webkit-box-shadow:0 0 0 1px #0076cc;box-shadow:0 0 0 1px #0076cc}omnibar-date-picker .o-date-picker__header__arrow-button{padding-left:.25rem;padding-right:.25rem;margin-left:-.25rem;margin-right:-.25rem;border-radius:.125rem}omnibar-date-picker .o-date-picker__header__calendar-button{font-weight:600;border-radius:9999px;padding-left:.5rem;padding-right:.5rem;margin-left:-.5rem;margin-right:-.5rem}omnibar-date-picker .o-date-picker__body{font-size:.75rem;margin-top:.75rem}omnibar-date-picker .o-date-picker__days .pika-title{display:none}omnibar-date-picker .o-date-picker__days .pika-table{width:100%}omnibar-date-picker .o-date-picker__days .pika-table tr{display:-ms-flexbox;display:flex;padding-top:.25rem;padding-bottom:.25rem}omnibar-date-picker .o-date-picker__days .pika-table thead tr{padding-top:.5rem;padding-bottom:.5rem}omnibar-date-picker .o-date-picker__days .pika-table td,omnibar-date-picker .o-date-picker__days .pika-table th{display:-ms-flexbox;display:flex;-ms-flex:1 1 0%;flex:1 1 0%;-ms-flex-pack:center;justify-content:center}omnibar-date-picker .o-date-picker__days .pika-table tbody td:first-of-type{border-top-left-radius:9999px;border-bottom-left-radius:9999px}omnibar-date-picker .o-date-picker__days .pika-table tbody td:last-of-type{border-top-right-radius:9999px;border-bottom-right-radius:9999px}omnibar-date-picker .o-date-picker__days .pika-table abbr{text-decoration:none;font-weight:600}omnibar-date-picker .o-date-picker__days .pika-table .pika-button{width:1.5rem;height:1.5rem;border-radius:9999px;position:relative;z-index:0}omnibar-date-picker .o-date-picker__days .pika-table .is-inrange,omnibar-date-picker .o-date-picker__days .pika-table .pika-button:hover{background-color:#e5f4ff}omnibar-date-picker .o-date-picker__days .pika-table .is-outside-current-month{color:#c6ccd0}omnibar-date-picker .o-date-picker__days .pika-table .is-disabled{color:#c6ccd0;cursor:not-allowed}omnibar-date-picker .o-date-picker__days .pika-table .is-disabled .pika-button{pointer-events:none}omnibar-date-picker .o-date-picker__days .pika-table .is-today .pika-button{background-color:#ebedee}omnibar-date-picker .o-date-picker__days .pika-table .is-endrange .pika-button,omnibar-date-picker .o-date-picker__days .pika-table .is-selected .pika-button,omnibar-date-picker .o-date-picker__days .pika-table .is-startrange .pika-button{background-color:#0076cc;color:#fff}.has-range-selected .is-startrange:not(.is-endrange):not(:last-of-type){background:-webkit-gradient(linear,left top,right top,color-stop(50%,#fff),color-stop(50%,#e5f4ff));background:linear-gradient(90deg,#fff 50%,#e5f4ff 0)}.has-range-selected .is-endrange:not(.is-startrange):not(:first-of-type){background:-webkit-gradient(linear,right top,left top,color-stop(50%,#fff),color-stop(50%,#e5f4ff));background:linear-gradient(270deg,#fff 50%,#e5f4ff 0)}omnibar-date-picker .o-date-picker__days .pika-table .is-focused .pika-button:after{position:absolute;top:-2px;right:-2px;bottom:-2px;left:-2px;border-radius:9999px;-webkit-box-shadow:0 0 0 1px #0076cc;box-shadow:0 0 0 1px #0076cc;content:\"\"}omnibar-date-picker .o-date-picker__months,omnibar-date-picker .o-date-picker__years{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}omnibar-date-picker .o-date-picker__month,omnibar-date-picker .o-date-picker__year{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;width:25%;padding:.25rem}omnibar-date-picker .o-date-picker__month__button,omnibar-date-picker .o-date-picker__year__button{height:1.5rem;padding-left:.75rem;padding-right:.75rem;border-radius:9999px;position:relative}omnibar-date-picker .o-date-picker__month__button:hover,omnibar-date-picker .o-date-picker__year__button:hover{background-color:#e5f4ff}omnibar-date-picker .o-date-picker__month.is-today .o-date-picker__month__button,omnibar-date-picker .o-date-picker__month.is-today .o-date-picker__year__button,omnibar-date-picker .o-date-picker__year.is-today .o-date-picker__month__button,omnibar-date-picker .o-date-picker__year.is-today .o-date-picker__year__button{background-color:#ebedee}omnibar-date-picker .o-date-picker__month.is-selected .o-date-picker__month__button,omnibar-date-picker .o-date-picker__month.is-selected .o-date-picker__year__button,omnibar-date-picker .o-date-picker__year.is-selected .o-date-picker__month__button,omnibar-date-picker .o-date-picker__year.is-selected .o-date-picker__year__button{background-color:#0076cc;color:#fff}omnibar-date-picker .o-date-picker__month.is-focused .o-date-picker__month__button:after,omnibar-date-picker .o-date-picker__month.is-focused .o-date-picker__year__button:after,omnibar-date-picker .o-date-picker__year.is-focused .o-date-picker__month__button:after,omnibar-date-picker .o-date-picker__year.is-focused .o-date-picker__year__button:after{position:absolute;top:-2px;right:-2px;bottom:-2px;left:-2px;border-radius:9999px;-webkit-box-shadow:0 0 0 1px #0076cc;box-shadow:0 0 0 1px #0076cc;content:\"\"}omnibar-date-picker omnibar-input .o-form-element__control input[type=text]{padding-right:2.5rem}omnibar-date-picker[inline]{display:inline-block}omnibar-date-picker[disabled]{color:#c6ccd0;cursor:not-allowed}omnibar-date-picker[disabled] .o-date-picker__container{pointer-events:none}omnibar-date-picker[opened] .o-date-picker__menu{display:block}\@media (max-width:640px){omnibar-date-picker .o-date-picker__menu{-ms-flex-direction:column;flex-direction:column;position:fixed;top:0;right:0;bottom:0;left:0;border-width:0;-webkit-box-shadow:none;box-shadow:none;margin-top:0;margin-bottom:0}omnibar-date-picker .o-date-picker__menu__mobile-header{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;border-bottom-width:1px;border-color:#ebedee;background-color:#f7f8f9;font-size:.875rem;height:2.5rem}omnibar-date-picker .o-date-picker__menu__mobile-header__col{display:-ms-flexbox;display:flex;-ms-flex:1 1 0%;flex:1 1 0%;overflow:hidden}omnibar-date-picker .o-date-picker__menu__mobile-header__col--center{-ms-flex-pack:center;justify-content:center}omnibar-date-picker .o-date-picker__menu__mobile-header__col--right{-ms-flex-pack:end;justify-content:flex-end}omnibar-date-picker .o-date-picker__menu__mobile-header__label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:500;text-align:center}omnibar-date-picker .o-date-picker__menu__mobile-header__button{color:#0076cc;text-align:left;padding-left:.75rem;padding-right:.75rem;padding-top:.5rem;padding-bottom:.5rem}omnibar-date-picker .o-date-picker__menu__mobile-header__button--right{text-align:right}omnibar-date-picker .o-date-picker__menu__mobile-header__button--disabled{color:#9ba3a7}omnibar-date-picker .o-date-picker__menu__mobile-actions{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;margin-top:auto;padding:1rem}omnibar-date-picker .o-date-picker__container,omnibar-date-picker .o-date-picker__menu__mobile-actions__clear-button,omnibar-date-picker[inline]{width:100%}omnibar-date-picker[opened] .o-date-picker__menu{display:-ms-flexbox;display:flex}}"; },
        enumerable: true,
        configurable: true
    });
    return class_5;
}());
var pikadayOptions = {
    showDaysInNextAndPreviousMonths: true,
    showMonthAfterYear: true,
    bound: false,
    keyboardInput: false,
};
var i18n = {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month',
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    weekdaysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
};
var OmnibarDropdownMenu = /** @class */ (function () {
    function class_6(hostRef) {
        var _this_1 = this;
        registerInstance(this, hostRef);
        this.open = false;
        this.top = false;
        this.right = false;
        this.openMutated = false;
        this.dividers = false;
        this.emphasizeFinal = false;
        this.color = 'primary';
        this.disabled = false;
        this.handleToggleClick = function () {
            _this_1.open = !_this_1.open;
        };
        this.handleKeyDown = function (e) {
            if (e.key === 'Enter')
                _this_1.open = !_this_1.open;
        };
        this.handleMenuItemClick = function (payload) {
            _this_1.optionSelected.emit(payload);
        };
        this.handleMenuItemBlur = function (e) {
            requestAnimationFrame(function () {
                var length = _this_1.dropdown.querySelectorAll('.o-dropdown-menu__menu-item').length;
                if ((e.target === _this_1.dropdown.querySelectorAll('.o-dropdown-menu__menu-item')[length - 1])
                    &&
                        (document.activeElement !== _this_1.dropdown.querySelectorAll('.o-dropdown-menu__menu-item')[length - 2])) {
                    _this_1.open = false;
                }
            });
        };
        this.handleEscape = function (e) {
            if (['Escape', 'Esc'].includes(e.key)) {
                _this_1.open = false;
                _this_1.toggle.focus();
            }
        };
        this.optionSelected = createEvent(this, "optionSelected", 7);
    }
    class_6.prototype.componentDidLoad = function () {
        var _this_1 = this;
        window.addEventListener('click', function (e) {
            // @ts-ignore
            if (_this_1.open && !_this_1.dropdown.contains(e.target) && !_this_1.toggle.contains(e.target)) {
                _this_1.open = false;
            }
        }, true); // third argument is capture
    };
    class_6.prototype.handleOpenChange = function (newValue, oldValue) {
        if (newValue && !oldValue) {
            this.openMutated = true;
        }
        if (!newValue) {
            this.top = false;
            this.right = false;
        }
    };
    class_6.prototype.componentDidRender = function () {
        if (this.open && this.openMutated) {
            this.checkViewportCollision();
        }
        this.openMutated = false;
    };
    class_6.prototype.checkViewportCollision = function () {
        var rect = this.dropdown.getBoundingClientRect();
        this.top = rect.bottom > window.innerHeight;
        this.right = rect.right < rect.width;
    };
    class_6.prototype.closeMenu = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.open = false;
                return [2 /*return*/];
            });
        });
    };
    class_6.prototype.render = function () {
        var _this_1 = this;
        return (h("div", { class: {
                'o-dropdown-menu': true,
                'o-dropdown-menu--dividers': this.dividers,
                'o-dropdown-menu--emphasize-final': this.emphasizeFinal,
                'o-dropdown-menu--color-active': this.color === 'active',
                'o-dropdown-menu--show': this.open
            }, onKeyDown: this.handleEscape }, h("div", { onClick: this.handleToggleClick, class: 'o-dropdown-menu__toggle', role: "button", "aria-label": "menu-toggle", tabIndex: 0, onKeyDown: this.handleKeyDown, ref: function (el) { return _this_1.toggle = el; } }, h("div", { class: 'o-dropdown-menu__toggle__focus-utility', tabindex: -1 }, h("slot", { name: "toggle" }))), h("div", { ref: function (el) { return _this_1.dropdown = el; }, class: {
                'o-dropdown-menu__dropdown': true,
                'o-dropdown-menu__dropdown--show': this.open,
                'o-dropdown-menu__dropdown--default': !this.top && !this.right,
                'o-dropdown-menu__dropdown--top': this.top,
                'o-dropdown-menu__dropdown--right': this.right
            } }, this.items && this.items.map(function (item) { return h(MenuItem, Object.assign({}, item, { onBlurCallback: _this_1.handleMenuItemBlur, onClickCallback: _this_1.handleMenuItemClick, disabled: _this_1.disabled })); }), h("slot", null))));
    };
    Object.defineProperty(class_6, "watchers", {
        get: function () {
            return {
                "open": ["handleOpenChange"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_6, "style", {
        get: function () { return "omnibar-dropdown-menu .o-dropdown-menu{opacity:1;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative;display:inline-block;vertical-align:middle}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__toggle{position:relative;height:100%;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__toggle:focus{outline:none}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__toggle:focus .o-dropdown-menu__toggle__focus-utility{outline:1px solid #0076cc}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__toggle .o-dropdown-menu__toggle__focus-utility{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__toggle .o-dropdown-menu__toggle__focus-utility:focus{outline:none}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown{position:absolute;display:none;border-radius:.125rem;-webkit-box-shadow:0 8px 16px 0 rgba(82,97,115,.18);box-shadow:0 8px 16px 0 rgba(82,97,115,.18);padding-top:.5rem;padding-bottom:.5rem;background-color:#fff;max-width:180px;z-index:2000}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown--show{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown--default{top:32px;right:0;left:auto}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown--top{bottom:32px;right:0;left:auto}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown--right{left:0;right:auto}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown .o-dropdown-menu__menu-item{color:#37474f;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;text-decoration:none;min-height:32px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;opacity:1!important}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown .o-dropdown-menu__menu-item .o-dropdown-menu-item__focus-utility{border-width:1px;border-color:transparent;width:100%;min-height:32px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:distribute;justify-content:space-around}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown .o-dropdown-menu__menu-item .o-dropdown-menu-item__focus-utility:focus{outline:none}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown .o-dropdown-menu__menu-item .o-dropdown-menu-item__focus-utility .o-dropdown-menu__menu-item__label{color:#37474f;opacity:1!important}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown .o-dropdown-menu__menu-item .o-dropdown-menu-item__focus-utility .o-dropdown-menu__menu-item__label:hover{text-decoration:underline}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown .o-dropdown-menu__menu-item:focus{outline:none}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown .o-dropdown-menu__menu-item:focus .o-dropdown-menu-item__focus-utility{border-width:1px;border-color:#0076cc}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown .o-dropdown-menu__menu-item .o-dropdown-menu__menu-item__container{color:#37474f;width:100%;padding:0 8px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown .o-dropdown-menu__menu-item .o-dropdown-menu__menu-item__container .o-dropdown-menu__menu-item__label{padding:0 8px;line-height:18px!important;font-size:12px!important;text-transform:capitalize;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown .o-dropdown-menu__menu-item--disabled{pointer-events:none}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown .o-dropdown-menu__menu-item--disabled .o-dropdown-menu__menu-item__label{color:#9ba3a7!important}omnibar-dropdown-menu .o-dropdown-menu .o-dropdown-menu__dropdown .o-dropdown-menu__menu-item--disabled:focus{outline:none}omnibar-dropdown-menu .o-dropdown-menu--color-active .o-dropdown-menu__menu-item__container{color:#0076cc}omnibar-dropdown-menu .o-dropdown-menu--emphasize-final omnibar-action-menu-item:last-child .o-dropdown-menu__menu-item:before{border-top-width:1px;border-color:#f7f8f9;content:\"\";display:block;width:100%;margin-top:8px;margin-bottom:8px}omnibar-dropdown-menu .o-dropdown-menu--dividers .o-dropdown-menu__dropdown{padding:0}omnibar-dropdown-menu .o-dropdown-menu--dividers .o-dropdown-menu__dropdown .o-dropdown-menu__menu-item{border-bottom-width:1px;border-color:#f7f8f9}omnibar-dropdown-menu .o-dropdown-menu--dividers .o-dropdown-menu__dropdown .o-dropdown-menu__menu-item:last-child{border-bottom:none}"; },
        enumerable: true,
        configurable: true
    });
    return class_6;
}());
var OmnibarGrid = /** @class */ (function () {
    function OmnibarGrid(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarGrid.prototype.render = function () {
        return (h("slot", null));
    };
    Object.defineProperty(OmnibarGrid, "style", {
        get: function () { return "omnibar-grid{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;background-color:#fff;font-size:.875rem;color:#37474f}omnibar-grid omnibar-grid-header omnibar-grid-cell{background-color:#f7f8f9;font-size:.75rem;font-weight:700}omnibar-grid omnibar-grid-body omnibar-grid-row[active]{background-color:#e5f4ff}omnibar-grid[small] omnibar-grid-body omnibar-grid-cell{font-size:.75rem}omnibar-grid[striped] omnibar-grid-body omnibar-grid-row:nth-child(2n){background-color:#f7f8f9}omnibar-grid[hoverable] omnibar-grid-body omnibar-grid-row:hover{background-color:#e5f4ff}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarGrid;
}());
var OmnibarGridBody = /** @class */ (function () {
    function OmnibarGridBody(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarGridBody.prototype.render = function () {
        return (h("slot", null));
    };
    Object.defineProperty(OmnibarGridBody, "style", {
        get: function () { return "omnibar-grid-body{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;width:100%}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarGridBody;
}());
var OmnibarGridCell = /** @class */ (function () {
    function OmnibarGridCell(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarGridCell.prototype.render = function () {
        return (h("div", { class: "o-grid__cell" }, h("slot", null)));
    };
    Object.defineProperty(OmnibarGridCell, "style", {
        get: function () { return "omnibar-grid-cell{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;width:100%;padding-top:.75rem;padding-bottom:.75rem;padding-left:.5rem;padding-right:.5rem;border-bottom-width:1px!important;border-color:#ebedee!important}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarGridCell;
}());
var OmnibarGridRow = /** @class */ (function () {
    function OmnibarGridRow(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarGridRow.prototype.render = function () {
        return (h("slot", null));
    };
    Object.defineProperty(OmnibarGridRow, "style", {
        get: function () { return "omnibar-grid-row{display:-ms-flexbox;display:flex;width:100%}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarGridRow;
}());
var kindDirectory = {
    family: 'families',
    icon: 'icons',
    product: 'products',
    resource: 'resources',
    line: 'icons-line'
};
var iconCache = {};
var RaulIcon = /** @class */ (function () {
    function class_7(hostRef) {
        registerInstance(this, hostRef);
        this.icon = null;
        this.kind = 'icon';
    }
    class_7.prototype.iconChanged = function () {
        this.loadSVG();
    };
    class_7.prototype.componentWillLoad = function () {
        this.loadSVG();
    };
    class_7.prototype.fetchSVG = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resp, e_5;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch("//cdn.realpage.com/images/" + kindDirectory[this.kind] + "/" + this.icon + ".svg", { cache: 'no-store' })];
                    case 1:
                        resp = _g.sent();
                        if (resp.ok) {
                            return [2 /*return*/, resp.text()];
                        }
                        else {
                            throw new Error("[Ominbar] Failed to fetch icon " + this.kind + "/" + this.icon);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_5 = _g.sent();
                        console.error(e_5);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    class_7.prototype.loadSVG = function () {
        return __awaiter(this, void 0, void 0, function () {
            var key, svg, _svg;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!this.icon) return [3 /*break*/, 3];
                        key = this.kind + "-" + this.icon;
                        if (!!iconCache[key]) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchSVG()];
                    case 1:
                        svg = _g.sent();
                        if (svg) {
                            _svg = svg.replace('<svg', '<svg aria-hidden="true" focusable="false" ');
                            //replace `path-1` with an unique ID because icons are exported with the same id and it breaks the icons.
                            _svg = _svg.replace(/path-/g, "path-" + pathId++);
                            iconCache[key] = _svg;
                        }
                        _g.label = 2;
                    case 2:
                        this.svgContent = iconCache[key];
                        _g.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    class_7.prototype.render = function () {
        return (h("i", { class: "o-icon", innerHTML: this.svgContent }));
    };
    Object.defineProperty(class_7, "watchers", {
        get: function () {
            return {
                "icon": ["iconChanged"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_7, "style", {
        get: function () { return "omnibar-icon{display:inline-block;vertical-align:middle}omnibar-icon svg{display:block;height:1em;width:1em}omnibar-icon svg g[fill=none] circle,omnibar-icon svg g[fill=none] ellipse,omnibar-icon svg g[fill=none] path,omnibar-icon svg g[fill=none] polygon,omnibar-icon svg g[fill=none] polyline,omnibar-icon svg g[fill=none] rect,omnibar-icon svg g[style*=\"fill:none\"] circle,omnibar-icon svg g[style*=\"fill:none\"] ellipse,omnibar-icon svg g[style*=\"fill:none\"] path,omnibar-icon svg g[style*=\"fill:none\"] polygon,omnibar-icon svg g[style*=\"fill:none\"] polyline,omnibar-icon svg g[style*=\"fill:none\"] rect{fill:inherit!important}omnibar-icon svg circle:not([fill=none]):not([style*=\"fill:none\"]):not([style*=\"fill: none\"]),omnibar-icon svg ellipse:not([fill=none]):not([style*=\"fill:none\"]):not([style*=\"fill: none\"]),omnibar-icon svg path:not([fill=none]):not([style*=\"fill:none\"]):not([style*=\"fill: none\"]),omnibar-icon svg polygon:not([fill=none]):not([style*=\"fill:none\"]):not([style*=\"fill: none\"]),omnibar-icon svg polyline:not([fill=none]):not([style*=\"fill:none\"]):not([style*=\"fill: none\"]),omnibar-icon svg rect:not([fill=none]):not([style*=\"fill:none\"]):not([style*=\"fill: none\"]){fill:currentColor!important}"; },
        enumerable: true,
        configurable: true
    });
    return class_7;
}());
var pathId = 0;
var OmnibarInput = /** @class */ (function () {
    function OmnibarInput(hostRef) {
        registerInstance(this, hostRef);
        this.inputId = "omnibar-input-" + inputIds++;
        /**
         * Input's type.
         */
        this.type = 'text';
    }
    OmnibarInput.prototype.componentDidLoad = function () {
        var inputEl = this.el.querySelector('input');
        if (inputEl) {
            if (inputEl.id) {
                this.inputId = inputEl.id;
            }
            else {
                inputEl.id = this.inputId;
            }
        }
    };
    OmnibarInput.prototype.render = function () {
        return (h("div", { class: {
                'o-form-element': true,
                'o-form-element--invalid': !!this.error,
                'o-form-element--search': this.type === 'search'
            } }, this.label && h("label", { class: "o-form-element__label", htmlFor: this.inputId }, this.label), h("div", { class: "o-form-element__control" }, h("slot", null), this.type === 'search' && h("omnibar-icon", { icon: "search", class: "o-from-element__control__search-icon" })), this.hint && h("small", { class: "o-form-element__hint" }, this.hint), this.error &&
            h("div", { class: "o-form-element__error" }, h("omnibar-icon", { icon: "interface-alert-diamond", class: "o-form-element__error__icon" }), " ", this.error)));
    };
    Object.defineProperty(OmnibarInput.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OmnibarInput, "style", {
        get: function () { return "omnibar-input{display:block}omnibar-input .o-form-element__control{position:relative}omnibar-input .o-form-element__control input[type=email],omnibar-input .o-form-element__control input[type=number],omnibar-input .o-form-element__control input[type=password],omnibar-input .o-form-element__control input[type=search],omnibar-input .o-form-element__control input[type=tel],omnibar-input .o-form-element__control input[type=text],omnibar-input .o-form-element__control input[type=url]{border-width:1px;border-color:#c6ccd0;display:block;font-size:.875rem;height:2.5rem;padding-left:.75rem;padding-right:.75rem;width:100%;background-color:var(--omnibar-input-bg,#fff);border-radius:var(--omnibar-input-border-radius,.125rem);color:var(--omnibar-input-color,#37474f)}omnibar-input .o-form-element__control input[type=email]::-webkit-input-placeholder,omnibar-input .o-form-element__control input[type=number]::-webkit-input-placeholder,omnibar-input .o-form-element__control input[type=password]::-webkit-input-placeholder,omnibar-input .o-form-element__control input[type=search]::-webkit-input-placeholder,omnibar-input .o-form-element__control input[type=tel]::-webkit-input-placeholder,omnibar-input .o-form-element__control input[type=text]::-webkit-input-placeholder,omnibar-input .o-form-element__control input[type=url]::-webkit-input-placeholder{color:#9ba3a7}omnibar-input .o-form-element__control input[type=email]::-moz-placeholder,omnibar-input .o-form-element__control input[type=number]::-moz-placeholder,omnibar-input .o-form-element__control input[type=password]::-moz-placeholder,omnibar-input .o-form-element__control input[type=search]::-moz-placeholder,omnibar-input .o-form-element__control input[type=tel]::-moz-placeholder,omnibar-input .o-form-element__control input[type=text]::-moz-placeholder,omnibar-input .o-form-element__control input[type=url]::-moz-placeholder{color:#9ba3a7}omnibar-input .o-form-element__control input[type=email]:-ms-input-placeholder,omnibar-input .o-form-element__control input[type=number]:-ms-input-placeholder,omnibar-input .o-form-element__control input[type=password]:-ms-input-placeholder,omnibar-input .o-form-element__control input[type=search]:-ms-input-placeholder,omnibar-input .o-form-element__control input[type=tel]:-ms-input-placeholder,omnibar-input .o-form-element__control input[type=text]:-ms-input-placeholder,omnibar-input .o-form-element__control input[type=url]:-ms-input-placeholder{color:#9ba3a7}omnibar-input .o-form-element__control input[type=email]::-ms-input-placeholder,omnibar-input .o-form-element__control input[type=number]::-ms-input-placeholder,omnibar-input .o-form-element__control input[type=password]::-ms-input-placeholder,omnibar-input .o-form-element__control input[type=search]::-ms-input-placeholder,omnibar-input .o-form-element__control input[type=tel]::-ms-input-placeholder,omnibar-input .o-form-element__control input[type=text]::-ms-input-placeholder,omnibar-input .o-form-element__control input[type=url]::-ms-input-placeholder{color:#9ba3a7}omnibar-input .o-form-element__control input[type=email]::placeholder,omnibar-input .o-form-element__control input[type=number]::placeholder,omnibar-input .o-form-element__control input[type=password]::placeholder,omnibar-input .o-form-element__control input[type=search]::placeholder,omnibar-input .o-form-element__control input[type=tel]::placeholder,omnibar-input .o-form-element__control input[type=text]::placeholder,omnibar-input .o-form-element__control input[type=url]::placeholder{color:#9ba3a7}omnibar-input .o-form-element__control input[type=email]::-ms-clear,omnibar-input .o-form-element__control input[type=number]::-ms-clear,omnibar-input .o-form-element__control input[type=password]::-ms-clear,omnibar-input .o-form-element__control input[type=search]::-ms-clear,omnibar-input .o-form-element__control input[type=tel]::-ms-clear,omnibar-input .o-form-element__control input[type=text]::-ms-clear,omnibar-input .o-form-element__control input[type=url]::-ms-clear{display:none}omnibar-input .o-form-element__control input[type=email][disabled],omnibar-input .o-form-element__control input[type=number][disabled],omnibar-input .o-form-element__control input[type=password][disabled],omnibar-input .o-form-element__control input[type=search][disabled],omnibar-input .o-form-element__control input[type=tel][disabled],omnibar-input .o-form-element__control input[type=text][disabled],omnibar-input .o-form-element__control input[type=url][disabled]{background-color:#ebedee;border-color:#ebedee;color:#9ba3a7;cursor:not-allowed}omnibar-input .o-form-element__control input[type=email]:focus,omnibar-input .o-form-element__control input[type=number]:focus,omnibar-input .o-form-element__control input[type=password]:focus,omnibar-input .o-form-element__control input[type=search]:focus,omnibar-input .o-form-element__control input[type=tel]:focus,omnibar-input .o-form-element__control input[type=text]:focus,omnibar-input .o-form-element__control input[type=url]:focus{border-color:#0076cc;outline:0}omnibar-input .o-form-element__control input[type=email]:invalid,omnibar-input .o-form-element__control input[type=number]:invalid,omnibar-input .o-form-element__control input[type=password]:invalid,omnibar-input .o-form-element__control input[type=search]:invalid,omnibar-input .o-form-element__control input[type=tel]:invalid,omnibar-input .o-form-element__control input[type=text]:invalid,omnibar-input .o-form-element__control input[type=url]:invalid{border-color:#d01a1f}omnibar-input .o-form-element__label{display:inline-block;font-weight:500;font-size:.75rem;margin-bottom:.25rem}omnibar-input .o-form-element__hint{display:block;font-size:.75rem;margin-top:.5rem}omnibar-input .o-form-element__error{display:-ms-flexbox;display:flex;font-size:.75rem;-ms-flex-align:center;align-items:center;color:#d01a1f;margin-top:.5rem}omnibar-input .o-form-element__error__icon{font-size:1rem;margin-right:.25rem}omnibar-input .o-form-element--invalid input[type=email],omnibar-input .o-form-element--invalid input[type=number],omnibar-input .o-form-element--invalid input[type=password],omnibar-input .o-form-element--invalid input[type=search],omnibar-input .o-form-element--invalid input[type=tel],omnibar-input .o-form-element--invalid input[type=text],omnibar-input .o-form-element--invalid input[type=url]{border-color:#d01a1f}omnibar-input .o-form-element--search input[type=email],omnibar-input .o-form-element--search input[type=number],omnibar-input .o-form-element--search input[type=password],omnibar-input .o-form-element--search input[type=search],omnibar-input .o-form-element--search input[type=tel],omnibar-input .o-form-element--search input[type=text],omnibar-input .o-form-element--search input[type=url]{padding-left:2.25rem}omnibar-input .o-form-element--search .o-from-element__control__search-icon{position:absolute;color:#9ba3a7;font-size:1.125rem;left:.75rem;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarInput;
}());
var inputIds = 0;
var OmnibarModal = /** @class */ (function () {
    function class_8(hostRef) {
        registerInstance(this, hostRef);
        this.dialogTransitionDuration = 0;
        /**
        * A `normal` modal will have a the header and body centered and no close button. A `media` modal will have the header content aligned to the left and a close button.
        */
        this.variant = 'normal';
        /**
        * Determines wether the modal can be closed via clicking away or the `Escape` key
        */
        this.dismissable = true;
        this.active = false;
        this.visible = false;
        this.expanded = false;
        this.focused = false;
        this.modalOpen = createEvent(this, "modalopen", 7);
        this.modalClose = createEvent(this, "modalclose", 7);
    }
    /**
    * Event emitted when the modal should be closed (because user clicked the close button, clicked away, pressed `Escape` or chose an option)
    */
    class_8.prototype.componentDidLoad = function () {
        this.modalEl.focus();
        this.active = true;
    };
    class_8.prototype.handleModalOpen = function (e) {
        if (this.el !== e.target) {
            this.blur();
        }
    };
    class_8.prototype.handleModalClose = function (e) {
        if (this.el !== e.target) {
            this.focus();
        }
    };
    /**
     * Opens the aside.
     * @returns {Promise<void>}
    */
    class_8.prototype.open = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_g) {
                this.modalTrigger = document.activeElement;
                this.visible = true;
                requestAnimationFrame(function () { return _this_1.expanded = true; });
                this.focus();
                this.modalOpen.emit();
                document.body.classList.add('no-scroll');
                return [2 /*return*/];
            });
        });
    };
    /**
     * Closes the aside.
     * @returns {Promise<void>}
    */
    class_8.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_g) {
                this.expanded = false;
                setTimeout(function () { return _this_1.visible = false; }, this.dialogTransitionDuration);
                this.blur();
                if (this.modalTrigger) {
                    this.modalTrigger.focus();
                }
                this.modalClose.emit();
                document.body.classList.remove('no-scroll');
                return [2 /*return*/];
            });
        });
    };
    class_8.prototype.handleActive = function (newValue) {
        if (newValue) {
            this.open();
        }
        else {
            this.close();
        }
    };
    class_8.prototype.focus = function () {
        this.focused = true;
        this.modalEl.focus();
    };
    class_8.prototype.blur = function () {
        var _this_1 = this;
        requestAnimationFrame(function () {
            _this_1.focused = false;
            _this_1.modalEl.blur();
        });
    };
    class_8.prototype.render = function () {
        var _this_1 = this;
        return (h(Host, { visible: this.visible, expanded: this.expanded }, h("div", { class: {
                "o-modal": true,
                "o-modal--visible": this.visible,
                "o-modal__overlay--media": this.variant === 'media',
                "o-modal__overlay--normal": this.variant === 'normal'
            }, onKeyDown: function (e) { return e.key === 'Escape' && _this_1.focused ? _this_1.close() : null; } }, h("div", { ref: function (el) { return _this_1.dialogEl = el; }, class: {
                "o-modal__container": true,
                "o-modal__container--normal": this.variant === 'normal',
                "o-modal__container--media": this.variant === 'media'
            }, role: "dialog", "aria-modal": "true" }, h("slot", null)), h("div", { class: "o-modal__overlay", tabindex: "-1", onClick: function () { return _this_1.dismissable ? _this_1.modalClose.emit() : null; }, ref: function (el) { return _this_1.modalEl = el; } }))));
    };
    Object.defineProperty(class_8.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_8, "watchers", {
        get: function () {
            return {
                "active": ["handleActive"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_8, "style", {
        get: function () { return "omnibar-modal{display:block;font-size:.875rem}omnibar-modal-header{-ms-flex:0 1 auto;flex:0 1 auto;margin-bottom:.5rem}omnibar-modal-body{-ms-flex-direction:column;flex-direction:column;text-align:center;overflow-y:auto;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;scrollbar-width:thin;scrollbar-color:#d3d3d3 #fff;scrollbar-base-color:#theme \"colors.gray-light\";scrollbar-face-color:#aaa;scrollbar-3dlight-color:#fff;scrollbar-track-color:#fff;scrollbar-arrow-color:#fff;scrollbar-shadow-color:#fff;scrollbar-dark-shadow-color:#fff;-ms-overflow-style:-ms-autohiding-scrollbar}omnibar-modal-body::-webkit-scrollbar{width:.25rem}omnibar-modal-body::-webkit-scrollbar-thumb{background-color:#c6ccd0;height:8rem;opacity:.8}.o-modal{display:none;z-index:10000;position:fixed;top:0;right:0;bottom:0;left:0}.o-modal--visible{display:block}.o-modal--media{width:704px;padding:0}\@media (max-width:640px){.o-modal--media{width:100%;height:100%}}.o-modal--media.o-modal-header{-ms-flex-pack:center;justify-content:center}.o-modal--media.o-modal-header__close{display:block}.o-modal__overlay{position:fixed;top:0;right:0;bottom:0;left:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:100%;z-index:10000;-webkit-animation:mfadeIn .3s cubic-bezier(0,0,.2,1);animation:mfadeIn .3s cubic-bezier(0,0,.2,1);will-change:transform;background:rgba(0,0,0,.6)}.o-modal__container{background-color:#fff;padding-top:2rem;padding-bottom:2rem;padding-right:1rem;padding-left:1rem;border-radius:.25rem;display:-ms-flexbox;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:start;justify-content:flex-start;display:flex;position:absolute;-ms-flex:0 1 auto;flex:0 1 auto;-webkit-animation:mslideIn .3s cubic-bezier(0,0,.2,1);animation:mslideIn .3s cubic-bezier(0,0,.2,1);will-change:transform;max-height:calc(100vh - 80px);width:360px;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);top:50%;left:50%;z-index:100000}\@media (max-width:640px){.o-modal__container{top:auto;bottom:2.5rem;-webkit-transform:translate(-50%);transform:translate(-50%)}}.o-modal__container--normal .o-modal-header__content{-ms-flex-pack:center;justify-content:center;width:100%;text-align:center}.o-modal__container--normal .o-modal-header__close{display:none}.o-modal__container--normal .o-modal-body{-ms-flex:1 1 0%;flex:1 1 0%;margin-bottom:1rem}.o-modal__container--normal .o-modal-footer{-ms-flex-pack:center;justify-content:center}.o-modal__container--media{width:704px;border-radius:.25rem;max-height:100%;padding-left:2rem;padding-right:2rem}\@media (max-width:640px){.o-modal__container--media{width:100%;height:100%}}.o-modal__container--media .o-modal-header{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center}.o-modal__container--media .o-modal-header__content{-ms-flex:1 1 0%;flex:1 1 0%;-ms-flex-pack:start;justify-content:flex-start}.o-modal__container--media .o-modal-header__close{display:block}.o-modal__container--media .o-modal-body{-ms-flex:1 1 0%;flex:1 1 0%;margin-bottom:0}.o-modal .o-modal-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;width:100%}.o-modal .o-modal-header__content{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.o-modal .o-modal-header__content h2{font-size:1.25rem;font-weight:600;line-height:1.25;margin-bottom:.5rem;margin-bottom:0}.o-modal .o-modal-header__content p{font-size:.875rem;line-height:1.25;margin-bottom:.5rem;color:rgba(55,71,79,.8);margin-bottom:0}.o-modal .o-modal-header__close:focus{outline:none}.o-modal .o-modal-header__close:focus .r-modal-header__close--focus{outline:1px solid #0076cc}.o-modal .o-modal-header__close--focus{width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.o-modal .o-modal-header__close--focus:focus{outline:none}.o-modal .o-modal-body{display:-ms-flexbox;display:flex;-ms-flex:1 1 0%;flex:1 1 0%;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;color:rgba(55,71,79,.8);padding-left:1rem;padding-right:1rem}.o-modal .o-modal-body img{-ms-flex:1 1 0%;flex:1 1 0%}.o-modal .o-modal-footer{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;margin-top:1rem;padding-left:1rem;padding-right:1rem}\@media (max-width:640px){.o-modal .o-modal-footer{-ms-flex-direction:column;flex-direction:column}.o-modal .o-modal-footer omnibar-button{padding:0}.o-modal .o-modal-footer omnibar-button:not(:first-child){padding-top:1rem}}\@media (min-width:640px){.o-modal .o-modal-footer omnibar-button{-ms-flex:1 1 0%;flex:1 1 0%}.o-modal .o-modal-footer omnibar-button:not(:first-child){padding-left:1rem}}\@-webkit-keyframes mfadeIn{0%{opacity:0}to{opacity:1}}\@keyframes mfadeIn{0%{opacity:0}to{opacity:1}}\@-webkit-keyframes mslidein{0%{-webkit-transform:translatey(15%);transform:translatey(15%)}to{-webkit-transform:translatey(0);transform:translatey(0)}}\@keyframes mslidein{0%{-webkit-transform:translatey(15%);transform:translatey(15%)}to{-webkit-transform:translatey(0);transform:translatey(0)}}\@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){omnibar-modal .o-modal__container,omnibar-modal omnibar-modal-body{-webkit-box-flex:1;-ms-flex:auto;flex:auto}}"; },
        enumerable: true,
        configurable: true
    });
    return class_8;
}());
var OmnibarModalBody = /** @class */ (function () {
    function OmnibarModalBody(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarModalBody.prototype.render = function () {
        return (h("div", { class: "o-modal-body" }, h("slot", null)));
    };
    return OmnibarModalBody;
}());
var OmnibarModalFooter = /** @class */ (function () {
    function OmnibarModalFooter(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarModalFooter.prototype.render = function () {
        return (h("div", { class: "o-modal-footer" }, h("slot", null)));
    };
    return OmnibarModalFooter;
}());
var OmnibarModal$1 = /** @class */ (function () {
    function OmnibarModal$1(hostRef) {
        registerInstance(this, hostRef);
        this.modalClose = createEvent(this, "modalclose", 7);
    }
    OmnibarModal$1.prototype.render = function () {
        var _this_1 = this;
        return (h("div", { class: "o-modal-header" }, h("div", { class: "o-modal-header__content" }, h("h2", null, this.modalTitle), h("p", null, this.description)), h("div", { class: "o-modal-header__close", role: "button", "aria-label": "close", tabindex: "0", onClick: function () { return _this_1.modalClose.emit(); }, onKeyDown: function (e) {
                if (e.key === 'Enter')
                    _this_1.modalClose.emit();
            } }, h("div", { class: "o-modal-header__close--focus", tabindex: "-1" }, h("omnibar-icon", { icon: "close" })))));
    };
    return OmnibarModal$1;
}());
var OmnibarNavigation = /** @class */ (function () {
    function class_9(hostRef) {
        registerInstance(this, hostRef);
        this.secondaryItems = [];
        this.followHref = true;
        this.items = [];
        this.currentRootId = null;
        this.forceCloseNavigation = createEvent(this, "forceCloseNavigation", 7);
        this.omnibarPlatformAlertAsideOpen = createEvent(this, "omnibarPlatformAlertAsideOpen", 7);
    }
    class_9.prototype.apiConfigChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            var secondaryItems, response;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        secondaryItems = [];
                        this.apiClient = createClient('notifications', this.api);
                        if (!this.apiClient.environment || this.apiClient.environment === 'mock' || this.apiClient.environment === 'local')
                            return [2 /*return*/];
                        if (!(this.api.accessToken !== null && !this.secondaryItems.length)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiClient.getNotificationCountbyProductCode(this.api.productCode)];
                    case 1:
                        response = _g.sent();
                        if (response && response.length > 0) {
                            secondaryItems = response;
                        }
                        this.secondaryItems = secondaryItems;
                        _g.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    class_9.prototype.handleHeightChanged = function () {
        this.updatePopoverHeight = !this.updatePopoverHeight;
    };
    class_9.prototype.handleActiveNavigation = function (e) {
        if (this.currentRootId !== e.detail.rootMenuId) {
            this.currentRootId = e.detail.rootMenuId;
        }
        if (this.screenSize === 'sm') {
            this.forceCloseNavigation.emit();
        }
    };
    class_9.prototype.viewPlatformAlerts = function (product) {
        product.productCode = product.productTileCode;
        this.omnibarPlatformAlertAsideOpen.emit(product);
    };
    class_9.prototype.navigationWithPageHeader = function () {
        return !!document.querySelector('omnibar-page-header');
    };
    class_9.prototype.hostData = function () {
        return {
            'data-current-root-id': this.currentRootId,
        };
    };
    class_9.prototype.__stencil_render = function () {
        var _this_1 = this;
        var renderProductAlert = function (item) {
            var alertMessage = item.alertCount + " product alert" + (item.alertCount > 1 ? 's' : '');
            return (h("omnibar-tooltip", { text: alertMessage, placement: _this_1.navigationMinimized ? 'top-start' : 'top', class: "o-secondary-menu__icon__alert" }, h("omnibar-icon", { icon: "interface-alert-triangle", onClick: function (event) {
                    event.stopPropagation();
                    if (item)
                        _this_1.viewPlatformAlerts(item);
                } })));
        };
        var renderNavigationItem = function (item, index) {
            return (h("omnibar-navigation-item", { key: index, uid: "omnibar-nav-" + index, data: item, url: item.url, text: item.title, icon: item.icon, items: item.items, "follow-href": _this_1.followHref.toString(), "page-id": item.pageId, "current-page-id": _this_1.pageId, "has-active-children": _this_1.currentRootId === index, "root-menu-id": index, "navigation-minimized": _this_1.navigationMinimized, hidden: item.hidden, iconKind: item.iconKind, updatePopoverHeight: _this_1.updatePopoverHeight }));
        };
        return (h("div", { class: {
                'o-omnibar-navigation': true,
                'o-dark': this.navigationDark,
                'o-minimized': this.navigationMinimized,
                'o-collapsed': this.navigationMinimized && !!this.screenSize.match(/sm/),
                'o-with-page-header': this.navigationWithPageHeader(),
            }, role: "navigation" }, h("div", { class: "o-menu", role: "menubar" }, this.items.map(function (item, index) { return renderNavigationItem(item, index); })), this.secondaryItems.length > 0 ?
            h("div", { class: "o-secondary-menu o-item" }, renderProductAlert(this.secondaryItems[0])) : ''));
    };
    Object.defineProperty(class_9.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_9, "watchers", {
        get: function () {
            return {
                "api": ["apiConfigChanged"]
            };
        },
        enumerable: true,
        configurable: true
    });
    class_9.prototype.render = function () { return h(Host, this.hostData(), this.__stencil_render()); };
    Object.defineProperty(class_9, "style", {
        get: function () { return ".o-omnibar-navigation{position:fixed;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;justify-content:space-between;bottom:0;top:56px;background-color:#fff;border-right:1px solid #e4e6e7;-webkit-box-shadow:-2px 0 16px 0 rgba(0,0,0,.2);box-shadow:-2px 0 16px 0 rgba(0,0,0,.2);-webkit-transition:width .35s,-webkit-transform .35s;transition:width .35s,-webkit-transform .35s;transition:width .35s,transform .35s;transition:width .35s,transform .35s,-webkit-transform .35s;width:300px;z-index:98}.o-omnibar-navigation.o-with-page-header{-webkit-box-shadow:-2px 43px 16px 0 rgba(0,0,0,.2);box-shadow:-2px 43px 16px 0 rgba(0,0,0,.2)}.o-omnibar-navigation.o-collapsed{-webkit-transform:translateX(-100%);transform:translateX(-100%)}.o-omnibar-navigation .o-menu{overflow:auto;list-style:none;margin:0;padding:0}.o-omnibar-navigation .o-item,.o-omnibar-navigation .o-menu{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.o-omnibar-navigation .o-item{border-top:1px solid #e4e6e7;border-bottom:1px solid #e4e6e7;margin-top:-1px;cursor:pointer;position:relative;-webkit-transition:width .35s,-webkit-transform .35s;transition:width .35s,-webkit-transform .35s;transition:width .35s,transform .35s;transition:width .35s,transform .35s,-webkit-transform .35s;min-height:calc(43px + 1px);width:100%}.o-omnibar-navigation .o-item-menu{display:none;list-style:none;margin:0;overflow:hidden;padding:0;-webkit-transition:height .35s;transition:height .35s}.o-omnibar-navigation .o-item-menu.o-item-menu-show{display:block}.o-omnibar-navigation .o-item-menu:not(.o-sub-item-menu){border-top:1px solid #e4e6e7}.o-omnibar-navigation .o-item-button{-ms-flex-positive:1;flex-grow:1;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding-left:1rem;padding-right:1rem;background-color:#fff;color:#37474f;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-decoration:none;min-height:calc(43px + 1px)}.o-omnibar-navigation .o-item-button:focus{outline:0}.o-omnibar-navigation .o-item-icon{min-width:20px;margin-right:1rem;font-size:1.25rem}.o-omnibar-navigation .o-item-arrow{margin-left:auto;-webkit-transition:-webkit-transform .35s;transition:-webkit-transform .35s;transition:transform .35s;transition:transform .35s,-webkit-transform .35s}.o-omnibar-navigation .o-item-arrow-up{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.o-omnibar-navigation .o-item-text{font-size:.875rem;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.o-omnibar-navigation .o-item-text--favorite{padding-right:1.25rem}.o-omnibar-navigation .o-item-active>a>.o-item-icon{color:#0076cc}.o-omnibar-navigation .o-item-hidden{display:none}.o-omnibar-navigation .o-sub-item{border:0}.o-omnibar-navigation .o-sub-item.o-item-active>a{background:#e7e8e9}.o-omnibar-navigation .o-sub-item .o-item-button{background-color:#f7f6f6;padding-left:32.5px}.o-omnibar-navigation .o-sub-item .o-item-button:hover{background-color:#e7e8e9}.o-omnibar-navigation .o-sub-item .o-sub-item .o-item-button{padding-left:37.5px}.o-omnibar-navigation .o-sub-item .o-sub-item .o-sub-item .o-item-button{padding-left:42.5px}.o-omnibar-navigation .o-sub-item .o-sub-item .o-sub-item .o-sub-item .o-item-button{padding-left:47.5px}.o-omnibar-navigation .o-sub-item .o-sub-item .o-sub-item .o-sub-item .o-sub-item .o-item-button{padding-left:52.5px}.o-omnibar-navigation.o-minimized{overflow-x:hidden;width:53px}.o-omnibar-navigation.o-minimized .o-menu{overflow-x:hidden;height:100%;width:68px}.o-omnibar-navigation.o-minimized .o-item{width:53px}.o-omnibar-navigation.o-minimized .o-item-menu:not(.o-sub-item-menu),.o-omnibar-navigation.o-minimized .o-item-text,.o-omnibar-navigation.o-minimized .o-item:not(.o-sub-item)>.o-item-button .o-badge-count,.o-omnibar-navigation.o-minimized .o-item:not(.o-sub-item)>.o-item-button .o-badge-indicator:not(.o-badge-indicator__positioned),.o-omnibar-navigation.o-minimized .o-item:not(.o-sub-item)>.o-item-button .o-item-arrow{display:none}.o-omnibar-navigation.o-dark{background-color:#495e69}.o-omnibar-navigation.o-dark .o-item-menu{background-color:#37474f}.o-omnibar-navigation.o-dark .o-item-button{background-color:#495e69;color:#fff}.o-omnibar-navigation.o-dark .o-item-active>a>.o-item-icon{color:#66bfff}.o-omnibar-navigation.o-dark .o-sub-item.o-item-active>a{background:#28343b}.o-omnibar-navigation.o-dark .o-sub-item .o-item-button{background-color:#37474f}.o-omnibar-navigation.o-dark .o-sub-item .o-item-button:focus{outline:none}.o-popover-submenu{border:1px solid #e4e6e7;width:0;z-index:1050;margin-left:-2px;margin-top:2px;-webkit-transition:width .35s;transition:width .35s;-webkit-box-shadow:-2px 3px 8px 0 rgba(0,0,0,.1);box-shadow:-2px 3px 8px 0 rgba(0,0,0,.1);position:absolute}.o-popover-submenu__show{width:300px}.o-popover-submenu-title{background-color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;border-color:#e4e6e7;padding-bottom:11px;padding-left:12px;white-space:nowrap}.o-popover-submenu .o-menu{list-style:none;margin:0;padding:0}.o-popover-submenu .o-item,.o-popover-submenu .o-menu{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.o-popover-submenu .o-item{border-top:1px solid #e4e6e7;border-bottom:1px solid #e4e6e7;cursor:pointer;position:relative;-webkit-transition:width .35s,-webkit-transform .35s;transition:width .35s,-webkit-transform .35s;transition:width .35s,transform .35s;transition:width .35s,transform .35s,-webkit-transform .35s;min-height:calc(43px + 1px);width:100%}.o-popover-submenu .o-item-menu{display:none;list-style:none;margin:0;overflow:auto;padding:0;-webkit-transition:height .35s;transition:height .35s}.o-popover-submenu .o-item-menu .o-sub-item-menu{overflow:hidden}.o-popover-submenu .o-item-menu.o-item-menu-show{display:block}.o-popover-submenu .o-item-menu:not(.o-sub-item-menu){border-top:1px solid #e4e6e7}.o-popover-submenu .o-item-button{-ms-flex-positive:1;flex-grow:1;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding-left:1rem;padding-right:1rem;background-color:#fff;color:#37474f;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-decoration:none;min-height:calc(43px + 1px)}.o-popover-submenu .o-item-button:focus{outline:0}.o-popover-submenu .o-item-icon{min-width:20px;margin-right:1rem;font-size:1.25rem}.o-popover-submenu .o-item-arrow{margin-left:auto;-webkit-transition:-webkit-transform .35s;transition:-webkit-transform .35s;transition:transform .35s;transition:transform .35s,-webkit-transform .35s}.o-popover-submenu .o-item-arrow-up{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.o-popover-submenu .o-item-text{font-size:.875rem;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.o-popover-submenu .o-item-text--favorite{padding-right:1.25rem}.o-popover-submenu .o-item-text.o-popover-submenu-title{display:-ms-flexbox;display:flex}.o-popover-submenu .o-item-active>a>.o-item-icon{color:#0076cc}.o-popover-submenu .o-item-hidden{display:none}.o-popover-submenu>.o-item-menu{display:block;border-left:1px solid #e4e6e7}.o-popover-submenu .o-sub-item{border:0}.o-popover-submenu .o-sub-item.o-item-active>a{background:#e7e8e9}.o-popover-submenu .o-sub-item .o-item-button{background-color:#f7f6f6;padding-left:32.5px}.o-popover-submenu .o-sub-item .o-item-button:hover{background-color:#e7e8e9}.o-popover-submenu .o-sub-item .o-sub-item .o-item-button{padding-left:37.5px}.o-popover-submenu .o-sub-item .o-sub-item .o-sub-item .o-item-button{padding-left:42.5px}.o-popover-submenu .o-sub-item .o-sub-item .o-sub-item .o-sub-item .o-item-button{padding-left:47.5px}.o-popover-submenu .o-sub-item .o-sub-item .o-sub-item .o-sub-item .o-sub-item .o-item-button{padding-left:52.5px}.o-popover-submenu .o-sub-item .o-item-button{padding-left:10px}.o-popover-submenu .o-sub-item .o-sub-item .o-item-button{padding-left:15px}.o-popover-submenu .o-sub-item .o-sub-item .o-sub-item .o-item-button{padding-left:20px}.o-popover-submenu .o-sub-item .o-sub-item .o-sub-item .o-sub-item .o-item-button{padding-left:25px}.o-popover-submenu .o-sub-item .o-sub-item .o-sub-item .o-sub-item .o-sub-item .o-item-button{padding-left:30px}.o-omnibar-navigation.o-dark+.o-popover-submenu{background-color:#495e69}.o-omnibar-navigation.o-dark+.o-popover-submenu .o-popover-submenu-title{background-color:#495e69;color:#fff}.o-omnibar-navigation.o-dark+.o-popover-submenu .o-item-menu{background-color:#37474f}.o-omnibar-navigation.o-dark+.o-popover-submenu .o-item-button{background-color:#495e69;color:#fff}.o-omnibar-navigation.o-dark+.o-popover-submenu .o-item-active>a>.o-item-icon{color:#66bfff}.o-omnibar-navigation.o-dark+.o-popover-submenu .o-sub-item.o-item-active>a{background:#28343b}.o-omnibar-navigation.o-dark+.o-popover-submenu .o-sub-item .o-item-button{background-color:#37474f}.o-omnibar-navigation.o-dark+.o-popover-submenu .o-sub-item .o-item-button:focus{outline:none}.o-badge-count,.o-badge-indicator{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:1.25rem;border-radius:9999px;font-size:.75rem;padding-left:.5rem;padding-right:.5rem;padding-top:.25rem;padding-bottom:.25rem;color:#fff;background:#f65216;margin-left:auto}.o-badge-indicator{height:auto;padding:.25rem}.o-badge-indicator+.o-item-arrow{margin-left:.75rem}.o-badge-indicator__positioned{position:absolute;top:25%;left:28px;border:1px solid #fff}.o-dark .o-badge-indicator__positioned{border-color:#37474f}.o-omnibar-fav{position:absolute;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:100%;width:2.5rem;border-radius:9999px;font-size:1.25rem;right:0;top:0;color:#fec12d;padding-right:.9rem}.o-omnibar-fav:hover{color:#c6ccd0}.o-secondary-menu__icon{border-radius:9999px;background-color:#ebedee;margin-right:1rem;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:32px;height:32px}.o-secondary-menu__icon__alert{right:20px;text-align:end;position:absolute;margin-top:.5rem;font-size:17px;color:#fec12d!important}"; },
        enumerable: true,
        configurable: true
    });
    return class_9;
}());
ShellTunnel.injectProps(OmnibarNavigation, ['screenSize', 'pageId', 'navigationMinimized', 'navigationDark', 'api']);
var classnames = createCommonjsModule(function (module) {
    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */
    /* global define */
    (function () {
        var hasOwn = {}.hasOwnProperty;
        function classNames() {
            var classes = [];
            for (var i = 0; i < arguments.length; i++) {
                var arg = arguments[i];
                if (!arg)
                    continue;
                var argType = typeof arg;
                if (argType === 'string' || argType === 'number') {
                    classes.push(arg);
                }
                else if (Array.isArray(arg) && arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) {
                        classes.push(inner);
                    }
                }
                else if (argType === 'object') {
                    for (var key in arg) {
                        if (hasOwn.call(arg, key) && arg[key]) {
                            classes.push(key);
                        }
                    }
                }
            }
            return classes.join(' ');
        }
        if (module.exports) {
            classNames.default = classNames;
            module.exports = classNames;
        }
        else {
            window.classNames = classNames;
        }
    }());
});
var OmnibarNavigationItem = /** @class */ (function () {
    function class_10(hostRef) {
        var _this_1 = this;
        registerInstance(this, hostRef);
        this.omnibarHeight = 56;
        this.subItemsMenuFromTop = null;
        this.subItemsAnimating = false;
        this.isFirstItemInMenu = false;
        this.isLastItemInMenu = false;
        this.pointerOverSubmenu = false;
        this.pointerOverMenuItem = false;
        this.popOverUpdating = false;
        this.popper = null;
        this.subItemsExpanding = false;
        this.subItemsExpanded = false;
        this.isFocused = false;
        this.items = [];
        this.hasActiveChildren = false;
        this.isSubItem = false;
        this.viewportDimensions = null;
        this.hidden = false;
        this.iconKind = 'icon';
        this.favoriteItems = false;
        this.checkActiveChild = function (array) {
            return array.some(function (item) {
                var _a;
                if ((_a = item.items) === null || _a === void 0 ? void 0 : _a.length) {
                    return _this_1.checkActiveChild(item.items);
                }
                else {
                    return item.pageId === _this_1.currentPageId;
                }
            });
        };
        this.navigate = createEvent(this, "navigate", 7);
        this.activeNavigation = createEvent(this, "activeNavigation", 7);
        this.linkFocused = createEvent(this, "linkFocused", 7);
        this.linkBlurred = createEvent(this, "linkBlurred", 7);
        this.navFavItemClick = createEvent(this, "navFavItemClick", 7);
        this.heightChanged = createEvent(this, "heightChanged", 7);
    }
    class_10.prototype.handleCurrentPageIdChange = function () {
        if (this.isCurrentPage()) {
            this.activeNavigation.emit({ rootMenuId: this.rootMenuId });
        }
    };
    class_10.prototype.handleChange = function () {
        var _this_1 = this;
        if (this.popper) {
            this.popOverUpdating = true;
            document.querySelector('body').classList.add('no-scroll');
            setTimeout(function () {
                if (_this_1.isFirstItemInMenu) { // for first item popover - enable 'preventOverflow'
                    _this_1.popper.modifiers.some(function (item) {
                        if (item.name === 'preventOverflow') {
                            item.enabled = true;
                            return true;
                        }
                    });
                }
                _this_1.popper.update();
            }, 351);
            setTimeout(function () {
                _this_1.popOverUpdating = false;
                document.querySelector('body').classList.remove('no-scroll');
            }, 400); // it should happen after height animation is completed
        }
    };
    class_10.prototype.componentWillLoad = function () {
        // this.subItemsExpanding = getSession(this.uid)
        // this.subItemsExpanded = getSession(this.uid)
        this.subItemsExpanded = this.checkActiveChild(this.items);
        this.subItemsExpanding = this.checkActiveChild(this.items);
    };
    class_10.prototype.componentDidLoad = function () {
        var _a, _b;
        this.handleCurrentPageIdChange();
        this.isFirstItemInMenu = this.el.isSameNode((_a = this.el.closest('.o-menu')) === null || _a === void 0 ? void 0 : _a.firstElementChild);
        this.isLastItemInMenu = this.el.isSameNode((_b = this.el.closest('.o-menu')) === null || _b === void 0 ? void 0 : _b.lastElementChild);
        document.querySelector('.o-omnibar-navigation .o-menu').addEventListener('scroll', this.removeSubmenu.bind(this));
    };
    class_10.prototype.isCurrentPage = function () {
        var _g = this, pageId = _g.pageId, currentPageId = _g.currentPageId, url = _g.url;
        if (!currentPageId)
            return false;
        return (pageId && pageId === currentPageId) || (url === currentPageId);
    };
    class_10.prototype.toggleSubItems = function (element) {
        return __awaiter(this, void 0, void 0, function () {
            var sleep_1, asyncSetTimeout, height_1;
            var _this_1 = this;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!element) return [3 /*break*/, 3];
                        sleep_1 = function (ms) {
                            return new Promise(function (resolve) { return setTimeout(resolve, ms || 0); });
                        };
                        asyncSetTimeout = function (fn, ms) { return __awaiter(_this_1, void 0, void 0, function () {
                            return __generator(this, function (_g) {
                                switch (_g.label) {
                                    case 0: return [4 /*yield*/, sleep_1(ms || 0)];
                                    case 1:
                                        _g.sent();
                                        return [2 /*return*/, fn()];
                                }
                            });
                        }); };
                        if (!!this.subItemsAnimating) return [3 /*break*/, 3];
                        this.subItemsAnimating = true;
                        this.subItemsExpanding = !this.subItemsExpanding;
                        height_1 = elementBlockHeight(element) + "px";
                        if (!this.subItemsExpanded) {
                            element.style.display = 'block';
                            element.style.height = '0px';
                            setTimeout(function () {
                                element.style.height = height_1;
                                _this_1.heightChanged.emit();
                            }, 50);
                            // setSession(this.uid, true)
                        }
                        else {
                            element.style.height = height_1;
                            setTimeout(function () {
                                element.style.height = '0px';
                                _this_1.heightChanged.emit();
                            }, 50);
                            // setSession(this.uid, false)
                        }
                        return [4 /*yield*/, asyncSetTimeout(function () {
                                _this_1.subItemsExpanded = !_this_1.subItemsExpanded;
                            }, 350)];
                    case 1:
                        _g.sent();
                        return [4 /*yield*/, asyncSetTimeout(function () { element.removeAttribute('style'); }, 100)];
                    case 2:
                        _g.sent();
                        this.subItemsAnimating = false;
                        _g.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    class_10.prototype.handleClick = function (e) {
        if (!this.followHref)
            e.preventDefault();
        if (this.items.length) {
            if (this.navigationMinimized && !this.isSubItem)
                return false;
            this.toggleSubItems(this.subItemsMenu);
        }
        else {
            this.navigate.emit(this.data);
            this.activeNavigation.emit({ rootMenuId: this.rootMenuId });
            if (this.data.onNavItemClick)
                this.data.onNavItemClick(e);
        }
    };
    class_10.prototype.handleMouseEnter = function (e) {
        this.pointerOverMenuItem = true;
        if (this.items.length && !this.isSubItem && this.navigationMinimized) {
            this.subItemsMenuFromTop = e.currentTarget.getBoundingClientRect().bottom - this.omnibarHeight;
        }
        if (!this.isSubItem && this.navigationMinimized) {
            this.showSubmenu();
        }
    };
    class_10.prototype.showSubmenu = function () {
        var _this_1 = this;
        if (!this.popper) {
            var submenu = document.createElement('div');
            submenu.innerHTML = "\n        " + (this.subItemsMenu ? '<div' : "<a href=\"" + this.url + "\" ") + " class=\"o-popover-submenu-title o-pt-3 o-item-text\">\n          <div>" + this.text + "</div>\n          " + ((!this.subItemsMenu && this.data.badgeCount) ? "<div class=\"o-badge-count o-mr-3\">" + this.data.badgeCount + "</div>" : '') + "      \n        " + (this.subItemsMenu ? '</div>' : '</a>') + "\n    ";
            this.submenuElem = document.querySelector('omnibar-navigation').appendChild(submenu);
            if (this.subItemsMenu) {
                this.submenuElem.appendChild(this.subItemsMenu);
            }
            this.submenuElem.classList.add('o-popover-submenu');
            this.popper = new Popper(this.listItemRef, this.submenuElem, {
                placement: 'right-start',
                modifiers: {
                    preventOverflow: {
                        enabled: !(this.isFirstItemInMenu && !this.subItemsMenu),
                        boundariesElement: 'viewport',
                    },
                    offset: { offset: this.isFirstItemInMenu ? '-1, 0' : '0, 0' },
                    hide: { enabled: !(this.isFirstItemInMenu) },
                    computeStyle: {
                        gpuAcceleration: false,
                    },
                }
            });
            this.submenuElem.classList.add('o-popover-submenu__show');
            if (!this.subItemsMenu) {
                submenu.addEventListener('click', function (e) { return _this_1.handleClick(e); });
            }
            this.submenuElem.addEventListener('mouseenter', function () { this.pointerOverSubmenu = true; }.bind(this));
            this.submenuElem.addEventListener('mouseleave', function () {
                if (this.popOverUpdating)
                    return;
                this.pointerOverSubmenu = false;
                this.removeSubmenu();
            }.bind(this));
            window.addEventListener('touchend', function (e) {
                if (e.target.closest('.o-popover-submenu__show'))
                    return;
                this.pointerOverSubmenu = false;
                this.pointerOverMenuItem = false;
                this.removeSubmenu();
            }.bind(this));
        }
    };
    class_10.prototype.removeSubmenu = function () {
        setTimeout(function () {
            if (this.pointerOverSubmenu || this.pointerOverMenuItem) {
                return;
            }
            if (this.popper) {
                if (this.subItemsMenu) {
                    this.listItemRef.appendChild(this.subItemsMenu); // move submenu back under nav li element
                }
                this.submenuElem.parentNode.removeChild(this.submenuElem);
                this.popper.destroy();
                this.popper = null;
                this.submenuElem = null;
            }
        }.bind(this), 0);
    };
    class_10.prototype.subItemsMenuMaxHeight = function () {
        return this.viewportDimensions['height'] - this.omnibarHeight;
    };
    class_10.prototype.handleFocus = function () {
        this.linkFocused.emit(this.rootMenuId);
        if (!this.subItemsExpanded) {
            if (this.navigationMinimized && !this.isSubItem)
                return false;
            this.toggleSubItems(this.subItemsMenu);
        }
        if (!this.isSubItem && this.navigationMinimized) {
            this.showSubmenu();
        }
    };
    class_10.prototype.handleBlur = function () {
        this.removeSubmenu();
        this.linkBlurred.emit({
            rootMenuId: this.rootMenuId,
            parentAnchorElementRef: this.parentAnchorElementRef
        });
    };
    class_10.prototype.handleKeyDown = function (e) {
        if (e.key === 'Enter')
            this.handleClick(e);
        if (e.key === 'Escape' || e.key === 'Esc') {
            if (this.parentAnchorElementRef) {
                e.stopPropagation();
                this.parentAnchorElementRef.focus();
                this.toggleParent();
            }
        }
    };
    class_10.prototype.handleClickFavorite = function (e) {
        this.navFavItemClick.emit({ pageId: this.data.pageId, favorite: !!this.data.favorite, pageUrl: this.data.url });
        if (this.data.onNavFavItemClick)
            this.data.onNavFavItemClick(e);
    };
    class_10.prototype.handleLinkFocusedEvent = function (ev) {
        if (!this.isFocused && (ev.detail === this.rootMenuId)) {
            this.isFocused = true;
        }
    };
    class_10.prototype.handleLinkBlurredEvent = function (ev) {
        if (this.isFocused && (ev.detail.rootMenuId === this.rootMenuId)) {
            this.isFocused = false;
        }
    };
    class_10.prototype.renderSubItemsMenu = function (items) {
        var _this_1 = this;
        var renderSubItem = function (item, index) {
            var _a;
            return (h("omnibar-navigation-item", { key: index, uid: _this_1.uid + "-" + index, data: item, url: item.url, text: item.title, icon: item.icon, items: item.items, "follow-href": _this_1.followHref.toString(), "page-id": item.pageId, "current-page-id": _this_1.currentPageId, "root-menu-id": _this_1.rootMenuId, "is-sub-item": true, "has-active-child": ((_a = item.items) === null || _a === void 0 ? void 0 : _a.length) && _this_1.checkActiveChild(item.items), parentAnchorElementRef: _this_1.anchorElementRef, toggleParent: function () { return _this_1.toggleSubItems(_this_1.subItemsMenu); }, hidden: _this_1.hidden, updatePopoverHeight: _this_1.updatePopoverHeight }));
        };
        if (this.items.length) {
            return (h("div", { class: classnames('o-item-menu', {
                    'o-sub-item-menu': this.isSubItem,
                    'o-item-menu-show': this.subItemsExpanded
                }), style: { maxHeight: this.navigationMinimized ? this.subItemsMenuMaxHeight() + "px" : '' }, ref: function (el) { return _this_1.subItemsMenu = el; }, role: "menubar" }, items.map(function (item, index) { return renderSubItem(item, index); })));
        }
        return null;
    };
    class_10.prototype.render = function () {
        var _this_1 = this;
        var checkChildBadges = function (array) {
            return array.some(function (item) {
                var _a;
                if ((_a = item.items) === null || _a === void 0 ? void 0 : _a.length) {
                    return checkChildBadges(item.items);
                }
                else {
                    return item.badgeCount;
                }
            });
        };
        var removeBadgeCountIfFavorite = function (array) {
            for (var eachItem in array) {
                var item = array[eachItem];
                if (item.hasOwnProperty('favorite')) {
                    delete item.badgeCount;
                }
            }
            return array;
        };
        var shouldFavoriteIconRendered = function () {
            return _this_1.favoriteItems && _this_1.data.hasOwnProperty('favorite');
        };
        if (this.favoriteItems) {
            this.items = removeBadgeCountIfFavorite(this.items);
        }
        var hasChildBadges = checkChildBadges(this.items);
        var renderItemIcon = function () {
            if (!_this_1.icon)
                return;
            if (_this_1.icon.match(/fa fa-/)) {
                return h("i", { class: _this_1.icon + " o-item-icon" });
            }
            else {
                return h("omnibar-icon", { icon: _this_1.icon, kind: _this_1.iconKind, class: "o-item-icon" });
            }
        };
        var renderItemArrow = function () {
            if (_this_1.items.length) {
                return (h("omnibar-icon", { icon: "omnibar-angle-down", class: classnames('o-item-arrow', { 'o-item-arrow-up': _this_1.subItemsExpanding }) }));
            }
            return null;
        };
        var renderText = function () {
            return h("span", { class: {
                    'o-item-text': true,
                    'o-item-text--favorite': shouldFavoriteIconRendered() && !_this_1.items.length && _this_1.isSubItem
                } }, _this_1.text);
        };
        var renderFavoriteIcon = function () {
            if (shouldFavoriteIconRendered() && !_this_1.items.length && _this_1.isSubItem) {
                return (h("div", { class: "o-omnibar-fav", onClick: function (e) { return _this_1.handleClickFavorite(e); } }, h("omnibar-icon", { kind: _this_1.data.favorite ? 'icon' : 'line', icon: "vote-star" })));
            }
            return null;
        };
        var renderBadgeCount = function () {
            if (!_this_1.items.length && _this_1.data.badgeCount) {
                return h("div", { class: "o-badge-count" }, _this_1.data.badgeCount);
            }
            return null;
        };
        var renderBageIndicator = function () {
            if (!_this_1.subItemsExpanded && hasChildBadges) {
                return h("div", { class: "o-badge-indicator" });
            }
            return null;
        };
        var renderBageMinimized = function () {
            if (_this_1.navigationMinimized && !_this_1.popper && (hasChildBadges || (!_this_1.items.length && _this_1.data.badgeCount))) {
                return h("div", { class: "o-badge-indicator o-badge-indicator__positioned" });
            }
            return null;
        };
        var renderBadges = function () {
            if (!shouldFavoriteIconRendered()) {
                return (renderBageMinimized() || renderBageIndicator() || renderBadgeCount());
            }
        };
        return (h("div", { role: "menuitem", "aria-expanded": this.subItemsExpanded, class: classnames('o-item', {
                'o-item-active': this.isCurrentPage() || this.hasActiveChildren,
                'o-sub-item': this.isSubItem,
                'o-item-focused': this.isFocused,
                'o-item-hidden': this.hidden
            }), onMouseEnter: function (e) { return _this_1.handleMouseEnter(e); }, onMouseLeave: function () {
                _this_1.pointerOverMenuItem = false;
                _this_1.removeSubmenu();
            }, ref: function (el) { return _this_1.listItemRef = el; } }, h("a", { href: !this.items.length ? this.url : null, title: this.text, class: "o-item-button", onClick: function (e) { return _this_1.handleClick(e); }, onKeyDown: function (e) { return _this_1.handleKeyDown(e); },
            // onMouseEnter={() => this.handleMouseEnter()}
            // onMouseLeave={() => this.removeSubmenu()}
            onFocus: function () { return _this_1.handleFocus(); }, onBlur: function () { return _this_1.handleBlur(); }, ref: function (el) { return _this_1.anchorElementRef = el; }, tabindex: "0" }, renderItemIcon(), renderText(), renderBadges(), renderItemArrow()), renderFavoriteIcon(), this.renderSubItemsMenu(this.items)));
    };
    Object.defineProperty(class_10.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_10, "watchers", {
        get: function () {
            return {
                "currentPageId": ["handleCurrentPageIdChange"],
                "updatePopoverHeight": ["handleChange"]
            };
        },
        enumerable: true,
        configurable: true
    });
    return class_10;
}());
ShellTunnel.injectProps(OmnibarNavigationItem, ['viewportDimensions', 'favoriteItems']);
var OmnibarOption = /** @class */ (function () {
    function OmnibarOption(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarOption.prototype.render = function () {
        var _this_1 = this;
        return (h(Host, { class: {
                'o-option': true,
                'o-option--multiple': this.multiple,
                'o-option--active': this.focused,
                'o-option--disabled': this.disabled,
                'o-option--selected': this.selected,
                'o-option--group': this.variant === 'group',
                'o-option--heading': this.variant === 'heading',
                'o-option--sub-option': this.variant === 'sub-option',
                'o-option--with-description': !!this.description
            }, role: "option", tabindex: "-1", id: this.optionId, "aria-selected": this.selected ? 'true' : 'false', "aria-disabled": this.disabled ? 'true' : null }, this.icon && h("omnibar-icon", { class: "o-option__icon", icon: this.icon, kind: this.iconKind }), h("div", { class: "o-option__text" }, h("div", { class: "o-option__text__title", title: this.text }, this.text), this.description && h("div", { class: "o-option__text__description", title: this.description }, this.description)), this.multiple
            ? h("omnibar-checkbox", { small: true }, h("input", { type: "checkbox", tabindex: "-1", "aria-hidden": "true", checked: this.selected, disabled: this.disabled, value: this.value, ref: function (el) { return el && (el.indeterminate = _this_1.indeterminate); } }))
            : h("div", { class: "o-option__check-mark" })));
    };
    return OmnibarOption;
}());
var OmnibarPageCrumb = /** @class */ (function () {
    function OmnibarPageCrumb(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarPageCrumb.prototype.render = function () {
        return (h("span", { class: "omnibar-page-crumb" }, h("slot", null)));
    };
    Object.defineProperty(OmnibarPageCrumb, "style", {
        get: function () { return "omnibar-page-header .omnibar-page-crumb a{color:#303436;text-decoration:none}omnibar-page-header .omnibar-page-crumb a:hover{text-decoration:underline}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarPageCrumb;
}());
var CrumbPosition;
(function (CrumbPosition) {
    CrumbPosition["before"] = "before";
    CrumbPosition["after"] = "after";
})(CrumbPosition || (CrumbPosition = {}));
var OmnibarPageHeader = /** @class */ (function () {
    function OmnibarPageHeader(hostRef) {
        registerInstance(this, hostRef);
        this.crumbs = [];
        this.crumbsPosition = CrumbPosition.after;
    }
    OmnibarPageHeader.prototype.render = function () {
        var _this_1 = this;
        var renderCrumb = function (crumb) {
            if (crumb.url)
                return h("a", { href: crumb.url }, crumb.text);
            return crumb.text;
        };
        var renderCrumbPosition = function (position) {
            if (_this_1.crumbsPosition === position) {
                return (_this_1.crumbs.map(function (item) { return h("omnibar-page-crumb", null, renderCrumb(item)); }));
            }
            return null;
        };
        return (h("div", { class: "o-page-header" }, h("div", { class: "o-page-header__wrapper" }, this.pageTitle && h("h1", null, this.pageTitle), h("div", { class: "o-page-header__breadcrumbs" }, renderCrumbPosition(CrumbPosition.before), h("slot", null), renderCrumbPosition(CrumbPosition.after)))));
    };
    Object.defineProperty(OmnibarPageHeader, "style", {
        get: function () { return "omnibar-page-header{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}omnibar-page-header .o-page-header{line-height:1.25;letter-spacing:0;overflow:hidden;padding-left:15px;-webkit-box-shadow:0 2px 10px -1px rgba(0,0,0,.2);box-shadow:0 2px 10px -1px rgba(0,0,0,.2);min-height:43px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff}omnibar-page-header .o-page-header__wrapper{overflow:hidden}omnibar-page-header .o-page-header__wrapper h1{font-size:1rem;color:#37474f;color:#0076cc;font-weight:400;margin:0}omnibar-page-header .o-page-header__breadcrumbs{font-size:.75rem;overflow-x:auto;white-space:nowrap;padding-right:15px;margin-top:0;color:#303436;scrollbar-width:none;-ms-overflow-style:none}omnibar-page-header .o-page-header__breadcrumbs::-webkit-scrollbar{display:none}omnibar-page-header .o-page-header__breadcrumbs omnibar-page-crumb:not(:last-child){padding-right:12px}omnibar-page-header .o-page-header__breadcrumbs omnibar-page-crumb:not(:last-child):after{position:relative;left:7px;content:\"/\"}omnibar-page-header .o-page-header__breadcrumbs omnibar-page-crumb:last-child{font-weight:700}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarPageHeader;
}());
var OmnibarPageLoader = /** @class */ (function () {
    function OmnibarPageLoader(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarPageLoader.prototype.render = function () {
        return (h("div", { class: 'o-page-loader__container' }, h("div", { class: 'o-page-loader__spinner' })));
    };
    Object.defineProperty(OmnibarPageLoader, "style", {
        get: function () { return "omnibar-page-loader .o-page-loader__container{z-index:10000;position:fixed;top:0;right:0;bottom:0;left:0;height:100vh;width:100vw;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;background:rgba(55,71,79,.5)}omnibar-page-loader .o-page-loader__container .o-page-loader__spinner{opacity:1;height:3rem;width:3rem;border-radius:9999px;border-width:4px;border-style:solid;border-color:#fff;border-right:4px solid #0076cc;-webkit-animation:spin 1s linear infinite;animation:spin 1s linear infinite}\@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}\@keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarPageLoader;
}());
var OmnibarPagingBar = /** @class */ (function () {
    function OmnibarPagingBar(hostRef) {
        registerInstance(this, hostRef);
        this.entities = [10, 20, 30, 40, 50];
        this.totalRows = 0;
        this.rowsPerPage = 10;
        this.currentPage = 1;
        this.pagingChange = createEvent(this, "pagingChange", 7);
    }
    OmnibarPagingBar.prototype.currentPageChanged = function (_, oldVal) {
        this.validateCurrentPage(oldVal);
    };
    OmnibarPagingBar.prototype.rowsPerPageChanged = function () {
        this.validateRowsPerPage();
    };
    OmnibarPagingBar.prototype.componentWillLoad = function () {
        this.validateRowsPerPage();
        this.validateCurrentPage();
    };
    OmnibarPagingBar.prototype.decrement = function () {
        this.currentPage = this.currentPage - 1;
        this.updateBar('previousPage');
    };
    OmnibarPagingBar.prototype.entitiesChange = function (event) {
        this.rowsPerPage = Number(event.target.value);
        this.currentPage = 1;
        this.updateBar('entitiesChange');
    };
    OmnibarPagingBar.prototype.increment = function () {
        this.currentPage = this.currentPage + 1;
        this.updateBar('nextPage');
    };
    OmnibarPagingBar.prototype.pageValueChange = function (event) {
        var val = Number(event.target.value);
        if (val > this.totalPages() || val < 1 || isNaN(val)) {
            event.target.value = this.currentPage;
        }
        else {
            this.currentPage = val;
            this.updateBar('pageValueChange');
        }
        event.target.blur();
    };
    OmnibarPagingBar.prototype.totalPages = function () {
        return Math.ceil(this.totalRows / this.rowsPerPage);
    };
    OmnibarPagingBar.prototype.startRow = function () {
        return (this.currentPage - 1) * this.rowsPerPage + 1;
    };
    OmnibarPagingBar.prototype.endRow = function () {
        var endRow = (this.currentPage - 1) * this.rowsPerPage + this.rowsPerPage;
        return endRow <= this.totalRows ? endRow : this.totalRows;
    };
    OmnibarPagingBar.prototype.updateBar = function (event) {
        if (this.validateRowsPerPage()) {
            this.pagingChange.emit({
                event: event,
                currentPage: this.currentPage,
                rowsPerPage: this.rowsPerPage,
                totalPages: this.totalPages(),
                startRow: this.startRow(),
                endRow: this.endRow()
            });
        }
    };
    OmnibarPagingBar.prototype.validateCurrentPage = function (oldVal) {
        if (oldVal === void 0) { oldVal = 1; }
        if (this.currentPage < 1 || this.currentPage > this.totalPages()) {
            console.error("OMNIBAR Paging Bar Component ERROR: current page can't be less than 1 or greater than total pages number");
            this.currentPage = oldVal;
        }
    };
    OmnibarPagingBar.prototype.validateRowsPerPage = function () {
        if (!this.entities.includes(this.rowsPerPage)) {
            console.error("OMNIBAR Paging Bar Component ERROR: rowsPerPage does not match entities array. rowsPerPage is set to " + this.rowsPerPage + " but available entities are: " + this.entities.toString());
        }
        return this.entities.includes(this.rowsPerPage);
    };
    OmnibarPagingBar.prototype.render = function () {
        var _this_1 = this;
        return (h("div", { class: "o-paging-bar" }, h("div", { class: "o-paging-bar__col o-paging-bar__col--entries" }, "Show", h("div", { class: "o-paging-bar__entry-select" }, h("select", { onChange: function (event) { return _this_1.entitiesChange(event); } }, this.entities && this.entities.map(function (entity) { return (h("option", { value: entity, selected: _this_1.rowsPerPage === entity }, entity)); })), h("omnibar-icon", { class: "o-select__arrow", icon: "arrow-down-v" })), "entries"), h("div", { class: "o-paging-bar__col o-paging-bar__col--count" }, this.startRow(), " - ", this.endRow() <= this.totalRows ? this.endRow() : this.totalRows, " of ", this.totalRows), h("div", { class: "o-paging-bar__col o-paging-bar__col--nav" }, h("button", { type: "button", "aria-label": "Previous Entries", onClick: function () { return _this_1.decrement(); }, disabled: this.currentPage === 1 }, h("omnibar-icon", { icon: "arrow-left-v" })), h("div", { class: "o-paging-bar__nav" }, "Page", h("div", { class: "o-paging-bar__input" }, h("input", { type: "number", min: "1", max: this.totalPages(), value: this.currentPage, onChange: function (event) { return _this_1.pageValueChange(event); }, onKeyPress: function (event) { return event.key === 'Enter' ? _this_1.pageValueChange(event) : null; } })), "of ", this.totalPages()), h("button", { type: "button", "aria-label": "Next Entries", onClick: function () { return _this_1.increment(); }, disabled: this.currentPage === this.totalPages() }, h("omnibar-icon", { icon: "arrow-right-v" })))));
    };
    Object.defineProperty(OmnibarPagingBar, "watchers", {
        get: function () {
            return {
                "currentPage": ["currentPageChanged"],
                "rowsPerPage": ["rowsPerPageChanged"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OmnibarPagingBar, "style", {
        get: function () { return "omnibar-paging-bar{display:block}omnibar-paging-bar .o-paging-bar{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-wrap:nowrap;flex-wrap:nowrap;font-size:.75rem;border-bottom:1px solid #ebedee}omnibar-paging-bar .o-paging-bar__col{max-width:100%;padding-top:.5rem;padding-bottom:.5rem;padding-right:.75rem;-webkit-box-flex:0;-ms-flex:0 0 100%;flex:0 0 100%}\@media (min-width:768px){omnibar-paging-bar .o-paging-bar__col{-webkit-box-flex:0;-ms-flex:0 0 33.3333333333%;flex:0 0 33.3333333333%;max-width:33.3333333333%}}omnibar-paging-bar .o-paging-bar__col--entries{display:none}\@media (min-width:768px){omnibar-paging-bar .o-paging-bar__col--entries{display:block;-webkit-box-flex:0;-ms-flex:0 0 33.3333333333%;flex:0 0 33.3333333333%;max-width:33.3333333333%}}omnibar-paging-bar .o-paging-bar__col--count{display:none;text-align:center}\@media (min-width:768px){omnibar-paging-bar .o-paging-bar__col--count{display:block;-webkit-box-flex:0;-ms-flex:0 0 33.3333333333%;flex:0 0 33.3333333333%;max-width:33.3333333333%}}omnibar-paging-bar .o-paging-bar__col--nav{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;text-align:center}\@media (min-width:768px){omnibar-paging-bar .o-paging-bar__col--nav{-ms-flex-pack:end;justify-content:flex-end;padding-right:0;text-align:right;-webkit-box-flex:0;-ms-flex:0 0 33.3333333333%;flex:0 0 33.3333333333%;max-width:33.3333333333%}}omnibar-paging-bar .o-paging-bar__col--nav button{position:relative;vertical-align:middle;padding-top:0;padding-bottom:0;padding-left:.75rem;padding-right:.75rem;margin-top:.25rem;font-size:.875rem;line-height:1}omnibar-paging-bar .o-paging-bar__col--nav button[disabled]{opacity:.3}body[modality=keyboard] omnibar-paging-bar .o-paging-bar__col--nav button:focus{outline:0}body[modality=keyboard] omnibar-paging-bar .o-paging-bar__col--nav button:focus:before{display:none;position:absolute;border:1px solid #0076cc;border-radius:3px;right:8px;content:\"\";height:24px;top:-3px;width:24px}omnibar-paging-bar .o-paging-bar__entry-select{display:inline-block;background-color:transparent;position:relative;vertical-align:baseline;margin-top:0;margin-bottom:0;margin-left:.25rem;margin-right:.25rem}omnibar-paging-bar .o-paging-bar__entry-select .o-select__arrow{position:absolute;color:#0076cc;right:2px;top:.5rem}omnibar-paging-bar .o-paging-bar__entry-select select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;position:relative;border-radius:.25rem;padding-left:.5rem;padding-right:.75rem;padding-top:.25rem;padding-bottom:.25rem;z-index:10;border-width:1px;border-color:transparent;color:#0076cc;width:42px}omnibar-paging-bar .o-paging-bar__entry-select select::-ms-expand{display:none}body[modality=keyboard] omnibar-paging-bar .o-paging-bar__entry-select select:focus{outline:0;border-radius:.25rem;border-color:#0076cc;border-radius:3px}omnibar-paging-bar .o-paging-bar select:focus~.o-paging-bar__entry-select{border-color:#0076cc}omnibar-paging-bar .o-paging-bar__nav{display:inline-block}omnibar-paging-bar .o-paging-bar__input{display:inline-block;margin:0 4px;width:40px}omnibar-paging-bar .o-paging-bar__input input[type=number]{text-align:center;width:100%;border:1px solid #c6ccd0;border-radius:2px;color:#0076cc;padding:2px 6px;-webkit-transition:all .35s;transition:all .35s}omnibar-paging-bar .o-paging-bar__input input[type=number]:focus{outline:0;border-color:#0076cc}omnibar-paging-bar .o-paging-bar__input input[type=number]::-webkit-inner-spin-button,omnibar-paging-bar .o-paging-bar__input input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;appearance:none;margin:0}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarPagingBar;
}());
var OmnibarProductAlerts = /** @class */ (function () {
    function class_11(hostRef) {
        registerInstance(this, hostRef);
        this.platformAlerts = [];
        this.opened = false;
        this.selectedItem = null;
        this.omnibarPlatformAlertsAsideClose = createEvent(this, "omnibarPlatformAlertsAsideClose", 7);
    }
    class_11.prototype.openedChanged = function () {
        this.opened
            ? (this.platfromAlertsAsideEl.open(), this.loadProductAlertInfo())
            : this.platfromAlertsAsideEl.close();
    };
    class_11.prototype.componentDidLoad = function () {
        var _this_1 = this;
        requestAnimationFrame(function () {
            if (_this_1.opened)
                _this_1.platfromAlertsAsideEl.open(), _this_1.loadProductAlertInfo();
        });
    };
    class_11.prototype.loadProductAlertInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        this.apiClient = createClient("notifications", this.api);
                        _g = this;
                        return [4 /*yield*/, this.apiClient.getPlatformAlertProductTileAlerts(this.selectedItem.productCode)];
                    case 1:
                        _g.platformAlerts = _h.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    class_11.prototype.render = function () {
        var _this_1 = this;
        return (h(Host, null, h("omnibar-aside", { class: "o-platformalert__aside", size: "medium", onOmnibarAsideClose: function (e) { return e.target === e.currentTarget
                ? _this_1.omnibarPlatformAlertsAsideClose.emit()
                : null; }, ref: function (el) { return (_this_1.platfromAlertsAsideEl = el); } }, h("omnibar-aside-header", null, h("omnibar-aside-title", null, "Product Alerts"), h("Omnibar-aside-subtitle", null, this.selectedItem.familyName ? this.selectedItem.familyName :
            this.platformAlerts.length > 0 ? this.platformAlerts[0].name : '')), h("omnibar-aside-body", null, h("div", { class: "o-flex o-flex-wrap o-mb-3" }, h("div", { class: "o-flex-1 o-w-6/12" }, this.platformAlerts.length > 0 &&
            this.platformAlerts.map(function (item) { return (h("omnibar-product-alerts-aside-notification", { titleinfo: item.title, startDate: item.startDate, message: item.message, productName: item.name })); })))), this.screenSize !== 'xl' && (h("omnibar-aside-footer", null, h("omnibar-aside-actions", null, h("omnibar-button", { variant: "primary", class: {
                'o-w-full': this.screenSize === 'sm'
            }, onClick: function () { return _this_1.platfromAlertsAsideEl.close(); } }, "Close")))))));
    };
    Object.defineProperty(class_11, "watchers", {
        get: function () {
            return {
                "opened": ["openedChanged"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_11, "style", {
        get: function () { return "omnibar-product-alerts{display:-ms-flexbox;display:flex;width:100%;font-size:.875rem}omnibar-product-alerts .o-platformalert__aside__title{display:block;max-width:100%;overflow:hidden;vertical-align:top;cursor:pointer;text-overflow:ellipsis}omnibar-product-alerts .o-platformalert__aside__toggle-button{font-size:.75rem;color:#0076cc;cursor:pointer;position:relative;bottom:7px}omnibar-product-alerts .o-platformalert__aside__toggle-button:hover{text-decoration:underline}omnibar-product-alerts .o-platformalert__aside__bottom-line{padding-bottom:1rem;border-bottom:1px solid #ebedee}omnibar-product-alerts .o-platformalert__aside__text{cursor:pointer;margin-right:.5rem;display:inline-block}omnibar-product-alerts .o-platformalert__aside__text ol,omnibar-product-alerts .o-platformalert__aside__text ul{list-style:revert!important;margin:revert!important;padding:revert!important;padding-left:15px!important}omnibar-product-alerts .o-platformalert__aside__text.o-truncate{max-width:calc(100% - 80px)}omnibar-product-alerts .o-platformalert__aside__text.o-truncate *{all:unset;margin:0!important;padding:0!important;white-space:no-wrap!important}"; },
        enumerable: true,
        configurable: true
    });
    return class_11;
}());
ShellTunnel.injectProps(OmnibarProductAlerts, ["api", "unityUser", "screenSize"]);
var OmnibarProductAlertsAsideNotification = /** @class */ (function () {
    function OmnibarProductAlertsAsideNotification(hostRef) {
        registerInstance(this, hostRef);
    }
    OmnibarProductAlertsAsideNotification.prototype.componentDidLoad = function () {
        var _this_1 = this;
        if (this.notificationTextContentEl) {
            this.notificationTextContentEl.innerHTML = this.message;
            var count = this.getCharacterCount();
            if (this.notificationTextContentEl.innerText.length > count) {
                this.notificationTextContentEl.innerText = this.notificationTextContentEl.innerText.substr(0, count) + '...';
                this.textOverflowing = true;
            }
            var divInfo = this.notificationTextContentEl.childNodes;
            divInfo.forEach(function (item, index) {
                if (index !== 0) {
                    _this_1.textOverflowing = true;
                    item.style.display = "none";
                }
                else {
                    item.className = "o-truncate";
                    if (item.tagName === "OL" || item.tagName === "UL") {
                        item.childNodes.forEach(function (subitem, subindex) {
                            if (subindex !== 0) {
                                _this_1.textOverflowing = true;
                                subitem.style.display = "none";
                            }
                        });
                    }
                }
            });
        }
    };
    OmnibarProductAlertsAsideNotification.prototype.getCharacterCount = function () {
        var count = 0;
        if (getScreenSize() == "sm") {
            count = 55;
        }
        else if (getScreenSize() != "sm") {
            count = 65;
        }
        return count;
    };
    OmnibarProductAlertsAsideNotification.prototype.convertDate = function (date) {
        date = hooks.utc(date).toDate();
        var diffDate = hooks.duration(hooks().diff(date)).asMinutes();
        var days = hooks.duration(hooks().diff(date)).asDays();
        if (diffDate < 10) {
            return "Just now";
        }
        else if (days < 1 && diffDate >= 10 && diffDate < 15) {
            return "10 mins ago";
        }
        else if (days < 1 && diffDate >= 15 && diffDate < 20) {
            return "15 mins ago";
        }
        else if (days < 1 && diffDate >= 20 && diffDate < 30) {
            return "20 mins ago";
        }
        else if (hooks(date).format("MM-DD-YYYY") ===
            hooks().add(-1, "days").format("MM-DD-YYYY")) {
            return "Yesterday at " + hooks(date).format("hh:mm A");
        }
        else if (hooks(date).format("YYYY-MM-DD") === hooks().format("YYYY-MM-DD")) {
            return "Today at " + hooks(date).format("hh:mm A");
        }
        else {
            return hooks(date).format("MM/DD/YYYY hh:mm A");
        }
    };
    OmnibarProductAlertsAsideNotification.prototype.handleToggleButtonClick = function () {
        var _this_1 = this;
        var count = this.getCharacterCount();
        this.textExpanded = !this.textExpanded;
        var divInfo = this.notificationTextContentEl.childNodes;
        if (this.textExpanded) {
            this.notificationTextContentEl.innerHTML = this.message;
        }
        else {
            if (this.notificationTextContentEl.innerText.length > count) {
                this.notificationTextContentEl.innerText = this.notificationTextContentEl.innerText.substr(0, count) + '...';
                this.textOverflowing = true;
            }
        }
        divInfo.forEach(function (item, index) {
            if (index !== 0) {
                item.style.display = _this_1.textExpanded ? "block" : "none";
            }
            else {
                item.className = _this_1.textExpanded ? "" : "o-truncate";
                if (item.tagName === "OL" || item.tagName === "UL") {
                    item.childNodes.forEach(function (subitem, subindex) {
                        if (subindex !== 0) {
                            subitem.style.display =
                                item.className === "o-truncate" ? "none" : "list-item";
                        }
                    });
                }
            }
        });
    };
    OmnibarProductAlertsAsideNotification.prototype.render = function () {
        var _this_1 = this;
        return (h(Host, null, h("div", { class: "o-relative o-my-5 o-platformalert__aside__bottom-line" }, h("div", { class: "o-text-sm o-text-muted" }, this.productName, " | ", this.convertDate(this.startDate)), h("div", { class: {
                "o-platformalert__aside__title o-font-semibold o-my-2": true,
                "o-truncate": !this.textExpanded && this.textOverflowing,
            }, onClick: function () { return _this_1.textOverflowing ? _this_1.handleToggleButtonClick() : ""; } }, this.titleinfo), h("div", { class: {
                "o-truncate": !this.textExpanded && this.textOverflowing,
                "o-platformalert__aside__text": true,
            }, onClick: function () { return _this_1.textOverflowing ? _this_1.handleToggleButtonClick() : ""; }, ref: function (el) { return (_this_1.notificationTextContentEl = el); } }), h("div", { class: {
                "o-platformalert__aside__toggle-button": true,
                "o-mt-2": this.textExpanded,
                "o-inline-block": !this.textExpanded
            }, onClick: function () { return _this_1.textOverflowing ? _this_1.handleToggleButtonClick() : ""; } }, this.textExpanded
            ? "View Less"
            : this.textOverflowing
                ? "View More"
                : ""))));
    };
    return OmnibarProductAlertsAsideNotification;
}());
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var _listCacheClear = listCacheClear;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
    return value === other || (value !== value && other !== other);
}
var eq_1 = eq;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
        if (eq_1(array[length][0], key)) {
            return length;
        }
    }
    return -1;
}
var _assocIndexOf = assocIndexOf;
/** Used for built-in method references. */
var arrayProto = Array.prototype;
/** Built-in value references. */
var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
    var data = this.__data__, index = _assocIndexOf(data, key);
    if (index < 0) {
        return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
        data.pop();
    }
    else {
        splice.call(data, index, 1);
    }
    --this.size;
    return true;
}
var _listCacheDelete = listCacheDelete;
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
    var data = this.__data__, index = _assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
var _listCacheGet = listCacheGet;
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
    return _assocIndexOf(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas;
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
    var data = this.__data__, index = _assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([key, value]);
    }
    else {
        data[index][1] = value;
    }
    return this;
}
var _listCacheSet = listCacheSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;
var _ListCache = ListCache;
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
    this.__data__ = new _ListCache;
    this.size = 0;
}
var _stackClear = stackClear;
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var _stackDelete = stackDelete;
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
    return this.__data__.get(key);
}
var _stackGet = stackGet;
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
    return this.__data__.has(key);
}
var _stackHas = stackHas;
/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
    if (!isObject_1(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = _baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$2;
/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];
var _coreJsData = coreJsData;
/** Used to detect methods masquerading as native. */
var maskSrcKey = (function () {
    var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
    return uid ? ('Symbol(src)_1.' + uid) : '';
}());
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
    return !!maskSrcKey && (maskSrcKey in func);
}
var _isMasked = isMasked;
/** Used for built-in method references. */
var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        }
        catch (e) { }
        try {
            return (func + '');
        }
        catch (e) { }
    }
    return '';
}
var _toSource = toSource;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */
var funcProto$1 = Function.prototype, objectProto$2 = Object.prototype;
/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;
/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
    funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
        .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
    if (!isObject_1(value) || _isMasked(value)) {
        return false;
    }
    var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
    return pattern.test(_toSource(value));
}
var _baseIsNative = baseIsNative;
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
    return object == null ? undefined : object[key];
}
var _getValue = getValue;
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
    var value = _getValue(object, key);
    return _baseIsNative(value) ? value : undefined;
}
var _getNative = getNative;
/* Built-in method references that are verified to be native. */
var Map$1 = _getNative(_root, 'Map');
var _Map = Map$1;
/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');
var _nativeCreate = nativeCreate;
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
    this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
    this.size = 0;
}
var _hashClear = hashClear;
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var _hashDelete = hashDelete;
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */
var objectProto$3 = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
    var data = this.__data__;
    if (_nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}
var _hashGet = hashGet;
/** Used for built-in method references. */
var objectProto$4 = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
    var data = this.__data__;
    return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$3.call(data, key);
}
var _hashHas = hashHas;
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
    return this;
}
var _hashSet = hashSet;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;
var _Hash = Hash;
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new _Hash,
        'map': new (_Map || _ListCache),
        'string': new _Hash
    };
}
var _mapCacheClear = mapCacheClear;
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
    var type = typeof value;
    return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
}
var _isKeyable = isKeyable;
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
    var data = map.__data__;
    return _isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
}
var _getMapData = getMapData;
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
    var result = _getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var _mapCacheDelete = mapCacheDelete;
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
    return _getMapData(this, key).get(key);
}
var _mapCacheGet = mapCacheGet;
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
    return _getMapData(this, key).has(key);
}
var _mapCacheHas = mapCacheHas;
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
    var data = _getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var _mapCacheSet = mapCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;
var _MapCache = MapCache;
/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof _ListCache) {
        var pairs = data.__data__;
        if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new _MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var _stackSet = stackSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
    var data = this.__data__ = new _ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;
var _Stack = Stack;
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
            break;
        }
    }
    return array;
}
var _arrayEach = arrayEach;
var defineProperty$1 = (function () {
    try {
        var func = _getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    }
    catch (e) { }
}());
var _defineProperty = defineProperty$1;
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
    if (key == '__proto__' && _defineProperty) {
        _defineProperty(object, key, {
            'configurable': true,
            'enumerable': true,
            'value': value,
            'writable': true
        });
    }
    else {
        object[key] = value;
    }
}
var _baseAssignValue = baseAssignValue;
/** Used for built-in method references. */
var objectProto$5 = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty$4.call(object, key) && eq_1(objValue, value)) ||
        (value === undefined && !(key in object))) {
        _baseAssignValue(object, key, value);
    }
}
var _assignValue = assignValue;
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while (++index < length) {
        var key = props[index];
        var newValue = customizer
            ? customizer(object[key], source[key], key, object, source)
            : undefined;
        if (newValue === undefined) {
            newValue = source[key];
        }
        if (isNew) {
            _baseAssignValue(object, key, newValue);
        }
        else {
            _assignValue(object, key, newValue);
        }
    }
    return object;
}
var _copyObject = copyObject;
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while (++index < n) {
        result[index] = iteratee(index);
    }
    return result;
}
var _baseTimes = baseTimes;
/** `Object#toString` result references. */
var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
    return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}
var _baseIsArguments = baseIsArguments;
/** Used for built-in method references. */
var objectProto$6 = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function () { return arguments; }()) ? _baseIsArguments : function (value) {
    return isObjectLike_1(value) && hasOwnProperty$5.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
};
var isArguments_1 = isArguments;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$1 = Array.isArray;
var isArray_1 = isArray$1;
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
    return false;
}
var stubFalse_1 = stubFalse;
var isBuffer_1 = createCommonjsModule(function (module, exports) {
    /** Detect free variable `exports`. */
    var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */
    var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Built-in value references. */
    var Buffer = moduleExports ? _root.Buffer : undefined;
    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse_1;
    module.exports = isBuffer;
});
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length &&
        (type == 'number' ||
            (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}
var _isIndex = isIndex;
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
    return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}
var isLength_1 = isLength;
/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag$1 = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
    typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
        typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
            typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
                typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
    typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
        typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
            typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
                typedArrayTags[mapTag] = typedArrayTags[numberTag] =
                    typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
                        typedArrayTags[setTag] = typedArrayTags[stringTag] =
                            typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return isObjectLike_1(value) &&
        isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}
var _baseIsTypedArray = baseIsTypedArray;
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
    return function (value) {
        return func(value);
    };
}
var _baseUnary = baseUnary;
var _nodeUtil = createCommonjsModule(function (module, exports) {
    /** Detect free variable `exports`. */
    var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */
    var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */
    var freeProcess = moduleExports && _freeGlobal.process;
    /** Used to access faster Node.js helpers. */
    var nodeUtil = (function () {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) {
                return types;
            }
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        }
        catch (e) { }
    }());
    module.exports = nodeUtil;
});
/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;
var isTypedArray_1 = isTypedArray;
/** Used for built-in method references. */
var objectProto$7 = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
    var isArr = isArray_1(value), isArg = !isArr && isArguments_1(value), isBuff = !isArr && !isArg && isBuffer_1(value), isType = !isArr && !isArg && !isBuff && isTypedArray_1(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? _baseTimes(value.length, String) : [], length = result.length;
    for (var key in value) {
        if ((inherited || hasOwnProperty$6.call(value, key)) &&
            !(skipIndexes && (
            // Safari 9 has enumerable `arguments.length` in strict mode.
            key == 'length' ||
                // Node.js 0.10 has enumerable non-index properties on buffers.
                (isBuff && (key == 'offset' || key == 'parent')) ||
                // PhantomJS 2 has enumerable non-index properties on typed arrays.
                (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
                // Skip index properties.
                _isIndex(key, length)))) {
            result.push(key);
        }
    }
    return result;
}
var _arrayLikeKeys = arrayLikeKeys;
/** Used for built-in method references. */
var objectProto$8 = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
    var Ctor = value && value.constructor, proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$8;
    return value === proto;
}
var _isPrototype = isPrototype;
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
    return function (arg) {
        return func(transform(arg));
    };
}
var _overArg = overArg;
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);
var _nativeKeys = nativeKeys;
/** Used for built-in method references. */
var objectProto$9 = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
    if (!_isPrototype(object)) {
        return _nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
        if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
            result.push(key);
        }
    }
    return result;
}
var _baseKeys = baseKeys;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
    return value != null && isLength_1(value.length) && !isFunction_1(value);
}
var isArrayLike_1 = isArrayLike;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$1(object) {
    return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}
var keys_1 = keys$1;
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
    return object && _copyObject(source, keys_1(source), object);
}
var _baseAssign = baseAssign;
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
    var result = [];
    if (object != null) {
        for (var key in Object(object)) {
            result.push(key);
        }
    }
    return result;
}
var _nativeKeysIn = nativeKeysIn;
/** Used for built-in method references. */
var objectProto$a = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
    if (!isObject_1(object)) {
        return _nativeKeysIn(object);
    }
    var isProto = _isPrototype(object), result = [];
    for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty$8.call(object, key)))) {
            result.push(key);
        }
    }
    return result;
}
var _baseKeysIn = baseKeysIn;
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$1(object) {
    return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}
var keysIn_1 = keysIn$1;
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
    return object && _copyObject(source, keysIn_1(source), object);
}
var _baseAssignIn = baseAssignIn;
var _cloneBuffer = createCommonjsModule(function (module, exports) {
    /** Detect free variable `exports`. */
    var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */
    var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Built-in value references. */
    var Buffer = moduleExports ? _root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
            return buffer.slice();
        }
        var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result);
        return result;
    }
    module.exports = cloneBuffer;
});
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while (++index < length) {
        array[index] = source[index];
    }
    return array;
}
var _copyArray = copyArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
            result[resIndex++] = value;
        }
    }
    return result;
}
var _arrayFilter = arrayFilter;
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
    return [];
}
var stubArray_1 = stubArray;
/** Used for built-in method references. */
var objectProto$b = Object.prototype;
/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$b.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray_1 : function (object) {
    if (object == null) {
        return [];
    }
    object = Object(object);
    return _arrayFilter(nativeGetSymbols(object), function (symbol) {
        return propertyIsEnumerable$1.call(object, symbol);
    });
};
var _getSymbols = getSymbols;
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
    return _copyObject(source, _getSymbols(source), object);
}
var _copySymbols = copySymbols;
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while (++index < length) {
        array[offset + index] = values[index];
    }
    return array;
}
var _arrayPush = arrayPush;
/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype;
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function (object) {
    var result = [];
    while (object) {
        _arrayPush(result, _getSymbols(object));
        object = _getPrototype(object);
    }
    return result;
};
var _getSymbolsIn = getSymbolsIn;
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
    return _copyObject(source, _getSymbolsIn(source), object);
}
var _copySymbolsIn = copySymbolsIn;
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys;
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
    return _baseGetAllKeys(object, keys_1, _getSymbols);
}
var _getAllKeys = getAllKeys;
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
    return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}
var _getAllKeysIn = getAllKeysIn;
/* Built-in method references that are verified to be native. */
var DataView$1 = _getNative(_root, 'DataView');
var _DataView = DataView$1;
/* Built-in method references that are verified to be native. */
var Promise$1 = _getNative(_root, 'Promise');
var _Promise = Promise$1;
/* Built-in method references that are verified to be native. */
var Set$1 = _getNative(_root, 'Set');
var _Set = Set$1;
/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');
var _WeakMap = WeakMap;
/** `Object#toString` result references. */
var mapTag$1 = '[object Map]', objectTag$1 = '[object Object]', promiseTag = '[object Promise]', setTag$1 = '[object Set]', weakMapTag$1 = '[object WeakMap]';
var dataViewTag$1 = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView), mapCtorString = _toSource(_Map), promiseCtorString = _toSource(_Promise), setCtorString = _toSource(_Set), weakMapCtorString = _toSource(_WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$1) ||
    (_Map && getTag(new _Map) != mapTag$1) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag$1) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
    getTag = function (value) {
        var result = _baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : undefined, ctorString = Ctor ? _toSource(Ctor) : '';
        if (ctorString) {
            switch (ctorString) {
                case dataViewCtorString: return dataViewTag$1;
                case mapCtorString: return mapTag$1;
                case promiseCtorString: return promiseTag;
                case setCtorString: return setTag$1;
                case weakMapCtorString: return weakMapTag$1;
            }
        }
        return result;
    };
}
var _getTag = getTag;
/** Used for built-in method references. */
var objectProto$c = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty$9.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var _initCloneArray = initCloneArray;
/** Built-in value references. */
var Uint8Array$1 = _root.Uint8Array;
var _Uint8Array = Uint8Array$1;
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
    return result;
}
var _cloneArrayBuffer = cloneArrayBuffer;
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var _cloneDataView = cloneDataView;
/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var _cloneRegExp = cloneRegExp;
/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
var _cloneSymbol = cloneSymbol;
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var _cloneTypedArray = cloneTypedArray;
/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]', dateTag$1 = '[object Date]', mapTag$2 = '[object Map]', numberTag$1 = '[object Number]', regexpTag$1 = '[object RegExp]', setTag$2 = '[object Set]', stringTag$1 = '[object String]', symbolTag$1 = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]', dataViewTag$2 = '[object DataView]', float32Tag$1 = '[object Float32Array]', float64Tag$1 = '[object Float64Array]', int8Tag$1 = '[object Int8Array]', int16Tag$1 = '[object Int16Array]', int32Tag$1 = '[object Int32Array]', uint8Tag$1 = '[object Uint8Array]', uint8ClampedTag$1 = '[object Uint8ClampedArray]', uint16Tag$1 = '[object Uint16Array]', uint32Tag$1 = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch (tag) {
        case arrayBufferTag$1:
            return _cloneArrayBuffer(object);
        case boolTag$1:
        case dateTag$1:
            return new Ctor(+object);
        case dataViewTag$2:
            return _cloneDataView(object, isDeep);
        case float32Tag$1:
        case float64Tag$1:
        case int8Tag$1:
        case int16Tag$1:
        case int32Tag$1:
        case uint8Tag$1:
        case uint8ClampedTag$1:
        case uint16Tag$1:
        case uint32Tag$1:
            return _cloneTypedArray(object, isDeep);
        case mapTag$2:
            return new Ctor;
        case numberTag$1:
        case stringTag$1:
            return new Ctor(object);
        case regexpTag$1:
            return _cloneRegExp(object);
        case setTag$2:
            return new Ctor;
        case symbolTag$1:
            return _cloneSymbol(object);
    }
}
var _initCloneByTag = initCloneByTag;
/** Built-in value references. */
var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function () {
    function object() { }
    return function (proto) {
        if (!isObject_1(proto)) {
            return {};
        }
        if (objectCreate) {
            return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}());
var _baseCreate = baseCreate;
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
    return (typeof object.constructor == 'function' && !_isPrototype(object))
        ? _baseCreate(_getPrototype(object))
        : {};
}
var _initCloneObject = initCloneObject;
/** `Object#toString` result references. */
var mapTag$3 = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
    return isObjectLike_1(value) && _getTag(value) == mapTag$3;
}
var _baseIsMap = baseIsMap;
/* Node.js helper references. */
var nodeIsMap = _nodeUtil && _nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;
var isMap_1 = isMap;
/** `Object#toString` result references. */
var setTag$3 = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
    return isObjectLike_1(value) && _getTag(value) == setTag$3;
}
var _baseIsSet = baseIsSet;
/* Node.js helper references. */
var nodeIsSet = _nodeUtil && _nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;
var isSet_1 = isSet;
/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]', arrayTag$1 = '[object Array]', boolTag$2 = '[object Boolean]', dateTag$2 = '[object Date]', errorTag$1 = '[object Error]', funcTag$2 = '[object Function]', genTag$1 = '[object GeneratorFunction]', mapTag$4 = '[object Map]', numberTag$2 = '[object Number]', objectTag$2 = '[object Object]', regexpTag$2 = '[object RegExp]', setTag$4 = '[object Set]', stringTag$2 = '[object String]', symbolTag$2 = '[object Symbol]', weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]', dataViewTag$3 = '[object DataView]', float32Tag$2 = '[object Float32Array]', float64Tag$2 = '[object Float64Array]', int8Tag$2 = '[object Int8Array]', int16Tag$2 = '[object Int16Array]', int32Tag$2 = '[object Int32Array]', uint8Tag$2 = '[object Uint8Array]', uint8ClampedTag$2 = '[object Uint8ClampedArray]', uint16Tag$2 = '[object Uint16Array]', uint32Tag$2 = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$2] = cloneableTags[arrayTag$1] =
    cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] =
        cloneableTags[boolTag$2] = cloneableTags[dateTag$2] =
            cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] =
                cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] =
                    cloneableTags[int32Tag$2] = cloneableTags[mapTag$4] =
                        cloneableTags[numberTag$2] = cloneableTags[objectTag$2] =
                            cloneableTags[regexpTag$2] = cloneableTags[setTag$4] =
                                cloneableTags[stringTag$2] = cloneableTags[symbolTag$2] =
                                    cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] =
                                        cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag$2] =
    cloneableTags[weakMapTag$2] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
    }
    if (result !== undefined) {
        return result;
    }
    if (!isObject_1(value)) {
        return value;
    }
    var isArr = isArray_1(value);
    if (isArr) {
        result = _initCloneArray(value);
        if (!isDeep) {
            return _copyArray(value, result);
        }
    }
    else {
        var tag = _getTag(value), isFunc = tag == funcTag$2 || tag == genTag$1;
        if (isBuffer_1(value)) {
            return _cloneBuffer(value, isDeep);
        }
        if (tag == objectTag$2 || tag == argsTag$2 || (isFunc && !object)) {
            result = (isFlat || isFunc) ? {} : _initCloneObject(value);
            if (!isDeep) {
                return isFlat
                    ? _copySymbolsIn(value, _baseAssignIn(result, value))
                    : _copySymbols(value, _baseAssign(result, value));
            }
        }
        else {
            if (!cloneableTags[tag]) {
                return object ? value : {};
            }
            result = _initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new _Stack);
    var stacked = stack.get(value);
    if (stacked) {
        return stacked;
    }
    stack.set(value, result);
    if (isSet_1(value)) {
        value.forEach(function (subValue) {
            result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
    }
    else if (isMap_1(value)) {
        value.forEach(function (subValue, key) {
            result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
    }
    var keysFunc = isFull
        ? (isFlat ? _getAllKeysIn : _getAllKeys)
        : (isFlat ? keysIn : keys_1);
    var props = isArr ? undefined : keysFunc(value);
    _arrayEach(props || value, function (subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var _baseClone = baseClone;
/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1, CLONE_SYMBOLS_FLAG$1 = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
    return _baseClone(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}
var cloneDeep_1 = cloneDeep;
var OmnibarScope = /** @class */ (function () {
    function class_12(hostRef) {
        var _this_1 = this;
        registerInstance(this, hostRef);
        this.applyClicked = false;
        this.previousValue = null;
        this.draftValue = null;
        this.clickableOpen = false;
        this.selector = false;
        this.advancedSelections = false;
        this.multiple = false;
        this.items = [];
        this.searchable = false;
        this.value = this.multiple ? [] : '';
        this.handleApply = function () {
            _this_1.applyClicked = true;
            _this_1.close();
        };
        this.handleAdvancedSelections = function () {
            _this_1.scopeAdvancedSelect.emit({
                selectedItems: _this_1.selectedOptions(),
                value: _this_1.value
            });
        };
        this.trackClickEvent = createEvent(this, "trackClickEvent", 7);
        this.scopeChange = createEvent(this, "scopeChange", 7);
        this.scopeAdvancedSelect = createEvent(this, "scopeAdvancedSelect", 7);
        this.scopeClick = createEvent(this, "scopeClick", 7);
    }
    class_12.prototype.itemsChanged = function () {
        this.value = null;
        this.computeValueFromOptions();
        this.draftValue = this.previousValue = this.multiple ? __spreadArrays(this.value) : this.value;
    };
    class_12.prototype.selectedItemsChanged = function (newVal) {
        this.selected = newVal;
    };
    class_12.prototype.unityCompanyChanged = function () {
        this.base = this.unityCompany;
    };
    class_12.prototype.componentWillLoad = function () {
        if (this.items && this.items.length) {
            this.computeValueFromOptions();
            this.draftValue = this.previousValue = this.multiple ? __spreadArrays(this.value) : this.value;
        }
        if (this.selectedItem)
            this.selected = this.selectedItem;
    };
    class_12.prototype.open = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                if (this.selectEl)
                    this.selectEl.open();
                if (this.clickable)
                    this.clickableOpen = true;
                return [2 /*return*/];
            });
        });
    };
    class_12.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                if (this.selectEl)
                    this.selectEl.close();
                if (this.clickable)
                    this.clickableOpen = false;
                return [2 /*return*/];
            });
        });
    };
    class_12.prototype.undo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.value = __spreadArrays(this.previousValue);
                return [2 /*return*/];
            });
        });
    };
    class_12.prototype.handleScopeClick = function () {
        if (!this.clickableOpen)
            this.clickableOpen = !this.clickableOpen;
        this.scopeClick.emit();
    };
    class_12.prototype.selectItems = function () {
        var _this_1 = this;
        return cloneDeep_1(this.items).reduce(function (items, item) {
            if (!item.id) {
                item.id = item.value;
            }
            if (item.items && item.items.length) {
                if (!_this_1.multiple) {
                    item.variant = 'heading';
                }
                item.items.forEach(function (subItem) {
                    if (!subItem.id) {
                        subItem.id = subItem.value;
                        subItem.variant = 'sub-option';
                    }
                });
            }
            items.push(item);
            if (item.items && item.items.length) {
                if (_this_1.multiple) {
                    item.options = __spreadArrays(item.items);
                }
                else {
                    item.items.forEach(function (subItem) {
                        items.push(subItem);
                    });
                }
                delete item.items;
            }
            return items;
        }, []);
    };
    class_12.prototype.options = function () {
        return this.selectItems().reduce(function (acc, cv) {
            if (cv.options && cv.options.length) {
                cv.options.forEach(function (option) { return acc.push(option); });
            }
            else {
                acc.push(cv);
            }
            return acc;
        }, []);
    };
    class_12.prototype.selectedOptions = function () {
        var _this_1 = this;
        var isSelected = function (optionValue) {
            return _this_1.multiple ? _this_1.value.includes(optionValue) : _this_1.value === optionValue;
        };
        return this.options().filter(function (option) { return isSelected(option.value); });
    };
    class_12.prototype.selectedItemsText = function () {
        return this.selectedOptions().length > 1
            ? 'Multiple items selected'
            : this.selectedOptions().map(function (option) { return option.text; }).join(', ');
    };
    class_12.prototype.computeValueFromOptions = function () {
        if (!this.value || !(this.value && this.value.length)) {
            if (this.multiple) {
                this.value = this.options()
                    .filter(function (option) { return option.selected; })
                    .map(function (option) { return option.value; });
            }
            else {
                var selectedOption = this.options().find(function (option) { return option.selected; });
                this.value = selectedOption ? selectedOption.value : '';
            }
        }
    };
    class_12.prototype.setSelectOptionsMaxHeight = function () {
        var _this_1 = this;
        var selectMenuHeaderEl = this.el.querySelector('.o-select__menu__header');
        var selectMenuFooterEl = this.el.querySelector('.o-select__menu__footer');
        setTimeout(function () {
            var selectMenuHeaderHeight = selectMenuHeaderEl ? selectMenuHeaderEl.offsetHeight : 0;
            var selectMenuFooterHeight = selectMenuFooterEl ? selectMenuFooterEl.offsetHeight : 0;
            _this_1.selectOptionsMaxHeight = "calc(100vh - " + (selectMenuHeaderHeight + selectMenuFooterHeight) + "px)";
        }, 100);
    };
    class_12.prototype.handleSelectOpen = function () {
        this.setSelectOptionsMaxHeight();
        this.trackClickEvent.emit({ button_name: 'Property Picker' });
    };
    class_12.prototype.handleSelectClose = function () {
        if (this.applyClicked) {
            this.previousValue = __spreadArrays(this.value);
            this.value = __spreadArrays(this.draftValue);
            this.applyClicked = false;
            this.scopeChange.emit({
                selectedItems: this.selectedOptions(),
                value: this.value
            });
        }
        else {
            if (this.multiple) {
                this.draftValue = __spreadArrays(this.value);
                this.value = __spreadArrays(this.value);
            }
        }
    };
    class_12.prototype.handleSelectChange = function (e) {
        if (this.multiple) {
            this.draftValue = e.detail.value;
        }
        else {
            this.previousValue = __spreadArrays(this.value);
        }
        this.value = e.detail.value;
        this.scopeChange.emit({
            selectedItems: this.selectedOptions(),
            value: this.value
        });
    };
    class_12.prototype.render = function () {
        var _this_1 = this;
        var renderProduct = function () {
            if (_this_1.product) {
                return (h("div", { class: "o-scope__product" }, _this_1.product));
            }
        };
        var renderBase = function () {
            if (_this_1.base) {
                var company = _this_1.productCode === 'ACCT' ? "" : _this_1.base;
                if (_this_1.productCode === 'ACCT') {
                    return (h("div", { class: "o-scope__base", title: company }, "\u00A0"));
                }
                else {
                    return (h("div", { class: "o-scope__base", title: company }, company));
                }
            }
        };
        var renderSelected = function (selected) {
            if (selected && _this_1.productCode !== 'ACCT') {
                return (h("div", { class: "o-scope__selected" }, h("span", { class: "o-scope__divider" }, "|"), h("span", { title: selected }, selected)));
            }
        };
        var renderStaticScope = function () {
            var Tag = _this_1.clickable ? 'button' : 'div';
            return (h(Tag, { class: {
                    'o-scope': true,
                    'o-scope--clickable': _this_1.clickable,
                    'o-scope--open': _this_1.clickableOpen
                }, type: _this_1.clickable && 'button', onClick: _this_1.clickable ? function () { return _this_1.handleScopeClick(); } : null }, renderProduct(), (_this_1.base || _this_1.selected) &&
                h("div", { class: "o-scope__subtitle" }, renderBase(), renderSelected(_this_1.selected)), _this_1.clickable &&
                h("omnibar-icon", { icon: "arrow-down-v", class: "o-scope__arrow" })));
        };
        var renderAdvancedSelectionsButton = function () {
            if (_this_1.advancedSelections) {
                return (h("button", { type: "button", class: "o-scope__button o-scope__button--advanced-selections", slot: "select-menu-footer", onClick: function () { return _this_1.handleAdvancedSelections(); } }, "Advanced Selections"));
            }
        };
        var renderApplyButton = function () {
            if (_this_1.multiple) {
                return (h("button", { type: "button", class: "o-scope__button o-scope__button--apply", slot: "select-menu-footer", onClick: function () { return _this_1.handleApply(); } }, "Apply"));
            }
        };
        var renderScopeSelector = function () {
            return (h("omnibar-select", { multiple: _this_1.multiple, searchable: _this_1.searchable, optionsMaxHeight: _this_1.selectOptionsMaxHeight, options: _this_1.selectItems(), menuPlacement: "bottom-start", value: _this_1.value, onOmnibarSelectOpen: function () { return _this_1.handleSelectOpen(); }, onOmnibarSelectClose: function () { return _this_1.handleSelectClose(); }, onOmnibarChange: function (e) { return _this_1.handleSelectChange(e); }, ref: function (el) { return _this_1.selectEl = el; } }, h("div", { class: "o-scope o-scope--selector", slot: "select-toggle", onClick: function () { return _this_1.scopeClick.emit(); } }, renderProduct(), (_this_1.base || _this_1.selected) &&
                h("div", { class: "o-scope__subtitle" }, renderBase(), renderSelected(_this_1.selectedItemsText())), h("omnibar-icon", { icon: "arrow-down-v", class: "o-scope__arrow" })), h("div", { class: "o-scope--selector__mobile-label", slot: "select-mobile-label" }, h("div", { class: "o-overflow-hidden" }, h("div", { class: "o-scope--selector__mobile-label__title" }, _this_1.product), (_this_1.base || _this_1.selected) &&
                h("div", { class: "o-scope--selector__mobile-label__description" }, _this_1.base && _this_1.base + " |", " ", _this_1.selectedItemsText())), h("omnibar-icon", { icon: "close", class: "o-scope--selector__mobile-label__close", onClick: function () { return _this_1.close(); } })), renderAdvancedSelectionsButton(), renderApplyButton()));
        };
        if (!this.selector) {
            return renderStaticScope();
        }
        else {
            return renderScopeSelector();
        }
    };
    Object.defineProperty(class_12.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_12, "watchers", {
        get: function () {
            return {
                "items": ["itemsChanged"],
                "selectedItem": ["selectedItemsChanged"],
                "unityCompany": ["unityCompanyChanged"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_12, "style", {
        get: function () { return ".o-omnibar omnibar-scope{overflow:hidden;-ms-flex-preferred-size:1;flex-basis:1;min-width:0}\@media (min-width:640px){.o-omnibar omnibar-scope{overflow:visible}}.o-omnibar omnibar-scope .o-scope{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;padding-left:.5rem;padding-right:.5rem;color:#fff;min-width:0;position:relative;height:56px;overflow:hidden}.o-omnibar omnibar-scope .o-scope[type=button]{outline:0}.o-omnibar omnibar-scope .o-scope--selector{cursor:pointer;padding-right:2.5rem;padding-left:1rem}.o-omnibar omnibar-scope .o-scope--selector:hover{background-color:rgba(0,0,0,.2)}.o-omnibar omnibar-scope .o-scope--selector__mobile-label{-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;background-color:#0076cc;display:-ms-flexbox;display:flex;font-size:1rem;padding-left:1rem;padding-right:1rem;height:56px}.o-omnibar omnibar-scope .o-scope--selector__mobile-label__description,.o-omnibar omnibar-scope .o-scope--selector__mobile-label__title{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.o-omnibar omnibar-scope .o-scope--selector__mobile-label__description{font-size:.75rem;color:#c6ccd0}.o-omnibar omnibar-scope .o-scope__product,.o-omnibar omnibar-scope .o-scope__subtitle{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.o-omnibar omnibar-scope .o-scope__product{font-size:1rem;text-align:left}.o-omnibar omnibar-scope .o-scope__subtitle{display:-ms-flexbox;display:flex;font-size:.75rem;color:#9ba3a7;max-width:100%}\@media (max-width:768px){.o-omnibar omnibar-scope .o-scope__subtitle{color:#e5f4ff;max-width:100%}}.o-omnibar omnibar-scope .o-scope__arrow,.o-omnibar omnibar-scope .o-scope__close{font-size:.75rem;position:absolute;right:12px;top:50%;-webkit-transform:translateY(-50%) rotate(0);transform:translateY(-50%) rotate(0);-webkit-transition:-webkit-transform .35s;transition:-webkit-transform .35s;transition:transform .35s;transition:transform .35s,-webkit-transform .35s}.o-omnibar omnibar-scope .o-scope__base,.o-omnibar omnibar-scope .o-scope__selected{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.o-omnibar omnibar-scope .o-scope__divider{margin:0 .25rem}.o-omnibar omnibar-scope .o-scope__button{width:100%;min-height:2.5rem}.o-omnibar omnibar-scope .o-scope__button--apply{font-size:.875rem;text-align:center;cursor:pointer;background-color:#fff;border:1px solid #0076cc;color:#0076cc;padding:.3125rem}.o-omnibar omnibar-scope .o-scope__button--advanced-selections{font-size:.75rem;padding-left:1rem;padding-right:1rem;padding-top:.5rem;padding-bottom:.5rem;cursor:pointer;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:justify;justify-content:space-between;white-space:nowrap;background-color:#fff;border:1px solid #e4e6e7;border-bottom:none;color:#0076cc;line-height:.625rem;margin-top:-1px}.o-omnibar omnibar-scope .o-scope--clickable{cursor:pointer;padding-left:1rem;padding-right:1rem;padding-right:2.5rem}.o-omnibar omnibar-scope .o-scope--clickable:focus,.o-omnibar omnibar-scope .o-scope--clickable:hover{background-color:rgba(0,0,0,.2)}.o-omnibar omnibar-scope .o-scope--clickable:focus{outline:0}.o-omnibar omnibar-scope .o-scope--clickable.o-scope--open{background-color:#0076cc}.o-omnibar omnibar-scope .o-scope--clickable.o-scope--open .o-scope__subtitle{color:#e5f4ff}.o-omnibar omnibar-scope .o-scope--clickable.o-scope--open .o-scope__arrow{-webkit-transform:translateY(-50%) rotate(180deg);transform:translateY(-50%) rotate(180deg)}.o-omnibar omnibar-scope omnibar-select{min-width:0}\@media (max-width:screen(sm)){.o-omnibar omnibar-scope omnibar-select{width:100%}}.o-omnibar omnibar-scope omnibar-select .o-select{height:100%}\@media (max-width:screen(sm)){.o-omnibar omnibar-scope omnibar-select .o-select{height:auto}}.o-omnibar omnibar-scope omnibar-select .o-select .o-select__toggle{margin:0;width:100%;background-color:#37474f}.o-omnibar omnibar-scope omnibar-select .o-select .o-select__toggle .o-scope{width:100%}.o-omnibar omnibar-scope omnibar-select .o-select .o-select__toggle:focus{outline:0;background-color:#28343b}.o-omnibar omnibar-scope omnibar-select .o-select .o-select__menu{margin-top:0;min-width:15.625rem;max-height:none}.o-omnibar omnibar-scope omnibar-select .o-select .o-select__menu__content{max-height:440px}.o-omnibar omnibar-scope omnibar-select .o-select--opened{z-index:100}.o-omnibar omnibar-scope omnibar-select .o-select--opened .o-scope{background-color:#0076cc}.o-omnibar omnibar-scope omnibar-select .o-select--opened .o-scope__subtitle{color:#e5f4ff}.o-omnibar omnibar-scope omnibar-select .o-select--opened .o-scope__arrow{-webkit-transform:translateY(-50%) rotate(180deg);transform:translateY(-50%) rotate(180deg)}.o-omnibar omnibar-scope omnibar-select .o-option--group,.o-omnibar omnibar-scope omnibar-select .o-option--heading{background-color:#f7f8f9}"; },
        enumerable: true,
        configurable: true
    });
    return class_12;
}());
ShellTunnel.injectProps(OmnibarScope, ['screenSize', 'unityCompany', 'productCode']);
var OmnibarSearch = /** @class */ (function () {
    function class_13(hostRef) {
        registerInstance(this, hostRef);
        this.active = false;
        this.showDropdown = false;
        this.placeholder = "Search";
        this.inline = true;
        this.searchAsYouType = false;
        this.searchFocus = createEvent(this, "searchFocus", 7);
        this.searchBlur = createEvent(this, "searchBlur", 7);
        this.searchQuery = createEvent(this, "searchQuery", 7);
        this.searchSubmit = createEvent(this, "searchSubmit", 7);
        this.searchClose = createEvent(this, "searchClose", 7);
    }
    // FOR FUTURE USE
    // @Listen('click', { target: 'window' })
    // @Listen('focusin', { target: 'window' })
    // handleClickAndFocusOutisde(e) {
    //   if (this.active && !this.el.contains(e.target)) {
    //     this.active = false
    //     // this.showDropdown = false
    //     // this.searchClose.emit({ target: this.input })
    //   }
    // }
    class_13.prototype.toggleResultPanel = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.toggle();
                return [2 /*return*/];
            });
        });
    };
    class_13.prototype.toggleSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.toggle();
                return [2 /*return*/];
            });
        });
    };
    class_13.prototype.toggle = function () {
        this.active = !this.active;
        // FOR FUTURE USE
        // this.showDropdown = this.active && !this.showDropdown
        // if (!this.active) this.searchClose.emit({ target: this.input })
    };
    class_13.prototype.focus = function () {
        var _this_1 = this;
        setTimeout(function () { return _this_1.input.focus(); }, 50);
        this.active = true;
        // FOR FUTURE USE
        // this.searchFocus.emit({ target: this.input })
    };
    // handleFocus(e) {
    class_13.prototype.handleFocus = function () {
        this.active = true;
        // FOR FUTURE USE
        // const target = e.target as HTMLInputElement
        // this.searchFocus.emit({ target })
    };
    // handleBlur(e) {
    class_13.prototype.handleBlur = function () {
        if (['lg', 'xl'].includes(this.screenSize))
            this.active = false;
        // FOR FUTURE USE
        // const target = e.target as HTMLInputElement
        // this.searchBlur.emit({ target })
    };
    class_13.prototype.handleInput = function (e) {
        // FOR FUTURE USE
        // const target = e.target as HTMLInputElement
        // this.showDropdown = this.searchAsYouType && !!e.target.value.length
        if (this.searchAsYouType) {
            this.searchQuery.emit(e.target.value);
        }
    };
    class_13.prototype.focusFirstChild = function (container) {
        var firstFocusableChild = container.querySelector([
            'a:not([disabled]):not([tabindex="-1"])',
            'button:not([disabled]):not([tabindex="-1"])',
            'input:not([disabled]):not([tabindex="-1"])',
            'select:not([disabled]):not([tabindex="-1"])',
            '[tabindex]:not([disabled]):not([tabindex="-1"])'
        ].join(','));
        firstFocusableChild.focus();
    };
    class_13.prototype.handleInputKeyDown = function (e) {
        e.stopPropagation();
        // const target = e.target as HTMLInputElement
        if (this.searchAsYouType) {
            // FOR FUTURE USE
            // if (['Enter', 'ArrowDown', 'Down'].includes(e.key)) {
            //   this.focusFirstChild(this.dropdown)
            // }
            this.searchQuery.emit(e.target.value);
        }
        else {
            if (e.key === 'Enter') {
                if (this.input.value) {
                    this.searchSubmit.emit(this.input.value);
                    this.input.blur();
                    // FOR FUTURE USE
                    // this.showDropdown = true
                }
            }
            // FOR FUTURE USE
            // if (['ArrowDown', 'Down'].includes(e.key) && this.showDropdown) {
            //   this.focusFirstChild(this.dropdown)
            //   this.searchBlur.emit({ target })
            // }
        }
        if (['sm', 'md'].includes(this.screenSize) && ['Esc', 'Escape'].includes(e.key)) {
            this.active = false;
            this.searchIcon.focus();
            // FOR FUTURE USE
            // this.showDropdown = false
            // this.searchClose.emit({ target: this.input })
        }
    };
    class_13.prototype.handleDropdownKeyDown = function (e) {
        if (e.key == 'Esc' || e.key == 'Escape') {
            e.stopPropagation();
            this.input.focus();
        }
    };
    class_13.prototype.render = function () {
        var _this_1 = this;
        var renderSearchIcon = function () {
            switch (_this_1.screenSize) {
                case 'sm':
                case 'md':
                    return (h("omnibar-icon", { class: "o-search__icon-search mobile", role: "button", "aria-label": "search", tabIndex: _this_1.active ? -1 : 0, onClick: function () { _this_1.focus(); }, onKeyPress: function (e) {
                            if (e.key == 'Enter')
                                _this_1.focus();
                        }, icon: "search", ref: function (el) { return _this_1.searchIcon = el; } }));
                case 'lg':
                case 'xl':
                    return (h("omnibar-icon", { class: "o-search__icon-search", onClick: function () {
                            if (_this_1.input.value == '') {
                                _this_1.focus();
                            }
                            else {
                                _this_1.searchSubmit.emit(_this_1.input.value);
                            }
                        }, icon: "search", ref: function (el) { return _this_1.searchIcon = el; } }));
            }
        };
        return (h("div", { class: {
                'o-search': true,
                'o-search--active': this.active,
                'o-search--inline': this.inline
            } }, h("input", { ref: function (el) { return _this_1.input = el; }, type: "search", placeholder: this.placeholder, onFocus: function () { return _this_1.handleFocus(); }, onBlur: function () { return _this_1.handleBlur(); }, onInput: function (e) { return _this_1.handleInput(e); }, onKeyDown: function (e) { return _this_1.handleInputKeyDown(e); }, onKeyPress: function (e) {
                if (e.key == 'Enter')
                    _this_1.focus();
            } }), renderSearchIcon(), h("omnibar-icon", { class: "o-search__icon-close", onClick: function () { return _this_1.toggle(); }, icon: "close" })));
    };
    Object.defineProperty(class_13.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_13, "style", {
        get: function () { return ".o-omnibar .o-search{height:100%;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 13px}\@media (max-width:1200px){.o-omnibar .o-search{padding:0 20px}.o-omnibar .o-search input{display:none}.o-omnibar .o-search .o-search__icon-search{color:#fff!important;right:10px!important;top:17px}.o-omnibar .o-search .o-search__icon-close{display:none;cursor:pointer}.o-omnibar .o-search.o-search--active{z-index:2000;position:absolute;right:0;width:100vw;max-width:100vw;min-width:100vw;-webkit-transition:all .3s ease;transition:all .3s ease;height:56px;padding:0 13px}.o-omnibar .o-search.o-search--active input{display:block;width:100%;z-index:100}.o-omnibar .o-search.o-search--active .o-search__icon-search{z-index:200;color:#afb3b6!important;right:55px!important}.o-omnibar .o-search.o-search--active .o-search__icon-close{display:block;padding-left:15px}.o-omnibar .o-search.o-search--active .o-search__dropdown--show{position:fixed;top:56px;left:0;right:0;bottom:0;overflow-y:scroll}.o-search-inline .o-omnibar .o-search.o-search--active .o-search__dropdown--show{display:block}.o-omnibar .o-search:focus-within{background-color:#2c393e}.o-omnibar .o-search omnibar-icon:focus{outline:none}}.o-omnibar .o-search.o-search--active{background:#0076cc}.o-omnibar .o-search.o-search--active.o-search--inline .o-search__dropdown--show{display:block}.o-omnibar .o-search input{font-size:1rem;color:#37474f;outline:0;border-width:1px;border-style:solid;border-color:transparent;border-radius:9999px;min-width:200px;padding:6px 30px 6px 15px}\@media (min-width:1024px){.o-omnibar .o-search input{font-size:.875rem}}.o-omnibar .o-search input[type=search]::-ms-clear,.o-omnibar .o-search input[type=search]::-ms-reveal{display:none;width:0;height:0}.o-omnibar .o-search input[type=search]::-webkit-search-cancel-button,.o-omnibar .o-search input[type=search]::-webkit-search-decoration,.o-omnibar .o-search input[type=search]::-webkit-search-results-button,.o-omnibar .o-search input[type=search]::-webkit-search-results-decoration{display:none}.o-omnibar .o-search .o-search__icon-search{position:absolute;cursor:pointer;font-size:1.25rem;top:18px;right:25px;color:#afb3b6}.o-omnibar .o-search .o-search__icon-close{display:none}.o-omnibar .o-search .o-search__dropdown{display:none;position:absolute;min-width:100%;background-color:#fff;color:#37474f;top:56px;left:0;z-index:2147483647}.o-omnibar .o-search .o-search__dropdown:not(:empty){-webkit-box-shadow:0 2px 5px 2px rgba(0,0,0,.2);box-shadow:0 2px 5px 2px rgba(0,0,0,.2)}"; },
        enumerable: true,
        configurable: true
    });
    return class_13;
}());
ShellTunnel.injectProps(OmnibarSearch, ['screenSize']);
function randomUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
var OmnibarSelect = /** @class */ (function () {
    function class_14(hostRef) {
        registerInstance(this, hostRef);
        this.processedOptions = [];
        this.popper = null;
        this.opened = false;
        this.expanded = false;
        this.searchQuery = '';
        this.isNoScroll = false;
        /**
         * If `true`, the user cannot interact with the select.
         */
        this.disabled = false;
        /**
         * If `true`, allows multiple selections.
         */
        this.multiple = false;
        /**
         * The name of the control, which is submitted with the form data.
         */
        this.name = "select-" + randomUID();
        /**
         * The text label.
         */
        this.label = null;
        /**
         * The text to display when the select value is empty.
         */
        this.placeholder = 'Select an option';
        /**
         * If `true`, adds a search field at the top of the select menu.
         */
        this.searchable = false;
        /**
         * If `true`, removes select toggle border.
         */
        this.borderless = false;
        /**
         * Options and groups of the select.
         */
        this.options = [];
        /**
         * Options menu's placement.
         */
        this.menuPlacement = 'bottom-start';
        /**
         * If `true` the menu position will be 'fixed'.
         */
        this.menuPositionFixed = false;
        /**
         * The look of the select field.
         */
        this.variant = 'select';
        /**
         * If `true` loading overlay will be appended to select dropdown menu.
         */
        this.loading = false;
        /**
         * No options message.
         */
        this.noOptionsMessage = 'No results found';
        /**
         * If `true` `noOptionsMessage` will be appended to select dropdown menu.
         */
        this.showNoOptionsMessage = false;
        this.omnibarSelectOpen = createEvent(this, "omnibarSelectOpen", 7);
        this.omnibarSelectClose = createEvent(this, "omnibarSelectClose", 7);
        this.omnibarChange = createEvent(this, "omnibarChange", 7);
    }
    class_14.prototype.optionsChanged = function () {
        this.selectAllId = "option-" + randomUID();
        this.processOptions();
    };
    class_14.prototype.valueChanged = function () {
        this.validateValue();
    };
    class_14.prototype.multipleChanged = function () {
        if (!this.value)
            this.setInitialValue();
    };
    class_14.prototype.componentWillLoad = function () {
        this.setInitialValue();
        this.processOptions();
        this.validateValue();
        this.handleDebouncedResize = debounce_1(this.handleDebouncedResize, 200);
    };
    class_14.prototype.componentDidLoad = function () {
        this.isNoScroll = document.body.classList.contains('no-scroll');
    };
    class_14.prototype.handleKeyDown = function (e) {
        if (NAVIGATION_KEYS.includes(e.key)) {
            e.preventDefault();
            this.opened ? this.focusOption(e.key) : this.open();
        }
        else if (ESCAPE_KEY.includes(e.key)) {
            this.close();
        }
    };
    class_14.prototype.handleClickAndFocusOutside = function (e) {
        if (this.opened && !this.selectEl.contains(e.target)) {
            this.close();
        }
    };
    class_14.prototype.handleDebouncedResize = function () {
        if (this.opened) {
            isScreen('sm') ? this.createPopper() : this.destroyPopper();
        }
    };
    /**
     * Open the select menu.
     */
    class_14.prototype.open = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_g) {
                this.opened = true;
                setTimeout(function () {
                    _this_1.expanded = true;
                    if (isScreen('sm')) {
                        _this_1.createPopper();
                    }
                    if (_this_1.searchable) {
                        _this_1.clearSearch();
                    }
                    _this_1.omnibarSelectOpen.emit({ value: _this_1.value });
                    _this_1.isNoScroll = document.body.classList.contains('no-scroll');
                    if (getScreenSize() == 'sm' && !_this_1.isNoScroll)
                        document.body.classList.add('no-scroll');
                }, 100);
                return [2 /*return*/];
            });
        });
    };
    /**
     * Close the select menu.
     */
    class_14.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            var transitionDuration;
            var _this_1 = this;
            return __generator(this, function (_g) {
                transitionDuration = parseFloat(window.getComputedStyle(this.selectMenuEl).transitionDuration) * 1000;
                this.expanded = false;
                setTimeout(function () {
                    _this_1.destroyPopper();
                    _this_1.opened = false;
                    _this_1.omnibarSelectClose.emit({ value: _this_1.value });
                }, transitionDuration);
                if (getScreenSize() == 'sm' && !this.isNoScroll)
                    document.body.classList.remove('no-scroll');
                return [2 /*return*/];
            });
        });
    };
    /**
     * Toggle the select menu.
     */
    class_14.prototype.toggle = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.opened ? this.close() : this.open();
                return [2 /*return*/];
            });
        });
    };
    class_14.prototype.hasSlot = function (slotName) {
        return !!this.el.querySelector("[slot=" + slotName + "]");
    };
    /**
     * Reduces the meta object to a string of key/value pairs, delimited by META_ITEM_DELIMITER.
     */
    class_14.prototype.metaAsString = function (meta) {
        return Object.keys(meta).reduce(function (accumulator, key) {
            accumulator.push(key + ":" + meta[key]);
            return accumulator;
        }, []).join(OmnibarSelect.META_ITEM_DELIMITER);
    };
    /**
     * Search is matched aginst option text unless a meta search indicator is entered at the
     * start of search. An example: if the meta indicator is a colon (:) then the following
     * search ":123" would only search the meta instead of text.
     *
     * The meta is added as key value pairs (object) and is then transformed into a string
     * that looks like the following "someKey:value|someOtherKey:anotherValue" (the delimiter
     * in this case is a pipe). This can allow the RealPage user to search by value, by key, or by both.
     * This allows for more precise searches.
     */
    class_14.prototype.matchSearchQuery = function (option) {
        var _a;
        var text = option.text.toLowerCase();
        var description = (_a = option.description) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        var isMetaSearchOnly = this.searchQuery.startsWith(OmnibarSelect.META_INDICATOR);
        var textMatches = text.indexOf(this.searchQuery) !== -1;
        var descriptionMatches = option.description ? description.indexOf(this.searchQuery) !== -1 : false;
        var metaMatches = false;
        // If searching only in meta, then the text field is no longer matched
        if (option.meta && isMetaSearchOnly) {
            var searchQueryWithoutMetaPrefix = this.searchQuery.substr(1);
            var meta = this.metaAsString(option.meta).toLowerCase();
            metaMatches = meta.indexOf(searchQueryWithoutMetaPrefix) !== -1;
            textMatches = false;
            descriptionMatches = false;
        }
        return textMatches || descriptionMatches || metaMatches;
    };
    class_14.prototype.visibleOptionsAndGroups = function () {
        var _this_1 = this;
        return this.processedOptions.filter(function (option) {
            if (option.options && option.options.length) {
                var someOptionsVisible = option.options.some(function (option) { return _this_1.matchSearchQuery(option); });
                return _this_1.matchSearchQuery(option) || someOptionsVisible;
            }
            else {
                return _this_1.matchSearchQuery(option);
            }
        });
    };
    class_14.prototype.optionsWithoutGroups = function () {
        return this.processedOptions.reduce(function (acc, cv) {
            if (cv.options && cv.options.length) {
                cv.options.forEach(function (option) { return acc.push(option); });
            }
            else {
                acc.push(cv);
            }
            return acc;
        }, []);
    };
    class_14.prototype.focusableOptionsAndGroups = function () {
        var _this_1 = this;
        var flattenedVisibleOptionsAndGroups = this.visibleOptionsAndGroups().reduce(function (acc, cv) {
            if (!cv.disabled) {
                acc.push(cv);
                if (cv.options && cv.options.length) {
                    cv.options.forEach(function (option) {
                        if (!option.disabled && (_this_1.matchSearchQuery(option) || _this_1.matchSearchQuery(cv))) {
                            acc.push(option);
                        }
                    });
                }
            }
            return acc;
        }, []);
        return this.multiple
            ? flattenedVisibleOptionsAndGroups
            : flattenedVisibleOptionsAndGroups.filter(function (option) { return !(option.options && option.options.length); });
    };
    class_14.prototype.selectedOptions = function () {
        var _this_1 = this;
        var isSelected = function (optionValue) {
            return _this_1.multiple ? _this_1.value.includes(optionValue) : _this_1.value === optionValue;
        };
        return this.optionsWithoutGroups().filter(function (option) { return isSelected(option.value); });
    };
    class_14.prototype.selectedOptionsText = function () {
        return this.selectedOptions().length > 1
            ? this.selectedOptions().length + " options selected"
            : this.selectedOptions().map(function (option) { return option.text; }).join();
    };
    class_14.prototype.setInitialValue = function () {
        this.value = this.multiple ? [] : '';
    };
    class_14.prototype.processOptions = function () {
        var _this_1 = this;
        this.processedOptions = cloneDeep_1(this.options).map(function (option) {
            option.id = "option-" + randomUID();
            if (option.options && option.options.length) {
                option.options.forEach(function (subOption) {
                    subOption.id = "option-" + randomUID();
                    if (subOption.selected)
                        _this_1.value = _this_1.multiple ? _this_1.value.concat(subOption.value) : subOption.value;
                });
            }
            if (option.selected)
                _this_1.value = _this_1.multiple ? _this_1.value.concat(option.value) : option.value;
            return option;
        });
    };
    class_14.prototype.validateValue = function () {
        var type = this.multiple ? 'array' : 'string';
        var isStringOrArray = this.multiple ? Array.isArray(this.value) : typeof this.value === 'string';
        if (!isStringOrArray) {
            throw new Error("value has to be " + type);
        }
    };
    class_14.prototype.focusOption = function (key) {
        var _this_1 = this;
        var focusedOptionIndex;
        if (document.activeElement === this.searchInputEl || document.activeElement === this.toggleButtonEl) {
            focusedOptionIndex = -1;
        }
        else {
            focusedOptionIndex = this.focusedOptionId
                ? this.focusableOptionsAndGroups().findIndex(function (option) { return option.id === _this_1.focusedOptionId; })
                : -1;
        }
        var focus = function (key) {
            _this_1.focusedOptionId = key === 'down'
                ? _this_1.focusableOptionsAndGroups()[focusedOptionIndex + 1].id
                : _this_1.focusableOptionsAndGroups()[focusedOptionIndex - 1].id;
            setTimeout(function () { return document.getElementById(_this_1.focusedOptionId).focus(); });
        };
        if (DOWN_KEY.includes(key) && !(focusedOptionIndex >= this.focusableOptionsAndGroups().length - 1)) {
            focus('down');
        }
        else if (UP_KEY.includes(key) && !(focusedOptionIndex <= 0)) {
            focus('up');
        }
    };
    class_14.prototype.handleOptionChange = function (e, _g) {
        var id = _g.id, selected = _g.selected, value = _g.value;
        e.preventDefault();
        this.focusedOptionId = id;
        if (this.multiple) {
            this.value = selected ? __spreadArrays(this.value, [value]) : this.value.filter(function (optionValue) { return optionValue !== value; });
        }
        else {
            this.value = value;
            this.close();
            this.toggleButtonEl.focus();
        }
        this.omnibarChange.emit({ value: this.value });
    };
    class_14.prototype.handleOptionsGroupChange = function (e, _g) {
        var id = _g.id, selected = _g.selected, optionsValues = _g.optionsValues;
        e.preventDefault();
        this.focusedOptionId = id;
        this.value = selected
            ? __spreadArrays(this.value, optionsValues).filter(function (item, i, self) { return self.indexOf(item) === i; })
            : this.value.filter(function (option) { return !optionsValues.includes(option); });
        this.omnibarChange.emit({ value: this.value });
    };
    class_14.prototype.handleSearch = function (e) {
        this.searchQuery = e.target.value.toLowerCase();
    };
    class_14.prototype.handleSelectAllChange = function (e, _g) {
        var id = _g.id, selected = _g.selected, allOptions = _g.allOptions;
        e.preventDefault();
        this.focusedOptionId = id;
        this.value = selected ? this.value.filter(function (option) { return !allOptions.includes(option); })
            : __spreadArrays(this.value, allOptions).filter(function (item, i, self) { return self.indexOf(item) === i; }); // combine 2 array and remove duplicates
        this.omnibarChange.emit({ value: this.value });
    };
    class_14.prototype.createPopper = function () {
        if (!this.popper) {
            this.popper = new Popper(this.toggleButtonEl, this.selectMenuEl, {
                placement: this.menuPlacement,
                positionFixed: this.menuPositionFixed
            });
        }
    };
    class_14.prototype.destroyPopper = function () {
        if (this.popper) {
            this.popper.destroy();
            this.popper = null;
        }
    };
    class_14.prototype.clearSearch = function () {
        var _this_1 = this;
        this.searchQuery = '';
        setTimeout(function () { return _this_1.searchInputEl.focus(); }, 0);
    };
    class_14.prototype.getVisibleOptionValues = function () {
        return this.focusableOptionsAndGroups()
            .filter(function (option) { return !option.options; }) // exclude group options
            .map(function (option) { return option.value; });
    };
    class_14.prototype.render = function () {
        var _this_1 = this;
        var renderHiddenInput = function () {
            if (_this_1.multiple) {
                return _this_1.value && _this_1.value.length
                    ? _this_1.value.map(function (value) { return h("input", { type: "hidden", name: _this_1.name, value: value }); })
                    : h("input", { type: "hidden", name: _this_1.name, value: _this_1.value });
            }
            else {
                return h("input", { type: "hidden", name: _this_1.name, value: _this_1.value });
            }
        };
        var renderSelectToggleContent = function () {
            if (!_this_1.hasSlot('select-toggle')) {
                return (h("div", { class: {
                        'o-select__toggle__content': true,
                        'o-select__toggle__content--borderless': _this_1.borderless,
                    } }, h("div", { class: "o-select__toggle__content__text" }, _this_1.selectedOptionsText() || _this_1.placeholder), h("omnibar-icon", { icon: "arrow-down-v", class: "o-select__toggle__content__arrow" })));
            }
        };
        var renderSelectMenuFooter = function () {
            if (_this_1.hasSlot('select-menu-footer')) {
                return (h("div", { class: "o-select__menu__footer" }, h("slot", { name: "select-menu-footer" })));
            }
        };
        var renderSelectMenuMobileLabelContent = function () {
            if (!_this_1.hasSlot('select-mobile-label')) {
                return (h("div", { class: "o-select__mobile-label__content" }, h("div", { class: "o-select__mobile-label__content__button" }, h("span", { onClick: function () { return _this_1.close(); } }, "Cancel")), _this_1.label &&
                    h("div", { class: "o-select__mobile-label__content__text" }, _this_1.label), _this_1.multiple &&
                    h("div", { class: {
                            'o-select__mobile-label__content__button': true,
                            'o-select__mobile-label__content__button--right': true,
                            'o-select__mobile-label__content__button--disabled': false
                        } }, h("span", { onClick: function () { return _this_1.close(); } }, "Done"))));
            }
        };
        var renderSelectMenuSearch = function () {
            if (_this_1.searchable) {
                return (h("div", { class: "o-select__search" }, h("omnibar-icon", { icon: "search", class: "o-select__search__icon" }), h("input", { type: "text", class: "o-select__search__input", placeholder: "Search", value: _this_1.searchQuery, onInput: function (e) { return _this_1.handleSearch(e); }, ref: function (el) { return _this_1.searchInputEl = el; } }), _this_1.searchQuery &&
                    h("omnibar-icon", { icon: "remove-2", class: "o-select__search__icon-reset", onClick: function () { return _this_1.clearSearch(); } })));
            }
        };
        var renderNoSearchResults = function () {
            if (_this_1.processedOptions.length && !_this_1.visibleOptionsAndGroups().length) {
                return (h("div", { class: "o-select__no-search-results" }, "No results found. Try changing your search criteria."));
            }
        };
        var renderSelectMenuHeader = function () {
            return (h("div", { class: "o-select__menu__header" }, h("div", { class: "o-select__mobile-label" }, renderSelectMenuMobileLabelContent(), h("slot", { name: "select-mobile-label" })), renderSelectMenuSearch(), renderNoSearchResults(), _this_1.showNoOptionsMessage && renderNoOptionsMessage()));
        };
        var renderOption = function (option, groupVisible, groupDisabled) {
            if (groupVisible === void 0) { groupVisible = false; }
            if (groupDisabled === void 0) { groupDisabled = false; }
            var id = option.id, text = option.text, description = option.description, disabled = option.disabled, icon = option.icon, iconKind = option.iconKind, variant = option.variant, value = option.value;
            var visible = _this_1.matchSearchQuery(option) || groupVisible;
            var focused = id === _this_1.focusedOptionId;
            var selected = _this_1.multiple ? _this_1.value.includes(value) : _this_1.value === value;
            var isDisabled = disabled || groupDisabled;
            if (visible) {
                return (h("omnibar-option", { multiple: _this_1.multiple, selected: selected, focused: focused, disabled: isDisabled, value: value, text: text, description: description, icon: icon, iconKind: iconKind, optionId: id, variant: variant, onClick: function (e) { return _this_1.handleOptionChange(e, { id: id, selected: _this_1.multiple ? !selected : true, value: value }); }, onKeyDown: function (e) { return e.key === 'Enter'
                        ? _this_1.handleOptionChange(e, { id: id, selected: _this_1.multiple ? !selected : true, value: value })
                        : null; } }));
            }
        };
        var renderOptionsGroup = function (group) {
            var id = group.id, text = group.text, description = group.description, disabled = group.disabled, value = group.value, options = group.options;
            var visibleOptionValues = _this_1.getVisibleOptionValues();
            var optionsValues = options
                .map(function (option) { return option.value; })
                .filter(function (option) { return visibleOptionValues.includes(option); });
            var groupVisible = _this_1.matchSearchQuery(group);
            var focused = id === _this_1.focusedOptionId;
            var selected = _this_1.multiple ? optionsValues.every(function (option) { return _this_1.value.includes(option); }) : false;
            var indeterminate = _this_1.multiple
                ? !selected && optionsValues.some(function (option) { return _this_1.value.includes(option); })
                : false;
            var enabledOptionsSelected = _this_1.multiple
                ? optionsValues.every(function (option) { return _this_1.value.includes(option); })
                : false;
            return (h("div", { class: "o-options-group", role: "group" }, h("omnibar-option", { variant: "group", multiple: _this_1.multiple, selected: selected, focused: focused, disabled: disabled, value: value, text: text, description: description, indeterminate: indeterminate, optionId: id, onClick: _this_1.multiple
                    ? function (e) { return _this_1.handleOptionsGroupChange(e, { id: id, selected: !enabledOptionsSelected, optionsValues: optionsValues }); }
                    : null, onKeyDown: function (e) { return _this_1.multiple && e.key === 'Enter'
                    ? _this_1.handleOptionsGroupChange(e, { id: id, selected: !enabledOptionsSelected, optionsValues: optionsValues })
                    : null; } }), options.map(function (option) { return renderOption(option, groupVisible, disabled); })));
        };
        var renderSelectAllOption = function () {
            var allOptions = _this_1.getVisibleOptionValues();
            var selectedVisibleOptions = _this_1.value.filter(function (item) { return allOptions.includes(item); });
            var indeterminate = !!selectedVisibleOptions.length && allOptions.length !== selectedVisibleOptions.length;
            var selected = selectedVisibleOptions.length && allOptions.length === selectedVisibleOptions.length;
            if (_this_1.focusableOptionsAndGroups().length) {
                return (h("omnibar-option", { class: "o-font-semibold", multiple: _this_1.multiple, selected: selected, text: "Select All", indeterminate: indeterminate, optionId: _this_1.selectAllId, onClick: function (e) { return _this_1.handleSelectAllChange(e, { id: _this_1.selectAllId, selected: selected, allOptions: allOptions }); }, onKeyDown: function (e) { return _this_1.handleSelectAllChange(e, { id: _this_1.selectAllId, selected: selected, allOptions: allOptions }); } }));
            }
        };
        var renderNoOptionsMessage = function () {
            return h("div", { class: "o-select__no-options" }, _this_1.noOptionsMessage);
        };
        return [
            renderHiddenInput(),
            this.label && h("label", { class: "o-select__label" }, this.label),
            h("div", { class: {
                    'o-select': true,
                    'o-select--opened': this.opened,
                    'o-select--expanded': this.expanded,
                    'o-select--invalid': !!this.error,
                }, ref: function (el) { return _this_1.selectEl = el; } }, h("button", { type: "button", class: "o-select__toggle", disabled: this.disabled, "aria-haspopup": "true", "aria-expanded": this.opened ? 'true' : 'false', "aria-activedescendant": this.focusedOptionId, onClick: function () { return _this_1.toggle(); }, ref: function (el) { return _this_1.toggleButtonEl = el; } }, renderSelectToggleContent(), h("slot", { name: "select-toggle" })), this.hint && h("small", { class: "o-select__hint" }, this.hint), this.error &&
                h("div", { class: "o-select__error" }, h("omnibar-icon", { icon: "interface-alert-diamond", class: "o-select__error__icon" }), " ", this.error), h("div", { class: "o-select__menu", ref: function (el) { return _this_1.selectMenuEl = el; } }, this.loading && h("omnibar-container-loader", null), h("div", { class: "o-select__menu__content" }, renderSelectMenuHeader(), h("div", { class: "o-select__menu__body", role: "listbox", tabindex: "-1", "aria-multiselectable": this.multiple ? 'true' : null, style: { maxHeight: this.optionsMaxHeight } }, this.multiple && renderSelectAllOption(), this.visibleOptionsAndGroups().map(function (option) {
                return option.options && option.options.length
                    ? renderOptionsGroup(option)
                    : renderOption(option);
            })), renderSelectMenuFooter())))
        ];
    };
    Object.defineProperty(class_14.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_14, "watchers", {
        get: function () {
            return {
                "options": ["optionsChanged"],
                "value": ["valueChanged"],
                "multiple": ["multipleChanged"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_14, "style", {
        get: function () { return "omnibar-select{display:block}omnibar-select .o-select{position:relative}omnibar-select .o-select__label{color:#37474f}omnibar-select .o-select__toggle{display:block;background-color:transparent;border-width:0;cursor:pointer;padding:0;text-align:left;outline:0;width:100%}omnibar-select .o-select__toggle__content{border-width:1px;border-color:#c6ccd0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;font-size:.875rem;height:2.5rem;padding-left:.75rem;padding-right:.75rem;line-height:1.25;background-color:var(--raul-select-bg,#fff);border-radius:var(--raul-select-border-radius,.125rem);color:var(--raul-select-color,#37474f)}omnibar-select .o-select__toggle__content__text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;-ms-flex-positive:1;flex-grow:1}omnibar-select .o-select__toggle__content__arrow{font-size:1rem;color:#c6ccd0;margin-left:.5rem}omnibar-select .o-select__toggle__content--borderless{border-color:transparent}omnibar-select .o-select__toggle:focus{outline:0}omnibar-select .o-select__toggle:focus .o-select__toggle__content{border-color:#0076cc}omnibar-select .o-select__toggle:disabled .o-select__toggle__content{background-color:#ebedee;border-color:#ebedee;color:#9ba3a7;cursor:not-allowed}omnibar-select .o-select__label{display:inline-block;font-weight:500;font-size:.75rem;margin-bottom:.25rem}omnibar-select .o-select__hint{display:block;font-size:.75rem;margin-top:.5rem}omnibar-select .o-select__error{display:-ms-flexbox;display:flex;font-size:.75rem;-ms-flex-align:center;align-items:center;color:#d01a1f;margin-top:.5rem}omnibar-select .o-select__error__icon{font-size:1rem;margin-right:.25rem}omnibar-select .o-select__menu{background-color:#fff;border-radius:.125rem;-ms-flex-direction:row;flex-direction:row;border-top-width:1px;border-bottom-width:1px;border-color:#ebedee;-webkit-box-shadow:0 8px 16px 0 rgba(82,97,115,.18);box-shadow:0 8px 16px 0 rgba(82,97,115,.18);position:absolute;left:0;top:100%;min-width:10rem;width:100%;margin-top:.5rem;margin-bottom:.5rem;display:none;opacity:0;z-index:10000;-webkit-transition:opacity .2s ease,scale .2s linear;transition:opacity .2s ease,scale .2s linear}omnibar-select .o-select__menu__content{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;max-height:20rem;width:100%;min-height:2.5rem}\@media (max-width:640px){omnibar-select .o-select__menu__content{max-height:none}}omnibar-select .o-select__menu__body{-ms-flex-positive:1;flex-grow:1;overflow:auto}\@media (max-width:640px){omnibar-select .o-select__menu{top:0;right:0;bottom:0;left:0;-webkit-box-shadow:none;box-shadow:none;margin:0;min-width:0;position:fixed;border-width:0;border-radius:0;-webkit-transform:scale(0);transform:scale(0)}}omnibar-select .o-select__mobile-label{display:none}\@media (max-width:640px){omnibar-select .o-select__mobile-label{display:block}omnibar-select .o-select__mobile-label__content{-ms-flex-align:center;align-items:center;border-bottom-width:1px;border-color:#ebedee;background-color:#f7f8f9;display:-ms-flexbox;display:flex;font-size:.875rem;height:2.5rem}omnibar-select .o-select__mobile-label__content__button,omnibar-select .o-select__mobile-label__content__text{width:33.333333%}omnibar-select .o-select__mobile-label__content__text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#37474f;font-weight:500;text-align:center}omnibar-select .o-select__mobile-label__content__button{color:#0076cc;padding-left:.75rem;padding-right:.75rem}omnibar-select .o-select__mobile-label__content__button--disabled{color:#9ba3a7}omnibar-select .o-select__mobile-label__content__button--right{margin-left:auto;text-align:right}}omnibar-select .o-select__search{color:#37474f;font-size:.75rem;position:relative}omnibar-select .o-select__search__input{border-width:1px!important;border-top-width:0!important;border-color:#ebedee!important;height:2.5rem!important;padding-left:2rem!important;padding-right:.75rem!important;width:100%!important}omnibar-select .o-select__search__input:focus{outline:1px solid #0076cc;outline-offset:-1px}omnibar-select .o-select__search__input::-webkit-input-placeholder{color:#9ba3a7}omnibar-select .o-select__search__input::-moz-placeholder{color:#9ba3a7}omnibar-select .o-select__search__input:-ms-input-placeholder{color:#9ba3a7}omnibar-select .o-select__search__input::-ms-input-placeholder{color:#9ba3a7}omnibar-select .o-select__search__input::placeholder{color:#9ba3a7}\@media (max-width:640px){omnibar-select .o-select__search__input{border-left-width:0;border-right-width:0}}omnibar-select .o-select__search__icon{color:#9ba3a7;left:.75rem}omnibar-select .o-select__search__icon,omnibar-select .o-select__search__icon-reset{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}omnibar-select .o-select__search__icon-reset{cursor:pointer;right:.75rem}omnibar-select .o-select__no-options,omnibar-select .o-select__no-search-results{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;font-size:.75rem;color:#37474f;padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;padding-right:1rem;min-height:.75rem}omnibar-select .o-select--opened .o-select__menu{display:-ms-flexbox;display:flex}omnibar-select .o-select--expanded .o-select__menu{opacity:1}\@media (max-width:640px){omnibar-select .o-select--expanded .o-select__menu{-webkit-transform:scale(1);transform:scale(1)}}omnibar-select .o-select--invalid .o-select__toggle__content{border-color:#d01a1f}omnibar-select .o-option{border-width:1px;border-color:#ebedee;border-top-width:0;font-size:.75rem;cursor:pointer;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-left:1rem;padding-right:1rem;padding-top:.5rem;padding-bottom:.5rem;white-space:nowrap;line-height:1.25;min-height:2.5rem}omnibar-select .o-option,omnibar-select .o-option__icon{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}omnibar-select .o-option__icon{background-color:#ebedee;border-radius:9999px;color:#9ba3a7;font-size:1rem;height:2rem;width:2rem;margin-right:1rem}omnibar-select .o-option__icon raul-icon{display:-ms-inline-flexbox;display:inline-flex}omnibar-select .o-option__text{color:#37474f;-ms-flex:1 1 0%;flex:1 1 0%;padding-right:.75rem}omnibar-select .o-option__text,omnibar-select .o-option__text__description,omnibar-select .o-option__text__title{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}omnibar-select .o-option__text__description{margin-top:.25rem}omnibar-select .o-option__check-mark{display:none;vertical-align:middle;border-bottom-width:2px;border-right-width:2px;border-color:#0076cc;height:.75rem;width:.5rem;-webkit-transform:rotate(45deg);transform:rotate(45deg);-webkit-transform-origin:100% 50%;transform-origin:100% 50%}omnibar-select .o-option:not(.o-option--group):hover{background-color:#f7f8f9}body[modality=keyboard] omnibar-select .o-option:focus{outline:1px solid #0076cc;outline-offset:-1px}omnibar-select .o-option--selected .o-option__check-mark{display:block}omnibar-select .o-option--disabled{pointer-events:none}omnibar-select .o-option--disabled .o-option__check-mark,omnibar-select .o-option--disabled .o-option__text{color:#9ba3a7}omnibar-select .o-option--group,omnibar-select .o-option--heading{background-color:transparent;padding-top:1.5rem;padding-bottom:1rem}omnibar-select .o-option--group .o-option__text__title,omnibar-select .o-option--heading .o-option__text__title{font-weight:600}omnibar-select .o-option--heading{pointer-events:none}omnibar-select .o-option--group:not(.o-option--multiple){cursor:auto}omnibar-select .o-option--with-description .o-option__text__title{font-weight:600}\@media (max-width:640px){omnibar-select .o-option{border-left-width:0;border-right-width:0}}"; },
        enumerable: true,
        configurable: true
    });
    return class_14;
}());
/**
 * The first character that is used at start of a search to indicate the RealPage user wants to search
 * within additional meta options. These options are arbitrarily set by RealPage user as key value pairs
 */
OmnibarSelect.META_INDICATOR = ':';
/**
  * Seperates between objects key/value pairs when object is converted to string.
  * Example: {a: "a", b: "b"} becomes "a:a|b:b"
  */
OmnibarSelect.META_ITEM_DELIMITER = '|';
var oidcClient_min = createCommonjsModule(function (module, exports) {
    !function t(e, r) { module.exports = r(); }(commonjsGlobal, function () {
        return function (t) { var e = {}; function r(n) { if (e[n])
            return e[n].exports; var i = e[n] = { i: n, l: !1, exports: {} }; return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports; } return r.m = t, r.c = e, r.d = function (t, e, n) { r.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n }); }, r.r = function (t) { "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 }); }, r.t = function (t, e) { if (1 & e && (t = r(t)), 8 & e)
            return t; if (4 & e && "object" == typeof t && t && t.__esModule)
            return t; var n = Object.create(null); if (r.r(n), Object.defineProperty(n, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t)
            for (var i in t)
                r.d(n, i, function (e) { return t[e]; }.bind(null, i)); return n; }, r.n = function (t) { var e = t && t.__esModule ? function e() { return t.default; } : function e() { return t; }; return r.d(e, "a", e), e; }, r.o = function (t, e) { return Object.prototype.hasOwnProperty.call(t, e); }, r.p = "", r(r.s = 22); }([function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }); var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(); var i = { debug: function t() { }, info: function t() { }, warn: function t() { }, error: function t() { } }, o = void 0, s = void 0; (e.Log = function () { function t() { !function e(t, r) { if (!(t instanceof r))
                throw new TypeError("Cannot call a class as a function"); }(this, t); } return t.reset = function t() { s = 3, o = i; }, t.debug = function t() { if (s >= 4) {
                for (var e = arguments.length, r = Array(e), n = 0; n < e; n++)
                    r[n] = arguments[n];
                o.debug.apply(o, Array.from(r));
            } }, t.info = function t() { if (s >= 3) {
                for (var e = arguments.length, r = Array(e), n = 0; n < e; n++)
                    r[n] = arguments[n];
                o.info.apply(o, Array.from(r));
            } }, t.warn = function t() { if (s >= 2) {
                for (var e = arguments.length, r = Array(e), n = 0; n < e; n++)
                    r[n] = arguments[n];
                o.warn.apply(o, Array.from(r));
            } }, t.error = function t() { if (s >= 1) {
                for (var e = arguments.length, r = Array(e), n = 0; n < e; n++)
                    r[n] = arguments[n];
                o.error.apply(o, Array.from(r));
            } }, n(t, null, [{ key: "NONE", get: function t() { return 0; } }, { key: "ERROR", get: function t() { return 1; } }, { key: "WARN", get: function t() { return 2; } }, { key: "INFO", get: function t() { return 3; } }, { key: "DEBUG", get: function t() { return 4; } }, { key: "level", get: function t() { return s; }, set: function t(e) { if (!(0 <= e && e <= 4))
                        throw new Error("Invalid log level"); s = e; } }, { key: "logger", get: function t() { return o; }, set: function t(e) { if (!e.debug && e.info && (e.debug = e.info), !(e.debug && e.info && e.warn && e.error))
                        throw new Error("Invalid logger"); o = e; } }]), t; }()).reset(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }); var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(); var i = { setInterval: function (t) { function e(e, r) { return t.apply(this, arguments); } return e.toString = function () { return t.toString(); }, e; }(function (t, e) { return setInterval(t, e); }), clearInterval: function (t) { function e(e) { return t.apply(this, arguments); } return e.toString = function () { return t.toString(); }, e; }(function (t) { return clearInterval(t); }) }, o = !1, s = null; e.Global = function () { function t() { !function e(t, r) { if (!(t instanceof r))
                throw new TypeError("Cannot call a class as a function"); }(this, t); } return t._testing = function t() { o = !0; }, t.setXMLHttpRequest = function t(e) { s = e; }, n(t, null, [{ key: "location", get: function t() { if (!o)
                        return location; } }, { key: "localStorage", get: function t() { if (!o && "undefined" != typeof window)
                        return localStorage; } }, { key: "sessionStorage", get: function t() { if (!o && "undefined" != typeof window)
                        return sessionStorage; } }, { key: "XMLHttpRequest", get: function t() { if (!o && "undefined" != typeof window)
                        return s || XMLHttpRequest; } }, { key: "timer", get: function t() { if (!o)
                        return i; } }]), t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.MetadataService = void 0; var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(), i = r(0), o = r(7); e.MetadataService = function () { function t(e) { var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.JsonService; if (function n(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), !e)
                throw i.Log.error("MetadataService: No settings passed to MetadataService"), new Error("settings"); this._settings = e, this._jsonService = new r(["application/jwk-set+json"]); } return t.prototype.getMetadata = function t() { var e = this; return this._settings.metadata ? (i.Log.debug("MetadataService.getMetadata: Returning metadata from settings"), Promise.resolve(this._settings.metadata)) : this.metadataUrl ? (i.Log.debug("MetadataService.getMetadata: getting metadata from", this.metadataUrl), this._jsonService.getJson(this.metadataUrl).then(function (t) { return i.Log.debug("MetadataService.getMetadata: json received"), e._settings.metadata = t, t; })) : (i.Log.error("MetadataService.getMetadata: No authority or metadataUrl configured on settings"), Promise.reject(new Error("No authority or metadataUrl configured on settings"))); }, t.prototype.getIssuer = function t() { return this._getMetadataProperty("issuer"); }, t.prototype.getAuthorizationEndpoint = function t() { return this._getMetadataProperty("authorization_endpoint"); }, t.prototype.getUserInfoEndpoint = function t() { return this._getMetadataProperty("userinfo_endpoint"); }, t.prototype.getTokenEndpoint = function t() { var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0]; return this._getMetadataProperty("token_endpoint", e); }, t.prototype.getCheckSessionIframe = function t() { return this._getMetadataProperty("check_session_iframe", !0); }, t.prototype.getEndSessionEndpoint = function t() { return this._getMetadataProperty("end_session_endpoint", !0); }, t.prototype.getRevocationEndpoint = function t() { return this._getMetadataProperty("revocation_endpoint", !0); }, t.prototype.getKeysEndpoint = function t() { return this._getMetadataProperty("jwks_uri", !0); }, t.prototype._getMetadataProperty = function t(e) { var r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1]; return i.Log.debug("MetadataService.getMetadataProperty for: " + e), this.getMetadata().then(function (t) { if (i.Log.debug("MetadataService.getMetadataProperty: metadata recieved"), void 0 === t[e]) {
                if (!0 === r)
                    return void i.Log.warn("MetadataService.getMetadataProperty: Metadata does not contain optional property " + e);
                throw i.Log.error("MetadataService.getMetadataProperty: Metadata does not contain property " + e), new Error("Metadata does not contain property " + e);
            } return t[e]; }); }, t.prototype.getSigningKeys = function t() { var e = this; return this._settings.signingKeys ? (i.Log.debug("MetadataService.getSigningKeys: Returning signingKeys from settings"), Promise.resolve(this._settings.signingKeys)) : this._getMetadataProperty("jwks_uri").then(function (t) { return i.Log.debug("MetadataService.getSigningKeys: jwks_uri received", t), e._jsonService.getJson(t).then(function (t) { if (i.Log.debug("MetadataService.getSigningKeys: key set received", t), !t.keys)
                throw i.Log.error("MetadataService.getSigningKeys: Missing keys on keyset"), new Error("Missing keys on keyset"); return e._settings.signingKeys = t.keys, e._settings.signingKeys; }); }); }, n(t, [{ key: "metadataUrl", get: function t() { return this._metadataUrl || (this._settings.metadataUrl ? this._metadataUrl = this._settings.metadataUrl : (this._metadataUrl = this._settings.authority, this._metadataUrl && this._metadataUrl.indexOf(".well-known/openid-configuration") < 0 && ("/" !== this._metadataUrl[this._metadataUrl.length - 1] && (this._metadataUrl += "/"), this._metadataUrl += ".well-known/openid-configuration"))), this._metadataUrl; } }]), t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.UrlUtility = void 0; var n = r(0), i = r(1); e.UrlUtility = function () { function t() { !function e(t, r) { if (!(t instanceof r))
                throw new TypeError("Cannot call a class as a function"); }(this, t); } return t.addQueryParam = function t(e, r, n) { return e.indexOf("?") < 0 && (e += "?"), "?" !== e[e.length - 1] && (e += "&"), e += encodeURIComponent(r), e += "=", e += encodeURIComponent(n); }, t.parseUrlFragment = function t(e) { var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "#", o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.Global; "string" != typeof e && (e = o.location.href); var s = e.lastIndexOf(r); s >= 0 && (e = e.substr(s + 1)), "?" === r && (s = e.indexOf("#")) >= 0 && (e = e.substr(0, s)); for (var a, u = {}, c = /([^&=]+)=([^&]*)/g, h = 0; a = c.exec(e);)
                if (u[decodeURIComponent(a[1])] = decodeURIComponent(a[2]), h++ > 50)
                    return n.Log.error("UrlUtility.parseUrlFragment: response exceeded expected number of parameters", e), { error: "Response exceeded expected number of parameters" }; for (var l in u)
                return u; return {}; }, t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.JoseUtil = void 0; var n = r(25), i = function o(t) { return t && t.__esModule ? t : { default: t }; }(r(32)); e.JoseUtil = (0, i.default)({ jws: n.jws, KeyUtil: n.KeyUtil, X509: n.X509, crypto: n.crypto, hextob64u: n.hextob64u, b64tohex: n.b64tohex, AllowedSigningAlgs: n.AllowedSigningAlgs }); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.OidcClientSettings = void 0; var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) { return typeof t; } : function (t) { return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t; }, i = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(), o = r(0), s = r(6), a = r(23), u = r(2); var c = "id_token", h = "openid", l = 900, f = 300; e.OidcClientSettings = function () { function t() { var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = e.authority, i = e.metadataUrl, o = e.metadata, d = e.signingKeys, g = e.client_id, p = e.client_secret, v = e.response_type, y = void 0 === v ? c : v, m = e.scope, _ = void 0 === m ? h : m, S = e.redirect_uri, F = e.post_logout_redirect_uri, b = e.prompt, w = e.display, E = e.max_age, x = e.ui_locales, k = e.acr_values, A = e.resource, P = e.response_mode, C = e.filterProtocolClaims, T = void 0 === C || C, R = e.loadUserInfo, I = void 0 === R || R, D = e.staleStateAge, U = void 0 === D ? l : D, L = e.clockSkew, B = void 0 === L ? f : L, N = e.userInfoJwtIssuer, O = void 0 === N ? "OP" : N, j = e.stateStore, H = void 0 === j ? new s.WebStorageStateStore : j, M = e.ResponseValidatorCtor, K = void 0 === M ? a.ResponseValidator : M, V = e.MetadataServiceCtor, q = void 0 === V ? u.MetadataService : V, J = e.extraQueryParams, W = void 0 === J ? {} : J, z = e.extraTokenParams, Y = void 0 === z ? {} : z; !function G(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), this._authority = r, this._metadataUrl = i, this._metadata = o, this._signingKeys = d, this._client_id = g, this._client_secret = p, this._response_type = y, this._scope = _, this._redirect_uri = S, this._post_logout_redirect_uri = F, this._prompt = b, this._display = w, this._max_age = E, this._ui_locales = x, this._acr_values = k, this._resource = A, this._response_mode = P, this._filterProtocolClaims = !!T, this._loadUserInfo = !!I, this._staleStateAge = U, this._clockSkew = B, this._userInfoJwtIssuer = O, this._stateStore = H, this._validator = new K(this), this._metadataService = new q(this), this._extraQueryParams = "object" === (void 0 === W ? "undefined" : n(W)) ? W : {}, this._extraTokenParams = "object" === (void 0 === Y ? "undefined" : n(Y)) ? Y : {}; } return i(t, [{ key: "client_id", get: function t() { return this._client_id; }, set: function t(e) { if (this._client_id)
                        throw o.Log.error("OidcClientSettings.set_client_id: client_id has already been assigned."), new Error("client_id has already been assigned."); this._client_id = e; } }, { key: "client_secret", get: function t() { return this._client_secret; } }, { key: "response_type", get: function t() { return this._response_type; } }, { key: "scope", get: function t() { return this._scope; } }, { key: "redirect_uri", get: function t() { return this._redirect_uri; } }, { key: "post_logout_redirect_uri", get: function t() { return this._post_logout_redirect_uri; } }, { key: "prompt", get: function t() { return this._prompt; } }, { key: "display", get: function t() { return this._display; } }, { key: "max_age", get: function t() { return this._max_age; } }, { key: "ui_locales", get: function t() { return this._ui_locales; } }, { key: "acr_values", get: function t() { return this._acr_values; } }, { key: "resource", get: function t() { return this._resource; } }, { key: "response_mode", get: function t() { return this._response_mode; } }, { key: "authority", get: function t() { return this._authority; }, set: function t(e) { if (this._authority)
                        throw o.Log.error("OidcClientSettings.set_authority: authority has already been assigned."), new Error("authority has already been assigned."); this._authority = e; } }, { key: "metadataUrl", get: function t() { return this._metadataUrl || (this._metadataUrl = this.authority, this._metadataUrl && this._metadataUrl.indexOf(".well-known/openid-configuration") < 0 && ("/" !== this._metadataUrl[this._metadataUrl.length - 1] && (this._metadataUrl += "/"), this._metadataUrl += ".well-known/openid-configuration")), this._metadataUrl; } }, { key: "metadata", get: function t() { return this._metadata; }, set: function t(e) { this._metadata = e; } }, { key: "signingKeys", get: function t() { return this._signingKeys; }, set: function t(e) { this._signingKeys = e; } }, { key: "filterProtocolClaims", get: function t() { return this._filterProtocolClaims; } }, { key: "loadUserInfo", get: function t() { return this._loadUserInfo; } }, { key: "staleStateAge", get: function t() { return this._staleStateAge; } }, { key: "clockSkew", get: function t() { return this._clockSkew; } }, { key: "userInfoJwtIssuer", get: function t() { return this._userInfoJwtIssuer; } }, { key: "stateStore", get: function t() { return this._stateStore; } }, { key: "validator", get: function t() { return this._validator; } }, { key: "metadataService", get: function t() { return this._metadataService; } }, { key: "extraQueryParams", get: function t() { return this._extraQueryParams; }, set: function t(e) { "object" === (void 0 === e ? "undefined" : n(e)) ? this._extraQueryParams = e : this._extraQueryParams = {}; } }, { key: "extraTokenParams", get: function t() { return this._extraTokenParams; }, set: function t(e) { "object" === (void 0 === e ? "undefined" : n(e)) ? this._extraTokenParams = e : this._extraTokenParams = {}; } }]), t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.WebStorageStateStore = void 0; var n = r(0), i = r(1); e.WebStorageStateStore = function () { function t() { var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = e.prefix, n = void 0 === r ? "oidc." : r, o = e.store, s = void 0 === o ? i.Global.localStorage : o; !function a(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), this._store = s, this._prefix = n; } return t.prototype.set = function t(e, r) { return n.Log.debug("WebStorageStateStore.set", e), e = this._prefix + e, this._store.setItem(e, r), Promise.resolve(); }, t.prototype.get = function t(e) { n.Log.debug("WebStorageStateStore.get", e), e = this._prefix + e; var r = this._store.getItem(e); return Promise.resolve(r); }, t.prototype.remove = function t(e) { n.Log.debug("WebStorageStateStore.remove", e), e = this._prefix + e; var r = this._store.getItem(e); return this._store.removeItem(e), Promise.resolve(r); }, t.prototype.getAllKeys = function t() { n.Log.debug("WebStorageStateStore.getAllKeys"); for (var e = [], r = 0; r < this._store.length; r++) {
                var i = this._store.key(r);
                0 === i.indexOf(this._prefix) && e.push(i.substr(this._prefix.length));
            } return Promise.resolve(e); }, t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.JsonService = void 0; var n = r(0), i = r(1); e.JsonService = function () { function t() { var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.Global.XMLHttpRequest, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null; !function o(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), e && Array.isArray(e) ? this._contentTypes = e.slice() : this._contentTypes = [], this._contentTypes.push("application/json"), n && this._contentTypes.push("application/jwt"), this._XMLHttpRequest = r, this._jwtHandler = n; } return t.prototype.getJson = function t(e, r) { var i = this; if (!e)
                throw n.Log.error("JsonService.getJson: No url passed"), new Error("url"); return n.Log.debug("JsonService.getJson, url: ", e), new Promise(function (t, o) { var s = new i._XMLHttpRequest; s.open("GET", e); var a = i._contentTypes, u = i._jwtHandler; s.onload = function () { if (n.Log.debug("JsonService.getJson: HTTP response received, status", s.status), 200 === s.status) {
                var r = s.getResponseHeader("Content-Type");
                if (r) {
                    var i = a.find(function (t) { if (r.startsWith(t))
                        return !0; });
                    if ("application/jwt" == i)
                        return void u(s).then(t, o);
                    if (i)
                        try {
                            return void t(JSON.parse(s.responseText));
                        }
                        catch (t) {
                            return n.Log.error("JsonService.getJson: Error parsing JSON response", t.message), void o(t);
                        }
                }
                o(Error("Invalid response Content-Type: " + r + ", from URL: " + e));
            }
            else
                o(Error(s.statusText + " (" + s.status + ")")); }, s.onerror = function () { n.Log.error("JsonService.getJson: network error"), o(Error("Network Error")); }, r && (n.Log.debug("JsonService.getJson: token passed, setting Authorization header"), s.setRequestHeader("Authorization", "Bearer " + r)), s.send(); }); }, t.prototype.postForm = function t(e, r) { var i = this; if (!e)
                throw n.Log.error("JsonService.postForm: No url passed"), new Error("url"); return n.Log.debug("JsonService.postForm, url: ", e), new Promise(function (t, o) { var s = new i._XMLHttpRequest; s.open("POST", e); var a = i._contentTypes; s.onload = function () { if (n.Log.debug("JsonService.postForm: HTTP response received, status", s.status), 200 !== s.status) {
                if (400 === s.status)
                    if (i = s.getResponseHeader("Content-Type"))
                        if (a.find(function (t) { if (i.startsWith(t))
                            return !0; }))
                            try {
                                var r = JSON.parse(s.responseText);
                                if (r && r.error)
                                    return n.Log.error("JsonService.postForm: Error from server: ", r.error), void o(new Error(r.error));
                            }
                            catch (t) {
                                return n.Log.error("JsonService.postForm: Error parsing JSON response", t.message), void o(t);
                            }
                o(Error(s.statusText + " (" + s.status + ")"));
            }
            else {
                var i;
                if ((i = s.getResponseHeader("Content-Type")) && a.find(function (t) { if (i.startsWith(t))
                    return !0; }))
                    try {
                        return void t(JSON.parse(s.responseText));
                    }
                    catch (t) {
                        return n.Log.error("JsonService.postForm: Error parsing JSON response", t.message), void o(t);
                    }
                o(Error("Invalid response Content-Type: " + i + ", from URL: " + e));
            } }, s.onerror = function () { n.Log.error("JsonService.postForm: network error"), o(Error("Network Error")); }; var u = ""; for (var c in r) {
                var h = r[c];
                h && (u.length > 0 && (u += "&"), u += encodeURIComponent(c), u += "=", u += encodeURIComponent(h));
            } s.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), s.send(u); }); }, t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.State = void 0; var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(), i = r(0), o = function s(t) { return t && t.__esModule ? t : { default: t }; }(r(14)); e.State = function () { function t() { var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = e.id, n = e.data, i = e.created, s = e.request_type; !function a(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), this._id = r || (0, o.default)(), this._data = n, this._created = "number" == typeof i && i > 0 ? i : parseInt(Date.now() / 1e3), this._request_type = s; } return t.prototype.toStorageString = function t() { return i.Log.debug("State.toStorageString"), JSON.stringify({ id: this.id, data: this.data, created: this.created, request_type: this.request_type }); }, t.fromStorageString = function e(r) { return i.Log.debug("State.fromStorageString"), new t(JSON.parse(r)); }, t.clearStaleState = function e(r, n) { var o = Date.now() / 1e3 - n; return r.getAllKeys().then(function (e) { i.Log.debug("State.clearStaleState: got keys", e); for (var n = [], s = function s(a) { var c = e[a]; u = r.get(c).then(function (e) { var n = !1; if (e)
                try {
                    var s = t.fromStorageString(e);
                    i.Log.debug("State.clearStaleState: got item from key: ", c, s.created), s.created <= o && (n = !0);
                }
                catch (t) {
                    i.Log.error("State.clearStaleState: Error parsing state for key", c, t.message), n = !0;
                }
            else
                i.Log.debug("State.clearStaleState: no item in storage for key: ", c), n = !0; if (n)
                return i.Log.debug("State.clearStaleState: removed item for key: ", c), r.remove(c); }), n.push(u); }, a = 0; a < e.length; a++) {
                var u;
                s(a);
            } return i.Log.debug("State.clearStaleState: waiting on promise count:", n.length), Promise.all(n); }); }, n(t, [{ key: "id", get: function t() { return this._id; } }, { key: "data", get: function t() { return this._data; } }, { key: "created", get: function t() { return this._created; } }, { key: "request_type", get: function t() { return this._request_type; } }]), t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.OidcClient = void 0; var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(), i = r(0), o = r(5), s = r(11), a = r(12), u = r(36), c = r(37), h = r(38), l = r(13), f = r(8); e.OidcClient = function () { function t() { var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}; !function r(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), e instanceof o.OidcClientSettings ? this._settings = e : this._settings = new o.OidcClientSettings(e); } return t.prototype.createSigninRequest = function t() { var e = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = r.response_type, o = r.scope, s = r.redirect_uri, u = r.data, c = r.state, h = r.prompt, l = r.display, f = r.max_age, d = r.ui_locales, g = r.id_token_hint, p = r.login_hint, v = r.acr_values, y = r.resource, m = r.request, _ = r.request_uri, S = r.response_mode, F = r.extraQueryParams, b = r.extraTokenParams, w = r.request_type, E = r.skipUserInfo, x = arguments[1]; i.Log.debug("OidcClient.createSigninRequest"); var k = this._settings.client_id; n = n || this._settings.response_type, o = o || this._settings.scope, s = s || this._settings.redirect_uri, h = h || this._settings.prompt, l = l || this._settings.display, f = f || this._settings.max_age, d = d || this._settings.ui_locales, v = v || this._settings.acr_values, y = y || this._settings.resource, S = S || this._settings.response_mode, F = F || this._settings.extraQueryParams, b = b || this._settings.extraTokenParams; var A = this._settings.authority; return a.SigninRequest.isCode(n) && "code" !== n ? Promise.reject(new Error("OpenID Connect hybrid flow is not supported")) : this._metadataService.getAuthorizationEndpoint().then(function (t) { i.Log.debug("OidcClient.createSigninRequest: Received authorization endpoint", t); var r = new a.SigninRequest({ url: t, client_id: k, redirect_uri: s, response_type: n, scope: o, data: u || c, authority: A, prompt: h, display: l, max_age: f, ui_locales: d, id_token_hint: g, login_hint: p, acr_values: v, resource: y, request: m, request_uri: _, extraQueryParams: F, extraTokenParams: b, request_type: w, response_mode: S, client_secret: e._settings.client_secret, skipUserInfo: E }), P = r.state; return (x = x || e._stateStore).set(P.id, P.toStorageString()).then(function () { return r; }); }); }, t.prototype.readSigninResponseState = function t(e, r) { var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2]; i.Log.debug("OidcClient.readSigninResponseState"); var o = "query" === this._settings.response_mode || !this._settings.response_mode && a.SigninRequest.isCode(this._settings.response_type) ? "?" : "#", s = new u.SigninResponse(e, o); return s.state ? (r = r || this._stateStore, (n ? r.remove.bind(r) : r.get.bind(r))(s.state).then(function (t) { if (!t)
                throw i.Log.error("OidcClient.readSigninResponseState: No matching state found in storage"), new Error("No matching state found in storage"); return { state: l.SigninState.fromStorageString(t), response: s }; })) : (i.Log.error("OidcClient.readSigninResponseState: No state in response"), Promise.reject(new Error("No state in response"))); }, t.prototype.processSigninResponse = function t(e, r) { var n = this; return i.Log.debug("OidcClient.processSigninResponse"), this.readSigninResponseState(e, r, !0).then(function (t) { var e = t.state, r = t.response; return i.Log.debug("OidcClient.processSigninResponse: Received state from storage; validating response"), n._validator.validateSigninResponse(e, r); }); }, t.prototype.createSignoutRequest = function t() { var e = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = r.id_token_hint, o = r.data, s = r.state, a = r.post_logout_redirect_uri, u = r.extraQueryParams, h = r.request_type, l = arguments[1]; return i.Log.debug("OidcClient.createSignoutRequest"), a = a || this._settings.post_logout_redirect_uri, u = u || this._settings.extraQueryParams, this._metadataService.getEndSessionEndpoint().then(function (t) { if (!t)
                throw i.Log.error("OidcClient.createSignoutRequest: No end session endpoint url returned"), new Error("no end session endpoint"); i.Log.debug("OidcClient.createSignoutRequest: Received end session endpoint", t); var r = new c.SignoutRequest({ url: t, id_token_hint: n, post_logout_redirect_uri: a, data: o || s, extraQueryParams: u, request_type: h }), f = r.state; return f && (i.Log.debug("OidcClient.createSignoutRequest: Signout request has state to persist"), (l = l || e._stateStore).set(f.id, f.toStorageString())), r; }); }, t.prototype.readSignoutResponseState = function t(e, r) { var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2]; i.Log.debug("OidcClient.readSignoutResponseState"); var o = new h.SignoutResponse(e); if (!o.state)
                return i.Log.debug("OidcClient.readSignoutResponseState: No state in response"), o.error ? (i.Log.warn("OidcClient.readSignoutResponseState: Response was error: ", o.error), Promise.reject(new s.ErrorResponse(o))) : Promise.resolve({ undefined: void 0, response: o }); var a = o.state; return r = r || this._stateStore, (n ? r.remove.bind(r) : r.get.bind(r))(a).then(function (t) { if (!t)
                throw i.Log.error("OidcClient.readSignoutResponseState: No matching state found in storage"), new Error("No matching state found in storage"); return { state: f.State.fromStorageString(t), response: o }; }); }, t.prototype.processSignoutResponse = function t(e, r) { var n = this; return i.Log.debug("OidcClient.processSignoutResponse"), this.readSignoutResponseState(e, r, !0).then(function (t) { var e = t.state, r = t.response; return e ? (i.Log.debug("OidcClient.processSignoutResponse: Received state from storage; validating response"), n._validator.validateSignoutResponse(e, r)) : (i.Log.debug("OidcClient.processSignoutResponse: No state from storage; skipping validating response"), r); }); }, t.prototype.clearStaleState = function t(e) { return i.Log.debug("OidcClient.clearStaleState"), e = e || this._stateStore, f.State.clearStaleState(e, this.settings.staleStateAge); }, n(t, [{ key: "_stateStore", get: function t() { return this.settings.stateStore; } }, { key: "_validator", get: function t() { return this.settings.validator; } }, { key: "_metadataService", get: function t() { return this.settings.metadataService; } }, { key: "settings", get: function t() { return this._settings; } }, { key: "metadataService", get: function t() { return this._metadataService; } }]), t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.TokenClient = void 0; var n = r(7), i = r(2), o = r(0); e.TokenClient = function () { function t(e) { var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.JsonService, s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.MetadataService; if (function a(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), !e)
                throw o.Log.error("TokenClient.ctor: No settings passed"), new Error("settings"); this._settings = e, this._jsonService = new r, this._metadataService = new s(this._settings); } return t.prototype.exchangeCode = function t() { var e = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}; return (r = Object.assign({}, r)).grant_type = r.grant_type || "authorization_code", r.client_id = r.client_id || this._settings.client_id, r.redirect_uri = r.redirect_uri || this._settings.redirect_uri, r.code ? r.redirect_uri ? r.code_verifier ? r.client_id ? this._metadataService.getTokenEndpoint(!1).then(function (t) { return o.Log.debug("TokenClient.exchangeCode: Received token endpoint"), e._jsonService.postForm(t, r).then(function (t) { return o.Log.debug("TokenClient.exchangeCode: response received"), t; }); }) : (o.Log.error("TokenClient.exchangeCode: No client_id passed"), Promise.reject(new Error("A client_id is required"))) : (o.Log.error("TokenClient.exchangeCode: No code_verifier passed"), Promise.reject(new Error("A code_verifier is required"))) : (o.Log.error("TokenClient.exchangeCode: No redirect_uri passed"), Promise.reject(new Error("A redirect_uri is required"))) : (o.Log.error("TokenClient.exchangeCode: No code passed"), Promise.reject(new Error("A code is required"))); }, t.prototype.exchangeRefreshToken = function t() { var e = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}; return (r = Object.assign({}, r)).grant_type = r.grant_type || "refresh_token", r.client_id = r.client_id || this._settings.client_id, r.client_secret = r.client_secret || this._settings.client_secret, r.refresh_token ? r.client_id ? this._metadataService.getTokenEndpoint(!1).then(function (t) { return o.Log.debug("TokenClient.exchangeRefreshToken: Received token endpoint"), e._jsonService.postForm(t, r).then(function (t) { return o.Log.debug("TokenClient.exchangeRefreshToken: response received"), t; }); }) : (o.Log.error("TokenClient.exchangeRefreshToken: No client_id passed"), Promise.reject(new Error("A client_id is required"))) : (o.Log.error("TokenClient.exchangeRefreshToken: No refresh_token passed"), Promise.reject(new Error("A refresh_token is required"))); }, t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.ErrorResponse = void 0; var n = r(0); e.ErrorResponse = function (t) { function e() { var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, i = r.error, o = r.error_description, s = r.error_uri, a = r.state, u = r.session_state; if (function c(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, e), !i)
                throw n.Log.error("No error passed to ErrorResponse"), new Error("error"); var h = function l(t, e) { if (!t)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return !e || "object" != typeof e && "function" != typeof e ? t : e; }(this, t.call(this, o || i)); return h.name = "ErrorResponse", h.error = i, h.error_description = o, h.error_uri = s, h.state = a, h.session_state = u, h; } return function r(t, e) { if ("function" != typeof e && null !== e)
                throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e); }(e, t), e; }(Error); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.SigninRequest = void 0; var n = r(0), i = r(3), o = r(13); e.SigninRequest = function () { function t(e) { var r = e.url, s = e.client_id, a = e.redirect_uri, u = e.response_type, c = e.scope, h = e.authority, l = e.data, f = e.prompt, d = e.display, g = e.max_age, p = e.ui_locales, v = e.id_token_hint, y = e.login_hint, m = e.acr_values, _ = e.resource, S = e.response_mode, F = e.request, b = e.request_uri, w = e.extraQueryParams, E = e.request_type, x = e.client_secret, k = e.extraTokenParams, A = e.skipUserInfo; if (function P(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), !r)
                throw n.Log.error("SigninRequest.ctor: No url passed"), new Error("url"); if (!s)
                throw n.Log.error("SigninRequest.ctor: No client_id passed"), new Error("client_id"); if (!a)
                throw n.Log.error("SigninRequest.ctor: No redirect_uri passed"), new Error("redirect_uri"); if (!u)
                throw n.Log.error("SigninRequest.ctor: No response_type passed"), new Error("response_type"); if (!c)
                throw n.Log.error("SigninRequest.ctor: No scope passed"), new Error("scope"); if (!h)
                throw n.Log.error("SigninRequest.ctor: No authority passed"), new Error("authority"); var C = t.isOidc(u), T = t.isCode(u); S || (S = t.isCode(u) ? "query" : null), this.state = new o.SigninState({ nonce: C, data: l, client_id: s, authority: h, redirect_uri: a, code_verifier: T, request_type: E, response_mode: S, client_secret: x, scope: c, extraTokenParams: k, skipUserInfo: A }), r = i.UrlUtility.addQueryParam(r, "client_id", s), r = i.UrlUtility.addQueryParam(r, "redirect_uri", a), r = i.UrlUtility.addQueryParam(r, "response_type", u), r = i.UrlUtility.addQueryParam(r, "scope", c), r = i.UrlUtility.addQueryParam(r, "state", this.state.id), C && (r = i.UrlUtility.addQueryParam(r, "nonce", this.state.nonce)), T && (r = i.UrlUtility.addQueryParam(r, "code_challenge", this.state.code_challenge), r = i.UrlUtility.addQueryParam(r, "code_challenge_method", "S256")); var R = { prompt: f, display: d, max_age: g, ui_locales: p, id_token_hint: v, login_hint: y, acr_values: m, resource: _, request: F, request_uri: b, response_mode: S }; for (var I in R)
                R[I] && (r = i.UrlUtility.addQueryParam(r, I, R[I])); for (var D in w)
                r = i.UrlUtility.addQueryParam(r, D, w[D]); this.url = r; } return t.isOidc = function t(e) { return !!e.split(/\s+/g).filter(function (t) { return "id_token" === t; })[0]; }, t.isOAuth = function t(e) { return !!e.split(/\s+/g).filter(function (t) { return "token" === t; })[0]; }, t.isCode = function t(e) { return !!e.split(/\s+/g).filter(function (t) { return "code" === t; })[0]; }, t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.SigninState = void 0; var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(), i = r(0), o = r(8), s = r(4), a = function u(t) { return t && t.__esModule ? t : { default: t }; }(r(14)); e.SigninState = function (t) { function e() { var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = r.nonce, i = r.authority, o = r.client_id, u = r.redirect_uri, c = r.code_verifier, h = r.response_mode, l = r.client_secret, f = r.scope, d = r.extraTokenParams, g = r.skipUserInfo; !function p(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, e); var v = function y(t, e) { if (!t)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return !e || "object" != typeof e && "function" != typeof e ? t : e; }(this, t.call(this, arguments[0])); if (!0 === n ? v._nonce = (0, a.default)() : n && (v._nonce = n), !0 === c ? v._code_verifier = (0, a.default)() + (0, a.default)() + (0, a.default)() : c && (v._code_verifier = c), v.code_verifier) {
                var m = s.JoseUtil.hashString(v.code_verifier, "SHA256");
                v._code_challenge = s.JoseUtil.hexToBase64Url(m);
            } return v._redirect_uri = u, v._authority = i, v._client_id = o, v._response_mode = h, v._client_secret = l, v._scope = f, v._extraTokenParams = d, v._skipUserInfo = g, v; } return function r(t, e) { if ("function" != typeof e && null !== e)
                throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e); }(e, t), e.prototype.toStorageString = function t() { return i.Log.debug("SigninState.toStorageString"), JSON.stringify({ id: this.id, data: this.data, created: this.created, request_type: this.request_type, nonce: this.nonce, code_verifier: this.code_verifier, redirect_uri: this.redirect_uri, authority: this.authority, client_id: this.client_id, response_mode: this.response_mode, client_secret: this.client_secret, scope: this.scope, extraTokenParams: this.extraTokenParams, skipUserInfo: this.skipUserInfo }); }, e.fromStorageString = function t(r) { return i.Log.debug("SigninState.fromStorageString"), new e(JSON.parse(r)); }, n(e, [{ key: "nonce", get: function t() { return this._nonce; } }, { key: "authority", get: function t() { return this._authority; } }, { key: "client_id", get: function t() { return this._client_id; } }, { key: "redirect_uri", get: function t() { return this._redirect_uri; } }, { key: "code_verifier", get: function t() { return this._code_verifier; } }, { key: "code_challenge", get: function t() { return this._code_challenge; } }, { key: "response_mode", get: function t() { return this._response_mode; } }, { key: "client_secret", get: function t() { return this._client_secret; } }, { key: "scope", get: function t() { return this._scope; } }, { key: "extraTokenParams", get: function t() { return this._extraTokenParams; } }, { key: "skipUserInfo", get: function t() { return this._skipUserInfo; } }]), e; }(o.State); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.default = function n() { return (0, i.default)().replace(/-/g, ""); }; var i = function o(t) { return t && t.__esModule ? t : { default: t }; }(r(33)); t.exports = e.default; }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.User = void 0; var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(), i = r(0); e.User = function () { function t(e) { var r = e.id_token, n = e.session_state, i = e.access_token, o = e.refresh_token, s = e.token_type, a = e.scope, u = e.profile, c = e.expires_at, h = e.state; !function l(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), this.id_token = r, this.session_state = n, this.access_token = i, this.refresh_token = o, this.token_type = s, this.scope = a, this.profile = u, this.expires_at = c, this.state = h; } return t.prototype.toStorageString = function t() { return i.Log.debug("User.toStorageString"), JSON.stringify({ id_token: this.id_token, session_state: this.session_state, access_token: this.access_token, refresh_token: this.refresh_token, token_type: this.token_type, scope: this.scope, profile: this.profile, expires_at: this.expires_at }); }, t.fromStorageString = function e(r) { return i.Log.debug("User.fromStorageString"), new t(JSON.parse(r)); }, n(t, [{ key: "expires_in", get: function t() { if (this.expires_at) {
                        var e = parseInt(Date.now() / 1e3);
                        return this.expires_at - e;
                    } }, set: function t(e) { var r = parseInt(e); if ("number" == typeof r && r > 0) {
                        var n = parseInt(Date.now() / 1e3);
                        this.expires_at = n + r;
                    } } }, { key: "expired", get: function t() { var e = this.expires_in; if (void 0 !== e)
                        return e <= 0; } }, { key: "scopes", get: function t() { return (this.scope || "").split(" "); } }]), t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.AccessTokenEvents = void 0; var n = r(0), i = r(48); var o = 60; e.AccessTokenEvents = function () { function t() { var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = e.accessTokenExpiringNotificationTime, n = void 0 === r ? o : r, s = e.accessTokenExpiringTimer, a = void 0 === s ? new i.Timer("Access token expiring") : s, u = e.accessTokenExpiredTimer, c = void 0 === u ? new i.Timer("Access token expired") : u; !function h(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), this._accessTokenExpiringNotificationTime = n, this._accessTokenExpiring = a, this._accessTokenExpired = c; } return t.prototype.load = function t(e) { if (e.access_token && void 0 !== e.expires_in) {
                var r = e.expires_in;
                if (n.Log.debug("AccessTokenEvents.load: access token present, remaining duration:", r), r > 0) {
                    var i = r - this._accessTokenExpiringNotificationTime;
                    i <= 0 && (i = 1), n.Log.debug("AccessTokenEvents.load: registering expiring timer in:", i), this._accessTokenExpiring.init(i);
                }
                else
                    n.Log.debug("AccessTokenEvents.load: canceling existing expiring timer becase we're past expiration."), this._accessTokenExpiring.cancel();
                var o = r + 1;
                n.Log.debug("AccessTokenEvents.load: registering expired timer in:", o), this._accessTokenExpired.init(o);
            }
            else
                this._accessTokenExpiring.cancel(), this._accessTokenExpired.cancel(); }, t.prototype.unload = function t() { n.Log.debug("AccessTokenEvents.unload: canceling existing access token timers"), this._accessTokenExpiring.cancel(), this._accessTokenExpired.cancel(); }, t.prototype.addAccessTokenExpiring = function t(e) { this._accessTokenExpiring.addHandler(e); }, t.prototype.removeAccessTokenExpiring = function t(e) { this._accessTokenExpiring.removeHandler(e); }, t.prototype.addAccessTokenExpired = function t(e) { this._accessTokenExpired.addHandler(e); }, t.prototype.removeAccessTokenExpired = function t(e) { this._accessTokenExpired.removeHandler(e); }, t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.Event = void 0; var n = r(0); e.Event = function () { function t(e) { !function r(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), this._name = e, this._callbacks = []; } return t.prototype.addHandler = function t(e) { this._callbacks.push(e); }, t.prototype.removeHandler = function t(e) { var r = this._callbacks.findIndex(function (t) { return t === e; }); r >= 0 && this._callbacks.splice(r, 1); }, t.prototype.raise = function t() { n.Log.debug("Event: Raising event: " + this._name); for (var e = 0; e < this._callbacks.length; e++) {
                var r;
                (r = this._callbacks)[e].apply(r, arguments);
            } }, t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.SessionMonitor = void 0; var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(), i = r(0), o = r(19), s = r(1); e.SessionMonitor = function () { function t(e) { var r = this, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.CheckSessionIFrame, a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : s.Global.timer; if (function u(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), !e)
                throw i.Log.error("SessionMonitor.ctor: No user manager passed to SessionMonitor"), new Error("userManager"); this._userManager = e, this._CheckSessionIFrameCtor = n, this._timer = a, this._userManager.events.addUserLoaded(this._start.bind(this)), this._userManager.events.addUserUnloaded(this._stop.bind(this)), this._userManager.getUser().then(function (t) { t ? r._start(t) : r._settings.monitorAnonymousSession && r._userManager.querySessionStatus().then(function (t) { var e = { session_state: t.session_state }; t.sub && t.sid && (e.profile = { sub: t.sub, sid: t.sid }), r._start(e); }).catch(function (t) { i.Log.error("SessionMonitor ctor: error from querySessionStatus:", t.message); }); }).catch(function (t) { i.Log.error("SessionMonitor ctor: error from getUser:", t.message); }); } return t.prototype._start = function t(e) { var r = this, n = e.session_state; n && (e.profile ? (this._sub = e.profile.sub, this._sid = e.profile.sid, i.Log.debug("SessionMonitor._start: session_state:", n, ", sub:", this._sub)) : (this._sub = void 0, this._sid = void 0, i.Log.debug("SessionMonitor._start: session_state:", n, ", anonymous user")), this._checkSessionIFrame ? this._checkSessionIFrame.start(n) : this._metadataService.getCheckSessionIframe().then(function (t) { if (t) {
                i.Log.debug("SessionMonitor._start: Initializing check session iframe");
                var e = r._client_id, o = r._checkSessionInterval, s = r._stopCheckSessionOnError;
                r._checkSessionIFrame = new r._CheckSessionIFrameCtor(r._callback.bind(r), e, t, o, s), r._checkSessionIFrame.load().then(function () { r._checkSessionIFrame.start(n); });
            }
            else
                i.Log.warn("SessionMonitor._start: No check session iframe found in the metadata"); }).catch(function (t) { i.Log.error("SessionMonitor._start: Error from getCheckSessionIframe:", t.message); })); }, t.prototype._stop = function t() { var e = this; if (this._sub = void 0, this._sid = void 0, this._checkSessionIFrame && (i.Log.debug("SessionMonitor._stop"), this._checkSessionIFrame.stop()), this._settings.monitorAnonymousSession)
                var r = this._timer.setInterval(function () { e._timer.clearInterval(r), e._userManager.querySessionStatus().then(function (t) { var r = { session_state: t.session_state }; t.sub && t.sid && (r.profile = { sub: t.sub, sid: t.sid }), e._start(r); }).catch(function (t) { i.Log.error("SessionMonitor: error from querySessionStatus:", t.message); }); }, 1e3); }, t.prototype._callback = function t() { var e = this; this._userManager.querySessionStatus().then(function (t) { var r = !0; t ? t.sub === e._sub ? (r = !1, e._checkSessionIFrame.start(t.session_state), t.sid === e._sid ? i.Log.debug("SessionMonitor._callback: Same sub still logged in at OP, restarting check session iframe; session_state:", t.session_state) : (i.Log.debug("SessionMonitor._callback: Same sub still logged in at OP, session state has changed, restarting check session iframe; session_state:", t.session_state), e._userManager.events._raiseUserSessionChanged())) : i.Log.debug("SessionMonitor._callback: Different subject signed into OP:", t.sub) : i.Log.debug("SessionMonitor._callback: Subject no longer signed into OP"), r && (e._sub ? (i.Log.debug("SessionMonitor._callback: SessionMonitor._callback; raising signed out event"), e._userManager.events._raiseUserSignedOut()) : (i.Log.debug("SessionMonitor._callback: SessionMonitor._callback; raising signed in event"), e._userManager.events._raiseUserSignedIn())); }).catch(function (t) { e._sub && (i.Log.debug("SessionMonitor._callback: Error calling queryCurrentSigninSession; raising signed out event", t.message), e._userManager.events._raiseUserSignedOut()); }); }, n(t, [{ key: "_settings", get: function t() { return this._userManager.settings; } }, { key: "_metadataService", get: function t() { return this._userManager.metadataService; } }, { key: "_client_id", get: function t() { return this._settings.client_id; } }, { key: "_checkSessionInterval", get: function t() { return this._settings.checkSessionInterval; } }, { key: "_stopCheckSessionOnError", get: function t() { return this._settings.stopCheckSessionOnError; } }]), t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.CheckSessionIFrame = void 0; var n = r(0); var i = 2e3; e.CheckSessionIFrame = function () { function t(e, r, n, o) { var s = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4]; !function a(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), this._callback = e, this._client_id = r, this._url = n, this._interval = o || i, this._stopOnError = s; var u = n.indexOf("/", n.indexOf("//") + 2); this._frame_origin = n.substr(0, u), this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "absolute", this._frame.style.display = "none", this._frame.style.width = 0, this._frame.style.height = 0, this._frame.src = n; } return t.prototype.load = function t() { var e = this; return new Promise(function (t) { e._frame.onload = function () { t(); }, window.document.body.appendChild(e._frame), e._boundMessageEvent = e._message.bind(e), window.addEventListener("message", e._boundMessageEvent, !1); }); }, t.prototype._message = function t(e) { e.origin === this._frame_origin && e.source === this._frame.contentWindow && ("error" === e.data ? (n.Log.error("CheckSessionIFrame: error message from check session op iframe"), this._stopOnError && this.stop()) : "changed" === e.data ? (n.Log.debug("CheckSessionIFrame: changed message from check session op iframe"), this.stop(), this._callback()) : n.Log.debug("CheckSessionIFrame: " + e.data + " message from check session op iframe")); }, t.prototype.start = function t(e) { var r = this; if (this._session_state !== e) {
                n.Log.debug("CheckSessionIFrame.start"), this.stop(), this._session_state = e;
                var i = function t() { r._frame.contentWindow.postMessage(r._client_id + " " + r._session_state, r._frame_origin); };
                i(), this._timer = window.setInterval(i, this._interval);
            } }, t.prototype.stop = function t() { this._session_state = null, this._timer && (n.Log.debug("CheckSessionIFrame.stop"), window.clearInterval(this._timer), this._timer = null); }, t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.TokenRevocationClient = void 0; var n = r(0), i = r(2), o = r(1); e.TokenRevocationClient = function () { function t(e) { var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.Global.XMLHttpRequest, s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.MetadataService; if (function a(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), !e)
                throw n.Log.error("TokenRevocationClient.ctor: No settings provided"), new Error("No settings provided."); this._settings = e, this._XMLHttpRequestCtor = r, this._metadataService = new s(this._settings); } return t.prototype.revoke = function t(e, r) { var i = this, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "access_token"; if (!e)
                throw n.Log.error("TokenRevocationClient.revoke: No token provided"), new Error("No token provided."); if ("access_token" !== o && "refresh_token" != o)
                throw n.Log.error("TokenRevocationClient.revoke: Invalid token type"), new Error("Invalid token type."); return this._metadataService.getRevocationEndpoint().then(function (t) { if (t) {
                n.Log.debug("TokenRevocationClient.revoke: Revoking " + o);
                var s = i._settings.client_id, a = i._settings.client_secret;
                return i._revoke(t, s, a, e, o);
            } if (r)
                throw n.Log.error("TokenRevocationClient.revoke: Revocation not supported"), new Error("Revocation not supported"); }); }, t.prototype._revoke = function t(e, r, i, o, s) { var a = this; return new Promise(function (t, u) { var c = new a._XMLHttpRequestCtor; c.open("POST", e), c.onload = function () { n.Log.debug("TokenRevocationClient.revoke: HTTP response received, status", c.status), 200 === c.status ? t() : u(Error(c.statusText + " (" + c.status + ")")); }, c.onerror = function () { n.Log.debug("TokenRevocationClient.revoke: Network Error."), u("Network Error"); }; var h = "client_id=" + encodeURIComponent(r); i && (h += "&client_secret=" + encodeURIComponent(i)), h += "&token_type_hint=" + encodeURIComponent(s), h += "&token=" + encodeURIComponent(o), c.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), c.send(h); }); }, t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.CordovaPopupWindow = void 0; var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(), i = r(0); var o = "location=no,toolbar=no,zoom=no", s = "_blank"; e.CordovaPopupWindow = function () { function t(e) { var r = this; !function n(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), this._promise = new Promise(function (t, e) { r._resolve = t, r._reject = e; }), this.features = e.popupWindowFeatures || o, this.target = e.popupWindowTarget || s, this.redirect_uri = e.startUrl, i.Log.debug("CordovaPopupWindow.ctor: redirect_uri: " + this.redirect_uri); } return t.prototype._isInAppBrowserInstalled = function t(e) { return ["cordova-plugin-inappbrowser", "cordova-plugin-inappbrowser.inappbrowser", "org.apache.cordova.inappbrowser"].some(function (t) { return e.hasOwnProperty(t); }); }, t.prototype.navigate = function t(e) { if (e && e.url) {
                if (!window.cordova)
                    return this._error("cordova is undefined");
                var r = window.cordova.require("cordova/plugin_list").metadata;
                if (!1 === this._isInAppBrowserInstalled(r))
                    return this._error("InAppBrowser plugin not found");
                this._popup = cordova.InAppBrowser.open(e.url, this.target, this.features), this._popup ? (i.Log.debug("CordovaPopupWindow.navigate: popup successfully created"), this._exitCallbackEvent = this._exitCallback.bind(this), this._loadStartCallbackEvent = this._loadStartCallback.bind(this), this._popup.addEventListener("exit", this._exitCallbackEvent, !1), this._popup.addEventListener("loadstart", this._loadStartCallbackEvent, !1)) : this._error("Error opening popup window");
            }
            else
                this._error("No url provided"); return this.promise; }, t.prototype._loadStartCallback = function t(e) { 0 === e.url.indexOf(this.redirect_uri) && this._success({ url: e.url }); }, t.prototype._exitCallback = function t(e) { this._error(e); }, t.prototype._success = function t(e) { this._cleanup(), i.Log.debug("CordovaPopupWindow: Successful response from cordova popup window"), this._resolve(e); }, t.prototype._error = function t(e) { this._cleanup(), i.Log.error(e), this._reject(new Error(e)); }, t.prototype.close = function t() { this._cleanup(); }, t.prototype._cleanup = function t() { this._popup && (i.Log.debug("CordovaPopupWindow: cleaning up popup"), this._popup.removeEventListener("exit", this._exitCallbackEvent, !1), this._popup.removeEventListener("loadstart", this._loadStartCallbackEvent, !1), this._popup.close()), this._popup = null; }, n(t, [{ key: "promise", get: function t() { return this._promise; } }]), t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }); var n = r(0), i = r(9), o = r(5), s = r(6), a = r(39), u = r(40), c = r(16), h = r(2), l = r(50), f = r(51), d = r(19), g = r(20), p = r(18), v = r(1), y = r(15), m = r(52); e.default = { Version: m.Version, Log: n.Log, OidcClient: i.OidcClient, OidcClientSettings: o.OidcClientSettings, WebStorageStateStore: s.WebStorageStateStore, InMemoryWebStorage: a.InMemoryWebStorage, UserManager: u.UserManager, AccessTokenEvents: c.AccessTokenEvents, MetadataService: h.MetadataService, CordovaPopupNavigator: l.CordovaPopupNavigator, CordovaIFrameNavigator: f.CordovaIFrameNavigator, CheckSessionIFrame: d.CheckSessionIFrame, TokenRevocationClient: g.TokenRevocationClient, SessionMonitor: p.SessionMonitor, Global: v.Global, User: y.User }, t.exports = e.default; }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.ResponseValidator = void 0; var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) { return typeof t; } : function (t) { return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t; }, i = r(0), o = r(2), s = r(24), a = r(10), u = r(11), c = r(4); var h = ["nonce", "at_hash", "iat", "nbf", "exp", "aud", "iss", "c_hash"]; e.ResponseValidator = function () { function t(e) { var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.MetadataService, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : s.UserInfoService, u = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : c.JoseUtil, h = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : a.TokenClient; if (function l(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), !e)
                throw i.Log.error("ResponseValidator.ctor: No settings passed to ResponseValidator"), new Error("settings"); this._settings = e, this._metadataService = new r(this._settings), this._userInfoService = new n(this._settings), this._joseUtil = u, this._tokenClient = new h(this._settings); } return t.prototype.validateSigninResponse = function t(e, r) { var n = this; return i.Log.debug("ResponseValidator.validateSigninResponse"), this._processSigninParams(e, r).then(function (t) { return i.Log.debug("ResponseValidator.validateSigninResponse: state processed"), n._validateTokens(e, t).then(function (t) { return i.Log.debug("ResponseValidator.validateSigninResponse: tokens validated"), n._processClaims(e, t).then(function (t) { return i.Log.debug("ResponseValidator.validateSigninResponse: claims processed"), t; }); }); }); }, t.prototype.validateSignoutResponse = function t(e, r) { return e.id !== r.state ? (i.Log.error("ResponseValidator.validateSignoutResponse: State does not match"), Promise.reject(new Error("State does not match"))) : (i.Log.debug("ResponseValidator.validateSignoutResponse: state validated"), r.state = e.data, r.error ? (i.Log.warn("ResponseValidator.validateSignoutResponse: Response was error", r.error), Promise.reject(new u.ErrorResponse(r))) : Promise.resolve(r)); }, t.prototype._processSigninParams = function t(e, r) { if (e.id !== r.state)
                return i.Log.error("ResponseValidator._processSigninParams: State does not match"), Promise.reject(new Error("State does not match")); if (!e.client_id)
                return i.Log.error("ResponseValidator._processSigninParams: No client_id on state"), Promise.reject(new Error("No client_id on state")); if (!e.authority)
                return i.Log.error("ResponseValidator._processSigninParams: No authority on state"), Promise.reject(new Error("No authority on state")); if (this._settings.authority) {
                if (this._settings.authority && this._settings.authority !== e.authority)
                    return i.Log.error("ResponseValidator._processSigninParams: authority mismatch on settings vs. signin state"), Promise.reject(new Error("authority mismatch on settings vs. signin state"));
            }
            else
                this._settings.authority = e.authority; if (this._settings.client_id) {
                if (this._settings.client_id && this._settings.client_id !== e.client_id)
                    return i.Log.error("ResponseValidator._processSigninParams: client_id mismatch on settings vs. signin state"), Promise.reject(new Error("client_id mismatch on settings vs. signin state"));
            }
            else
                this._settings.client_id = e.client_id; return i.Log.debug("ResponseValidator._processSigninParams: state validated"), r.state = e.data, r.error ? (i.Log.warn("ResponseValidator._processSigninParams: Response was error", r.error), Promise.reject(new u.ErrorResponse(r))) : e.nonce && !r.id_token ? (i.Log.error("ResponseValidator._processSigninParams: Expecting id_token in response"), Promise.reject(new Error("No id_token in response"))) : !e.nonce && r.id_token ? (i.Log.error("ResponseValidator._processSigninParams: Not expecting id_token in response"), Promise.reject(new Error("Unexpected id_token in response"))) : e.code_verifier && !r.code ? (i.Log.error("ResponseValidator._processSigninParams: Expecting code in response"), Promise.reject(new Error("No code in response"))) : !e.code_verifier && r.code ? (i.Log.error("ResponseValidator._processSigninParams: Not expecting code in response"), Promise.reject(new Error("Unexpected code in response"))) : (r.scope || (r.scope = e.scope), Promise.resolve(r)); }, t.prototype._processClaims = function t(e, r) { var n = this; if (r.isOpenIdConnect) {
                if (i.Log.debug("ResponseValidator._processClaims: response is OIDC, processing claims"), r.profile = this._filterProtocolClaims(r.profile), !0 !== e.skipUserInfo && this._settings.loadUserInfo && r.access_token)
                    return i.Log.debug("ResponseValidator._processClaims: loading user info"), this._userInfoService.getClaims(r.access_token).then(function (t) { return i.Log.debug("ResponseValidator._processClaims: user info claims received from user info endpoint"), t.sub !== r.profile.sub ? (i.Log.error("ResponseValidator._processClaims: sub from user info endpoint does not match sub in access_token"), Promise.reject(new Error("sub from user info endpoint does not match sub in access_token"))) : (r.profile = n._mergeClaims(r.profile, t), i.Log.debug("ResponseValidator._processClaims: user info claims received, updated profile:", r.profile), r); });
                i.Log.debug("ResponseValidator._processClaims: not loading user info");
            }
            else
                i.Log.debug("ResponseValidator._processClaims: response is not OIDC, not processing claims"); return Promise.resolve(r); }, t.prototype._mergeClaims = function t(e, r) { var i = Object.assign({}, e); for (var o in r) {
                var s = r[o];
                Array.isArray(s) || (s = [s]);
                for (var a = 0; a < s.length; a++) {
                    var u = s[a];
                    i[o] ? Array.isArray(i[o]) ? i[o].indexOf(u) < 0 && i[o].push(u) : i[o] !== u && ("object" === (void 0 === u ? "undefined" : n(u)) ? i[o] = this._mergeClaims(i[o], u) : i[o] = [i[o], u]) : i[o] = u;
                }
            } return i; }, t.prototype._filterProtocolClaims = function t(e) { i.Log.debug("ResponseValidator._filterProtocolClaims, incoming claims:", e); var r = Object.assign({}, e); return this._settings._filterProtocolClaims ? (h.forEach(function (t) { delete r[t]; }), i.Log.debug("ResponseValidator._filterProtocolClaims: protocol claims filtered", r)) : i.Log.debug("ResponseValidator._filterProtocolClaims: protocol claims not filtered"), r; }, t.prototype._validateTokens = function t(e, r) { return r.code ? (i.Log.debug("ResponseValidator._validateTokens: Validating code"), this._processCode(e, r)) : r.id_token ? r.access_token ? (i.Log.debug("ResponseValidator._validateTokens: Validating id_token and access_token"), this._validateIdTokenAndAccessToken(e, r)) : (i.Log.debug("ResponseValidator._validateTokens: Validating id_token"), this._validateIdToken(e, r)) : (i.Log.debug("ResponseValidator._validateTokens: No code to process or id_token to validate"), Promise.resolve(r)); }, t.prototype._processCode = function t(e, r) { var o = this, s = { client_id: e.client_id, client_secret: e.client_secret, code: r.code, redirect_uri: e.redirect_uri, code_verifier: e.code_verifier }; return e.extraTokenParams && "object" === n(e.extraTokenParams) && Object.assign(s, e.extraTokenParams), this._tokenClient.exchangeCode(s).then(function (t) { for (var n in t)
                r[n] = t[n]; return r.id_token ? (i.Log.debug("ResponseValidator._processCode: token response successful, processing id_token"), o._validateIdTokenAttributes(e, r)) : (i.Log.debug("ResponseValidator._processCode: token response successful, returning response"), r); }); }, t.prototype._validateIdTokenAttributes = function t(e, r) { var n = this; return this._metadataService.getIssuer().then(function (t) { var o = e.client_id, s = n._settings.clockSkew; return i.Log.debug("ResponseValidator._validateIdTokenAttributes: Validaing JWT attributes; using clock skew (in seconds) of: ", s), n._joseUtil.validateJwtAttributes(r.id_token, t, o, s).then(function (t) { return e.nonce && e.nonce !== t.nonce ? (i.Log.error("ResponseValidator._validateIdTokenAttributes: Invalid nonce in id_token"), Promise.reject(new Error("Invalid nonce in id_token"))) : t.sub ? (r.profile = t, r) : (i.Log.error("ResponseValidator._validateIdTokenAttributes: No sub present in id_token"), Promise.reject(new Error("No sub present in id_token"))); }); }); }, t.prototype._validateIdTokenAndAccessToken = function t(e, r) { var n = this; return this._validateIdToken(e, r).then(function (t) { return n._validateAccessToken(t); }); }, t.prototype._validateIdToken = function t(e, r) { var n = this; if (!e.nonce)
                return i.Log.error("ResponseValidator._validateIdToken: No nonce on state"), Promise.reject(new Error("No nonce on state")); var o = this._joseUtil.parseJwt(r.id_token); if (!o || !o.header || !o.payload)
                return i.Log.error("ResponseValidator._validateIdToken: Failed to parse id_token", o), Promise.reject(new Error("Failed to parse id_token")); if (e.nonce !== o.payload.nonce)
                return i.Log.error("ResponseValidator._validateIdToken: Invalid nonce in id_token"), Promise.reject(new Error("Invalid nonce in id_token")); var s = o.header.kid; return this._metadataService.getIssuer().then(function (t) { return i.Log.debug("ResponseValidator._validateIdToken: Received issuer"), n._metadataService.getSigningKeys().then(function (a) { if (!a)
                return i.Log.error("ResponseValidator._validateIdToken: No signing keys from metadata"), Promise.reject(new Error("No signing keys from metadata")); i.Log.debug("ResponseValidator._validateIdToken: Received signing keys"); var u = void 0; if (s)
                u = a.filter(function (t) { return t.kid === s; })[0];
            else {
                if ((a = n._filterByAlg(a, o.header.alg)).length > 1)
                    return i.Log.error("ResponseValidator._validateIdToken: No kid found in id_token and more than one key found in metadata"), Promise.reject(new Error("No kid found in id_token and more than one key found in metadata"));
                u = a[0];
            } if (!u)
                return i.Log.error("ResponseValidator._validateIdToken: No key matching kid or alg found in signing keys"), Promise.reject(new Error("No key matching kid or alg found in signing keys")); var c = e.client_id, h = n._settings.clockSkew; return i.Log.debug("ResponseValidator._validateIdToken: Validaing JWT; using clock skew (in seconds) of: ", h), n._joseUtil.validateJwt(r.id_token, u, t, c, h).then(function () { return i.Log.debug("ResponseValidator._validateIdToken: JWT validation successful"), o.payload.sub ? (r.profile = o.payload, r) : (i.Log.error("ResponseValidator._validateIdToken: No sub present in id_token"), Promise.reject(new Error("No sub present in id_token"))); }); }); }); }, t.prototype._filterByAlg = function t(e, r) { var n = null; if (r.startsWith("RS"))
                n = "RSA";
            else if (r.startsWith("PS"))
                n = "PS";
            else {
                if (!r.startsWith("ES"))
                    return i.Log.debug("ResponseValidator._filterByAlg: alg not supported: ", r), [];
                n = "EC";
            } return i.Log.debug("ResponseValidator._filterByAlg: Looking for keys that match kty: ", n), e = e.filter(function (t) { return t.kty === n; }), i.Log.debug("ResponseValidator._filterByAlg: Number of keys that match kty: ", n, e.length), e; }, t.prototype._validateAccessToken = function t(e) { if (!e.profile)
                return i.Log.error("ResponseValidator._validateAccessToken: No profile loaded from id_token"), Promise.reject(new Error("No profile loaded from id_token")); if (!e.profile.at_hash)
                return i.Log.error("ResponseValidator._validateAccessToken: No at_hash in id_token"), Promise.reject(new Error("No at_hash in id_token")); if (!e.id_token)
                return i.Log.error("ResponseValidator._validateAccessToken: No id_token"), Promise.reject(new Error("No id_token")); var r = this._joseUtil.parseJwt(e.id_token); if (!r || !r.header)
                return i.Log.error("ResponseValidator._validateAccessToken: Failed to parse id_token", r), Promise.reject(new Error("Failed to parse id_token")); var n = r.header.alg; if (!n || 5 !== n.length)
                return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:", n), Promise.reject(new Error("Unsupported alg: " + n)); var o = n.substr(2, 3); if (!o)
                return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:", n, o), Promise.reject(new Error("Unsupported alg: " + n)); if (256 !== (o = parseInt(o)) && 384 !== o && 512 !== o)
                return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:", n, o), Promise.reject(new Error("Unsupported alg: " + n)); var s = "sha" + o, a = this._joseUtil.hashString(e.access_token, s); if (!a)
                return i.Log.error("ResponseValidator._validateAccessToken: access_token hash failed:", s), Promise.reject(new Error("Failed to validate at_hash")); var u = a.substr(0, a.length / 2), c = this._joseUtil.hexToBase64Url(u); return c !== e.profile.at_hash ? (i.Log.error("ResponseValidator._validateAccessToken: Failed to validate at_hash", c, e.profile.at_hash), Promise.reject(new Error("Failed to validate at_hash"))) : (i.Log.debug("ResponseValidator._validateAccessToken: success"), Promise.resolve(e)); }, t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.UserInfoService = void 0; var n = r(7), i = r(2), o = r(0), s = r(4); e.UserInfoService = function () { function t(e) { var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.JsonService, a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.MetadataService, u = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : s.JoseUtil; if (function c(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), !e)
                throw o.Log.error("UserInfoService.ctor: No settings passed"), new Error("settings"); this._settings = e, this._jsonService = new r(void 0, void 0, this._getClaimsFromJwt.bind(this)), this._metadataService = new a(this._settings), this._joseUtil = u; } return t.prototype.getClaims = function t(e) { var r = this; return e ? this._metadataService.getUserInfoEndpoint().then(function (t) { return o.Log.debug("UserInfoService.getClaims: received userinfo url", t), r._jsonService.getJson(t, e).then(function (t) { return o.Log.debug("UserInfoService.getClaims: claims received", t), t; }); }) : (o.Log.error("UserInfoService.getClaims: No token passed"), Promise.reject(new Error("A token is required"))); }, t.prototype._getClaimsFromJwt = function t(e) { var r = this; try {
                var n = this._joseUtil.parseJwt(e.responseText);
                if (!n || !n.header || !n.payload)
                    return o.Log.error("UserInfoService._getClaimsFromJwt: Failed to parse JWT", n), Promise.reject(new Error("Failed to parse id_token"));
                var i = n.header.kid, s = void 0;
                switch (this._settings.userInfoJwtIssuer) {
                    case "OP":
                        s = this._metadataService.getIssuer();
                        break;
                    case "ANY":
                        s = Promise.resolve(n.payload.iss);
                        break;
                    default: s = Promise.resolve(this._settings.userInfoJwtIssuer);
                }
                return s.then(function (t) { return o.Log.debug("UserInfoService._getClaimsFromJwt: Received issuer:" + t), r._metadataService.getSigningKeys().then(function (s) { if (!s)
                    return o.Log.error("UserInfoService._getClaimsFromJwt: No signing keys from metadata"), Promise.reject(new Error("No signing keys from metadata")); o.Log.debug("UserInfoService._getClaimsFromJwt: Received signing keys"); var a = void 0; if (i)
                    a = s.filter(function (t) { return t.kid === i; })[0];
                else {
                    if ((s = r._filterByAlg(s, n.header.alg)).length > 1)
                        return o.Log.error("UserInfoService._getClaimsFromJwt: No kid found in id_token and more than one key found in metadata"), Promise.reject(new Error("No kid found in id_token and more than one key found in metadata"));
                    a = s[0];
                } if (!a)
                    return o.Log.error("UserInfoService._getClaimsFromJwt: No key matching kid or alg found in signing keys"), Promise.reject(new Error("No key matching kid or alg found in signing keys")); var u = r._settings.client_id, c = r._settings.clockSkew; return o.Log.debug("UserInfoService._getClaimsFromJwt: Validaing JWT; using clock skew (in seconds) of: ", c), r._joseUtil.validateJwt(e.responseText, a, t, u, c, void 0, !0).then(function () { return o.Log.debug("UserInfoService._getClaimsFromJwt: JWT validation successful"), n.payload; }); }); });
            }
            catch (t) {
                return o.Log.error("UserInfoService._getClaimsFromJwt: Error parsing JWT response", t.message), void reject(t);
            } }, t.prototype._filterByAlg = function t(e, r) { var n = null; if (r.startsWith("RS"))
                n = "RSA";
            else if (r.startsWith("PS"))
                n = "PS";
            else {
                if (!r.startsWith("ES"))
                    return o.Log.debug("UserInfoService._filterByAlg: alg not supported: ", r), [];
                n = "EC";
            } return o.Log.debug("UserInfoService._filterByAlg: Looking for keys that match kty: ", n), e = e.filter(function (t) { return t.kty === n; }), o.Log.debug("UserInfoService._filterByAlg: Number of keys that match kty: ", n, e.length), e; }, t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.AllowedSigningAlgs = e.b64tohex = e.hextob64u = e.crypto = e.X509 = e.KeyUtil = e.jws = void 0; var n = r(26); e.jws = n.jws, e.KeyUtil = n.KEYUTIL, e.X509 = n.X509, e.crypto = n.crypto, e.hextob64u = n.hextob64u, e.b64tohex = n.b64tohex, e.AllowedSigningAlgs = ["RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512"]; }, function (t, e, r) {
                (function (t) {
                    Object.defineProperty(e, "__esModule", { value: !0 });
                    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) { return typeof t; } : function (t) { return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t; }, n = { userAgent: !1 }, i = {};
                    /*!
                    Copyright (c) 2011, Yahoo! Inc. All rights reserved.
                    Code licensed under the BSD License:
                    http://developer.yahoo.com/yui/license.html
                    version: 2.9.0
                    */
                    if (void 0 === o)
                        var o = {};
                    o.lang = { extend: function t(e, r, i) { if (!r || !e)
                            throw new Error("YAHOO.lang.extend failed, please check that all dependencies are included."); var o = function t() { }; if (o.prototype = r.prototype, e.prototype = new o, e.prototype.constructor = e, e.superclass = r.prototype, r.prototype.constructor == Object.prototype.constructor && (r.prototype.constructor = r), i) {
                            var s;
                            for (s in i)
                                e.prototype[s] = i[s];
                            var a = function t() { }, u = ["toString", "valueOf"];
                            try {
                                /MSIE/.test(n.userAgent) && (a = function t(e, r) { for (s = 0; s < u.length; s += 1) {
                                    var n = u[s], i = r[n];
                                    "function" == typeof i && i != Object.prototype[n] && (e[n] = i);
                                } });
                            }
                            catch (t) { }
                            a(e.prototype, i);
                        } } };
                    /*! CryptoJS v3.1.2 core-fix.js
                     * code.google.com/p/crypto-js
                     * (c) 2009-2013 by Jeff Mott. All rights reserved.
                     * code.google.com/p/crypto-js/wiki/License
                     * THIS IS FIX of 'core.js' to fix Hmac issue.
                     * https://code.google.com/p/crypto-js/issues/detail?id=84
                     * https://crypto-js.googlecode.com/svn-history/r667/branches/3.x/src/core.js
                     */
                    var s, a, u, c, h, l, f, d, g, p, v, y = y || (s = Math, u = (a = {}).lib = {}, c = u.Base = function () { function t() { } return { extend: function e(r) { t.prototype = this; var n = new t; return r && n.mixIn(r), n.hasOwnProperty("init") || (n.init = function () { n.$super.init.apply(this, arguments); }), n.init.prototype = n, n.$super = this, n; }, create: function t() { var e = this.extend(); return e.init.apply(e, arguments), e; }, init: function t() { }, mixIn: function t(e) { for (var r in e)
                            e.hasOwnProperty(r) && (this[r] = e[r]); e.hasOwnProperty("toString") && (this.toString = e.toString); }, clone: function t() { return this.init.prototype.extend(this); } }; }(), h = u.WordArray = c.extend({ init: function t(e, r) { e = this.words = e || [], this.sigBytes = void 0 != r ? r : 4 * e.length; }, toString: function t(e) { return (e || f).stringify(this); }, concat: function t(e) { var r = this.words, n = e.words, i = this.sigBytes, o = e.sigBytes; if (this.clamp(), i % 4)
                            for (var s = 0; s < o; s++) {
                                var a = n[s >>> 2] >>> 24 - s % 4 * 8 & 255;
                                r[i + s >>> 2] |= a << 24 - (i + s) % 4 * 8;
                            }
                        else
                            for (s = 0; s < o; s += 4)
                                r[i + s >>> 2] = n[s >>> 2]; return this.sigBytes += o, this; }, clamp: function t() { var e = this.words, r = this.sigBytes; e[r >>> 2] &= 4294967295 << 32 - r % 4 * 8, e.length = s.ceil(r / 4); }, clone: function t() { var e = c.clone.call(this); return e.words = this.words.slice(0), e; }, random: function t(e) { for (var r = [], n = 0; n < e; n += 4)
                            r.push(4294967296 * s.random() | 0); return new h.init(r, e); } }), l = a.enc = {}, f = l.Hex = { stringify: function t(e) { for (var r = e.words, n = e.sigBytes, i = [], o = 0; o < n; o++) {
                            var s = r[o >>> 2] >>> 24 - o % 4 * 8 & 255;
                            i.push((s >>> 4).toString(16)), i.push((15 & s).toString(16));
                        } return i.join(""); }, parse: function t(e) { for (var r = e.length, n = [], i = 0; i < r; i += 2)
                            n[i >>> 3] |= parseInt(e.substr(i, 2), 16) << 24 - i % 8 * 4; return new h.init(n, r / 2); } }, d = l.Latin1 = { stringify: function t(e) { for (var r = e.words, n = e.sigBytes, i = [], o = 0; o < n; o++) {
                            var s = r[o >>> 2] >>> 24 - o % 4 * 8 & 255;
                            i.push(String.fromCharCode(s));
                        } return i.join(""); }, parse: function t(e) { for (var r = e.length, n = [], i = 0; i < r; i++)
                            n[i >>> 2] |= (255 & e.charCodeAt(i)) << 24 - i % 4 * 8; return new h.init(n, r); } }, g = l.Utf8 = { stringify: function t(e) { try {
                            return decodeURIComponent(escape(d.stringify(e)));
                        }
                        catch (t) {
                            throw new Error("Malformed UTF-8 data");
                        } }, parse: function t(e) { return d.parse(unescape(encodeURIComponent(e))); } }, p = u.BufferedBlockAlgorithm = c.extend({ reset: function t() { this._data = new h.init, this._nDataBytes = 0; }, _append: function t(e) { "string" == typeof e && (e = g.parse(e)), this._data.concat(e), this._nDataBytes += e.sigBytes; }, _process: function t(e) { var r = this._data, n = r.words, i = r.sigBytes, o = this.blockSize, a = i / (4 * o), u = (a = e ? s.ceil(a) : s.max((0 | a) - this._minBufferSize, 0)) * o, c = s.min(4 * u, i); if (u) {
                            for (var l = 0; l < u; l += o)
                                this._doProcessBlock(n, l);
                            var f = n.splice(0, u);
                            r.sigBytes -= c;
                        } return new h.init(f, c); }, clone: function t() { var e = c.clone.call(this); return e._data = this._data.clone(), e; }, _minBufferSize: 0 }), u.Hasher = p.extend({ cfg: c.extend(), init: function t(e) { this.cfg = this.cfg.extend(e), this.reset(); }, reset: function t() { p.reset.call(this), this._doReset(); }, update: function t(e) { return this._append(e), this._process(), this; }, finalize: function t(e) { return e && this._append(e), this._doFinalize(); }, blockSize: 16, _createHelper: function t(e) { return function (t, r) { return new e.init(r).finalize(t); }; }, _createHmacHelper: function t(e) { return function (t, r) { return new v.HMAC.init(e, r).finalize(t); }; } }), v = a.algo = {}, a);
                    !function (t) { var e, r = (e = y).lib, n = r.Base, i = r.WordArray; (e = e.x64 = {}).Word = n.extend({ init: function t(e, r) { this.high = e, this.low = r; } }), e.WordArray = n.extend({ init: function t(e, r) { e = this.words = e || [], this.sigBytes = void 0 != r ? r : 8 * e.length; }, toX32: function t() { for (var e = this.words, r = e.length, n = [], o = 0; o < r; o++) {
                            var s = e[o];
                            n.push(s.high), n.push(s.low);
                        } return i.create(n, this.sigBytes); }, clone: function t() { for (var e = n.clone.call(this), r = e.words = this.words.slice(0), i = r.length, o = 0; o < i; o++)
                            r[o] = r[o].clone(); return e; } }); }(), function () { var t = y, e = t.lib.WordArray; t.enc.Base64 = { stringify: function t(e) { var r = e.words, n = e.sigBytes, i = this._map; e.clamp(), e = []; for (var o = 0; o < n; o += 3)
                            for (var s = (r[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 16 | (r[o + 1 >>> 2] >>> 24 - (o + 1) % 4 * 8 & 255) << 8 | r[o + 2 >>> 2] >>> 24 - (o + 2) % 4 * 8 & 255, a = 0; 4 > a && o + .75 * a < n; a++)
                                e.push(i.charAt(s >>> 6 * (3 - a) & 63)); if (r = i.charAt(64))
                            for (; e.length % 4;)
                                e.push(r); return e.join(""); }, parse: function t(r) { var n = r.length, i = this._map; (o = i.charAt(64)) && (-1 != (o = r.indexOf(o)) && (n = o)); for (var o = [], s = 0, a = 0; a < n; a++)
                            if (a % 4) {
                                var u = i.indexOf(r.charAt(a - 1)) << a % 4 * 2, c = i.indexOf(r.charAt(a)) >>> 6 - a % 4 * 2;
                                o[s >>> 2] |= (u | c) << 24 - s % 4 * 8, s++;
                            } return e.create(o, s); }, _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=" }; }(), function (t) { for (var e = y, r = (i = e.lib).WordArray, n = i.Hasher, i = e.algo, o = [], s = [], a = function t(e) { return 4294967296 * (e - (0 | e)) | 0; }, u = 2, c = 0; 64 > c;) {
                        var h;
                        t: {
                            h = u;
                            for (var l = t.sqrt(h), f = 2; f <= l; f++)
                                if (!(h % f)) {
                                    h = !1;
                                    break t;
                                }
                            h = !0;
                        }
                        h && (8 > c && (o[c] = a(t.pow(u, .5))), s[c] = a(t.pow(u, 1 / 3)), c++), u++;
                    } var d = []; i = i.SHA256 = n.extend({ _doReset: function t() { this._hash = new r.init(o.slice(0)); }, _doProcessBlock: function t(e, r) { for (var n = this._hash.words, i = n[0], o = n[1], a = n[2], u = n[3], c = n[4], h = n[5], l = n[6], f = n[7], g = 0; 64 > g; g++) {
                            if (16 > g)
                                d[g] = 0 | e[r + g];
                            else {
                                var p = d[g - 15], v = d[g - 2];
                                d[g] = ((p << 25 | p >>> 7) ^ (p << 14 | p >>> 18) ^ p >>> 3) + d[g - 7] + ((v << 15 | v >>> 17) ^ (v << 13 | v >>> 19) ^ v >>> 10) + d[g - 16];
                            }
                            p = f + ((c << 26 | c >>> 6) ^ (c << 21 | c >>> 11) ^ (c << 7 | c >>> 25)) + (c & h ^ ~c & l) + s[g] + d[g], v = ((i << 30 | i >>> 2) ^ (i << 19 | i >>> 13) ^ (i << 10 | i >>> 22)) + (i & o ^ i & a ^ o & a), f = l, l = h, h = c, c = u + p | 0, u = a, a = o, o = i, i = p + v | 0;
                        } n[0] = n[0] + i | 0, n[1] = n[1] + o | 0, n[2] = n[2] + a | 0, n[3] = n[3] + u | 0, n[4] = n[4] + c | 0, n[5] = n[5] + h | 0, n[6] = n[6] + l | 0, n[7] = n[7] + f | 0; }, _doFinalize: function e() { var r = this._data, n = r.words, i = 8 * this._nDataBytes, o = 8 * r.sigBytes; return n[o >>> 5] |= 128 << 24 - o % 32, n[14 + (o + 64 >>> 9 << 4)] = t.floor(i / 4294967296), n[15 + (o + 64 >>> 9 << 4)] = i, r.sigBytes = 4 * n.length, this._process(), this._hash; }, clone: function t() { var e = n.clone.call(this); return e._hash = this._hash.clone(), e; } }); e.SHA256 = n._createHelper(i), e.HmacSHA256 = n._createHmacHelper(i); }(Math), function () { function t() { return n.create.apply(n, arguments); } for (var e = y, r = e.lib.Hasher, n = (o = e.x64).Word, i = o.WordArray, o = e.algo, s = [t(1116352408, 3609767458), t(1899447441, 602891725), t(3049323471, 3964484399), t(3921009573, 2173295548), t(961987163, 4081628472), t(1508970993, 3053834265), t(2453635748, 2937671579), t(2870763221, 3664609560), t(3624381080, 2734883394), t(310598401, 1164996542), t(607225278, 1323610764), t(1426881987, 3590304994), t(1925078388, 4068182383), t(2162078206, 991336113), t(2614888103, 633803317), t(3248222580, 3479774868), t(3835390401, 2666613458), t(4022224774, 944711139), t(264347078, 2341262773), t(604807628, 2007800933), t(770255983, 1495990901), t(1249150122, 1856431235), t(1555081692, 3175218132), t(1996064986, 2198950837), t(2554220882, 3999719339), t(2821834349, 766784016), t(2952996808, 2566594879), t(3210313671, 3203337956), t(3336571891, 1034457026), t(3584528711, 2466948901), t(113926993, 3758326383), t(338241895, 168717936), t(666307205, 1188179964), t(773529912, 1546045734), t(1294757372, 1522805485), t(1396182291, 2643833823), t(1695183700, 2343527390), t(1986661051, 1014477480), t(2177026350, 1206759142), t(2456956037, 344077627), t(2730485921, 1290863460), t(2820302411, 3158454273), t(3259730800, 3505952657), t(3345764771, 106217008), t(3516065817, 3606008344), t(3600352804, 1432725776), t(4094571909, 1467031594), t(275423344, 851169720), t(430227734, 3100823752), t(506948616, 1363258195), t(659060556, 3750685593), t(883997877, 3785050280), t(958139571, 3318307427), t(1322822218, 3812723403), t(1537002063, 2003034995), t(1747873779, 3602036899), t(1955562222, 1575990012), t(2024104815, 1125592928), t(2227730452, 2716904306), t(2361852424, 442776044), t(2428436474, 593698344), t(2756734187, 3733110249), t(3204031479, 2999351573), t(3329325298, 3815920427), t(3391569614, 3928383900), t(3515267271, 566280711), t(3940187606, 3454069534), t(4118630271, 4000239992), t(116418474, 1914138554), t(174292421, 2731055270), t(289380356, 3203993006), t(460393269, 320620315), t(685471733, 587496836), t(852142971, 1086792851), t(1017036298, 365543100), t(1126000580, 2618297676), t(1288033470, 3409855158), t(1501505948, 4234509866), t(1607167915, 987167468), t(1816402316, 1246189591)], a = [], u = 0; 80 > u; u++)
                        a[u] = t(); o = o.SHA512 = r.extend({ _doReset: function t() { this._hash = new i.init([new n.init(1779033703, 4089235720), new n.init(3144134277, 2227873595), new n.init(1013904242, 4271175723), new n.init(2773480762, 1595750129), new n.init(1359893119, 2917565137), new n.init(2600822924, 725511199), new n.init(528734635, 4215389547), new n.init(1541459225, 327033209)]); }, _doProcessBlock: function t(e, r) { for (var n = (f = this._hash.words)[0], i = f[1], o = f[2], u = f[3], c = f[4], h = f[5], l = f[6], f = f[7], d = n.high, g = n.low, p = i.high, v = i.low, y = o.high, m = o.low, _ = u.high, S = u.low, F = c.high, b = c.low, w = h.high, E = h.low, x = l.high, k = l.low, A = f.high, P = f.low, C = d, T = g, R = p, I = v, D = y, U = m, L = _, B = S, N = F, O = b, j = w, H = E, M = x, K = k, V = A, q = P, J = 0; 80 > J; J++) {
                            var W = a[J];
                            if (16 > J)
                                var z = W.high = 0 | e[r + 2 * J], Y = W.low = 0 | e[r + 2 * J + 1];
                            else {
                                z = ((Y = (z = a[J - 15]).high) >>> 1 | (G = z.low) << 31) ^ (Y >>> 8 | G << 24) ^ Y >>> 7;
                                var G = (G >>> 1 | Y << 31) ^ (G >>> 8 | Y << 24) ^ (G >>> 7 | Y << 25), X = ((Y = (X = a[J - 2]).high) >>> 19 | (Q = X.low) << 13) ^ (Y << 3 | Q >>> 29) ^ Y >>> 6, Q = (Q >>> 19 | Y << 13) ^ (Q << 3 | Y >>> 29) ^ (Q >>> 6 | Y << 26), $ = (Y = a[J - 7]).high, Z = (tt = a[J - 16]).high, tt = tt.low;
                                z = (z = (z = z + $ + ((Y = G + Y.low) >>> 0 < G >>> 0 ? 1 : 0)) + X + ((Y = Y + Q) >>> 0 < Q >>> 0 ? 1 : 0)) + Z + ((Y = Y + tt) >>> 0 < tt >>> 0 ? 1 : 0);
                                W.high = z, W.low = Y;
                            }
                            $ = N & j ^ ~N & M, tt = O & H ^ ~O & K, W = C & R ^ C & D ^ R & D;
                            var et = T & I ^ T & U ^ I & U, rt = (G = (C >>> 28 | T << 4) ^ (C << 30 | T >>> 2) ^ (C << 25 | T >>> 7), X = (T >>> 28 | C << 4) ^ (T << 30 | C >>> 2) ^ (T << 25 | C >>> 7), (Q = s[J]).high), nt = Q.low;
                            Z = (Z = (Z = (Z = V + ((N >>> 14 | O << 18) ^ (N >>> 18 | O << 14) ^ (N << 23 | O >>> 9)) + ((Q = q + ((O >>> 14 | N << 18) ^ (O >>> 18 | N << 14) ^ (O << 23 | N >>> 9))) >>> 0 < q >>> 0 ? 1 : 0)) + $ + ((Q = Q + tt) >>> 0 < tt >>> 0 ? 1 : 0)) + rt + ((Q = Q + nt) >>> 0 < nt >>> 0 ? 1 : 0)) + z + ((Q = Q + Y) >>> 0 < Y >>> 0 ? 1 : 0), W = G + W + ((Y = X + et) >>> 0 < X >>> 0 ? 1 : 0), V = M, q = K, M = j, K = H, j = N, H = O, N = L + Z + ((O = B + Q | 0) >>> 0 < B >>> 0 ? 1 : 0) | 0, L = D, B = U, D = R, U = I, R = C, I = T, C = Z + W + ((T = Q + Y | 0) >>> 0 < Q >>> 0 ? 1 : 0) | 0;
                        } g = n.low = g + T, n.high = d + C + (g >>> 0 < T >>> 0 ? 1 : 0), v = i.low = v + I, i.high = p + R + (v >>> 0 < I >>> 0 ? 1 : 0), m = o.low = m + U, o.high = y + D + (m >>> 0 < U >>> 0 ? 1 : 0), S = u.low = S + B, u.high = _ + L + (S >>> 0 < B >>> 0 ? 1 : 0), b = c.low = b + O, c.high = F + N + (b >>> 0 < O >>> 0 ? 1 : 0), E = h.low = E + H, h.high = w + j + (E >>> 0 < H >>> 0 ? 1 : 0), k = l.low = k + K, l.high = x + M + (k >>> 0 < K >>> 0 ? 1 : 0), P = f.low = P + q, f.high = A + V + (P >>> 0 < q >>> 0 ? 1 : 0); }, _doFinalize: function t() { var e = this._data, r = e.words, n = 8 * this._nDataBytes, i = 8 * e.sigBytes; return r[i >>> 5] |= 128 << 24 - i % 32, r[30 + (i + 128 >>> 10 << 5)] = Math.floor(n / 4294967296), r[31 + (i + 128 >>> 10 << 5)] = n, e.sigBytes = 4 * r.length, this._process(), this._hash.toX32(); }, clone: function t() { var e = r.clone.call(this); return e._hash = this._hash.clone(), e; }, blockSize: 32 }), e.SHA512 = r._createHelper(o), e.HmacSHA512 = r._createHmacHelper(o); }(), function () { var t = y, e = (i = t.x64).Word, r = i.WordArray, n = (i = t.algo).SHA512, i = i.SHA384 = n.extend({ _doReset: function t() { this._hash = new r.init([new e.init(3418070365, 3238371032), new e.init(1654270250, 914150663), new e.init(2438529370, 812702999), new e.init(355462360, 4144912697), new e.init(1731405415, 4290775857), new e.init(2394180231, 1750603025), new e.init(3675008525, 1694076839), new e.init(1203062813, 3204075428)]); }, _doFinalize: function t() { var e = n._doFinalize.call(this); return e.sigBytes -= 16, e; } }); t.SHA384 = n._createHelper(i), t.HmacSHA384 = n._createHmacHelper(i); }();
                    /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
                     */
                    var m, _ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", S = "=";
                    function F(t) { var e, r, n = ""; for (e = 0; e + 3 <= t.length; e += 3)
                        r = parseInt(t.substring(e, e + 3), 16), n += _.charAt(r >> 6) + _.charAt(63 & r); if (e + 1 == t.length ? (r = parseInt(t.substring(e, e + 1), 16), n += _.charAt(r << 2)) : e + 2 == t.length && (r = parseInt(t.substring(e, e + 2), 16), n += _.charAt(r >> 2) + _.charAt((3 & r) << 4)), S)
                        for (; (3 & n.length) > 0;)
                            n += S; return n; }
                    function b(t) { var e, r, n, i = "", o = 0; for (e = 0; e < t.length && t.charAt(e) != S; ++e)
                        (n = _.indexOf(t.charAt(e))) < 0 || (0 == o ? (i += D(n >> 2), r = 3 & n, o = 1) : 1 == o ? (i += D(r << 2 | n >> 4), r = 15 & n, o = 2) : 2 == o ? (i += D(r), i += D(n >> 2), r = 3 & n, o = 3) : (i += D(r << 2 | n >> 4), i += D(15 & n), o = 0)); return 1 == o && (i += D(r << 2)), i; }
                    function w(t) { var e, r = b(t), n = new Array; for (e = 0; 2 * e < r.length; ++e)
                        n[e] = parseInt(r.substring(2 * e, 2 * e + 2), 16); return n; }
                    function E(t, e, r) { null != t && ("number" == typeof t ? this.fromNumber(t, e, r) : null == e && "string" != typeof t ? this.fromString(t, 256) : this.fromString(t, e)); }
                    function x() { return new E(null); }
                    (E.prototype.am = function A(t, e, r, n, i, o) { for (; --o >= 0;) {
                        var s = e * this[t++] + r[n] + i;
                        i = Math.floor(s / 67108864), r[n++] = 67108863 & s;
                    } return i; }, m = 26), E.prototype.DB = m, E.prototype.DM = (1 << m) - 1, E.prototype.DV = 1 << m;
                    E.prototype.FV = Math.pow(2, 52), E.prototype.F1 = 52 - m, E.prototype.F2 = 2 * m - 52;
                    var C, T, R = "0123456789abcdefghijklmnopqrstuvwxyz", I = new Array;
                    for (C = "0".charCodeAt(0), T = 0; T <= 9; ++T)
                        I[C++] = T;
                    for (C = "a".charCodeAt(0), T = 10; T < 36; ++T)
                        I[C++] = T;
                    for (C = "A".charCodeAt(0), T = 10; T < 36; ++T)
                        I[C++] = T;
                    function D(t) { return R.charAt(t); }
                    function U(t, e) { var r = I[t.charCodeAt(e)]; return null == r ? -1 : r; }
                    function L(t) { var e = x(); return e.fromInt(t), e; }
                    function B(t) { var e, r = 1; return 0 != (e = t >>> 16) && (t = e, r += 16), 0 != (e = t >> 8) && (t = e, r += 8), 0 != (e = t >> 4) && (t = e, r += 4), 0 != (e = t >> 2) && (t = e, r += 2), 0 != (e = t >> 1) && (t = e, r += 1), r; }
                    function N(t) { this.m = t; }
                    function O(t) { this.m = t, this.mp = t.invDigit(), this.mpl = 32767 & this.mp, this.mph = this.mp >> 15, this.um = (1 << t.DB - 15) - 1, this.mt2 = 2 * t.t; }
                    function j(t, e) { return t & e; }
                    function H(t, e) { return t | e; }
                    function M(t, e) { return t ^ e; }
                    function K(t, e) { return t & ~e; }
                    function V(t) { if (0 == t)
                        return -1; var e = 0; return 0 == (65535 & t) && (t >>= 16, e += 16), 0 == (255 & t) && (t >>= 8, e += 8), 0 == (15 & t) && (t >>= 4, e += 4), 0 == (3 & t) && (t >>= 2, e += 2), 0 == (1 & t) && ++e, e; }
                    function q(t) { for (var e = 0; 0 != t;)
                        t &= t - 1, ++e; return e; }
                    function J() { }
                    function W(t) { return t; }
                    function z(t) { this.r2 = x(), this.q3 = x(), E.ONE.dlShiftTo(2 * t.t, this.r2), this.mu = this.r2.divide(t), this.m = t; }
                    N.prototype.convert = function Y(t) { return t.s < 0 || t.compareTo(this.m) >= 0 ? t.mod(this.m) : t; }, N.prototype.revert = function G(t) { return t; }, N.prototype.reduce = function X(t) { t.divRemTo(this.m, null, t); }, N.prototype.mulTo = function Q(t, e, r) { t.multiplyTo(e, r), this.reduce(r); }, N.prototype.sqrTo = function $(t, e) { t.squareTo(e), this.reduce(e); }, O.prototype.convert = function Z(t) { var e = x(); return t.abs().dlShiftTo(this.m.t, e), e.divRemTo(this.m, null, e), t.s < 0 && e.compareTo(E.ZERO) > 0 && this.m.subTo(e, e), e; }, O.prototype.revert = function tt(t) { var e = x(); return t.copyTo(e), this.reduce(e), e; }, O.prototype.reduce = function et(t) { for (; t.t <= this.mt2;)
                        t[t.t++] = 0; for (var e = 0; e < this.m.t; ++e) {
                        var r = 32767 & t[e], n = r * this.mpl + ((r * this.mph + (t[e] >> 15) * this.mpl & this.um) << 15) & t.DM;
                        for (t[r = e + this.m.t] += this.m.am(0, n, t, e, 0, this.m.t); t[r] >= t.DV;)
                            t[r] -= t.DV, t[++r]++;
                    } t.clamp(), t.drShiftTo(this.m.t, t), t.compareTo(this.m) >= 0 && t.subTo(this.m, t); }, O.prototype.mulTo = function rt(t, e, r) { t.multiplyTo(e, r), this.reduce(r); }, O.prototype.sqrTo = function nt(t, e) { t.squareTo(e), this.reduce(e); }, E.prototype.copyTo = function it(t) { for (var e = this.t - 1; e >= 0; --e)
                        t[e] = this[e]; t.t = this.t, t.s = this.s; }, E.prototype.fromInt = function ot(t) { this.t = 1, this.s = t < 0 ? -1 : 0, t > 0 ? this[0] = t : t < -1 ? this[0] = t + this.DV : this.t = 0; }, E.prototype.fromString = function st(t, e) { var r; if (16 == e)
                        r = 4;
                    else if (8 == e)
                        r = 3;
                    else if (256 == e)
                        r = 8;
                    else if (2 == e)
                        r = 1;
                    else if (32 == e)
                        r = 5;
                    else {
                        if (4 != e)
                            return void this.fromRadix(t, e);
                        r = 2;
                    } this.t = 0, this.s = 0; for (var n = t.length, i = !1, o = 0; --n >= 0;) {
                        var s = 8 == r ? 255 & t[n] : U(t, n);
                        s < 0 ? "-" == t.charAt(n) && (i = !0) : (i = !1, 0 == o ? this[this.t++] = s : o + r > this.DB ? (this[this.t - 1] |= (s & (1 << this.DB - o) - 1) << o, this[this.t++] = s >> this.DB - o) : this[this.t - 1] |= s << o, (o += r) >= this.DB && (o -= this.DB));
                    } 8 == r && 0 != (128 & t[0]) && (this.s = -1, o > 0 && (this[this.t - 1] |= (1 << this.DB - o) - 1 << o)), this.clamp(), i && E.ZERO.subTo(this, this); }, E.prototype.clamp = function at() { for (var t = this.s & this.DM; this.t > 0 && this[this.t - 1] == t;)
                        --this.t; }, E.prototype.dlShiftTo = function ut(t, e) { var r; for (r = this.t - 1; r >= 0; --r)
                        e[r + t] = this[r]; for (r = t - 1; r >= 0; --r)
                        e[r] = 0; e.t = this.t + t, e.s = this.s; }, E.prototype.drShiftTo = function ct(t, e) { for (var r = t; r < this.t; ++r)
                        e[r - t] = this[r]; e.t = Math.max(this.t - t, 0), e.s = this.s; }, E.prototype.lShiftTo = function ht(t, e) { var r, n = t % this.DB, i = this.DB - n, o = (1 << i) - 1, s = Math.floor(t / this.DB), a = this.s << n & this.DM; for (r = this.t - 1; r >= 0; --r)
                        e[r + s + 1] = this[r] >> i | a, a = (this[r] & o) << n; for (r = s - 1; r >= 0; --r)
                        e[r] = 0; e[s] = a, e.t = this.t + s + 1, e.s = this.s, e.clamp(); }, E.prototype.rShiftTo = function lt(t, e) { e.s = this.s; var r = Math.floor(t / this.DB); if (r >= this.t)
                        e.t = 0;
                    else {
                        var n = t % this.DB, i = this.DB - n, o = (1 << n) - 1;
                        e[0] = this[r] >> n;
                        for (var s = r + 1; s < this.t; ++s)
                            e[s - r - 1] |= (this[s] & o) << i, e[s - r] = this[s] >> n;
                        n > 0 && (e[this.t - r - 1] |= (this.s & o) << i), e.t = this.t - r, e.clamp();
                    } }, E.prototype.subTo = function ft(t, e) { for (var r = 0, n = 0, i = Math.min(t.t, this.t); r < i;)
                        n += this[r] - t[r], e[r++] = n & this.DM, n >>= this.DB; if (t.t < this.t) {
                        for (n -= t.s; r < this.t;)
                            n += this[r], e[r++] = n & this.DM, n >>= this.DB;
                        n += this.s;
                    }
                    else {
                        for (n += this.s; r < t.t;)
                            n -= t[r], e[r++] = n & this.DM, n >>= this.DB;
                        n -= t.s;
                    } e.s = n < 0 ? -1 : 0, n < -1 ? e[r++] = this.DV + n : n > 0 && (e[r++] = n), e.t = r, e.clamp(); }, E.prototype.multiplyTo = function dt(t, e) { var r = this.abs(), n = t.abs(), i = r.t; for (e.t = i + n.t; --i >= 0;)
                        e[i] = 0; for (i = 0; i < n.t; ++i)
                        e[i + r.t] = r.am(0, n[i], e, i, 0, r.t); e.s = 0, e.clamp(), this.s != t.s && E.ZERO.subTo(e, e); }, E.prototype.squareTo = function gt(t) { for (var e = this.abs(), r = t.t = 2 * e.t; --r >= 0;)
                        t[r] = 0; for (r = 0; r < e.t - 1; ++r) {
                        var n = e.am(r, e[r], t, 2 * r, 0, 1);
                        (t[r + e.t] += e.am(r + 1, 2 * e[r], t, 2 * r + 1, n, e.t - r - 1)) >= e.DV && (t[r + e.t] -= e.DV, t[r + e.t + 1] = 1);
                    } t.t > 0 && (t[t.t - 1] += e.am(r, e[r], t, 2 * r, 0, 1)), t.s = 0, t.clamp(); }, E.prototype.divRemTo = function pt(t, e, r) { var n = t.abs(); if (!(n.t <= 0)) {
                        var i = this.abs();
                        if (i.t < n.t)
                            return null != e && e.fromInt(0), void (null != r && this.copyTo(r));
                        null == r && (r = x());
                        var o = x(), s = this.s, a = t.s, u = this.DB - B(n[n.t - 1]);
                        u > 0 ? (n.lShiftTo(u, o), i.lShiftTo(u, r)) : (n.copyTo(o), i.copyTo(r));
                        var c = o.t, h = o[c - 1];
                        if (0 != h) {
                            var l = h * (1 << this.F1) + (c > 1 ? o[c - 2] >> this.F2 : 0), f = this.FV / l, d = (1 << this.F1) / l, g = 1 << this.F2, p = r.t, v = p - c, y = null == e ? x() : e;
                            for (o.dlShiftTo(v, y), r.compareTo(y) >= 0 && (r[r.t++] = 1, r.subTo(y, r)), E.ONE.dlShiftTo(c, y), y.subTo(o, o); o.t < c;)
                                o[o.t++] = 0;
                            for (; --v >= 0;) {
                                var m = r[--p] == h ? this.DM : Math.floor(r[p] * f + (r[p - 1] + g) * d);
                                if ((r[p] += o.am(0, m, r, v, 0, c)) < m)
                                    for (o.dlShiftTo(v, y), r.subTo(y, r); r[p] < --m;)
                                        r.subTo(y, r);
                            }
                            null != e && (r.drShiftTo(c, e), s != a && E.ZERO.subTo(e, e)), r.t = c, r.clamp(), u > 0 && r.rShiftTo(u, r), s < 0 && E.ZERO.subTo(r, r);
                        }
                    } }, E.prototype.invDigit = function vt() { if (this.t < 1)
                        return 0; var t = this[0]; if (0 == (1 & t))
                        return 0; var e = 3 & t; return (e = (e = (e = (e = e * (2 - (15 & t) * e) & 15) * (2 - (255 & t) * e) & 255) * (2 - ((65535 & t) * e & 65535)) & 65535) * (2 - t * e % this.DV) % this.DV) > 0 ? this.DV - e : -e; }, E.prototype.isEven = function yt() { return 0 == (this.t > 0 ? 1 & this[0] : this.s); }, E.prototype.exp = function mt(t, e) { if (t > 4294967295 || t < 1)
                        return E.ONE; var r = x(), n = x(), i = e.convert(this), o = B(t) - 1; for (i.copyTo(r); --o >= 0;)
                        if (e.sqrTo(r, n), (t & 1 << o) > 0)
                            e.mulTo(n, i, r);
                        else {
                            var s = r;
                            r = n, n = s;
                        } return e.revert(r); }, E.prototype.toString = function _t(t) { if (this.s < 0)
                        return "-" + this.negate().toString(t); var e; if (16 == t)
                        e = 4;
                    else if (8 == t)
                        e = 3;
                    else if (2 == t)
                        e = 1;
                    else if (32 == t)
                        e = 5;
                    else {
                        if (4 != t)
                            return this.toRadix(t);
                        e = 2;
                    } var r, n = (1 << e) - 1, i = !1, o = "", s = this.t, a = this.DB - s * this.DB % e; if (s-- > 0)
                        for (a < this.DB && (r = this[s] >> a) > 0 && (i = !0, o = D(r)); s >= 0;)
                            a < e ? (r = (this[s] & (1 << a) - 1) << e - a, r |= this[--s] >> (a += this.DB - e)) : (r = this[s] >> (a -= e) & n, a <= 0 && (a += this.DB, --s)), r > 0 && (i = !0), i && (o += D(r)); return i ? o : "0"; }, E.prototype.negate = function St() { var t = x(); return E.ZERO.subTo(this, t), t; }, E.prototype.abs = function Ft() { return this.s < 0 ? this.negate() : this; }, E.prototype.compareTo = function bt(t) { var e = this.s - t.s; if (0 != e)
                        return e; var r = this.t; if (0 != (e = r - t.t))
                        return this.s < 0 ? -e : e; for (; --r >= 0;)
                        if (0 != (e = this[r] - t[r]))
                            return e; return 0; }, E.prototype.bitLength = function wt() { return this.t <= 0 ? 0 : this.DB * (this.t - 1) + B(this[this.t - 1] ^ this.s & this.DM); }, E.prototype.mod = function Et(t) { var e = x(); return this.abs().divRemTo(t, null, e), this.s < 0 && e.compareTo(E.ZERO) > 0 && t.subTo(e, e), e; }, E.prototype.modPowInt = function xt(t, e) { var r; return r = t < 256 || e.isEven() ? new N(e) : new O(e), this.exp(t, r); }, E.ZERO = L(0), E.ONE = L(1), J.prototype.convert = W, J.prototype.revert = W, J.prototype.mulTo = function kt(t, e, r) { t.multiplyTo(e, r); }, J.prototype.sqrTo = function At(t, e) { t.squareTo(e); }, z.prototype.convert = function Pt(t) { if (t.s < 0 || t.t > 2 * this.m.t)
                        return t.mod(this.m); if (t.compareTo(this.m) < 0)
                        return t; var e = x(); return t.copyTo(e), this.reduce(e), e; }, z.prototype.revert = function Ct(t) { return t; }, z.prototype.reduce = function Tt(t) { for (t.drShiftTo(this.m.t - 1, this.r2), t.t > this.m.t + 1 && (t.t = this.m.t + 1, t.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); t.compareTo(this.r2) < 0;)
                        t.dAddOffset(1, this.m.t + 1); for (t.subTo(this.r2, t); t.compareTo(this.m) >= 0;)
                        t.subTo(this.m, t); }, z.prototype.mulTo = function Rt(t, e, r) { t.multiplyTo(e, r), this.reduce(r); }, z.prototype.sqrTo = function It(t, e) { t.squareTo(e), this.reduce(e); };
                    var Dt = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997], Ut = (1 << 26) / Dt[Dt.length - 1];
                    /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
                     */
                    function Lt() { this.i = 0, this.j = 0, this.S = new Array; }
                    E.prototype.chunkSize = function Bt(t) { return Math.floor(Math.LN2 * this.DB / Math.log(t)); }, E.prototype.toRadix = function Nt(t) { if (null == t && (t = 10), 0 == this.signum() || t < 2 || t > 36)
                        return "0"; var e = this.chunkSize(t), r = Math.pow(t, e), n = L(r), i = x(), o = x(), s = ""; for (this.divRemTo(n, i, o); i.signum() > 0;)
                        s = (r + o.intValue()).toString(t).substr(1) + s, i.divRemTo(n, i, o); return o.intValue().toString(t) + s; }, E.prototype.fromRadix = function Ot(t, e) { this.fromInt(0), null == e && (e = 10); for (var r = this.chunkSize(e), n = Math.pow(e, r), i = !1, o = 0, s = 0, a = 0; a < t.length; ++a) {
                        var u = U(t, a);
                        u < 0 ? "-" == t.charAt(a) && 0 == this.signum() && (i = !0) : (s = e * s + u, ++o >= r && (this.dMultiply(n), this.dAddOffset(s, 0), o = 0, s = 0));
                    } o > 0 && (this.dMultiply(Math.pow(e, o)), this.dAddOffset(s, 0)), i && E.ZERO.subTo(this, this); }, E.prototype.fromNumber = function jt(t, e, r) { if ("number" == typeof e)
                        if (t < 2)
                            this.fromInt(1);
                        else
                            for (this.fromNumber(t, r), this.testBit(t - 1) || this.bitwiseTo(E.ONE.shiftLeft(t - 1), H, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(e);)
                                this.dAddOffset(2, 0), this.bitLength() > t && this.subTo(E.ONE.shiftLeft(t - 1), this);
                    else {
                        var n = new Array, i = 7 & t;
                        n.length = 1 + (t >> 3), e.nextBytes(n), i > 0 ? n[0] &= (1 << i) - 1 : n[0] = 0, this.fromString(n, 256);
                    } }, E.prototype.bitwiseTo = function Ht(t, e, r) { var n, i, o = Math.min(t.t, this.t); for (n = 0; n < o; ++n)
                        r[n] = e(this[n], t[n]); if (t.t < this.t) {
                        for (i = t.s & this.DM, n = o; n < this.t; ++n)
                            r[n] = e(this[n], i);
                        r.t = this.t;
                    }
                    else {
                        for (i = this.s & this.DM, n = o; n < t.t; ++n)
                            r[n] = e(i, t[n]);
                        r.t = t.t;
                    } r.s = e(this.s, t.s), r.clamp(); }, E.prototype.changeBit = function Mt(t, e) { var r = E.ONE.shiftLeft(t); return this.bitwiseTo(r, e, r), r; }, E.prototype.addTo = function Kt(t, e) { for (var r = 0, n = 0, i = Math.min(t.t, this.t); r < i;)
                        n += this[r] + t[r], e[r++] = n & this.DM, n >>= this.DB; if (t.t < this.t) {
                        for (n += t.s; r < this.t;)
                            n += this[r], e[r++] = n & this.DM, n >>= this.DB;
                        n += this.s;
                    }
                    else {
                        for (n += this.s; r < t.t;)
                            n += t[r], e[r++] = n & this.DM, n >>= this.DB;
                        n += t.s;
                    } e.s = n < 0 ? -1 : 0, n > 0 ? e[r++] = n : n < -1 && (e[r++] = this.DV + n), e.t = r, e.clamp(); }, E.prototype.dMultiply = function Vt(t) { this[this.t] = this.am(0, t - 1, this, 0, 0, this.t), ++this.t, this.clamp(); }, E.prototype.dAddOffset = function qt(t, e) { if (0 != t) {
                        for (; this.t <= e;)
                            this[this.t++] = 0;
                        for (this[e] += t; this[e] >= this.DV;)
                            this[e] -= this.DV, ++e >= this.t && (this[this.t++] = 0), ++this[e];
                    } }, E.prototype.multiplyLowerTo = function Jt(t, e, r) { var n, i = Math.min(this.t + t.t, e); for (r.s = 0, r.t = i; i > 0;)
                        r[--i] = 0; for (n = r.t - this.t; i < n; ++i)
                        r[i + this.t] = this.am(0, t[i], r, i, 0, this.t); for (n = Math.min(t.t, e); i < n; ++i)
                        this.am(0, t[i], r, i, 0, e - i); r.clamp(); }, E.prototype.multiplyUpperTo = function Wt(t, e, r) { --e; var n = r.t = this.t + t.t - e; for (r.s = 0; --n >= 0;)
                        r[n] = 0; for (n = Math.max(e - this.t, 0); n < t.t; ++n)
                        r[this.t + n - e] = this.am(e - n, t[n], r, 0, 0, this.t + n - e); r.clamp(), r.drShiftTo(1, r); }, E.prototype.modInt = function zt(t) { if (t <= 0)
                        return 0; var e = this.DV % t, r = this.s < 0 ? t - 1 : 0; if (this.t > 0)
                        if (0 == e)
                            r = this[0] % t;
                        else
                            for (var n = this.t - 1; n >= 0; --n)
                                r = (e * r + this[n]) % t; return r; }, E.prototype.millerRabin = function Yt(t) { var e = this.subtract(E.ONE), r = e.getLowestSetBit(); if (r <= 0)
                        return !1; var n = e.shiftRight(r); (t = t + 1 >> 1) > Dt.length && (t = Dt.length); for (var i = x(), o = 0; o < t; ++o) {
                        i.fromInt(Dt[Math.floor(Math.random() * Dt.length)]);
                        var s = i.modPow(n, this);
                        if (0 != s.compareTo(E.ONE) && 0 != s.compareTo(e)) {
                            for (var a = 1; a++ < r && 0 != s.compareTo(e);)
                                if (0 == (s = s.modPowInt(2, this)).compareTo(E.ONE))
                                    return !1;
                            if (0 != s.compareTo(e))
                                return !1;
                        }
                    } return !0; }, E.prototype.clone =
                        /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
                         */
                        function Gt() { var t = x(); return this.copyTo(t), t; }, E.prototype.intValue = function Xt() { if (this.s < 0) {
                        if (1 == this.t)
                            return this[0] - this.DV;
                        if (0 == this.t)
                            return -1;
                    }
                    else {
                        if (1 == this.t)
                            return this[0];
                        if (0 == this.t)
                            return 0;
                    } return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0]; }, E.prototype.byteValue = function Qt() { return 0 == this.t ? this.s : this[0] << 24 >> 24; }, E.prototype.shortValue = function $t() { return 0 == this.t ? this.s : this[0] << 16 >> 16; }, E.prototype.signum = function Zt() { return this.s < 0 ? -1 : this.t <= 0 || 1 == this.t && this[0] <= 0 ? 0 : 1; }, E.prototype.toByteArray = function te() { var t = this.t, e = new Array; e[0] = this.s; var r, n = this.DB - t * this.DB % 8, i = 0; if (t-- > 0)
                        for (n < this.DB && (r = this[t] >> n) != (this.s & this.DM) >> n && (e[i++] = r | this.s << this.DB - n); t >= 0;)
                            n < 8 ? (r = (this[t] & (1 << n) - 1) << 8 - n, r |= this[--t] >> (n += this.DB - 8)) : (r = this[t] >> (n -= 8) & 255, n <= 0 && (n += this.DB, --t)), 0 != (128 & r) && (r |= -256), 0 == i && (128 & this.s) != (128 & r) && ++i, (i > 0 || r != this.s) && (e[i++] = r); return e; }, E.prototype.equals = function ee(t) { return 0 == this.compareTo(t); }, E.prototype.min = function re(t) { return this.compareTo(t) < 0 ? this : t; }, E.prototype.max = function ne(t) { return this.compareTo(t) > 0 ? this : t; }, E.prototype.and = function ie(t) { var e = x(); return this.bitwiseTo(t, j, e), e; }, E.prototype.or = function oe(t) { var e = x(); return this.bitwiseTo(t, H, e), e; }, E.prototype.xor = function se(t) { var e = x(); return this.bitwiseTo(t, M, e), e; }, E.prototype.andNot = function ae(t) { var e = x(); return this.bitwiseTo(t, K, e), e; }, E.prototype.not = function ue() { for (var t = x(), e = 0; e < this.t; ++e)
                        t[e] = this.DM & ~this[e]; return t.t = this.t, t.s = ~this.s, t; }, E.prototype.shiftLeft = function ce(t) { var e = x(); return t < 0 ? this.rShiftTo(-t, e) : this.lShiftTo(t, e), e; }, E.prototype.shiftRight = function he(t) { var e = x(); return t < 0 ? this.lShiftTo(-t, e) : this.rShiftTo(t, e), e; }, E.prototype.getLowestSetBit = function le() { for (var t = 0; t < this.t; ++t)
                        if (0 != this[t])
                            return t * this.DB + V(this[t]); return this.s < 0 ? this.t * this.DB : -1; }, E.prototype.bitCount = function fe() { for (var t = 0, e = this.s & this.DM, r = 0; r < this.t; ++r)
                        t += q(this[r] ^ e); return t; }, E.prototype.testBit = function de(t) { var e = Math.floor(t / this.DB); return e >= this.t ? 0 != this.s : 0 != (this[e] & 1 << t % this.DB); }, E.prototype.setBit = function ge(t) { return this.changeBit(t, H); }, E.prototype.clearBit = function pe(t) { return this.changeBit(t, K); }, E.prototype.flipBit = function ve(t) { return this.changeBit(t, M); }, E.prototype.add = function ye(t) { var e = x(); return this.addTo(t, e), e; }, E.prototype.subtract = function me(t) { var e = x(); return this.subTo(t, e), e; }, E.prototype.multiply = function _e(t) { var e = x(); return this.multiplyTo(t, e), e; }, E.prototype.divide = function Se(t) { var e = x(); return this.divRemTo(t, e, null), e; }, E.prototype.remainder = function Fe(t) { var e = x(); return this.divRemTo(t, null, e), e; }, E.prototype.divideAndRemainder = function be(t) { var e = x(), r = x(); return this.divRemTo(t, e, r), new Array(e, r); }, E.prototype.modPow = function we(t, e) { var r, n, i = t.bitLength(), o = L(1); if (i <= 0)
                        return o; r = i < 18 ? 1 : i < 48 ? 3 : i < 144 ? 4 : i < 768 ? 5 : 6, n = i < 8 ? new N(e) : e.isEven() ? new z(e) : new O(e); var s = new Array, a = 3, u = r - 1, c = (1 << r) - 1; if (s[1] = n.convert(this), r > 1) {
                        var h = x();
                        for (n.sqrTo(s[1], h); a <= c;)
                            s[a] = x(), n.mulTo(h, s[a - 2], s[a]), a += 2;
                    } var l, f, d = t.t - 1, g = !0, p = x(); for (i = B(t[d]) - 1; d >= 0;) {
                        for (i >= u ? l = t[d] >> i - u & c : (l = (t[d] & (1 << i + 1) - 1) << u - i, d > 0 && (l |= t[d - 1] >> this.DB + i - u)), a = r; 0 == (1 & l);)
                            l >>= 1, --a;
                        if ((i -= a) < 0 && (i += this.DB, --d), g)
                            s[l].copyTo(o), g = !1;
                        else {
                            for (; a > 1;)
                                n.sqrTo(o, p), n.sqrTo(p, o), a -= 2;
                            a > 0 ? n.sqrTo(o, p) : (f = o, o = p, p = f), n.mulTo(p, s[l], o);
                        }
                        for (; d >= 0 && 0 == (t[d] & 1 << i);)
                            n.sqrTo(o, p), f = o, o = p, p = f, --i < 0 && (i = this.DB - 1, --d);
                    } return n.revert(o); }, E.prototype.modInverse = function Ee(t) { var e = t.isEven(); if (this.isEven() && e || 0 == t.signum())
                        return E.ZERO; for (var r = t.clone(), n = this.clone(), i = L(1), o = L(0), s = L(0), a = L(1); 0 != r.signum();) {
                        for (; r.isEven();)
                            r.rShiftTo(1, r), e ? (i.isEven() && o.isEven() || (i.addTo(this, i), o.subTo(t, o)), i.rShiftTo(1, i)) : o.isEven() || o.subTo(t, o), o.rShiftTo(1, o);
                        for (; n.isEven();)
                            n.rShiftTo(1, n), e ? (s.isEven() && a.isEven() || (s.addTo(this, s), a.subTo(t, a)), s.rShiftTo(1, s)) : a.isEven() || a.subTo(t, a), a.rShiftTo(1, a);
                        r.compareTo(n) >= 0 ? (r.subTo(n, r), e && i.subTo(s, i), o.subTo(a, o)) : (n.subTo(r, n), e && s.subTo(i, s), a.subTo(o, a));
                    } return 0 != n.compareTo(E.ONE) ? E.ZERO : a.compareTo(t) >= 0 ? a.subtract(t) : a.signum() < 0 ? (a.addTo(t, a), a.signum() < 0 ? a.add(t) : a) : a; }, E.prototype.pow = function xe(t) { return this.exp(t, new J); }, E.prototype.gcd = function ke(t) { var e = this.s < 0 ? this.negate() : this.clone(), r = t.s < 0 ? t.negate() : t.clone(); if (e.compareTo(r) < 0) {
                        var n = e;
                        e = r, r = n;
                    } var i = e.getLowestSetBit(), o = r.getLowestSetBit(); if (o < 0)
                        return e; for (i < o && (o = i), o > 0 && (e.rShiftTo(o, e), r.rShiftTo(o, r)); e.signum() > 0;)
                        (i = e.getLowestSetBit()) > 0 && e.rShiftTo(i, e), (i = r.getLowestSetBit()) > 0 && r.rShiftTo(i, r), e.compareTo(r) >= 0 ? (e.subTo(r, e), e.rShiftTo(1, e)) : (r.subTo(e, r), r.rShiftTo(1, r)); return o > 0 && r.lShiftTo(o, r), r; }, E.prototype.isProbablePrime = function Ae(t) { var e, r = this.abs(); if (1 == r.t && r[0] <= Dt[Dt.length - 1]) {
                        for (e = 0; e < Dt.length; ++e)
                            if (r[0] == Dt[e])
                                return !0;
                        return !1;
                    } if (r.isEven())
                        return !1; for (e = 1; e < Dt.length;) {
                        for (var n = Dt[e], i = e + 1; i < Dt.length && n < Ut;)
                            n *= Dt[i++];
                        for (n = r.modInt(n); e < i;)
                            if (n % Dt[e++] == 0)
                                return !1;
                    } return r.millerRabin(t); }, E.prototype.square = function Pe() { var t = x(); return this.squareTo(t), t; }, Lt.prototype.init = function Ce(t) { var e, r, n; for (e = 0; e < 256; ++e)
                        this.S[e] = e; for (r = 0, e = 0; e < 256; ++e)
                        r = r + this.S[e] + t[e % t.length] & 255, n = this.S[e], this.S[e] = this.S[r], this.S[r] = n; this.i = 0, this.j = 0; }, Lt.prototype.next = function Te() { var t; return this.i = this.i + 1 & 255, this.j = this.j + this.S[this.i] & 255, t = this.S[this.i], this.S[this.i] = this.S[this.j], this.S[this.j] = t, this.S[t + this.S[this.i] & 255]; };
                    var Re, Ie, De, Ue = 256;
                    /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
                     */ function Le() { !function t(e) { Ie[De++] ^= 255 & e, Ie[De++] ^= e >> 8 & 255, Ie[De++] ^= e >> 16 & 255, Ie[De++] ^= e >> 24 & 255, De >= Ue && (De -= Ue); }((new Date).getTime()); }
                    if (null == Ie) {
                        var Be;
                        if (Ie = new Array, De = 0, void 0 !== i && (void 0 !== i.msCrypto)) {
                            var Ne = i.msCrypto;
                            if (Ne.getRandomValues) {
                                var Oe = new Uint8Array(32);
                                for (Ne.getRandomValues(Oe), Be = 0; Be < 32; ++Be)
                                    Ie[De++] = Oe[Be];
                            }
                        }
                        for (; De < Ue;)
                            Be = Math.floor(65536 * Math.random()), Ie[De++] = Be >>> 8, Ie[De++] = 255 & Be;
                        De = 0, Le();
                    }
                    function He() { if (null == Re) {
                        for (Le(), (Re = function t() { return new Lt; }()).init(Ie), De = 0; De < Ie.length; ++De)
                            Ie[De] = 0;
                        De = 0;
                    } return Re.next(); }
                    function Me() { }
                    /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
                     */
                    function Ke(t, e) { return new E(t, e); }
                    function Ve(t, e, r) { for (var n = "", i = 0; n.length < e;)
                        n += r(String.fromCharCode.apply(String, t.concat([(4278190080 & i) >> 24, (16711680 & i) >> 16, (65280 & i) >> 8, 255 & i]))), i += 1; return n; }
                    function qe() { this.n = null, this.e = 0, this.d = null, this.p = null, this.q = null, this.dmp1 = null, this.dmq1 = null, this.coeff = null; }
                    /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
                     */
                    function Je(t, e) { this.x = e, this.q = t; }
                    function We(t, e, r, n) { this.curve = t, this.x = e, this.y = r, this.z = null == n ? E.ONE : n, this.zinv = null; }
                    function ze(t, e, r) { this.q = t, this.a = this.fromBigInteger(e), this.b = this.fromBigInteger(r), this.infinity = new We(this, null, null); }
                    Me.prototype.nextBytes = function Ye(t) { var e; for (e = 0; e < t.length; ++e)
                        t[e] = He(); }, qe.prototype.doPublic = function Ge(t) { return t.modPowInt(this.e, this.n); }, qe.prototype.setPublic = function Xe(t, e) { if (this.isPublic = !0, this.isPrivate = !1, "string" != typeof t)
                        this.n = t, this.e = e;
                    else {
                        if (!(null != t && null != e && t.length > 0 && e.length > 0))
                            throw "Invalid RSA public key";
                        this.n = Ke(t, 16), this.e = parseInt(e, 16);
                    } }, qe.prototype.encrypt = function Qe(t) { var e = function r(t, e) { if (e < t.length + 11)
                        throw "Message too long for RSA"; for (var r = new Array, n = t.length - 1; n >= 0 && e > 0;) {
                        var i = t.charCodeAt(n--);
                        i < 128 ? r[--e] = i : i > 127 && i < 2048 ? (r[--e] = 63 & i | 128, r[--e] = i >> 6 | 192) : (r[--e] = 63 & i | 128, r[--e] = i >> 6 & 63 | 128, r[--e] = i >> 12 | 224);
                    } r[--e] = 0; for (var o = new Me, s = new Array; e > 2;) {
                        for (s[0] = 0; 0 == s[0];)
                            o.nextBytes(s);
                        r[--e] = s[0];
                    } return r[--e] = 2, r[--e] = 0, new E(r); }(t, this.n.bitLength() + 7 >> 3); if (null == e)
                        return null; var n = this.doPublic(e); if (null == n)
                        return null; var i = n.toString(16); return 0 == (1 & i.length) ? i : "0" + i; }, qe.prototype.encryptOAEP = function $e(t, e, r) { var n = function i(t, e, r, n) { var i = Er.crypto.MessageDigest, o = Er.crypto.Util, s = null; if (r || (r = "sha1"), "string" == typeof r && (s = i.getCanonicalAlgName(r), n = i.getHashLength(s), r = function t(e) { return Or(o.hashHex(jr(e), s)); }), t.length + 2 * n + 2 > e)
                        throw "Message too long for RSA"; var a, u = ""; for (a = 0; a < e - t.length - 2 * n - 2; a += 1)
                        u += "\0"; var c = r("") + u + "" + t, h = new Array(n); (new Me).nextBytes(h); var l = Ve(h, c.length, r), f = []; for (a = 0; a < c.length; a += 1)
                        f[a] = c.charCodeAt(a) ^ l.charCodeAt(a); var d = Ve(f, h.length, r), g = [0]; for (a = 0; a < h.length; a += 1)
                        g[a + 1] = h[a] ^ d.charCodeAt(a); return new E(g.concat(f)); }(t, this.n.bitLength() + 7 >> 3, e, r); if (null == n)
                        return null; var o = this.doPublic(n); if (null == o)
                        return null; var s = o.toString(16); return 0 == (1 & s.length) ? s : "0" + s; }, qe.prototype.type = "RSA", Je.prototype.equals = function Ze(t) { return t == this || this.q.equals(t.q) && this.x.equals(t.x); }, Je.prototype.toBigInteger = function tr() { return this.x; }, Je.prototype.negate = function er() { return new Je(this.q, this.x.negate().mod(this.q)); }, Je.prototype.add = function rr(t) { return new Je(this.q, this.x.add(t.toBigInteger()).mod(this.q)); }, Je.prototype.subtract = function nr(t) { return new Je(this.q, this.x.subtract(t.toBigInteger()).mod(this.q)); }, Je.prototype.multiply = function ir(t) { return new Je(this.q, this.x.multiply(t.toBigInteger()).mod(this.q)); }, Je.prototype.square = function or() { return new Je(this.q, this.x.square().mod(this.q)); }, Je.prototype.divide = function sr(t) { return new Je(this.q, this.x.multiply(t.toBigInteger().modInverse(this.q)).mod(this.q)); }, We.prototype.getX = function ar() { return null == this.zinv && (this.zinv = this.z.modInverse(this.curve.q)), this.curve.fromBigInteger(this.x.toBigInteger().multiply(this.zinv).mod(this.curve.q)); }, We.prototype.getY = function ur() { return null == this.zinv && (this.zinv = this.z.modInverse(this.curve.q)), this.curve.fromBigInteger(this.y.toBigInteger().multiply(this.zinv).mod(this.curve.q)); }, We.prototype.equals = function cr(t) { return t == this || (this.isInfinity() ? t.isInfinity() : t.isInfinity() ? this.isInfinity() : !!t.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t.z)).mod(this.curve.q).equals(E.ZERO) && t.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t.z)).mod(this.curve.q).equals(E.ZERO)); }, We.prototype.isInfinity = function hr() { return null == this.x && null == this.y || this.z.equals(E.ZERO) && !this.y.toBigInteger().equals(E.ZERO); }, We.prototype.negate = function lr() { return new We(this.curve, this.x, this.y.negate(), this.z); }, We.prototype.add = function fr(t) { if (this.isInfinity())
                        return t; if (t.isInfinity())
                        return this; var e = t.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t.z)).mod(this.curve.q), r = t.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t.z)).mod(this.curve.q); if (E.ZERO.equals(r))
                        return E.ZERO.equals(e) ? this.twice() : this.curve.getInfinity(); var n = new E("3"), i = this.x.toBigInteger(), o = this.y.toBigInteger(), s = (t.x.toBigInteger(), t.y.toBigInteger(), r.square()), a = s.multiply(r), u = i.multiply(s), c = e.square().multiply(this.z), h = c.subtract(u.shiftLeft(1)).multiply(t.z).subtract(a).multiply(r).mod(this.curve.q), l = u.multiply(n).multiply(e).subtract(o.multiply(a)).subtract(c.multiply(e)).multiply(t.z).add(e.multiply(a)).mod(this.curve.q), f = a.multiply(this.z).multiply(t.z).mod(this.curve.q); return new We(this.curve, this.curve.fromBigInteger(h), this.curve.fromBigInteger(l), f); }, We.prototype.twice = function dr() { if (this.isInfinity())
                        return this; if (0 == this.y.toBigInteger().signum())
                        return this.curve.getInfinity(); var t = new E("3"), e = this.x.toBigInteger(), r = this.y.toBigInteger(), n = r.multiply(this.z), i = n.multiply(r).mod(this.curve.q), o = this.curve.a.toBigInteger(), s = e.square().multiply(t); E.ZERO.equals(o) || (s = s.add(this.z.square().multiply(o))); var a = (s = s.mod(this.curve.q)).square().subtract(e.shiftLeft(3).multiply(i)).shiftLeft(1).multiply(n).mod(this.curve.q), u = s.multiply(t).multiply(e).subtract(i.shiftLeft(1)).shiftLeft(2).multiply(i).subtract(s.square().multiply(s)).mod(this.curve.q), c = n.square().multiply(n).shiftLeft(3).mod(this.curve.q); return new We(this.curve, this.curve.fromBigInteger(a), this.curve.fromBigInteger(u), c); }, We.prototype.multiply = function gr(t) { if (this.isInfinity())
                        return this; if (0 == t.signum())
                        return this.curve.getInfinity(); var e, r = t, n = r.multiply(new E("3")), i = this.negate(), o = this; for (e = n.bitLength() - 2; e > 0; --e) {
                        o = o.twice();
                        var s = n.testBit(e);
                        s != r.testBit(e) && (o = o.add(s ? this : i));
                    } return o; }, We.prototype.multiplyTwo = function pr(t, e, r) { var n; n = t.bitLength() > r.bitLength() ? t.bitLength() - 1 : r.bitLength() - 1; for (var i = this.curve.getInfinity(), o = this.add(e); n >= 0;)
                        i = i.twice(), t.testBit(n) ? i = r.testBit(n) ? i.add(o) : i.add(this) : r.testBit(n) && (i = i.add(e)), --n; return i; }, ze.prototype.getQ = function vr() { return this.q; }, ze.prototype.getA = function yr() { return this.a; }, ze.prototype.getB = function mr() { return this.b; }, ze.prototype.equals = function _r(t) { return t == this || this.q.equals(t.q) && this.a.equals(t.a) && this.b.equals(t.b); }, ze.prototype.getInfinity = function Sr() { return this.infinity; }, ze.prototype.fromBigInteger = function Fr(t) { return new Je(this.q, t); }, ze.prototype.decodePointHex = function br(t) { switch (parseInt(t.substr(0, 2), 16)) {
                        case 0: return this.infinity;
                        case 2:
                        case 3: return null;
                        case 4:
                        case 6:
                        case 7:
                            var e = (t.length - 2) / 2, r = t.substr(2, e), n = t.substr(e + 2, e);
                            return new We(this, this.fromBigInteger(new E(r, 16)), this.fromBigInteger(new E(n, 16)));
                        default: return null;
                    } },
                        /*! (c) Stefan Thomas | https://github.com/bitcoinjs/bitcoinjs-lib
                         */
                        Je.prototype.getByteLength = function () { return Math.floor((this.toBigInteger().bitLength() + 7) / 8); }, We.prototype.getEncoded = function (t) { var e = function t(e, r) { var n = e.toByteArrayUnsigned(); if (r < n.length)
                        n = n.slice(n.length - r);
                    else
                        for (; r > n.length;)
                            n.unshift(0); return n; }, r = this.getX().toBigInteger(), n = this.getY().toBigInteger(), i = e(r, 32); return t ? n.isEven() ? i.unshift(2) : i.unshift(3) : (i.unshift(4), i = i.concat(e(n, 32))), i; }, We.decodeFrom = function (t, e) { var r = e.length - 1, n = e.slice(1, 1 + r / 2), i = e.slice(1 + r / 2, 1 + r); n.unshift(0), i.unshift(0); var o = new E(n), s = new E(i); return new We(t, t.fromBigInteger(o), t.fromBigInteger(s)); }, We.decodeFromHex = function (t, e) { e.substr(0, 2); var r = e.length - 2, n = e.substr(2, r / 2), i = e.substr(2 + r / 2, r / 2), o = new E(n, 16), s = new E(i, 16); return new We(t, t.fromBigInteger(o), t.fromBigInteger(s)); }, We.prototype.add2D = function (t) { if (this.isInfinity())
                        return t; if (t.isInfinity())
                        return this; if (this.x.equals(t.x))
                        return this.y.equals(t.y) ? this.twice() : this.curve.getInfinity(); var e = t.x.subtract(this.x), r = t.y.subtract(this.y).divide(e), n = r.square().subtract(this.x).subtract(t.x), i = r.multiply(this.x.subtract(n)).subtract(this.y); return new We(this.curve, n, i); }, We.prototype.twice2D = function () { if (this.isInfinity())
                        return this; if (0 == this.y.toBigInteger().signum())
                        return this.curve.getInfinity(); var t = this.curve.fromBigInteger(E.valueOf(2)), e = this.curve.fromBigInteger(E.valueOf(3)), r = this.x.square().multiply(e).add(this.curve.a).divide(this.y.multiply(t)), n = r.square().subtract(this.x.multiply(t)), i = r.multiply(this.x.subtract(n)).subtract(this.y); return new We(this.curve, n, i); }, We.prototype.multiply2D = function (t) { if (this.isInfinity())
                        return this; if (0 == t.signum())
                        return this.curve.getInfinity(); var e, r = t, n = r.multiply(new E("3")), i = this.negate(), o = this; for (e = n.bitLength() - 2; e > 0; --e) {
                        o = o.twice();
                        var s = n.testBit(e);
                        s != r.testBit(e) && (o = o.add2D(s ? this : i));
                    } return o; }, We.prototype.isOnCurve = function () { var t = this.getX().toBigInteger(), e = this.getY().toBigInteger(), r = this.curve.getA().toBigInteger(), n = this.curve.getB().toBigInteger(), i = this.curve.getQ(), o = e.multiply(e).mod(i), s = t.multiply(t).multiply(t).add(r.multiply(t)).add(n).mod(i); return o.equals(s); }, We.prototype.toString = function () { return "(" + this.getX().toBigInteger().toString() + "," + this.getY().toBigInteger().toString() + ")"; }, We.prototype.validate = function () { var t = this.curve.getQ(); if (this.isInfinity())
                        throw new Error("Point is at infinity."); var e = this.getX().toBigInteger(), r = this.getY().toBigInteger(); if (e.compareTo(E.ONE) < 0 || e.compareTo(t.subtract(E.ONE)) > 0)
                        throw new Error("x coordinate out of bounds"); if (r.compareTo(E.ONE) < 0 || r.compareTo(t.subtract(E.ONE)) > 0)
                        throw new Error("y coordinate out of bounds"); if (!this.isOnCurve())
                        throw new Error("Point is not on the curve."); if (this.multiply(t).isInfinity())
                        throw new Error("Point is not a scalar multiple of G."); return !0; };
                    /*! Mike Samuel (c) 2009 | code.google.com/p/json-sans-eval
                     */
                    var wr = function () { var t = new RegExp('(?:false|true|null|[\\{\\}\\[\\]]|(?:-?\\b(?:0|[1-9][0-9]*)(?:\\.[0-9]+)?(?:[eE][+-]?[0-9]+)?\\b)|(?:"(?:[^\\0-\\x08\\x0a-\\x1f"\\\\]|\\\\(?:["/\\\\bfnrt]|u[0-9A-Fa-f]{4}))*"))', "g"), e = new RegExp("\\\\(?:([^u])|u(.{4}))", "g"), n = { '"': '"', "/": "/", "\\": "\\", b: "\b", f: "\f", n: "\n", r: "\r", t: "\t" }; function i(t, e, r) { return e ? n[e] : String.fromCharCode(parseInt(r, 16)); } var o = new String(""), s = (Object.hasOwnProperty); return function (n, a) { var u, c, h = n.match(t), l = h[0], f = !1; "{" === l ? u = {} : "[" === l ? u = [] : (u = [], f = !0); for (var d = [u], g = 1 - f, p = h.length; g < p; ++g) {
                        var v;
                        switch ((l = h[g]).charCodeAt(0)) {
                            default:
                                (v = d[0])[c || v.length] = +l, c = void 0;
                                break;
                            case 34:
                                if (-1 !== (l = l.substring(1, l.length - 1)).indexOf("\\") && (l = l.replace(e, i)), v = d[0], !c) {
                                    if (!(v instanceof Array)) {
                                        c = l || o;
                                        break;
                                    }
                                    c = v.length;
                                }
                                v[c] = l, c = void 0;
                                break;
                            case 91:
                                v = d[0], d.unshift(v[c || v.length] = []), c = void 0;
                                break;
                            case 93:
                                d.shift();
                                break;
                            case 102:
                                (v = d[0])[c || v.length] = !1, c = void 0;
                                break;
                            case 110:
                                (v = d[0])[c || v.length] = null, c = void 0;
                                break;
                            case 116:
                                (v = d[0])[c || v.length] = !0, c = void 0;
                                break;
                            case 123:
                                v = d[0], d.unshift(v[c || v.length] = {}), c = void 0;
                                break;
                            case 125: d.shift();
                        }
                    } if (f) {
                        if (1 !== d.length)
                            throw new Error;
                        u = u[0];
                    }
                    else if (d.length)
                        throw new Error; if (a) {
                        u = function t(e, n) { var i = e[n]; if (i && "object" === (void 0 === i ? "undefined" : r(i))) {
                            var o = null;
                            for (var u in i)
                                if (s.call(i, u) && i !== e) {
                                    var c = t(i, u);
                                    void 0 !== c ? i[u] = c : (o || (o = []), o.push(u));
                                }
                            if (o)
                                for (var h = o.length; --h >= 0;)
                                    delete i[o[h]];
                        } return a.call(e, n, i); }({ "": u }, "");
                    } return u; }; }();
                    void 0 !== Er && Er || (e.KJUR = Er = {}), void 0 !== Er.asn1 && Er.asn1 || (Er.asn1 = {}), Er.asn1.ASN1Util = new function () { this.integerToByteHex = function (t) { var e = t.toString(16); return e.length % 2 == 1 && (e = "0" + e), e; }, this.bigIntToMinTwosComplementsHex = function (t) { var e = t.toString(16); if ("-" != e.substr(0, 1))
                        e.length % 2 == 1 ? e = "0" + e : e.match(/^[0-7]/) || (e = "00" + e);
                    else {
                        var r = e.substr(1).length;
                        r % 2 == 1 ? r += 1 : e.match(/^[0-7]/) || (r += 2);
                        for (var n = "", i = 0; i < r; i++)
                            n += "f";
                        e = new E(n, 16).xor(t).add(E.ONE).toString(16).replace(/^-/, "");
                    } return e; }, this.getPEMStringFromHex = function (t, e) { return Vr(t, e); }, this.newObject = function (t) { var e = Er.asn1, r = e.DERBoolean, n = e.DERInteger, i = e.DERBitString, o = e.DEROctetString, s = e.DERNull, a = e.DERObjectIdentifier, u = e.DEREnumerated, c = e.DERUTF8String, h = e.DERNumericString, l = e.DERPrintableString, f = e.DERTeletexString, d = e.DERIA5String, g = e.DERUTCTime, p = e.DERGeneralizedTime, v = e.DERSequence, y = e.DERSet, m = e.DERTaggedObject, _ = e.ASN1Util.newObject, S = Object.keys(t); if (1 != S.length)
                        throw "key of param shall be only one."; var F = S[0]; if (-1 == ":bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:".indexOf(":" + F + ":"))
                        throw "undefined key: " + F; if ("bool" == F)
                        return new r(t[F]); if ("int" == F)
                        return new n(t[F]); if ("bitstr" == F)
                        return new i(t[F]); if ("octstr" == F)
                        return new o(t[F]); if ("null" == F)
                        return new s(t[F]); if ("oid" == F)
                        return new a(t[F]); if ("enum" == F)
                        return new u(t[F]); if ("utf8str" == F)
                        return new c(t[F]); if ("numstr" == F)
                        return new h(t[F]); if ("prnstr" == F)
                        return new l(t[F]); if ("telstr" == F)
                        return new f(t[F]); if ("ia5str" == F)
                        return new d(t[F]); if ("utctime" == F)
                        return new g(t[F]); if ("gentime" == F)
                        return new p(t[F]); if ("seq" == F) {
                        for (var b = t[F], w = [], E = 0; E < b.length; E++) {
                            var x = _(b[E]);
                            w.push(x);
                        }
                        return new v({ array: w });
                    } if ("set" == F) {
                        for (b = t[F], w = [], E = 0; E < b.length; E++) {
                            x = _(b[E]);
                            w.push(x);
                        }
                        return new y({ array: w });
                    } if ("tag" == F) {
                        var k = t[F];
                        if ("[object Array]" === Object.prototype.toString.call(k) && 3 == k.length) {
                            var A = _(k[2]);
                            return new m({ tag: k[0], explicit: k[1], obj: A });
                        }
                        var P = {};
                        if (void 0 !== k.explicit && (P.explicit = k.explicit), void 0 !== k.tag && (P.tag = k.tag), void 0 === k.obj)
                            throw "obj shall be specified for 'tag'.";
                        return P.obj = _(k.obj), new m(P);
                    } }, this.jsonToASN1HEX = function (t) { return this.newObject(t).getEncodedHex(); }; }, Er.asn1.ASN1Util.oidHexToInt = function (t) { for (var e = "", r = parseInt(t.substr(0, 2), 16), n = (e = Math.floor(r / 40) + "." + r % 40, ""), i = 2; i < t.length; i += 2) {
                        var o = ("00000000" + parseInt(t.substr(i, 2), 16).toString(2)).slice(-8);
                        if (n += o.substr(1, 7), "0" == o.substr(0, 1))
                            e = e + "." + new E(n, 2).toString(10), n = "";
                    } return e; }, Er.asn1.ASN1Util.oidIntToHex = function (t) { var e = function t(e) { var r = e.toString(16); return 1 == r.length && (r = "0" + r), r; }, r = function t(r) { var n = "", i = new E(r, 10).toString(2), o = 7 - i.length % 7; 7 == o && (o = 0); for (var s = "", a = 0; a < o; a++)
                        s += "0"; i = s + i; for (a = 0; a < i.length - 1; a += 7) {
                        var u = i.substr(a, 7);
                        a != i.length - 7 && (u = "1" + u), n += e(parseInt(u, 2));
                    } return n; }; if (!t.match(/^[0-9.]+$/))
                        throw "malformed oid string: " + t; var n = "", i = t.split("."), o = 40 * parseInt(i[0]) + parseInt(i[1]); n += e(o), i.splice(0, 2); for (var s = 0; s < i.length; s++)
                        n += r(i[s]); return n; }, Er.asn1.ASN1Object = function () { this.getLengthHexFromValue = function () { if (void 0 === this.hV || null == this.hV)
                        throw "this.hV is null or undefined."; if (this.hV.length % 2 == 1)
                        throw "value hex must be even length: n=" + "".length + ",v=" + this.hV; var t = this.hV.length / 2, e = t.toString(16); if (e.length % 2 == 1 && (e = "0" + e), t < 128)
                        return e; var r = e.length / 2; if (r > 15)
                        throw "ASN.1 length too long to represent by 8x: n = " + t.toString(16); return (128 + r).toString(16) + e; }, this.getEncodedHex = function () { return (null == this.hTLV || this.isModified) && (this.hV = this.getFreshValueHex(), this.hL = this.getLengthHexFromValue(), this.hTLV = this.hT + this.hL + this.hV, this.isModified = !1), this.hTLV; }, this.getValueHex = function () { return this.getEncodedHex(), this.hV; }, this.getFreshValueHex = function () { return ""; }; }, Er.asn1.DERAbstractString = function (t) { Er.asn1.DERAbstractString.superclass.constructor.call(this); this.getString = function () { return this.s; }, this.setString = function (t) { this.hTLV = null, this.isModified = !0, this.s = t, this.hV = Br(this.s).toLowerCase(); }, this.setStringHex = function (t) { this.hTLV = null, this.isModified = !0, this.s = null, this.hV = t; }, this.getFreshValueHex = function () { return this.hV; }, void 0 !== t && ("string" == typeof t ? this.setString(t) : void 0 !== t.str ? this.setString(t.str) : void 0 !== t.hex && this.setStringHex(t.hex)); }, o.lang.extend(Er.asn1.DERAbstractString, Er.asn1.ASN1Object), Er.asn1.DERAbstractTime = function (t) { Er.asn1.DERAbstractTime.superclass.constructor.call(this); this.localDateToUTC = function (t) { return utc = t.getTime() + 6e4 * t.getTimezoneOffset(), new Date(utc); }, this.formatDate = function (t, e, r) { var n = this.zeroPadding, i = this.localDateToUTC(t), o = String(i.getFullYear()); "utc" == e && (o = o.substr(2, 2)); var s = o + n(String(i.getMonth() + 1), 2) + n(String(i.getDate()), 2) + n(String(i.getHours()), 2) + n(String(i.getMinutes()), 2) + n(String(i.getSeconds()), 2); if (!0 === r) {
                        var a = i.getMilliseconds();
                        if (0 != a) {
                            var u = n(String(a), 3);
                            s = s + "." + (u = u.replace(/[0]+$/, ""));
                        }
                    } return s + "Z"; }, this.zeroPadding = function (t, e) { return t.length >= e ? t : new Array(e - t.length + 1).join("0") + t; }, this.getString = function () { return this.s; }, this.setString = function (t) { this.hTLV = null, this.isModified = !0, this.s = t, this.hV = Rr(t); }, this.setByDateValue = function (t, e, r, n, i, o) { var s = new Date(Date.UTC(t, e - 1, r, n, i, o, 0)); this.setByDate(s); }, this.getFreshValueHex = function () { return this.hV; }; }, o.lang.extend(Er.asn1.DERAbstractTime, Er.asn1.ASN1Object), Er.asn1.DERAbstractStructured = function (t) { Er.asn1.DERAbstractString.superclass.constructor.call(this); this.setByASN1ObjectArray = function (t) { this.hTLV = null, this.isModified = !0, this.asn1Array = t; }, this.appendASN1Object = function (t) { this.hTLV = null, this.isModified = !0, this.asn1Array.push(t); }, this.asn1Array = new Array, void 0 !== t && void 0 !== t.array && (this.asn1Array = t.array); }, o.lang.extend(Er.asn1.DERAbstractStructured, Er.asn1.ASN1Object), Er.asn1.DERBoolean = function () { Er.asn1.DERBoolean.superclass.constructor.call(this), this.hT = "01", this.hTLV = "0101ff"; }, o.lang.extend(Er.asn1.DERBoolean, Er.asn1.ASN1Object), Er.asn1.DERInteger = function (t) { Er.asn1.DERInteger.superclass.constructor.call(this), this.hT = "02", this.setByBigInteger = function (t) { this.hTLV = null, this.isModified = !0, this.hV = Er.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t); }, this.setByInteger = function (t) { var e = new E(String(t), 10); this.setByBigInteger(e); }, this.setValueHex = function (t) { this.hV = t; }, this.getFreshValueHex = function () { return this.hV; }, void 0 !== t && (void 0 !== t.bigint ? this.setByBigInteger(t.bigint) : void 0 !== t.int ? this.setByInteger(t.int) : "number" == typeof t ? this.setByInteger(t) : void 0 !== t.hex && this.setValueHex(t.hex)); }, o.lang.extend(Er.asn1.DERInteger, Er.asn1.ASN1Object), Er.asn1.DERBitString = function (t) { if (void 0 !== t && void 0 !== t.obj) {
                        var e = Er.asn1.ASN1Util.newObject(t.obj);
                        t.hex = "00" + e.getEncodedHex();
                    } Er.asn1.DERBitString.superclass.constructor.call(this), this.hT = "03", this.setHexValueIncludingUnusedBits = function (t) { this.hTLV = null, this.isModified = !0, this.hV = t; }, this.setUnusedBitsAndHexValue = function (t, e) { if (t < 0 || 7 < t)
                        throw "unused bits shall be from 0 to 7: u = " + t; var r = "0" + t; this.hTLV = null, this.isModified = !0, this.hV = r + e; }, this.setByBinaryString = function (t) { var e = 8 - (t = t.replace(/0+$/, "")).length % 8; 8 == e && (e = 0); for (var r = 0; r <= e; r++)
                        t += "0"; var n = ""; for (r = 0; r < t.length - 1; r += 8) {
                        var i = t.substr(r, 8), o = parseInt(i, 2).toString(16);
                        1 == o.length && (o = "0" + o), n += o;
                    } this.hTLV = null, this.isModified = !0, this.hV = "0" + e + n; }, this.setByBooleanArray = function (t) { for (var e = "", r = 0; r < t.length; r++)
                        1 == t[r] ? e += "1" : e += "0"; this.setByBinaryString(e); }, this.newFalseArray = function (t) { for (var e = new Array(t), r = 0; r < t; r++)
                        e[r] = !1; return e; }, this.getFreshValueHex = function () { return this.hV; }, void 0 !== t && ("string" == typeof t && t.toLowerCase().match(/^[0-9a-f]+$/) ? this.setHexValueIncludingUnusedBits(t) : void 0 !== t.hex ? this.setHexValueIncludingUnusedBits(t.hex) : void 0 !== t.bin ? this.setByBinaryString(t.bin) : void 0 !== t.array && this.setByBooleanArray(t.array)); }, o.lang.extend(Er.asn1.DERBitString, Er.asn1.ASN1Object), Er.asn1.DEROctetString = function (t) { if (void 0 !== t && void 0 !== t.obj) {
                        var e = Er.asn1.ASN1Util.newObject(t.obj);
                        t.hex = e.getEncodedHex();
                    } Er.asn1.DEROctetString.superclass.constructor.call(this, t), this.hT = "04"; }, o.lang.extend(Er.asn1.DEROctetString, Er.asn1.DERAbstractString), Er.asn1.DERNull = function () { Er.asn1.DERNull.superclass.constructor.call(this), this.hT = "05", this.hTLV = "0500"; }, o.lang.extend(Er.asn1.DERNull, Er.asn1.ASN1Object), Er.asn1.DERObjectIdentifier = function (t) { var e = function t(e) { var r = e.toString(16); return 1 == r.length && (r = "0" + r), r; }, r = function t(r) { var n = "", i = new E(r, 10).toString(2), o = 7 - i.length % 7; 7 == o && (o = 0); for (var s = "", a = 0; a < o; a++)
                        s += "0"; i = s + i; for (a = 0; a < i.length - 1; a += 7) {
                        var u = i.substr(a, 7);
                        a != i.length - 7 && (u = "1" + u), n += e(parseInt(u, 2));
                    } return n; }; Er.asn1.DERObjectIdentifier.superclass.constructor.call(this), this.hT = "06", this.setValueHex = function (t) { this.hTLV = null, this.isModified = !0, this.s = null, this.hV = t; }, this.setValueOidString = function (t) { if (!t.match(/^[0-9.]+$/))
                        throw "malformed oid string: " + t; var n = "", i = t.split("."), o = 40 * parseInt(i[0]) + parseInt(i[1]); n += e(o), i.splice(0, 2); for (var s = 0; s < i.length; s++)
                        n += r(i[s]); this.hTLV = null, this.isModified = !0, this.s = null, this.hV = n; }, this.setValueName = function (t) { var e = Er.asn1.x509.OID.name2oid(t); if ("" === e)
                        throw "DERObjectIdentifier oidName undefined: " + t; this.setValueOidString(e); }, this.getFreshValueHex = function () { return this.hV; }, void 0 !== t && ("string" == typeof t ? t.match(/^[0-2].[0-9.]+$/) ? this.setValueOidString(t) : this.setValueName(t) : void 0 !== t.oid ? this.setValueOidString(t.oid) : void 0 !== t.hex ? this.setValueHex(t.hex) : void 0 !== t.name && this.setValueName(t.name)); }, o.lang.extend(Er.asn1.DERObjectIdentifier, Er.asn1.ASN1Object), Er.asn1.DEREnumerated = function (t) { Er.asn1.DEREnumerated.superclass.constructor.call(this), this.hT = "0a", this.setByBigInteger = function (t) { this.hTLV = null, this.isModified = !0, this.hV = Er.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t); }, this.setByInteger = function (t) { var e = new E(String(t), 10); this.setByBigInteger(e); }, this.setValueHex = function (t) { this.hV = t; }, this.getFreshValueHex = function () { return this.hV; }, void 0 !== t && (void 0 !== t.int ? this.setByInteger(t.int) : "number" == typeof t ? this.setByInteger(t) : void 0 !== t.hex && this.setValueHex(t.hex)); }, o.lang.extend(Er.asn1.DEREnumerated, Er.asn1.ASN1Object), Er.asn1.DERUTF8String = function (t) { Er.asn1.DERUTF8String.superclass.constructor.call(this, t), this.hT = "0c"; }, o.lang.extend(Er.asn1.DERUTF8String, Er.asn1.DERAbstractString), Er.asn1.DERNumericString = function (t) { Er.asn1.DERNumericString.superclass.constructor.call(this, t), this.hT = "12"; }, o.lang.extend(Er.asn1.DERNumericString, Er.asn1.DERAbstractString), Er.asn1.DERPrintableString = function (t) { Er.asn1.DERPrintableString.superclass.constructor.call(this, t), this.hT = "13"; }, o.lang.extend(Er.asn1.DERPrintableString, Er.asn1.DERAbstractString), Er.asn1.DERTeletexString = function (t) { Er.asn1.DERTeletexString.superclass.constructor.call(this, t), this.hT = "14"; }, o.lang.extend(Er.asn1.DERTeletexString, Er.asn1.DERAbstractString), Er.asn1.DERIA5String = function (t) { Er.asn1.DERIA5String.superclass.constructor.call(this, t), this.hT = "16"; }, o.lang.extend(Er.asn1.DERIA5String, Er.asn1.DERAbstractString), Er.asn1.DERUTCTime = function (t) { Er.asn1.DERUTCTime.superclass.constructor.call(this, t), this.hT = "17", this.setByDate = function (t) { this.hTLV = null, this.isModified = !0, this.date = t, this.s = this.formatDate(this.date, "utc"), this.hV = Rr(this.s); }, this.getFreshValueHex = function () { return void 0 === this.date && void 0 === this.s && (this.date = new Date, this.s = this.formatDate(this.date, "utc"), this.hV = Rr(this.s)), this.hV; }, void 0 !== t && (void 0 !== t.str ? this.setString(t.str) : "string" == typeof t && t.match(/^[0-9]{12}Z$/) ? this.setString(t) : void 0 !== t.hex ? this.setStringHex(t.hex) : void 0 !== t.date && this.setByDate(t.date)); }, o.lang.extend(Er.asn1.DERUTCTime, Er.asn1.DERAbstractTime), Er.asn1.DERGeneralizedTime = function (t) { Er.asn1.DERGeneralizedTime.superclass.constructor.call(this, t), this.hT = "18", this.withMillis = !1, this.setByDate = function (t) { this.hTLV = null, this.isModified = !0, this.date = t, this.s = this.formatDate(this.date, "gen", this.withMillis), this.hV = Rr(this.s); }, this.getFreshValueHex = function () { return void 0 === this.date && void 0 === this.s && (this.date = new Date, this.s = this.formatDate(this.date, "gen", this.withMillis), this.hV = Rr(this.s)), this.hV; }, void 0 !== t && (void 0 !== t.str ? this.setString(t.str) : "string" == typeof t && t.match(/^[0-9]{14}Z$/) ? this.setString(t) : void 0 !== t.hex ? this.setStringHex(t.hex) : void 0 !== t.date && this.setByDate(t.date), !0 === t.millis && (this.withMillis = !0)); }, o.lang.extend(Er.asn1.DERGeneralizedTime, Er.asn1.DERAbstractTime), Er.asn1.DERSequence = function (t) { Er.asn1.DERSequence.superclass.constructor.call(this, t), this.hT = "30", this.getFreshValueHex = function () { for (var t = "", e = 0; e < this.asn1Array.length; e++) {
                        t += this.asn1Array[e].getEncodedHex();
                    } return this.hV = t, this.hV; }; }, o.lang.extend(Er.asn1.DERSequence, Er.asn1.DERAbstractStructured), Er.asn1.DERSet = function (t) { Er.asn1.DERSet.superclass.constructor.call(this, t), this.hT = "31", this.sortFlag = !0, this.getFreshValueHex = function () { for (var t = new Array, e = 0; e < this.asn1Array.length; e++) {
                        var r = this.asn1Array[e];
                        t.push(r.getEncodedHex());
                    } return 1 == this.sortFlag && t.sort(), this.hV = t.join(""), this.hV; }, void 0 !== t && void 0 !== t.sortflag && 0 == t.sortflag && (this.sortFlag = !1); }, o.lang.extend(Er.asn1.DERSet, Er.asn1.DERAbstractStructured), Er.asn1.DERTaggedObject = function (t) { Er.asn1.DERTaggedObject.superclass.constructor.call(this), this.hT = "a0", this.hV = "", this.isExplicit = !0, this.asn1Object = null, this.setASN1Object = function (t, e, r) { this.hT = e, this.isExplicit = t, this.asn1Object = r, this.isExplicit ? (this.hV = this.asn1Object.getEncodedHex(), this.hTLV = null, this.isModified = !0) : (this.hV = null, this.hTLV = r.getEncodedHex(), this.hTLV = this.hTLV.replace(/^../, e), this.isModified = !1); }, this.getFreshValueHex = function () { return this.hV; }, void 0 !== t && (void 0 !== t.tag && (this.hT = t.tag), void 0 !== t.explicit && (this.isExplicit = t.explicit), void 0 !== t.obj && (this.asn1Object = t.obj, this.setASN1Object(this.isExplicit, this.hT, this.asn1Object))); }, o.lang.extend(Er.asn1.DERTaggedObject, Er.asn1.ASN1Object);
                    var Er, xr, kr, Ar = new function () { };
                    function Pr(t) { for (var e = new Array, r = 0; r < t.length; r++)
                        e[r] = t.charCodeAt(r); return e; }
                    function Cr(t) { for (var e = "", r = 0; r < t.length; r++)
                        e += String.fromCharCode(t[r]); return e; }
                    function Tr(t) { for (var e = "", r = 0; r < t.length; r++) {
                        var n = t[r].toString(16);
                        1 == n.length && (n = "0" + n), e += n;
                    } return e; }
                    function Rr(t) { return Tr(Pr(t)); }
                    function Ir(t) { return t = (t = (t = t.replace(/\=/g, "")).replace(/\+/g, "-")).replace(/\//g, "_"); }
                    function Dr(t) { return t.length % 4 == 2 ? t += "==" : t.length % 4 == 3 && (t += "="), t = (t = t.replace(/-/g, "+")).replace(/_/g, "/"); }
                    function Ur(t) { return t.length % 2 == 1 && (t = "0" + t), Ir(F(t)); }
                    function Lr(t) { return b(Dr(t)); }
                    function Br(t) { return zr($r(t)); }
                    function Nr(t) { return decodeURIComponent(Yr(t)); }
                    function Or(t) { for (var e = "", r = 0; r < t.length - 1; r += 2)
                        e += String.fromCharCode(parseInt(t.substr(r, 2), 16)); return e; }
                    function jr(t) { for (var e = "", r = 0; r < t.length; r++)
                        e += ("0" + t.charCodeAt(r).toString(16)).slice(-2); return e; }
                    function Hr(t) { return F(t); }
                    function Mr(t) { var e = Hr(t).replace(/(.{64})/g, "$1\r\n"); return e = e.replace(/\r\n$/, ""); }
                    function Kr(t) { return b(t.replace(/[^0-9A-Za-z\/+=]*/g, "")); }
                    function Vr(t, e) { return "-----BEGIN " + e + "-----\r\n" + Mr(t) + "\r\n-----END " + e + "-----\r\n"; }
                    function qr(t, e) { if (-1 == t.indexOf("-----BEGIN "))
                        throw "can't find PEM header: " + e; return Kr(t = void 0 !== e ? (t = t.replace("-----BEGIN " + e + "-----", "")).replace("-----END " + e + "-----", "") : (t = t.replace(/-----BEGIN [^-]+-----/, "")).replace(/-----END [^-]+-----/, "")); }
                    function Jr(t) { var e, r, n, i, o, s, a, u, c, h, l; if (l = t.match(/^(\d{2}|\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)(|\.\d+)Z$/))
                        return u = l[1], e = parseInt(u), 2 === u.length && (50 <= e && e < 100 ? e = 1900 + e : 0 <= e && e < 50 && (e = 2e3 + e)), r = parseInt(l[2]) - 1, n = parseInt(l[3]), i = parseInt(l[4]), o = parseInt(l[5]), s = parseInt(l[6]), a = 0, "" !== (c = l[7]) && (h = (c.substr(1) + "00").substr(0, 3), a = parseInt(h)), Date.UTC(e, r, n, i, o, s, a); throw "unsupported zulu format: " + t; }
                    function Wr(t) { return ~~(Jr(t) / 1e3); }
                    function zr(t) { return t.replace(/%/g, ""); }
                    function Yr(t) { return t.replace(/(..)/g, "%$1"); }
                    function Gr(t) { var e = "malformed IPv6 address"; if (!t.match(/^[0-9A-Fa-f:]+$/))
                        throw e; var r = (t = t.toLowerCase()).split(":").length - 1; if (r < 2)
                        throw e; var n = ":".repeat(7 - r + 2), i = (t = t.replace("::", n)).split(":"); if (8 != i.length)
                        throw e; for (var o = 0; o < 8; o++)
                        i[o] = ("0000" + i[o]).slice(-4); return i.join(""); }
                    function Xr(t) { if (!t.match(/^[0-9A-Fa-f]{32}$/))
                        throw "malformed IPv6 address octet"; for (var e = (t = t.toLowerCase()).match(/.{1,4}/g), r = 0; r < 8; r++)
                        e[r] = e[r].replace(/^0+/, ""), "" == e[r] && (e[r] = "0"); var n = (t = ":" + e.join(":") + ":").match(/:(0:){2,}/g); if (null === n)
                        return t.slice(1, -1); var i = ""; for (r = 0; r < n.length; r++)
                        n[r].length > i.length && (i = n[r]); return (t = t.replace(i, "::")).slice(1, -1); }
                    function Qr(t) { var e = "malformed hex value"; if (!t.match(/^([0-9A-Fa-f][0-9A-Fa-f]){1,}$/))
                        throw e; if (8 != t.length)
                        return 32 == t.length ? Xr(t) : t; try {
                        return parseInt(t.substr(0, 2), 16) + "." + parseInt(t.substr(2, 2), 16) + "." + parseInt(t.substr(4, 2), 16) + "." + parseInt(t.substr(6, 2), 16);
                    }
                    catch (t) {
                        throw e;
                    } }
                    function $r(t) { for (var e = encodeURIComponent(t), r = "", n = 0; n < e.length; n++)
                        "%" == e[n] ? (r += e.substr(n, 3), n += 2) : r = r + "%" + Rr(e[n]); return r; }
                    function Zr(t) { return t.length % 2 == 1 ? "0" + t : t.substr(0, 1) > "7" ? "00" + t : t; }
                    Ar.getLblen = function (t, e) { if ("8" != t.substr(e + 2, 1))
                        return 1; var r = parseInt(t.substr(e + 3, 1)); return 0 == r ? -1 : 0 < r && r < 10 ? r + 1 : -2; }, Ar.getL = function (t, e) { var r = Ar.getLblen(t, e); return r < 1 ? "" : t.substr(e + 2, 2 * r); }, Ar.getVblen = function (t, e) { var r; return "" == (r = Ar.getL(t, e)) ? -1 : ("8" === r.substr(0, 1) ? new E(r.substr(2), 16) : new E(r, 16)).intValue(); }, Ar.getVidx = function (t, e) { var r = Ar.getLblen(t, e); return r < 0 ? r : e + 2 * (r + 1); }, Ar.getV = function (t, e) { var r = Ar.getVidx(t, e), n = Ar.getVblen(t, e); return t.substr(r, 2 * n); }, Ar.getTLV = function (t, e) { return t.substr(e, 2) + Ar.getL(t, e) + Ar.getV(t, e); }, Ar.getNextSiblingIdx = function (t, e) { return Ar.getVidx(t, e) + 2 * Ar.getVblen(t, e); }, Ar.getChildIdx = function (t, e) { var r = Ar, n = new Array, i = r.getVidx(t, e); "03" == t.substr(e, 2) ? n.push(i + 2) : n.push(i); for (var o = r.getVblen(t, e), s = i, a = 0;;) {
                        var u = r.getNextSiblingIdx(t, s);
                        if (null == u || u - i >= 2 * o)
                            break;
                        if (a >= 200)
                            break;
                        n.push(u), s = u, a++;
                    } return n; }, Ar.getNthChildIdx = function (t, e, r) { return Ar.getChildIdx(t, e)[r]; }, Ar.getIdxbyList = function (t, e, r, n) { var i, o, s = Ar; if (0 == r.length) {
                        if (void 0 !== n && t.substr(e, 2) !== n)
                            throw "checking tag doesn't match: " + t.substr(e, 2) + "!=" + n;
                        return e;
                    } return i = r.shift(), o = s.getChildIdx(t, e), s.getIdxbyList(t, o[i], r, n); }, Ar.getTLVbyList = function (t, e, r, n) { var i = Ar, o = i.getIdxbyList(t, e, r); if (void 0 === o)
                        throw "can't find nthList object"; if (void 0 !== n && t.substr(o, 2) != n)
                        throw "checking tag doesn't match: " + t.substr(o, 2) + "!=" + n; return i.getTLV(t, o); }, Ar.getVbyList = function (t, e, r, n, i) { var o, s, a = Ar; if (void 0 === (o = a.getIdxbyList(t, e, r, n)))
                        throw "can't find nthList object"; return s = a.getV(t, o), !0 === i && (s = s.substr(2)), s; }, Ar.hextooidstr = function (t) { var e = function t(e, r) { return e.length >= r ? e : new Array(r - e.length + 1).join("0") + e; }, r = [], n = t.substr(0, 2), i = parseInt(n, 16); r[0] = new String(Math.floor(i / 40)), r[1] = new String(i % 40); for (var o = t.substr(2), s = [], a = 0; a < o.length / 2; a++)
                        s.push(parseInt(o.substr(2 * a, 2), 16)); var u = [], c = ""; for (a = 0; a < s.length; a++)
                        128 & s[a] ? c += e((127 & s[a]).toString(2), 7) : (c += e((127 & s[a]).toString(2), 7), u.push(new String(parseInt(c, 2))), c = ""); var h = r.join("."); return u.length > 0 && (h = h + "." + u.join(".")), h; }, Ar.dump = function (t, e, r, n) { var i = Ar, o = i.getV, s = i.dump, a = i.getChildIdx, u = t; t instanceof Er.asn1.ASN1Object && (u = t.getEncodedHex()); var c = function t(e, r) { return e.length <= 2 * r ? e : e.substr(0, r) + "..(total " + e.length / 2 + "bytes).." + e.substr(e.length - r, r); }; void 0 === e && (e = { ommit_long_octet: 32 }), void 0 === r && (r = 0), void 0 === n && (n = ""); var h = e.ommit_long_octet; if ("01" == u.substr(r, 2))
                        return "00" == (l = o(u, r)) ? n + "BOOLEAN FALSE\n" : n + "BOOLEAN TRUE\n"; if ("02" == u.substr(r, 2))
                        return n + "INTEGER " + c(l = o(u, r), h) + "\n"; if ("03" == u.substr(r, 2))
                        return n + "BITSTRING " + c(l = o(u, r), h) + "\n"; if ("04" == u.substr(r, 2)) {
                        var l = o(u, r);
                        if (i.isASN1HEX(l)) {
                            var f = n + "OCTETSTRING, encapsulates\n";
                            return f += s(l, e, 0, n + "  ");
                        }
                        return n + "OCTETSTRING " + c(l, h) + "\n";
                    } if ("05" == u.substr(r, 2))
                        return n + "NULL\n"; if ("06" == u.substr(r, 2)) {
                        var d = o(u, r), g = Er.asn1.ASN1Util.oidHexToInt(d), p = Er.asn1.x509.OID.oid2name(g), v = g.replace(/\./g, " ");
                        return "" != p ? n + "ObjectIdentifier " + p + " (" + v + ")\n" : n + "ObjectIdentifier (" + v + ")\n";
                    } if ("0c" == u.substr(r, 2))
                        return n + "UTF8String '" + Nr(o(u, r)) + "'\n"; if ("13" == u.substr(r, 2))
                        return n + "PrintableString '" + Nr(o(u, r)) + "'\n"; if ("14" == u.substr(r, 2))
                        return n + "TeletexString '" + Nr(o(u, r)) + "'\n"; if ("16" == u.substr(r, 2))
                        return n + "IA5String '" + Nr(o(u, r)) + "'\n"; if ("17" == u.substr(r, 2))
                        return n + "UTCTime " + Nr(o(u, r)) + "\n"; if ("18" == u.substr(r, 2))
                        return n + "GeneralizedTime " + Nr(o(u, r)) + "\n"; if ("30" == u.substr(r, 2)) {
                        if ("3000" == u.substr(r, 4))
                            return n + "SEQUENCE {}\n";
                        f = n + "SEQUENCE\n";
                        var y = e;
                        if ((2 == (S = a(u, r)).length || 3 == S.length) && "06" == u.substr(S[0], 2) && "04" == u.substr(S[S.length - 1], 2)) {
                            p = i.oidname(o(u, S[0]));
                            var m = JSON.parse(JSON.stringify(e));
                            m.x509ExtName = p, y = m;
                        }
                        for (var _ = 0; _ < S.length; _++)
                            f += s(u, y, S[_], n + "  ");
                        return f;
                    } if ("31" == u.substr(r, 2)) {
                        f = n + "SET\n";
                        var S = a(u, r);
                        for (_ = 0; _ < S.length; _++)
                            f += s(u, e, S[_], n + "  ");
                        return f;
                    } var F = parseInt(u.substr(r, 2), 16); if (0 != (128 & F)) {
                        var b = 31 & F;
                        if (0 != (32 & F)) {
                            var f = n + "[" + b + "]\n";
                            for (S = a(u, r), _ = 0; _ < S.length; _++)
                                f += s(u, e, S[_], n + "  ");
                            return f;
                        }
                        return "68747470" == (l = o(u, r)).substr(0, 8) && (l = Nr(l)), "subjectAltName" === e.x509ExtName && 2 == b && (l = Nr(l)), f = n + "[" + b + "] " + l + "\n";
                    } return n + "UNKNOWN(" + u.substr(r, 2) + ") " + o(u, r) + "\n"; }, Ar.isASN1HEX = function (t) { var e = Ar; if (t.length % 2 == 1)
                        return !1; var r = e.getVblen(t, 0), n = t.substr(0, 2), i = e.getL(t, 0); return t.length - n.length - i.length == 2 * r; }, Ar.oidname = function (t) { var e = Er.asn1; Er.lang.String.isHex(t) && (t = e.ASN1Util.oidHexToInt(t)); var r = e.x509.OID.oid2name(t); return "" === r && (r = t), r; }, void 0 !== Er && Er || (e.KJUR = Er = {}), void 0 !== Er.lang && Er.lang || (Er.lang = {}), Er.lang.String = function () { }, "function" == typeof t ? (e.utf8tob64u = xr = function e(r) { return Ir(new t(r, "utf8").toString("base64")); }, e.b64utoutf8 = kr = function e(r) { return new t(Dr(r), "base64").toString("utf8"); }) : (e.utf8tob64u = xr = function t(e) { return Ur(zr($r(e))); }, e.b64utoutf8 = kr = function t(e) { return decodeURIComponent(Yr(Lr(e))); }), Er.lang.String.isInteger = function (t) { return !!t.match(/^[0-9]+$/) || !!t.match(/^-[0-9]+$/); }, Er.lang.String.isHex = function (t) { return !(t.length % 2 != 0 || !t.match(/^[0-9a-f]+$/) && !t.match(/^[0-9A-F]+$/)); }, Er.lang.String.isBase64 = function (t) { return !(!(t = t.replace(/\s+/g, "")).match(/^[0-9A-Za-z+\/]+={0,3}$/) || t.length % 4 != 0); }, Er.lang.String.isBase64URL = function (t) { return !t.match(/[+/=]/) && (t = Dr(t), Er.lang.String.isBase64(t)); }, Er.lang.String.isIntegerArray = function (t) { return !!(t = t.replace(/\s+/g, "")).match(/^\[[0-9,]+\]$/); };
                    void 0 !== Er && Er || (e.KJUR = Er = {}), void 0 !== Er.crypto && Er.crypto || (Er.crypto = {}), Er.crypto.Util = new function () { this.DIGESTINFOHEAD = { sha1: "3021300906052b0e03021a05000414", sha224: "302d300d06096086480165030402040500041c", sha256: "3031300d060960864801650304020105000420", sha384: "3041300d060960864801650304020205000430", sha512: "3051300d060960864801650304020305000440", md2: "3020300c06082a864886f70d020205000410", md5: "3020300c06082a864886f70d020505000410", ripemd160: "3021300906052b2403020105000414" }, this.DEFAULTPROVIDER = { md5: "cryptojs", sha1: "cryptojs", sha224: "cryptojs", sha256: "cryptojs", sha384: "cryptojs", sha512: "cryptojs", ripemd160: "cryptojs", hmacmd5: "cryptojs", hmacsha1: "cryptojs", hmacsha224: "cryptojs", hmacsha256: "cryptojs", hmacsha384: "cryptojs", hmacsha512: "cryptojs", hmacripemd160: "cryptojs", MD5withRSA: "cryptojs/jsrsa", SHA1withRSA: "cryptojs/jsrsa", SHA224withRSA: "cryptojs/jsrsa", SHA256withRSA: "cryptojs/jsrsa", SHA384withRSA: "cryptojs/jsrsa", SHA512withRSA: "cryptojs/jsrsa", RIPEMD160withRSA: "cryptojs/jsrsa", MD5withECDSA: "cryptojs/jsrsa", SHA1withECDSA: "cryptojs/jsrsa", SHA224withECDSA: "cryptojs/jsrsa", SHA256withECDSA: "cryptojs/jsrsa", SHA384withECDSA: "cryptojs/jsrsa", SHA512withECDSA: "cryptojs/jsrsa", RIPEMD160withECDSA: "cryptojs/jsrsa", SHA1withDSA: "cryptojs/jsrsa", SHA224withDSA: "cryptojs/jsrsa", SHA256withDSA: "cryptojs/jsrsa", MD5withRSAandMGF1: "cryptojs/jsrsa", SHA1withRSAandMGF1: "cryptojs/jsrsa", SHA224withRSAandMGF1: "cryptojs/jsrsa", SHA256withRSAandMGF1: "cryptojs/jsrsa", SHA384withRSAandMGF1: "cryptojs/jsrsa", SHA512withRSAandMGF1: "cryptojs/jsrsa", RIPEMD160withRSAandMGF1: "cryptojs/jsrsa" }, this.CRYPTOJSMESSAGEDIGESTNAME = { md5: y.algo.MD5, sha1: y.algo.SHA1, sha224: y.algo.SHA224, sha256: y.algo.SHA256, sha384: y.algo.SHA384, sha512: y.algo.SHA512, ripemd160: y.algo.RIPEMD160 }, this.getDigestInfoHex = function (t, e) { if (void 0 === this.DIGESTINFOHEAD[e])
                        throw "alg not supported in Util.DIGESTINFOHEAD: " + e; return this.DIGESTINFOHEAD[e] + t; }, this.getPaddedDigestInfoHex = function (t, e, r) { var n = this.getDigestInfoHex(t, e), i = r / 4; if (n.length + 22 > i)
                        throw "key is too short for SigAlg: keylen=" + r + "," + e; for (var o = "0001", s = "00" + n, a = "", u = i - o.length - s.length, c = 0; c < u; c += 2)
                        a += "ff"; return o + a + s; }, this.hashString = function (t, e) { return new Er.crypto.MessageDigest({ alg: e }).digestString(t); }, this.hashHex = function (t, e) { return new Er.crypto.MessageDigest({ alg: e }).digestHex(t); }, this.sha1 = function (t) { return new Er.crypto.MessageDigest({ alg: "sha1", prov: "cryptojs" }).digestString(t); }, this.sha256 = function (t) { return new Er.crypto.MessageDigest({ alg: "sha256", prov: "cryptojs" }).digestString(t); }, this.sha256Hex = function (t) { return new Er.crypto.MessageDigest({ alg: "sha256", prov: "cryptojs" }).digestHex(t); }, this.sha512 = function (t) { return new Er.crypto.MessageDigest({ alg: "sha512", prov: "cryptojs" }).digestString(t); }, this.sha512Hex = function (t) { return new Er.crypto.MessageDigest({ alg: "sha512", prov: "cryptojs" }).digestHex(t); }; }, Er.crypto.Util.md5 = function (t) { return new Er.crypto.MessageDigest({ alg: "md5", prov: "cryptojs" }).digestString(t); }, Er.crypto.Util.ripemd160 = function (t) { return new Er.crypto.MessageDigest({ alg: "ripemd160", prov: "cryptojs" }).digestString(t); }, Er.crypto.Util.SECURERANDOMGEN = new Me, Er.crypto.Util.getRandomHexOfNbytes = function (t) { var e = new Array(t); return Er.crypto.Util.SECURERANDOMGEN.nextBytes(e), Tr(e); }, Er.crypto.Util.getRandomBigIntegerOfNbytes = function (t) { return new E(Er.crypto.Util.getRandomHexOfNbytes(t), 16); }, Er.crypto.Util.getRandomHexOfNbits = function (t) { var e = t % 8, r = new Array((t - e) / 8 + 1); return Er.crypto.Util.SECURERANDOMGEN.nextBytes(r), r[0] = (255 << e & 255 ^ 255) & r[0], Tr(r); }, Er.crypto.Util.getRandomBigIntegerOfNbits = function (t) { return new E(Er.crypto.Util.getRandomHexOfNbits(t), 16); }, Er.crypto.Util.getRandomBigIntegerZeroToMax = function (t) { for (var e = t.bitLength();;) {
                        var r = Er.crypto.Util.getRandomBigIntegerOfNbits(e);
                        if (-1 != t.compareTo(r))
                            return r;
                    } }, Er.crypto.Util.getRandomBigIntegerMinToMax = function (t, e) { var r = t.compareTo(e); if (1 == r)
                        throw "biMin is greater than biMax"; if (0 == r)
                        return t; var n = e.subtract(t); return Er.crypto.Util.getRandomBigIntegerZeroToMax(n).add(t); }, Er.crypto.MessageDigest = function (t) { this.setAlgAndProvider = function (t, e) { if (null !== (t = Er.crypto.MessageDigest.getCanonicalAlgName(t)) && void 0 === e && (e = Er.crypto.Util.DEFAULTPROVIDER[t]), -1 != ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(t) && "cryptojs" == e) {
                        try {
                            this.md = Er.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[t].create();
                        }
                        catch (e) {
                            throw "setAlgAndProvider hash alg set fail alg=" + t + "/" + e;
                        }
                        this.updateString = function (t) { this.md.update(t); }, this.updateHex = function (t) { var e = y.enc.Hex.parse(t); this.md.update(e); }, this.digest = function () { return this.md.finalize().toString(y.enc.Hex); }, this.digestString = function (t) { return this.updateString(t), this.digest(); }, this.digestHex = function (t) { return this.updateHex(t), this.digest(); };
                    } if (-1 != ":sha256:".indexOf(t) && "sjcl" == e) {
                        try {
                            this.md = new sjcl.hash.sha256;
                        }
                        catch (e) {
                            throw "setAlgAndProvider hash alg set fail alg=" + t + "/" + e;
                        }
                        this.updateString = function (t) { this.md.update(t); }, this.updateHex = function (t) { var e = sjcl.codec.hex.toBits(t); this.md.update(e); }, this.digest = function () { var t = this.md.finalize(); return sjcl.codec.hex.fromBits(t); }, this.digestString = function (t) { return this.updateString(t), this.digest(); }, this.digestHex = function (t) { return this.updateHex(t), this.digest(); };
                    } }, this.updateString = function (t) { throw "updateString(str) not supported for this alg/prov: " + this.algName + "/" + this.provName; }, this.updateHex = function (t) { throw "updateHex(hex) not supported for this alg/prov: " + this.algName + "/" + this.provName; }, this.digest = function () { throw "digest() not supported for this alg/prov: " + this.algName + "/" + this.provName; }, this.digestString = function (t) { throw "digestString(str) not supported for this alg/prov: " + this.algName + "/" + this.provName; }, this.digestHex = function (t) { throw "digestHex(hex) not supported for this alg/prov: " + this.algName + "/" + this.provName; }, void 0 !== t && void 0 !== t.alg && (this.algName = t.alg, void 0 === t.prov && (this.provName = Er.crypto.Util.DEFAULTPROVIDER[this.algName]), this.setAlgAndProvider(this.algName, this.provName)); }, Er.crypto.MessageDigest.getCanonicalAlgName = function (t) { return "string" == typeof t && (t = (t = t.toLowerCase()).replace(/-/, "")), t; }, Er.crypto.MessageDigest.getHashLength = function (t) { var e = Er.crypto.MessageDigest, r = e.getCanonicalAlgName(t); if (void 0 === e.HASHLENGTH[r])
                        throw "not supported algorithm: " + t; return e.HASHLENGTH[r]; }, Er.crypto.MessageDigest.HASHLENGTH = { md5: 16, sha1: 20, sha224: 28, sha256: 32, sha384: 48, sha512: 64, ripemd160: 20 }, Er.crypto.Mac = function (t) { this.setAlgAndProvider = function (t, e) { if (null == (t = t.toLowerCase()) && (t = "hmacsha1"), "hmac" != (t = t.toLowerCase()).substr(0, 4))
                        throw "setAlgAndProvider unsupported HMAC alg: " + t; void 0 === e && (e = Er.crypto.Util.DEFAULTPROVIDER[t]), this.algProv = t + "/" + e; var r = t.substr(4); if (-1 != ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(r) && "cryptojs" == e) {
                        try {
                            var n = Er.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[r];
                            this.mac = y.algo.HMAC.create(n, this.pass);
                        }
                        catch (t) {
                            throw "setAlgAndProvider hash alg set fail hashAlg=" + r + "/" + t;
                        }
                        this.updateString = function (t) { this.mac.update(t); }, this.updateHex = function (t) { var e = y.enc.Hex.parse(t); this.mac.update(e); }, this.doFinal = function () { return this.mac.finalize().toString(y.enc.Hex); }, this.doFinalString = function (t) { return this.updateString(t), this.doFinal(); }, this.doFinalHex = function (t) { return this.updateHex(t), this.doFinal(); };
                    } }, this.updateString = function (t) { throw "updateString(str) not supported for this alg/prov: " + this.algProv; }, this.updateHex = function (t) { throw "updateHex(hex) not supported for this alg/prov: " + this.algProv; }, this.doFinal = function () { throw "digest() not supported for this alg/prov: " + this.algProv; }, this.doFinalString = function (t) { throw "digestString(str) not supported for this alg/prov: " + this.algProv; }, this.doFinalHex = function (t) { throw "digestHex(hex) not supported for this alg/prov: " + this.algProv; }, this.setPassword = function (t) { if ("string" == typeof t) {
                        var e = t;
                        return t.length % 2 != 1 && t.match(/^[0-9A-Fa-f]+$/) || (e = jr(t)), void (this.pass = y.enc.Hex.parse(e));
                    } if ("object" != (void 0 === t ? "undefined" : r(t)))
                        throw "KJUR.crypto.Mac unsupported password type: " + t; e = null; if (void 0 !== t.hex) {
                        if (t.hex.length % 2 != 0 || !t.hex.match(/^[0-9A-Fa-f]+$/))
                            throw "Mac: wrong hex password: " + t.hex;
                        e = t.hex;
                    } if (void 0 !== t.utf8 && (e = Br(t.utf8)), void 0 !== t.rstr && (e = jr(t.rstr)), void 0 !== t.b64 && (e = b(t.b64)), void 0 !== t.b64u && (e = Lr(t.b64u)), null == e)
                        throw "KJUR.crypto.Mac unsupported password type: " + t; this.pass = y.enc.Hex.parse(e); }, void 0 !== t && (void 0 !== t.pass && this.setPassword(t.pass), void 0 !== t.alg && (this.algName = t.alg, void 0 === t.prov && (this.provName = Er.crypto.Util.DEFAULTPROVIDER[this.algName]), this.setAlgAndProvider(this.algName, this.provName))); }, Er.crypto.Signature = function (t) { var e = null; if (this._setAlgNames = function () { var t = this.algName.match(/^(.+)with(.+)$/); t && (this.mdAlgName = t[1].toLowerCase(), this.pubkeyAlgName = t[2].toLowerCase()); }, this._zeroPaddingOfSignature = function (t, e) { for (var r = "", n = e / 4 - t.length, i = 0; i < n; i++)
                        r += "0"; return r + t; }, this.setAlgAndProvider = function (t, e) { if (this._setAlgNames(), "cryptojs/jsrsa" != e)
                        throw "provider not supported: " + e; if (-1 != ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(this.mdAlgName)) {
                        try {
                            this.md = new Er.crypto.MessageDigest({ alg: this.mdAlgName });
                        }
                        catch (t) {
                            throw "setAlgAndProvider hash alg set fail alg=" + this.mdAlgName + "/" + t;
                        }
                        this.init = function (t, e) { var r = null; try {
                            r = void 0 === e ? tn.getKey(t) : tn.getKey(t, e);
                        }
                        catch (t) {
                            throw "init failed:" + t;
                        } if (!0 === r.isPrivate)
                            this.prvKey = r, this.state = "SIGN";
                        else {
                            if (!0 !== r.isPublic)
                                throw "init failed.:" + r;
                            this.pubKey = r, this.state = "VERIFY";
                        } }, this.updateString = function (t) { this.md.updateString(t); }, this.updateHex = function (t) { this.md.updateHex(t); }, this.sign = function () { if (this.sHashHex = this.md.digest(), void 0 !== this.ecprvhex && void 0 !== this.eccurvename) {
                            var t = new Er.crypto.ECDSA({ curve: this.eccurvename });
                            this.hSign = t.signHex(this.sHashHex, this.ecprvhex);
                        }
                        else if (this.prvKey instanceof qe && "rsaandmgf1" === this.pubkeyAlgName)
                            this.hSign = this.prvKey.signWithMessageHashPSS(this.sHashHex, this.mdAlgName, this.pssSaltLen);
                        else if (this.prvKey instanceof qe && "rsa" === this.pubkeyAlgName)
                            this.hSign = this.prvKey.signWithMessageHash(this.sHashHex, this.mdAlgName);
                        else if (this.prvKey instanceof Er.crypto.ECDSA)
                            this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
                        else {
                            if (!(this.prvKey instanceof Er.crypto.DSA))
                                throw "Signature: unsupported private key alg: " + this.pubkeyAlgName;
                            this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
                        } return this.hSign; }, this.signString = function (t) { return this.updateString(t), this.sign(); }, this.signHex = function (t) { return this.updateHex(t), this.sign(); }, this.verify = function (t) { if (this.sHashHex = this.md.digest(), void 0 !== this.ecpubhex && void 0 !== this.eccurvename)
                            return new Er.crypto.ECDSA({ curve: this.eccurvename }).verifyHex(this.sHashHex, t, this.ecpubhex); if (this.pubKey instanceof qe && "rsaandmgf1" === this.pubkeyAlgName)
                            return this.pubKey.verifyWithMessageHashPSS(this.sHashHex, t, this.mdAlgName, this.pssSaltLen); if (this.pubKey instanceof qe && "rsa" === this.pubkeyAlgName)
                            return this.pubKey.verifyWithMessageHash(this.sHashHex, t); if (void 0 !== Er.crypto.ECDSA && this.pubKey instanceof Er.crypto.ECDSA)
                            return this.pubKey.verifyWithMessageHash(this.sHashHex, t); if (void 0 !== Er.crypto.DSA && this.pubKey instanceof Er.crypto.DSA)
                            return this.pubKey.verifyWithMessageHash(this.sHashHex, t); throw "Signature: unsupported public key alg: " + this.pubkeyAlgName; };
                    } }, this.init = function (t, e) { throw "init(key, pass) not supported for this alg:prov=" + this.algProvName; }, this.updateString = function (t) { throw "updateString(str) not supported for this alg:prov=" + this.algProvName; }, this.updateHex = function (t) { throw "updateHex(hex) not supported for this alg:prov=" + this.algProvName; }, this.sign = function () { throw "sign() not supported for this alg:prov=" + this.algProvName; }, this.signString = function (t) { throw "digestString(str) not supported for this alg:prov=" + this.algProvName; }, this.signHex = function (t) { throw "digestHex(hex) not supported for this alg:prov=" + this.algProvName; }, this.verify = function (t) { throw "verify(hSigVal) not supported for this alg:prov=" + this.algProvName; }, this.initParams = t, void 0 !== t && (void 0 !== t.alg && (this.algName = t.alg, void 0 === t.prov ? this.provName = Er.crypto.Util.DEFAULTPROVIDER[this.algName] : this.provName = t.prov, this.algProvName = this.algName + ":" + this.provName, this.setAlgAndProvider(this.algName, this.provName), this._setAlgNames()), void 0 !== t.psssaltlen && (this.pssSaltLen = t.psssaltlen), void 0 !== t.prvkeypem)) {
                        if (void 0 !== t.prvkeypas)
                            throw "both prvkeypem and prvkeypas parameters not supported";
                        try {
                            e = tn.getKey(t.prvkeypem);
                            this.init(e);
                        }
                        catch (t) {
                            throw "fatal error to load pem private key: " + t;
                        }
                    } }, Er.crypto.Cipher = function (t) { }, Er.crypto.Cipher.encrypt = function (t, e, r) { if (e instanceof qe && e.isPublic) {
                        var n = Er.crypto.Cipher.getAlgByKeyAndName(e, r);
                        if ("RSA" === n)
                            return e.encrypt(t);
                        if ("RSAOAEP" === n)
                            return e.encryptOAEP(t, "sha1");
                        var i = n.match(/^RSAOAEP(\d+)$/);
                        if (null !== i)
                            return e.encryptOAEP(t, "sha" + i[1]);
                        throw "Cipher.encrypt: unsupported algorithm for RSAKey: " + r;
                    } throw "Cipher.encrypt: unsupported key or algorithm"; }, Er.crypto.Cipher.decrypt = function (t, e, r) { if (e instanceof qe && e.isPrivate) {
                        var n = Er.crypto.Cipher.getAlgByKeyAndName(e, r);
                        if ("RSA" === n)
                            return e.decrypt(t);
                        if ("RSAOAEP" === n)
                            return e.decryptOAEP(t, "sha1");
                        var i = n.match(/^RSAOAEP(\d+)$/);
                        if (null !== i)
                            return e.decryptOAEP(t, "sha" + i[1]);
                        throw "Cipher.decrypt: unsupported algorithm for RSAKey: " + r;
                    } throw "Cipher.decrypt: unsupported key or algorithm"; }, Er.crypto.Cipher.getAlgByKeyAndName = function (t, e) { if (t instanceof qe) {
                        if (-1 != ":RSA:RSAOAEP:RSAOAEP224:RSAOAEP256:RSAOAEP384:RSAOAEP512:".indexOf(e))
                            return e;
                        if (null === e || void 0 === e)
                            return "RSA";
                        throw "getAlgByKeyAndName: not supported algorithm name for RSAKey: " + e;
                    } throw "getAlgByKeyAndName: not supported algorithm name: " + e; }, Er.crypto.OID = new function () { this.oidhex2name = { "2a864886f70d010101": "rsaEncryption", "2a8648ce3d0201": "ecPublicKey", "2a8648ce380401": "dsa", "2a8648ce3d030107": "secp256r1", "2b8104001f": "secp192k1", "2b81040021": "secp224r1", "2b8104000a": "secp256k1", "2b81040023": "secp521r1", "2b81040022": "secp384r1", "2a8648ce380403": "SHA1withDSA", "608648016503040301": "SHA224withDSA", "608648016503040302": "SHA256withDSA" }; }, void 0 !== Er && Er || (e.KJUR = Er = {}), void 0 !== Er.crypto && Er.crypto || (Er.crypto = {}), Er.crypto.ECDSA = function (t) { var e = new Me; this.type = "EC", this.isPrivate = !1, this.isPublic = !1, this.getBigRandom = function (t) { return new E(t.bitLength(), e).mod(t.subtract(E.ONE)).add(E.ONE); }, this.setNamedCurve = function (t) { this.ecparams = Er.crypto.ECParameterDB.getByName(t), this.prvKeyHex = null, this.pubKeyHex = null, this.curveName = t; }, this.setPrivateKeyHex = function (t) { this.isPrivate = !0, this.prvKeyHex = t; }, this.setPublicKeyHex = function (t) { this.isPublic = !0, this.pubKeyHex = t; }, this.getPublicKeyXYHex = function () { var t = this.pubKeyHex; if ("04" !== t.substr(0, 2))
                        throw "this method supports uncompressed format(04) only"; var e = this.ecparams.keylen / 4; if (t.length !== 2 + 2 * e)
                        throw "malformed public key hex length"; var r = {}; return r.x = t.substr(2, e), r.y = t.substr(2 + e), r; }, this.getShortNISTPCurveName = function () { var t = this.curveName; return "secp256r1" === t || "NIST P-256" === t || "P-256" === t || "prime256v1" === t ? "P-256" : "secp384r1" === t || "NIST P-384" === t || "P-384" === t ? "P-384" : null; }, this.generateKeyPairHex = function () { var t = this.ecparams.n, e = this.getBigRandom(t), r = this.ecparams.G.multiply(e), n = r.getX().toBigInteger(), i = r.getY().toBigInteger(), o = this.ecparams.keylen / 4, s = ("0000000000" + e.toString(16)).slice(-o), a = "04" + ("0000000000" + n.toString(16)).slice(-o) + ("0000000000" + i.toString(16)).slice(-o); return this.setPrivateKeyHex(s), this.setPublicKeyHex(a), { ecprvhex: s, ecpubhex: a }; }, this.signWithMessageHash = function (t) { return this.signHex(t, this.prvKeyHex); }, this.signHex = function (t, e) { var r = new E(e, 16), n = this.ecparams.n, i = new E(t, 16); do {
                        var o = this.getBigRandom(n), s = this.ecparams.G.multiply(o).getX().toBigInteger().mod(n);
                    } while (s.compareTo(E.ZERO) <= 0); var a = o.modInverse(n).multiply(i.add(r.multiply(s))).mod(n); return Er.crypto.ECDSA.biRSSigToASN1Sig(s, a); }, this.sign = function (t, e) { var r = e, n = this.ecparams.n, i = E.fromByteArrayUnsigned(t); do {
                        var o = this.getBigRandom(n), s = this.ecparams.G.multiply(o).getX().toBigInteger().mod(n);
                    } while (s.compareTo(E.ZERO) <= 0); var a = o.modInverse(n).multiply(i.add(r.multiply(s))).mod(n); return this.serializeSig(s, a); }, this.verifyWithMessageHash = function (t, e) { return this.verifyHex(t, e, this.pubKeyHex); }, this.verifyHex = function (t, e, r) { var n, i, o, s = Er.crypto.ECDSA.parseSigHex(e); n = s.r, i = s.s, o = We.decodeFromHex(this.ecparams.curve, r); var a = new E(t, 16); return this.verifyRaw(a, n, i, o); }, this.verify = function (t, e, n) { var i, o, s; if (Bitcoin.Util.isArray(e)) {
                        var a = this.parseSig(e);
                        i = a.r, o = a.s;
                    }
                    else {
                        if ("object" !== (void 0 === e ? "undefined" : r(e)) || !e.r || !e.s)
                            throw "Invalid value for signature";
                        i = e.r, o = e.s;
                    } if (n instanceof We)
                        s = n;
                    else {
                        if (!Bitcoin.Util.isArray(n))
                            throw "Invalid format for pubkey value, must be byte array or ECPointFp";
                        s = We.decodeFrom(this.ecparams.curve, n);
                    } var u = E.fromByteArrayUnsigned(t); return this.verifyRaw(u, i, o, s); }, this.verifyRaw = function (t, e, r, n) { var i = this.ecparams.n, o = this.ecparams.G; if (e.compareTo(E.ONE) < 0 || e.compareTo(i) >= 0)
                        return !1; if (r.compareTo(E.ONE) < 0 || r.compareTo(i) >= 0)
                        return !1; var s = r.modInverse(i), a = t.multiply(s).mod(i), u = e.multiply(s).mod(i); return o.multiply(a).add(n.multiply(u)).getX().toBigInteger().mod(i).equals(e); }, this.serializeSig = function (t, e) { var r = t.toByteArraySigned(), n = e.toByteArraySigned(), i = []; return i.push(2), i.push(r.length), (i = i.concat(r)).push(2), i.push(n.length), (i = i.concat(n)).unshift(i.length), i.unshift(48), i; }, this.parseSig = function (t) { var e; if (48 != t[0])
                        throw new Error("Signature not a valid DERSequence"); if (2 != t[e = 2])
                        throw new Error("First element in signature must be a DERInteger"); var r = t.slice(e + 2, e + 2 + t[e + 1]); if (2 != t[e += 2 + t[e + 1]])
                        throw new Error("Second element in signature must be a DERInteger"); var n = t.slice(e + 2, e + 2 + t[e + 1]); return e += 2 + t[e + 1], { r: E.fromByteArrayUnsigned(r), s: E.fromByteArrayUnsigned(n) }; }, this.parseSigCompact = function (t) { if (65 !== t.length)
                        throw "Signature has the wrong length"; var e = t[0] - 27; if (e < 0 || e > 7)
                        throw "Invalid signature type"; var r = this.ecparams.n; return { r: E.fromByteArrayUnsigned(t.slice(1, 33)).mod(r), s: E.fromByteArrayUnsigned(t.slice(33, 65)).mod(r), i: e }; }, this.readPKCS5PrvKeyHex = function (t) { var e, r, n, i = Ar, o = Er.crypto.ECDSA.getName, s = i.getVbyList; if (!1 === i.isASN1HEX(t))
                        throw "not ASN.1 hex string"; try {
                        e = s(t, 0, [2, 0], "06"), r = s(t, 0, [1], "04");
                        try {
                            n = s(t, 0, [3, 0], "03").substr(2);
                        }
                        catch (t) { }
                    }
                    catch (t) {
                        throw "malformed PKCS#1/5 plain ECC private key";
                    } if (this.curveName = o(e), void 0 === this.curveName)
                        throw "unsupported curve name"; this.setNamedCurve(this.curveName), this.setPublicKeyHex(n), this.setPrivateKeyHex(r), this.isPublic = !1; }, this.readPKCS8PrvKeyHex = function (t) { var e, r, n, i = Ar, o = Er.crypto.ECDSA.getName, s = i.getVbyList; if (!1 === i.isASN1HEX(t))
                        throw "not ASN.1 hex string"; try {
                        s(t, 0, [1, 0], "06"), e = s(t, 0, [1, 1], "06"), r = s(t, 0, [2, 0, 1], "04");
                        try {
                            n = s(t, 0, [2, 0, 2, 0], "03").substr(2);
                        }
                        catch (t) { }
                    }
                    catch (t) {
                        throw "malformed PKCS#8 plain ECC private key";
                    } if (this.curveName = o(e), void 0 === this.curveName)
                        throw "unsupported curve name"; this.setNamedCurve(this.curveName), this.setPublicKeyHex(n), this.setPrivateKeyHex(r), this.isPublic = !1; }, this.readPKCS8PubKeyHex = function (t) { var e, r, n = Ar, i = Er.crypto.ECDSA.getName, o = n.getVbyList; if (!1 === n.isASN1HEX(t))
                        throw "not ASN.1 hex string"; try {
                        o(t, 0, [0, 0], "06"), e = o(t, 0, [0, 1], "06"), r = o(t, 0, [1], "03").substr(2);
                    }
                    catch (t) {
                        throw "malformed PKCS#8 ECC public key";
                    } if (this.curveName = i(e), null === this.curveName)
                        throw "unsupported curve name"; this.setNamedCurve(this.curveName), this.setPublicKeyHex(r); }, this.readCertPubKeyHex = function (t, e) { 5 !== e && (e = 6); var r, n, i = Ar, o = Er.crypto.ECDSA.getName, s = i.getVbyList; if (!1 === i.isASN1HEX(t))
                        throw "not ASN.1 hex string"; try {
                        r = s(t, 0, [0, e, 0, 1], "06"), n = s(t, 0, [0, e, 1], "03").substr(2);
                    }
                    catch (t) {
                        throw "malformed X.509 certificate ECC public key";
                    } if (this.curveName = o(r), null === this.curveName)
                        throw "unsupported curve name"; this.setNamedCurve(this.curveName), this.setPublicKeyHex(n); }, void 0 !== t && void 0 !== t.curve && (this.curveName = t.curve), void 0 === this.curveName && (this.curveName = "secp256r1"), this.setNamedCurve(this.curveName), void 0 !== t && (void 0 !== t.prv && this.setPrivateKeyHex(t.prv), void 0 !== t.pub && this.setPublicKeyHex(t.pub)); }, Er.crypto.ECDSA.parseSigHex = function (t) { var e = Er.crypto.ECDSA.parseSigHexInHexRS(t); return { r: new E(e.r, 16), s: new E(e.s, 16) }; }, Er.crypto.ECDSA.parseSigHexInHexRS = function (t) { var e = Ar, r = e.getChildIdx, n = e.getV; if ("30" != t.substr(0, 2))
                        throw "signature is not a ASN.1 sequence"; var i = r(t, 0); if (2 != i.length)
                        throw "number of signature ASN.1 sequence elements seem wrong"; var o = i[0], s = i[1]; if ("02" != t.substr(o, 2))
                        throw "1st item of sequene of signature is not ASN.1 integer"; if ("02" != t.substr(s, 2))
                        throw "2nd item of sequene of signature is not ASN.1 integer"; return { r: n(t, o), s: n(t, s) }; }, Er.crypto.ECDSA.asn1SigToConcatSig = function (t) { var e = Er.crypto.ECDSA.parseSigHexInHexRS(t), r = e.r, n = e.s; if ("00" == r.substr(0, 2) && r.length % 32 == 2 && (r = r.substr(2)), "00" == n.substr(0, 2) && n.length % 32 == 2 && (n = n.substr(2)), r.length % 32 == 30 && (r = "00" + r), n.length % 32 == 30 && (n = "00" + n), r.length % 32 != 0)
                        throw "unknown ECDSA sig r length error"; if (n.length % 32 != 0)
                        throw "unknown ECDSA sig s length error"; return r + n; }, Er.crypto.ECDSA.concatSigToASN1Sig = function (t) { if (t.length / 2 * 8 % 128 != 0)
                        throw "unknown ECDSA concatinated r-s sig  length error"; var e = t.substr(0, t.length / 2), r = t.substr(t.length / 2); return Er.crypto.ECDSA.hexRSSigToASN1Sig(e, r); }, Er.crypto.ECDSA.hexRSSigToASN1Sig = function (t, e) { var r = new E(t, 16), n = new E(e, 16); return Er.crypto.ECDSA.biRSSigToASN1Sig(r, n); }, Er.crypto.ECDSA.biRSSigToASN1Sig = function (t, e) { var r = Er.asn1, n = new r.DERInteger({ bigint: t }), i = new r.DERInteger({ bigint: e }); return new r.DERSequence({ array: [n, i] }).getEncodedHex(); }, Er.crypto.ECDSA.getName = function (t) { return "2a8648ce3d030107" === t ? "secp256r1" : "2b8104000a" === t ? "secp256k1" : "2b81040022" === t ? "secp384r1" : -1 !== "|secp256r1|NIST P-256|P-256|prime256v1|".indexOf(t) ? "secp256r1" : -1 !== "|secp256k1|".indexOf(t) ? "secp256k1" : -1 !== "|secp384r1|NIST P-384|P-384|".indexOf(t) ? "secp384r1" : null; }, void 0 !== Er && Er || (e.KJUR = Er = {}), void 0 !== Er.crypto && Er.crypto || (Er.crypto = {}), Er.crypto.ECParameterDB = new function () { var t = {}, e = {}; function r(t) { return new E(t, 16); } this.getByName = function (r) { var n = r; if (void 0 !== e[n] && (n = e[r]), void 0 !== t[n])
                        return t[n]; throw "unregistered EC curve name: " + n; }, this.regist = function (n, i, o, s, a, u, c, h, l, f, d, g) { t[n] = {}; var p = r(o), v = r(s), y = r(a), m = r(u), _ = r(c), S = new ze(p, v, y), F = S.decodePointHex("04" + h + l); t[n].name = n, t[n].keylen = i, t[n].curve = S, t[n].G = F, t[n].n = m, t[n].h = _, t[n].oid = d, t[n].info = g; for (var b = 0; b < f.length; b++)
                        e[f[b]] = n; }; }, Er.crypto.ECParameterDB.regist("secp128r1", 128, "FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF", "FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC", "E87579C11079F43DD824993C2CEE5ED3", "FFFFFFFE0000000075A30D1B9038A115", "1", "161FF7528B899B2D0C28607CA52C5B86", "CF5AC8395BAFEB13C02DA292DDED7A83", [], "", "secp128r1 : SECG curve over a 128 bit prime field"), Er.crypto.ECParameterDB.regist("secp160k1", 160, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73", "0", "7", "0100000000000000000001B8FA16DFAB9ACA16B6B3", "1", "3B4C382CE37AA192A4019E763036F4F5DD4D7EBB", "938CF935318FDCED6BC28286531733C3F03C4FEE", [], "", "secp160k1 : SECG curve over a 160 bit prime field"), Er.crypto.ECParameterDB.regist("secp160r1", 160, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC", "1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45", "0100000000000000000001F4C8F927AED3CA752257", "1", "4A96B5688EF573284664698968C38BB913CBFC82", "23A628553168947D59DCC912042351377AC5FB32", [], "", "secp160r1 : SECG curve over a 160 bit prime field"), Er.crypto.ECParameterDB.regist("secp192k1", 192, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37", "0", "3", "FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D", "1", "DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D", "9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D", []), Er.crypto.ECParameterDB.regist("secp192r1", 192, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC", "64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1", "FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831", "1", "188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF1012", "07192B95FFC8DA78631011ED6B24CDD573F977A11E794811", []), Er.crypto.ECParameterDB.regist("secp224r1", 224, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE", "B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4", "FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D", "1", "B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21", "BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34", []), Er.crypto.ECParameterDB.regist("secp256k1", 256, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFC2F", "0", "7", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "1", "79BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798", "483ADA7726A3C4655DA4FBFC0E1108A8FD17B448A68554199C47D08FFB10D4B8", []), Er.crypto.ECParameterDB.regist("secp256r1", 256, "FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF", "FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC", "5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B", "FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551", "1", "6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296", "4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5", ["NIST P-256", "P-256", "prime256v1"]), Er.crypto.ECParameterDB.regist("secp384r1", 384, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC", "B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973", "1", "AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB7", "3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f", ["NIST P-384", "P-384"]), Er.crypto.ECParameterDB.regist("secp521r1", 521, "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC", "051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00", "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409", "1", "C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66", "011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650", ["NIST P-521", "P-521"]);
                    var tn = function () { var t = function t(r, n, i) { return e(y.AES, r, n, i); }, e = function t(e, r, n, i) { var o = y.enc.Hex.parse(r), s = y.enc.Hex.parse(n), a = y.enc.Hex.parse(i), u = {}; u.key = s, u.iv = a, u.ciphertext = o; var c = e.decrypt(u, s, { iv: a }); return y.enc.Hex.stringify(c); }, r = function t(e, r, i) { return n(y.AES, e, r, i); }, n = function t(e, r, n, i) { var o = y.enc.Hex.parse(r), s = y.enc.Hex.parse(n), a = y.enc.Hex.parse(i), u = e.encrypt(o, s, { iv: a }), c = y.enc.Hex.parse(u.toString()); return y.enc.Base64.stringify(c); }, i = { "AES-256-CBC": { proc: t, eproc: r, keylen: 32, ivlen: 16 }, "AES-192-CBC": { proc: t, eproc: r, keylen: 24, ivlen: 16 }, "AES-128-CBC": { proc: t, eproc: r, keylen: 16, ivlen: 16 }, "DES-EDE3-CBC": { proc: function t(r, n, i) { return e(y.TripleDES, r, n, i); }, eproc: function t(e, r, i) { return n(y.TripleDES, e, r, i); }, keylen: 24, ivlen: 8 }, "DES-CBC": { proc: function t(r, n, i) { return e(y.DES, r, n, i); }, eproc: function t(e, r, i) { return n(y.DES, e, r, i); }, keylen: 8, ivlen: 8 } }, o = function t(e) { var r = {}, n = e.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)", "m")); n && (r.cipher = n[1], r.ivsalt = n[2]); var i = e.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----")); i && (r.type = i[1]); var o = -1, s = 0; -1 != e.indexOf("\r\n\r\n") && (o = e.indexOf("\r\n\r\n"), s = 2), -1 != e.indexOf("\n\n") && (o = e.indexOf("\n\n"), s = 1); var a = e.indexOf("-----END"); if (-1 != o && -1 != a) {
                        var u = e.substring(o + 2 * s, a - s);
                        u = u.replace(/\s+/g, ""), r.data = u;
                    } return r; }, s = function t(e, r, n) { for (var o = n.substring(0, 16), s = y.enc.Hex.parse(o), a = y.enc.Utf8.parse(r), u = i[e].keylen + i[e].ivlen, c = "", h = null;;) {
                        var l = y.algo.MD5.create();
                        if (null != h && l.update(h), l.update(a), l.update(s), h = l.finalize(), (c += y.enc.Hex.stringify(h)).length >= 2 * u)
                            break;
                    } var f = {}; return f.keyhex = c.substr(0, 2 * i[e].keylen), f.ivhex = c.substr(2 * i[e].keylen, 2 * i[e].ivlen), f; }, a = function t(e, r, n, o) { var s = y.enc.Base64.parse(e), a = y.enc.Hex.stringify(s); return (0, i[r].proc)(a, n, o); }; return { version: "1.0.0", parsePKCS5PEM: function t(e) { return o(e); }, getKeyAndUnusedIvByPasscodeAndIvsalt: function t(e, r, n) { return s(e, r, n); }, decryptKeyB64: function t(e, r, n, i) { return a(e, r, n, i); }, getDecryptedKeyHex: function t(e, r) { var n = o(e), i = (n.cipher), u = n.ivsalt, c = n.data, h = s(i, r, u).keyhex; return a(c, i, h, u); }, getEncryptedPKCS5PEMFromPrvKeyHex: function t(e, r, n, o, a) { var u = ""; if (void 0 !== o && null != o || (o = "AES-256-CBC"), void 0 === i[o])
                            throw "KEYUTIL unsupported algorithm: " + o; void 0 !== a && null != a || (a = function t(e) { var r = y.lib.WordArray.random(e); return y.enc.Hex.stringify(r); }(i[o].ivlen).toUpperCase()); var c = function t(e, r, n, o) { return (0, i[r].eproc)(e, n, o); }(r, o, s(o, n, a).keyhex, a); u = "-----BEGIN " + e + " PRIVATE KEY-----\r\n"; return u += "Proc-Type: 4,ENCRYPTED\r\n", u += "DEK-Info: " + o + "," + a + "\r\n", u += "\r\n", u += c.replace(/(.{64})/g, "$1\r\n"), u += "\r\n-----END " + e + " PRIVATE KEY-----\r\n"; }, parseHexOfEncryptedPKCS8: function t(e) { var r = Ar, n = r.getChildIdx, i = r.getV, o = {}, s = n(e, 0); if (2 != s.length)
                            throw "malformed format: SEQUENCE(0).items != 2: " + s.length; o.ciphertext = i(e, s[1]); var a = n(e, s[0]); if (2 != a.length)
                            throw "malformed format: SEQUENCE(0.0).items != 2: " + a.length; if ("2a864886f70d01050d" != i(e, a[0]))
                            throw "this only supports pkcs5PBES2"; var u = n(e, a[1]); if (2 != a.length)
                            throw "malformed format: SEQUENCE(0.0.1).items != 2: " + u.length; var c = n(e, u[1]); if (2 != c.length)
                            throw "malformed format: SEQUENCE(0.0.1.1).items != 2: " + c.length; if ("2a864886f70d0307" != i(e, c[0]))
                            throw "this only supports TripleDES"; o.encryptionSchemeAlg = "TripleDES", o.encryptionSchemeIV = i(e, c[1]); var h = n(e, u[0]); if (2 != h.length)
                            throw "malformed format: SEQUENCE(0.0.1.0).items != 2: " + h.length; if ("2a864886f70d01050c" != i(e, h[0]))
                            throw "this only supports pkcs5PBKDF2"; var l = n(e, h[1]); if (l.length < 2)
                            throw "malformed format: SEQUENCE(0.0.1.0.1).items < 2: " + l.length; o.pbkdf2Salt = i(e, l[0]); var f = i(e, l[1]); try {
                            o.pbkdf2Iter = parseInt(f, 16);
                        }
                        catch (t) {
                            throw "malformed format pbkdf2Iter: " + f;
                        } return o; }, getPBKDF2KeyHexFromParam: function t(e, r) { var n = y.enc.Hex.parse(e.pbkdf2Salt), i = e.pbkdf2Iter, o = y.PBKDF2(r, n, { keySize: 6, iterations: i }); return y.enc.Hex.stringify(o); }, _getPlainPKCS8HexFromEncryptedPKCS8PEM: function t(e, r) { var n = qr(e, "ENCRYPTED PRIVATE KEY"), i = this.parseHexOfEncryptedPKCS8(n), o = tn.getPBKDF2KeyHexFromParam(i, r), s = {}; s.ciphertext = y.enc.Hex.parse(i.ciphertext); var a = y.enc.Hex.parse(o), u = y.enc.Hex.parse(i.encryptionSchemeIV), c = y.TripleDES.decrypt(s, a, { iv: u }); return y.enc.Hex.stringify(c); }, getKeyFromEncryptedPKCS8PEM: function t(e, r) { var n = this._getPlainPKCS8HexFromEncryptedPKCS8PEM(e, r); return this.getKeyFromPlainPrivatePKCS8Hex(n); }, parsePlainPrivatePKCS8Hex: function t(e) { var r = Ar, n = r.getChildIdx, i = r.getV, o = { algparam: null }; if ("30" != e.substr(0, 2))
                            throw "malformed plain PKCS8 private key(code:001)"; var s = n(e, 0); if (3 != s.length)
                            throw "malformed plain PKCS8 private key(code:002)"; if ("30" != e.substr(s[1], 2))
                            throw "malformed PKCS8 private key(code:003)"; var a = n(e, s[1]); if (2 != a.length)
                            throw "malformed PKCS8 private key(code:004)"; if ("06" != e.substr(a[0], 2))
                            throw "malformed PKCS8 private key(code:005)"; if (o.algoid = i(e, a[0]), "06" == e.substr(a[1], 2) && (o.algparam = i(e, a[1])), "04" != e.substr(s[2], 2))
                            throw "malformed PKCS8 private key(code:006)"; return o.keyidx = r.getVidx(e, s[2]), o; }, getKeyFromPlainPrivatePKCS8PEM: function t(e) { var r = qr(e, "PRIVATE KEY"); return this.getKeyFromPlainPrivatePKCS8Hex(r); }, getKeyFromPlainPrivatePKCS8Hex: function t(e) { var r, n = this.parsePlainPrivatePKCS8Hex(e); if ("2a864886f70d010101" == n.algoid)
                            r = new qe;
                        else if ("2a8648ce380401" == n.algoid)
                            r = new Er.crypto.DSA;
                        else {
                            if ("2a8648ce3d0201" != n.algoid)
                                throw "unsupported private key algorithm";
                            r = new Er.crypto.ECDSA;
                        } return r.readPKCS8PrvKeyHex(e), r; }, _getKeyFromPublicPKCS8Hex: function t(e) { var r, n = Ar.getVbyList(e, 0, [0, 0], "06"); if ("2a864886f70d010101" === n)
                            r = new qe;
                        else if ("2a8648ce380401" === n)
                            r = new Er.crypto.DSA;
                        else {
                            if ("2a8648ce3d0201" !== n)
                                throw "unsupported PKCS#8 public key hex";
                            r = new Er.crypto.ECDSA;
                        } return r.readPKCS8PubKeyHex(e), r; }, parsePublicRawRSAKeyHex: function t(e) { var r = Ar, n = r.getChildIdx, i = r.getV, o = {}; if ("30" != e.substr(0, 2))
                            throw "malformed RSA key(code:001)"; var s = n(e, 0); if (2 != s.length)
                            throw "malformed RSA key(code:002)"; if ("02" != e.substr(s[0], 2))
                            throw "malformed RSA key(code:003)"; if (o.n = i(e, s[0]), "02" != e.substr(s[1], 2))
                            throw "malformed RSA key(code:004)"; return o.e = i(e, s[1]), o; }, parsePublicPKCS8Hex: function t(e) { var r = Ar, n = r.getChildIdx, i = r.getV, o = { algparam: null }, s = n(e, 0); if (2 != s.length)
                            throw "outer DERSequence shall have 2 elements: " + s.length; var a = s[0]; if ("30" != e.substr(a, 2))
                            throw "malformed PKCS8 public key(code:001)"; var u = n(e, a); if (2 != u.length)
                            throw "malformed PKCS8 public key(code:002)"; if ("06" != e.substr(u[0], 2))
                            throw "malformed PKCS8 public key(code:003)"; if (o.algoid = i(e, u[0]), "06" == e.substr(u[1], 2) ? o.algparam = i(e, u[1]) : "30" == e.substr(u[1], 2) && (o.algparam = {}, o.algparam.p = r.getVbyList(e, u[1], [0], "02"), o.algparam.q = r.getVbyList(e, u[1], [1], "02"), o.algparam.g = r.getVbyList(e, u[1], [2], "02")), "03" != e.substr(s[1], 2))
                            throw "malformed PKCS8 public key(code:004)"; return o.key = i(e, s[1]).substr(2), o; } }; }();
                    tn.getKey = function (t, e, r) { var n = (v = Ar).getChildIdx, i = (v.getVbyList), o = Er.crypto, s = o.ECDSA, a = o.DSA, u = qe, c = qr, h = tn; if (void 0 !== u && t instanceof u)
                        return t; if (void 0 !== s && t instanceof s)
                        return t; if (void 0 !== a && t instanceof a)
                        return t; if (void 0 !== t.curve && void 0 !== t.xy && void 0 === t.d)
                        return new s({ pub: t.xy, curve: t.curve }); if (void 0 !== t.curve && void 0 !== t.d)
                        return new s({ prv: t.d, curve: t.curve }); if (void 0 === t.kty && void 0 !== t.n && void 0 !== t.e && void 0 === t.d)
                        return (P = new u).setPublic(t.n, t.e), P; if (void 0 === t.kty && void 0 !== t.n && void 0 !== t.e && void 0 !== t.d && void 0 !== t.p && void 0 !== t.q && void 0 !== t.dp && void 0 !== t.dq && void 0 !== t.co && void 0 === t.qi)
                        return (P = new u).setPrivateEx(t.n, t.e, t.d, t.p, t.q, t.dp, t.dq, t.co), P; if (void 0 === t.kty && void 0 !== t.n && void 0 !== t.e && void 0 !== t.d && void 0 === t.p)
                        return (P = new u).setPrivate(t.n, t.e, t.d), P; if (void 0 !== t.p && void 0 !== t.q && void 0 !== t.g && void 0 !== t.y && void 0 === t.x)
                        return (P = new a).setPublic(t.p, t.q, t.g, t.y), P; if (void 0 !== t.p && void 0 !== t.q && void 0 !== t.g && void 0 !== t.y && void 0 !== t.x)
                        return (P = new a).setPrivate(t.p, t.q, t.g, t.y, t.x), P; if ("RSA" === t.kty && void 0 !== t.n && void 0 !== t.e && void 0 === t.d)
                        return (P = new u).setPublic(Lr(t.n), Lr(t.e)), P; if ("RSA" === t.kty && void 0 !== t.n && void 0 !== t.e && void 0 !== t.d && void 0 !== t.p && void 0 !== t.q && void 0 !== t.dp && void 0 !== t.dq && void 0 !== t.qi)
                        return (P = new u).setPrivateEx(Lr(t.n), Lr(t.e), Lr(t.d), Lr(t.p), Lr(t.q), Lr(t.dp), Lr(t.dq), Lr(t.qi)), P; if ("RSA" === t.kty && void 0 !== t.n && void 0 !== t.e && void 0 !== t.d)
                        return (P = new u).setPrivate(Lr(t.n), Lr(t.e), Lr(t.d)), P; if ("EC" === t.kty && void 0 !== t.crv && void 0 !== t.x && void 0 !== t.y && void 0 === t.d) {
                        var l = (A = new s({ curve: t.crv })).ecparams.keylen / 4, f = "04" + ("0000000000" + Lr(t.x)).slice(-l) + ("0000000000" + Lr(t.y)).slice(-l);
                        return A.setPublicKeyHex(f), A;
                    } if ("EC" === t.kty && void 0 !== t.crv && void 0 !== t.x && void 0 !== t.y && void 0 !== t.d) {
                        l = (A = new s({ curve: t.crv })).ecparams.keylen / 4, f = "04" + ("0000000000" + Lr(t.x)).slice(-l) + ("0000000000" + Lr(t.y)).slice(-l);
                        var d = ("0000000000" + Lr(t.d)).slice(-l);
                        return A.setPublicKeyHex(f), A.setPrivateKeyHex(d), A;
                    } if ("pkcs5prv" === r) {
                        var g, p = t, v = Ar;
                        if (9 === (g = n(p, 0)).length)
                            (P = new u).readPKCS5PrvKeyHex(p);
                        else if (6 === g.length)
                            (P = new a).readPKCS5PrvKeyHex(p);
                        else {
                            if (!(g.length > 2 && "04" === p.substr(g[1], 2)))
                                throw "unsupported PKCS#1/5 hexadecimal key";
                            (P = new s).readPKCS5PrvKeyHex(p);
                        }
                        return P;
                    } if ("pkcs8prv" === r)
                        return P = h.getKeyFromPlainPrivatePKCS8Hex(t); if ("pkcs8pub" === r)
                        return h._getKeyFromPublicPKCS8Hex(t); if ("x509pub" === r)
                        return sn.getPublicKeyFromCertHex(t); if (-1 != t.indexOf("-END CERTIFICATE-", 0) || -1 != t.indexOf("-END X509 CERTIFICATE-", 0) || -1 != t.indexOf("-END TRUSTED CERTIFICATE-", 0))
                        return sn.getPublicKeyFromCertPEM(t); if (-1 != t.indexOf("-END PUBLIC KEY-")) {
                        var y = qr(t, "PUBLIC KEY");
                        return h._getKeyFromPublicPKCS8Hex(y);
                    } if (-1 != t.indexOf("-END RSA PRIVATE KEY-") && -1 == t.indexOf("4,ENCRYPTED")) {
                        var m = c(t, "RSA PRIVATE KEY");
                        return h.getKey(m, null, "pkcs5prv");
                    } if (-1 != t.indexOf("-END DSA PRIVATE KEY-") && -1 == t.indexOf("4,ENCRYPTED")) {
                        var _ = i(R = c(t, "DSA PRIVATE KEY"), 0, [1], "02"), S = i(R, 0, [2], "02"), F = i(R, 0, [3], "02"), b = i(R, 0, [4], "02"), w = i(R, 0, [5], "02");
                        return (P = new a).setPrivate(new E(_, 16), new E(S, 16), new E(F, 16), new E(b, 16), new E(w, 16)), P;
                    } if (-1 != t.indexOf("-END PRIVATE KEY-"))
                        return h.getKeyFromPlainPrivatePKCS8PEM(t); if (-1 != t.indexOf("-END RSA PRIVATE KEY-") && -1 != t.indexOf("4,ENCRYPTED")) {
                        var x = h.getDecryptedKeyHex(t, e), k = new qe;
                        return k.readPKCS5PrvKeyHex(x), k;
                    } if (-1 != t.indexOf("-END EC PRIVATE KEY-") && -1 != t.indexOf("4,ENCRYPTED")) {
                        var A, P = i(R = h.getDecryptedKeyHex(t, e), 0, [1], "04"), C = i(R, 0, [2, 0], "06"), T = i(R, 0, [3, 0], "03").substr(2);
                        if (void 0 === Er.crypto.OID.oidhex2name[C])
                            throw "undefined OID(hex) in KJUR.crypto.OID: " + C;
                        return (A = new s({ curve: Er.crypto.OID.oidhex2name[C] })).setPublicKeyHex(T), A.setPrivateKeyHex(P), A.isPublic = !1, A;
                    } if (-1 != t.indexOf("-END DSA PRIVATE KEY-") && -1 != t.indexOf("4,ENCRYPTED")) {
                        var R;
                        _ = i(R = h.getDecryptedKeyHex(t, e), 0, [1], "02"), S = i(R, 0, [2], "02"), F = i(R, 0, [3], "02"), b = i(R, 0, [4], "02"), w = i(R, 0, [5], "02");
                        return (P = new a).setPrivate(new E(_, 16), new E(S, 16), new E(F, 16), new E(b, 16), new E(w, 16)), P;
                    } if (-1 != t.indexOf("-END ENCRYPTED PRIVATE KEY-"))
                        return h.getKeyFromEncryptedPKCS8PEM(t, e); throw "not supported argument"; }, tn.generateKeypair = function (t, e) { if ("RSA" == t) {
                        var r = e;
                        (s = new qe).generate(r, "10001"), s.isPrivate = !0, s.isPublic = !0;
                        var n = new qe, i = s.n.toString(16), o = s.e.toString(16);
                        return n.setPublic(i, o), n.isPrivate = !1, n.isPublic = !0, (a = {}).prvKeyObj = s, a.pubKeyObj = n, a;
                    } if ("EC" == t) {
                        var s, a, u = e, c = new Er.crypto.ECDSA({ curve: u }).generateKeyPairHex();
                        return (s = new Er.crypto.ECDSA({ curve: u })).setPublicKeyHex(c.ecpubhex), s.setPrivateKeyHex(c.ecprvhex), s.isPrivate = !0, s.isPublic = !1, (n = new Er.crypto.ECDSA({ curve: u })).setPublicKeyHex(c.ecpubhex), n.isPrivate = !1, n.isPublic = !0, (a = {}).prvKeyObj = s, a.pubKeyObj = n, a;
                    } throw "unknown algorithm: " + t; }, tn.getPEM = function (t, e, r, n, i, o) { var s = Er, a = s.asn1, u = a.DERObjectIdentifier, c = a.DERInteger, h = a.ASN1Util.newObject, l = a.x509.SubjectPublicKeyInfo, f = s.crypto, d = f.DSA, g = f.ECDSA, p = qe; function v(t) { return h({ seq: [{ int: 0 }, { int: { bigint: t.n } }, { int: t.e }, { int: { bigint: t.d } }, { int: { bigint: t.p } }, { int: { bigint: t.q } }, { int: { bigint: t.dmp1 } }, { int: { bigint: t.dmq1 } }, { int: { bigint: t.coeff } }] }); } function m(t) { return h({ seq: [{ int: 1 }, { octstr: { hex: t.prvKeyHex } }, { tag: ["a0", !0, { oid: { name: t.curveName } }] }, { tag: ["a1", !0, { bitstr: { hex: "00" + t.pubKeyHex } }] }] }); } function _(t) { return h({ seq: [{ int: 0 }, { int: { bigint: t.p } }, { int: { bigint: t.q } }, { int: { bigint: t.g } }, { int: { bigint: t.y } }, { int: { bigint: t.x } }] }); } if ((void 0 !== p && t instanceof p || void 0 !== d && t instanceof d || void 0 !== g && t instanceof g) && 1 == t.isPublic && (void 0 === e || "PKCS8PUB" == e))
                        return Vr(w = new l(t).getEncodedHex(), "PUBLIC KEY"); if ("PKCS1PRV" == e && void 0 !== p && t instanceof p && (void 0 === r || null == r) && 1 == t.isPrivate)
                        return Vr(w = v(t).getEncodedHex(), "RSA PRIVATE KEY"); if ("PKCS1PRV" == e && void 0 !== g && t instanceof g && (void 0 === r || null == r) && 1 == t.isPrivate) {
                        var S = new u({ name: t.curveName }).getEncodedHex(), F = m(t).getEncodedHex(), b = "";
                        return b += Vr(S, "EC PARAMETERS"), b += Vr(F, "EC PRIVATE KEY");
                    } if ("PKCS1PRV" == e && void 0 !== d && t instanceof d && (void 0 === r || null == r) && 1 == t.isPrivate)
                        return Vr(w = _(t).getEncodedHex(), "DSA PRIVATE KEY"); if ("PKCS5PRV" == e && void 0 !== p && t instanceof p && void 0 !== r && null != r && 1 == t.isPrivate) {
                        var w = v(t).getEncodedHex();
                        return void 0 === n && (n = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA", w, r, n, o);
                    } if ("PKCS5PRV" == e && void 0 !== g && t instanceof g && void 0 !== r && null != r && 1 == t.isPrivate) {
                        w = m(t).getEncodedHex();
                        return void 0 === n && (n = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("EC", w, r, n, o);
                    } if ("PKCS5PRV" == e && void 0 !== d && t instanceof d && void 0 !== r && null != r && 1 == t.isPrivate) {
                        w = _(t).getEncodedHex();
                        return void 0 === n && (n = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("DSA", w, r, n, o);
                    } var E = function t(e, r) { var n = x(e, r); return new h({ seq: [{ seq: [{ oid: { name: "pkcs5PBES2" } }, { seq: [{ seq: [{ oid: { name: "pkcs5PBKDF2" } }, { seq: [{ octstr: { hex: n.pbkdf2Salt } }, { int: n.pbkdf2Iter }] }] }, { seq: [{ oid: { name: "des-EDE3-CBC" } }, { octstr: { hex: n.encryptionSchemeIV } }] }] }] }, { octstr: { hex: n.ciphertext } }] }).getEncodedHex(); }, x = function t(e, r) { var n = y.lib.WordArray.random(8), i = y.lib.WordArray.random(8), o = y.PBKDF2(r, n, { keySize: 6, iterations: 100 }), s = y.enc.Hex.parse(e), a = y.TripleDES.encrypt(s, o, { iv: i }) + "", u = {}; return u.ciphertext = a, u.pbkdf2Salt = y.enc.Hex.stringify(n), u.pbkdf2Iter = 100, u.encryptionSchemeAlg = "DES-EDE3-CBC", u.encryptionSchemeIV = y.enc.Hex.stringify(i), u; }; if ("PKCS8PRV" == e && void 0 != p && t instanceof p && 1 == t.isPrivate) {
                        var k = v(t).getEncodedHex();
                        w = h({ seq: [{ int: 0 }, { seq: [{ oid: { name: "rsaEncryption" } }, { null: !0 }] }, { octstr: { hex: k } }] }).getEncodedHex();
                        return void 0 === r || null == r ? Vr(w, "PRIVATE KEY") : Vr(F = E(w, r), "ENCRYPTED PRIVATE KEY");
                    } if ("PKCS8PRV" == e && void 0 !== g && t instanceof g && 1 == t.isPrivate) {
                        k = new h({ seq: [{ int: 1 }, { octstr: { hex: t.prvKeyHex } }, { tag: ["a1", !0, { bitstr: { hex: "00" + t.pubKeyHex } }] }] }).getEncodedHex(), w = h({ seq: [{ int: 0 }, { seq: [{ oid: { name: "ecPublicKey" } }, { oid: { name: t.curveName } }] }, { octstr: { hex: k } }] }).getEncodedHex();
                        return void 0 === r || null == r ? Vr(w, "PRIVATE KEY") : Vr(F = E(w, r), "ENCRYPTED PRIVATE KEY");
                    } if ("PKCS8PRV" == e && void 0 !== d && t instanceof d && 1 == t.isPrivate) {
                        k = new c({ bigint: t.x }).getEncodedHex(), w = h({ seq: [{ int: 0 }, { seq: [{ oid: { name: "dsa" } }, { seq: [{ int: { bigint: t.p } }, { int: { bigint: t.q } }, { int: { bigint: t.g } }] }] }, { octstr: { hex: k } }] }).getEncodedHex();
                        return void 0 === r || null == r ? Vr(w, "PRIVATE KEY") : Vr(F = E(w, r), "ENCRYPTED PRIVATE KEY");
                    } throw "unsupported object nor format"; }, tn.getKeyFromCSRPEM = function (t) { var e = qr(t, "CERTIFICATE REQUEST"); return tn.getKeyFromCSRHex(e); }, tn.getKeyFromCSRHex = function (t) { var e = tn.parseCSRHex(t); return tn.getKey(e.p8pubkeyhex, null, "pkcs8pub"); }, tn.parseCSRHex = function (t) { var e = Ar, r = e.getChildIdx, n = e.getTLV, i = {}, o = t; if ("30" != o.substr(0, 2))
                        throw "malformed CSR(code:001)"; var s = r(o, 0); if (s.length < 1)
                        throw "malformed CSR(code:002)"; if ("30" != o.substr(s[0], 2))
                        throw "malformed CSR(code:003)"; var a = r(o, s[0]); if (a.length < 3)
                        throw "malformed CSR(code:004)"; return i.p8pubkeyhex = n(o, a[2]), i; }, tn.getJWKFromKey = function (t) { var e = {}; if (t instanceof qe && t.isPrivate)
                        return e.kty = "RSA", e.n = Ur(t.n.toString(16)), e.e = Ur(t.e.toString(16)), e.d = Ur(t.d.toString(16)), e.p = Ur(t.p.toString(16)), e.q = Ur(t.q.toString(16)), e.dp = Ur(t.dmp1.toString(16)), e.dq = Ur(t.dmq1.toString(16)), e.qi = Ur(t.coeff.toString(16)), e; if (t instanceof qe && t.isPublic)
                        return e.kty = "RSA", e.n = Ur(t.n.toString(16)), e.e = Ur(t.e.toString(16)), e; if (t instanceof Er.crypto.ECDSA && t.isPrivate) {
                        if ("P-256" !== (n = t.getShortNISTPCurveName()) && "P-384" !== n)
                            throw "unsupported curve name for JWT: " + n;
                        var r = t.getPublicKeyXYHex();
                        return e.kty = "EC", e.crv = n, e.x = Ur(r.x), e.y = Ur(r.y), e.d = Ur(t.prvKeyHex), e;
                    } if (t instanceof Er.crypto.ECDSA && t.isPublic) {
                        var n;
                        if ("P-256" !== (n = t.getShortNISTPCurveName()) && "P-384" !== n)
                            throw "unsupported curve name for JWT: " + n;
                        r = t.getPublicKeyXYHex();
                        return e.kty = "EC", e.crv = n, e.x = Ur(r.x), e.y = Ur(r.y), e;
                    } throw "not supported key object"; }, qe.getPosArrayOfChildrenFromHex = function (t) { return Ar.getChildIdx(t, 0); }, qe.getHexValueArrayOfChildrenFromHex = function (t) { var e, r = Ar.getV, n = r(t, (e = qe.getPosArrayOfChildrenFromHex(t))[0]), i = r(t, e[1]), o = r(t, e[2]), s = r(t, e[3]), a = r(t, e[4]), u = r(t, e[5]), c = r(t, e[6]), h = r(t, e[7]), l = r(t, e[8]); return (e = new Array).push(n, i, o, s, a, u, c, h, l), e; }, qe.prototype.readPrivateKeyFromPEMString = function (t) { var e = qr(t), r = qe.getHexValueArrayOfChildrenFromHex(e); this.setPrivateEx(r[1], r[2], r[3], r[4], r[5], r[6], r[7], r[8]); }, qe.prototype.readPKCS5PrvKeyHex = function (t) { var e = qe.getHexValueArrayOfChildrenFromHex(t); this.setPrivateEx(e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]); }, qe.prototype.readPKCS8PrvKeyHex = function (t) { var e, r, n, i, o, s, a, u, c = Ar, h = c.getVbyList; if (!1 === c.isASN1HEX(t))
                        throw "not ASN.1 hex string"; try {
                        e = h(t, 0, [2, 0, 1], "02"), r = h(t, 0, [2, 0, 2], "02"), n = h(t, 0, [2, 0, 3], "02"), i = h(t, 0, [2, 0, 4], "02"), o = h(t, 0, [2, 0, 5], "02"), s = h(t, 0, [2, 0, 6], "02"), a = h(t, 0, [2, 0, 7], "02"), u = h(t, 0, [2, 0, 8], "02");
                    }
                    catch (t) {
                        throw "malformed PKCS#8 plain RSA private key";
                    } this.setPrivateEx(e, r, n, i, o, s, a, u); }, qe.prototype.readPKCS5PubKeyHex = function (t) { var e = Ar, r = e.getV; if (!1 === e.isASN1HEX(t))
                        throw "keyHex is not ASN.1 hex string"; var n = e.getChildIdx(t, 0); if (2 !== n.length || "02" !== t.substr(n[0], 2) || "02" !== t.substr(n[1], 2))
                        throw "wrong hex for PKCS#5 public key"; var i = r(t, n[0]), o = r(t, n[1]); this.setPublic(i, o); }, qe.prototype.readPKCS8PubKeyHex = function (t) { var e = Ar; if (!1 === e.isASN1HEX(t))
                        throw "not ASN.1 hex string"; if ("06092a864886f70d010101" !== e.getTLVbyList(t, 0, [0, 0]))
                        throw "not PKCS8 RSA public key"; var r = e.getTLVbyList(t, 0, [1, 0]); this.readPKCS5PubKeyHex(r); }, qe.prototype.readCertPubKeyHex = function (t, e) { var r, n; (r = new sn).readCertHex(t), n = r.getPublicKeyHex(), this.readPKCS8PubKeyHex(n); };
                    var en = new RegExp("");
                    function rn(t, e) { for (var r = "", n = e / 4 - t.length, i = 0; i < n; i++)
                        r += "0"; return r + t; }
                    function nn(t, e, r) { for (var n = "", i = 0; n.length < e;)
                        n += Or(r(jr(t + String.fromCharCode.apply(String, [(4278190080 & i) >> 24, (16711680 & i) >> 16, (65280 & i) >> 8, 255 & i])))), i += 1; return n; }
                    function on(t) { for (var e in Er.crypto.Util.DIGESTINFOHEAD) {
                        var r = Er.crypto.Util.DIGESTINFOHEAD[e], n = r.length;
                        if (t.substring(0, n) == r)
                            return [e, t.substring(n)];
                    } return []; }
                    function sn() { var t = Ar, e = t.getChildIdx, r = t.getV, n = t.getTLV, i = t.getVbyList, o = t.getTLVbyList, s = t.getIdxbyList, a = t.getVidx, u = t.oidname, c = sn, h = qr; this.hex = null, this.version = 0, this.foffset = 0, this.aExtInfo = null, this.getVersion = function () { return null === this.hex || 0 !== this.version ? this.version : "a003020102" !== o(this.hex, 0, [0, 0]) ? (this.version = 1, this.foffset = -1, 1) : (this.version = 3, 3); }, this.getSerialNumberHex = function () { return i(this.hex, 0, [0, 1 + this.foffset], "02"); }, this.getSignatureAlgorithmField = function () { return u(i(this.hex, 0, [0, 2 + this.foffset, 0], "06")); }, this.getIssuerHex = function () { return o(this.hex, 0, [0, 3 + this.foffset], "30"); }, this.getIssuerString = function () { return c.hex2dn(this.getIssuerHex()); }, this.getSubjectHex = function () { return o(this.hex, 0, [0, 5 + this.foffset], "30"); }, this.getSubjectString = function () { return c.hex2dn(this.getSubjectHex()); }, this.getNotBefore = function () { var t = i(this.hex, 0, [0, 4 + this.foffset, 0]); return t = t.replace(/(..)/g, "%$1"), t = decodeURIComponent(t); }, this.getNotAfter = function () { var t = i(this.hex, 0, [0, 4 + this.foffset, 1]); return t = t.replace(/(..)/g, "%$1"), t = decodeURIComponent(t); }, this.getPublicKeyHex = function () { return t.getTLVbyList(this.hex, 0, [0, 6 + this.foffset], "30"); }, this.getPublicKeyIdx = function () { return s(this.hex, 0, [0, 6 + this.foffset], "30"); }, this.getPublicKeyContentIdx = function () { var t = this.getPublicKeyIdx(); return s(this.hex, t, [1, 0], "30"); }, this.getPublicKey = function () { return tn.getKey(this.getPublicKeyHex(), null, "pkcs8pub"); }, this.getSignatureAlgorithmName = function () { return u(i(this.hex, 0, [1, 0], "06")); }, this.getSignatureValueHex = function () { return i(this.hex, 0, [2], "03", !0); }, this.verifySignature = function (t) { var e = this.getSignatureAlgorithmName(), r = this.getSignatureValueHex(), n = o(this.hex, 0, [0], "30"), i = new Er.crypto.Signature({ alg: e }); return i.init(t), i.updateHex(n), i.verify(r); }, this.parseExt = function () { if (3 !== this.version)
                        return -1; var r = s(this.hex, 0, [0, 7, 0], "30"), n = e(this.hex, r); this.aExtInfo = new Array; for (var o = 0; o < n.length; o++) {
                        var u = { critical: !1 }, c = 0;
                        3 === e(this.hex, n[o]).length && (u.critical = !0, c = 1), u.oid = t.hextooidstr(i(this.hex, n[o], [0], "06"));
                        var h = s(this.hex, n[o], [1 + c]);
                        u.vidx = a(this.hex, h), this.aExtInfo.push(u);
                    } }, this.getExtInfo = function (t) { var e = this.aExtInfo, r = t; if (t.match(/^[0-9.]+$/) || (r = Er.asn1.x509.OID.name2oid(t)), "" !== r)
                        for (var n = 0; n < e.length; n++)
                            if (e[n].oid === r)
                                return e[n]; }, this.getExtBasicConstraints = function () { var t = this.getExtInfo("basicConstraints"); if (void 0 === t)
                        return t; var e = r(this.hex, t.vidx); if ("" === e)
                        return {}; if ("0101ff" === e)
                        return { cA: !0 }; if ("0101ff02" === e.substr(0, 8)) {
                        var n = r(e, 6);
                        return { cA: !0, pathLen: parseInt(n, 16) };
                    } throw "basicConstraints parse error"; }, this.getExtKeyUsageBin = function () { var t = this.getExtInfo("keyUsage"); if (void 0 === t)
                        return ""; var e = r(this.hex, t.vidx); if (e.length % 2 != 0 || e.length <= 2)
                        throw "malformed key usage value"; var n = parseInt(e.substr(0, 2)), i = parseInt(e.substr(2), 16).toString(2); return i.substr(0, i.length - n); }, this.getExtKeyUsageString = function () { for (var t = this.getExtKeyUsageBin(), e = new Array, r = 0; r < t.length; r++)
                        "1" == t.substr(r, 1) && e.push(sn.KEYUSAGE_NAME[r]); return e.join(","); }, this.getExtSubjectKeyIdentifier = function () { var t = this.getExtInfo("subjectKeyIdentifier"); return void 0 === t ? t : r(this.hex, t.vidx); }, this.getExtAuthorityKeyIdentifier = function () { var t = this.getExtInfo("authorityKeyIdentifier"); if (void 0 === t)
                        return t; for (var i = {}, o = n(this.hex, t.vidx), s = e(o, 0), a = 0; a < s.length; a++)
                        "80" === o.substr(s[a], 2) && (i.kid = r(o, s[a])); return i; }, this.getExtExtKeyUsageName = function () { var t = this.getExtInfo("extKeyUsage"); if (void 0 === t)
                        return t; var i = new Array, o = n(this.hex, t.vidx); if ("" === o)
                        return i; for (var s = e(o, 0), a = 0; a < s.length; a++)
                        i.push(u(r(o, s[a]))); return i; }, this.getExtSubjectAltName = function () { for (var t = this.getExtSubjectAltName2(), e = new Array, r = 0; r < t.length; r++)
                        "DNS" === t[r][0] && e.push(t[r][1]); return e; }, this.getExtSubjectAltName2 = function () { var t, i, o, s = this.getExtInfo("subjectAltName"); if (void 0 === s)
                        return s; for (var a = new Array, u = n(this.hex, s.vidx), c = e(u, 0), h = 0; h < c.length; h++)
                        o = u.substr(c[h], 2), t = r(u, c[h]), "81" === o && (i = Nr(t), a.push(["MAIL", i])), "82" === o && (i = Nr(t), a.push(["DNS", i])), "84" === o && (i = sn.hex2dn(t, 0), a.push(["DN", i])), "86" === o && (i = Nr(t), a.push(["URI", i])), "87" === o && (i = Qr(t), a.push(["IP", i])); return a; }, this.getExtCRLDistributionPointsURI = function () { var t = this.getExtInfo("cRLDistributionPoints"); if (void 0 === t)
                        return t; for (var r = new Array, n = e(this.hex, t.vidx), o = 0; o < n.length; o++)
                        try {
                            var s = Nr(i(this.hex, n[o], [0, 0, 0], "86"));
                            r.push(s);
                        }
                        catch (t) { } return r; }, this.getExtAIAInfo = function () { var t = this.getExtInfo("authorityInfoAccess"); if (void 0 === t)
                        return t; for (var r = { ocsp: [], caissuer: [] }, n = e(this.hex, t.vidx), o = 0; o < n.length; o++) {
                        var s = i(this.hex, n[o], [0], "06"), a = i(this.hex, n[o], [1], "86");
                        "2b06010505073001" === s && r.ocsp.push(Nr(a)), "2b06010505073002" === s && r.caissuer.push(Nr(a));
                    } return r; }, this.getExtCertificatePolicies = function () { var t = this.getExtInfo("certificatePolicies"); if (void 0 === t)
                        return t; for (var o = n(this.hex, t.vidx), s = [], a = e(o, 0), c = 0; c < a.length; c++) {
                        var h = {}, l = e(o, a[c]);
                        if (h.id = u(r(o, l[0])), 2 === l.length)
                            for (var f = e(o, l[1]), d = 0; d < f.length; d++) {
                                var g = i(o, f[d], [0], "06");
                                "2b06010505070201" === g ? h.cps = Nr(i(o, f[d], [1])) : "2b06010505070202" === g && (h.unotice = Nr(i(o, f[d], [1, 0])));
                            }
                        s.push(h);
                    } return s; }, this.readCertPEM = function (t) { this.readCertHex(h(t)); }, this.readCertHex = function (t) { this.hex = t, this.getVersion(); try {
                        s(this.hex, 0, [0, 7], "a3"), this.parseExt();
                    }
                    catch (t) { } }, this.getInfo = function () { var t, e, r; if (t = "Basic Fields\n", t += "  serial number: " + this.getSerialNumberHex() + "\n", t += "  signature algorithm: " + this.getSignatureAlgorithmField() + "\n", t += "  issuer: " + this.getIssuerString() + "\n", t += "  notBefore: " + this.getNotBefore() + "\n", t += "  notAfter: " + this.getNotAfter() + "\n", t += "  subject: " + this.getSubjectString() + "\n", t += "  subject public key info: \n", t += "    key algorithm: " + (e = this.getPublicKey()).type + "\n", "RSA" === e.type && (t += "    n=" + Zr(e.n.toString(16)).substr(0, 16) + "...\n", t += "    e=" + Zr(e.e.toString(16)) + "\n"), void 0 !== (r = this.aExtInfo) && null !== r) {
                        t += "X509v3 Extensions:\n";
                        for (var n = 0; n < r.length; n++) {
                            var i = r[n], o = Er.asn1.x509.OID.oid2name(i.oid);
                            "" === o && (o = i.oid);
                            var s = "";
                            if (!0 === i.critical && (s = "CRITICAL"), t += "  " + o + " " + s + ":\n", "basicConstraints" === o) {
                                var a = this.getExtBasicConstraints();
                                void 0 === a.cA ? t += "    {}\n" : (t += "    cA=true", void 0 !== a.pathLen && (t += ", pathLen=" + a.pathLen), t += "\n");
                            }
                            else if ("keyUsage" === o)
                                t += "    " + this.getExtKeyUsageString() + "\n";
                            else if ("subjectKeyIdentifier" === o)
                                t += "    " + this.getExtSubjectKeyIdentifier() + "\n";
                            else if ("authorityKeyIdentifier" === o) {
                                var u = this.getExtAuthorityKeyIdentifier();
                                void 0 !== u.kid && (t += "    kid=" + u.kid + "\n");
                            }
                            else {
                                if ("extKeyUsage" === o)
                                    t += "    " + this.getExtExtKeyUsageName().join(", ") + "\n";
                                else if ("subjectAltName" === o)
                                    t += "    " + this.getExtSubjectAltName2() + "\n";
                                else if ("cRLDistributionPoints" === o)
                                    t += "    " + this.getExtCRLDistributionPointsURI() + "\n";
                                else if ("authorityInfoAccess" === o) {
                                    var c = this.getExtAIAInfo();
                                    void 0 !== c.ocsp && (t += "    ocsp: " + c.ocsp.join(",") + "\n"), void 0 !== c.caissuer && (t += "    caissuer: " + c.caissuer.join(",") + "\n");
                                }
                                else if ("certificatePolicies" === o)
                                    for (var h = this.getExtCertificatePolicies(), l = 0; l < h.length; l++)
                                        void 0 !== h[l].id && (t += "    policy oid: " + h[l].id + "\n"), void 0 !== h[l].cps && (t += "    cps: " + h[l].cps + "\n");
                            }
                        }
                    } return t += "signature algorithm: " + this.getSignatureAlgorithmName() + "\n", t += "signature: " + this.getSignatureValueHex().substr(0, 16) + "...\n"; }; }
                    en.compile("[^0-9a-f]", "gi"), qe.prototype.sign = function (t, e) { var r = function t(r) { return Er.crypto.Util.hashString(r, e); }(t); return this.signWithMessageHash(r, e); }, qe.prototype.signWithMessageHash = function (t, e) { var r = Ke(Er.crypto.Util.getPaddedDigestInfoHex(t, e, this.n.bitLength()), 16); return rn(this.doPrivate(r).toString(16), this.n.bitLength()); }, qe.prototype.signPSS = function (t, e, r) { var n = function t(r) { return Er.crypto.Util.hashHex(r, e); }(jr(t)); return void 0 === r && (r = -1), this.signWithMessageHashPSS(n, e, r); }, qe.prototype.signWithMessageHashPSS = function (t, e, r) { var n, i = Or(t), o = i.length, s = this.n.bitLength() - 1, a = Math.ceil(s / 8), u = function t(r) { return Er.crypto.Util.hashHex(r, e); }; if (-1 === r || void 0 === r)
                        r = o;
                    else if (-2 === r)
                        r = a - o - 2;
                    else if (r < -2)
                        throw "invalid salt length"; if (a < o + r + 2)
                        throw "data too long"; var c = ""; r > 0 && (c = new Array(r), (new Me).nextBytes(c), c = String.fromCharCode.apply(String, c)); var h = Or(u(jr("\0\0\0\0\0\0\0\0" + i + c))), l = []; for (n = 0; n < a - r - o - 2; n += 1)
                        l[n] = 0; var f = String.fromCharCode.apply(String, l) + "" + c, d = nn(h, f.length, u), g = []; for (n = 0; n < f.length; n += 1)
                        g[n] = f.charCodeAt(n) ^ d.charCodeAt(n); var p = 65280 >> 8 * a - s & 255; for (g[0] &= ~p, n = 0; n < o; n++)
                        g.push(h.charCodeAt(n)); return g.push(188), rn(this.doPrivate(new E(g)).toString(16), this.n.bitLength()); }, qe.prototype.verify = function (t, e) { var r = Ke(e = (e = e.replace(en, "")).replace(/[ \n]+/g, ""), 16); if (r.bitLength() > this.n.bitLength())
                        return 0; var n = on(this.doPublic(r).toString(16).replace(/^1f+00/, "")); if (0 == n.length)
                        return !1; var i = n[0]; return n[1] == function t(e) { return Er.crypto.Util.hashString(e, i); }(t); }, qe.prototype.verifyWithMessageHash = function (t, e) { var r = Ke(e = (e = e.replace(en, "")).replace(/[ \n]+/g, ""), 16); if (r.bitLength() > this.n.bitLength())
                        return 0; var n = on(this.doPublic(r).toString(16).replace(/^1f+00/, "")); if (0 == n.length)
                        return !1; return n[1] == t; }, qe.prototype.verifyPSS = function (t, e, r, n) { var i = function t(e) { return Er.crypto.Util.hashHex(e, r); }(jr(t)); return void 0 === n && (n = -1), this.verifyWithMessageHashPSS(i, e, r, n); }, qe.prototype.verifyWithMessageHashPSS = function (t, e, r, n) { var i = new E(e, 16); if (i.bitLength() > this.n.bitLength())
                        return !1; var o, s = function t(e) { return Er.crypto.Util.hashHex(e, r); }, a = Or(t), u = a.length, c = this.n.bitLength() - 1, h = Math.ceil(c / 8); if (-1 === n || void 0 === n)
                        n = u;
                    else if (-2 === n)
                        n = h - u - 2;
                    else if (n < -2)
                        throw "invalid salt length"; if (h < u + n + 2)
                        throw "data too long"; var l = this.doPublic(i).toByteArray(); for (o = 0; o < l.length; o += 1)
                        l[o] &= 255; for (; l.length < h;)
                        l.unshift(0); if (188 !== l[h - 1])
                        throw "encoded message does not end in 0xbc"; var f = (l = String.fromCharCode.apply(String, l)).substr(0, h - u - 1), d = l.substr(f.length, u), g = 65280 >> 8 * h - c & 255; if (0 != (f.charCodeAt(0) & g))
                        throw "bits beyond keysize not zero"; var p = nn(d, f.length, s), v = []; for (o = 0; o < f.length; o += 1)
                        v[o] = f.charCodeAt(o) ^ p.charCodeAt(o); v[0] &= ~g; var y = h - u - n - 2; for (o = 0; o < y; o += 1)
                        if (0 !== v[o])
                            throw "leftmost octets not zero"; if (1 !== v[y])
                        throw "0x01 marker not found"; return d === Or(s(jr("\0\0\0\0\0\0\0\0" + a + String.fromCharCode.apply(String, v.slice(-n))))); }, qe.SALT_LEN_HLEN = -1, qe.SALT_LEN_MAX = -2, qe.SALT_LEN_RECOVER = -2, sn.hex2dn = function (t, e) { if (void 0 === e && (e = 0), "30" !== t.substr(e, 2))
                        throw "malformed DN"; for (var r = new Array, n = Ar.getChildIdx(t, e), i = 0; i < n.length; i++)
                        r.push(sn.hex2rdn(t, n[i])); return "/" + (r = r.map(function (t) { return t.replace("/", "\\/"); })).join("/"); }, sn.hex2rdn = function (t, e) { if (void 0 === e && (e = 0), "31" !== t.substr(e, 2))
                        throw "malformed RDN"; for (var r = new Array, n = Ar.getChildIdx(t, e), i = 0; i < n.length; i++)
                        r.push(sn.hex2attrTypeValue(t, n[i])); return (r = r.map(function (t) { return t.replace("+", "\\+"); })).join("+"); }, sn.hex2attrTypeValue = function (t, e) { var r = Ar, n = r.getV; if (void 0 === e && (e = 0), "30" !== t.substr(e, 2))
                        throw "malformed attribute type and value"; var i = r.getChildIdx(t, e); 2 !== i.length || t.substr(i[0], 2); var o = n(t, i[0]), s = Er.asn1.ASN1Util.oidHexToInt(o); return Er.asn1.x509.OID.oid2atype(s) + "=" + Or(n(t, i[1])); }, sn.getPublicKeyFromCertHex = function (t) { var e = new sn; return e.readCertHex(t), e.getPublicKey(); }, sn.getPublicKeyFromCertPEM = function (t) { var e = new sn; return e.readCertPEM(t), e.getPublicKey(); }, sn.getPublicKeyInfoPropOfCertPEM = function (t) { var e, r, n = Ar.getVbyList, i = {}; return i.algparam = null, (e = new sn).readCertPEM(t), r = e.getPublicKeyHex(), i.keyhex = n(r, 0, [1], "03").substr(2), i.algoid = n(r, 0, [0, 0], "06"), "2a8648ce3d0201" === i.algoid && (i.algparam = n(r, 0, [0, 1], "06")), i; }, sn.KEYUSAGE_NAME = ["digitalSignature", "nonRepudiation", "keyEncipherment", "dataEncipherment", "keyAgreement", "keyCertSign", "cRLSign", "encipherOnly", "decipherOnly"], void 0 !== Er && Er || (e.KJUR = Er = {}), void 0 !== Er.jws && Er.jws || (Er.jws = {}), Er.jws.JWS = function () { var t = Er.jws.JWS.isSafeJSONString; this.parseJWS = function (e, r) { if (void 0 === this.parsedJWS || !r && void 0 === this.parsedJWS.sigvalH) {
                        var n = e.match(/^([^.]+)\.([^.]+)\.([^.]+)$/);
                        if (null == n)
                            throw "JWS signature is not a form of 'Head.Payload.SigValue'.";
                        var i = n[1], o = n[2], s = n[3], a = i + "." + o;
                        if (this.parsedJWS = {}, this.parsedJWS.headB64U = i, this.parsedJWS.payloadB64U = o, this.parsedJWS.sigvalB64U = s, this.parsedJWS.si = a, !r) {
                            var u = Lr(s), c = Ke(u, 16);
                            this.parsedJWS.sigvalH = u, this.parsedJWS.sigvalBI = c;
                        }
                        var h = kr(i), l = kr(o);
                        if (this.parsedJWS.headS = h, this.parsedJWS.payloadS = l, !t(h, this.parsedJWS, "headP"))
                            throw "malformed JSON string for JWS Head: " + h;
                    } }; }, Er.jws.JWS.sign = function (t, e, n, i, o) { var s, a, u, c = Er, h = c.jws.JWS, l = h.readSafeJSONString, f = h.isSafeJSONString, d = c.crypto, g = (d.Mac), p = d.Signature, v = JSON; if ("string" != typeof e && "object" != (void 0 === e ? "undefined" : r(e)))
                        throw "spHeader must be JSON string or object: " + e; if ("object" == (void 0 === e ? "undefined" : r(e)) && (a = e, s = v.stringify(a)), "string" == typeof e) {
                        if (!f(s = e))
                            throw "JWS Head is not safe JSON string: " + s;
                        a = l(s);
                    } if (u = n, "object" == (void 0 === n ? "undefined" : r(n)) && (u = v.stringify(n)), "" != t && null != t || void 0 === a.alg || (t = a.alg), "" != t && null != t && void 0 === a.alg && (a.alg = t, s = v.stringify(a)), t !== a.alg)
                        throw "alg and sHeader.alg doesn't match: " + t + "!=" + a.alg; var y = null; if (void 0 === h.jwsalg2sigalg[t])
                        throw "unsupported alg name: " + t; y = h.jwsalg2sigalg[t]; var m = xr(s) + "." + xr(u), _ = ""; if ("Hmac" == y.substr(0, 4)) {
                        if (void 0 === i)
                            throw "mac key shall be specified for HS* alg";
                        var S = new g({ alg: y, prov: "cryptojs", pass: i });
                        S.updateString(m), _ = S.doFinal();
                    }
                    else {
                        var F;
                        if (-1 != y.indexOf("withECDSA"))
                            (F = new p({ alg: y })).init(i, o), F.updateString(m), hASN1Sig = F.sign(), _ = Er.crypto.ECDSA.asn1SigToConcatSig(hASN1Sig);
                        else if ("none" != y)
                            (F = new p({ alg: y })).init(i, o), F.updateString(m), _ = F.sign();
                    } return m + "." + Ur(_); }, Er.jws.JWS.verify = function (t, e, n) { var i, o = Er, s = o.jws.JWS, a = s.readSafeJSONString, u = o.crypto, c = u.ECDSA, h = u.Mac, l = u.Signature; void 0 !== r(qe) && (i = qe); var f = t.split("."); if (3 !== f.length)
                        return !1; var d = f[0] + "." + f[1], g = Lr(f[2]), p = a(kr(f[0])), v = null, y = null; if (void 0 === p.alg)
                        throw "algorithm not specified in header"; if ((y = (v = p.alg).substr(0, 2), null != n && "[object Array]" === Object.prototype.toString.call(n) && n.length > 0) && -1 == (":" + n.join(":") + ":").indexOf(":" + v + ":"))
                        throw "algorithm '" + v + "' not accepted in the list"; if ("none" != v && null === e)
                        throw "key shall be specified to verify."; if ("string" == typeof e && -1 != e.indexOf("-----BEGIN ") && (e = tn.getKey(e)), !("RS" != y && "PS" != y || e instanceof i))
                        throw "key shall be a RSAKey obj for RS* and PS* algs"; if ("ES" == y && !(e instanceof c))
                        throw "key shall be a ECDSA obj for ES* algs"; var m = null; if (void 0 === s.jwsalg2sigalg[p.alg])
                        throw "unsupported alg name: " + v; if ("none" == (m = s.jwsalg2sigalg[v]))
                        throw "not supported"; if ("Hmac" == m.substr(0, 4)) {
                        if (void 0 === e)
                            throw "hexadecimal key shall be specified for HMAC";
                        var _ = new h({ alg: m, pass: e });
                        return _.updateString(d), g == _.doFinal();
                    } if (-1 != m.indexOf("withECDSA")) {
                        var S, F = null;
                        try {
                            F = c.concatSigToASN1Sig(g);
                        }
                        catch (t) {
                            return !1;
                        }
                        return (S = new l({ alg: m })).init(e), S.updateString(d), S.verify(F);
                    } return (S = new l({ alg: m })).init(e), S.updateString(d), S.verify(g); }, Er.jws.JWS.parse = function (t) { var e, r, n, i = t.split("."), o = {}; if (2 != i.length && 3 != i.length)
                        throw "malformed sJWS: wrong number of '.' splitted elements"; return e = i[0], r = i[1], 3 == i.length && (n = i[2]), o.headerObj = Er.jws.JWS.readSafeJSONString(kr(e)), o.payloadObj = Er.jws.JWS.readSafeJSONString(kr(r)), o.headerPP = JSON.stringify(o.headerObj, null, "  "), null == o.payloadObj ? o.payloadPP = kr(r) : o.payloadPP = JSON.stringify(o.payloadObj, null, "  "), void 0 !== n && (o.sigHex = Lr(n)), o; }, Er.jws.JWS.verifyJWT = function (t, e, n) { var i = Er.jws, o = i.JWS, s = o.readSafeJSONString, a = o.inArray, u = o.includedArray, c = t.split("."), h = c[0], l = c[1], f = (Lr(c[2]), s(kr(h))), d = s(kr(l)); if (void 0 === f.alg)
                        return !1; if (void 0 === n.alg)
                        throw "acceptField.alg shall be specified"; if (!a(f.alg, n.alg))
                        return !1; if (void 0 !== d.iss && "object" === r(n.iss) && !a(d.iss, n.iss))
                        return !1; if (void 0 !== d.sub && "object" === r(n.sub) && !a(d.sub, n.sub))
                        return !1; if (void 0 !== d.aud && "object" === r(n.aud))
                        if ("string" == typeof d.aud) {
                            if (!a(d.aud, n.aud))
                                return !1;
                        }
                        else if ("object" == r(d.aud) && !u(d.aud, n.aud))
                            return !1; var g = i.IntDate.getNow(); return void 0 !== n.verifyAt && "number" == typeof n.verifyAt && (g = n.verifyAt), void 0 !== n.gracePeriod && "number" == typeof n.gracePeriod || (n.gracePeriod = 0), !(void 0 !== d.exp && "number" == typeof d.exp && d.exp + n.gracePeriod < g) && (!(void 0 !== d.nbf && "number" == typeof d.nbf && g < d.nbf - n.gracePeriod) && (!(void 0 !== d.iat && "number" == typeof d.iat && g < d.iat - n.gracePeriod) && ((void 0 === d.jti || void 0 === n.jti || d.jti === n.jti) && !!o.verify(t, e, n.alg)))); }, Er.jws.JWS.includedArray = function (t, e) { var n = Er.jws.JWS.inArray; if (null === t)
                        return !1; if ("object" !== (void 0 === t ? "undefined" : r(t)))
                        return !1; if ("number" != typeof t.length)
                        return !1; for (var i = 0; i < t.length; i++)
                        if (!n(t[i], e))
                            return !1; return !0; }, Er.jws.JWS.inArray = function (t, e) { if (null === e)
                        return !1; if ("object" !== (void 0 === e ? "undefined" : r(e)))
                        return !1; if ("number" != typeof e.length)
                        return !1; for (var n = 0; n < e.length; n++)
                        if (e[n] == t)
                            return !0; return !1; }, Er.jws.JWS.jwsalg2sigalg = { HS256: "HmacSHA256", HS384: "HmacSHA384", HS512: "HmacSHA512", RS256: "SHA256withRSA", RS384: "SHA384withRSA", RS512: "SHA512withRSA", ES256: "SHA256withECDSA", ES384: "SHA384withECDSA", PS256: "SHA256withRSAandMGF1", PS384: "SHA384withRSAandMGF1", PS512: "SHA512withRSAandMGF1", none: "none" }, Er.jws.JWS.isSafeJSONString = function (t, e, n) { var i = null; try {
                        return "object" != (void 0 === (i = wr(t)) ? "undefined" : r(i)) ? 0 : i.constructor === Array ? 0 : (e && (e[n] = i), 1);
                    }
                    catch (t) {
                        return 0;
                    } }, Er.jws.JWS.readSafeJSONString = function (t) { var e = null; try {
                        return "object" != (void 0 === (e = wr(t)) ? "undefined" : r(e)) ? null : e.constructor === Array ? null : e;
                    }
                    catch (t) {
                        return null;
                    } }, Er.jws.JWS.getEncodedSignatureValueFromJWS = function (t) { var e = t.match(/^[^.]+\.[^.]+\.([^.]+)$/); if (null == e)
                        throw "JWS signature is not a form of 'Head.Payload.SigValue'."; return e[1]; }, Er.jws.JWS.getJWKthumbprint = function (t) { if ("RSA" !== t.kty && "EC" !== t.kty && "oct" !== t.kty)
                        throw "unsupported algorithm for JWK Thumprint"; var e = "{"; if ("RSA" === t.kty) {
                        if ("string" != typeof t.n || "string" != typeof t.e)
                            throw "wrong n and e value for RSA key";
                        e += '"e":"' + t.e + '",', e += '"kty":"' + t.kty + '",', e += '"n":"' + t.n + '"}';
                    }
                    else if ("EC" === t.kty) {
                        if ("string" != typeof t.crv || "string" != typeof t.x || "string" != typeof t.y)
                            throw "wrong crv, x and y value for EC key";
                        e += '"crv":"' + t.crv + '",', e += '"kty":"' + t.kty + '",', e += '"x":"' + t.x + '",', e += '"y":"' + t.y + '"}';
                    }
                    else if ("oct" === t.kty) {
                        if ("string" != typeof t.k)
                            throw "wrong k value for oct(symmetric) key";
                        e += '"kty":"' + t.kty + '",', e += '"k":"' + t.k + '"}';
                    } var r = jr(e); return Ur(Er.crypto.Util.hashHex(r, "sha256")); }, Er.jws.IntDate = {}, Er.jws.IntDate.get = function (t) { var e = Er.jws.IntDate, r = e.getNow, n = e.getZulu; if ("now" == t)
                        return r(); if ("now + 1hour" == t)
                        return r() + 3600; if ("now + 1day" == t)
                        return r() + 86400; if ("now + 1month" == t)
                        return r() + 2592e3; if ("now + 1year" == t)
                        return r() + 31536e3; if (t.match(/Z$/))
                        return n(t); if (t.match(/^[0-9]+$/))
                        return parseInt(t); throw "unsupported format: " + t; }, Er.jws.IntDate.getZulu = function (t) { return Wr(t); }, Er.jws.IntDate.getNow = function () { return ~~(new Date / 1e3); }, Er.jws.IntDate.intDate2UTCString = function (t) { return new Date(1e3 * t).toUTCString(); }, Er.jws.IntDate.intDate2Zulu = function (t) { var e = new Date(1e3 * t); return ("0000" + e.getUTCFullYear()).slice(-4) + ("00" + (e.getUTCMonth() + 1)).slice(-2) + ("00" + e.getUTCDate()).slice(-2) + ("00" + e.getUTCHours()).slice(-2) + ("00" + e.getUTCMinutes()).slice(-2) + ("00" + e.getUTCSeconds()).slice(-2) + "Z"; }, e.SecureRandom = Me, e.rng_seed_time = Le, e.BigInteger = E, e.RSAKey = qe;
                    var an = Er.crypto.EDSA;
                    e.EDSA = an;
                    var un = Er.crypto.DSA;
                    e.DSA = un;
                    var cn = Er.crypto.Signature;
                    e.Signature = cn;
                    var hn = Er.crypto.MessageDigest;
                    e.MessageDigest = hn;
                    var ln = Er.crypto.Mac;
                    e.Mac = ln;
                    var fn = Er.crypto.Cipher;
                    e.Cipher = fn, e.KEYUTIL = tn, e.ASN1HEX = Ar, e.X509 = sn, e.CryptoJS = y, e.b64tohex = b, e.b64toBA = w, e.stoBA = Pr, e.BAtos = Cr, e.BAtohex = Tr, e.stohex = Rr, e.stob64 = function dn(t) { return F(Rr(t)); }, e.stob64u = function gn(t) { return Ir(F(Rr(t))); }, e.b64utos = function pn(t) { return Cr(w(Dr(t))); }, e.b64tob64u = Ir, e.b64utob64 = Dr, e.hex2b64 = F, e.hextob64u = Ur, e.b64utohex = Lr, e.utf8tob64u = xr, e.b64utoutf8 = kr, e.utf8tob64 = function vn(t) { return F(zr($r(t))); }, e.b64toutf8 = function yn(t) { return decodeURIComponent(Yr(b(t))); }, e.utf8tohex = Br, e.hextoutf8 = Nr, e.hextorstr = Or, e.rstrtohex = jr, e.hextob64 = Hr, e.hextob64nl = Mr, e.b64nltohex = Kr, e.hextopem = Vr, e.pemtohex = qr, e.hextoArrayBuffer = function mn(t) { if (t.length % 2 != 0)
                        throw "input is not even length"; if (null == t.match(/^[0-9A-Fa-f]+$/))
                        throw "input is not hexadecimal"; for (var e = new ArrayBuffer(t.length / 2), r = new DataView(e), n = 0; n < t.length / 2; n++)
                        r.setUint8(n, parseInt(t.substr(2 * n, 2), 16)); return e; }, e.ArrayBuffertohex = function _n(t) { for (var e = "", r = new DataView(t), n = 0; n < t.byteLength; n++)
                        e += ("00" + r.getUint8(n).toString(16)).slice(-2); return e; }, e.zulutomsec = Jr, e.zulutosec = Wr, e.zulutodate = function Sn(t) { return new Date(Jr(t)); }, e.datetozulu = function Fn(t, e, r) { var n, i = t.getUTCFullYear(); if (e) {
                        if (i < 1950 || 2049 < i)
                            throw "not proper year for UTCTime: " + i;
                        n = ("" + i).slice(-2);
                    }
                    else
                        n = ("000" + i).slice(-4); if (n += ("0" + (t.getUTCMonth() + 1)).slice(-2), n += ("0" + t.getUTCDate()).slice(-2), n += ("0" + t.getUTCHours()).slice(-2), n += ("0" + t.getUTCMinutes()).slice(-2), n += ("0" + t.getUTCSeconds()).slice(-2), r) {
                        var o = t.getUTCMilliseconds();
                        0 !== o && (n += "." + (o = (o = ("00" + o).slice(-3)).replace(/0+$/g, "")));
                    } return n += "Z"; }, e.uricmptohex = zr, e.hextouricmp = Yr, e.ipv6tohex = Gr, e.hextoipv6 = Xr, e.hextoip = Qr, e.iptohex = function bn(t) { var e = "malformed IP address"; if (!(t = t.toLowerCase(t)).match(/^[0-9.]+$/)) {
                        if (t.match(/^[0-9a-f:]+$/) && -1 !== t.indexOf(":"))
                            return Gr(t);
                        throw e;
                    } var r = t.split("."); if (4 !== r.length)
                        throw e; var n = ""; try {
                        for (var i = 0; i < 4; i++)
                            n += ("0" + parseInt(r[i]).toString(16)).slice(-2);
                        return n;
                    }
                    catch (t) {
                        throw e;
                    } }, e.encodeURIComponentAll = $r, e.newline_toUnix = function wn(t) { return t = t.replace(/\r\n/gm, "\n"); }, e.newline_toDos = function En(t) { return t = (t = t.replace(/\r\n/gm, "\n")).replace(/\n/gm, "\r\n"); }, e.hextoposhex = Zr, e.intarystrtohex = function xn(t) { t = (t = (t = t.replace(/^\s*\[\s*/, "")).replace(/\s*\]\s*$/, "")).replace(/\s*/g, ""); try {
                        return t.split(/,/).map(function (t, e, r) { var n = parseInt(t); if (n < 0 || 255 < n)
                            throw "integer not in range 0-255"; return ("00" + n.toString(16)).slice(-2); }).join("");
                    }
                    catch (t) {
                        throw "malformed integer array string: " + t;
                    } }, e.strdiffidx = function t(e, r) { var n = e.length; e.length > r.length && (n = r.length); for (var i = 0; i < n; i++)
                        if (e.charCodeAt(i) != r.charCodeAt(i))
                            return i; return e.length != r.length ? n : -1; }, e.KJUR = Er;
                    var kn = Er.crypto;
                    e.crypto = kn;
                    var An = Er.asn1;
                    e.asn1 = An;
                    var Pn = Er.jws;
                    e.jws = Pn;
                    var Cn = Er.lang;
                    e.lang = Cn;
                }).call(this, r(27).Buffer);
            }, function (t, e, r) {
                (function (t) {
                    /*!
                     * The buffer module from node.js, for the browser.
                     *
                     * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
                     * @license  MIT
                     */
                    var n = r(29), i = r(30), o = r(31);
                    function s() { return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823; }
                    function a(t, e) { if (s() < e)
                        throw new RangeError("Invalid typed array length"); return u.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = u.prototype : (null === t && (t = new u(e)), t.length = e), t; }
                    function u(t, e, r) { if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u))
                        return new u(t, e, r); if ("number" == typeof t) {
                        if ("string" == typeof e)
                            throw new Error("If encoding is specified then the first argument must be a string");
                        return l(this, t);
                    } return c(this, t, e, r); }
                    function c(t, e, r, n) { if ("number" == typeof e)
                        throw new TypeError('"value" argument must not be a number'); return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function i(t, e, r, n) { if (r < 0 || e.byteLength < r)
                        throw new RangeError("'offset' is out of bounds"); if (e.byteLength < r + (n || 0))
                        throw new RangeError("'length' is out of bounds"); e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n); u.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = u.prototype : t = f(t, e); return t; }(t, e, r, n) : "string" == typeof e ? function s(t, e, r) { "string" == typeof r && "" !== r || (r = "utf8"); if (!u.isEncoding(r))
                        throw new TypeError('"encoding" must be a valid string encoding'); var n = 0 | g(e, r), i = (t = a(t, n)).write(e, r); i !== n && (t = t.slice(0, i)); return t; }(t, e, r) : function c(t, e) { if (u.isBuffer(e)) {
                        var r = 0 | d(e.length);
                        return 0 === (t = a(t, r)).length ? t : (e.copy(t, 0, 0, r), t);
                    } if (e) {
                        if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e)
                            return "number" != typeof e.length || function n(t) { return t != t; }(e.length) ? a(t, 0) : f(t, e);
                        if ("Buffer" === e.type && o(e.data))
                            return f(t, e.data);
                    } throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object."); }(t, e); }
                    function h(t) { if ("number" != typeof t)
                        throw new TypeError('"size" argument must be a number'); if (t < 0)
                        throw new RangeError('"size" argument must not be negative'); }
                    function l(t, e) { if (h(e), t = a(t, e < 0 ? 0 : 0 | d(e)), !u.TYPED_ARRAY_SUPPORT)
                        for (var r = 0; r < e; ++r)
                            t[r] = 0; return t; }
                    function f(t, e) { var r = e.length < 0 ? 0 : 0 | d(e.length); t = a(t, r); for (var n = 0; n < r; n += 1)
                        t[n] = 255 & e[n]; return t; }
                    function d(t) { if (t >= s())
                        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s().toString(16) + " bytes"); return 0 | t; }
                    function g(t, e) { if (u.isBuffer(t))
                        return t.length; if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer))
                        return t.byteLength; "string" != typeof t && (t = "" + t); var r = t.length; if (0 === r)
                        return 0; for (var n = !1;;)
                        switch (e) {
                            case "ascii":
                            case "latin1":
                            case "binary": return r;
                            case "utf8":
                            case "utf-8":
                            case void 0: return K(t).length;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le": return 2 * r;
                            case "hex": return r >>> 1;
                            case "base64": return V(t).length;
                            default:
                                if (n)
                                    return K(t).length;
                                e = ("" + e).toLowerCase(), n = !0;
                        } }
                    function p(t, e, r) { var n = t[e]; t[e] = t[r], t[r] = n; }
                    function v(t, e, r, n, i) { if (0 === t.length)
                        return -1; if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
                        if (i)
                            return -1;
                        r = t.length - 1;
                    }
                    else if (r < 0) {
                        if (!i)
                            return -1;
                        r = 0;
                    } if ("string" == typeof e && (e = u.from(e, n)), u.isBuffer(e))
                        return 0 === e.length ? -1 : y(t, e, r, n, i); if ("number" == typeof e)
                        return e &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : y(t, [e], r, n, i); throw new TypeError("val must be string, number or Buffer"); }
                    function y(t, e, r, n, i) { var o, s = 1, a = t.length, u = e.length; if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                        if (t.length < 2 || e.length < 2)
                            return -1;
                        s = 2, a /= 2, u /= 2, r /= 2;
                    } function c(t, e) { return 1 === s ? t[e] : t.readUInt16BE(e * s); } if (i) {
                        var h = -1;
                        for (o = r; o < a; o++)
                            if (c(t, o) === c(e, -1 === h ? 0 : o - h)) {
                                if (-1 === h && (h = o), o - h + 1 === u)
                                    return h * s;
                            }
                            else
                                -1 !== h && (o -= o - h), h = -1;
                    }
                    else
                        for (r + u > a && (r = a - u), o = r; o >= 0; o--) {
                            for (var l = !0, f = 0; f < u; f++)
                                if (c(t, o + f) !== c(e, f)) {
                                    l = !1;
                                    break;
                                }
                            if (l)
                                return o;
                        } return -1; }
                    function m(t, e, r, n) { r = Number(r) || 0; var i = t.length - r; n ? (n = Number(n)) > i && (n = i) : n = i; var o = e.length; if (o % 2 != 0)
                        throw new TypeError("Invalid hex string"); n > o / 2 && (n = o / 2); for (var s = 0; s < n; ++s) {
                        var a = parseInt(e.substr(2 * s, 2), 16);
                        if (isNaN(a))
                            return s;
                        t[r + s] = a;
                    } return s; }
                    function _(t, e, r, n) { return q(K(e, t.length - r), t, r, n); }
                    function S(t, e, r, n) { return q(function i(t) { for (var e = [], r = 0; r < t.length; ++r)
                        e.push(255 & t.charCodeAt(r)); return e; }(e), t, r, n); }
                    function F(t, e, r, n) { return S(t, e, r, n); }
                    function b(t, e, r, n) { return q(V(e), t, r, n); }
                    function w(t, e, r, n) { return q(function i(t, e) { for (var r, n, i, o = [], s = 0; s < t.length && !((e -= 2) < 0); ++s)
                        r = t.charCodeAt(s), n = r >> 8, i = r % 256, o.push(i), o.push(n); return o; }(e, t.length - r), t, r, n); }
                    function E(t, e, r) { return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r)); }
                    function x(t, e, r) { r = Math.min(t.length, r); for (var n = [], i = e; i < r;) {
                        var o, s, a, u, c = t[i], h = null, l = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
                        if (i + l <= r)
                            switch (l) {
                                case 1:
                                    c < 128 && (h = c);
                                    break;
                                case 2:
                                    128 == (192 & (o = t[i + 1])) && (u = (31 & c) << 6 | 63 & o) > 127 && (h = u);
                                    break;
                                case 3:
                                    o = t[i + 1], s = t[i + 2], 128 == (192 & o) && 128 == (192 & s) && (u = (15 & c) << 12 | (63 & o) << 6 | 63 & s) > 2047 && (u < 55296 || u > 57343) && (h = u);
                                    break;
                                case 4: o = t[i + 1], s = t[i + 2], a = t[i + 3], 128 == (192 & o) && 128 == (192 & s) && 128 == (192 & a) && (u = (15 & c) << 18 | (63 & o) << 12 | (63 & s) << 6 | 63 & a) > 65535 && u < 1114112 && (h = u);
                            }
                        null === h ? (h = 65533, l = 1) : h > 65535 && (h -= 65536, n.push(h >>> 10 & 1023 | 55296), h = 56320 | 1023 & h), n.push(h), i += l;
                    } return function f(t) { var e = t.length; if (e <= P)
                        return String.fromCharCode.apply(String, t); var r = "", n = 0; for (; n < e;)
                        r += String.fromCharCode.apply(String, t.slice(n, n += P)); return r; }(n); }
                    e.Buffer = u, e.SlowBuffer = function k(t) { +t != t && (t = 0); return u.alloc(+t); }, e.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function A() { try {
                        var t = new Uint8Array(1);
                        return t.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42; } }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
                    }
                    catch (t) {
                        return !1;
                    } }(), e.kMaxLength = s(), u.poolSize = 8192, u._augment = function (t) { return t.__proto__ = u.prototype, t; }, u.from = function (t, e, r) { return c(null, t, e, r); }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, { value: null, configurable: !0 })), u.alloc = function (t, e, r) { return function n(t, e, r, i) { return h(e), e <= 0 ? a(t, e) : void 0 !== r ? "string" == typeof i ? a(t, e).fill(r, i) : a(t, e).fill(r) : a(t, e); }(null, t, e, r); }, u.allocUnsafe = function (t) { return l(null, t); }, u.allocUnsafeSlow = function (t) { return l(null, t); }, u.isBuffer = function t(e) { return !(null == e || !e._isBuffer); }, u.compare = function t(e, r) { if (!u.isBuffer(e) || !u.isBuffer(r))
                        throw new TypeError("Arguments must be Buffers"); if (e === r)
                        return 0; for (var n = e.length, i = r.length, o = 0, s = Math.min(n, i); o < s; ++o)
                        if (e[o] !== r[o]) {
                            n = e[o], i = r[o];
                            break;
                        } return n < i ? -1 : i < n ? 1 : 0; }, u.isEncoding = function t(e) { switch (String(e).toLowerCase()) {
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "latin1":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le": return !0;
                        default: return !1;
                    } }, u.concat = function t(e, r) { if (!o(e))
                        throw new TypeError('"list" argument must be an Array of Buffers'); if (0 === e.length)
                        return u.alloc(0); var n; if (void 0 === r)
                        for (r = 0, n = 0; n < e.length; ++n)
                            r += e[n].length; var i = u.allocUnsafe(r), s = 0; for (n = 0; n < e.length; ++n) {
                        var a = e[n];
                        if (!u.isBuffer(a))
                            throw new TypeError('"list" argument must be an Array of Buffers');
                        a.copy(i, s), s += a.length;
                    } return i; }, u.byteLength = g, u.prototype._isBuffer = !0, u.prototype.swap16 = function t() { var e = this.length; if (e % 2 != 0)
                        throw new RangeError("Buffer size must be a multiple of 16-bits"); for (var r = 0; r < e; r += 2)
                        p(this, r, r + 1); return this; }, u.prototype.swap32 = function t() { var e = this.length; if (e % 4 != 0)
                        throw new RangeError("Buffer size must be a multiple of 32-bits"); for (var r = 0; r < e; r += 4)
                        p(this, r, r + 3), p(this, r + 1, r + 2); return this; }, u.prototype.swap64 = function t() { var e = this.length; if (e % 8 != 0)
                        throw new RangeError("Buffer size must be a multiple of 64-bits"); for (var r = 0; r < e; r += 8)
                        p(this, r, r + 7), p(this, r + 1, r + 6), p(this, r + 2, r + 5), p(this, r + 3, r + 4); return this; }, u.prototype.toString = function t() { var e = 0 | this.length; return 0 === e ? "" : 0 === arguments.length ? x(this, 0, e) : function r(t, e, n) { var i = !1; if ((void 0 === e || e < 0) && (e = 0), e > this.length)
                        return ""; if ((void 0 === n || n > this.length) && (n = this.length), n <= 0)
                        return ""; if ((n >>>= 0) <= (e >>>= 0))
                        return ""; for (t || (t = "utf8");;)
                        switch (t) {
                            case "hex": return R(this, e, n);
                            case "utf8":
                            case "utf-8": return x(this, e, n);
                            case "ascii": return C(this, e, n);
                            case "latin1":
                            case "binary": return T(this, e, n);
                            case "base64": return E(this, e, n);
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le": return I(this, e, n);
                            default:
                                if (i)
                                    throw new TypeError("Unknown encoding: " + t);
                                t = (t + "").toLowerCase(), i = !0;
                        } }.apply(this, arguments); }, u.prototype.equals = function t(e) { if (!u.isBuffer(e))
                        throw new TypeError("Argument must be a Buffer"); return this === e || 0 === u.compare(this, e); }, u.prototype.inspect = function t() { var r = "", n = e.INSPECT_MAX_BYTES; return this.length > 0 && (r = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (r += " ... ")), "<Buffer " + r + ">"; }, u.prototype.compare = function t(e, r, n, i, o) { if (!u.isBuffer(e))
                        throw new TypeError("Argument must be a Buffer"); if (void 0 === r && (r = 0), void 0 === n && (n = e ? e.length : 0), void 0 === i && (i = 0), void 0 === o && (o = this.length), r < 0 || n > e.length || i < 0 || o > this.length)
                        throw new RangeError("out of range index"); if (i >= o && r >= n)
                        return 0; if (i >= o)
                        return -1; if (r >= n)
                        return 1; if (r >>>= 0, n >>>= 0, i >>>= 0, o >>>= 0, this === e)
                        return 0; for (var s = o - i, a = n - r, c = Math.min(s, a), h = this.slice(i, o), l = e.slice(r, n), f = 0; f < c; ++f)
                        if (h[f] !== l[f]) {
                            s = h[f], a = l[f];
                            break;
                        } return s < a ? -1 : a < s ? 1 : 0; }, u.prototype.includes = function t(e, r, n) { return -1 !== this.indexOf(e, r, n); }, u.prototype.indexOf = function t(e, r, n) { return v(this, e, r, n, !0); }, u.prototype.lastIndexOf = function t(e, r, n) { return v(this, e, r, n, !1); }, u.prototype.write = function t(e, r, n, i) { if (void 0 === r)
                        i = "utf8", n = this.length, r = 0;
                    else if (void 0 === n && "string" == typeof r)
                        i = r, n = this.length, r = 0;
                    else {
                        if (!isFinite(r))
                            throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                        r |= 0, isFinite(n) ? (n |= 0, void 0 === i && (i = "utf8")) : (i = n, n = void 0);
                    } var o = this.length - r; if ((void 0 === n || n > o) && (n = o), e.length > 0 && (n < 0 || r < 0) || r > this.length)
                        throw new RangeError("Attempt to write outside buffer bounds"); i || (i = "utf8"); for (var s = !1;;)
                        switch (i) {
                            case "hex": return m(this, e, r, n);
                            case "utf8":
                            case "utf-8": return _(this, e, r, n);
                            case "ascii": return S(this, e, r, n);
                            case "latin1":
                            case "binary": return F(this, e, r, n);
                            case "base64": return b(this, e, r, n);
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le": return w(this, e, r, n);
                            default:
                                if (s)
                                    throw new TypeError("Unknown encoding: " + i);
                                i = ("" + i).toLowerCase(), s = !0;
                        } }, u.prototype.toJSON = function t() { return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) }; };
                    var P = 4096;
                    function C(t, e, r) { var n = ""; r = Math.min(t.length, r); for (var i = e; i < r; ++i)
                        n += String.fromCharCode(127 & t[i]); return n; }
                    function T(t, e, r) { var n = ""; r = Math.min(t.length, r); for (var i = e; i < r; ++i)
                        n += String.fromCharCode(t[i]); return n; }
                    function R(t, e, r) { var n = t.length; (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n); for (var i = "", o = e; o < r; ++o)
                        i += M(t[o]); return i; }
                    function I(t, e, r) { for (var n = t.slice(e, r), i = "", o = 0; o < n.length; o += 2)
                        i += String.fromCharCode(n[o] + 256 * n[o + 1]); return i; }
                    function D(t, e, r) { if (t % 1 != 0 || t < 0)
                        throw new RangeError("offset is not uint"); if (t + e > r)
                        throw new RangeError("Trying to access beyond buffer length"); }
                    function U(t, e, r, n, i, o) { if (!u.isBuffer(t))
                        throw new TypeError('"buffer" argument must be a Buffer instance'); if (e > i || e < o)
                        throw new RangeError('"value" argument is out of bounds'); if (r + n > t.length)
                        throw new RangeError("Index out of range"); }
                    function L(t, e, r, n) { e < 0 && (e = 65535 + e + 1); for (var i = 0, o = Math.min(t.length - r, 2); i < o; ++i)
                        t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i); }
                    function B(t, e, r, n) { e < 0 && (e = 4294967295 + e + 1); for (var i = 0, o = Math.min(t.length - r, 4); i < o; ++i)
                        t[r + i] = e >>> 8 * (n ? i : 3 - i) & 255; }
                    function N(t, e, r, n, i, o) { if (r + n > t.length)
                        throw new RangeError("Index out of range"); if (r < 0)
                        throw new RangeError("Index out of range"); }
                    function O(t, e, r, n, o) { return o || N(t, 0, r, 4), i.write(t, e, r, n, 23, 4), r + 4; }
                    function j(t, e, r, n, o) { return o || N(t, 0, r, 8), i.write(t, e, r, n, 52, 8), r + 8; }
                    u.prototype.slice = function t(e, r) { var n, i = this.length; if (e = ~~e, r = void 0 === r ? i : ~~r, e < 0 ? (e += i) < 0 && (e = 0) : e > i && (e = i), r < 0 ? (r += i) < 0 && (r = 0) : r > i && (r = i), r < e && (r = e), u.TYPED_ARRAY_SUPPORT)
                        (n = this.subarray(e, r)).__proto__ = u.prototype;
                    else {
                        var o = r - e;
                        n = new u(o, void 0);
                        for (var s = 0; s < o; ++s)
                            n[s] = this[s + e];
                    } return n; }, u.prototype.readUIntLE = function t(e, r, n) { e |= 0, r |= 0, n || D(e, r, this.length); for (var i = this[e], o = 1, s = 0; ++s < r && (o *= 256);)
                        i += this[e + s] * o; return i; }, u.prototype.readUIntBE = function t(e, r, n) { e |= 0, r |= 0, n || D(e, r, this.length); for (var i = this[e + --r], o = 1; r > 0 && (o *= 256);)
                        i += this[e + --r] * o; return i; }, u.prototype.readUInt8 = function t(e, r) { return r || D(e, 1, this.length), this[e]; }, u.prototype.readUInt16LE = function t(e, r) { return r || D(e, 2, this.length), this[e] | this[e + 1] << 8; }, u.prototype.readUInt16BE = function t(e, r) { return r || D(e, 2, this.length), this[e] << 8 | this[e + 1]; }, u.prototype.readUInt32LE = function t(e, r) { return r || D(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3]; }, u.prototype.readUInt32BE = function t(e, r) { return r || D(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]); }, u.prototype.readIntLE = function t(e, r, n) { e |= 0, r |= 0, n || D(e, r, this.length); for (var i = this[e], o = 1, s = 0; ++s < r && (o *= 256);)
                        i += this[e + s] * o; return i >= (o *= 128) && (i -= Math.pow(2, 8 * r)), i; }, u.prototype.readIntBE = function t(e, r, n) { e |= 0, r |= 0, n || D(e, r, this.length); for (var i = r, o = 1, s = this[e + --i]; i > 0 && (o *= 256);)
                        s += this[e + --i] * o; return s >= (o *= 128) && (s -= Math.pow(2, 8 * r)), s; }, u.prototype.readInt8 = function t(e, r) { return r || D(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e]; }, u.prototype.readInt16LE = function t(e, r) { r || D(e, 2, this.length); var n = this[e] | this[e + 1] << 8; return 32768 & n ? 4294901760 | n : n; }, u.prototype.readInt16BE = function t(e, r) { r || D(e, 2, this.length); var n = this[e + 1] | this[e] << 8; return 32768 & n ? 4294901760 | n : n; }, u.prototype.readInt32LE = function t(e, r) { return r || D(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24; }, u.prototype.readInt32BE = function t(e, r) { return r || D(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]; }, u.prototype.readFloatLE = function t(e, r) { return r || D(e, 4, this.length), i.read(this, e, !0, 23, 4); }, u.prototype.readFloatBE = function t(e, r) { return r || D(e, 4, this.length), i.read(this, e, !1, 23, 4); }, u.prototype.readDoubleLE = function t(e, r) { return r || D(e, 8, this.length), i.read(this, e, !0, 52, 8); }, u.prototype.readDoubleBE = function t(e, r) { return r || D(e, 8, this.length), i.read(this, e, !1, 52, 8); }, u.prototype.writeUIntLE = function t(e, r, n, i) { (e = +e, r |= 0, n |= 0, i) || U(this, e, r, n, Math.pow(2, 8 * n) - 1, 0); var o = 1, s = 0; for (this[r] = 255 & e; ++s < n && (o *= 256);)
                        this[r + s] = e / o & 255; return r + n; }, u.prototype.writeUIntBE = function t(e, r, n, i) { (e = +e, r |= 0, n |= 0, i) || U(this, e, r, n, Math.pow(2, 8 * n) - 1, 0); var o = n - 1, s = 1; for (this[r + o] = 255 & e; --o >= 0 && (s *= 256);)
                        this[r + o] = e / s & 255; return r + n; }, u.prototype.writeUInt8 = function t(e, r, n) { return e = +e, r |= 0, n || U(this, e, r, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[r] = 255 & e, r + 1; }, u.prototype.writeUInt16LE = function t(e, r, n) { return e = +e, r |= 0, n || U(this, e, r, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[r] = 255 & e, this[r + 1] = e >>> 8) : L(this, e, r, !0), r + 2; }, u.prototype.writeUInt16BE = function t(e, r, n) { return e = +e, r |= 0, n || U(this, e, r, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 8, this[r + 1] = 255 & e) : L(this, e, r, !1), r + 2; }, u.prototype.writeUInt32LE = function t(e, r, n) { return e = +e, r |= 0, n || U(this, e, r, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[r + 3] = e >>> 24, this[r + 2] = e >>> 16, this[r + 1] = e >>> 8, this[r] = 255 & e) : B(this, e, r, !0), r + 4; }, u.prototype.writeUInt32BE = function t(e, r, n) { return e = +e, r |= 0, n || U(this, e, r, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 24, this[r + 1] = e >>> 16, this[r + 2] = e >>> 8, this[r + 3] = 255 & e) : B(this, e, r, !1), r + 4; }, u.prototype.writeIntLE = function t(e, r, n, i) { if (e = +e, r |= 0, !i) {
                        var o = Math.pow(2, 8 * n - 1);
                        U(this, e, r, n, o - 1, -o);
                    } var s = 0, a = 1, u = 0; for (this[r] = 255 & e; ++s < n && (a *= 256);)
                        e < 0 && 0 === u && 0 !== this[r + s - 1] && (u = 1), this[r + s] = (e / a >> 0) - u & 255; return r + n; }, u.prototype.writeIntBE = function t(e, r, n, i) { if (e = +e, r |= 0, !i) {
                        var o = Math.pow(2, 8 * n - 1);
                        U(this, e, r, n, o - 1, -o);
                    } var s = n - 1, a = 1, u = 0; for (this[r + s] = 255 & e; --s >= 0 && (a *= 256);)
                        e < 0 && 0 === u && 0 !== this[r + s + 1] && (u = 1), this[r + s] = (e / a >> 0) - u & 255; return r + n; }, u.prototype.writeInt8 = function t(e, r, n) { return e = +e, r |= 0, n || U(this, e, r, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[r] = 255 & e, r + 1; }, u.prototype.writeInt16LE = function t(e, r, n) { return e = +e, r |= 0, n || U(this, e, r, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[r] = 255 & e, this[r + 1] = e >>> 8) : L(this, e, r, !0), r + 2; }, u.prototype.writeInt16BE = function t(e, r, n) { return e = +e, r |= 0, n || U(this, e, r, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 8, this[r + 1] = 255 & e) : L(this, e, r, !1), r + 2; }, u.prototype.writeInt32LE = function t(e, r, n) { return e = +e, r |= 0, n || U(this, e, r, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[r] = 255 & e, this[r + 1] = e >>> 8, this[r + 2] = e >>> 16, this[r + 3] = e >>> 24) : B(this, e, r, !0), r + 4; }, u.prototype.writeInt32BE = function t(e, r, n) { return e = +e, r |= 0, n || U(this, e, r, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), u.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 24, this[r + 1] = e >>> 16, this[r + 2] = e >>> 8, this[r + 3] = 255 & e) : B(this, e, r, !1), r + 4; }, u.prototype.writeFloatLE = function t(e, r, n) { return O(this, e, r, !0, n); }, u.prototype.writeFloatBE = function t(e, r, n) { return O(this, e, r, !1, n); }, u.prototype.writeDoubleLE = function t(e, r, n) { return j(this, e, r, !0, n); }, u.prototype.writeDoubleBE = function t(e, r, n) { return j(this, e, r, !1, n); }, u.prototype.copy = function t(e, r, n, i) { if (n || (n = 0), i || 0 === i || (i = this.length), r >= e.length && (r = e.length), r || (r = 0), i > 0 && i < n && (i = n), i === n)
                        return 0; if (0 === e.length || 0 === this.length)
                        return 0; if (r < 0)
                        throw new RangeError("targetStart out of bounds"); if (n < 0 || n >= this.length)
                        throw new RangeError("sourceStart out of bounds"); if (i < 0)
                        throw new RangeError("sourceEnd out of bounds"); i > this.length && (i = this.length), e.length - r < i - n && (i = e.length - r + n); var o, s = i - n; if (this === e && n < r && r < i)
                        for (o = s - 1; o >= 0; --o)
                            e[o + r] = this[o + n];
                    else if (s < 1e3 || !u.TYPED_ARRAY_SUPPORT)
                        for (o = 0; o < s; ++o)
                            e[o + r] = this[o + n];
                    else
                        Uint8Array.prototype.set.call(e, this.subarray(n, n + s), r); return s; }, u.prototype.fill = function t(e, r, n, i) { if ("string" == typeof e) {
                        if ("string" == typeof r ? (i = r, r = 0, n = this.length) : "string" == typeof n && (i = n, n = this.length), 1 === e.length) {
                            var o = e.charCodeAt(0);
                            o < 256 && (e = o);
                        }
                        if (void 0 !== i && "string" != typeof i)
                            throw new TypeError("encoding must be a string");
                        if ("string" == typeof i && !u.isEncoding(i))
                            throw new TypeError("Unknown encoding: " + i);
                    }
                    else
                        "number" == typeof e && (e &= 255); if (r < 0 || this.length < r || this.length < n)
                        throw new RangeError("Out of range index"); if (n <= r)
                        return this; var s; if (r >>>= 0, n = void 0 === n ? this.length : n >>> 0, e || (e = 0), "number" == typeof e)
                        for (s = r; s < n; ++s)
                            this[s] = e;
                    else {
                        var a = u.isBuffer(e) ? e : K(new u(e, i).toString()), c = a.length;
                        for (s = 0; s < n - r; ++s)
                            this[s + r] = a[s % c];
                    } return this; };
                    var H = /[^+\/0-9A-Za-z-_]/g;
                    function M(t) { return t < 16 ? "0" + t.toString(16) : t.toString(16); }
                    function K(t, e) { var r; e = e || 1 / 0; for (var n = t.length, i = null, o = [], s = 0; s < n; ++s) {
                        if ((r = t.charCodeAt(s)) > 55295 && r < 57344) {
                            if (!i) {
                                if (r > 56319) {
                                    (e -= 3) > -1 && o.push(239, 191, 189);
                                    continue;
                                }
                                if (s + 1 === n) {
                                    (e -= 3) > -1 && o.push(239, 191, 189);
                                    continue;
                                }
                                i = r;
                                continue;
                            }
                            if (r < 56320) {
                                (e -= 3) > -1 && o.push(239, 191, 189), i = r;
                                continue;
                            }
                            r = 65536 + (i - 55296 << 10 | r - 56320);
                        }
                        else
                            i && (e -= 3) > -1 && o.push(239, 191, 189);
                        if (i = null, r < 128) {
                            if ((e -= 1) < 0)
                                break;
                            o.push(r);
                        }
                        else if (r < 2048) {
                            if ((e -= 2) < 0)
                                break;
                            o.push(r >> 6 | 192, 63 & r | 128);
                        }
                        else if (r < 65536) {
                            if ((e -= 3) < 0)
                                break;
                            o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                        }
                        else {
                            if (!(r < 1114112))
                                throw new Error("Invalid code point");
                            if ((e -= 4) < 0)
                                break;
                            o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                        }
                    } return o; }
                    function V(t) { return n.toByteArray(function e(t) { if ((t = function e(t) { return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, ""); }(t).replace(H, "")).length < 2)
                        return ""; for (; t.length % 4 != 0;)
                        t += "="; return t; }(t)); }
                    function q(t, e, r, n) { for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i)
                        e[i + r] = t[i]; return i; }
                }).call(this, r(28));
            }, function (t, e) { var r; r = function () { return this; }(); try {
                r = r || new Function("return this")();
            }
            catch (t) {
                "object" == typeof window && (r = window);
            } t.exports = r; }, function (t, e, r) { e.byteLength = function n(t) { var e = f(t), r = e[0], n = e[1]; return 3 * (r + n) / 4 - n; }, e.toByteArray = function i(t) { for (var e, r = f(t), n = r[0], i = r[1], o = new u(function s(t, e, r) { return 3 * (e + r) / 4 - r; }(0, n, i)), c = 0, h = i > 0 ? n - 4 : n, l = 0; l < h; l += 4)
                e = a[t.charCodeAt(l)] << 18 | a[t.charCodeAt(l + 1)] << 12 | a[t.charCodeAt(l + 2)] << 6 | a[t.charCodeAt(l + 3)], o[c++] = e >> 16 & 255, o[c++] = e >> 8 & 255, o[c++] = 255 & e; 2 === i && (e = a[t.charCodeAt(l)] << 2 | a[t.charCodeAt(l + 1)] >> 4, o[c++] = 255 & e); 1 === i && (e = a[t.charCodeAt(l)] << 10 | a[t.charCodeAt(l + 1)] << 4 | a[t.charCodeAt(l + 2)] >> 2, o[c++] = e >> 8 & 255, o[c++] = 255 & e); return o; }, e.fromByteArray = function o(t) { for (var e, r = t.length, n = r % 3, i = [], o = 0, a = r - n; o < a; o += 16383)
                i.push(d(t, o, o + 16383 > a ? a : o + 16383)); 1 === n ? (e = t[r - 1], i.push(s[e >> 2] + s[e << 4 & 63] + "==")) : 2 === n && (e = (t[r - 2] << 8) + t[r - 1], i.push(s[e >> 10] + s[e >> 4 & 63] + s[e << 2 & 63] + "=")); return i.join(""); }; for (var s = [], a = [], u = "undefined" != typeof Uint8Array ? Uint8Array : Array, c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", h = 0, l = c.length; h < l; ++h)
                s[h] = c[h], a[c.charCodeAt(h)] = h; function f(t) { var e = t.length; if (e % 4 > 0)
                throw new Error("Invalid string. Length must be a multiple of 4"); var r = t.indexOf("="); return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4]; } function d(t, e, r) { for (var n, i, o = [], a = e; a < r; a += 3)
                n = (t[a] << 16 & 16711680) + (t[a + 1] << 8 & 65280) + (255 & t[a + 2]), o.push(s[(i = n) >> 18 & 63] + s[i >> 12 & 63] + s[i >> 6 & 63] + s[63 & i]); return o.join(""); } a["-".charCodeAt(0)] = 62, a["_".charCodeAt(0)] = 63; }, function (t, e) { e.read = function (t, e, r, n, i) { var o, s, a = 8 * i - n - 1, u = (1 << a) - 1, c = u >> 1, h = -7, l = r ? i - 1 : 0, f = r ? -1 : 1, d = t[e + l]; for (l += f, o = d & (1 << -h) - 1, d >>= -h, h += a; h > 0; o = 256 * o + t[e + l], l += f, h -= 8)
                ; for (s = o & (1 << -h) - 1, o >>= -h, h += n; h > 0; s = 256 * s + t[e + l], l += f, h -= 8)
                ; if (0 === o)
                o = 1 - c;
            else {
                if (o === u)
                    return s ? NaN : 1 / 0 * (d ? -1 : 1);
                s += Math.pow(2, n), o -= c;
            } return (d ? -1 : 1) * s * Math.pow(2, o - n); }, e.write = function (t, e, r, n, i, o) { var s, a, u, c = 8 * o - i - 1, h = (1 << c) - 1, l = h >> 1, f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = n ? 0 : o - 1, g = n ? 1 : -1, p = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0; for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = h) : (s = Math.floor(Math.log(e) / Math.LN2), e * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), (e += s + l >= 1 ? f / u : f * Math.pow(2, 1 - l)) * u >= 2 && (s++, u /= 2), s + l >= h ? (a = 0, s = h) : s + l >= 1 ? (a = (e * u - 1) * Math.pow(2, i), s += l) : (a = e * Math.pow(2, l - 1) * Math.pow(2, i), s = 0)); i >= 8; t[r + d] = 255 & a, d += g, a /= 256, i -= 8)
                ; for (s = s << i | a, c += i; c > 0; t[r + d] = 255 & s, d += g, s /= 256, c -= 8)
                ; t[r + d - g] |= 128 * p; }; }, function (t, e) { var r = {}.toString; t.exports = Array.isArray || function (t) { return "[object Array]" == r.call(t); }; }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.default = function n(t) { var e = t.jws, r = t.KeyUtil, n = t.X509, o = t.crypto, s = t.hextob64u, a = t.b64tohex, u = t.AllowedSigningAlgs; return function () { function t() { !function e(t, r) { if (!(t instanceof r))
                throw new TypeError("Cannot call a class as a function"); }(this, t); } return t.parseJwt = function t(r) { i.Log.debug("JoseUtil.parseJwt"); try {
                var n = e.JWS.parse(r);
                return { header: n.headerObj, payload: n.payloadObj };
            }
            catch (t) {
                i.Log.error(t);
            } }, t.validateJwt = function e(o, s, u, c, h, l, f) { i.Log.debug("JoseUtil.validateJwt"); try {
                if ("RSA" === s.kty)
                    if (s.e && s.n)
                        s = r.getKey(s);
                    else {
                        if (!s.x5c || !s.x5c.length)
                            return i.Log.error("JoseUtil.validateJwt: RSA key missing key material", s), Promise.reject(new Error("RSA key missing key material"));
                        var d = a(s.x5c[0]);
                        s = n.getPublicKeyFromCertHex(d);
                    }
                else {
                    if ("EC" !== s.kty)
                        return i.Log.error("JoseUtil.validateJwt: Unsupported key type", s && s.kty), Promise.reject(new Error(s.kty));
                    if (!(s.crv && s.x && s.y))
                        return i.Log.error("JoseUtil.validateJwt: EC key missing key material", s), Promise.reject(new Error("EC key missing key material"));
                    s = r.getKey(s);
                }
                return t._validateJwt(o, s, u, c, h, l, f);
            }
            catch (t) {
                return i.Log.error(t && t.message || t), Promise.reject("JWT validation failed");
            } }, t.validateJwtAttributes = function e(r, n, o, s, a, u) { s || (s = 0), a || (a = parseInt(Date.now() / 1e3)); var c = t.parseJwt(r).payload; if (!c.iss)
                return i.Log.error("JoseUtil._validateJwt: issuer was not provided"), Promise.reject(new Error("issuer was not provided")); if (c.iss !== n)
                return i.Log.error("JoseUtil._validateJwt: Invalid issuer in token", c.iss), Promise.reject(new Error("Invalid issuer in token: " + c.iss)); if (!c.aud)
                return i.Log.error("JoseUtil._validateJwt: aud was not provided"), Promise.reject(new Error("aud was not provided")); var h = c.aud === o || Array.isArray(c.aud) && c.aud.indexOf(o) >= 0; if (!h)
                return i.Log.error("JoseUtil._validateJwt: Invalid audience in token", c.aud), Promise.reject(new Error("Invalid audience in token: " + c.aud)); if (c.azp && c.azp !== o)
                return i.Log.error("JoseUtil._validateJwt: Invalid azp in token", c.azp), Promise.reject(new Error("Invalid azp in token: " + c.azp)); if (!u) {
                var l = a + s, f = a - s;
                if (!c.iat)
                    return i.Log.error("JoseUtil._validateJwt: iat was not provided"), Promise.reject(new Error("iat was not provided"));
                if (l < c.iat)
                    return i.Log.error("JoseUtil._validateJwt: iat is in the future", c.iat), Promise.reject(new Error("iat is in the future: " + c.iat));
                if (c.nbf && l < c.nbf)
                    return i.Log.error("JoseUtil._validateJwt: nbf is in the future", c.nbf), Promise.reject(new Error("nbf is in the future: " + c.nbf));
                if (!c.exp)
                    return i.Log.error("JoseUtil._validateJwt: exp was not provided"), Promise.reject(new Error("exp was not provided"));
                if (c.exp < f)
                    return i.Log.error("JoseUtil._validateJwt: exp is in the past", c.exp), Promise.reject(new Error("exp is in the past:" + c.exp));
            } return Promise.resolve(c); }, t._validateJwt = function r(n, o, s, a, c, h, l) { return t.validateJwtAttributes(n, s, a, c, h, l).then(function (t) { try {
                return e.JWS.verify(n, o, u) ? t : (i.Log.error("JoseUtil._validateJwt: signature validation failed"), Promise.reject(new Error("signature validation failed")));
            }
            catch (t) {
                return i.Log.error(t && t.message || t), Promise.reject(new Error("signature validation failed"));
            } }); }, t.hashString = function t(e, r) { try {
                return o.Util.hashString(e, r);
            }
            catch (t) {
                i.Log.error(t);
            } }, t.hexToBase64Url = function t(e) { try {
                return s(e);
            }
            catch (t) {
                i.Log.error(t);
            } }, t; }(); }; var i = r(0); t.exports = e.default; }, function (t, e, r) { var n = r(34), i = r(35); t.exports = function o(t, e, r) { var o = e && r || 0; "string" == typeof t && (e = "binary" === t ? new Array(16) : null, t = null); var s = (t = t || {}).random || (t.rng || n)(); if (s[6] = 15 & s[6] | 64, s[8] = 63 & s[8] | 128, e)
                for (var a = 0; a < 16; ++a)
                    e[o + a] = s[a]; return e || i(s); }; }, function (t, e) { var r = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto); if (r) {
                var n = new Uint8Array(16);
                t.exports = function t() { return r(n), n; };
            }
            else {
                var i = new Array(16);
                t.exports = function t() { for (var e, r = 0; r < 16; r++)
                    0 == (3 & r) && (e = 4294967296 * Math.random()), i[r] = e >>> ((3 & r) << 3) & 255; return i; };
            } }, function (t, e) { for (var r = [], n = 0; n < 256; ++n)
                r[n] = (n + 256).toString(16).substr(1); t.exports = function i(t, e) { var n = e || 0, i = r; return [i[t[n++]], i[t[n++]], i[t[n++]], i[t[n++]], "-", i[t[n++]], i[t[n++]], "-", i[t[n++]], i[t[n++]], "-", i[t[n++]], i[t[n++]], "-", i[t[n++]], i[t[n++]], i[t[n++]], i[t[n++]], i[t[n++]], i[t[n++]]].join(""); }; }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.SigninResponse = void 0; var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(), i = r(3); e.SigninResponse = function () { function t(e) { var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "#"; !function n(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t); var o = i.UrlUtility.parseUrlFragment(e, r); this.error = o.error, this.error_description = o.error_description, this.error_uri = o.error_uri, this.code = o.code, this.state = o.state, this.id_token = o.id_token, this.session_state = o.session_state, this.access_token = o.access_token, this.token_type = o.token_type, this.scope = o.scope, this.profile = void 0, this.expires_in = o.expires_in; } return n(t, [{ key: "expires_in", get: function t() { if (this.expires_at) {
                        var e = parseInt(Date.now() / 1e3);
                        return this.expires_at - e;
                    } }, set: function t(e) { var r = parseInt(e); if ("number" == typeof r && r > 0) {
                        var n = parseInt(Date.now() / 1e3);
                        this.expires_at = n + r;
                    } } }, { key: "expired", get: function t() { var e = this.expires_in; if (void 0 !== e)
                        return e <= 0; } }, { key: "scopes", get: function t() { return (this.scope || "").split(" "); } }, { key: "isOpenIdConnect", get: function t() { return this.scopes.indexOf("openid") >= 0 || !!this.id_token; } }]), t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.SignoutRequest = void 0; var n = r(0), i = r(3), o = r(8); e.SignoutRequest = function t(e) { var r = e.url, s = e.id_token_hint, a = e.post_logout_redirect_uri, u = e.data, c = e.extraQueryParams, h = e.request_type; if (function l(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), !r)
                throw n.Log.error("SignoutRequest.ctor: No url passed"), new Error("url"); for (var f in s && (r = i.UrlUtility.addQueryParam(r, "id_token_hint", s)), a && (r = i.UrlUtility.addQueryParam(r, "post_logout_redirect_uri", a), u && (this.state = new o.State({ data: u, request_type: h }), r = i.UrlUtility.addQueryParam(r, "state", this.state.id))), c)
                r = i.UrlUtility.addQueryParam(r, f, c[f]); this.url = r; }; }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.SignoutResponse = void 0; var n = r(3); e.SignoutResponse = function t(e) { !function r(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t); var i = n.UrlUtility.parseUrlFragment(e, "?"); this.error = i.error, this.error_description = i.error_description, this.error_uri = i.error_uri, this.state = i.state; }; }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.InMemoryWebStorage = void 0; var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(), i = r(0); e.InMemoryWebStorage = function () { function t() { !function e(t, r) { if (!(t instanceof r))
                throw new TypeError("Cannot call a class as a function"); }(this, t), this._data = {}; } return t.prototype.getItem = function t(e) { return i.Log.debug("InMemoryWebStorage.getItem", e), this._data[e]; }, t.prototype.setItem = function t(e, r) { i.Log.debug("InMemoryWebStorage.setItem", e), this._data[e] = r; }, t.prototype.removeItem = function t(e) { i.Log.debug("InMemoryWebStorage.removeItem", e), delete this._data[e]; }, t.prototype.key = function t(e) { return Object.getOwnPropertyNames(this._data)[e]; }, n(t, [{ key: "length", get: function t() { return Object.getOwnPropertyNames(this._data).length; } }]), t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.UserManager = void 0; var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(), i = r(0), o = r(9), s = r(41), a = r(15), u = r(47), c = r(49), h = r(18), l = r(20), f = r(10), d = r(4); e.UserManager = function (t) { function e() { var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : c.SilentRenewService, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : h.SessionMonitor, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : l.TokenRevocationClient, g = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : f.TokenClient, p = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : d.JoseUtil; !function v(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, e), r instanceof s.UserManagerSettings || (r = new s.UserManagerSettings(r)); var y = function m(t, e) { if (!t)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return !e || "object" != typeof e && "function" != typeof e ? t : e; }(this, t.call(this, r)); return y._events = new u.UserManagerEvents(r), y._silentRenewService = new n(y), y.settings.automaticSilentRenew && (i.Log.debug("UserManager.ctor: automaticSilentRenew is configured, setting up silent renew"), y.startSilentRenew()), y.settings.monitorSession && (i.Log.debug("UserManager.ctor: monitorSession is configured, setting up session monitor"), y._sessionMonitor = new o(y)), y._tokenRevocationClient = new a(y._settings), y._tokenClient = new g(y._settings), y._joseUtil = p, y; } return function r(t, e) { if ("function" != typeof e && null !== e)
                throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e); }(e, t), e.prototype.getUser = function t() { var e = this; return this._loadUser().then(function (t) { return t ? (i.Log.info("UserManager.getUser: user loaded"), e._events.load(t, !1), t) : (i.Log.info("UserManager.getUser: user not found in storage"), null); }); }, e.prototype.removeUser = function t() { var e = this; return this.storeUser(null).then(function () { i.Log.info("UserManager.removeUser: user removed from storage"), e._events.unload(); }); }, e.prototype.signinRedirect = function t() { var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}; (e = Object.assign({}, e)).request_type = "si:r"; var r = { useReplaceToNavigate: e.useReplaceToNavigate }; return this._signinStart(e, this._redirectNavigator, r).then(function () { i.Log.info("UserManager.signinRedirect: successful"); }); }, e.prototype.signinRedirectCallback = function t(e) { return this._signinEnd(e || this._redirectNavigator.url).then(function (t) { return t.profile && t.profile.sub ? i.Log.info("UserManager.signinRedirectCallback: successful, signed in sub: ", t.profile.sub) : i.Log.info("UserManager.signinRedirectCallback: no sub"), t; }); }, e.prototype.signinPopup = function t() { var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}; (e = Object.assign({}, e)).request_type = "si:p"; var r = e.redirect_uri || this.settings.popup_redirect_uri || this.settings.redirect_uri; return r ? (e.redirect_uri = r, e.display = "popup", this._signin(e, this._popupNavigator, { startUrl: r, popupWindowFeatures: e.popupWindowFeatures || this.settings.popupWindowFeatures, popupWindowTarget: e.popupWindowTarget || this.settings.popupWindowTarget }).then(function (t) { return t && (t.profile && t.profile.sub ? i.Log.info("UserManager.signinPopup: signinPopup successful, signed in sub: ", t.profile.sub) : i.Log.info("UserManager.signinPopup: no sub")), t; })) : (i.Log.error("UserManager.signinPopup: No popup_redirect_uri or redirect_uri configured"), Promise.reject(new Error("No popup_redirect_uri or redirect_uri configured"))); }, e.prototype.signinPopupCallback = function t(e) { return this._signinCallback(e, this._popupNavigator).then(function (t) { return t && (t.profile && t.profile.sub ? i.Log.info("UserManager.signinPopupCallback: successful, signed in sub: ", t.profile.sub) : i.Log.info("UserManager.signinPopupCallback: no sub")), t; }).catch(function (t) { i.Log.error(t.message); }); }, e.prototype.signinSilent = function t() { var e = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}; return (r = Object.assign({}, r)).request_type = "si:s", this._loadUser().then(function (t) { return t && t.refresh_token ? (r.refresh_token = t.refresh_token, e._useRefreshToken(r)) : (r.id_token_hint = r.id_token_hint || e.settings.includeIdTokenInSilentRenew && t && t.id_token, t && e._settings.validateSubOnSilentRenew && (i.Log.debug("UserManager.signinSilent, subject prior to silent renew: ", t.profile.sub), r.current_sub = t.profile.sub), e._signinSilentIframe(r)); }); }, e.prototype._useRefreshToken = function t() { var e = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}; return this._tokenClient.exchangeRefreshToken(r).then(function (t) { return t ? t.access_token ? e._loadUser().then(function (r) { if (r) {
                var n = Promise.resolve();
                return t.id_token && (n = e._validateIdTokenFromTokenRefreshToken(r.profile, t.id_token)), n.then(function () { return i.Log.debug("UserManager._useRefreshToken: refresh token response success"), r.id_token = t.id_token, r.access_token = t.access_token, r.refresh_token = t.refresh_token || r.refresh_token, r.expires_in = t.expires_in, e.storeUser(r).then(function () { return e._events.load(r), r; }); });
            } return null; }) : (i.Log.error("UserManager._useRefreshToken: No access token returned from token endpoint"), Promise.reject("No access token returned from token endpoint")) : (i.Log.error("UserManager._useRefreshToken: No response returned from token endpoint"), Promise.reject("No response returned from token endpoint")); }); }, e.prototype._validateIdTokenFromTokenRefreshToken = function t(e, r) { var n = this; return this._metadataService.getIssuer().then(function (t) { return n._joseUtil.validateJwtAttributes(r, t, n._settings.client_id, n._settings.clockSkew).then(function (t) { return t ? t.sub !== e.sub ? (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: sub in id_token does not match current sub"), Promise.reject(new Error("sub in id_token does not match current sub"))) : t.auth_time && t.auth_time !== e.auth_time ? (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: auth_time in id_token does not match original auth_time"), Promise.reject(new Error("auth_time in id_token does not match original auth_time"))) : t.azp && t.azp !== e.azp ? (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: azp in id_token does not match original azp"), Promise.reject(new Error("azp in id_token does not match original azp"))) : !t.azp && e.azp ? (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: azp not in id_token, but present in original id_token"), Promise.reject(new Error("azp not in id_token, but present in original id_token"))) : void 0 : (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: Failed to validate id_token"), Promise.reject(new Error("Failed to validate id_token"))); }); }); }, e.prototype._signinSilentIframe = function t() { var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = e.redirect_uri || this.settings.silent_redirect_uri || this.settings.redirect_uri; return r ? (e.redirect_uri = r, e.prompt = e.prompt || "none", this._signin(e, this._iframeNavigator, { startUrl: r, silentRequestTimeout: e.silentRequestTimeout || this.settings.silentRequestTimeout }).then(function (t) { return t && (t.profile && t.profile.sub ? i.Log.info("UserManager.signinSilent: successful, signed in sub: ", t.profile.sub) : i.Log.info("UserManager.signinSilent: no sub")), t; })) : (i.Log.error("UserManager.signinSilent: No silent_redirect_uri configured"), Promise.reject(new Error("No silent_redirect_uri configured"))); }, e.prototype.signinSilentCallback = function t(e) { return this._signinCallback(e, this._iframeNavigator).then(function (t) { return t && (t.profile && t.profile.sub ? i.Log.info("UserManager.signinSilentCallback: successful, signed in sub: ", t.profile.sub) : i.Log.info("UserManager.signinSilentCallback: no sub")), t; }); }, e.prototype.signinCallback = function t(e) { var r = this; return this.readSigninResponseState(e).then(function (t) { var n = t.state; return "si:r" === n.request_type ? r.signinRedirectCallback(e) : "si:p" === n.request_type ? r.signinPopupCallback(e) : "si:s" === n.request_type ? r.signinSilentCallback(e) : Promise.reject(new Error("invalid response_type in state")); }); }, e.prototype.signoutCallback = function t(e, r) { var n = this; return this.readSignoutResponseState(e).then(function (t) { var i = t.state, o = t.response; return i ? "so:r" === i.request_type ? n.signoutRedirectCallback(e) : "so:p" === i.request_type ? n.signoutPopupCallback(e, r) : Promise.reject(new Error("invalid response_type in state")) : o; }); }, e.prototype.querySessionStatus = function t() { var e = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}; (r = Object.assign({}, r)).request_type = "si:s"; var n = r.redirect_uri || this.settings.silent_redirect_uri || this.settings.redirect_uri; return n ? (r.redirect_uri = n, r.prompt = "none", r.response_type = r.response_type || this.settings.query_status_response_type, r.scope = r.scope || "openid", r.skipUserInfo = !0, this._signinStart(r, this._iframeNavigator, { startUrl: n, silentRequestTimeout: r.silentRequestTimeout || this.settings.silentRequestTimeout }).then(function (t) { return e.processSigninResponse(t.url).then(function (t) { if (i.Log.debug("UserManager.querySessionStatus: got signin response"), t.session_state && t.profile.sub)
                return i.Log.info("UserManager.querySessionStatus: querySessionStatus success for sub: ", t.profile.sub), { session_state: t.session_state, sub: t.profile.sub, sid: t.profile.sid }; i.Log.info("querySessionStatus successful, user not authenticated"); }).catch(function (t) { if (t.session_state && e.settings.monitorAnonymousSession && ("login_required" == t.message || "consent_required" == t.message || "interaction_required" == t.message || "account_selection_required" == t.message))
                return i.Log.info("UserManager.querySessionStatus: querySessionStatus success for anonymous user"), { session_state: t.session_state }; throw t; }); })) : (i.Log.error("UserManager.querySessionStatus: No silent_redirect_uri configured"), Promise.reject(new Error("No silent_redirect_uri configured"))); }, e.prototype._signin = function t(e, r) { var n = this, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}; return this._signinStart(e, r, i).then(function (t) { return n._signinEnd(t.url, e); }); }, e.prototype._signinStart = function t(e, r) { var n = this, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}; return r.prepare(o).then(function (t) { return i.Log.debug("UserManager._signinStart: got navigator window handle"), n.createSigninRequest(e).then(function (e) { return i.Log.debug("UserManager._signinStart: got signin request"), o.url = e.url, o.id = e.state.id, t.navigate(o); }).catch(function (e) { throw t.close && (i.Log.debug("UserManager._signinStart: Error after preparing navigator, closing navigator window"), t.close()), e; }); }); }, e.prototype._signinEnd = function t(e) { var r = this, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}; return this.processSigninResponse(e).then(function (t) { i.Log.debug("UserManager._signinEnd: got signin response"); var e = new a.User(t); if (n.current_sub) {
                if (n.current_sub !== e.profile.sub)
                    return i.Log.debug("UserManager._signinEnd: current user does not match user returned from signin. sub from signin: ", e.profile.sub), Promise.reject(new Error("login_required"));
                i.Log.debug("UserManager._signinEnd: current user matches user returned from signin");
            } return r.storeUser(e).then(function () { return i.Log.debug("UserManager._signinEnd: user stored"), r._events.load(e), e; }); }); }, e.prototype._signinCallback = function t(e, r) { return i.Log.debug("UserManager._signinCallback"), r.callback(e); }, e.prototype.signoutRedirect = function t() { var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}; (e = Object.assign({}, e)).request_type = "so:r"; var r = e.post_logout_redirect_uri || this.settings.post_logout_redirect_uri; r && (e.post_logout_redirect_uri = r); var n = { useReplaceToNavigate: e.useReplaceToNavigate }; return this._signoutStart(e, this._redirectNavigator, n).then(function () { i.Log.info("UserManager.signoutRedirect: successful"); }); }, e.prototype.signoutRedirectCallback = function t(e) { return this._signoutEnd(e || this._redirectNavigator.url).then(function (t) { return i.Log.info("UserManager.signoutRedirectCallback: successful"), t; }); }, e.prototype.signoutPopup = function t() { var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}; (e = Object.assign({}, e)).request_type = "so:p"; var r = e.post_logout_redirect_uri || this.settings.popup_post_logout_redirect_uri || this.settings.post_logout_redirect_uri; return e.post_logout_redirect_uri = r, e.display = "popup", e.post_logout_redirect_uri && (e.state = e.state || {}), this._signout(e, this._popupNavigator, { startUrl: r, popupWindowFeatures: e.popupWindowFeatures || this.settings.popupWindowFeatures, popupWindowTarget: e.popupWindowTarget || this.settings.popupWindowTarget }).then(function () { i.Log.info("UserManager.signoutPopup: successful"); }); }, e.prototype.signoutPopupCallback = function t(e, r) { void 0 === r && "boolean" == typeof e && (r = e, e = null); return this._popupNavigator.callback(e, r, "?").then(function () { i.Log.info("UserManager.signoutPopupCallback: successful"); }); }, e.prototype._signout = function t(e, r) { var n = this, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}; return this._signoutStart(e, r, i).then(function (t) { return n._signoutEnd(t.url); }); }, e.prototype._signoutStart = function t() { var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = this, n = arguments[1], o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}; return n.prepare(o).then(function (t) { return i.Log.debug("UserManager._signoutStart: got navigator window handle"), r._loadUser().then(function (n) { return i.Log.debug("UserManager._signoutStart: loaded current user from storage"), (r._settings.revokeAccessTokenOnSignout ? r._revokeInternal(n) : Promise.resolve()).then(function () { var s = e.id_token_hint || n && n.id_token; return s && (i.Log.debug("UserManager._signoutStart: Setting id_token into signout request"), e.id_token_hint = s), r.removeUser().then(function () { return i.Log.debug("UserManager._signoutStart: user removed, creating signout request"), r.createSignoutRequest(e).then(function (e) { return i.Log.debug("UserManager._signoutStart: got signout request"), o.url = e.url, e.state && (o.id = e.state.id), t.navigate(o); }); }); }); }).catch(function (e) { throw t.close && (i.Log.debug("UserManager._signoutStart: Error after preparing navigator, closing navigator window"), t.close()), e; }); }); }, e.prototype._signoutEnd = function t(e) { return this.processSignoutResponse(e).then(function (t) { return i.Log.debug("UserManager._signoutEnd: got signout response"), t; }); }, e.prototype.revokeAccessToken = function t() { var e = this; return this._loadUser().then(function (t) { return e._revokeInternal(t, !0).then(function (r) { if (r)
                return i.Log.debug("UserManager.revokeAccessToken: removing token properties from user and re-storing"), t.access_token = null, t.refresh_token = null, t.expires_at = null, t.token_type = null, e.storeUser(t).then(function () { i.Log.debug("UserManager.revokeAccessToken: user stored"), e._events.load(t); }); }); }).then(function () { i.Log.info("UserManager.revokeAccessToken: access token revoked successfully"); }); }, e.prototype._revokeInternal = function t(e, r) { var n = this; if (e) {
                var o = e.access_token, s = e.refresh_token;
                return this._revokeAccessTokenInternal(o, r).then(function (t) { return n._revokeRefreshTokenInternal(s, r).then(function (e) { return t || e || i.Log.debug("UserManager.revokeAccessToken: no need to revoke due to no token(s), or JWT format"), t || e; }); });
            } return Promise.resolve(!1); }, e.prototype._revokeAccessTokenInternal = function t(e, r) { return !e || e.indexOf(".") >= 0 ? Promise.resolve(!1) : this._tokenRevocationClient.revoke(e, r).then(function () { return !0; }); }, e.prototype._revokeRefreshTokenInternal = function t(e, r) { return e ? this._tokenRevocationClient.revoke(e, r, "refresh_token").then(function () { return !0; }) : Promise.resolve(!1); }, e.prototype.startSilentRenew = function t() { this._silentRenewService.start(); }, e.prototype.stopSilentRenew = function t() { this._silentRenewService.stop(); }, e.prototype._loadUser = function t() { return this._userStore.get(this._userStoreKey).then(function (t) { return t ? (i.Log.debug("UserManager._loadUser: user storageString loaded"), a.User.fromStorageString(t)) : (i.Log.debug("UserManager._loadUser: no user storageString"), null); }); }, e.prototype.storeUser = function t(e) { if (e) {
                i.Log.debug("UserManager.storeUser: storing user");
                var r = e.toStorageString();
                return this._userStore.set(this._userStoreKey, r);
            } return i.Log.debug("storeUser.storeUser: removing user"), this._userStore.remove(this._userStoreKey); }, n(e, [{ key: "_redirectNavigator", get: function t() { return this.settings.redirectNavigator; } }, { key: "_popupNavigator", get: function t() { return this.settings.popupNavigator; } }, { key: "_iframeNavigator", get: function t() { return this.settings.iframeNavigator; } }, { key: "_userStore", get: function t() { return this.settings.userStore; } }, { key: "events", get: function t() { return this._events; } }, { key: "_userStoreKey", get: function t() { return "user:" + this.settings.authority + ":" + this.settings.client_id; } }]), e; }(o.OidcClient); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.UserManagerSettings = void 0; var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(), i = (r(0), r(5)), o = r(42), s = r(43), a = r(45), u = r(6), c = r(1), h = r(12); var l = 60, f = 2e3; e.UserManagerSettings = function (t) { function e() { var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = r.popup_redirect_uri, i = r.popup_post_logout_redirect_uri, d = r.popupWindowFeatures, g = r.popupWindowTarget, p = r.silent_redirect_uri, v = r.silentRequestTimeout, y = r.automaticSilentRenew, m = void 0 !== y && y, _ = r.validateSubOnSilentRenew, S = void 0 !== _ && _, F = r.includeIdTokenInSilentRenew, b = void 0 === F || F, w = r.monitorSession, E = void 0 === w || w, x = r.monitorAnonymousSession, k = void 0 !== x && x, A = r.checkSessionInterval, P = void 0 === A ? f : A, C = r.stopCheckSessionOnError, T = void 0 === C || C, R = r.query_status_response_type, I = r.revokeAccessTokenOnSignout, D = void 0 !== I && I, U = r.accessTokenExpiringNotificationTime, L = void 0 === U ? l : U, B = r.redirectNavigator, N = void 0 === B ? new o.RedirectNavigator : B, O = r.popupNavigator, j = void 0 === O ? new s.PopupNavigator : O, H = r.iframeNavigator, M = void 0 === H ? new a.IFrameNavigator : H, K = r.userStore, V = void 0 === K ? new u.WebStorageStateStore({ store: c.Global.sessionStorage }) : K; !function q(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, e); var J = function W(t, e) { if (!t)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return !e || "object" != typeof e && "function" != typeof e ? t : e; }(this, t.call(this, arguments[0])); return J._popup_redirect_uri = n, J._popup_post_logout_redirect_uri = i, J._popupWindowFeatures = d, J._popupWindowTarget = g, J._silent_redirect_uri = p, J._silentRequestTimeout = v, J._automaticSilentRenew = m, J._validateSubOnSilentRenew = S, J._includeIdTokenInSilentRenew = b, J._accessTokenExpiringNotificationTime = L, J._monitorSession = E, J._monitorAnonymousSession = k, J._checkSessionInterval = P, J._stopCheckSessionOnError = T, R ? J._query_status_response_type = R : arguments[0] && arguments[0].response_type ? J._query_status_response_type = h.SigninRequest.isOidc(arguments[0].response_type) ? "id_token" : "code" : J._query_status_response_type = "id_token", J._revokeAccessTokenOnSignout = D, J._redirectNavigator = N, J._popupNavigator = j, J._iframeNavigator = M, J._userStore = V, J; } return function r(t, e) { if ("function" != typeof e && null !== e)
                throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e); }(e, t), n(e, [{ key: "popup_redirect_uri", get: function t() { return this._popup_redirect_uri; } }, { key: "popup_post_logout_redirect_uri", get: function t() { return this._popup_post_logout_redirect_uri; } }, { key: "popupWindowFeatures", get: function t() { return this._popupWindowFeatures; } }, { key: "popupWindowTarget", get: function t() { return this._popupWindowTarget; } }, { key: "silent_redirect_uri", get: function t() { return this._silent_redirect_uri; } }, { key: "silentRequestTimeout", get: function t() { return this._silentRequestTimeout; } }, { key: "automaticSilentRenew", get: function t() { return this._automaticSilentRenew; } }, { key: "validateSubOnSilentRenew", get: function t() { return this._validateSubOnSilentRenew; } }, { key: "includeIdTokenInSilentRenew", get: function t() { return this._includeIdTokenInSilentRenew; } }, { key: "accessTokenExpiringNotificationTime", get: function t() { return this._accessTokenExpiringNotificationTime; } }, { key: "monitorSession", get: function t() { return this._monitorSession; } }, { key: "monitorAnonymousSession", get: function t() { return this._monitorAnonymousSession; } }, { key: "checkSessionInterval", get: function t() { return this._checkSessionInterval; } }, { key: "stopCheckSessionOnError", get: function t() { return this._stopCheckSessionOnError; } }, { key: "query_status_response_type", get: function t() { return this._query_status_response_type; } }, { key: "revokeAccessTokenOnSignout", get: function t() { return this._revokeAccessTokenOnSignout; } }, { key: "redirectNavigator", get: function t() { return this._redirectNavigator; } }, { key: "popupNavigator", get: function t() { return this._popupNavigator; } }, { key: "iframeNavigator", get: function t() { return this._iframeNavigator; } }, { key: "userStore", get: function t() { return this._userStore; } }]), e; }(i.OidcClientSettings); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.RedirectNavigator = void 0; var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(), i = r(0); e.RedirectNavigator = function () { function t() { !function e(t, r) { if (!(t instanceof r))
                throw new TypeError("Cannot call a class as a function"); }(this, t); } return t.prototype.prepare = function t() { return Promise.resolve(this); }, t.prototype.navigate = function t(e) { return e && e.url ? (e.useReplaceToNavigate ? window.location.replace(e.url) : window.location = e.url, Promise.resolve()) : (i.Log.error("RedirectNavigator.navigate: No url provided"), Promise.reject(new Error("No url provided"))); }, n(t, [{ key: "url", get: function t() { return window.location.href; } }]), t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.PopupNavigator = void 0; var n = r(0), i = r(44); e.PopupNavigator = function () { function t() { !function e(t, r) { if (!(t instanceof r))
                throw new TypeError("Cannot call a class as a function"); }(this, t); } return t.prototype.prepare = function t(e) { var r = new i.PopupWindow(e); return Promise.resolve(r); }, t.prototype.callback = function t(e, r, o) { n.Log.debug("PopupNavigator.callback"); try {
                return i.PopupWindow.notifyOpener(e, r, o), Promise.resolve();
            }
            catch (t) {
                return Promise.reject(t);
            } }, t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.PopupWindow = void 0; var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(), i = r(0), o = r(3); var s = 500, a = "location=no,toolbar=no,width=500,height=500,left=100,top=100;", u = "_blank"; e.PopupWindow = function () { function t(e) { var r = this; !function n(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), this._promise = new Promise(function (t, e) { r._resolve = t, r._reject = e; }); var o = e.popupWindowTarget || u, c = e.popupWindowFeatures || a; this._popup = window.open("", o, c), this._popup && (i.Log.debug("PopupWindow.ctor: popup successfully created"), this._checkForPopupClosedTimer = window.setInterval(this._checkForPopupClosed.bind(this), s)); } return t.prototype.navigate = function t(e) { return this._popup ? e && e.url ? (i.Log.debug("PopupWindow.navigate: Setting URL in popup"), this._id = e.id, this._id && (window["popupCallback_" + e.id] = this._callback.bind(this)), this._popup.focus(), this._popup.window.location = e.url) : (this._error("PopupWindow.navigate: no url provided"), this._error("No url provided")) : this._error("PopupWindow.navigate: Error opening popup window"), this.promise; }, t.prototype._success = function t(e) { i.Log.debug("PopupWindow.callback: Successful response from popup window"), this._cleanup(), this._resolve(e); }, t.prototype._error = function t(e) { i.Log.error("PopupWindow.error: ", e), this._cleanup(), this._reject(new Error(e)); }, t.prototype.close = function t() { this._cleanup(!1); }, t.prototype._cleanup = function t(e) { i.Log.debug("PopupWindow.cleanup"), window.clearInterval(this._checkForPopupClosedTimer), this._checkForPopupClosedTimer = null, delete window["popupCallback_" + this._id], this._popup && !e && this._popup.close(), this._popup = null; }, t.prototype._checkForPopupClosed = function t() { this._popup && !this._popup.closed || this._error("Popup window closed"); }, t.prototype._callback = function t(e, r) { this._cleanup(r), e ? (i.Log.debug("PopupWindow.callback success"), this._success({ url: e })) : (i.Log.debug("PopupWindow.callback: Invalid response from popup"), this._error("Invalid response from popup")); }, t.notifyOpener = function t(e, r, n) { if (window.opener) {
                if (e = e || window.location.href) {
                    var s = o.UrlUtility.parseUrlFragment(e, n);
                    if (s.state) {
                        var a = "popupCallback_" + s.state, u = window.opener[a];
                        u ? (i.Log.debug("PopupWindow.notifyOpener: passing url message to opener"), u(e, r)) : i.Log.warn("PopupWindow.notifyOpener: no matching callback found on opener");
                    }
                    else
                        i.Log.warn("PopupWindow.notifyOpener: no state found in response url");
                }
            }
            else
                i.Log.warn("PopupWindow.notifyOpener: no window.opener. Can't complete notification."); }, n(t, [{ key: "promise", get: function t() { return this._promise; } }]), t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.IFrameNavigator = void 0; var n = r(0), i = r(46); e.IFrameNavigator = function () { function t() { !function e(t, r) { if (!(t instanceof r))
                throw new TypeError("Cannot call a class as a function"); }(this, t); } return t.prototype.prepare = function t(e) { var r = new i.IFrameWindow(e); return Promise.resolve(r); }, t.prototype.callback = function t(e) { n.Log.debug("IFrameNavigator.callback"); try {
                return i.IFrameWindow.notifyParent(e), Promise.resolve();
            }
            catch (t) {
                return Promise.reject(t);
            } }, t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.IFrameWindow = void 0; var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(), i = r(0); e.IFrameWindow = function () { function t(e) { var r = this; !function n(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), this._promise = new Promise(function (t, e) { r._resolve = t, r._reject = e; }), this._boundMessageEvent = this._message.bind(this), window.addEventListener("message", this._boundMessageEvent, !1), this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "absolute", this._frame.style.display = "none", this._frame.style.width = 0, this._frame.style.height = 0, window.document.body.appendChild(this._frame); } return t.prototype.navigate = function t(e) { if (e && e.url) {
                var r = e.silentRequestTimeout || 1e4;
                i.Log.debug("IFrameWindow.navigate: Using timeout of:", r), this._timer = window.setTimeout(this._timeout.bind(this), r), this._frame.src = e.url;
            }
            else
                this._error("No url provided"); return this.promise; }, t.prototype._success = function t(e) { this._cleanup(), i.Log.debug("IFrameWindow: Successful response from frame window"), this._resolve(e); }, t.prototype._error = function t(e) { this._cleanup(), i.Log.error(e), this._reject(new Error(e)); }, t.prototype.close = function t() { this._cleanup(); }, t.prototype._cleanup = function t() { this._frame && (i.Log.debug("IFrameWindow: cleanup"), window.removeEventListener("message", this._boundMessageEvent, !1), window.clearTimeout(this._timer), window.document.body.removeChild(this._frame), this._timer = null, this._frame = null, this._boundMessageEvent = null); }, t.prototype._timeout = function t() { i.Log.debug("IFrameWindow.timeout"), this._error("Frame window timed out"); }, t.prototype._message = function t(e) { if (i.Log.debug("IFrameWindow.message"), this._timer && e.origin === this._origin && e.source === this._frame.contentWindow) {
                var r = e.data;
                r ? this._success({ url: r }) : this._error("Invalid response from frame");
            } }, t.notifyParent = function t(e) { i.Log.debug("IFrameWindow.notifyParent"), window.frameElement && (e = e || window.location.href) && (i.Log.debug("IFrameWindow.notifyParent: posting url message to parent"), window.parent.postMessage(e, location.protocol + "//" + location.host)); }, n(t, [{ key: "promise", get: function t() { return this._promise; } }, { key: "_origin", get: function t() { return location.protocol + "//" + location.host; } }]), t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.UserManagerEvents = void 0; var n = r(0), i = r(16), o = r(17); e.UserManagerEvents = function (t) { function e(r) { !function n(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, e); var i = function s(t, e) { if (!t)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return !e || "object" != typeof e && "function" != typeof e ? t : e; }(this, t.call(this, r)); return i._userLoaded = new o.Event("User loaded"), i._userUnloaded = new o.Event("User unloaded"), i._silentRenewError = new o.Event("Silent renew error"), i._userSignedIn = new o.Event("User signed in"), i._userSignedOut = new o.Event("User signed out"), i._userSessionChanged = new o.Event("User session changed"), i; } return function r(t, e) { if ("function" != typeof e && null !== e)
                throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e); }(e, t), e.prototype.load = function e(r) { var i = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]; n.Log.debug("UserManagerEvents.load"), t.prototype.load.call(this, r), i && this._userLoaded.raise(r); }, e.prototype.unload = function e() { n.Log.debug("UserManagerEvents.unload"), t.prototype.unload.call(this), this._userUnloaded.raise(); }, e.prototype.addUserLoaded = function t(e) { this._userLoaded.addHandler(e); }, e.prototype.removeUserLoaded = function t(e) { this._userLoaded.removeHandler(e); }, e.prototype.addUserUnloaded = function t(e) { this._userUnloaded.addHandler(e); }, e.prototype.removeUserUnloaded = function t(e) { this._userUnloaded.removeHandler(e); }, e.prototype.addSilentRenewError = function t(e) { this._silentRenewError.addHandler(e); }, e.prototype.removeSilentRenewError = function t(e) { this._silentRenewError.removeHandler(e); }, e.prototype._raiseSilentRenewError = function t(e) { n.Log.debug("UserManagerEvents._raiseSilentRenewError", e.message), this._silentRenewError.raise(e); }, e.prototype.addUserSignedIn = function t(e) { this._userSignedIn.addHandler(e); }, e.prototype.removeUserSignedIn = function t(e) { this._userSignedIn.removeHandler(e); }, e.prototype._raiseUserSignedIn = function t() { n.Log.debug("UserManagerEvents._raiseUserSignedIn"), this._userSignedIn.raise(); }, e.prototype.addUserSignedOut = function t(e) { this._userSignedOut.addHandler(e); }, e.prototype.removeUserSignedOut = function t(e) { this._userSignedOut.removeHandler(e); }, e.prototype._raiseUserSignedOut = function t() { n.Log.debug("UserManagerEvents._raiseUserSignedOut"), this._userSignedOut.raise(); }, e.prototype.addUserSessionChanged = function t(e) { this._userSessionChanged.addHandler(e); }, e.prototype.removeUserSessionChanged = function t(e) { this._userSessionChanged.removeHandler(e); }, e.prototype._raiseUserSessionChanged = function t() { n.Log.debug("UserManagerEvents._raiseUserSessionChanged"), this._userSessionChanged.raise(); }, e; }(i.AccessTokenEvents); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.Timer = void 0; var n = function () { function t(t, e) { for (var r = 0; r < e.length; r++) {
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            } } return function (e, r, n) { return r && t(e.prototype, r), n && t(e, n), e; }; }(), i = r(0), o = r(1), s = r(17); e.Timer = function (t) { function e(r) { var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.Global.timer, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0; !function s(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, e); var a = function u(t, e) { if (!t)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return !e || "object" != typeof e && "function" != typeof e ? t : e; }(this, t.call(this, r)); return a._timer = n, a._nowFunc = i || function () { return Date.now() / 1e3; }, a; } return function r(t, e) { if ("function" != typeof e && null !== e)
                throw new TypeError("Super expression must either be null or a function, not " + typeof e); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e); }(e, t), e.prototype.init = function t(e) { e <= 0 && (e = 1), e = parseInt(e); var r = this.now + e; if (this.expiration === r && this._timerHandle)
                i.Log.debug("Timer.init timer " + this._name + " skipping initialization since already initialized for expiration:", this.expiration);
            else {
                this.cancel(), i.Log.debug("Timer.init timer " + this._name + " for duration:", e), this._expiration = r;
                var n = 5;
                e < n && (n = e), this._timerHandle = this._timer.setInterval(this._callback.bind(this), 1e3 * n);
            } }, e.prototype.cancel = function t() { this._timerHandle && (i.Log.debug("Timer.cancel: ", this._name), this._timer.clearInterval(this._timerHandle), this._timerHandle = null); }, e.prototype._callback = function e() { var r = this._expiration - this.now; i.Log.debug("Timer.callback; " + this._name + " timer expires in:", r), this._expiration <= this.now && (this.cancel(), t.prototype.raise.call(this)); }, n(e, [{ key: "now", get: function t() { return parseInt(this._nowFunc()); } }, { key: "expiration", get: function t() { return this._expiration; } }]), e; }(s.Event); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.SilentRenewService = void 0; var n = r(0); e.SilentRenewService = function () { function t(e) { !function r(t, e) { if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function"); }(this, t), this._userManager = e; } return t.prototype.start = function t() { this._callback || (this._callback = this._tokenExpiring.bind(this), this._userManager.events.addAccessTokenExpiring(this._callback), this._userManager.getUser().then(function (t) { }).catch(function (t) { n.Log.error("SilentRenewService.start: Error from getUser:", t.message); })); }, t.prototype.stop = function t() { this._callback && (this._userManager.events.removeAccessTokenExpiring(this._callback), delete this._callback); }, t.prototype._tokenExpiring = function t() { var e = this; this._userManager.signinSilent().then(function (t) { n.Log.debug("SilentRenewService._tokenExpiring: Silent token renewal successful"); }, function (t) { n.Log.error("SilentRenewService._tokenExpiring: Error from signinSilent:", t.message), e._userManager.events._raiseSilentRenewError(t); }); }, t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.CordovaPopupNavigator = void 0; var n = r(21); e.CordovaPopupNavigator = function () { function t() { !function e(t, r) { if (!(t instanceof r))
                throw new TypeError("Cannot call a class as a function"); }(this, t); } return t.prototype.prepare = function t(e) { var r = new n.CordovaPopupWindow(e); return Promise.resolve(r); }, t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }), e.CordovaIFrameNavigator = void 0; var n = r(21); e.CordovaIFrameNavigator = function () { function t() { !function e(t, r) { if (!(t instanceof r))
                throw new TypeError("Cannot call a class as a function"); }(this, t); } return t.prototype.prepare = function t(e) { e.popupWindowFeatures = "hidden=yes"; var r = new n.CordovaPopupWindow(e); return Promise.resolve(r); }, t; }(); }, function (t, e, r) { Object.defineProperty(e, "__esModule", { value: !0 }); e.Version = "1.10.1"; }]);
    });
});
unwrapExports(oidcClient_min);
var oidcClient_min_1 = oidcClient_min.UserManager;
var TelescopeClient = /** @class */ (function () {
    function TelescopeClient(environment) {
        this.environment = environment;
        this.src = environments[this.environment].telescope;
        var index = this.src.indexOf('systemId');
        this.systemId = this.src.substr(index).substr(9);
    }
    TelescopeClient.prototype.loadTelescopeScript = function () {
        return __awaiter(this, void 0, void 0, function () {
            var script;
            var _this_1 = this;
            return __generator(this, function (_g) {
                script = document.createElement('script');
                script.src = this.src;
                return [2 /*return*/, new Promise(function (resolve) {
                        if (script.readyState) {
                            script.onreadystatechange = function () {
                                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                                    script.onreadystatechange = null;
                                    _this_1.loaded = true;
                                    resolve(true);
                                }
                            };
                        }
                        else {
                            script.onload = function () {
                                _this_1.loaded = true;
                                resolve(true);
                            };
                        }
                        document.body.appendChild(script);
                    })];
            });
        });
    };
    TelescopeClient.prototype.trackEvent = function (event, data, systemId) {
        if (this.loaded) {
            rptracker.track(event, data, systemId || this.systemId);
        }
    };
    return TelescopeClient;
}());
var OmnibarShell = /** @class */ (function () {
    function class_15(hostRef) {
        var _this_1 = this;
        registerInstance(this, hostRef);
        this.viewportDimensions = null;
        this.navigation = true;
        this.auth = null;
        this.authErrorCallback = null;
        this.environment = null;
        this.servers = null;
        this.productCode = null;
        this.isUnifiedLogin = false;
        this.pageId = null;
        this.logoutUrl = null;
        this.followLogoutHref = true;
        this.silentRefreshUri = null;
        this.propertyId = null;
        this.productCenterShortName = null;
        this.navigationMinimized = JSON.parse(localStorage.getItem('navigation-minimized') || "true");
        this.apiConfig = {
            accessToken: null,
            authErrorCallback: function () { return window.location.href = environments[_this_1.environment].unityHome; },
            environment: this.environment,
            servers: {},
            productCode: 'REPLACEME',
            user: null,
            isUnifiedLogin: this.isUnifiedLogin,
            logoutUrl: this.logoutUrl,
            silentRefreshUri: this.silentRefreshUri
        };
        this.unityUser = {};
        this.unityProducts = null;
        this.unityResources = null;
        this.user = null;
        this.changeCompanyModalOpened = false;
        this.toggleNavigationState = function (_e, value) {
            if (value === void 0) { value = 'toggle'; }
            _this_1.navigationMinimized = (value === 'toggle') ? !_this_1.navigationMinimized : !value;
            localStorage.setItem('navigation-minimized', JSON.stringify(_this_1.navigationMinimized));
            _this_1.navigationToggle.emit({
                expanded: !_this_1.navigationMinimized
            });
            var body = document.querySelector('body');
            if (!_this_1.navigationMinimized && _this_1.screenSize == 'sm') {
                body.classList.add('no-scroll');
            }
            else {
                body.classList.remove('no-scroll');
            }
        };
        this.navigationToggle = createEvent(this, "navigationToggle", 7);
        this.omnibarChangePersona = createEvent(this, "omnibarChangePersona", 7);
        this.unityResourcesChange = createEvent(this, "unityResourcesChange", 7);
        this.platformAlertCountChange = createEvent(this, "platformAlertCountChange", 7);
    }
    class_15.prototype.componentWillLoad = function () {
        this.screenSize = getScreenSize();
        this.viewportDimensions = getViewportDimensions();
        if (this.environment === 'mock')
            this.auth = 'foo';
        this.apiConfig = {
            accessToken: this.auth || this.apiConfig.accessToken,
            authErrorCallback: this.authErrorCallback || this.apiConfig.authErrorCallback,
            environment: this.environment || this.apiConfig.environment,
            servers: this.servers || this.apiConfig.servers,
            productCode: this.productCode || this.apiConfig.productCode,
            user: this.user || this.apiConfig.user,
            isUnifiedLogin: this.isUnifiedLogin || this.apiConfig.isUnifiedLogin,
            logoutUrl: this.logoutUrl || this.apiConfig.logoutUrl,
            silentRefreshUri: this.silentRefreshUri || this.apiConfig.silentRefreshUri,
            postLogoutRedirectUri: this.postLogoutRedirectUri || this.apiConfig.postLogoutRedirectUri
        };
        this.createTelescopeClient();
    };
    class_15.prototype.componentDidLoad = function () {
        var _a;
        if (((_a = environments[this.environment]) === null || _a === void 0 ? void 0 : _a.telescope) && !this.isUnifiedLogin) {
            this.addTelescopeScript();
        }
        var headerHeight = this.headerRef.offsetHeight;
        this.pageWrapperRef.style.paddingTop = headerHeight + "px";
    };
    class_15.prototype.createTelescopeClient = function () {
        var _a;
        if (!this.apiConfig.environment) {
            console.warn('"environment" attribute is required for omnibar-shell');
            return;
        }
        if ((_a = environments[this.environment]) === null || _a === void 0 ? void 0 : _a.telescope) {
            this.telescopeClient = new TelescopeClient(this.apiConfig.environment);
        }
    };
    class_15.prototype.addTelescopeScript = function (user) {
        var _this_1 = this;
        if (!this.telescopeClient.loaded) {
            this.telescopeClient.loadTelescopeScript().then(function () {
                _this_1.trackPageViewedEvent(user);
            });
        }
        else {
            this.trackPageViewedEvent(user);
        }
    };
    class_15.prototype.handleUnityResourcesChange = function () {
        this.unityResourcesChange.emit({
            unityResources: this.unityResources
        });
    };
    class_15.prototype.handleReturnToHomePage = function () {
        window.location.href = environments[this.environment].unityHome;
    };
    class_15.prototype.handleOmnibarNotificationsAsideOpen = function (event) {
        this.selectedItem = event.detail.detail;
        this.notificationsAsideOpened = true;
    };
    class_15.prototype.handleOmnibarPlatformAlertAsideOpen = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.selectedItem = event.detail;
                this.platformAlertAsideOpened = true;
                return [2 /*return*/];
            });
        });
    };
    class_15.prototype.authErrorFetch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.apiClient.authErrorCallback();
                return [2 /*return*/];
            });
        });
    };
    class_15.prototype.reload = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_g) {
                this.apiConfig = Object.assign({}, this.apiConfig);
                if (this.unityUser) {
                    this.apiClient = createClient('unity', this.apiConfig);
                    this.apiClient.getUserProfile().then(function (profile) {
                        if (_this_1.apiConfig.environment && _this_1.apiConfig.environment !== 'local') {
                            _this_1.apiClient = createClient('notifications', _this_1.apiConfig);
                            _this_1.apiClient.getPlatformAlertProductTilesCount().then(function (resp) {
                                _this_1.platformAlertCountChange.emit({ platformAlertCount: resp });
                                Object.keys(profile.products).forEach(function (key) {
                                    _this_1.unityProducts[key].forEach(function (productItems) {
                                        if (!resp)
                                            return;
                                        var alerts = resp.find(function (alerts) { return alerts.productTileCode === productItems.productCode; });
                                        if (alerts) {
                                            productItems.alertsCount = alerts.alertCount;
                                        }
                                    });
                                });
                                profile.resources.forEach(function (productItems) {
                                    if (!resp)
                                        return;
                                    var alerts = resp.find(function (alerts) { return alerts.productTileCode === productItems.productCode; });
                                    if (alerts) {
                                        productItems.alertsCount = alerts.alertCount;
                                    }
                                });
                                _this_1.unityProducts = profile.products;
                                _this_1.unityResources = profile.resources;
                            });
                        }
                        _this_1.unityUser = profile.user;
                        _this_1.unityCompany = profile.user.companyName;
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    class_15.prototype.apiConfigChanged = function (newVal) {
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_g) {
                if (!newVal.environment || !newVal.isUnifiedLogin || !newVal.silentRefreshUri)
                    return [2 /*return*/];
                if (newVal.environment !== 'mock') {
                    if (!this.manager)
                        this.manager = new oidcClient_min_1(getClientSettings(this.apiConfig));
                    if (!this.user) {
                        this.manager.getUser().then(function (user) {
                            _this_1.user = user;
                        });
                        this.manager.events.addUserLoaded(function (user) {
                            // For future use
                            // if(!(this.user.profile.personaId === user.profile.personaId) && this.productCode !== "UL") alert('Persona Changed!')
                            _this_1.user = user;
                            _this_1.auth = _this_1.user.access_token;
                        });
                        this.manager.events.addUserSignedOut(function () {
                            if (_this_1.logoutUrl && _this_1.productCode !== 'UL') {
                                var ifrm = document.createElement('iframe');
                                ifrm.setAttribute('id', 'logoutFrame');
                                ifrm.setAttribute('style', 'visibility: hidden; position: absolute; display: none; width: 0px; height: 0px;');
                                ifrm.setAttribute('src', _this_1.logoutUrl);
                                document.body.appendChild(ifrm);
                                var loader = document.createElement('omnibar-page-loader');
                                document.body.appendChild(loader);
                                ifrm.onload = function () {
                                    var sessionkeys = Object.keys(sessionStorage);
                                    sessionkeys.forEach(function (s) {
                                        if (s.includes('oidc.user:'))
                                            sessionStorage.removeItem(s);
                                    });
                                    window.location.href = "" + environments[_this_1.environment].unityHome;
                                };
                            }
                            else {
                                if (_this_1.productCode !== 'UL')
                                    console.error('Omnibar Error: Products must provide a logout-url.');
                            }
                        });
                    }
                    if (!isLoggedIn(this.user)) {
                        this.manager.signinSilent().then(function (user) {
                            _this_1.user = user;
                            _this_1.auth = _this_1.user.access_token;
                        }).catch(function (error) {
                            console.warn(error);
                            // FOR DEBUGGING
                            // let rootPath = `${window.location.protocol}//${window.location.host}`
                            // window.location.href = rootPath == 'http://localhost:4200' ? `${rootPath}/logout` : `${environments[this.environment].unityHome}/logout`
                            _this_1.manager.signoutRedirect();
                        });
                    }
                }
                else {
                    this.auth = 'foo';
                }
                return [2 /*return*/];
            });
        });
    };
    class_15.prototype.authChanged = function (newVal) {
        var _this_1 = this;
        this.apiConfig = Object.assign(Object.assign({}, this.apiConfig), { accessToken: newVal });
        if (this.unityUser) {
            this.apiClient = createClient('unity', this.apiConfig);
            this.apiClient.getUserProfile().then(function (profile) {
                var _a;
                if (((_a = environments[_this_1.environment]) === null || _a === void 0 ? void 0 : _a.telescope) && Object.keys(_this_1.unityUser).length === 0) {
                    _this_1.addTelescopeScript(profile.user); // track only on initial load
                }
                _this_1.apiClient = createClient('notifications', _this_1.apiConfig);
                if (_this_1.apiConfig.environment && _this_1.apiConfig.environment !== 'local') {
                    _this_1.apiClient.getPlatformAlertProductTilesCount().then(function (resp) {
                        _this_1.platformAlertCountChange.emit({ platformAlertCount: resp });
                        Object.keys(profile.products).forEach(function (key) {
                            profile.products[key].forEach(function (productItems) {
                                if (!resp)
                                    return;
                                var alerts = resp.find(function (alerts) { return alerts.productTileCode === productItems.productCode; });
                                if (alerts) {
                                    productItems.alertsCount = alerts.alertCount;
                                }
                            });
                        });
                        profile.resources.forEach(function (productItems) {
                            if (!resp)
                                return;
                            var alerts = resp.find(function (alerts) { return alerts.productTileCode === productItems.productCode; });
                            if (alerts) {
                                productItems.alertsCount = alerts.alertCount;
                            }
                        });
                        _this_1.unityProducts = profile.products;
                        _this_1.unityResources = profile.resources;
                    });
                }
                _this_1.unityUser = profile.user;
                _this_1.unityCompany = profile.user.companyName;
            });
        }
    };
    class_15.prototype.logoutUrlChanged = function (newVal) {
        this.apiConfig = Object.assign(Object.assign({}, this.apiConfig), { logoutUrl: newVal });
    };
    class_15.prototype.silentRefreshUriChanged = function (newVal) {
        this.apiConfig = Object.assign(Object.assign({}, this.apiConfig), { silentRefreshUri: newVal });
    };
    class_15.prototype.postLogoutRedirectUriChanged = function (newVal) {
        this.apiConfig = Object.assign(Object.assign({}, this.apiConfig), { postLogoutRedirectUri: newVal });
    };
    class_15.prototype.authErrorCallbackChanged = function (newVal) {
        this.apiConfig = Object.assign(Object.assign({}, this.apiConfig), { authErrorCallback: newVal });
    };
    class_15.prototype.environmentChanged = function (newVal) {
        var _a;
        this.apiConfig = Object.assign(Object.assign({}, this.apiConfig), { environment: newVal });
        this.createTelescopeClient();
        if (((_a = environments[this.environment]) === null || _a === void 0 ? void 0 : _a.telescope) && !this.isUnifiedLogin) {
            this.addTelescopeScript();
        }
    };
    class_15.prototype.isUnifiedLoginChanged = function (newVal) {
        this.apiConfig = Object.assign(Object.assign({}, this.apiConfig), { isUnifiedLogin: newVal });
    };
    class_15.prototype.serversChanged = function (newVal) {
        this.apiConfig = Object.assign(Object.assign({}, this.apiConfig), { servers: newVal });
    };
    class_15.prototype.productCodeChanged = function (newVal) {
        this.apiConfig = Object.assign(Object.assign({}, this.apiConfig), { productCode: newVal });
    };
    class_15.prototype.propertyIdChanged = function (newVal) {
        this.propertyId = newVal;
    };
    class_15.prototype.productCenterShortNameChanged = function (newVal) {
        this.productCenterShortName = newVal;
    };
    class_15.prototype.logoutRedirectUrlChanged = function (newVal) {
        this.logoutRedirectUrl = newVal;
    };
    class_15.prototype.handleHelpTrackEvent = function (info) {
        var _a, _b;
        if ((_a = environments[this.environment]) === null || _a === void 0 ? void 0 : _a.telescope) {
            var _g = info.detail, event = _g.event, data = _g.data;
            var oidcClientData = this.getOidcClientData();
            var eventData = Object.assign({
                user_name: ((_b = this.unityUser) === null || _b === void 0 ? void 0 : _b.fullName) || document.querySelector('omnibar-unified-menu').getAttribute('user-name'),
                date_time: new Date(),
                company_master_id: oidcClientData ? oidcClientData.profile.orgCompanyMasterId : null,
                org_name: oidcClientData ? oidcClientData.profile.orgName : null,
                link_name: '',
                link_url: '',
                property_id: this.propertyId || null,
                product_name: this.productCode === 'ACCT' ? 'Accounting' : (document.querySelector('omnibar-scope').getAttribute('product') || null),
            }, data);
            this.telescopeClient.trackEvent(event, eventData, environments[this.environment].telescopeHelpSystemId);
        }
    };
    class_15.prototype.handleTrackClickEvent = function (e) {
        var _a, _b, _c;
        if ((_a = environments[this.environment]) === null || _a === void 0 ? void 0 : _a.telescope) {
            var _g = e.detail, button_name = _g.button_name, user = _g.user;
            var user_name = user || ((_b = this.unityUser) === null || _b === void 0 ? void 0 : _b.fullName);
            if (!user_name) { // if event is coming from scope selector, the user info can be not available
                user_name = document.querySelector('omnibar-unified-menu').getAttribute('user-name');
            }
            var oidcClientData = this.getOidcClientData();
            var omnibarScope = document.querySelector('omnibar-scope');
            var isOmnibarScopeMulti = omnibarScope.hasAttribute('multiple');
            var property_name = isOmnibarScopeMulti ? 'Multi Properties' : ((_c = omnibarScope.querySelector('omnibar-select')) === null || _c === void 0 ? void 0 : _c.value) || null;
            var eventData = {
                user_name: user_name,
                button_name: button_name,
                company_master_id: oidcClientData ? oidcClientData.profile.orgCompanyMasterId : null,
                org_name: oidcClientData ? oidcClientData.profile.orgName : null,
                page_url: window.location.href,
                unified_login: this.apiConfig.isUnifiedLogin,
                product_name: this.productCode === 'ACCT' ? 'Accounting' : (document.querySelector('omnibar-scope').getAttribute('product') || null),
                product_center_short_name: this.productCenterShortName,
                property_name: property_name
            };
            this.telescopeClient.trackEvent('Button Clicked', eventData);
        }
    };
    class_15.prototype.trackPageViewedEvent = function (userProfile) {
        var _a;
        var isUnifiedLogin = this.apiConfig.isUnifiedLogin;
        var oidcClientData = this.getOidcClientData();
        var product_name = this.productCode === 'ACCT' ? 'Accounting' : (document.querySelector('omnibar-scope').getAttribute('product') || null);
        var user_name = ((_a = userProfile) === null || _a === void 0 ? void 0 : _a.fullName) || document.querySelector('omnibar-unified-menu').getAttribute('user-name');
        var eventData = {
            user_name: user_name,
            company_master_id: oidcClientData ? oidcClientData.profile.orgCompanyMasterId : null,
            org_name: oidcClientData ? oidcClientData.profile.orgName : null,
            page_url: window.location.href,
            unified_login: isUnifiedLogin,
            product_name: product_name,
            product_center_short_name: this.productCenterShortName
        };
        this.telescopeClient.trackEvent('Omnibar Initialized', eventData);
    };
    class_15.prototype.closeNavigation = function (e) {
        this.toggleNavigationState(e, false);
    };
    class_15.prototype.setNavigationTheme = function (_g) {
        var value = _g.detail.value;
        this.navigationDark = value;
    };
    class_15.prototype.handleResize = function () {
        this.screenSize = getScreenSize();
        this.viewportDimensions = getViewportDimensions();
    };
    class_15.prototype.handleUserChangeCompany = function (event) {
        this.changeCompanyModalOpened = true;
        this.changeCompanyPersonaId = event.detail;
    };
    class_15.prototype.handleCloseChangeCompanyModal = function () {
        this.changeCompanyModalOpened = false;
    };
    class_15.prototype.handleChangePersona = function (event) {
        this.omnibarChangePersona.emit(event.detail);
    };
    class_15.prototype.handleUnifiedLogout = function () {
        var _this_1 = this;
        if (this.logoutUrl) {
            var ifrm = document.createElement('iframe');
            ifrm.setAttribute('id', 'logoutFrame');
            ifrm.setAttribute('style', 'visibility: hidden; position: absolute; display: none; width: 0px; height: 0px;');
            ifrm.setAttribute('src', this.logoutUrl);
            document.body.appendChild(ifrm);
            var loader = document.createElement('omnibar-page-loader');
            document.body.appendChild(loader);
            ifrm.onload = function () {
                var sessionkeys = Object.keys(sessionStorage);
                sessionkeys.forEach(function (s) {
                    if (s.includes('oidc.user:'))
                        sessionStorage.removeItem(s);
                });
                _this_1.manager.signoutRedirect();
            };
        }
        else {
            console.error('Omnibar Error: Products must provide a logout-url.');
        }
    };
    class_15.prototype.getOidcClientData = function () {
        return Object.keys(sessionStorage).map(function (_item, i) {
            var key = sessionStorage.key(i);
            if (key.startsWith('oidc.user')) {
                return JSON.parse(sessionStorage.getItem(key));
            }
        })[0];
    };
    class_15.prototype.hostData = function () {
        // For RAUL2 in-page components compatibility
        return {
            'class': { 'raul-left-navigation-expanded': !this.navigationMinimized },
        };
    };
    class_15.prototype.handleKeyDown = function (e) {
        if (e.key === 'Enter') {
            if (this.navigationMinimized) {
                this.toggleNavigationState(e, true);
                if (document.querySelector('a.item-button')) {
                    //@ts-ignore
                    document.querySelector('a.item-button').focus();
                }
            }
            else {
                this.toggleNavigationState(e, false);
            }
        }
    };
    class_15.prototype.handleNavigationKeyDown = function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
            this.toggleNavigationState(e, false);
            this.hamburgerIconRef.focus();
        }
    };
    class_15.prototype.__stencil_render = function () {
        var _this_1 = this;
        var tunnelState = {
            api: this.apiConfig,
            authenticated: !!this.auth,
            unityUser: this.unityUser,
            unityProducts: this.unityProducts,
            unityResources: this.unityResources,
            unityCompany: this.unityCompany,
            screenSize: this.screenSize,
            pageId: this.pageId,
            navigation: this.navigation,
            navigationMinimized: this.navigationMinimized,
            navigationDark: this.navigationDark,
            viewportDimensions: this.viewportDimensions,
            followLogoutHref: this.followLogoutHref,
            propertyId: this.propertyId,
            productCenterShortName: this.productCenterShortName,
            favoriteItems: this.productCode === 'BI' || this.apiConfig.productCode === 'BI',
            productCode: this.productCode || this.apiConfig.productCode,
            logoutUrl: this.logoutUrl || this.apiConfig.logoutUrl
        };
        return (h(ShellTunnel.Provider, { state: tunnelState }, h("div", { class: {
                'o-omnibar-shell': true,
                'o-omnibar-shell--no-navigation': !this.navigation
            } }, h("div", { class: "o-omnibar" }, this.navigation &&
            h("div", { class: "o-navigation-toggle", onClick: this.toggleNavigationState, role: "button", "aria-label": "toggle", tabindex: "0", "aria-pressed": !this.navigationMinimized, onKeyDown: function (e) { return _this_1.handleKeyDown(e); }, ref: function (el) { return _this_1.hamburgerIconRef = el; } }, h("omnibar-icon", { icon: "omnibar-hamburger" })), h("div", { class: "o-logo" }, h("img", { src: "https://cdn.realpage.com/images/rp-logo-dots.svg" })), h("slot", { name: "scope" }), h("slot", { name: "search" }), h("slot", { name: "unified-menu" })), h("div", { class: "o-main" }, h("div", { class: "o-navigation", onKeyDown: function (e) { return _this_1.handleNavigationKeyDown(e); } }, h("slot", { name: "navigation" })), h("div", { class: "o-page" }, h("div", { class: "o-header", ref: function (el) { return _this_1.headerRef = el; } }, h("slot", { name: "header" })), h("div", { ref: function (el) { return _this_1.pageWrapperRef = el; }, class: "o-page-wrapper" }, h("slot", { name: "page" }))))), this.platformAlertAsideOpened &&
            h("omnibar-product-alerts", { opened: this.platformAlertAsideOpened, selectedItem: this.selectedItem, onOmnibarPlatformAlertsAsideClose: function () { return _this_1.platformAlertAsideOpened = false; } }), this.notificationsAsideOpened &&
            h("omnibar-unified-notifications-aside", { opened: this.notificationsAsideOpened, selectedItem: this.selectedItem, onOmnibarNotificationsAsideClose: function () { return _this_1.notificationsAsideOpened = false; } }), this.changeCompanyModalOpened &&
            h("omnibar-change-company-modal", { "persona-id": this.changeCompanyPersonaId })));
    };
    Object.defineProperty(class_15.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_15, "watchers", {
        get: function () {
            return {
                "unityResources": ["handleUnityResourcesChange"],
                "apiConfig": ["apiConfigChanged"],
                "auth": ["authChanged"],
                "logoutUrl": ["logoutUrlChanged"],
                "silentRefreshUri": ["silentRefreshUriChanged"],
                "postLogoutRedirectUri": ["postLogoutRedirectUriChanged"],
                "authErrorCallback": ["authErrorCallbackChanged"],
                "environment": ["environmentChanged"],
                "isUnifiedLogin": ["isUnifiedLoginChanged"],
                "servers": ["serversChanged"],
                "productCode": ["productCodeChanged"],
                "propertyId": ["propertyIdChanged"],
                "productCenterShortName": ["productCenterShortNameChanged"],
                "logoutRedirectUrl": ["logoutRedirectUrlChanged"]
            };
        },
        enumerable: true,
        configurable: true
    });
    class_15.prototype.render = function () { return h(Host, this.hostData(), this.__stencil_render()); };
    Object.defineProperty(class_15, "style", {
        get: function () { return ".o-omnibar{-ms-flex-align:stretch;align-items:stretch;position:fixed;width:100%;height:56px;min-height:56px;color:#fff;background:#37474f;z-index:1040}.o-omnibar,.o-omnibar>*,.o-omnibar>* slot{display:-ms-flexbox;display:flex}.o-omnibar>* slot{-ms-flex-align:stretch;align-items:stretch}.o-omnibar .o-navigation-toggle{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;min-width:53px;cursor:pointer;font-size:1rem}.o-omnibar .o-navigation-toggle:hover{background:rgba(0,0,0,.2)}.o-omnibar .o-navigation-toggle:focus{outline:none;background:rgba(0,0,0,.2)}.o-omnibar .o-navigation-toggle .o-omnibar-icon{height:1.2em;width:1.2em}.o-omnibar .o-logo{padding:0 .625rem}.o-omnibar .o-logo img{height:56px;width:24px;min-width:24px}\@media (max-width:576px){.o-omnibar .o-logo{display:none}}.o-omnibar omnibar-scope{-webkit-box-flex:1;-ms-flex:1;flex:1}.o-omnibar omnibar-search{justify-self:flex-end}.o-omnibar omnibar-unified-menu{margin-left:auto}omnibar-shell{display:block!important}.o-omnibar-shell{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.o-omnibar-shell.no-scroll{overflow:hidden}.o-omnibar-shell .o-main{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;top:56px;position:relative}.o-omnibar-shell .o-main .o-header{position:fixed;width:100%;right:0;z-index:50;-webkit-transition:width .35s,-webkit-transform .35s;transition:width .35s,-webkit-transform .35s;transition:width .35s,transform .35s;transition:width .35s,transform .35s,-webkit-transform .35s}\@media (min-width:768px){.o-omnibar-shell .o-main .o-header{width:calc(100% - 53px)}.raul-left-navigation-expanded .o-omnibar-shell .o-main .o-header{width:calc(100% - 300px)}}.o-omnibar-shell .o-main .o-navigation{z-index:1040}.raul-left-navigation-expanded .o-omnibar-shell .o-main .o-navigation{z-index:1030}.o-omnibar-shell .o-main .o-page{-webkit-box-flex:1;-ms-flex:1;flex:1;height:100%;min-width:0}.o-omnibar-shell .o-main .o-page .o-page-wrapper--padded{padding-top:44px}.o-omnibar-shell .o-main .o-page .o-page-wrapper [slot=page]{display:block;height:100%}\@media (min-width:768px){.o-omnibar-shell .o-main .o-page .o-page-wrapper [slot=page]{padding-left:53px;-webkit-transition:padding-left .35s;transition:padding-left .35s}.raul-left-navigation-expanded .o-omnibar-shell .o-main .o-page .o-page-wrapper [slot=page]{padding-left:300px}}\@media (min-width:768px){.o-omnibar-shell--no-navigation .o-main .o-header{width:100%;-webkit-transition:none;transition:none}.o-omnibar-shell--no-navigation .o-main .o-page .o-page-wrapper [slot=page]{padding-left:0;-webkit-transition:none;transition:none}}"; },
        enumerable: true,
        configurable: true
    });
    return class_15;
}());
var OmnibarSimpleSelect = /** @class */ (function () {
    function OmnibarSimpleSelect(hostRef) {
        registerInstance(this, hostRef);
        this.inputId = "omnibar-select-" + selectIds++;
    }
    OmnibarSimpleSelect.prototype.render = function () {
        return (h("div", { class: {
                'o-form-element': true,
                'o-form-element--invalid': !!this.error
            } }, this.label && h("label", { class: "o-form-element__label", htmlFor: this.inputId }, this.label), h("div", { class: "o-form-element__control" }, h("slot", null), h("omnibar-icon", { class: "o-form-element__control__arrow", icon: "arrow-down-v" })), this.hint && h("small", { class: "o-form-element__hint" }, this.hint), this.error &&
            h("div", { class: "o-form-element__error" }, h("omnibar-icon", { icon: "interface-alert-diamond", class: "o-form-element__error__icon" }), " ", this.error)));
    };
    Object.defineProperty(OmnibarSimpleSelect.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OmnibarSimpleSelect, "style", {
        get: function () { return "omnibar-simple-select{display:block;font-size:.875rem}omnibar-simple-select .o-form-element{text-align:left}omnibar-simple-select .o-form-element__control{position:relative}omnibar-simple-select .o-form-element__control select{border-width:1px;border-color:#c6ccd0;display:block;font-size:1rem;height:2.5rem;padding-left:.75rem;padding-right:2rem;width:100%;-webkit-appearance:none;-moz-appearance:none;appearance:none;position:relative;background-color:transparent;z-index:10;border-radius:var(--raul-input-border-radius,.125rem);color:var(--raul-input-color,#37474f)}omnibar-simple-select .o-form-element__control select::-webkit-input-placeholder{color:#9ba3a7;opacity:1}omnibar-simple-select .o-form-element__control select::-moz-placeholder{color:#9ba3a7;opacity:1}omnibar-simple-select .o-form-element__control select:-ms-input-placeholder{color:#9ba3a7;opacity:1}omnibar-simple-select .o-form-element__control select::-ms-input-placeholder{color:#9ba3a7;opacity:1}omnibar-simple-select .o-form-element__control select::placeholder{color:#9ba3a7;opacity:1}omnibar-simple-select .o-form-element__control select[disabled]{background-color:#ebedee;border-color:#ebedee;color:#9ba3a7;cursor:not-allowed}omnibar-simple-select .o-form-element__control select:focus{border-color:#0076cc;outline:0}omnibar-simple-select .o-form-element__control select:invalid{border-color:#d01a1f}omnibar-simple-select .o-form-element__control select::-ms-expand{display:none}\@media (min-width:1024px){omnibar-simple-select .o-form-element__control select{font-size:.875rem}}omnibar-simple-select .o-form-element__control__arrow{position:absolute;font-size:1rem;color:#9ba3a7;right:.75rem;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}omnibar-simple-select .o-form-element__label{display:inline-block;font-weight:500;font-size:.75rem;margin-bottom:.25rem}omnibar-simple-select .o-form-element__hint{display:block;font-size:.75rem;margin-top:.5rem}omnibar-simple-select .o-form-element__error{display:-ms-flexbox;display:flex;font-size:.75rem;-ms-flex-align:center;align-items:center;color:#d01a1f;margin-top:.5rem}omnibar-simple-select .o-form-element__error__icon{font-size:1rem;margin-right:.25rem}omnibar-simple-select .o-form-element--invalid select{border-color:#d01a1f}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarSimpleSelect;
}());
var selectIds = 0;
var OmnibarStatus = /** @class */ (function () {
    function OmnibarStatus(hostRef) {
        registerInstance(this, hostRef);
        /**
         * Status variant.
         */
        this.variant = 'default';
    }
    OmnibarStatus.prototype.componentDidLoad = function () {
        this.title = this.statusTextEl.textContent;
    };
    OmnibarStatus.prototype.render = function () {
        var _g;
        var _this_1 = this;
        return (h("div", { class: (_g = {
                    'o-status': true
                },
                _g["o-status--" + this.variant] = this.variant !== 'default',
                _g) }, h("div", { class: "o-status__text", title: this.title, ref: function (el) { return _this_1.statusTextEl = el; } }, h("slot", null))));
    };
    Object.defineProperty(OmnibarStatus, "style", {
        get: function () { return "omnibar-status{display:inline-block;max-width:100%}omnibar-status .o-status{position:relative;display:-ms-flexbox;display:flex;background-color:#ebedee;font-size:.75rem;font-weight:500;color:#37474f;text-align:left;line-height:1.25;border-radius:.125rem;padding-left:.5rem;padding-right:.5rem;padding-top:.25rem;padding-bottom:.25rem;max-width:100%}omnibar-status .o-status--destructive{background-color:#fae8e9;color:#d01a1f}omnibar-status .o-status--success{background-color:#e7f3eb;color:#139c3e}omnibar-status .o-status--warning{background-color:#fef8ea;color:#bc8701}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarStatus;
}());
var OmnibarSwitch = /** @class */ (function () {
    function class_16(hostRef) {
        var _this_1 = this;
        registerInstance(this, hostRef);
        this.labelPosition = "before";
        this.spaceBetween = false;
        this.value = false;
        this.controlled = false;
        this.toggleValue = function () {
            _this_1.omnibarChange.emit({ value: !_this_1.value });
            if (!_this_1.controlled)
                _this_1.value = !_this_1.value;
        };
        this.omnibarChange = createEvent(this, "omnibarChange", 7);
    }
    class_16.prototype.toggle = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.toggleValue();
                return [2 /*return*/];
            });
        });
    };
    class_16.prototype.render = function () {
        var _this_1 = this;
        var renderLabel = function (pos) {
            return (h("label", { class: "o-switch__label--" + pos }, _this_1.label));
        };
        var renderToggle = function () {
            return (h("div", { class: classnames('o-switch', {
                    'o-switch--checked': _this_1.value,
                }) }, h("div", { class: "o-switch__track" }, h("div", { class: "o-switch__knob" }))));
        };
        return (h("div", { class: classnames('o-switch__container', { 'o-switch__container--space-between': this.spaceBetween }), onClick: function () { return _this_1.toggleValue(); } }, this.labelPosition === 'before' && renderLabel(this.labelPosition), renderToggle(), this.labelPosition === 'after' && renderLabel(this.labelPosition)));
    };
    Object.defineProperty(class_16, "style", {
        get: function () { return "omnibar-switch{display:block}omnibar-switch .o-switch__container{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;cursor:pointer}omnibar-switch .o-switch__container--space-between{-ms-flex-pack:justify;justify-content:space-between}omnibar-switch .o-switch__container label{margin:0}omnibar-switch .o-switch__container label.o-switch__label--before{margin-right:.5rem}omnibar-switch .o-switch__container label.o-switch__label--after{margin-left:.5rem}omnibar-switch .o-switch__container .o-switch{position:relative}omnibar-switch .o-switch__container .o-switch .o-switch__track{width:2rem}omnibar-switch .o-switch__container .o-switch .o-switch__knob,omnibar-switch .o-switch__container .o-switch .o-switch__track{background-color:#fff;border-width:2px;border-color:#c6ccd0;height:1.25rem;border-radius:9999px;-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out}omnibar-switch .o-switch__container .o-switch .o-switch__knob{position:absolute;left:0;top:0;width:1.25rem}omnibar-switch .o-switch__container .o-switch.o-switch--checked .o-switch__track{background-color:#139c3e;border-color:#139c3e}omnibar-switch .o-switch__container .o-switch.o-switch--checked .o-switch__knob{border-color:#139c3e;-webkit-transform:translateX(.75rem);transform:translateX(.75rem)}omnibar-switch .o-switch__container slot{display:none}"; },
        enumerable: true,
        configurable: true
    });
    return class_16;
}());
var OmnibarTabs = /** @class */ (function () {
    function OmnibarTabs(hostRef) {
        registerInstance(this, hostRef);
        /**
         * An array of objects representing the navigation.
         */
        this.tabs = [];
        this.omnibarTabChange = createEvent(this, "omnibarTabChange", 7);
    }
    OmnibarTabs.prototype.connectedCallback = function () {
        this.xsDevice = window.innerWidth < 640;
    };
    OmnibarTabs.prototype.handleResize = function () {
        this.xsDevice = window.innerWidth < 640;
    };
    OmnibarTabs.prototype.selectOptions = function () {
        return this.tabs.reduce(function (acc, cv) {
            acc = __spreadArrays(acc, [{ value: cv.name, text: cv.label }]);
            return acc;
        }, []);
    };
    OmnibarTabs.prototype.handleClick = function (tabName) {
        this.omnibarTabChange.emit(tabName);
    };
    OmnibarTabs.prototype.handleOmnibarChange = function (e) {
        this.omnibarTabChange.emit(e.detail.value);
    };
    OmnibarTabs.prototype.render = function () {
        var _this_1 = this;
        if (!(this.selectOnMobile && this.xsDevice)) {
            return (h("div", { class: "o-tabs", role: "tablist" }, h("div", { class: "o-tabs__list" }, this.tabs.map(function (item) {
                return (h("button", { role: "tab", class: {
                        'o-tabs__item': true,
                        'o-tabs__item--active': item.name === _this_1.activeTab,
                        'o-tabs__item--disabled': item.disabled
                    }, id: item.name + "-tab", disabled: item.disabled, "aria-controls": item.id || item.name, "aria-selected": item.name === _this_1.activeTab, onClick: function () { return _this_1.handleClick(item.name); } }, item.label));
            }))));
        }
        else {
            return (h("omnibar-select", { options: this.selectOptions(), value: this.activeTab, onOmnibarChange: function (e) { return _this_1.handleOmnibarChange(e); } }));
        }
    };
    Object.defineProperty(OmnibarTabs, "style", {
        get: function () { return "omnibar-tabs{display:block}.o-tabs{font-size:.875rem!important;border-bottom-width:1px!important;border-color:#ebedee!important;height:2.5rem!important;overflow:hidden!important}.o-tabs__list{display:-ms-flexbox!important;display:flex!important;overflow-x:auto!important;height:4rem!important}.o-tabs__list button:focus{outline:0!important}.o-tabs__item{-ms-flex:none!important;flex:none!important;font-size:.875rem!important;font-weight:600!important;border-bottom-width:2px!important;border-color:transparent!important;height:2.5rem!important;padding-left:1rem!important;padding-right:1rem!important;margin-top:-1px!important;padding-top:1px!important}.o-tabs__item:focus{outline:0}.o-tabs__item:focus,.o-tabs__item:hover{border-color:#c6ccd0}.o-tabs__item.o-tabs__item--active{border-color:#0076cc!important}.o-tabs__item.o-tabs__item--disabled{color:#9ba3a7;pointer-events:none}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarTabs;
}());
var OmnibarThemeToggle = /** @class */ (function () {
    function OmnibarThemeToggle(hostRef) {
        var _this_1 = this;
        registerInstance(this, hostRef);
        this.active = JSON.parse(localStorage.getItem('navigation-dark')) || false;
        this.handleChange = function (e) {
            e.stopPropagation();
            _this_1.active = e.detail.value;
            _this_1.darkThemeToggle.emit({
                value: e.detail.value
            });
            localStorage.setItem('navigation-dark', JSON.stringify(_this_1.active));
        };
        this.handleKeyPress = function (e) {
            if (e.key === 'Enter') {
                // @ts-ignore
                _this_1.omnibarSwitchRef.toggle();
            }
        };
        this.darkThemeToggle = createEvent(this, "darkThemeToggle", 7);
    }
    OmnibarThemeToggle.prototype.componentWillLoad = function () {
        this.darkThemeToggle.emit({
            value: this.active
        });
    };
    OmnibarThemeToggle.prototype.render = function () {
        var _this_1 = this;
        return (h("div", { role: "button", tabindex: 0, class: "omnibar-theme-toggle", onKeyPress: function (e) { return _this_1.handleKeyPress(e); }, "aria-label": "theme-toggle" }, h("omnibar-switch", { onOmnibarChange: this.handleChange, label: "Dark Navigation", "label-position": "before", "space-between": "true", value: this.active, ref: function (el) { return _this_1.omnibarSwitchRef = el; } })));
    };
    Object.defineProperty(OmnibarThemeToggle, "style", {
        get: function () { return ".o-omnibar .omnibar-theme-toggle{font-size:.75rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:43px;padding:0 15px;padding-right:10px;border-bottom:1px solid #e4e6e7}.o-omnibar .omnibar-theme-toggle omnibar-switch{width:100%}.o-omnibar .omnibar-theme-toggle omnibar-switch .o-switch__container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.o-omnibar .omnibar-theme-toggle:focus{outline:none;background-color:#e5f4ff}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarThemeToggle;
}());
var OmnibarTooltip = /** @class */ (function () {
    function class_17(hostRef) {
        registerInstance(this, hostRef);
        this.tooltipId = "omnibar-tooltip-" + tooltipIds++;
        this.popper = null;
        this.text = '';
        this.placement = 'top';
        this.disabledHoverListener = false;
        this.disabledFocusListener = false;
    }
    class_17.prototype.handleMouseEnter = function () {
        if (!this.disabledHoverListener) {
            this.show();
        }
    };
    class_17.prototype.handleMouseLeave = function () {
        if (!this.disabledHoverListener) {
            this.hide();
        }
    };
    class_17.prototype.handleFocusIn = function () {
        if (!this.disabledFocusListener) {
            this.show();
        }
    };
    class_17.prototype.handleFocusOut = function () {
        if (!this.disabledFocusListener) {
            this.hide();
        }
    };
    class_17.prototype.show = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.createTooltip();
                return [2 /*return*/];
            });
        });
    };
    class_17.prototype.hide = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.removeTooltip();
                return [2 /*return*/];
            });
        });
    };
    class_17.prototype.tooltipRef = function () {
        return document.getElementById(this.tooltipId);
    };
    class_17.prototype.tooltipArrowRef = function () {
        return this.tooltipRef().querySelector('.o-tooltip__arrow');
    };
    class_17.prototype.tooltipElement = function () {
        var tooltipTemplate = "\n      <div class=\"o-tooltip\" id=\"" + this.tooltipId + "\" role=\"tooltip\">\n        <div class=\"o-tooltip__arrow\"></div>\n        \n        <div class=\"o-tooltip__content\">\n          " + this.text + "        \n        </div>\n      </div>\n    ";
        return new DOMParser().parseFromString(tooltipTemplate, 'text/html').body.firstChild;
    };
    class_17.prototype.popperOptions = function () {
        return {
            placement: this.placement,
            modifiers: {
                arrow: {
                    element: this.tooltipArrowRef()
                },
                preventOverflow: {
                    enabled: false
                },
                hide: {
                    enabled: false
                }
            }
        };
    };
    class_17.prototype.createTooltip = function () {
        if (!this.popper) {
            document.body.appendChild(this.tooltipElement());
            this.tooltipRef().classList.add('o-tooltip--show');
            this.popper = new Popper(this.el, this.tooltipRef(), this.popperOptions());
        }
    };
    class_17.prototype.removeTooltip = function () {
        var _this_1 = this;
        if (this.popper) {
            var transitionDuration = parseFloat(getComputedStyle(this.tooltipRef()).transitionDuration) * 1000;
            this.tooltipRef().classList.remove('o-tooltip--show');
            setTimeout(function () {
                _this_1.tooltipRef().parentNode.removeChild(_this_1.tooltipRef());
                _this_1.popper.destroy();
                _this_1.popper = null;
            }, transitionDuration);
        }
    };
    class_17.prototype.render = function () {
        return (h("slot", null));
    };
    Object.defineProperty(class_17.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_17, "style", {
        get: function () { return "omnibar-tooltip{display:inline-block;vertical-align:middle;font-size:.875rem}.o-tooltip{background-color:#37474f;color:#fff;font-size:.75rem;padding:.75rem;border-radius:.125rem;-webkit-box-shadow:0 16px 27px 0 rgba(82,97,115,.22);box-shadow:0 16px 27px 0 rgba(82,97,115,.22);opacity:0;-webkit-transition:opacity .15s linear;transition:opacity .15s linear;z-index:50;max-width:16rem;z-index:10000}.o-tooltip__arrow{height:0;width:0;border-color:transparent;position:absolute;border-width:.5rem}.o-tooltip--show{opacity:1}.o-tooltip[x-placement^=top]{margin-bottom:.75rem}.o-tooltip[x-placement^=top] .o-tooltip__arrow{border-bottom-width:0;margin-bottom:-.5rem;bottom:0;border-top-color:#37474f}.o-tooltip[x-placement^=bottom]{margin-top:.75rem}.o-tooltip[x-placement^=bottom] .o-tooltip__arrow{border-top-width:0;margin-top:-.5rem;top:0;border-bottom-color:#37474f}.o-tooltip[x-placement^=right]{margin-left:.75rem}.o-tooltip[x-placement^=right] .o-tooltip__arrow{border-left-width:0;margin-left:-.5rem;left:0;border-right-color:#37474f}.o-tooltip[x-placement^=left]{margin-right:.75rem}.o-tooltip[x-placement^=left] .o-tooltip__arrow{border-right-width:0;margin-right:-.5rem;right:0;border-left-color:#37474f}.o-tooltip[x-placement^=bottom-end] .o-tooltip__arrow,.o-tooltip[x-placement^=top-end] .o-tooltip__arrow{left:auto!important;right:.5rem!important}.o-tooltip[x-placement^=bottom-start] .o-tooltip__arrow,.o-tooltip[x-placement^=top-start] .o-tooltip__arrow{left:.5rem!important;right:auto!important}.o-tooltip[x-placement^=left-start] .o-tooltip__arrow,.o-tooltip[x-placement^=right-start] .o-tooltip__arrow{top:.5rem!important;bottom:auto!important}.o-tooltip[x-placement^=left-end] .o-tooltip__arrow,.o-tooltip[x-placement^=right-end] .o-tooltip__arrow{top:auto!important;bottom:.5rem!important}"; },
        enumerable: true,
        configurable: true
    });
    return class_17;
}());
var tooltipIds = 0;
function createHelpToast(toastData, trackingFunc, refreshFunc) {
    var action = toastData.action, title = toastData.title, body = toastData.body, yesText = toastData.yesText, noText = toastData.noText, type = toastData.type, url = toastData.url, _g = toastData.items, items = _g === void 0 ? [] : _g;
    var createToast = window.OMNIBAR.commands.toast;
    var toast = createToast({
        tagName: 'omnibar-toast',
        timeout: 20000,
        origin: 'Help',
        avatar: 'https://cdn.realpage.com/images/resources/simon-orange.svg',
        heading: title,
        body: body,
        status: true,
        actions: [
            {
                label: 'no',
                text: noText
            },
            {
                label: 'yes',
                text: yesText
            },
        ],
    });
    toast.addEventListener('omnibarToastAction', function () { return toast.dismiss(); });
    if (action === 'Show') {
        toast.addEventListener('omnibarToastAction', function (e) {
            if (e.detail !== 'yes')
                return;
            helpMenu().open();
        });
    }
    if (action === 'Open' && type === 'ReleaseNotes') {
        toast.addEventListener('omnibarToastAction', function (e) {
            if (e.detail !== 'yes')
                return;
            trackingFunc('ReleaseNotes', items).then(function () {
                refreshFunc();
            });
            window.open(url, '_blank');
        });
    }
}
function helpMenu() {
    return document.querySelector('omnibar-unified-menu-item[menu-name=Help]');
}
var OmnibarUnifiedHelp = /** @class */ (function () {
    function class_18(hostRef) {
        registerInstance(this, hostRef);
        this.authenticated = false;
        this.helpQuery = null;
        this.helpPageUrl = null;
        // OneSite specific params
        this.helpPm = null;
        this.helpSi = null;
        this.helpCs = null;
        this.simonEnabled = false;
        this.badgeCount = 0;
        this.videos = null;
        this.releaseNotes = null;
        this.onlineHelp = null;
        this.knowledgeBase = null;
        this.helpCenter = null;
        this.displayedToast = false;
        this.trackHelpEvent = createEvent(this, "trackHelpEvent", 7);
    }
    class_18.prototype.apiConfigChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                // TODO: REMOVE AFTER DEMO
                if (!this.api.environment)
                    return [2 /*return*/];
                // Make API calls here
                this.apiClient = createClient('help', this.api);
                this.load();
                return [2 /*return*/];
            });
        });
    };
    class_18.prototype.helpQueryChanged = function () {
        this.hasLoaded() ? this.loadOnlineHelpOnly() : this.load();
    };
    class_18.prototype.onMenuClick = function (ev) {
        return __awaiter(this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!(ev.detail.name === 'Help')) return [3 /*break*/, 2];
                        if (!(this.badgeCount > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiClient.viewedHelpDropdown()];
                    case 1:
                        resp = _g.sent();
                        this.badgeCount = resp.badgeCount;
                        _g.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    class_18.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resp, _g, enabled, badgeCount, videos, releaseNotes, onlineHelp, knowledgeBase, all;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        // TODO: REMOVE AFTER DEMO
                        if (!this.demo && this.disabled || !this.apiClient)
                            return [2 /*return*/];
                        if (!this.helpQuery)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.apiClient.getHelpMenuData(Object.assign({ onlineHelpQuery: this.helpQuery }, this.oneSiteParams()))];
                    case 1:
                        resp = _h.sent();
                        _g = resp ? resp : '', enabled = _g.enabled, badgeCount = _g.badgeCount, videos = _g.videos, releaseNotes = _g.releaseNotes, onlineHelp = _g.onlineHelp, knowledgeBase = _g.knowledgeBase, all = _g.all;
                        this.simonEnabled = enabled;
                        this.badgeCount = badgeCount;
                        this.videos = videos;
                        this.releaseNotes = releaseNotes;
                        this.onlineHelp = onlineHelp;
                        this.knowledgeBase = knowledgeBase;
                        this.helpCenter = all;
                        return [2 /*return*/];
                }
            });
        });
    };
    class_18.prototype.loadOnlineHelpOnly = function () {
        return __awaiter(this, void 0, void 0, function () {
            var onlineHelp;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        // TODO: REMOVE AFTER DEMO
                        if (!this.demo && this.disabled || !this.apiClient)
                            return [2 /*return*/];
                        if (!this.helpQuery)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.apiClient.getHelpMenuData(Object.assign({
                                onlineHelpQuery: this.helpQuery,
                                include: 'onlinehelp',
                            }, this.oneSiteParams()))];
                    case 1:
                        onlineHelp = (_g.sent()).onlineHelp;
                        this.onlineHelp = onlineHelp;
                        return [2 /*return*/];
                }
            });
        });
    };
    class_18.prototype.hasLoaded = function () {
        return this.videos || this.releaseNotes || this.knowledgeBase || this.helpCenter;
    };
    class_18.prototype.maybeDisplayToast = function (toastData) {
        if (this.displayedToast || !toastData)
            return;
        createHelpToast(toastData, this.apiClient.trackViewed, this.load.bind(this));
        this.displayedToast = true;
    };
    class_18.prototype.handleVideoWatched = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var _g, video, progress;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        _g = e.detail, video = _g.video, progress = _g.progress;
                        return [4 /*yield*/, this.apiClient.trackVideoProgress(video, progress)];
                    case 1:
                        _h.sent();
                        this.load();
                        return [2 /*return*/];
                }
            });
        });
    };
    class_18.prototype.handleUpdateView = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var update;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        update = e.detail.update;
                        if (!this.authenticated) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiClient.trackViewed('ReleaseNotes', [update])];
                    case 1:
                        _g.sent();
                        this.load();
                        _g.label = 2;
                    case 2:
                        this.trackHelpEvent.emit({
                            event: 'Product Updates Clicked',
                            data: {
                                link_name: update.title,
                                link_url: update.url
                            }
                        });
                        this.unifiedMenuItemEl.close();
                        return [2 /*return*/];
                }
            });
        });
    };
    class_18.prototype.handleUpdateViewAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!this.releaseNotes)
                            return [2 /*return*/];
                        if (!this.authenticated) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiClient.trackViewed('ReleaseNotes', this.releaseNotes.items || [])];
                    case 1:
                        _g.sent();
                        this.load();
                        _g.label = 2;
                    case 2:
                        this.trackHelpEvent.emit({
                            event: 'Product Updates Clicked',
                            data: {
                                link_name: 'View All',
                                link_url: this.releaseNotes && this.releaseNotes.url
                            }
                        });
                        this.unifiedMenuItemEl.close();
                        return [2 /*return*/];
                }
            });
        });
    };
    class_18.prototype.handleOmnibarVideoPlay = function () {
        this.unifiedMenuItemEl.close();
    };
    class_18.prototype.onlineHelpUrl = function () {
        return this.helpPageUrl || (this.api.environment ? environments[this.api.environment]['helpUri'] + "/?" + this.helpQuery : "http://onesitehelp.realpage.com/?" + this.helpQuery);
    };
    class_18.prototype.oneSiteParams = function () {
        return {
            pm: this.helpPm,
            si: this.helpSi,
            cs: this.helpCs,
        };
    };
    class_18.prototype.render = function () {
        var _this_1 = this;
        var renderUnifiedHelp = function () {
            return (h("omnibar-unified-menu-item", { "badge-count": _this_1.badgeCount, "menu-name": "Help", icon: "omnibar-help", ref: function (el) { return _this_1.unifiedMenuItemEl = el; } }, _this_1.releaseNotes && h("omnibar-unified-help-updates", { updates: _this_1.releaseNotes }), _this_1.onlineHelp && h("omnibar-unified-help-articles", { articles: _this_1.onlineHelp }), h("omnibar-unified-help-videos", { video: _this_1.videos }), h("omnibar-unified-help-knowledgebase", { kb: _this_1.knowledgeBase }), h("omnibar-unified-help-center", { hc: _this_1.helpCenter })));
        };
        var renderOldOnlineHelp = function () {
            return (h("omnibar-unified-menu-item", { url: _this_1.onlineHelpUrl(), target: "_unifiedHelp", "menu-name": "Help", icon: "omnibar-help" }));
        };
        var renderNavItem = function () {
            // TODO: REMOVE AFTER DEMO
            return _this_1.simonEnabled || _this_1.demo ? renderUnifiedHelp() : renderOldOnlineHelp();
        };
        return (h("div", { class: {
                'o-omnibar-unified-help': true,
                'o-demo': this.demo,
            } }, renderNavItem()));
    };
    Object.defineProperty(class_18.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_18, "watchers", {
        get: function () {
            return {
                "api": ["apiConfigChanged"],
                "helpQuery": ["helpQueryChanged"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_18, "style", {
        get: function () { return ".o-omnibar-unified-help{height:100%}.o-omnibar-unified-help .o-omnibar-unified-help-articles,.o-omnibar-unified-help .o-omnibar-unified-help-updates,.o-omnibar-unified-help .o-omnibar-unified-help-videos{border-bottom:1px solid #e4e6e7}.o-omnibar-unified-help .o-omnibar-unified-help-center #help-center{font-size:.875rem;color:#0076cc;text-align:center;display:block}.o-omnibar-unified-help.o-demo .o-item-status,.o-omnibar-unified-help.o-demo .o-item-statusless{display:none!important}.o-omnibar-unified-help.o-demo .o-item-text{padding-left:15px!important}.o-omnibar-unified-help .o-section{min-width:350px}.o-omnibar-unified-help .o-section .o-header{display:-ms-flexbox;display:flex;padding-top:1.5rem;padding-bottom:.75rem;padding-left:1rem;padding-right:1rem;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;background-color:#f7f8f9}.o-omnibar-unified-help .o-section .o-header .o-title{font-size:.75rem;font-weight:500}.o-omnibar-unified-help .o-section .o-header .o-all-link{font-size:.75rem;color:#0076cc;text-decoration:none}.o-omnibar-unified-help .o-section .o-body .o-item-row{display:-ms-flexbox;display:flex;cursor:pointer;text-decoration:none;border-bottom:1px solid #e4e6e7}.o-omnibar-unified-help .o-section .o-body .o-item-row:first-child{border-top:1px solid #e4e6e7}.o-omnibar-unified-help .o-section .o-body .o-item-row:last-child{border-bottom:0}.o-omnibar-unified-help .o-section .o-body .o-item-row:visited{color:#e4e6e7}.o-omnibar-unified-help .o-section .o-body .o-item-row .o-item-status{margin-left:.75rem;margin-right:.75rem;background-color:transparent;border-radius:9999px;margin-top:1rem;width:9px;height:9px}.o-omnibar-unified-help .o-section .o-body .o-item-row .o-item-status.o-is-unread{background:#f65216}.o-omnibar-unified-help .o-section .o-body .o-item-row .o-item-statusless{margin-right:20px}.o-omnibar-unified-help .o-section .o-body .o-item-row .o-item-text{font-size:.75rem;padding-top:.75rem;padding-bottom:.75rem;-webkit-box-flex:1;-ms-flex:1;flex:1;color:#303436}.o-omnibar-unified-help .o-section .o-body .o-item-row .o-item-text .o-item-title{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;font-weight:500;color:#303436}.o-omnibar-unified-help .o-section .o-body .o-item-row .o-item-text .o-item-title .o-item-action{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;color:#f65216}.o-omnibar-unified-help .o-section .o-body .o-item-row .o-item-text .o-item-title .o-item-action omnibar-icon{font-size:.875rem;margin-right:15px}.o-omnibar-unified-help .o-section .o-body .o-item-row .o-item-text .o-item-title .o-item-action .o-item-action-text{font-weight:700;margin-right:5px}.o-unified-help__videos__modal .o-modal__overlay .o-modal__container{padding:0}.o-unified-help__videos__modal__header{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;background-color:#f06000;color:#fff;font-size:1.25rem;font-weight:600;line-height:1.25;margin-bottom:.5rem;padding:1rem;margin-bottom:0}.o-unified-help__videos__modal__body{padding:2rem}"; },
        enumerable: true,
        configurable: true
    });
    return class_18;
}());
ShellTunnel.injectProps(OmnibarUnifiedHelp, ['api', 'pageId', 'authenticated']);
var OmnibarUnifiedHelpArticles = /** @class */ (function () {
    function OmnibarUnifiedHelpArticles(hostRef) {
        registerInstance(this, hostRef);
        this.articles = null;
        this.trackHelpEvent = createEvent(this, "trackHelpEvent", 7);
        this.closeUnifiedMenuDropdown = createEvent(this, "closeUnifiedMenuDropdown", 7);
    }
    OmnibarUnifiedHelpArticles.prototype.articleClick = function (article) {
        var _a, _b;
        this.trackHelpEvent.emit({
            event: 'Online Help Clicked',
            data: {
                link_name: ((_a = article) === null || _a === void 0 ? void 0 : _a.title) || 'View All',
                link_url: ((_b = article) === null || _b === void 0 ? void 0 : _b.url) || (this.articles && this.articles.url)
            }
        });
        this.closeUnifiedMenuDropdown.emit();
    };
    OmnibarUnifiedHelpArticles.prototype.render = function () {
        var _this_1 = this;
        return (h("div", { class: "o-omnibar-unified-help-articles" }, h("div", { class: "o-section" }, h("div", { class: "o-header o-cursor-default" }, h("div", { class: "o-title" }, this.articles && this.articles.title), h("a", { class: "o-all-link", href: this.articles && this.articles.url, target: "_blank", onClick: function () { return _this_1.articleClick(); } }, "View All")), h("div", { class: "o-body" }, this.articles && this.articles.items && this.articles.items.map(function (article) { return (h("a", { class: "o-item-row", href: article.url, target: "_blank", onClick: function () { return _this_1.articleClick(article); } }, h("div", { class: "o-item-status" }), h("div", { class: "o-item-text" }, h("div", { class: "o-item-desc", innerHTML: article.title })))); })))));
    };
    return OmnibarUnifiedHelpArticles;
}());
var OmnibarUnifiedHelpCenter = /** @class */ (function () {
    function OmnibarUnifiedHelpCenter(hostRef) {
        registerInstance(this, hostRef);
        this.hc = null;
        this.trackHelpEvent = createEvent(this, "trackHelpEvent", 7);
        this.closeUnifiedMenuDropdown = createEvent(this, "closeUnifiedMenuDropdown", 7);
    }
    OmnibarUnifiedHelpCenter.prototype.render = function () {
        var _this_1 = this;
        if (!this.hc)
            return null;
        return (h("div", { class: "o-omnibar-unified-help-center" }, h("div", { class: "o-section" }, h("div", { class: "o-body" }, h("a", { class: "o-item-row", href: this.hc.url, target: "_blank", onClick: function () {
                _this_1.trackHelpEvent.emit({
                    event: 'More Simon Content Clicked',
                    data: {
                        link_name: _this_1.hc.title,
                        link_url: _this_1.hc.url
                    }
                });
                _this_1.closeUnifiedMenuDropdown.emit();
            } }, h("div", { class: "o-item-text" }, h("div", { class: "o-item-title", id: "help-center" }, this.hc.title)))))));
    };
    return OmnibarUnifiedHelpCenter;
}());
var OmnibarUnifiedHelpKnowledgebase = /** @class */ (function () {
    function OmnibarUnifiedHelpKnowledgebase(hostRef) {
        registerInstance(this, hostRef);
        this.kb = null;
        this.trackHelpEvent = createEvent(this, "trackHelpEvent", 7);
        this.closeUnifiedMenuDropdown = createEvent(this, "closeUnifiedMenuDropdown", 7);
    }
    OmnibarUnifiedHelpKnowledgebase.prototype.render = function () {
        var _this_1 = this;
        if (!this.kb)
            return null;
        return (h("div", { class: "o-omnibar-unified-help-knowledgebase" }, h("div", { class: "o-section" }, h("div", { class: "o-header o-cursor-default" }, h("div", { class: "o-title" }, this.kb.title), h("a", { href: this.kb.url, class: "o-all-link", target: "_blank", onClick: function () {
                _this_1.trackHelpEvent.emit({
                    event: 'Knowledge Base Clicked',
                    data: {
                        link_name: 'View All',
                        link_url: _this_1.url
                    }
                });
                _this_1.closeUnifiedMenuDropdown.emit();
            } }, "View All")))));
    };
    return OmnibarUnifiedHelpKnowledgebase;
}());
var OmnibarUnifiedHelpUpdates = /** @class */ (function () {
    function OmnibarUnifiedHelpUpdates(hostRef) {
        registerInstance(this, hostRef);
        this.updates = null;
        this.updateView = createEvent(this, "updateView", 7);
        this.updateViewAll = createEvent(this, "updateViewAll", 7);
    }
    OmnibarUnifiedHelpUpdates.prototype.render = function () {
        var _this_1 = this;
        return (h("div", { class: "o-omnibar-unified-help-updates" }, h("div", { class: "o-section" }, h("div", { class: "o-header o-cursor-default" }, h("div", { class: "o-title" }, this.updates && this.updates.title), h("a", { class: "o-all-link", href: this.updates && this.updates.url, target: "_blank", onClick: this.updateViewAll.emit }, "View All")), h("div", { class: "o-body" }, this.updates && this.updates.items && this.updates.items.map(function (update) { return (h("a", { class: "o-item-row", href: update.url, target: "_blank", onClick: function () { return _this_1.updateView.emit({ update: update }); } }, h("div", { class: {
                'o-item-status': true,
                'o-is-unread': !update.isViewed,
            } }), h("div", { class: "o-item-text" }, h("div", { class: "o-item-title" }, update.title), h("div", { class: "o-item-desc" }, update.subTitle)))); })))));
    };
    return OmnibarUnifiedHelpUpdates;
}());
var OmnibarUnifiedHelpVideos = /** @class */ (function () {
    function OmnibarUnifiedHelpVideos(hostRef) {
        registerInstance(this, hostRef);
        this.video = null;
        this.trackHelpEvent = createEvent(this, "trackHelpEvent", 7);
        this.closeUnifiedMenuDropdown = createEvent(this, "closeUnifiedMenuDropdown", 7);
    }
    OmnibarUnifiedHelpVideos.prototype.render = function () {
        var _this_1 = this;
        if (!this.video)
            return null;
        return (h("div", { class: "o-omnibar-unified-help-videos" }, h("div", { class: "o-section" }, h("div", { class: "o-header" }, h("div", { class: "o-title" }, this.video.title), h("a", { href: this.video.url, class: "o-all-link", target: "_blank", onClick: function () {
                _this_1.trackHelpEvent.emit({
                    event: 'Videos Clicked',
                    data: {
                        link_name: 'View All',
                        link_url: _this_1.video.url
                    }
                });
                _this_1.closeUnifiedMenuDropdown.emit();
            } }, "View All")))));
    };
    return OmnibarUnifiedHelpVideos;
}());
var UserTunnel = createProviderConsumer({}, function (subscribe, child) { return (h("context-consumer", { subscribe: subscribe, renderer: child })); });
function clearSession() {
    sessionStorage.clear();
}
function guessInitials(name) {
    if (name === void 0) { name = ''; }
    var names = name.split(' '), firstInitial = names[0].substring(0, 1), lastInitial = names[names.length - 1].substring(0, 1);
    return names.length > 1 ? firstInitial + lastInitial : firstInitial;
}
var OmnibarUnifiedMenu = /** @class */ (function () {
    function class_19(hostRef) {
        var _this_1 = this;
        registerInstance(this, hostRef);
        this.activeUserMenu = false;
        this.profile = null;
        this.manager = null;
        this.canChangeCompany = false;
        this.toggleActiveUserMenu = function () {
            _this_1.unifiedMenuClick.emit({
                name: "User Menu",
            });
            _this_1.activeUserMenu = !_this_1.activeUserMenu;
            var body = document.querySelector('body');
            if (_this_1.activeUserMenu && !['lg', 'xl'].includes(_this_1.screenSize)) {
                _this_1.forceCloseNavigation.emit();
                body.classList.add('no-scroll');
            }
            if (!_this_1.activeUserMenu && !['lg', 'xl'].includes(_this_1.screenSize)) {
                body.classList.remove('no-scroll');
            }
        };
        this.forceCloseNavigation = createEvent(this, "forceCloseNavigation", 7);
        this.unifiedMenuClick = createEvent(this, "unifiedMenuClick", 7);
        this.omnibarLogout = createEvent(this, "omnibarLogout", 7);
        this.omnibarUnifiedLogout = createEvent(this, "omnibarUnifiedLogout", 7);
        this.trackClickEvent = createEvent(this, "trackClickEvent", 7);
        this.userChangeCompany = createEvent(this, "userChangeCompany", 7);
    }
    class_19.prototype.handleUnifiedMenuClick = function (e) {
        var name = e.detail.name;
        if (name) {
            this.trackClickEvent.emit({
                button_name: name,
                user: this.userName
            });
        }
    };
    class_19.prototype.apiConfigChanged = function () {
        this.profile = this.api.user;
        this.manager = this.api.manager;
    };
    class_19.prototype.closeUserMenu = function () {
        return __awaiter(this, void 0, void 0, function () {
            var body;
            return __generator(this, function (_g) {
                this.activeUserMenu = false;
                body = document.querySelector('body');
                if (!['lg', 'xl'].includes(this.screenSize))
                    body.classList.remove('no-scroll');
                return [2 /*return*/];
            });
        });
    };
    class_19.prototype.moveToUserMenu = function (node) {
        this.userMenuDropdownRef.insertBefore(node, this.userMenuDropdownRef.firstElementChild);
    };
    class_19.prototype.moveToIconMenu = function (node) {
        this.iconMenuRef.insertBefore(node, this.iconMenuRef.querySelector('[id="oSwitcher"]').nextSibling);
    };
    class_19.prototype.logOutUser = function () {
        if (this.api.isUnifiedLogin && !(this.api.productCode == 'UL' || this.api.productCode == 'VMP')) {
            this.omnibarUnifiedLogout.emit();
        }
        else {
            if (this.followLogoutHref == false) {
                this.omnibarLogout.emit({
                    logoutUrl: this.api.logoutUrl
                });
                this.closeUserMenu();
            }
            else {
                window.location.href = this.api.logoutUrl;
            }
        }
    };
    class_19.prototype.resetMenu = function (e) {
        if (!['lg', 'xl'].includes(this.screenSize))
            return;
        if (e.target.matches('omnibar-unified-menu-item')) {
            this.activeUserMenu = false;
        }
    };
    class_19.prototype.closeUserMenuIfActive = function (e) {
        if (e.type === 'keydown' && e.key === 'Escape'
            || e.type === 'click' && !e.target.closest('omnibar-unified-menu')) {
            this.closeUserMenu();
        }
    };
    class_19.prototype.handleScreenSizeChange = function (size) {
        var _this_1 = this;
        if (this.didLoad) {
            switch (size) {
                case 'sm':
                    this.responsiveMenuItems.forEach(function (node) { return _this_1.moveToUserMenu(node); });
                    break;
                case 'md':
                    this.responsiveMenuItems.forEach(function (node) { return _this_1.moveToIconMenu(node); });
                    break;
                case 'lg':
                    this.responsiveMenuItems.forEach(function (node) { return _this_1.moveToIconMenu(node); });
                    break;
            }
        }
    };
    class_19.prototype.componentDidLoad = function () {
        this.didLoad = true;
        this.responsiveMenuItems = Array.from(document.querySelectorAll("\n      .o-icon-menu >\n        :not(#oSwitcher), \n      .o-user__dropdown-menu > .flex >\n        :not([slot=user]):not(omnibar-theme-toggle):not(.o-user__logout-link)\n    "));
    };
    class_19.prototype.launchChangeCompanyModal = function () {
        this.userChangeCompany.emit(this.unityUser.personaId);
        this.closeUserMenu();
    };
    class_19.prototype.render = function () {
        var _this_1 = this;
        var userName = this.unityUser && this.unityUser.fullName || this.userName, userTitle = this.unityUser && this.unityUser.title || this.userTitle;
        var userTunnelState = {
            userName: userName,
            userTitle: userTitle
        };
        var renderUserChangeCompanyLink = function () {
            return (h("a", { onClick: function () { return _this_1.launchChangeCompanyModal(); } }, h("omnibar-user-menu-item", { "menu-name": "Change Company" }, "Change Company")));
        };
        var renderLogout = function () {
            return (h("a", { onClick: function () { return _this_1.logOutUser(); } }, h("omnibar-user-menu-item", { "menu-name": "Log Out" }, "Log Out")));
        };
        var renderUserMenuDropdown = function () {
            return (h("div", { class: "o-user__dropdown-menu" }, h("div", { class: "o-flex o-flex-wrap", ref: function (el) { return _this_1.userMenuDropdownRef = el; } }, (_this_1.screenSize == 'sm') && [
                h("div", { id: "oHelp", class: "o-icon-menu__help" }, h("slot", { name: "help" })),
                h("div", { id: "oNotifications", class: "o-icon-menu__notifications" }, h("slot", { name: "notifications" })),
                h("div", { id: "oCustomItems", class: "o-icon-menu__custom" }, h("slot", null)),
                h("div", { id: "oSettings", class: "o-icon-menu__settings" }, h("slot", { name: "settings" })),
                h("div", { id: "oVendors", class: "o-icon-menu__vendors" }, h(UserTunnel.Provider, { state: userTunnelState }, h("slot", { name: "vendors" }))),
            ]), h("slot", { name: "user" }), _this_1.unityUser && _this_1.unityUser.hasMultiCompany ? renderUserChangeCompanyLink() : null, _this_1.navigation && h("omnibar-theme-toggle", { onClick: function () { return _this_1.unifiedMenuClick.emit({
                    name: "Theme toggle",
                }); } }), h("div", { onClick: clearSession, class: "o-user__logout-link" }, _this_1.api.isUnifiedLogin || _this_1.api.logoutUrl ? renderLogout() : null)));
        };
        var renderUserMenu = function () {
            return (h("div", { class: {
                    'o-user': true,
                    'o-user--active': _this_1.activeUserMenu
                } }, h("button", { type: "button", class: "o-user__info", "aria-haspopup": "true", "aria-expanded": _this_1.activeUserMenu ? 'true' : 'false', onClick: _this_1.toggleActiveUserMenu }, h("div", { class: "o-user__identity" }, h("div", { class: "o-user__name" }, userName), h("div", { class: "o-user__title" }, userTitle)), h("div", { class: "o-user__avatar" }, guessInitials(userName)), h("div", { class: "o-user__close" }, h("omnibar-icon", { icon: "close" }))), renderUserMenuDropdown()));
        };
        return (h("div", { class: {
                'o-unified-menu': true,
                'o-unified-menu--unauthenticated': !this.authenticated
            } }, h("div", { class: "o-icon-menu", ref: function (el) { return _this_1.iconMenuRef = el; } }, h("div", { id: "oSwitcher", class: "o-icon-menu__switcher" }, h("slot", { name: "switcher" })), (this.screenSize != 'sm') && [
            h("div", { id: "oCustomItems", class: "o-icon-menu__custom" }, h("slot", null)),
            h("div", { id: "oSettings", class: "o-icon-menu__settings" }, h("slot", { name: "settings" })),
            h("div", { id: "oVendors", class: "o-icon-menu__vendors" }, h(UserTunnel.Provider, { state: userTunnelState }, h("slot", { name: "vendors" }))),
            h("div", { id: "oNotifications", class: "o-icon-menu__notifications" }, h("slot", { name: "notifications" })),
            h("div", { id: "oHelp", class: "o-icon-menu__help" }, h("slot", { name: "help" })),
        ]), renderUserMenu()));
    };
    Object.defineProperty(class_19.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_19, "watchers", {
        get: function () {
            return {
                "api": ["apiConfigChanged"],
                "screenSize": ["handleScreenSizeChange"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_19, "style", {
        get: function () { return ".o-omnibar .o-user{position:relative;height:100%;cursor:pointer}.o-omnibar .o-user,.o-omnibar .o-user__info{font-size:.75rem;display:-webkit-box;display:-ms-flexbox;display:flex}.o-omnibar .o-user__info{line-height:1.25;-ms-flex-align:center;background-color:transparent;border:0;color:inherit;margin:0;outline:none;padding:0;text-align:left;-webkit-box-align:center;align-items:center;text-align:right;padding:0 14px;width:auto}.o-omnibar .o-user__info:focus,.o-omnibar .o-user__info:hover{background:rgba(0,0,0,.2)}.o-omnibar .o-user__identity{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-right:10px;margin-left:10px;margin-top:3px;text-align:right}.o-omnibar .o-user__name{font-weight:700}.o-omnibar .o-user__title{color:hsla(0,0%,100%,.6)}.o-omnibar .o-user__avatar{font-size:.875rem;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;background-color:#0076cc;padding-top:1px;font-weight:500;letter-spacing:1px;width:32px;min-width:32px;height:32px;border-radius:50%}.o-omnibar .o-user__close{display:none}.o-omnibar .o-user__dropdown-menu{-webkit-box-shadow:0 8px 16px 0 rgba(82,97,115,.18);box-shadow:0 8px 16px 0 rgba(82,97,115,.18);display:none;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;color:#303436;position:absolute;top:56px;right:0;z-index:2147483647;min-width:250px;background:#fff;max-height:calc(100vh - 56px);overflow-y:auto}.o-omnibar .o-user--active .o-user__info{background:#0076cc;width:100%}.o-omnibar .o-user--active .o-user__info .o-user__identity{opacity:1}.o-omnibar .o-user--active .o-user__info .o-user__avatar{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;background:#fff;color:#0076cc}.o-omnibar .o-user--active .o-user__dropdown-menu{display:-webkit-box;display:-ms-flexbox;display:flex;opacity:1;-webkit-transition:all .3s ease;transition:all .3s ease}.o-omnibar .o-user button:focus{outline:0}\@media (max-width:767px){.o-omnibar .o-user{max-width:60px;min-width:60px;-webkit-transition:all .3s ease;transition:all .3s ease}.o-omnibar .o-user__identity{display:none}.o-omnibar .o-user__dropdown-menu{position:fixed;left:100vw;bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;opacity:0}.o-omnibar .o-user--active,.o-omnibar .o-user__dropdown-menu{right:0;-webkit-transition:all .3s ease;transition:all .3s ease}.o-omnibar .o-user--active{z-index:20;position:absolute;width:100vw;max-width:100vw;min-width:100vw;height:56px;background:#0076cc}.o-omnibar .o-user--active .o-user__identity{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2;text-align:left;display:inline-block}.o-omnibar .o-user--active .o-user__close{display:inline-block;font-size:1rem;cursor:pointer;margin-left:auto;-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}.o-omnibar .o-user--active .o-user__dropdown-menu{left:0}}.o-omnibar .o-unified-menu,.o-omnibar .o-unified-menu .o-icon-menu{display:-webkit-box;display:-ms-flexbox;display:flex;height:100%}.o-omnibar .o-unified-menu .o-icon-menu__switcher{-ms-flex-order:-9999;order:-9999}.o-omnibar .o-unified-menu .o-icon-menu__custom{-ms-flex-order:3;order:3;width:100%}\@media (min-width:1024px){.o-omnibar .o-unified-menu .o-icon-menu__custom{-ms-flex-order:2;order:2;width:auto;display:-ms-flexbox;display:flex}}.o-omnibar .o-unified-menu .o-icon-menu__settings{-ms-flex-order:4;order:4;width:100%}\@media (min-width:768px){.o-omnibar .o-unified-menu .o-icon-menu__settings{-ms-flex-order:3;order:3;width:auto}}.o-omnibar .o-unified-menu .o-icon-menu__vendor{-ms-flex-order:5;order:5;width:100%}\@media (min-width:768px){.o-omnibar .o-unified-menu .o-icon-menu__vendor{-ms-flex-order:4;order:4;width:auto}}.o-omnibar .o-unified-menu .o-icon-menu__notifications{-ms-flex-order:2;order:2;width:100%}\@media (min-width:1024px){.o-omnibar .o-unified-menu .o-icon-menu__notifications{-ms-flex-order:5;order:5;width:auto}}.o-omnibar .o-unified-menu .o-icon-menu__help{-ms-flex-order:-9999;order:-9999;width:100%}\@media (min-width:1024px){.o-omnibar .o-unified-menu .o-icon-menu__help{-ms-flex-order:6;order:6;width:auto}}.o-omnibar .o-unified-menu .o-icon-menu omnibar-unified-menu-item{height:100%}.o-omnibar .o-unified-menu .o-icon-menu .omnibar-unified-menu-item{width:47px}.o-omnibar .o-unified-menu omnibar-unified-switcher [slot=unauthenticated]{display:none}.o-omnibar .o-unified-menu--unauthenticated omnibar-unified-switcher [slot=unauthenticated]{display:block}"; },
        enumerable: true,
        configurable: true
    });
    return class_19;
}());
ShellTunnel.injectProps(OmnibarUnifiedMenu, ['screenSize', 'api', 'authenticated', 'navigation', 'unityUser', 'followLogoutHref']);
var OmnibarUnifiedMenuItem = /** @class */ (function () {
    function class_20(hostRef) {
        var _this_1 = this;
        registerInstance(this, hostRef);
        this.iconKind = "icon";
        this.badgeCount = 0;
        this.notButton = false;
        this.target = "_self";
        this.active = false;
        this.toggleActive = function () {
            var previousActiveState = _this_1.active;
            _this_1.unifiedMenuClick.emit({
                name: previousActiveState === false ? _this_1.menuName : null,
            });
            _this_1.active = !previousActiveState;
            if (_this_1.active) {
                _this_1.calculateDropdownPosition();
            }
            else {
                _this_1.dropdownPosition = {};
            }
        };
        this.handleKeyPress = function (e) {
            if (e.key === 'Enter') {
                _this_1.toggleActive();
            }
        };
        this.unifiedMenuClick = createEvent(this, "unifiedMenuClick", 7);
    }
    class_20.prototype.open = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.active = false;
                this.toggleActive();
                return [2 /*return*/];
            });
        });
    };
    class_20.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                this.active = true;
                this.toggleActive();
                return [2 /*return*/];
            });
        });
    };
    // hasDropdownContent() {
    //   return this.dropdown.innerHTML.trim() !== ''
    // }
    class_20.prototype.showDropdownContent = function () {
        return this.active; // && this.hasDropdownContent()
    };
    class_20.prototype.closeUnifiedMenuDropdown = function () {
        this.active = false;
        this.dropdownPosition = {};
    };
    class_20.prototype.resetMenu = function () {
        this.active = false;
        this.dropdownPosition = {};
    };
    class_20.prototype.handleViewClick = function () {
        this.active = false;
        this.dropdownPosition = {};
    };
    class_20.prototype.closeIfActive = function (e) {
        if (e.type === 'keydown' && e.key === 'Escape'
            || e.type === 'click' && !e.target.closest('omnibar-unified-menu')) {
            this.active = false;
            this.dropdownPosition = {};
        }
    };
    class_20.prototype.calculateDropdownPosition = function () {
        if (isElementInViewport(this.dropdown)) {
            this.dropdownPosition = {};
        }
        else {
            this.dropdownPosition = { right: '0', left: 'auto' };
        }
    };
    class_20.prototype.render = function () {
        var _this_1 = this;
        var renderBadge = function () {
            if (_this_1.badgeCount > 0) {
                return (h("div", { class: "o-badge-count" }, _this_1.badgeCount));
            }
        };
        var renderDropdown = function () {
            return (h("div", { class: "o-dropdown", ref: function (el) { return _this_1.dropdown = el; }, style: _this_1.dropdownPosition }, h("slot", null)));
        };
        var itemContainer = function () {
            return (h("div", { class: classnames('omnibar-unified-menu-item', { 'o-unified-menu-item__active': _this_1.showDropdownContent() }) }, h("div", { onClick: _this_1.toggleActive, title: _this_1.menuName, class: "o-unified-menu-item-toggle" }, h("div", null, h("omnibar-icon", { kind: _this_1.iconKind, icon: _this_1.icon }), h("span", { class: "o-unified-menu-item-menu__name" }, _this_1.menuName)), h("div", { class: "o-unified-menu-item-menu__close" }, h("omnibar-icon", { icon: "close" })), renderBadge()), !_this_1.url && renderDropdown()));
        };
        return (this.url ?
            h("a", { href: this.url, target: this.target, class: "omnibar-unified-menu-item" }, itemContainer())
            :
                h("div", { role: "button", "aria-label": "menu-item", tabindex: !this.notButton && 0, class: "omnibar-unified-menu-item", onKeyPress: !this.notButton && this.handleKeyPress }, itemContainer()));
    };
    Object.defineProperty(class_20.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_20, "style", {
        get: function () { return ".o-icon-menu .omnibar-unified-menu-item{position:relative;width:100%;height:100%;color:#fff}.o-icon-menu .omnibar-unified-menu-item:hover:not(.o-unified-menu-item__active){background:rgba(0,0,0,.2)}.o-icon-menu .omnibar-unified-menu-item:focus{outline:none;background:rgba(0,0,0,.2)}.o-icon-menu .omnibar-unified-menu-item:focus .o-unified-menu-item-toggle{background:rgba(0,0,0,.2)}.o-icon-menu .omnibar-unified-menu-item.o-unified-menu-item__active{background:#0076cc}.o-icon-menu .omnibar-unified-menu-item.o-unified-menu-item__active .o-dropdown{display:block}.o-icon-menu .omnibar-unified-menu-item>.o-unified-menu-item-toggle{height:100%;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;position:relative}.o-icon-menu .omnibar-unified-menu-item>.o-unified-menu-item-toggle div{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.o-icon-menu .omnibar-unified-menu-item>.o-unified-menu-item-toggle .o-badge-count{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;text-align:right;-ms-flex-pack:center;justify-content:center;height:1.25rem;border-radius:9999px;font-size:.75rem;padding-left:.5rem;padding-right:.5rem;padding-top:.25rem;padding-bottom:.25rem;position:absolute;z-index:10;top:10px;right:0;color:#fff;background:#f65216}.o-icon-menu .omnibar-unified-menu-item>.o-unified-menu-item-toggle omnibar-icon{position:relative;top:2px;font-size:1.25rem}.o-icon-menu .omnibar-unified-menu-item>.o-unified-menu-item-toggle .o-unified-menu-item-menu__close,.o-icon-menu .omnibar-unified-menu-item>.o-unified-menu-item-toggle .o-unified-menu-item-menu__name{display:none}.o-icon-menu .omnibar-unified-menu-item>.o-dropdown{-webkit-box-shadow:0 8px 16px 0 rgba(82,97,115,.18);box-shadow:0 8px 16px 0 rgba(82,97,115,.18);position:fixed;display:none;overflow:auto;width:100%;height:100%;color:#303436;top:56px;left:0;min-width:300px;background:#fff;max-height:calc(100vh - 56px);overflow-y:auto}\@media (min-width:768px){.o-icon-menu .omnibar-unified-menu-item>.o-dropdown{position:absolute;height:auto;width:auto}}.o-user a,.o-user a:hover{color:#303436;text-decoration:none}.o-user .omnibar-unified-menu-item:focus{outline:none;background-color:#e5f4ff}.o-user .omnibar-unified-menu-item:focus .o-unified-menu-item-toggle{background-color:#e5f4ff}.o-user .omnibar-unified-menu-item>.o-unified-menu-item-toggle{height:100%;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:15px;border-bottom:1px solid #e4e6e7}.o-user .omnibar-unified-menu-item>.o-unified-menu-item-toggle:hover{background:#f7f6f6}.o-user .omnibar-unified-menu-item>.o-unified-menu-item-toggle .o-badge-count{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:1.25rem;border-radius:9999px;font-size:.75rem;padding-left:.5rem;padding-right:.5rem;padding-top:.25rem;padding-bottom:.25rem;color:#fff;background:#f65216}.o-user .omnibar-unified-menu-item>.o-unified-menu-item-toggle omnibar-icon{display:none}.o-user .omnibar-unified-menu-item>.o-dropdown{display:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#303436;position:relative;background:#fff;-webkit-box-shadow:none;box-shadow:none;border-bottom:1px solid #e4e6e7}.o-user .omnibar-unified-menu-item.o-unified-menu-item__active{background:#f7f6f6}.o-user .omnibar-unified-menu-item.o-unified-menu-item__active .o-dropdown{display:block}"; },
        enumerable: true,
        configurable: true
    });
    return class_20;
}());
ShellTunnel.injectProps(OmnibarUnifiedMenuItem, ['screenSize']);
function createNotificationToast(toastData) {
    var productName = toastData.productName, title = toastData.title, message = toastData.message, priority = toastData.priority, item = toastData.item, actions = toastData.actions, total = toastData.total;
    var createToast = window.OMNIBAR.commands.toast;
    var toast = createToast({
        tagName: 'notification-toast',
        timeout: 5000,
        origin: productName,
        heading: title,
        body: message,
        read: true,
        severity: priority == true ? 'High' : '',
        item: item,
        actions: actions,
        total: total
    });
    toast.addEventListener('omnibarToastAction', function () { return toast.dismiss(); });
    toast.addEventListener('dismissNotifications', function (item) { return toastData.this.handleDismissNotifications({ detail: item.detail }); });
    toast.addEventListener('updateStatus', function (item) { return toastData.this.handleUpdateStatus(item); });
    toast.addEventListener('viewNotifications', function (item) { return toastData.this.handleViewNotifications(item); });
}
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/** Error thrown when an HTTP request fails. */
var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    /** Constructs a new instance of {@link @microsoft/signalr.HttpError}.
     *
     * @param {string} errorMessage A descriptive error message.
     * @param {number} statusCode The HTTP status code represented by this error.
     */
    function HttpError(errorMessage, statusCode) {
        var _newTarget = this.constructor;
        var _this = this;
        var trueProto = _newTarget.prototype;
        _this = _super.call(this, errorMessage) || this;
        _this.statusCode = statusCode;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        _this.__proto__ = trueProto;
        return _this;
    }
    return HttpError;
}(Error));
/** Error thrown when a timeout elapses. */
var TimeoutError = /** @class */ (function (_super) {
    __extends(TimeoutError, _super);
    /** Constructs a new instance of {@link @microsoft/signalr.TimeoutError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */
    function TimeoutError(errorMessage) {
        var _newTarget = this.constructor;
        if (errorMessage === void 0) {
            errorMessage = "A timeout occurred.";
        }
        var _this = this;
        var trueProto = _newTarget.prototype;
        _this = _super.call(this, errorMessage) || this;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        _this.__proto__ = trueProto;
        return _this;
    }
    return TimeoutError;
}(Error));
/** Error thrown when an action is aborted. */
var AbortError = /** @class */ (function (_super) {
    __extends(AbortError, _super);
    /** Constructs a new instance of {@link AbortError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */
    function AbortError(errorMessage) {
        var _newTarget = this.constructor;
        if (errorMessage === void 0) {
            errorMessage = "An abort occurred.";
        }
        var _this = this;
        var trueProto = _newTarget.prototype;
        _this = _super.call(this, errorMessage) || this;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        _this.__proto__ = trueProto;
        return _this;
    }
    return AbortError;
}(Error));
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign = (undefined && undefined.__assign) || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
    }
    return t;
};
/** Represents an HTTP response. */
var HttpResponse = /** @class */ (function () {
    function HttpResponse(statusCode, statusText, content) {
        this.statusCode = statusCode;
        this.statusText = statusText;
        this.content = content;
    }
    return HttpResponse;
}());
/** Abstraction over an HTTP client.
 *
 * This class provides an abstraction over an HTTP client so that a different implementation can be provided on different platforms.
 */
var HttpClient = /** @class */ (function () {
    function HttpClient() {
    }
    HttpClient.prototype.get = function (url, options) {
        return this.send(__assign({}, options, { method: "GET", url: url }));
    };
    HttpClient.prototype.post = function (url, options) {
        return this.send(__assign({}, options, { method: "POST", url: url }));
    };
    HttpClient.prototype.delete = function (url, options) {
        return this.send(__assign({}, options, { method: "DELETE", url: url }));
    };
    /** Gets all cookies that apply to the specified URL.
     *
     * @param url The URL that the cookies are valid for.
     * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
     */
    // @ts-ignore
    HttpClient.prototype.getCookieString = function (url) {
        return "";
    };
    return HttpClient;
}());
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var inited = false;
function init() {
    inited = true;
    var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    for (var i = 0, len = code.length; i < len; ++i) {
        lookup[i] = code[i];
        revLookup[code.charCodeAt(i)] = i;
    }
    revLookup['-'.charCodeAt(0)] = 62;
    revLookup['_'.charCodeAt(0)] = 63;
}
function toByteArray(b64) {
    if (!inited) {
        init();
    }
    var i, j, l, tmp, placeHolders, arr;
    var len = b64.length;
    if (len % 4 > 0) {
        throw new Error('Invalid string. Length must be a multiple of 4');
    }
    // the number of equal signs (place holders)
    // if there are two placeholders, than the two characters before it
    // represent one byte
    // if there is only one, then the three characters before it represent 2 bytes
    // this is just a cheap hack to not do indexOf twice
    placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;
    // base64 is 4/3 + up to two characters of the original data
    arr = new Arr(len * 3 / 4 - placeHolders);
    // if there are placeholders, only get up to the last complete 4 chars
    l = placeHolders > 0 ? len - 4 : len;
    var L = 0;
    for (i = 0, j = 0; i < l; i += 4, j += 3) {
        tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)];
        arr[L++] = (tmp >> 16) & 0xFF;
        arr[L++] = (tmp >> 8) & 0xFF;
        arr[L++] = tmp & 0xFF;
    }
    if (placeHolders === 2) {
        tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
        arr[L++] = tmp & 0xFF;
    }
    else if (placeHolders === 1) {
        tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2);
        arr[L++] = (tmp >> 8) & 0xFF;
        arr[L++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for (var i = start; i < end; i += 3) {
        tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2]);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    if (!inited) {
        init();
    }
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var output = '';
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
        parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
    }
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        output += lookup[tmp >> 2];
        output += lookup[(tmp << 4) & 0x3F];
        output += '==';
    }
    else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + (uint8[len - 1]);
        output += lookup[tmp >> 10];
        output += lookup[(tmp >> 4) & 0x3F];
        output += lookup[(tmp << 2) & 0x3F];
        output += '=';
    }
    parts.push(output);
    return parts.join('');
}
function read(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? (nBytes - 1) : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & ((1 << (-nBits)) - 1);
    s >>= (-nBits);
    nBits += eLen;
    for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) { }
    m = e & ((1 << (-nBits)) - 1);
    e >>= (-nBits);
    nBits += mLen;
    for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) { }
    if (e === 0) {
        e = 1 - eBias;
    }
    else if (e === eMax) {
        return m ? NaN : ((s ? -1 : 1) * Infinity);
    }
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
}
function write(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
    var i = isLE ? 0 : (nBytes - 1);
    var d = isLE ? 1 : -1;
    var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    }
    else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) {
            value += rt / c;
        }
        else {
            value += rt * Math.pow(2, 1 - eBias);
        }
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        }
        else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        }
        else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) { }
    e = (e << mLen) | m;
    eLen += mLen;
    for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) { }
    buffer[offset + i - d] |= s * 128;
}
var toString$1 = {}.toString;
var isArray$2 = Array.isArray || function (arr) {
    return toString$1.call(arr) == '[object Array]';
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined
    ? global$1.TYPED_ARRAY_SUPPORT
    : true;
function kMaxLength() {
    return Buffer.TYPED_ARRAY_SUPPORT
        ? 0x7fffffff
        : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) {
        throw new RangeError('Invalid typed array length');
    }
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
    }
    else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) {
            that = new Buffer(length);
        }
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */
function Buffer(arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
        return new Buffer(arg, encodingOrOffset, length);
    }
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') {
            throw new Error('If encoding is specified then the first argument must be a string');
        }
        return allocUnsafe(this, arg);
    }
    return from$1(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192; // not used by this implementation
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
    arr.__proto__ = Buffer.prototype;
    return arr;
};
function from$1(that, value, encodingOrOffset, length) {
    if (typeof value === 'number') {
        throw new TypeError('"value" argument must not be a number');
    }
    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
        return fromArrayBuffer(that, value, encodingOrOffset, length);
    }
    if (typeof value === 'string') {
        return fromString(that, value, encodingOrOffset);
    }
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
    return from$1(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
}
function assertSize(size) {
    if (typeof size !== 'number') {
        throw new TypeError('"size" argument must be a number');
    }
    else if (size < 0) {
        throw new RangeError('"size" argument must not be negative');
    }
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) {
        return createBuffer(that, size);
    }
    if (fill !== undefined) {
        // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpretted as a start offset.
        return typeof encoding === 'string'
            ? createBuffer(that, size).fill(fill, encoding)
            : createBuffer(that, size).fill(fill);
    }
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) {
        for (var i = 0; i < size; ++i) {
            that[i] = 0;
        }
    }
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') {
        encoding = 'utf8';
    }
    if (!Buffer.isEncoding(encoding)) {
        throw new TypeError('"encoding" must be a valid string encoding');
    }
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) {
        // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        that = that.slice(0, actual);
    }
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for (var i = 0; i < length; i += 1) {
        that[i] = array[i] & 255;
    }
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) {
        throw new RangeError('\'offset\' is out of bounds');
    }
    if (array.byteLength < byteOffset + (length || 0)) {
        throw new RangeError('\'length\' is out of bounds');
    }
    if (byteOffset === undefined && length === undefined) {
        array = new Uint8Array(array);
    }
    else if (length === undefined) {
        array = new Uint8Array(array, byteOffset);
    }
    else {
        array = new Uint8Array(array, byteOffset, length);
    }
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
    }
    else {
        // Fallback: Return an object instance of the Buffer class
        that = fromArrayLike(that, array);
    }
    return that;
}
function fromObject(that, obj) {
    if (internalIsBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) {
            return that;
        }
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if ((typeof ArrayBuffer !== 'undefined' &&
            obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
            if (typeof obj.length !== 'number' || isnan(obj.length)) {
                return createBuffer(that, 0);
            }
            return fromArrayLike(that, obj);
        }
        if (obj.type === 'Buffer' && isArray$2(obj.data)) {
            return fromArrayLike(that, obj.data);
        }
    }
    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) {
        throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
            'size: 0x' + kMaxLength().toString(16) + ' bytes');
    }
    return length | 0;
}
Buffer.isBuffer = isBuffer;
function internalIsBuffer(b) {
    return !!(b != null && b._isBuffer);
}
Buffer.compare = function compare(a, b) {
    if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
        throw new TypeError('Arguments must be Buffers');
    }
    if (a === b)
        return 0;
    var x = a.length;
    var y = b.length;
    for (var i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
    }
    if (x < y)
        return -1;
    if (y < x)
        return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch (String(encoding).toLowerCase()) {
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!isArray$2(list)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
    }
    if (list.length === 0) {
        return Buffer.alloc(0);
    }
    var i;
    if (length === undefined) {
        length = 0;
        for (i = 0; i < list.length; ++i) {
            length += list[i].length;
        }
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for (i = 0; i < list.length; ++i) {
        var buf = list[i];
        if (!internalIsBuffer(buf)) {
            throw new TypeError('"list" argument must be an Array of Buffers');
        }
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (internalIsBuffer(string)) {
        return string.length;
    }
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
        (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
        return string.byteLength;
    }
    if (typeof string !== 'string') {
        string = '' + string;
    }
    var len = string.length;
    if (len === 0)
        return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for (;;) {
        switch (encoding) {
            case 'ascii':
            case 'latin1':
            case 'binary':
                return len;
            case 'utf8':
            case 'utf-8':
            case undefined:
                return utf8ToBytes(string).length;
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return len * 2;
            case 'hex':
                return len >>> 1;
            case 'base64':
                return base64ToBytes(string).length;
            default:
                if (loweredCase)
                    return utf8ToBytes(string).length; // assume utf8
                encoding = ('' + encoding).toLowerCase();
                loweredCase = true;
        }
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) {
        start = 0;
    }
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) {
        return '';
    }
    if (end === undefined || end > this.length) {
        end = this.length;
    }
    if (end <= 0) {
        return '';
    }
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) {
        return '';
    }
    if (!encoding)
        encoding = 'utf8';
    while (true) {
        switch (encoding) {
            case 'hex':
                return hexSlice(this, start, end);
            case 'utf8':
            case 'utf-8':
                return utf8Slice(this, start, end);
            case 'ascii':
                return asciiSlice(this, start, end);
            case 'latin1':
            case 'binary':
                return latin1Slice(this, start, end);
            case 'base64':
                return base64Slice(this, start, end);
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return utf16leSlice(this, start, end);
            default:
                if (loweredCase)
                    throw new TypeError('Unknown encoding: ' + encoding);
                encoding = (encoding + '').toLowerCase();
                loweredCase = true;
        }
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 16-bits');
    }
    for (var i = 0; i < len; i += 2) {
        swap(this, i, i + 1);
    }
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 32-bits');
    }
    for (var i = 0; i < len; i += 4) {
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 64-bits');
    }
    for (var i = 0; i < len; i += 8) {
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0)
        return '';
    if (arguments.length === 0)
        return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
    if (!internalIsBuffer(b))
        throw new TypeError('Argument must be a Buffer');
    if (this === b)
        return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max)
            str += ' ... ';
    }
    return '<Buffer ' + str + '>';
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!internalIsBuffer(target)) {
        throw new TypeError('Argument must be a Buffer');
    }
    if (start === undefined) {
        start = 0;
    }
    if (end === undefined) {
        end = target ? target.length : 0;
    }
    if (thisStart === undefined) {
        thisStart = 0;
    }
    if (thisEnd === undefined) {
        thisEnd = this.length;
    }
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError('out of range index');
    }
    if (thisStart >= thisEnd && start >= end) {
        return 0;
    }
    if (thisStart >= thisEnd) {
        return -1;
    }
    if (start >= end) {
        return 1;
    }
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target)
        return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for (var i = 0; i < len; ++i) {
        if (thisCopy[i] !== targetCopy[i]) {
            x = thisCopy[i];
            y = targetCopy[i];
            break;
        }
    }
    if (x < y)
        return -1;
    if (y < x)
        return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0)
        return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    }
    else if (byteOffset > 0x7fffffff) {
        byteOffset = 0x7fffffff;
    }
    else if (byteOffset < -0x80000000) {
        byteOffset = -0x80000000;
    }
    byteOffset = +byteOffset; // Coerce to Number.
    if (isNaN(byteOffset)) {
        // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : (buffer.length - 1);
    }
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0)
        byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir)
            return -1;
        else
            byteOffset = buffer.length - 1;
    }
    else if (byteOffset < 0) {
        if (dir)
            byteOffset = 0;
        else
            return -1;
    }
    // Normalize val
    if (typeof val === 'string') {
        val = Buffer.from(val, encoding);
    }
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (internalIsBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) {
            return -1;
        }
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    }
    else if (typeof val === 'number') {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (Buffer.TYPED_ARRAY_SUPPORT &&
            typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) {
                return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            }
            else {
                return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
        }
        return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' ||
            encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) {
                return -1;
            }
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) {
            return buf[i];
        }
        else {
            return buf.readUInt16BE(i * indexSize);
        }
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for (i = byteOffset; i < arrLength; i++) {
            if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                if (foundIndex === -1)
                    foundIndex = i;
                if (i - foundIndex + 1 === valLength)
                    return foundIndex * indexSize;
            }
            else {
                if (foundIndex !== -1)
                    i -= i - foundIndex;
                foundIndex = -1;
            }
        }
    }
    else {
        if (byteOffset + valLength > arrLength)
            byteOffset = arrLength - valLength;
        for (i = byteOffset; i >= 0; i--) {
            var found = true;
            for (var j = 0; j < valLength; j++) {
                if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                }
            }
            if (found)
                return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) {
        length = remaining;
    }
    else {
        length = Number(length);
        if (length > remaining) {
            length = remaining;
        }
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0)
        throw new TypeError('Invalid hex string');
    if (length > strLen / 2) {
        length = strLen / 2;
    }
    for (var i = 0; i < length; ++i) {
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed))
            return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
        // Buffer#write(string, encoding)
    }
    else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
        // Buffer#write(string, offset[, length][, encoding])
    }
    else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined)
                encoding = 'utf8';
        }
        else {
            encoding = length;
            length = undefined;
        }
        // legacy write(string, encoding, offset, length) - remove in v0.13
    }
    else {
        throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    }
    var remaining = this.length - offset;
    if (length === undefined || length > remaining)
        length = remaining;
    if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
        throw new RangeError('Attempt to write outside buffer bounds');
    }
    if (!encoding)
        encoding = 'utf8';
    var loweredCase = false;
    for (;;) {
        switch (encoding) {
            case 'hex':
                return hexWrite(this, string, offset, length);
            case 'utf8':
            case 'utf-8':
                return utf8Write(this, string, offset, length);
            case 'ascii':
                return asciiWrite(this, string, offset, length);
            case 'latin1':
            case 'binary':
                return latin1Write(this, string, offset, length);
            case 'base64':
                // Warning: maxLength not taken into account in base64Write
                return base64Write(this, string, offset, length);
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return ucs2Write(this, string, offset, length);
            default:
                if (loweredCase)
                    throw new TypeError('Unknown encoding: ' + encoding);
                encoding = ('' + encoding).toLowerCase();
                loweredCase = true;
        }
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) {
        return fromByteArray(buf);
    }
    else {
        return fromByteArray(buf.slice(start, end));
    }
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while (i < end) {
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = (firstByte > 0xEF) ? 4
            : (firstByte > 0xDF) ? 3
                : (firstByte > 0xBF) ? 2
                    : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch (bytesPerSequence) {
                case 1:
                    if (firstByte < 0x80) {
                        codePoint = firstByte;
                    }
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
                        if (tempCodePoint > 0x7F) {
                            codePoint = tempCodePoint;
                        }
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                            codePoint = tempCodePoint;
                        }
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                            codePoint = tempCodePoint;
                        }
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        }
        else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
    }
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while (i < len) {
        res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    }
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i] & 0x7F);
    }
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i]);
    }
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0)
        start = 0;
    if (!end || end < 0 || end > len)
        end = len;
    var out = '';
    for (var i = start; i < end; ++i) {
        out += toHex(buf[i]);
    }
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for (var i = 0; i < bytes.length; i += 2) {
        res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    }
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0)
            start = 0;
    }
    else if (start > len) {
        start = len;
    }
    if (end < 0) {
        end += len;
        if (end < 0)
            end = 0;
    }
    else if (end > len) {
        end = len;
    }
    if (end < start)
        end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
    }
    else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for (var i = 0; i < sliceLen; ++i) {
            newBuf[i] = this[i + start];
        }
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset(offset, ext, length) {
    if ((offset % 1) !== 0 || offset < 0)
        throw new RangeError('offset is not uint');
    if (offset + ext > length)
        throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert)
        checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 0x100)) {
        val += this[offset + i] * mul;
    }
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        checkOffset(offset, byteLength, this.length);
    }
    var val = this[offset + --byteLength];
    var mul = 1;
    while (byteLength > 0 && (mul *= 0x100)) {
        val += this[offset + --byteLength] * mul;
    }
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 2, this.length);
    return this[offset] | (this[offset + 1] << 8);
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 2, this.length);
    return (this[offset] << 8) | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return ((this[offset]) |
        (this[offset + 1] << 8) |
        (this[offset + 2] << 16)) +
        (this[offset + 3] * 0x1000000);
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return (this[offset] * 0x1000000) +
        ((this[offset + 1] << 16) |
            (this[offset + 2] << 8) |
            this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert)
        checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 0x100)) {
        val += this[offset + i] * mul;
    }
    mul *= 0x80;
    if (val >= mul)
        val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert)
        checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while (i > 0 && (mul *= 0x100)) {
        val += this[offset + --i] * mul;
    }
    mul *= 0x80;
    if (val >= mul)
        val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80))
        return (this[offset]);
    return ((0xff - this[offset] + 1) * -1);
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 2, this.length);
    var val = this[offset] | (this[offset + 1] << 8);
    return (val & 0x8000) ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | (this[offset] << 8);
    return (val & 0x8000) ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return (this[offset]) |
        (this[offset + 1] << 8) |
        (this[offset + 2] << 16) |
        (this[offset + 3] << 24);
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return (this[offset] << 24) |
        (this[offset + 1] << 16) |
        (this[offset + 2] << 8) |
        (this[offset + 3]);
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 4, this.length);
    return read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 8, this.length);
    return read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert)
        checkOffset(offset, 8, this.length);
    return read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!internalIsBuffer(buf))
        throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min)
        throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length)
        throw new RangeError('Index out of range');
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while (++i < byteLength && (mul *= 0x100)) {
        this[offset + i] = (value / mul) & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while (--i >= 0 && (mul *= 0x100)) {
        this[offset + i] = (value / mul) & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT)
        value = Math.floor(value);
    this[offset] = (value & 0xff);
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0)
        value = 0xffff + value + 1;
    for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
        buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
            (littleEndian ? i : 1 - i) * 8;
    }
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value & 0xff);
        this[offset + 1] = (value >>> 8);
    }
    else {
        objectWriteUInt16(this, value, offset, true);
    }
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value >>> 8);
        this[offset + 1] = (value & 0xff);
    }
    else {
        objectWriteUInt16(this, value, offset, false);
    }
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0)
        value = 0xffffffff + value + 1;
    for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
        buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff;
    }
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = (value >>> 24);
        this[offset + 2] = (value >>> 16);
        this[offset + 1] = (value >>> 8);
        this[offset] = (value & 0xff);
    }
    else {
        objectWriteUInt32(this, value, offset, true);
    }
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value >>> 24);
        this[offset + 1] = (value >>> 16);
        this[offset + 2] = (value >>> 8);
        this[offset + 3] = (value & 0xff);
    }
    else {
        objectWriteUInt32(this, value, offset, false);
    }
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while (++i < byteLength && (mul *= 0x100)) {
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
            sub = 1;
        }
        this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while (--i >= 0 && (mul *= 0x100)) {
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
            sub = 1;
        }
        this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 1, 0x7f, -0x80);
    if (!Buffer.TYPED_ARRAY_SUPPORT)
        value = Math.floor(value);
    if (value < 0)
        value = 0xff + value + 1;
    this[offset] = (value & 0xff);
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value & 0xff);
        this[offset + 1] = (value >>> 8);
    }
    else {
        objectWriteUInt16(this, value, offset, true);
    }
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value >>> 8);
        this[offset + 1] = (value & 0xff);
    }
    else {
        objectWriteUInt16(this, value, offset, false);
    }
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value & 0xff);
        this[offset + 1] = (value >>> 8);
        this[offset + 2] = (value >>> 16);
        this[offset + 3] = (value >>> 24);
    }
    else {
        objectWriteUInt32(this, value, offset, true);
    }
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert)
        checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    if (value < 0)
        value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value >>> 24);
        this[offset + 1] = (value >>> 16);
        this[offset + 2] = (value >>> 8);
        this[offset + 3] = (value & 0xff);
    }
    else {
        objectWriteUInt32(this, value, offset, false);
    }
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length)
        throw new RangeError('Index out of range');
    if (offset < 0)
        throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) {
        checkIEEE754(buf, value, offset, 4);
    }
    write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) {
        checkIEEE754(buf, value, offset, 8);
    }
    write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start)
        start = 0;
    if (!end && end !== 0)
        end = this.length;
    if (targetStart >= target.length)
        targetStart = target.length;
    if (!targetStart)
        targetStart = 0;
    if (end > 0 && end < start)
        end = start;
    // Copy 0 bytes; we're done
    if (end === start)
        return 0;
    if (target.length === 0 || this.length === 0)
        return 0;
    // Fatal error conditions
    if (targetStart < 0) {
        throw new RangeError('targetStart out of bounds');
    }
    if (start < 0 || start >= this.length)
        throw new RangeError('sourceStart out of bounds');
    if (end < 0)
        throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length)
        end = this.length;
    if (target.length - targetStart < end - start) {
        end = target.length - targetStart + start;
    }
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) {
        // descending copy from end
        for (i = len - 1; i >= 0; --i) {
            target[i + targetStart] = this[i + start];
        }
    }
    else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
        // ascending copy from start
        for (i = 0; i < len; ++i) {
            target[i + targetStart] = this[i + start];
        }
    }
    else {
        Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    }
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        }
        else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) {
                val = code;
            }
        }
        if (encoding !== undefined && typeof encoding !== 'string') {
            throw new TypeError('encoding must be a string');
        }
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
            throw new TypeError('Unknown encoding: ' + encoding);
        }
    }
    else if (typeof val === 'number') {
        val = val & 255;
    }
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) {
        throw new RangeError('Out of range index');
    }
    if (end <= start) {
        return this;
    }
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val)
        val = 0;
    var i;
    if (typeof val === 'number') {
        for (i = start; i < end; ++i) {
            this[i] = val;
        }
    }
    else {
        var bytes = internalIsBuffer(val)
            ? val
            : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for (i = 0; i < end - start; ++i) {
            this[i + start] = bytes[i % len];
        }
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2)
        return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while (str.length % 4 !== 0) {
        str = str + '=';
    }
    return str;
}
function stringtrim(str) {
    if (str.trim)
        return str.trim();
    return str.replace(/^\s+|\s+$/g, '');
}
function toHex(n) {
    if (n < 16)
        return '0' + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for (var i = 0; i < length; ++i) {
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1)
                        bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1)
                        bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1)
                    bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        }
        else if (leadSurrogate) {
            // valid bmp char, but last char was a lead
            if ((units -= 3) > -1)
                bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0)
                break;
            bytes.push(codePoint);
        }
        else if (codePoint < 0x800) {
            if ((units -= 2) < 0)
                break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        }
        else if (codePoint < 0x10000) {
            if ((units -= 3) < 0)
                break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        }
        else if (codePoint < 0x110000) {
            if ((units -= 4) < 0)
                break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        }
        else {
            throw new Error('Invalid code point');
        }
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for (var i = 0; i < str.length; ++i) {
        // Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF);
    }
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for (var i = 0; i < str.length; ++i) {
        if ((units -= 2) < 0)
            break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for (var i = 0; i < length; ++i) {
        if ((i + offset >= dst.length) || (i >= src.length))
            break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val; // eslint-disable-line no-self-compare
}
// the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
function isBuffer(obj) {
    return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj));
}
function isFastBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0));
}
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// These values are designed to match the ASP.NET Log Levels since that's the pattern we're emulating here.
/** Indicates the severity of a log message.
 *
 * Log Levels are ordered in increasing severity. So `Debug` is more severe than `Trace`, etc.
 */
var LogLevel;
(function (LogLevel) {
    /** Log level for very low severity diagnostic messages. */
    LogLevel[LogLevel["Trace"] = 0] = "Trace";
    /** Log level for low severity diagnostic messages. */
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
    /** Log level for informational diagnostic messages. */
    LogLevel[LogLevel["Information"] = 2] = "Information";
    /** Log level for diagnostic messages that indicate a non-fatal problem. */
    LogLevel[LogLevel["Warning"] = 3] = "Warning";
    /** Log level for diagnostic messages that indicate a failure in the current operation. */
    LogLevel[LogLevel["Error"] = 4] = "Error";
    /** Log level for diagnostic messages that indicate a failure that will terminate the entire application. */
    LogLevel[LogLevel["Critical"] = 5] = "Critical";
    /** The highest possible log level. Used when configuring logging to indicate that no log messages should be emitted. */
    LogLevel[LogLevel["None"] = 6] = "None";
})(LogLevel || (LogLevel = {}));
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
/** A logger that does nothing when log messages are sent to it. */
var NullLogger = /** @class */ (function () {
    function NullLogger() {
    }
    /** @inheritDoc */
    // tslint:disable-next-line
    NullLogger.prototype.log = function (_logLevel, _message) {
    };
    /** The singleton instance of the {@link @microsoft/signalr.NullLogger}. */
    NullLogger.instance = new NullLogger();
    return NullLogger;
}());
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/** @private */
var Arg = /** @class */ (function () {
    function Arg() {
    }
    Arg.isRequired = function (val, name) {
        if (val === null || val === undefined) {
            throw new Error("The '" + name + "' argument is required.");
        }
    };
    Arg.isIn = function (val, values, name) {
        // TypeScript enums have keys for **both** the name and the value of each enum member on the type itself.
        if (!(val in values)) {
            throw new Error("Unknown " + name + " value: " + val + ".");
        }
    };
    return Arg;
}());
/** @private */
var Platform = /** @class */ (function () {
    function Platform() {
    }
    Object.defineProperty(Platform, "isBrowser", {
        get: function () {
            return typeof window === "object";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Platform, "isWebWorker", {
        get: function () {
            return typeof self === "object" && "importScripts" in self;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Platform, "isNode", {
        get: function () {
            return !this.isBrowser && !this.isWebWorker;
        },
        enumerable: true,
        configurable: true
    });
    return Platform;
}());
/** @private */
function getDataDetail(data, includeContent) {
    var detail = "";
    if (isArrayBuffer(data)) {
        detail = "Binary data of length " + data.byteLength;
        if (includeContent) {
            detail += ". Content: '" + formatArrayBuffer(data) + "'";
        }
    }
    else if (typeof data === "string") {
        detail = "String data of length " + data.length;
        if (includeContent) {
            detail += ". Content: '" + data + "'";
        }
    }
    return detail;
}
/** @private */
function formatArrayBuffer(data) {
    var view = new Uint8Array(data);
    // Uint8Array.map only supports returning another Uint8Array?
    var str = "";
    view.forEach(function (num) {
        var pad = num < 16 ? "0" : "";
        str += "0x" + pad + num.toString(16) + " ";
    });
    // Trim of trailing space.
    return str.substr(0, str.length - 1);
}
// Also in signalr-protocol-msgpack/Utils.ts
/** @private */
function isArrayBuffer(val) {
    return val && typeof ArrayBuffer !== "undefined" &&
        (val instanceof ArrayBuffer ||
            // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
            (val.constructor && val.constructor.name === "ArrayBuffer"));
}
/** @private */
function sendMessage(logger, transportName, httpClient, url, accessTokenFactory, content, logMessageContent) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, headers, token, responseType, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!accessTokenFactory)
                        return [3 /*break*/, 2];
                    return [4 /*yield*/, accessTokenFactory()];
                case 1:
                    token = _b.sent();
                    if (token) {
                        headers = (_a = {},
                            _a["Authorization"] = "Bearer " + token,
                            _a);
                    }
                    _b.label = 2;
                case 2:
                    logger.log(LogLevel.Trace, "(" + transportName + " transport) sending data. " + getDataDetail(content, logMessageContent) + ".");
                    responseType = isArrayBuffer(content) ? "arraybuffer" : "text";
                    return [4 /*yield*/, httpClient.post(url, {
                            content: content,
                            headers: headers,
                            responseType: responseType,
                        })];
                case 3:
                    response = _b.sent();
                    logger.log(LogLevel.Trace, "(" + transportName + " transport) request complete. Response status: " + response.statusCode + ".");
                    return [2 /*return*/];
            }
        });
    });
}
/** @private */
function createLogger(logger) {
    if (logger === undefined) {
        return new ConsoleLogger(LogLevel.Information);
    }
    if (logger === null) {
        return NullLogger.instance;
    }
    if (logger.log) {
        return logger;
    }
    return new ConsoleLogger(logger);
}
/** @private */
var SubjectSubscription = /** @class */ (function () {
    function SubjectSubscription(subject, observer) {
        this.subject = subject;
        this.observer = observer;
    }
    SubjectSubscription.prototype.dispose = function () {
        var index = this.subject.observers.indexOf(this.observer);
        if (index > -1) {
            this.subject.observers.splice(index, 1);
        }
        if (this.subject.observers.length === 0 && this.subject.cancelCallback) {
            this.subject.cancelCallback().catch(function (_) { });
        }
    };
    return SubjectSubscription;
}());
/** @private */
var ConsoleLogger = /** @class */ (function () {
    function ConsoleLogger(minimumLogLevel) {
        this.minimumLogLevel = minimumLogLevel;
        this.outputConsole = console;
    }
    ConsoleLogger.prototype.log = function (logLevel, message) {
        if (logLevel >= this.minimumLogLevel) {
            switch (logLevel) {
                case LogLevel.Critical:
                case LogLevel.Error:
                    this.outputConsole.error("[" + new Date().toISOString() + "] " + LogLevel[logLevel] + ": " + message);
                    break;
                case LogLevel.Warning:
                    this.outputConsole.warn("[" + new Date().toISOString() + "] " + LogLevel[logLevel] + ": " + message);
                    break;
                case LogLevel.Information:
                    this.outputConsole.info("[" + new Date().toISOString() + "] " + LogLevel[logLevel] + ": " + message);
                    break;
                default:
                    // console.debug only goes to attached debuggers in Node, so we use console.log for Trace and Debug
                    this.outputConsole.log("[" + new Date().toISOString() + "] " + LogLevel[logLevel] + ": " + message);
                    break;
            }
        }
    };
    return ConsoleLogger;
}());
//# sourceMappingURL=Utils.js.map
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __extends$1 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$1 = (undefined && undefined.__assign) || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
    }
    return t;
};
var requestModule;
if (typeof XMLHttpRequest === "undefined") {
    // In order to ignore the dynamic require in webpack builds we need to do this magic
    // @ts-ignore: TS doesn't know about these names
    var requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : require;
    requestModule = requireFunc("request");
}
/** @private */
var NodeHttpClient = /** @class */ (function (_super) {
    __extends$1(NodeHttpClient, _super);
    function NodeHttpClient(logger) {
        var _this = _super.call(this) || this;
        if (typeof requestModule === "undefined") {
            throw new Error("The 'request' module could not be loaded.");
        }
        _this.logger = logger;
        _this.cookieJar = requestModule.jar();
        _this.request = requestModule.defaults({ jar: _this.cookieJar });
        return _this;
    }
    NodeHttpClient.prototype.send = function (httpRequest) {
        var _this = this;
        // Check that abort was not signaled before calling send
        if (httpRequest.abortSignal) {
            if (httpRequest.abortSignal.aborted) {
                return Promise.reject(new AbortError());
            }
        }
        return new Promise(function (resolve, reject) {
            var requestBody;
            if (isArrayBuffer(httpRequest.content)) {
                requestBody = Buffer.from(httpRequest.content);
            }
            else {
                requestBody = httpRequest.content || "";
            }
            var currentRequest = _this.request(httpRequest.url, {
                body: requestBody,
                // If binary is expected 'null' should be used, otherwise for text 'utf8'
                encoding: httpRequest.responseType === "arraybuffer" ? null : "utf8",
                headers: __assign$1({
                    // Tell auth middleware to 401 instead of redirecting
                    "X-Requested-With": "XMLHttpRequest"
                }, httpRequest.headers),
                method: httpRequest.method,
                timeout: httpRequest.timeout,
            }, function (error, response, body) {
                if (httpRequest.abortSignal) {
                    httpRequest.abortSignal.onabort = null;
                }
                if (error) {
                    if (error.code === "ETIMEDOUT") {
                        _this.logger.log(LogLevel.Warning, "Timeout from HTTP request.");
                        reject(new TimeoutError());
                    }
                    _this.logger.log(LogLevel.Warning, "Error from HTTP request. " + error);
                    reject(error);
                    return;
                }
                if (response.statusCode >= 200 && response.statusCode < 300) {
                    resolve(new HttpResponse(response.statusCode, response.statusMessage || "", body));
                }
                else {
                    reject(new HttpError(response.statusMessage || "", response.statusCode || 0));
                }
            });
            if (httpRequest.abortSignal) {
                httpRequest.abortSignal.onabort = function () {
                    currentRequest.abort();
                    reject(new AbortError());
                };
            }
        });
    };
    NodeHttpClient.prototype.getCookieString = function (url) {
        return this.cookieJar.getCookieString(url);
    };
    return NodeHttpClient;
}(HttpClient));
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __extends$2 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var XhrHttpClient = /** @class */ (function (_super) {
    __extends$2(XhrHttpClient, _super);
    function XhrHttpClient(logger) {
        var _this = _super.call(this) || this;
        _this.logger = logger;
        return _this;
    }
    /** @inheritDoc */
    XhrHttpClient.prototype.send = function (request) {
        var _this = this;
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) {
            return Promise.reject(new AbortError());
        }
        if (!request.method) {
            return Promise.reject(new Error("No method defined."));
        }
        if (!request.url) {
            return Promise.reject(new Error("No url defined."));
        }
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(request.method, request.url, true);
            xhr.withCredentials = true;
            xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            // Explicitly setting the Content-Type header for React Native on Android platform.
            xhr.setRequestHeader("Content-Type", "text/plain;charset=UTF-8");
            var headers = request.headers;
            if (headers) {
                Object.keys(headers)
                    .forEach(function (header) {
                    xhr.setRequestHeader(header, headers[header]);
                });
            }
            if (request.responseType) {
                xhr.responseType = request.responseType;
            }
            if (request.abortSignal) {
                request.abortSignal.onabort = function () {
                    xhr.abort();
                    reject(new AbortError());
                };
            }
            if (request.timeout) {
                xhr.timeout = request.timeout;
            }
            xhr.onload = function () {
                if (request.abortSignal) {
                    request.abortSignal.onabort = null;
                }
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(new HttpResponse(xhr.status, xhr.statusText, xhr.response || xhr.responseText));
                }
                else {
                    reject(new HttpError(xhr.statusText, xhr.status));
                }
            };
            xhr.onerror = function () {
                _this.logger.log(LogLevel.Warning, "Error from HTTP request. " + xhr.status + ": " + xhr.statusText + ".");
                reject(new HttpError(xhr.statusText, xhr.status));
            };
            xhr.ontimeout = function () {
                _this.logger.log(LogLevel.Warning, "Timeout from HTTP request.");
                reject(new TimeoutError());
            };
            xhr.send(request.content || "");
        });
    };
    return XhrHttpClient;
}(HttpClient));
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __extends$3 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/** Default implementation of {@link @microsoft/signalr.HttpClient}. */
var DefaultHttpClient = /** @class */ (function (_super) {
    __extends$3(DefaultHttpClient, _super);
    /** Creates a new instance of the {@link @microsoft/signalr.DefaultHttpClient}, using the provided {@link @microsoft/signalr.ILogger} to log messages. */
    function DefaultHttpClient(logger) {
        var _this = _super.call(this) || this;
        if (typeof XMLHttpRequest !== "undefined") {
            _this.httpClient = new XhrHttpClient(logger);
        }
        else {
            _this.httpClient = new NodeHttpClient(logger);
        }
        return _this;
    }
    /** @inheritDoc */
    DefaultHttpClient.prototype.send = function (request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) {
            return Promise.reject(new AbortError());
        }
        if (!request.method) {
            return Promise.reject(new Error("No method defined."));
        }
        if (!request.url) {
            return Promise.reject(new Error("No url defined."));
        }
        return this.httpClient.send(request);
    };
    DefaultHttpClient.prototype.getCookieString = function (url) {
        return this.httpClient.getCookieString(url);
    };
    return DefaultHttpClient;
}(HttpClient));
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// Not exported from index
/** @private */
var TextMessageFormat = /** @class */ (function () {
    function TextMessageFormat() {
    }
    TextMessageFormat.write = function (output) {
        return "" + output + TextMessageFormat.RecordSeparator;
    };
    TextMessageFormat.parse = function (input) {
        if (input[input.length - 1] !== TextMessageFormat.RecordSeparator) {
            throw new Error("Message is incomplete.");
        }
        var messages = input.split(TextMessageFormat.RecordSeparator);
        messages.pop();
        return messages;
    };
    TextMessageFormat.RecordSeparatorCode = 0x1e;
    TextMessageFormat.RecordSeparator = String.fromCharCode(TextMessageFormat.RecordSeparatorCode);
    return TextMessageFormat;
}());
/** @private */
var HandshakeProtocol = /** @class */ (function () {
    function HandshakeProtocol() {
    }
    // Handshake request is always JSON
    HandshakeProtocol.prototype.writeHandshakeRequest = function (handshakeRequest) {
        return TextMessageFormat.write(JSON.stringify(handshakeRequest));
    };
    HandshakeProtocol.prototype.parseHandshakeResponse = function (data) {
        var responseMessage;
        var messageData;
        var remainingData;
        if (isArrayBuffer(data) || (typeof Buffer !== "undefined" && data instanceof Buffer)) {
            // Format is binary but still need to read JSON text from handshake response
            var binaryData = new Uint8Array(data);
            var separatorIndex = binaryData.indexOf(TextMessageFormat.RecordSeparatorCode);
            if (separatorIndex === -1) {
                throw new Error("Message is incomplete.");
            }
            // content before separator is handshake response
            // optional content after is additional messages
            var responseLength = separatorIndex + 1;
            messageData = String.fromCharCode.apply(null, binaryData.slice(0, responseLength));
            remainingData = (binaryData.byteLength > responseLength) ? binaryData.slice(responseLength).buffer : null;
        }
        else {
            var textData = data;
            var separatorIndex = textData.indexOf(TextMessageFormat.RecordSeparator);
            if (separatorIndex === -1) {
                throw new Error("Message is incomplete.");
            }
            // content before separator is handshake response
            // optional content after is additional messages
            var responseLength = separatorIndex + 1;
            messageData = textData.substring(0, responseLength);
            remainingData = (textData.length > responseLength) ? textData.substring(responseLength) : null;
        }
        // At this point we should have just the single handshake message
        var messages = TextMessageFormat.parse(messageData);
        var response = JSON.parse(messages[0]);
        if (response.type) {
            throw new Error("Expected a handshake response from the server.");
        }
        responseMessage = response;
        // multiple messages could have arrived with handshake
        // return additional data to be parsed as usual, or null if all parsed
        return [remainingData, responseMessage];
    };
    return HandshakeProtocol;
}());
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
/** Defines the type of a Hub Message. */
var MessageType;
(function (MessageType) {
    /** Indicates the message is an Invocation message and implements the {@link @microsoft/signalr.InvocationMessage} interface. */
    MessageType[MessageType["Invocation"] = 1] = "Invocation";
    /** Indicates the message is a StreamItem message and implements the {@link @microsoft/signalr.StreamItemMessage} interface. */
    MessageType[MessageType["StreamItem"] = 2] = "StreamItem";
    /** Indicates the message is a Completion message and implements the {@link @microsoft/signalr.CompletionMessage} interface. */
    MessageType[MessageType["Completion"] = 3] = "Completion";
    /** Indicates the message is a Stream Invocation message and implements the {@link @microsoft/signalr.StreamInvocationMessage} interface. */
    MessageType[MessageType["StreamInvocation"] = 4] = "StreamInvocation";
    /** Indicates the message is a Cancel Invocation message and implements the {@link @microsoft/signalr.CancelInvocationMessage} interface. */
    MessageType[MessageType["CancelInvocation"] = 5] = "CancelInvocation";
    /** Indicates the message is a Ping message and implements the {@link @microsoft/signalr.PingMessage} interface. */
    MessageType[MessageType["Ping"] = 6] = "Ping";
    /** Indicates the message is a Close message and implements the {@link @microsoft/signalr.CloseMessage} interface. */
    MessageType[MessageType["Close"] = 7] = "Close";
})(MessageType || (MessageType = {}));
// Copyright (c) .NET Foundation. All rights reserved.
/** Stream implementation to stream items to the server. */
var Subject = /** @class */ (function () {
    function Subject() {
        this.observers = [];
    }
    Subject.prototype.next = function (item) {
        for (var _i = 0, _a = this.observers; _i < _a.length; _i++) {
            var observer = _a[_i];
            observer.next(item);
        }
    };
    Subject.prototype.error = function (err) {
        for (var _i = 0, _a = this.observers; _i < _a.length; _i++) {
            var observer = _a[_i];
            if (observer.error) {
                observer.error(err);
            }
        }
    };
    Subject.prototype.complete = function () {
        for (var _i = 0, _a = this.observers; _i < _a.length; _i++) {
            var observer = _a[_i];
            if (observer.complete) {
                observer.complete();
            }
        }
    };
    Subject.prototype.subscribe = function (observer) {
        this.observers.push(observer);
        return new SubjectSubscription(this, observer);
    };
    return Subject;
}());
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __awaiter$1 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$1 = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var DEFAULT_TIMEOUT_IN_MS = 30 * 1000;
var DEFAULT_PING_INTERVAL_IN_MS = 15 * 1000;
/** Describes the current state of the {@link HubConnection} to the server. */
var HubConnectionState;
(function (HubConnectionState) {
    /** The hub connection is disconnected. */
    HubConnectionState["Disconnected"] = "Disconnected";
    /** The hub connection is connecting. */
    HubConnectionState["Connecting"] = "Connecting";
    /** The hub connection is connected. */
    HubConnectionState["Connected"] = "Connected";
    /** The hub connection is disconnecting. */
    HubConnectionState["Disconnecting"] = "Disconnecting";
    /** The hub connection is reconnecting. */
    HubConnectionState["Reconnecting"] = "Reconnecting";
})(HubConnectionState || (HubConnectionState = {}));
/** Represents a connection to a SignalR Hub. */
var HubConnection = /** @class */ (function () {
    function HubConnection(connection, logger, protocol, reconnectPolicy) {
        var _this = this;
        Arg.isRequired(connection, "connection");
        Arg.isRequired(logger, "logger");
        Arg.isRequired(protocol, "protocol");
        this.serverTimeoutInMilliseconds = DEFAULT_TIMEOUT_IN_MS;
        this.keepAliveIntervalInMilliseconds = DEFAULT_PING_INTERVAL_IN_MS;
        this.logger = logger;
        this.protocol = protocol;
        this.connection = connection;
        this.reconnectPolicy = reconnectPolicy;
        this.handshakeProtocol = new HandshakeProtocol();
        this.connection.onreceive = function (data) { return _this.processIncomingData(data); };
        this.connection.onclose = function (error) { return _this.connectionClosed(error); };
        this.callbacks = {};
        this.methods = {};
        this.closedCallbacks = [];
        this.reconnectingCallbacks = [];
        this.reconnectedCallbacks = [];
        this.invocationId = 0;
        this.receivedHandshakeResponse = false;
        this.connectionState = HubConnectionState.Disconnected;
        this.connectionStarted = false;
        this.cachedPingMessage = this.protocol.writeMessage({ type: MessageType.Ping });
    }
    /** @internal */
    // Using a public static factory method means we can have a private constructor and an _internal_
    // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
    // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
    // public parameter-less constructor.
    HubConnection.create = function (connection, logger, protocol, reconnectPolicy) {
        return new HubConnection(connection, logger, protocol, reconnectPolicy);
    };
    Object.defineProperty(HubConnection.prototype, "state", {
        /** Indicates the state of the {@link HubConnection} to the server. */
        get: function () {
            return this.connectionState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HubConnection.prototype, "connectionId", {
        /** Represents the connection id of the {@link HubConnection} on the server. The connection id will be null when the connection is either
         *  in the disconnected state or if the negotiation step was skipped.
         */
        get: function () {
            return this.connection ? (this.connection.connectionId || null) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HubConnection.prototype, "baseUrl", {
        /** Indicates the url of the {@link HubConnection} to the server. */
        get: function () {
            return this.connection.baseUrl || "";
        },
        /**
         * Sets a new url for the HubConnection. Note that the url can only be changed when the connection is in either the Disconnected or
         * Reconnecting states.
         * @param {string} url The url to connect to.
         */
        set: function (url) {
            if (this.connectionState !== HubConnectionState.Disconnected && this.connectionState !== HubConnectionState.Reconnecting) {
                throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
            }
            if (!url) {
                throw new Error("The HubConnection url must be a valid url.");
            }
            this.connection.baseUrl = url;
        },
        enumerable: true,
        configurable: true
    });
    /** Starts the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
     */
    HubConnection.prototype.start = function () {
        this.startPromise = this.startWithStateTransitions();
        return this.startPromise;
    };
    HubConnection.prototype.startWithStateTransitions = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            var e_1;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.connectionState !== HubConnectionState.Disconnected) {
                            return [2 /*return*/, Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state."))];
                        }
                        this.connectionState = HubConnectionState.Connecting;
                        this.logger.log(LogLevel.Debug, "Starting HubConnection.");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.startInternal()];
                    case 2:
                        _a.sent();
                        this.connectionState = HubConnectionState.Connected;
                        this.connectionStarted = true;
                        this.logger.log(LogLevel.Debug, "HubConnection connected successfully.");
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.connectionState = HubConnectionState.Disconnected;
                        this.logger.log(LogLevel.Debug, "HubConnection failed to start successfully because of error '" + e_1 + "'.");
                        return [2 /*return*/, Promise.reject(e_1)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HubConnection.prototype.startInternal = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            var handshakePromise, handshakeRequest, e_2;
            var _this = this;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.stopDuringStartError = undefined;
                        this.receivedHandshakeResponse = false;
                        handshakePromise = new Promise(function (resolve, reject) {
                            _this.handshakeResolver = resolve;
                            _this.handshakeRejecter = reject;
                        });
                        return [4 /*yield*/, this.connection.start(this.protocol.transferFormat)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 7]);
                        handshakeRequest = {
                            protocol: this.protocol.name,
                            version: this.protocol.version,
                        };
                        this.logger.log(LogLevel.Debug, "Sending handshake request.");
                        return [4 /*yield*/, this.sendMessage(this.handshakeProtocol.writeHandshakeRequest(handshakeRequest))];
                    case 3:
                        _a.sent();
                        this.logger.log(LogLevel.Information, "Using HubProtocol '" + this.protocol.name + "'.");
                        // defensively cleanup timeout in case we receive a message from the server before we finish start
                        this.cleanupTimeout();
                        this.resetTimeoutPeriod();
                        this.resetKeepAliveInterval();
                        return [4 /*yield*/, handshakePromise];
                    case 4:
                        _a.sent();
                        // It's important to check the stopDuringStartError instead of just relying on the handshakePromise
                        // being rejected on close, because this continuation can run after both the handshake completed successfully
                        // and the connection was closed.
                        if (this.stopDuringStartError) {
                            // It's important to throw instead of returning a rejected promise, because we don't want to allow any state
                            // transitions to occur between now and the calling code observing the exceptions. Returning a rejected promise
                            // will cause the calling continuation to get scheduled to run later.
                            throw this.stopDuringStartError;
                        }
                        return [3 /*break*/, 7];
                    case 5:
                        e_2 = _a.sent();
                        this.logger.log(LogLevel.Debug, "Hub handshake failed with error '" + e_2 + "' during start(). Stopping HubConnection.");
                        this.cleanupTimeout();
                        this.cleanupPingTimer();
                        // HttpConnection.stop() should not complete until after the onclose callback is invoked.
                        // This will transition the HubConnection to the disconnected state before HttpConnection.stop() completes.
                        return [4 /*yield*/, this.connection.stop(e_2)];
                    case 6:
                        // HttpConnection.stop() should not complete until after the onclose callback is invoked.
                        // This will transition the HubConnection to the disconnected state before HttpConnection.stop() completes.
                        _a.sent();
                        throw e_2;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /** Stops the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
     */
    HubConnection.prototype.stop = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            var startPromise, e_3;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        startPromise = this.startPromise;
                        this.stopPromise = this.stopInternal();
                        return [4 /*yield*/, this.stopPromise];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        // Awaiting undefined continues immediately
                        return [4 /*yield*/, startPromise];
                    case 3:
                        // Awaiting undefined continues immediately
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_3 = _a.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    HubConnection.prototype.stopInternal = function (error) {
        if (this.connectionState === HubConnectionState.Disconnected) {
            this.logger.log(LogLevel.Debug, "Call to HubConnection.stop(" + error + ") ignored because it is already in the disconnected state.");
            return Promise.resolve();
        }
        if (this.connectionState === HubConnectionState.Disconnecting) {
            this.logger.log(LogLevel.Debug, "Call to HttpConnection.stop(" + error + ") ignored because the connection is already in the disconnecting state.");
            return this.stopPromise;
        }
        this.connectionState = HubConnectionState.Disconnecting;
        this.logger.log(LogLevel.Debug, "Stopping HubConnection.");
        if (this.reconnectDelayHandle) {
            // We're in a reconnect delay which means the underlying connection is currently already stopped.
            // Just clear the handle to stop the reconnect loop (which no one is waiting on thankfully) and
            // fire the onclose callbacks.
            this.logger.log(LogLevel.Debug, "Connection stopped during reconnect delay. Done reconnecting.");
            clearTimeout(this.reconnectDelayHandle);
            this.reconnectDelayHandle = undefined;
            this.completeClose();
            return Promise.resolve();
        }
        this.cleanupTimeout();
        this.cleanupPingTimer();
        this.stopDuringStartError = error || new Error("The connection was stopped before the hub handshake could complete.");
        // HttpConnection.stop() should not complete until after either HttpConnection.start() fails
        // or the onclose callback is invoked. The onclose callback will transition the HubConnection
        // to the disconnected state if need be before HttpConnection.stop() completes.
        return this.connection.stop(error);
    };
    /** Invokes a streaming hub method on the server using the specified name and arguments.
     *
     * @typeparam T The type of the items returned by the server.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
     */
    HubConnection.prototype.stream = function (methodName) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a = this.replaceStreamingParams(args), streams = _a[0], streamIds = _a[1];
        var invocationDescriptor = this.createStreamInvocation(methodName, args, streamIds);
        var promiseQueue;
        var subject = new Subject();
        subject.cancelCallback = function () {
            var cancelInvocation = _this.createCancelInvocation(invocationDescriptor.invocationId);
            delete _this.callbacks[invocationDescriptor.invocationId];
            return promiseQueue.then(function () {
                return _this.sendWithProtocol(cancelInvocation);
            });
        };
        this.callbacks[invocationDescriptor.invocationId] = function (invocationEvent, error) {
            if (error) {
                subject.error(error);
                return;
            }
            else if (invocationEvent) {
                // invocationEvent will not be null when an error is not passed to the callback
                if (invocationEvent.type === MessageType.Completion) {
                    if (invocationEvent.error) {
                        subject.error(new Error(invocationEvent.error));
                    }
                    else {
                        subject.complete();
                    }
                }
                else {
                    subject.next((invocationEvent.item));
                }
            }
        };
        promiseQueue = this.sendWithProtocol(invocationDescriptor)
            .catch(function (e) {
            subject.error(e);
            delete _this.callbacks[invocationDescriptor.invocationId];
        });
        this.launchStreams(streams, promiseQueue);
        return subject;
    };
    HubConnection.prototype.sendMessage = function (message) {
        this.resetKeepAliveInterval();
        return this.connection.send(message);
    };
    /**
     * Sends a js object to the server.
     * @param message The js object to serialize and send.
     */
    HubConnection.prototype.sendWithProtocol = function (message) {
        return this.sendMessage(this.protocol.writeMessage(message));
    };
    /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
     *
     * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
     * be processing the invocation.
     *
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
     */
    HubConnection.prototype.send = function (methodName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a = this.replaceStreamingParams(args), streams = _a[0], streamIds = _a[1];
        var sendPromise = this.sendWithProtocol(this.createInvocation(methodName, args, true, streamIds));
        this.launchStreams(streams, sendPromise);
        return sendPromise;
    };
    /** Invokes a hub method on the server using the specified name and arguments.
     *
     * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
     * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
     * resolving the Promise.
     *
     * @typeparam T The expected return type.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
     */
    HubConnection.prototype.invoke = function (methodName) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a = this.replaceStreamingParams(args), streams = _a[0], streamIds = _a[1];
        var invocationDescriptor = this.createInvocation(methodName, args, false, streamIds);
        var p = new Promise(function (resolve, reject) {
            // invocationId will always have a value for a non-blocking invocation
            _this.callbacks[invocationDescriptor.invocationId] = function (invocationEvent, error) {
                if (error) {
                    reject(error);
                    return;
                }
                else if (invocationEvent) {
                    // invocationEvent will not be null when an error is not passed to the callback
                    if (invocationEvent.type === MessageType.Completion) {
                        if (invocationEvent.error) {
                            reject(new Error(invocationEvent.error));
                        }
                        else {
                            resolve(invocationEvent.result);
                        }
                    }
                    else {
                        reject(new Error("Unexpected message type: " + invocationEvent.type));
                    }
                }
            };
            var promiseQueue = _this.sendWithProtocol(invocationDescriptor)
                .catch(function (e) {
                reject(e);
                // invocationId will always have a value for a non-blocking invocation
                delete _this.callbacks[invocationDescriptor.invocationId];
            });
            _this.launchStreams(streams, promiseQueue);
        });
        return p;
    };
    /** Registers a handler that will be invoked when the hub method with the specified method name is invoked.
     *
     * @param {string} methodName The name of the hub method to define.
     * @param {Function} newMethod The handler that will be raised when the hub method is invoked.
     */
    HubConnection.prototype.on = function (methodName, newMethod) {
        if (!methodName || !newMethod) {
            return;
        }
        methodName = methodName.toLowerCase();
        if (!this.methods[methodName]) {
            this.methods[methodName] = [];
        }
        // Preventing adding the same handler multiple times.
        if (this.methods[methodName].indexOf(newMethod) !== -1) {
            return;
        }
        this.methods[methodName].push(newMethod);
    };
    HubConnection.prototype.off = function (methodName, method) {
        if (!methodName) {
            return;
        }
        methodName = methodName.toLowerCase();
        var handlers = this.methods[methodName];
        if (!handlers) {
            return;
        }
        if (method) {
            var removeIdx = handlers.indexOf(method);
            if (removeIdx !== -1) {
                handlers.splice(removeIdx, 1);
                if (handlers.length === 0) {
                    delete this.methods[methodName];
                }
            }
        }
        else {
            delete this.methods[methodName];
        }
    };
    /** Registers a handler that will be invoked when the connection is closed.
     *
     * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
     */
    HubConnection.prototype.onclose = function (callback) {
        if (callback) {
            this.closedCallbacks.push(callback);
        }
    };
    /** Registers a handler that will be invoked when the connection starts reconnecting.
     *
     * @param {Function} callback The handler that will be invoked when the connection starts reconnecting. Optionally receives a single argument containing the error that caused the connection to start reconnecting (if any).
     */
    HubConnection.prototype.onreconnecting = function (callback) {
        if (callback) {
            this.reconnectingCallbacks.push(callback);
        }
    };
    /** Registers a handler that will be invoked when the connection successfully reconnects.
     *
     * @param {Function} callback The handler that will be invoked when the connection successfully reconnects.
     */
    HubConnection.prototype.onreconnected = function (callback) {
        if (callback) {
            this.reconnectedCallbacks.push(callback);
        }
    };
    HubConnection.prototype.processIncomingData = function (data) {
        this.cleanupTimeout();
        if (!this.receivedHandshakeResponse) {
            data = this.processHandshakeResponse(data);
            this.receivedHandshakeResponse = true;
        }
        // Data may have all been read when processing handshake response
        if (data) {
            // Parse the messages
            var messages = this.protocol.parseMessages(data, this.logger);
            for (var _i = 0, messages_1 = messages; _i < messages_1.length; _i++) {
                var message = messages_1[_i];
                switch (message.type) {
                    case MessageType.Invocation:
                        this.invokeClientMethod(message);
                        break;
                    case MessageType.StreamItem:
                    case MessageType.Completion:
                        var callback = this.callbacks[message.invocationId];
                        if (callback) {
                            if (message.type === MessageType.Completion) {
                                delete this.callbacks[message.invocationId];
                            }
                            callback(message);
                        }
                        break;
                    case MessageType.Ping:
                        // Don't care about pings
                        break;
                    case MessageType.Close:
                        this.logger.log(LogLevel.Information, "Close message received from server.");
                        var error = message.error ? new Error("Server returned an error on close: " + message.error) : undefined;
                        if (message.allowReconnect === true) {
                            // It feels wrong not to await connection.stop() here, but processIncomingData is called as part of an onreceive callback which is not async,
                            // this is already the behavior for serverTimeout(), and HttpConnection.Stop() should catch and log all possible exceptions.
                            // tslint:disable-next-line:no-floating-promises
                            this.connection.stop(error);
                        }
                        else {
                            // We cannot await stopInternal() here, but subsequent calls to stop() will await this if stopInternal() is still ongoing.
                            this.stopPromise = this.stopInternal(error);
                        }
                        break;
                    default:
                        this.logger.log(LogLevel.Warning, "Invalid message type: " + message.type + ".");
                        break;
                }
            }
        }
        this.resetTimeoutPeriod();
    };
    HubConnection.prototype.processHandshakeResponse = function (data) {
        var _a;
        var responseMessage;
        var remainingData;
        try {
            _a = this.handshakeProtocol.parseHandshakeResponse(data), remainingData = _a[0], responseMessage = _a[1];
        }
        catch (e) {
            var message = "Error parsing handshake response: " + e;
            this.logger.log(LogLevel.Error, message);
            var error = new Error(message);
            this.handshakeRejecter(error);
            throw error;
        }
        if (responseMessage.error) {
            var message = "Server returned handshake error: " + responseMessage.error;
            this.logger.log(LogLevel.Error, message);
            var error = new Error(message);
            this.handshakeRejecter(error);
            throw error;
        }
        else {
            this.logger.log(LogLevel.Debug, "Server handshake complete.");
        }
        this.handshakeResolver();
        return remainingData;
    };
    HubConnection.prototype.resetKeepAliveInterval = function () {
        var _this = this;
        this.cleanupPingTimer();
        this.pingServerHandle = setTimeout(function () {
            return __awaiter$1(_this, void 0, void 0, function () {
                var _a;
                return __generator$1(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(this.connectionState === HubConnectionState.Connected))
                                return [3 /*break*/, 4];
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.sendMessage(this.cachedPingMessage)];
                        case 2:
                            _b.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            _a = _b.sent();
                            // We don't care about the error. It should be seen elsewhere in the client.
                            // The connection is probably in a bad or closed state now, cleanup the timer so it stops triggering
                            this.cleanupPingTimer();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }, this.keepAliveIntervalInMilliseconds);
    };
    HubConnection.prototype.resetTimeoutPeriod = function () {
        var _this = this;
        if (!this.connection.features || !this.connection.features.inherentKeepAlive) {
            // Set the timeout timer
            this.timeoutHandle = setTimeout(function () { return _this.serverTimeout(); }, this.serverTimeoutInMilliseconds);
        }
    };
    HubConnection.prototype.serverTimeout = function () {
        // The server hasn't talked to us in a while. It doesn't like us anymore ... :(
        // Terminate the connection, but we don't need to wait on the promise. This could trigger reconnecting.
        // tslint:disable-next-line:no-floating-promises
        this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
    };
    HubConnection.prototype.invokeClientMethod = function (invocationMessage) {
        var _this = this;
        var methods = this.methods[invocationMessage.target.toLowerCase()];
        if (methods) {
            try {
                methods.forEach(function (m) { return m.apply(_this, invocationMessage.arguments); });
            }
            catch (e) {
                this.logger.log(LogLevel.Error, "A callback for the method " + invocationMessage.target.toLowerCase() + " threw error '" + e + "'.");
            }
            if (invocationMessage.invocationId) {
                // This is not supported in v1. So we return an error to avoid blocking the server waiting for the response.
                var message = "Server requested a response, which is not supported in this version of the client.";
                this.logger.log(LogLevel.Error, message);
                // We don't want to wait on the stop itself.
                this.stopPromise = this.stopInternal(new Error(message));
            }
        }
        else {
            this.logger.log(LogLevel.Warning, "No client method with the name '" + invocationMessage.target + "' found.");
        }
    };
    HubConnection.prototype.connectionClosed = function (error) {
        this.logger.log(LogLevel.Debug, "HubConnection.connectionClosed(" + error + ") called while in state " + this.connectionState + ".");
        // Triggering this.handshakeRejecter is insufficient because it could already be resolved without the continuation having run yet.
        this.stopDuringStartError = this.stopDuringStartError || error || new Error("The underlying connection was closed before the hub handshake could complete.");
        // If the handshake is in progress, start will be waiting for the handshake promise, so we complete it.
        // If it has already completed, this should just noop.
        if (this.handshakeResolver) {
            this.handshakeResolver();
        }
        this.cancelCallbacksWithError(error || new Error("Invocation canceled due to the underlying connection being closed."));
        this.cleanupTimeout();
        this.cleanupPingTimer();
        if (this.connectionState === HubConnectionState.Disconnecting) {
            this.completeClose(error);
        }
        else if (this.connectionState === HubConnectionState.Connected && this.reconnectPolicy) {
            // tslint:disable-next-line:no-floating-promises
            this.reconnect(error);
        }
        else if (this.connectionState === HubConnectionState.Connected) {
            this.completeClose(error);
        }
        // If none of the above if conditions were true were called the HubConnection must be in either:
        // 1. The Connecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail it.
        // 2. The Reconnecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail the current reconnect attempt
        //    and potentially continue the reconnect() loop.
        // 3. The Disconnected state in which case we're already done.
    };
    HubConnection.prototype.completeClose = function (error) {
        var _this = this;
        if (this.connectionStarted) {
            this.connectionState = HubConnectionState.Disconnected;
            this.connectionStarted = false;
            try {
                this.closedCallbacks.forEach(function (c) { return c.apply(_this, [error]); });
            }
            catch (e) {
                this.logger.log(LogLevel.Error, "An onclose callback called with error '" + error + "' threw error '" + e + "'.");
            }
        }
    };
    HubConnection.prototype.reconnect = function (error) {
        return __awaiter$1(this, void 0, void 0, function () {
            var reconnectStartTime, previousReconnectAttempts, retryError, nextRetryDelay, e_4;
            var _this = this;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reconnectStartTime = Date.now();
                        previousReconnectAttempts = 0;
                        retryError = error !== undefined ? error : new Error("Attempting to reconnect due to a unknown error.");
                        nextRetryDelay = this.getNextRetryDelay(previousReconnectAttempts++, 0, retryError);
                        if (nextRetryDelay === null) {
                            this.logger.log(LogLevel.Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt.");
                            this.completeClose(error);
                            return [2 /*return*/];
                        }
                        this.connectionState = HubConnectionState.Reconnecting;
                        if (error) {
                            this.logger.log(LogLevel.Information, "Connection reconnecting because of error '" + error + "'.");
                        }
                        else {
                            this.logger.log(LogLevel.Information, "Connection reconnecting.");
                        }
                        if (this.onreconnecting) {
                            try {
                                this.reconnectingCallbacks.forEach(function (c) { return c.apply(_this, [error]); });
                            }
                            catch (e) {
                                this.logger.log(LogLevel.Error, "An onreconnecting callback called with error '" + error + "' threw error '" + e + "'.");
                            }
                            // Exit early if an onreconnecting callback called connection.stop().
                            if (this.connectionState !== HubConnectionState.Reconnecting) {
                                this.logger.log(LogLevel.Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");
                                return [2 /*return*/];
                            }
                        }
                        _a.label = 1;
                    case 1:
                        if (!(nextRetryDelay !== null))
                            return [3 /*break*/, 7];
                        this.logger.log(LogLevel.Information, "Reconnect attempt number " + previousReconnectAttempts + " will start in " + nextRetryDelay + " ms.");
                        return [4 /*yield*/, new Promise(function (resolve) {
                                _this.reconnectDelayHandle = setTimeout(resolve, nextRetryDelay);
                            })];
                    case 2:
                        _a.sent();
                        this.reconnectDelayHandle = undefined;
                        if (this.connectionState !== HubConnectionState.Reconnecting) {
                            this.logger.log(LogLevel.Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");
                            return [2 /*return*/];
                        }
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.startInternal()];
                    case 4:
                        _a.sent();
                        this.connectionState = HubConnectionState.Connected;
                        this.logger.log(LogLevel.Information, "HubConnection reconnected successfully.");
                        if (this.onreconnected) {
                            try {
                                this.reconnectedCallbacks.forEach(function (c) { return c.apply(_this, [_this.connection.connectionId]); });
                            }
                            catch (e) {
                                this.logger.log(LogLevel.Error, "An onreconnected callback called with connectionId '" + this.connection.connectionId + "; threw error '" + e + "'.");
                            }
                        }
                        return [2 /*return*/];
                    case 5:
                        e_4 = _a.sent();
                        this.logger.log(LogLevel.Information, "Reconnect attempt failed because of error '" + e_4 + "'.");
                        if (this.connectionState !== HubConnectionState.Reconnecting) {
                            this.logger.log(LogLevel.Debug, "Connection left the reconnecting state during reconnect attempt. Done reconnecting.");
                            return [2 /*return*/];
                        }
                        retryError = e_4 instanceof Error ? e_4 : new Error(e_4.toString());
                        nextRetryDelay = this.getNextRetryDelay(previousReconnectAttempts++, Date.now() - reconnectStartTime, retryError);
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 1];
                    case 7:
                        this.logger.log(LogLevel.Information, "Reconnect retries have been exhausted after " + (Date.now() - reconnectStartTime) + " ms and " + previousReconnectAttempts + " failed attempts. Connection disconnecting.");
                        this.completeClose();
                        return [2 /*return*/];
                }
            });
        });
    };
    HubConnection.prototype.getNextRetryDelay = function (previousRetryCount, elapsedMilliseconds, retryReason) {
        try {
            return this.reconnectPolicy.nextRetryDelayInMilliseconds({
                elapsedMilliseconds: elapsedMilliseconds,
                previousRetryCount: previousRetryCount,
                retryReason: retryReason,
            });
        }
        catch (e) {
            this.logger.log(LogLevel.Error, "IRetryPolicy.nextRetryDelayInMilliseconds(" + previousRetryCount + ", " + elapsedMilliseconds + ") threw error '" + e + "'.");
            return null;
        }
    };
    HubConnection.prototype.cancelCallbacksWithError = function (error) {
        var callbacks = this.callbacks;
        this.callbacks = {};
        Object.keys(callbacks)
            .forEach(function (key) {
            var callback = callbacks[key];
            callback(null, error);
        });
    };
    HubConnection.prototype.cleanupPingTimer = function () {
        if (this.pingServerHandle) {
            clearTimeout(this.pingServerHandle);
        }
    };
    HubConnection.prototype.cleanupTimeout = function () {
        if (this.timeoutHandle) {
            clearTimeout(this.timeoutHandle);
        }
    };
    HubConnection.prototype.createInvocation = function (methodName, args, nonblocking, streamIds) {
        if (nonblocking) {
            return {
                arguments: args,
                streamIds: streamIds,
                target: methodName,
                type: MessageType.Invocation,
            };
        }
        else {
            var invocationId = this.invocationId;
            this.invocationId++;
            return {
                arguments: args,
                invocationId: invocationId.toString(),
                streamIds: streamIds,
                target: methodName,
                type: MessageType.Invocation,
            };
        }
    };
    HubConnection.prototype.launchStreams = function (streams, promiseQueue) {
        var _this = this;
        if (streams.length === 0) {
            return;
        }
        // Synchronize stream data so they arrive in-order on the server
        if (!promiseQueue) {
            promiseQueue = Promise.resolve();
        }
        var _loop_1 = function (streamId) {
            streams[streamId].subscribe({
                complete: function () {
                    promiseQueue = promiseQueue.then(function () { return _this.sendWithProtocol(_this.createCompletionMessage(streamId)); });
                },
                error: function (err) {
                    var message;
                    if (err instanceof Error) {
                        message = err.message;
                    }
                    else if (err && err.toString) {
                        message = err.toString();
                    }
                    else {
                        message = "Unknown error";
                    }
                    promiseQueue = promiseQueue.then(function () { return _this.sendWithProtocol(_this.createCompletionMessage(streamId, message)); });
                },
                next: function (item) {
                    promiseQueue = promiseQueue.then(function () { return _this.sendWithProtocol(_this.createStreamItemMessage(streamId, item)); });
                },
            });
        };
        // We want to iterate over the keys, since the keys are the stream ids
        // tslint:disable-next-line:forin
        for (var streamId in streams) {
            _loop_1(streamId);
        }
    };
    HubConnection.prototype.replaceStreamingParams = function (args) {
        var streams = [];
        var streamIds = [];
        for (var i = 0; i < args.length; i++) {
            var argument = args[i];
            if (this.isObservable(argument)) {
                var streamId = this.invocationId;
                this.invocationId++;
                // Store the stream for later use
                streams[streamId] = argument;
                streamIds.push(streamId.toString());
                // remove stream from args
                args.splice(i, 1);
            }
        }
        return [streams, streamIds];
    };
    HubConnection.prototype.isObservable = function (arg) {
        // This allows other stream implementations to just work (like rxjs)
        return arg && arg.subscribe && typeof arg.subscribe === "function";
    };
    HubConnection.prototype.createStreamInvocation = function (methodName, args, streamIds) {
        var invocationId = this.invocationId;
        this.invocationId++;
        return {
            arguments: args,
            invocationId: invocationId.toString(),
            streamIds: streamIds,
            target: methodName,
            type: MessageType.StreamInvocation,
        };
    };
    HubConnection.prototype.createCancelInvocation = function (id) {
        return {
            invocationId: id,
            type: MessageType.CancelInvocation,
        };
    };
    HubConnection.prototype.createStreamItemMessage = function (id, item) {
        return {
            invocationId: id,
            item: item,
            type: MessageType.StreamItem,
        };
    };
    HubConnection.prototype.createCompletionMessage = function (id, error, result) {
        if (error) {
            return {
                error: error,
                invocationId: id,
                type: MessageType.Completion,
            };
        }
        return {
            invocationId: id,
            result: result,
            type: MessageType.Completion,
        };
    };
    return HubConnection;
}());
//# sourceMappingURL=HubConnection.js.map
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// 0, 2, 10, 30 second delays before reconnect attempts.
var DEFAULT_RETRY_DELAYS_IN_MILLISECONDS = [0, 2000, 10000, 30000, null];
/** @private */
var DefaultReconnectPolicy = /** @class */ (function () {
    function DefaultReconnectPolicy(retryDelays) {
        this.retryDelays = retryDelays !== undefined ? retryDelays.concat([null]) : DEFAULT_RETRY_DELAYS_IN_MILLISECONDS;
    }
    DefaultReconnectPolicy.prototype.nextRetryDelayInMilliseconds = function (retryContext) {
        return this.retryDelays[retryContext.previousRetryCount];
    };
    return DefaultReconnectPolicy;
}());
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// This will be treated as a bit flag in the future, so we keep it using power-of-two values.
/** Specifies a specific HTTP transport type. */
var HttpTransportType;
(function (HttpTransportType) {
    /** Specifies no transport preference. */
    HttpTransportType[HttpTransportType["None"] = 0] = "None";
    /** Specifies the WebSockets transport. */
    HttpTransportType[HttpTransportType["WebSockets"] = 1] = "WebSockets";
    /** Specifies the Server-Sent Events transport. */
    HttpTransportType[HttpTransportType["ServerSentEvents"] = 2] = "ServerSentEvents";
    /** Specifies the Long Polling transport. */
    HttpTransportType[HttpTransportType["LongPolling"] = 4] = "LongPolling";
})(HttpTransportType || (HttpTransportType = {}));
/** Specifies the transfer format for a connection. */
var TransferFormat;
(function (TransferFormat) {
    /** Specifies that only text data will be transmitted over the connection. */
    TransferFormat[TransferFormat["Text"] = 1] = "Text";
    /** Specifies that binary data will be transmitted over the connection. */
    TransferFormat[TransferFormat["Binary"] = 2] = "Binary";
})(TransferFormat || (TransferFormat = {}));
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// Rough polyfill of https://developer.mozilla.org/en-US/docs/Web/API/AbortController
// We don't actually ever use the API being polyfilled, we always use the polyfill because
// it's a very new API right now.
// Not exported from index.
/** @private */
var AbortController = /** @class */ (function () {
    function AbortController() {
        this.isAborted = false;
        this.onabort = null;
    }
    AbortController.prototype.abort = function () {
        if (!this.isAborted) {
            this.isAborted = true;
            if (this.onabort) {
                this.onabort();
            }
        }
    };
    Object.defineProperty(AbortController.prototype, "signal", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbortController.prototype, "aborted", {
        get: function () {
            return this.isAborted;
        },
        enumerable: true,
        configurable: true
    });
    return AbortController;
}());
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __awaiter$2 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$2 = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Not exported from 'index', this type is internal.
/** @private */
var LongPollingTransport = /** @class */ (function () {
    function LongPollingTransport(httpClient, accessTokenFactory, logger, logMessageContent) {
        this.httpClient = httpClient;
        this.accessTokenFactory = accessTokenFactory;
        this.logger = logger;
        this.pollAbort = new AbortController();
        this.logMessageContent = logMessageContent;
        this.running = false;
        this.onreceive = null;
        this.onclose = null;
    }
    Object.defineProperty(LongPollingTransport.prototype, "pollAborted", {
        // This is an internal type, not exported from 'index' so this is really just internal.
        get: function () {
            return this.pollAbort.aborted;
        },
        enumerable: true,
        configurable: true
    });
    LongPollingTransport.prototype.connect = function (url, transferFormat) {
        return __awaiter$2(this, void 0, void 0, function () {
            var pollOptions, token, pollUrl, response;
            return __generator$2(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Arg.isRequired(url, "url");
                        Arg.isRequired(transferFormat, "transferFormat");
                        Arg.isIn(transferFormat, TransferFormat, "transferFormat");
                        this.url = url;
                        this.logger.log(LogLevel.Trace, "(LongPolling transport) Connecting.");
                        // Allow binary format on Node and Browsers that support binary content (indicated by the presence of responseType property)
                        if (transferFormat === TransferFormat.Binary &&
                            (typeof XMLHttpRequest !== "undefined" && typeof new XMLHttpRequest().responseType !== "string")) {
                            throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
                        }
                        pollOptions = {
                            abortSignal: this.pollAbort.signal,
                            headers: {},
                            timeout: 100000,
                        };
                        if (transferFormat === TransferFormat.Binary) {
                            pollOptions.responseType = "arraybuffer";
                        }
                        return [4 /*yield*/, this.getAccessToken()];
                    case 1:
                        token = _a.sent();
                        this.updateHeaderToken(pollOptions, token);
                        pollUrl = url + "&_=" + Date.now();
                        this.logger.log(LogLevel.Trace, "(LongPolling transport) polling: " + pollUrl + ".");
                        return [4 /*yield*/, this.httpClient.get(pollUrl, pollOptions)];
                    case 2:
                        response = _a.sent();
                        if (response.statusCode !== 200) {
                            this.logger.log(LogLevel.Error, "(LongPolling transport) Unexpected response code: " + response.statusCode + ".");
                            // Mark running as false so that the poll immediately ends and runs the close logic
                            this.closeError = new HttpError(response.statusText || "", response.statusCode);
                            this.running = false;
                        }
                        else {
                            this.running = true;
                        }
                        this.receiving = this.poll(this.url, pollOptions);
                        return [2 /*return*/];
                }
            });
        });
    };
    LongPollingTransport.prototype.getAccessToken = function () {
        return __awaiter$2(this, void 0, void 0, function () {
            return __generator$2(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.accessTokenFactory)
                            return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accessTokenFactory()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, null];
                }
            });
        });
    };
    LongPollingTransport.prototype.updateHeaderToken = function (request, token) {
        if (!request.headers) {
            request.headers = {};
        }
        if (token) {
            // tslint:disable-next-line:no-string-literal
            request.headers["Authorization"] = "Bearer " + token;
            return;
        }
        // tslint:disable-next-line:no-string-literal
        if (request.headers["Authorization"]) {
            // tslint:disable-next-line:no-string-literal
            delete request.headers["Authorization"];
        }
    };
    LongPollingTransport.prototype.poll = function (url, pollOptions) {
        return __awaiter$2(this, void 0, void 0, function () {
            var token, pollUrl, response, e_1;
            return __generator$2(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 8, 9]);
                        _a.label = 1;
                    case 1:
                        if (!this.running)
                            return [3 /*break*/, 7];
                        return [4 /*yield*/, this.getAccessToken()];
                    case 2:
                        token = _a.sent();
                        this.updateHeaderToken(pollOptions, token);
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        pollUrl = url + "&_=" + Date.now();
                        this.logger.log(LogLevel.Trace, "(LongPolling transport) polling: " + pollUrl + ".");
                        return [4 /*yield*/, this.httpClient.get(pollUrl, pollOptions)];
                    case 4:
                        response = _a.sent();
                        if (response.statusCode === 204) {
                            this.logger.log(LogLevel.Information, "(LongPolling transport) Poll terminated by server.");
                            this.running = false;
                        }
                        else if (response.statusCode !== 200) {
                            this.logger.log(LogLevel.Error, "(LongPolling transport) Unexpected response code: " + response.statusCode + ".");
                            // Unexpected status code
                            this.closeError = new HttpError(response.statusText || "", response.statusCode);
                            this.running = false;
                        }
                        else {
                            // Process the response
                            if (response.content) {
                                this.logger.log(LogLevel.Trace, "(LongPolling transport) data received. " + getDataDetail(response.content, this.logMessageContent) + ".");
                                if (this.onreceive) {
                                    this.onreceive(response.content);
                                }
                            }
                            else {
                                // This is another way timeout manifest.
                                this.logger.log(LogLevel.Trace, "(LongPolling transport) Poll timed out, reissuing.");
                            }
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        if (!this.running) {
                            // Log but disregard errors that occur after stopping
                            this.logger.log(LogLevel.Trace, "(LongPolling transport) Poll errored after shutdown: " + e_1.message);
                        }
                        else {
                            if (e_1 instanceof TimeoutError) {
                                // Ignore timeouts and reissue the poll.
                                this.logger.log(LogLevel.Trace, "(LongPolling transport) Poll timed out, reissuing.");
                            }
                            else {
                                // Close the connection with the error as the result.
                                this.closeError = e_1;
                                this.running = false;
                            }
                        }
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 1];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        this.logger.log(LogLevel.Trace, "(LongPolling transport) Polling complete.");
                        // We will reach here with pollAborted==false when the server returned a response causing the transport to stop.
                        // If pollAborted==true then client initiated the stop and the stop method will raise the close event after DELETE is sent.
                        if (!this.pollAborted) {
                            this.raiseOnClose();
                        }
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    LongPollingTransport.prototype.send = function (data) {
        return __awaiter$2(this, void 0, void 0, function () {
            return __generator$2(this, function (_a) {
                if (!this.running) {
                    return [2 /*return*/, Promise.reject(new Error("Cannot send until the transport is connected"))];
                }
                return [2 /*return*/, sendMessage(this.logger, "LongPolling", this.httpClient, this.url, this.accessTokenFactory, data, this.logMessageContent)];
            });
        });
    };
    LongPollingTransport.prototype.stop = function () {
        return __awaiter$2(this, void 0, void 0, function () {
            var deleteOptions, token;
            return __generator$2(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.log(LogLevel.Trace, "(LongPolling transport) Stopping polling.");
                        // Tell receiving loop to stop, abort any current request, and then wait for it to finish
                        this.running = false;
                        this.pollAbort.abort();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 5, 6]);
                        return [4 /*yield*/, this.receiving];
                    case 2:
                        _a.sent();
                        // Send DELETE to clean up long polling on the server
                        this.logger.log(LogLevel.Trace, "(LongPolling transport) sending DELETE request to " + this.url + ".");
                        deleteOptions = {
                            headers: {},
                        };
                        return [4 /*yield*/, this.getAccessToken()];
                    case 3:
                        token = _a.sent();
                        this.updateHeaderToken(deleteOptions, token);
                        return [4 /*yield*/, this.httpClient.delete(this.url, deleteOptions)];
                    case 4:
                        _a.sent();
                        this.logger.log(LogLevel.Trace, "(LongPolling transport) DELETE request sent.");
                        return [3 /*break*/, 6];
                    case 5:
                        this.logger.log(LogLevel.Trace, "(LongPolling transport) Stop finished.");
                        // Raise close event here instead of in polling
                        // It needs to happen after the DELETE request is sent
                        this.raiseOnClose();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    LongPollingTransport.prototype.raiseOnClose = function () {
        if (this.onclose) {
            var logMessage = "(LongPolling transport) Firing onclose event.";
            if (this.closeError) {
                logMessage += " Error: " + this.closeError;
            }
            this.logger.log(LogLevel.Trace, logMessage);
            this.onclose(this.closeError);
        }
    };
    return LongPollingTransport;
}());
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __awaiter$3 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$3 = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/** @private */
var ServerSentEventsTransport = /** @class */ (function () {
    function ServerSentEventsTransport(httpClient, accessTokenFactory, logger, logMessageContent, eventSourceConstructor) {
        this.httpClient = httpClient;
        this.accessTokenFactory = accessTokenFactory;
        this.logger = logger;
        this.logMessageContent = logMessageContent;
        this.eventSourceConstructor = eventSourceConstructor;
        this.onreceive = null;
        this.onclose = null;
    }
    ServerSentEventsTransport.prototype.connect = function (url, transferFormat) {
        return __awaiter$3(this, void 0, void 0, function () {
            var token;
            var _this = this;
            return __generator$3(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Arg.isRequired(url, "url");
                        Arg.isRequired(transferFormat, "transferFormat");
                        Arg.isIn(transferFormat, TransferFormat, "transferFormat");
                        this.logger.log(LogLevel.Trace, "(SSE transport) Connecting.");
                        // set url before accessTokenFactory because this.url is only for send and we set the auth header instead of the query string for send
                        this.url = url;
                        if (!this.accessTokenFactory)
                            return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accessTokenFactory()];
                    case 1:
                        token = _a.sent();
                        if (token) {
                            url += (url.indexOf("?") < 0 ? "?" : "&") + ("access_token=" + encodeURIComponent(token));
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                            var opened = false;
                            if (transferFormat !== TransferFormat.Text) {
                                reject(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
                                return;
                            }
                            var eventSource;
                            if (Platform.isBrowser || Platform.isWebWorker) {
                                eventSource = new _this.eventSourceConstructor(url, { withCredentials: true });
                            }
                            else {
                                // Non-browser passes cookies via the dictionary
                                var cookies = _this.httpClient.getCookieString(url);
                                eventSource = new _this.eventSourceConstructor(url, { withCredentials: true, headers: { Cookie: cookies } });
                            }
                            try {
                                eventSource.onmessage = function (e) {
                                    if (_this.onreceive) {
                                        try {
                                            _this.logger.log(LogLevel.Trace, "(SSE transport) data received. " + getDataDetail(e.data, _this.logMessageContent) + ".");
                                            _this.onreceive(e.data);
                                        }
                                        catch (error) {
                                            _this.close(error);
                                            return;
                                        }
                                    }
                                };
                                eventSource.onerror = function (e) {
                                    var error = new Error(e.data || "Error occurred");
                                    if (opened) {
                                        _this.close(error);
                                    }
                                    else {
                                        reject(error);
                                    }
                                };
                                eventSource.onopen = function () {
                                    _this.logger.log(LogLevel.Information, "SSE connected to " + _this.url);
                                    _this.eventSource = eventSource;
                                    opened = true;
                                    resolve();
                                };
                            }
                            catch (e) {
                                reject(e);
                                return;
                            }
                        })];
                }
            });
        });
    };
    ServerSentEventsTransport.prototype.send = function (data) {
        return __awaiter$3(this, void 0, void 0, function () {
            return __generator$3(this, function (_a) {
                if (!this.eventSource) {
                    return [2 /*return*/, Promise.reject(new Error("Cannot send until the transport is connected"))];
                }
                return [2 /*return*/, sendMessage(this.logger, "SSE", this.httpClient, this.url, this.accessTokenFactory, data, this.logMessageContent)];
            });
        });
    };
    ServerSentEventsTransport.prototype.stop = function () {
        this.close();
        return Promise.resolve();
    };
    ServerSentEventsTransport.prototype.close = function (e) {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = undefined;
            if (this.onclose) {
                this.onclose(e);
            }
        }
    };
    return ServerSentEventsTransport;
}());
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __awaiter$4 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$4 = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/** @private */
var WebSocketTransport = /** @class */ (function () {
    function WebSocketTransport(httpClient, accessTokenFactory, logger, logMessageContent, webSocketConstructor) {
        this.logger = logger;
        this.accessTokenFactory = accessTokenFactory;
        this.logMessageContent = logMessageContent;
        this.webSocketConstructor = webSocketConstructor;
        this.httpClient = httpClient;
        this.onreceive = null;
        this.onclose = null;
    }
    WebSocketTransport.prototype.connect = function (url, transferFormat) {
        return __awaiter$4(this, void 0, void 0, function () {
            var token;
            var _this = this;
            return __generator$4(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Arg.isRequired(url, "url");
                        Arg.isRequired(transferFormat, "transferFormat");
                        Arg.isIn(transferFormat, TransferFormat, "transferFormat");
                        this.logger.log(LogLevel.Trace, "(WebSockets transport) Connecting.");
                        if (!this.accessTokenFactory)
                            return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accessTokenFactory()];
                    case 1:
                        token = _a.sent();
                        if (token) {
                            url += (url.indexOf("?") < 0 ? "?" : "&") + ("access_token=" + encodeURIComponent(token));
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                            url = url.replace(/^http/, "ws");
                            var webSocket;
                            var cookies = _this.httpClient.getCookieString(url);
                            var opened = false;
                            if (Platform.isNode && cookies) {
                                // Only pass cookies when in non-browser environments
                                webSocket = new _this.webSocketConstructor(url, undefined, {
                                    headers: {
                                        Cookie: "" + cookies,
                                    },
                                });
                            }
                            if (!webSocket) {
                                // Chrome is not happy with passing 'undefined' as protocol
                                webSocket = new _this.webSocketConstructor(url);
                            }
                            if (transferFormat === TransferFormat.Binary) {
                                webSocket.binaryType = "arraybuffer";
                            }
                            // tslint:disable-next-line:variable-name
                            webSocket.onopen = function (_event) {
                                _this.logger.log(LogLevel.Information, "WebSocket connected to " + url + ".");
                                _this.webSocket = webSocket;
                                opened = true;
                                resolve();
                            };
                            webSocket.onerror = function (event) {
                                var error = null;
                                // ErrorEvent is a browser only type we need to check if the type exists before using it
                                if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) {
                                    error = event.error;
                                }
                                else {
                                    error = new Error("There was an error with the transport.");
                                }
                                reject(error);
                            };
                            webSocket.onmessage = function (message) {
                                _this.logger.log(LogLevel.Trace, "(WebSockets transport) data received. " + getDataDetail(message.data, _this.logMessageContent) + ".");
                                if (_this.onreceive) {
                                    _this.onreceive(message.data);
                                }
                            };
                            webSocket.onclose = function (event) {
                                // Don't call close handler if connection was never established
                                // We'll reject the connect call instead
                                if (opened) {
                                    _this.close(event);
                                }
                                else {
                                    var error = null;
                                    // ErrorEvent is a browser only type we need to check if the type exists before using it
                                    if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) {
                                        error = event.error;
                                    }
                                    else {
                                        error = new Error("There was an error with the transport.");
                                    }
                                    reject(error);
                                }
                            };
                        })];
                }
            });
        });
    };
    WebSocketTransport.prototype.send = function (data) {
        if (this.webSocket && this.webSocket.readyState === this.webSocketConstructor.OPEN) {
            this.logger.log(LogLevel.Trace, "(WebSockets transport) sending data. " + getDataDetail(data, this.logMessageContent) + ".");
            this.webSocket.send(data);
            return Promise.resolve();
        }
        return Promise.reject("WebSocket is not in the OPEN state");
    };
    WebSocketTransport.prototype.stop = function () {
        if (this.webSocket) {
            // Manually invoke onclose callback inline so we know the HttpConnection was closed properly before returning
            // This also solves an issue where websocket.onclose could take 18+ seconds to trigger during network disconnects
            this.close(undefined);
        }
        return Promise.resolve();
    };
    WebSocketTransport.prototype.close = function (event) {
        // webSocket will be null if the transport did not start successfully
        if (this.webSocket) {
            // Clear websocket handlers because we are considering the socket closed now
            this.webSocket.onclose = function () { };
            this.webSocket.onmessage = function () { };
            this.webSocket.onerror = function () { };
            this.webSocket.close();
            this.webSocket = undefined;
        }
        this.logger.log(LogLevel.Trace, "(WebSockets transport) socket closed.");
        if (this.onclose) {
            if (event && (event.wasClean === false || event.code !== 1000)) {
                this.onclose(new Error("WebSocket closed with status code: " + event.code + " (" + event.reason + ")."));
            }
            else {
                this.onclose();
            }
        }
    };
    return WebSocketTransport;
}());
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __awaiter$5 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$5 = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var MAX_REDIRECTS = 100;
var WebSocketModule = null;
var EventSourceModule = null;
if (Platform.isNode && typeof require !== "undefined") {
    // In order to ignore the dynamic require in webpack builds we need to do this magic
    // @ts-ignore: TS doesn't know about these names
    var requireFunc$1 = typeof __webpack_require__ === "function" ? __non_webpack_require__ : require;
    WebSocketModule = requireFunc$1("ws");
    EventSourceModule = requireFunc$1("eventsource");
}
/** @private */
var HttpConnection = /** @class */ (function () {
    function HttpConnection(url, options) {
        if (options === void 0) {
            options = {};
        }
        this.features = {};
        this.negotiateVersion = 1;
        Arg.isRequired(url, "url");
        this.logger = createLogger(options.logger);
        this.baseUrl = this.resolveUrl(url);
        options = options || {};
        options.logMessageContent = options.logMessageContent || false;
        if (!Platform.isNode && typeof WebSocket !== "undefined" && !options.WebSocket) {
            options.WebSocket = WebSocket;
        }
        else if (Platform.isNode && !options.WebSocket) {
            if (WebSocketModule) {
                options.WebSocket = WebSocketModule;
            }
        }
        if (!Platform.isNode && typeof EventSource !== "undefined" && !options.EventSource) {
            options.EventSource = EventSource;
        }
        else if (Platform.isNode && !options.EventSource) {
            if (typeof EventSourceModule !== "undefined") {
                options.EventSource = EventSourceModule;
            }
        }
        this.httpClient = options.httpClient || new DefaultHttpClient(this.logger);
        this.connectionState = "Disconnected" /* Disconnected */;
        this.connectionStarted = false;
        this.options = options;
        this.onreceive = null;
        this.onclose = null;
    }
    HttpConnection.prototype.start = function (transferFormat) {
        return __awaiter$5(this, void 0, void 0, function () {
            var message, message;
            return __generator$5(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        transferFormat = transferFormat || TransferFormat.Binary;
                        Arg.isIn(transferFormat, TransferFormat, "transferFormat");
                        this.logger.log(LogLevel.Debug, "Starting connection with transfer format '" + TransferFormat[transferFormat] + "'.");
                        if (this.connectionState !== "Disconnected" /* Disconnected */) {
                            return [2 /*return*/, Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state."))];
                        }
                        this.connectionState = "Connecting " /* Connecting */;
                        this.startInternalPromise = this.startInternal(transferFormat);
                        return [4 /*yield*/, this.startInternalPromise];
                    case 1:
                        _a.sent();
                        if (!(this.connectionState === "Disconnecting" /* Disconnecting */))
                            return [3 /*break*/, 3];
                        message = "Failed to start the HttpConnection before stop() was called.";
                        this.logger.log(LogLevel.Error, message);
                        // We cannot await stopPromise inside startInternal since stopInternal awaits the startInternalPromise.
                        return [4 /*yield*/, this.stopPromise];
                    case 2:
                        // We cannot await stopPromise inside startInternal since stopInternal awaits the startInternalPromise.
                        _a.sent();
                        return [2 /*return*/, Promise.reject(new Error(message))];
                    case 3:
                        if (this.connectionState !== "Connected" /* Connected */) {
                            message = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
                            this.logger.log(LogLevel.Error, message);
                            return [2 /*return*/, Promise.reject(new Error(message))];
                        }
                        _a.label = 4;
                    case 4:
                        this.connectionStarted = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.send = function (data) {
        if (this.connectionState !== "Connected" /* Connected */) {
            return Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State."));
        }
        if (!this.sendQueue) {
            this.sendQueue = new TransportSendQueue(this.transport);
        }
        // Transport will not be null if state is connected
        return this.sendQueue.send(data);
    };
    HttpConnection.prototype.stop = function (error) {
        return __awaiter$5(this, void 0, void 0, function () {
            var _this = this;
            return __generator$5(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.connectionState === "Disconnected" /* Disconnected */) {
                            this.logger.log(LogLevel.Debug, "Call to HttpConnection.stop(" + error + ") ignored because the connection is already in the disconnected state.");
                            return [2 /*return*/, Promise.resolve()];
                        }
                        if (this.connectionState === "Disconnecting" /* Disconnecting */) {
                            this.logger.log(LogLevel.Debug, "Call to HttpConnection.stop(" + error + ") ignored because the connection is already in the disconnecting state.");
                            return [2 /*return*/, this.stopPromise];
                        }
                        this.connectionState = "Disconnecting" /* Disconnecting */;
                        this.stopPromise = new Promise(function (resolve) {
                            // Don't complete stop() until stopConnection() completes.
                            _this.stopPromiseResolver = resolve;
                        });
                        // stopInternal should never throw so just observe it.
                        return [4 /*yield*/, this.stopInternal(error)];
                    case 1:
                        // stopInternal should never throw so just observe it.
                        _a.sent();
                        return [4 /*yield*/, this.stopPromise];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.stopInternal = function (error) {
        return __awaiter$5(this, void 0, void 0, function () {
            var e_1, e_2;
            return __generator$5(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Set error as soon as possible otherwise there is a race between
                        // the transport closing and providing an error and the error from a close message
                        // We would prefer the close message error.
                        this.stopError = error;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.startInternalPromise];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        if (!this.transport)
                            return [3 /*break*/, 9];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.transport.stop()];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        e_2 = _a.sent();
                        this.logger.log(LogLevel.Error, "HttpConnection.transport.stop() threw error '" + e_2 + "'.");
                        this.stopConnection();
                        return [3 /*break*/, 8];
                    case 8:
                        this.transport = undefined;
                        return [3 /*break*/, 10];
                    case 9:
                        this.logger.log(LogLevel.Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
                        this.stopConnection();
                        _a.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.startInternal = function (transferFormat) {
        return __awaiter$5(this, void 0, void 0, function () {
            var url, negotiateResponse, redirects, _loop_1, this_1, e_3;
            return __generator$5(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.baseUrl;
                        this.accessTokenFactory = this.options.accessTokenFactory;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 12, , 13]);
                        if (!this.options.skipNegotiation)
                            return [3 /*break*/, 5];
                        if (!(this.options.transport === HttpTransportType.WebSockets))
                            return [3 /*break*/, 3];
                        // No need to add a connection ID in this case
                        this.transport = this.constructTransport(HttpTransportType.WebSockets);
                        // We should just call connect directly in this case.
                        // No fallback or negotiate in this case.
                        return [4 /*yield*/, this.startTransport(url, transferFormat)];
                    case 2:
                        // We should just call connect directly in this case.
                        // No fallback or negotiate in this case.
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3: throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
                    case 4: return [3 /*break*/, 11];
                    case 5:
                        negotiateResponse = null;
                        redirects = 0;
                        _loop_1 = function () {
                            var accessToken_1;
                            return __generator$5(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this_1.getNegotiationResponse(url)];
                                    case 1:
                                        negotiateResponse = _a.sent();
                                        // the user tries to stop the connection when it is being started
                                        if (this_1.connectionState === "Disconnecting" /* Disconnecting */ || this_1.connectionState === "Disconnected" /* Disconnected */) {
                                            throw new Error("The connection was stopped during negotiation.");
                                        }
                                        if (negotiateResponse.error) {
                                            throw new Error(negotiateResponse.error);
                                        }
                                        if (negotiateResponse.ProtocolVersion) {
                                            throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
                                        }
                                        if (negotiateResponse.url) {
                                            url = negotiateResponse.url;
                                        }
                                        if (negotiateResponse.accessToken) {
                                            accessToken_1 = negotiateResponse.accessToken;
                                            this_1.accessTokenFactory = function () { return accessToken_1; };
                                        }
                                        redirects++;
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 6;
                    case 6: return [5 /*yield**/, _loop_1()];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8:
                        if (negotiateResponse.url && redirects < MAX_REDIRECTS)
                            return [3 /*break*/, 6];
                        _a.label = 9;
                    case 9:
                        if (redirects === MAX_REDIRECTS && negotiateResponse.url) {
                            throw new Error("Negotiate redirection limit exceeded.");
                        }
                        return [4 /*yield*/, this.createTransport(url, this.options.transport, negotiateResponse, transferFormat)];
                    case 10:
                        _a.sent();
                        _a.label = 11;
                    case 11:
                        if (this.transport instanceof LongPollingTransport) {
                            this.features.inherentKeepAlive = true;
                        }
                        if (this.connectionState === "Connecting " /* Connecting */) {
                            // Ensure the connection transitions to the connected state prior to completing this.startInternalPromise.
                            // start() will handle the case when stop was called and startInternal exits still in the disconnecting state.
                            this.logger.log(LogLevel.Debug, "The HttpConnection connected successfully.");
                            this.connectionState = "Connected" /* Connected */;
                        }
                        return [3 /*break*/, 13];
                    case 12:
                        e_3 = _a.sent();
                        this.logger.log(LogLevel.Error, "Failed to start the connection: " + e_3);
                        this.connectionState = "Disconnected" /* Disconnected */;
                        this.transport = undefined;
                        return [2 /*return*/, Promise.reject(e_3)];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.getNegotiationResponse = function (url) {
        return __awaiter$5(this, void 0, void 0, function () {
            var _a, headers, token, negotiateUrl, response, negotiateResponse, e_4;
            return __generator$5(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.accessTokenFactory)
                            return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accessTokenFactory()];
                    case 1:
                        token = _b.sent();
                        if (token) {
                            headers = (_a = {},
                                _a["Authorization"] = "Bearer " + token,
                                _a);
                        }
                        _b.label = 2;
                    case 2:
                        negotiateUrl = this.resolveNegotiateUrl(url);
                        this.logger.log(LogLevel.Debug, "Sending negotiation request: " + negotiateUrl + ".");
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.httpClient.post(negotiateUrl, {
                                content: "",
                                headers: headers,
                            })];
                    case 4:
                        response = _b.sent();
                        if (response.statusCode !== 200) {
                            return [2 /*return*/, Promise.reject(new Error("Unexpected status code returned from negotiate " + response.statusCode))];
                        }
                        negotiateResponse = JSON.parse(response.content);
                        if (!negotiateResponse.negotiateVersion || negotiateResponse.negotiateVersion < 1) {
                            // Negotiate version 0 doesn't use connectionToken
                            // So we set it equal to connectionId so all our logic can use connectionToken without being aware of the negotiate version
                            negotiateResponse.connectionToken = negotiateResponse.connectionId;
                        }
                        return [2 /*return*/, negotiateResponse];
                    case 5:
                        e_4 = _b.sent();
                        this.logger.log(LogLevel.Error, "Failed to complete negotiation with the server: " + e_4);
                        return [2 /*return*/, Promise.reject(e_4)];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.createConnectUrl = function (url, connectionToken) {
        if (!connectionToken) {
            return url;
        }
        return url + (url.indexOf("?") === -1 ? "?" : "&") + ("id=" + connectionToken);
    };
    HttpConnection.prototype.createTransport = function (url, requestedTransport, negotiateResponse, requestedTransferFormat) {
        return __awaiter$5(this, void 0, void 0, function () {
            var connectUrl, transportExceptions, transports, negotiate, _i, transports_1, endpoint, transportOrError, ex_1, ex_2, message;
            return __generator$5(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        connectUrl = this.createConnectUrl(url, negotiateResponse.connectionToken);
                        if (!this.isITransport(requestedTransport))
                            return [3 /*break*/, 2];
                        this.logger.log(LogLevel.Debug, "Connection was provided an instance of ITransport, using that directly.");
                        this.transport = requestedTransport;
                        return [4 /*yield*/, this.startTransport(connectUrl, requestedTransferFormat)];
                    case 1:
                        _a.sent();
                        this.connectionId = negotiateResponse.connectionId;
                        return [2 /*return*/];
                    case 2:
                        transportExceptions = [];
                        transports = negotiateResponse.availableTransports || [];
                        negotiate = negotiateResponse;
                        _i = 0, transports_1 = transports;
                        _a.label = 3;
                    case 3:
                        if (!(_i < transports_1.length))
                            return [3 /*break*/, 13];
                        endpoint = transports_1[_i];
                        transportOrError = this.resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat);
                        if (!(transportOrError instanceof Error))
                            return [3 /*break*/, 4];
                        // Store the error and continue, we don't want to cause a re-negotiate in these cases
                        transportExceptions.push(endpoint.transport + " failed: " + transportOrError);
                        return [3 /*break*/, 12];
                    case 4:
                        if (!this.isITransport(transportOrError))
                            return [3 /*break*/, 12];
                        this.transport = transportOrError;
                        if (!!negotiate)
                            return [3 /*break*/, 9];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.getNegotiationResponse(url)];
                    case 6:
                        negotiate = _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        ex_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(ex_1)];
                    case 8:
                        connectUrl = this.createConnectUrl(url, negotiate.connectionToken);
                        _a.label = 9;
                    case 9:
                        _a.trys.push([9, 11, , 12]);
                        return [4 /*yield*/, this.startTransport(connectUrl, requestedTransferFormat)];
                    case 10:
                        _a.sent();
                        this.connectionId = negotiate.connectionId;
                        return [2 /*return*/];
                    case 11:
                        ex_2 = _a.sent();
                        this.logger.log(LogLevel.Error, "Failed to start the transport '" + endpoint.transport + "': " + ex_2);
                        negotiate = undefined;
                        transportExceptions.push(endpoint.transport + " failed: " + ex_2);
                        if (this.connectionState !== "Connecting " /* Connecting */) {
                            message = "Failed to select transport before stop() was called.";
                            this.logger.log(LogLevel.Debug, message);
                            return [2 /*return*/, Promise.reject(new Error(message))];
                        }
                        return [3 /*break*/, 12];
                    case 12:
                        _i++;
                        return [3 /*break*/, 3];
                    case 13:
                        if (transportExceptions.length > 0) {
                            return [2 /*return*/, Promise.reject(new Error("Unable to connect to the server with any of the available transports. " + transportExceptions.join(" ")))];
                        }
                        return [2 /*return*/, Promise.reject(new Error("None of the transports supported by the client are supported by the server."))];
                }
            });
        });
    };
    HttpConnection.prototype.constructTransport = function (transport) {
        switch (transport) {
            case HttpTransportType.WebSockets:
                if (!this.options.WebSocket) {
                    throw new Error("'WebSocket' is not supported in your environment.");
                }
                return new WebSocketTransport(this.httpClient, this.accessTokenFactory, this.logger, this.options.logMessageContent || false, this.options.WebSocket);
            case HttpTransportType.ServerSentEvents:
                if (!this.options.EventSource) {
                    throw new Error("'EventSource' is not supported in your environment.");
                }
                return new ServerSentEventsTransport(this.httpClient, this.accessTokenFactory, this.logger, this.options.logMessageContent || false, this.options.EventSource);
            case HttpTransportType.LongPolling:
                return new LongPollingTransport(this.httpClient, this.accessTokenFactory, this.logger, this.options.logMessageContent || false);
            default:
                throw new Error("Unknown transport: " + transport + ".");
        }
    };
    HttpConnection.prototype.startTransport = function (url, transferFormat) {
        var _this = this;
        this.transport.onreceive = this.onreceive;
        this.transport.onclose = function (e) { return _this.stopConnection(e); };
        return this.transport.connect(url, transferFormat);
    };
    HttpConnection.prototype.resolveTransportOrError = function (endpoint, requestedTransport, requestedTransferFormat) {
        var transport = HttpTransportType[endpoint.transport];
        if (transport === null || transport === undefined) {
            this.logger.log(LogLevel.Debug, "Skipping transport '" + endpoint.transport + "' because it is not supported by this client.");
            return new Error("Skipping transport '" + endpoint.transport + "' because it is not supported by this client.");
        }
        else {
            if (transportMatches(requestedTransport, transport)) {
                var transferFormats = endpoint.transferFormats.map(function (s) { return TransferFormat[s]; });
                if (transferFormats.indexOf(requestedTransferFormat) >= 0) {
                    if ((transport === HttpTransportType.WebSockets && !this.options.WebSocket) ||
                        (transport === HttpTransportType.ServerSentEvents && !this.options.EventSource)) {
                        this.logger.log(LogLevel.Debug, "Skipping transport '" + HttpTransportType[transport] + "' because it is not supported in your environment.'");
                        return new Error("'" + HttpTransportType[transport] + "' is not supported in your environment.");
                    }
                    else {
                        this.logger.log(LogLevel.Debug, "Selecting transport '" + HttpTransportType[transport] + "'.");
                        try {
                            return this.constructTransport(transport);
                        }
                        catch (ex) {
                            return ex;
                        }
                    }
                }
                else {
                    this.logger.log(LogLevel.Debug, "Skipping transport '" + HttpTransportType[transport] + "' because it does not support the requested transfer format '" + TransferFormat[requestedTransferFormat] + "'.");
                    return new Error("'" + HttpTransportType[transport] + "' does not support " + TransferFormat[requestedTransferFormat] + ".");
                }
            }
            else {
                this.logger.log(LogLevel.Debug, "Skipping transport '" + HttpTransportType[transport] + "' because it was disabled by the client.");
                return new Error("'" + HttpTransportType[transport] + "' is disabled by the client.");
            }
        }
    };
    HttpConnection.prototype.isITransport = function (transport) {
        return transport && typeof (transport) === "object" && "connect" in transport;
    };
    HttpConnection.prototype.stopConnection = function (error) {
        var _this = this;
        this.logger.log(LogLevel.Debug, "HttpConnection.stopConnection(" + error + ") called while in state " + this.connectionState + ".");
        this.transport = undefined;
        // If we have a stopError, it takes precedence over the error from the transport
        error = this.stopError || error;
        this.stopError = undefined;
        if (this.connectionState === "Disconnected" /* Disconnected */) {
            this.logger.log(LogLevel.Debug, "Call to HttpConnection.stopConnection(" + error + ") was ignored because the connection is already in the disconnected state.");
            return;
        }
        if (this.connectionState === "Connecting " /* Connecting */) {
            this.logger.log(LogLevel.Warning, "Call to HttpConnection.stopConnection(" + error + ") was ignored because the connection hasn't yet left the in the connecting state.");
            return;
        }
        if (this.connectionState === "Disconnecting" /* Disconnecting */) {
            // A call to stop() induced this call to stopConnection and needs to be completed.
            // Any stop() awaiters will be scheduled to continue after the onclose callback fires.
            this.stopPromiseResolver();
        }
        if (error) {
            this.logger.log(LogLevel.Error, "Connection disconnected with error '" + error + "'.");
        }
        else {
            this.logger.log(LogLevel.Information, "Connection disconnected.");
        }
        if (this.sendQueue) {
            this.sendQueue.stop().catch(function (e) {
                _this.logger.log(LogLevel.Error, "TransportSendQueue.stop() threw error '" + e + "'.");
            });
            this.sendQueue = undefined;
        }
        this.connectionId = undefined;
        this.connectionState = "Disconnected" /* Disconnected */;
        if (this.connectionStarted) {
            this.connectionStarted = false;
            try {
                if (this.onclose) {
                    this.onclose(error);
                }
            }
            catch (e) {
                this.logger.log(LogLevel.Error, "HttpConnection.onclose(" + error + ") threw error '" + e + "'.");
            }
        }
    };
    HttpConnection.prototype.resolveUrl = function (url) {
        // startsWith is not supported in IE
        if (url.lastIndexOf("https://", 0) === 0 || url.lastIndexOf("http://", 0) === 0) {
            return url;
        }
        if (!Platform.isBrowser || !window.document) {
            throw new Error("Cannot resolve '" + url + "'.");
        }
        // Setting the url to the href propery of an anchor tag handles normalization
        // for us. There are 3 main cases.
        // 1. Relative path normalization e.g "b" -> "http://localhost:5000/a/b"
        // 2. Absolute path normalization e.g "/a/b" -> "http://localhost:5000/a/b"
        // 3. Networkpath reference normalization e.g "//localhost:5000/a/b" -> "http://localhost:5000/a/b"
        var aTag = window.document.createElement("a");
        aTag.href = url;
        this.logger.log(LogLevel.Information, "Normalizing '" + url + "' to '" + aTag.href + "'.");
        return aTag.href;
    };
    HttpConnection.prototype.resolveNegotiateUrl = function (url) {
        var index = url.indexOf("?");
        var negotiateUrl = url.substring(0, index === -1 ? url.length : index);
        if (negotiateUrl[negotiateUrl.length - 1] !== "/") {
            negotiateUrl += "/";
        }
        negotiateUrl += "negotiate";
        negotiateUrl += index === -1 ? "" : url.substring(index);
        if (negotiateUrl.indexOf("negotiateVersion") === -1) {
            negotiateUrl += index === -1 ? "?" : "&";
            negotiateUrl += "negotiateVersion=" + this.negotiateVersion;
        }
        return negotiateUrl;
    };
    return HttpConnection;
}());
function transportMatches(requestedTransport, actualTransport) {
    return !requestedTransport || ((actualTransport & requestedTransport) !== 0);
}
/** @private */
var TransportSendQueue = /** @class */ (function () {
    function TransportSendQueue(transport) {
        this.transport = transport;
        this.buffer = [];
        this.executing = true;
        this.sendBufferedData = new PromiseSource();
        this.transportResult = new PromiseSource();
        this.sendLoopPromise = this.sendLoop();
    }
    TransportSendQueue.prototype.send = function (data) {
        this.bufferData(data);
        if (!this.transportResult) {
            this.transportResult = new PromiseSource();
        }
        return this.transportResult.promise;
    };
    TransportSendQueue.prototype.stop = function () {
        this.executing = false;
        this.sendBufferedData.resolve();
        return this.sendLoopPromise;
    };
    TransportSendQueue.prototype.bufferData = function (data) {
        if (this.buffer.length && typeof (this.buffer[0]) !== typeof (data)) {
            throw new Error("Expected data to be of type " + typeof (this.buffer) + " but was of type " + typeof (data));
        }
        this.buffer.push(data);
        this.sendBufferedData.resolve();
    };
    TransportSendQueue.prototype.sendLoop = function () {
        return __awaiter$5(this, void 0, void 0, function () {
            var transportResult, data, error_1;
            return __generator$5(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [4 /*yield*/, this.sendBufferedData.promise];
                    case 1:
                        _a.sent();
                        if (!this.executing) {
                            if (this.transportResult) {
                                this.transportResult.reject("Connection stopped.");
                            }
                            return [3 /*break*/, 6];
                        }
                        this.sendBufferedData = new PromiseSource();
                        transportResult = this.transportResult;
                        this.transportResult = undefined;
                        data = typeof (this.buffer[0]) === "string" ?
                            this.buffer.join("") :
                            TransportSendQueue.concatBuffers(this.buffer);
                        this.buffer.length = 0;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.transport.send(data)];
                    case 3:
                        _a.sent();
                        transportResult.resolve();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        transportResult.reject(error_1);
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 0];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    TransportSendQueue.concatBuffers = function (arrayBuffers) {
        var totalLength = arrayBuffers.map(function (b) { return b.byteLength; }).reduce(function (a, b) { return a + b; });
        var result = new Uint8Array(totalLength);
        var offset = 0;
        for (var _i = 0, arrayBuffers_1 = arrayBuffers; _i < arrayBuffers_1.length; _i++) {
            var item = arrayBuffers_1[_i];
            result.set(new Uint8Array(item), offset);
            offset += item.byteLength;
        }
        return result;
    };
    return TransportSendQueue;
}());
var PromiseSource = /** @class */ (function () {
    function PromiseSource() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            var _a;
            return _a = [resolve, reject], _this.resolver = _a[0], _this.rejecter = _a[1], _a;
        });
    }
    PromiseSource.prototype.resolve = function () {
        this.resolver();
    };
    PromiseSource.prototype.reject = function (reason) {
        this.rejecter(reason);
    };
    return PromiseSource;
}());
//# sourceMappingURL=HttpConnection.js.map
// Copyright (c) .NET Foundation. All rights reserved.
var JSON_HUB_PROTOCOL_NAME = "json";
/** Implements the JSON Hub Protocol. */
var JsonHubProtocol = /** @class */ (function () {
    function JsonHubProtocol() {
        /** @inheritDoc */
        this.name = JSON_HUB_PROTOCOL_NAME;
        /** @inheritDoc */
        this.version = 1;
        /** @inheritDoc */
        this.transferFormat = TransferFormat.Text;
    }
    /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
     *
     * @param {string} input A string containing the serialized representation.
     * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
     */
    JsonHubProtocol.prototype.parseMessages = function (input, logger) {
        // The interface does allow "ArrayBuffer" to be passed in, but this implementation does not. So let's throw a useful error.
        if (typeof input !== "string") {
            throw new Error("Invalid input for JSON hub protocol. Expected a string.");
        }
        if (!input) {
            return [];
        }
        if (logger === null) {
            logger = NullLogger.instance;
        }
        // Parse the messages
        var messages = TextMessageFormat.parse(input);
        var hubMessages = [];
        for (var _i = 0, messages_1 = messages; _i < messages_1.length; _i++) {
            var message = messages_1[_i];
            var parsedMessage = JSON.parse(message);
            if (typeof parsedMessage.type !== "number") {
                throw new Error("Invalid payload.");
            }
            switch (parsedMessage.type) {
                case MessageType.Invocation:
                    this.isInvocationMessage(parsedMessage);
                    break;
                case MessageType.StreamItem:
                    this.isStreamItemMessage(parsedMessage);
                    break;
                case MessageType.Completion:
                    this.isCompletionMessage(parsedMessage);
                    break;
                case MessageType.Ping:
                    // Single value, no need to validate
                    break;
                case MessageType.Close:
                    // All optional values, no need to validate
                    break;
                default:
                    // Future protocol changes can add message types, old clients can ignore them
                    logger.log(LogLevel.Information, "Unknown message type '" + parsedMessage.type + "' ignored.");
                    continue;
            }
            hubMessages.push(parsedMessage);
        }
        return hubMessages;
    };
    /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
     *
     * @param {HubMessage} message The message to write.
     * @returns {string} A string containing the serialized representation of the message.
     */
    JsonHubProtocol.prototype.writeMessage = function (message) {
        return TextMessageFormat.write(JSON.stringify(message));
    };
    JsonHubProtocol.prototype.isInvocationMessage = function (message) {
        this.assertNotEmptyString(message.target, "Invalid payload for Invocation message.");
        if (message.invocationId !== undefined) {
            this.assertNotEmptyString(message.invocationId, "Invalid payload for Invocation message.");
        }
    };
    JsonHubProtocol.prototype.isStreamItemMessage = function (message) {
        this.assertNotEmptyString(message.invocationId, "Invalid payload for StreamItem message.");
        if (message.item === undefined) {
            throw new Error("Invalid payload for StreamItem message.");
        }
    };
    JsonHubProtocol.prototype.isCompletionMessage = function (message) {
        if (message.result && message.error) {
            throw new Error("Invalid payload for Completion message.");
        }
        if (!message.result && message.error) {
            this.assertNotEmptyString(message.error, "Invalid payload for Completion message.");
        }
        this.assertNotEmptyString(message.invocationId, "Invalid payload for Completion message.");
    };
    JsonHubProtocol.prototype.assertNotEmptyString = function (value, errorMessage) {
        if (typeof value !== "string" || value === "") {
            throw new Error(errorMessage);
        }
    };
    return JsonHubProtocol;
}());
//# sourceMappingURL=JsonHubProtocol.js.map
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign$2 = (undefined && undefined.__assign) || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
    }
    return t;
};
// tslint:disable:object-literal-sort-keys
var LogLevelNameMapping = {
    trace: LogLevel.Trace,
    debug: LogLevel.Debug,
    info: LogLevel.Information,
    information: LogLevel.Information,
    warn: LogLevel.Warning,
    warning: LogLevel.Warning,
    error: LogLevel.Error,
    critical: LogLevel.Critical,
    none: LogLevel.None,
};
function parseLogLevel(name) {
    // Case-insensitive matching via lower-casing
    // Yes, I know case-folding is a complicated problem in Unicode, but we only support
    // the ASCII strings defined in LogLevelNameMapping anyway, so it's fine -anurse.
    var mapping = LogLevelNameMapping[name.toLowerCase()];
    if (typeof mapping !== "undefined") {
        return mapping;
    }
    else {
        throw new Error("Unknown log level: " + name);
    }
}
/** A builder for configuring {@link @microsoft/signalr.HubConnection} instances. */
var HubConnectionBuilder = /** @class */ (function () {
    function HubConnectionBuilder() {
    }
    HubConnectionBuilder.prototype.configureLogging = function (logging) {
        Arg.isRequired(logging, "logging");
        if (isLogger(logging)) {
            this.logger = logging;
        }
        else if (typeof logging === "string") {
            var logLevel = parseLogLevel(logging);
            this.logger = new ConsoleLogger(logLevel);
        }
        else {
            this.logger = new ConsoleLogger(logging);
        }
        return this;
    };
    HubConnectionBuilder.prototype.withUrl = function (url, transportTypeOrOptions) {
        Arg.isRequired(url, "url");
        this.url = url;
        // Flow-typing knows where it's at. Since HttpTransportType is a number and IHttpConnectionOptions is guaranteed
        // to be an object, we know (as does TypeScript) this comparison is all we need to figure out which overload was called.
        if (typeof transportTypeOrOptions === "object") {
            this.httpConnectionOptions = __assign$2({}, this.httpConnectionOptions, transportTypeOrOptions);
        }
        else {
            this.httpConnectionOptions = __assign$2({}, this.httpConnectionOptions, { transport: transportTypeOrOptions });
        }
        return this;
    };
    /** Configures the {@link @microsoft/signalr.HubConnection} to use the specified Hub Protocol.
     *
     * @param {IHubProtocol} protocol The {@link @microsoft/signalr.IHubProtocol} implementation to use.
     */
    HubConnectionBuilder.prototype.withHubProtocol = function (protocol) {
        Arg.isRequired(protocol, "protocol");
        this.protocol = protocol;
        return this;
    };
    HubConnectionBuilder.prototype.withAutomaticReconnect = function (retryDelaysOrReconnectPolicy) {
        if (this.reconnectPolicy) {
            throw new Error("A reconnectPolicy has already been set.");
        }
        if (!retryDelaysOrReconnectPolicy) {
            this.reconnectPolicy = new DefaultReconnectPolicy();
        }
        else if (Array.isArray(retryDelaysOrReconnectPolicy)) {
            this.reconnectPolicy = new DefaultReconnectPolicy(retryDelaysOrReconnectPolicy);
        }
        else {
            this.reconnectPolicy = retryDelaysOrReconnectPolicy;
        }
        return this;
    };
    /** Creates a {@link @microsoft/signalr.HubConnection} from the configuration options specified in this builder.
     *
     * @returns {HubConnection} The configured {@link @microsoft/signalr.HubConnection}.
     */
    HubConnectionBuilder.prototype.build = function () {
        // If httpConnectionOptions has a logger, use it. Otherwise, override it with the one
        // provided to configureLogger
        var httpConnectionOptions = this.httpConnectionOptions || {};
        // If it's 'null', the user **explicitly** asked for null, don't mess with it.
        if (httpConnectionOptions.logger === undefined) {
            // If our logger is undefined or null, that's OK, the HttpConnection constructor will handle it.
            httpConnectionOptions.logger = this.logger;
        }
        // Now create the connection
        if (!this.url) {
            throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
        }
        var connection = new HttpConnection(this.url, httpConnectionOptions);
        return HubConnection.create(connection, this.logger || NullLogger.instance, this.protocol || new JsonHubProtocol(), this.reconnectPolicy);
    };
    return HubConnectionBuilder;
}());
function isLogger(logger) {
    return logger.log !== undefined;
}
var OmnibarUnifiedNotifications = /** @class */ (function () {
    function class_21(hostRef) {
        registerInstance(this, hostRef);
        this.authenticated = false;
        this.badgeCount = 0;
        this.stompClient = null;
        this.toast = {};
        this.omnibarNotificationsAsideOpen = createEvent(this, "omnibarNotificationsAsideOpen", 7);
    }
    class_21.prototype.apiConfigChanged = function () {
        if (!this.api.accessToken || !this.api.environment || this.api.environment === 'local')
            return;
        // Make API calls here
        this.apiClient = createClient('notifications', this.api);
        this.apiSocketClient = createClient('notificationsignalr', this.api);
        this.getBadgeCount();
        // Commented for future push notifications usage
        //this.getToastNotification()
        if (this.connection !== null && this.connection !== undefined)
            this.connection.stop();
        if (this.api.environment && this.api.environment !== 'mock')
            this.connectToSockJS();
    };
    class_21.prototype.componentDidUnload = function () {
        if (this.api.environment && !(this.api.environment === 'mock' || this.api.environment === 'local') && this.unNotificationSubscription)
            this.unNotificationSubscription.unsubscribe();
        if (this.connection !== null && this.connection !== undefined)
            this.connection.stop();
    };
    class_21.prototype.onMenuClick = function (ev) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                // if (ev.detail.name === 'Notifications' && (!this.notifications || this.badgeCount != 0)) {
                if (ev.detail.name === 'Notifications') {
                    this.getNotifications();
                }
                return [2 /*return*/];
            });
        });
    };
    class_21.prototype.handleViewNotifications = function (item) {
        this.omnibarNotificationsAsideOpen.emit(item);
    };
    class_21.prototype.handleDismissNotifications = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        if (!(item.detail !== null && item.detail !== undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiClient.updateNotificationsStatus([{ isDismiss: true, notificationId: item.detail.id }])];
                    case 1:
                        _g = _h.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.apiClient.updateAllNotificationsStatus({ isDismiss: true })];
                    case 3:
                        _g = _h.sent();
                        _h.label = 4;
                    case 4:
                        _g;
                        this.getNotifications();
                        return [2 /*return*/];
                }
            });
        });
    };
    class_21.prototype.handleUpdateStatus = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, this.apiClient.updateNotificationsStatus([{ isRead: true, notificationId: item.detail.id }])];
                    case 1:
                        _g.sent();
                        this.getNotifications();
                        return [2 /*return*/];
                }
            });
        });
    };
    class_21.prototype.getBadgeCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        _g = this;
                        return [4 /*yield*/, this.apiClient.getNotificationCount()];
                    case 1:
                        _g.badgeCount = _h.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    class_21.prototype.getNotifications = function () {
        return __awaiter(this, void 0, void 0, function () {
            var notifications, realpageAlerts, _g;
            var _this_1 = this;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        this.selectedTab = 'myNotification';
                        return [4 /*yield*/, this.apiClient.getNotifications()];
                    case 1:
                        notifications = _h.sent();
                        return [4 /*yield*/, this.apiClient.getPlatformAlertRealpageAlerts()];
                    case 2:
                        realpageAlerts = _h.sent();
                        notifications = notifications.reverse().splice(0, 5);
                        this.tabs = [{
                                label: "My Notifications",
                                name: "myNotification"
                            }, {
                                label: "From RealPage (" + realpageAlerts.length + ")",
                                name: "realpage"
                            }];
                        realpageAlerts = realpageAlerts.splice(0, 5);
                        if (!!this.lookupData) return [3 /*break*/, 4];
                        _g = this;
                        return [4 /*yield*/, this.apiClient.getLookupData()];
                    case 3:
                        _g.lookupData = _h.sent();
                        _h.label = 4;
                    case 4:
                        if (this.lookupData) {
                            notifications.forEach(function (item) {
                                if (item.actions.length > 2) {
                                    item.moreActions = item.actions.splice(2, item.actions.length);
                                }
                                item.iconClass = _this_1.lookupData.notificationTypes.find(function (type) { return type.id === item.notificationTypeId; }).icon;
                            });
                        }
                        this.notifications = notifications;
                        this.realpageAlerts = realpageAlerts;
                        return [2 /*return*/];
                }
            });
        });
    };
    class_21.prototype.bindToastNotifications = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _loop_2, this_2, index;
            var _this_1 = this;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _loop_2 = function (index) {
                            return __generator(this, function (_g) {
                                switch (_g.label) {
                                    case 0:
                                        this_2.toast.notification[index].item = this_2.toast.notification[index];
                                        this_2.toast.notification[index].this = this_2;
                                        this_2.toast.notification[index].actions = this_2.toast.notification[index].actions ? this_2.toast.notification[index].actions : [];
                                        if (!!this_2.lookupData) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this_2.apiClient.getLookupData()];
                                    case 1:
                                        this_2.lookupData = _g.sent();
                                        _g.label = 2;
                                    case 2:
                                        if (this_2.lookupData.notificationTypes.find(function (type) { return type.id === _this_1.toast.notification[index].notificationTypeId; })) {
                                            this_2.toast.notification[index].iconClass = this_2.lookupData.notificationTypes.find(function (type) { return type.id === _this_1.toast.notification[index].notificationTypeId; }).icon;
                                        }
                                        if (this_2.toast.notification && !document.hidden)
                                            createNotificationToast(this_2.toast.notification[index]);
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_2 = this;
                        index = 0;
                        _g.label = 1;
                    case 1:
                        if (!(index < this.count)) return [3 /*break*/, 4];
                        return [5 /*yield**/, _loop_2(index)];
                    case 2:
                        _g.sent();
                        _g.label = 3;
                    case 3:
                        index++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.toast.notification.splice(0, this.count);
                        if (this.toast && this.toast.notificationCount > 0) {
                            this.count = this.toast.notificationCount - 4 > 0 ? this.toast.notificationCount - 4 : this.toast.notificationCount;
                            this.toast.notificationCount = this.toast.notificationCount - 4 > 0 ? this.toast.notificationCount - 4 : 0;
                            this.interval = window.setInterval(function () {
                                _this_1.bindToastNotifications();
                            }, 5000);
                        }
                        else {
                            clearInterval(this.interval);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    class_21.prototype.getToastNotification = function () {
        this.toast.notificationCount = this.toast.notification.length;
        this.count = this.toast.notificationCount - 4 > 0 ? 4 : this.toast.notificationCount;
        this.toast.notificationCount = this.toast.notificationCount - 4 > 0 ? this.toast.notificationCount - 4 : 0;
        this.bindToastNotifications();
    };
    class_21.prototype.connectToSockJS = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            var _this_1 = this;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!(!this.connection || (this.connection && this.connection.connectionState !== 'Connected' && this.connection.connectionState !== 'Connecting'))) return [3 /*break*/, 4];
                        this.connection = new HubConnectionBuilder()
                            .withUrl(this.apiSocketClient.server + "/hubs/messages", {
                            accessTokenFactory: function () { return _this_1.api.accessToken; },
                            skipNegotiation: true,
                            transport: HttpTransportType.WebSockets
                        })
                            .withAutomaticReconnect()
                            .build();
                        this.connection.on("ReceiveMessage", function (data) {
                            if (data.messageHandlerNamespace === "Notifications_events") {
                                try {
                                    eval(data.messageData);
                                }
                                catch (err) {
                                    console.log(err);
                                }
                            }
                            else if (data.messageHandlerNamespace === "Notifications_updateTotal") {
                                _this_1.getBadgeCount();
                            }
                            else if (data.messageHandlerNamespace === "Notifications_newMessage") {
                                _this_1.getBadgeCount();
                                if (_this_1.toast.notification && _this_1.toast.notification.length > 0) {
                                    if (data.messageData instanceof Array === true) {
                                        _this_1.toast
                                            .notification = _this_1.toast
                                            .notification.concat(data.messageData);
                                    }
                                    else {
                                        _this_1.toast
                                            .notification.push(data.messageData);
                                    }
                                }
                                else {
                                    _this_1.toast.notification = [];
                                    if (data.messageData instanceof Array === true) {
                                        _this_1.toast.notification = data.messageData;
                                    }
                                    else {
                                        _this_1.toast.notification.push(data.messageData);
                                    }
                                }
                                if (_this_1.toast.notification.length > 0) {
                                    _this_1.getToastNotification();
                                }
                            }
                        });
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.connection.start()
                                .catch(function (err) {
                                setTimeout(function () { return _this_1.connection.start(); }, 5000);
                                console.log(err + ' : ' + new Date().toString());
                                console.log(_this_1);
                            })];
                    case 2:
                        _g.sent();
                        console.log(new Date() + " : " + "Connected");
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _g.sent();
                        setTimeout(function () { return _this_1.connection.start(); }, 5000);
                        console.log(err_1 + ' : ' + new Date().toString());
                        console.log(this);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    class_21.prototype.notificationsTabChange = function (e) {
        this.selectedTab = e.detail;
    };
    class_21.prototype.render = function () {
        var _this_1 = this;
        if (this.authenticated) {
            return (h(Host, null, h("div", { class: "o-unified-notifications" }, h("omnibar-unified-menu-item", { "badge-count": this.badgeCount, "menu-name": "Notifications", icon: "omnibar-notifications" }, h("omnibar-tabs", { class: "o-unified-notifications__tabs", onOmnibarTabChange: function (e) { return _this_1.notificationsTabChange(e); }, activeTab: this.selectedTab, tabs: this.tabs }), h("omnibar-unified-notifications-items", { items: this.notifications, realpageItems: this.realpageAlerts, selectedTab: this.selectedTab }), h("omnibar-unified-notifications-footer", { items: this.notifications, url: "#", selectedTab: this.selectedTab })))));
        }
    };
    Object.defineProperty(class_21, "watchers", {
        get: function () {
            return {
                "api": ["apiConfigChanged"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_21, "style", {
        get: function () { return ".o-omnibar .o-unified-notifications{height:100%}.o-omnibar .o-unified-notifications__tabs{padding:.5rem}.o-omnibar .o-unified-notifications__footer{border-top:1px solid #e4e6e7}.o-omnibar .o-unified-notifications__footer div{border-width:0;font-size:.875rem;font-weight:400;line-height:1;text-align:left;width:100%;color:#0076cc;padding:.8125rem}.o-omnibar .o-unified-notifications__items__action{border-width:0;font-size:.75rem;font-weight:400;line-height:1;text-align:left;width:100%;color:#0076cc}.o-omnibar .o-unified-notifications .type-icon{background:#ebedee;border-radius:50px;border-width:7px}.o-omnibar .o-unified-notifications .icon-color{color:#9ba3a7;font-size:20px}.o-omnibar .o-unified-notifications .dismiss-icon{color:#b8bec1;font-size:20px;position:absolute;right:30px}.o-omnibar .o-unified-notifications .o-section{position:relative;min-width:350px;min-height:90px}.o-omnibar .o-unified-notifications .o-item__row{display:-ms-flexbox;display:flex;width:100%;padding-top:1rem;padding-bottom:1rem;padding-right:1.5rem;padding-left:.75rem;text-decoration:none;cursor:pointer;border-bottom:1px solid #e4e6e7}.o-omnibar .o-unified-notifications .o-item__row:hover{background:#f7f8f9}.o-omnibar .o-unified-notifications .o-item__row:hover .o-item__header-time-stamp{display:none}.o-omnibar .o-unified-notifications .o-item__row:hover .o-item__header-arrow{display:inline-block}.o-omnibar .o-unified-notifications .o-item__row:last-child{border-color:transparent}.o-omnibar .o-unified-notifications .o-item__row:visited{color:#e4e6e7}.o-omnibar .o-unified-notifications .o-item__status-wrapper{padding:1.75rem 0}.o-omnibar .o-unified-notifications .o-item__body{margin-left:.5rem;-ms-flex-positive:1;flex-grow:1;min-width:0}\@media (min-width:768px){.o-omnibar .o-unified-notifications .o-item__body{max-width:294px}}.o-omnibar .o-unified-notifications .o-item__body omnibar-status{margin-top:.5rem}.o-omnibar .o-unified-notifications .o-item__status{width:9px;height:9px;border-radius:50%;left:25px}.o-omnibar .o-unified-notifications .o-item__status--unread{background:#f65216}.o-omnibar .o-unified-notifications .o-item__text{font-size:.875rem;color:#303436}.o-omnibar .o-unified-notifications .o-item__text-subject{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:.875rem;margin-bottom:.25rem;width:100%;line-height:.9375rem;font-weight:500;color:#303436}.o-omnibar .o-unified-notifications .o-item__text-message{color:#666c6f;min-width:0}.o-omnibar .o-unified-notifications .o-item__text-message div{overflow:hidden;-ms-flex-positive:1;flex-grow:1;white-space:nowrap;text-overflow:ellipsis}.o-omnibar .o-unified-notifications .o-item__render-text ol,.o-omnibar .o-unified-notifications .o-item__render-text ul{list-style:revert;margin:revert;padding:revert;padding-left:15px!important}.o-omnibar .o-unified-notifications .o-item__render-text.o-truncate *{all:unset;margin:0!important;padding:0!important;white-space:no-wrap!important}.o-omnibar .o-unified-notifications .o-item__header{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;font-size:.75rem;margin-bottom:.5rem;width:100%;color:#5f6c71}.o-omnibar .o-unified-notifications .o-item__header-time-stamp{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.o-omnibar .o-unified-notifications .o-item__header-arrow{display:none}.o-omnibar .o-unified-notifications .o-item__priority{font-size:.75rem;display:inline-block;margin-top:.25rem;font-weight:500;padding:.1875rem 6px;color:#d01a1f;background-color:#fae8e9}.o-omnibar .o-unified-notifications .o-dropdown-menu__menu-item :not(.o-dropdown-menu__menu-item--disabled) .o-dropdown-menu__menu-item__label{font-weight:400!important;color:#0076cc!important}"; },
        enumerable: true,
        configurable: true
    });
    return class_21;
}());
ShellTunnel.injectProps(OmnibarUnifiedNotifications, ['api', 'authenticated']);
var OmnibarUnifiedNotificationsAside = /** @class */ (function () {
    function class_22(hostRef) {
        registerInstance(this, hostRef);
        this.priorityOptions = [
            { text: 'High Priority', value: 'true' },
            { text: 'Unread', value: 'false' },
        ];
        this.sortOptions = [
            { text: 'A - Z', value: 'Title_false' },
            { text: 'Z - A', value: 'Title_true' },
            { text: 'Newest - Oldest', value: 'CreatedDate_true' },
            { text: 'Oldest - Newest', value: 'CreatedDate_false' },
        ];
        this.opened = false;
        this.selectedItem = null;
        this.loading = true;
        this.notifications = [];
        this.realpageNotifications = [];
        this.products = [];
        this.selectedNotificationsIds = [];
        this.queryParams = { limit: 10, offset: 1, orderBy: 'CreatedDate', IsDesc: true };
        this.gridBodyId = 0;
        this.searchValue = '';
        this.productsValue = '';
        this.priorityValue = '';
        this.sortValue = '';
        this.dateValue = [];
        this.draftProductsValue = '';
        this.draftPriorityValue = '';
        this.draftSortValue = '';
        this.draftDateValue = [];
        this.productsLoading = false;
        this.noProductsFound = false;
        this.tabs = [{
                label: "My Notifications",
                name: "myNotification"
            }, {
                label: "RealPage Alerts",
                name: "realpage"
            }];
        this.getProductCategoriesFinished = false;
        this.omnibarNotificationsAsideClose = createEvent(this, "omnibarNotificationsAsideClose", 7);
    }
    class_22.prototype.openedChanged = function () {
        this.opened ? this.notificationsAsideEl.open() : this.notificationsAsideEl.close();
    };
    class_22.prototype.queryParamsChanged = function () {
        this.getNotifications();
    };
    class_22.prototype.deleteConfirmationModalOpenedChange = function () {
        console.log(document.querySelector('omnibar-modal'));
        // this.deleteModal.active
    };
    class_22.prototype.apiConfigChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_g) {
                if (this.api.accessToken || this.api.environment) {
                    this.notificationsApiClient = createClient('notifications', this.api);
                    this.userApiClient = createClient('unity', this.api);
                    this.selectedTab = this.selectedItem.selectedTab;
                    this.userApiClient.getUserProfile().then(function (profile) {
                        _this_1.realpageId = profile.user.realPageId;
                    });
                    this.getCategories().then(function (productId) {
                        _this_1.firstPreferrenceProductId = productId;
                    });
                    if (this.selectedTab == 'myNotification') {
                        this.getNotifications();
                    }
                    else {
                        this.getRealpageNotifications();
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    class_22.prototype.componentDidLoad = function () {
        var _this_1 = this;
        requestAnimationFrame(function () {
            if (_this_1.opened)
                _this_1.notificationsAsideEl.open();
        });
        this.sortValue = 'CreatedDate_true';
    };
    class_22.prototype.processedQueryParams = function () {
        if (this.selectedItem !== null) {
            this.queryParams.productIds = this.selectedItem.productId;
            this.selectedItem = this.selectedItem.isShow === true ? this.selectedItem : null;
            this.getProductNames();
        }
        return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, this.queryParams.limit && { pageSize: this.queryParams.limit }), this.queryParams.offset && { pageNumber: this.queryParams.offset }), this.queryParams.priority && { priority: Boolean(this.queryParams.priority) }), this.queryParams.productIds && { productId: this.queryParams.productIds }), this.queryParams.searchKeyword && { searchTerm: this.queryParams.searchKeyword }), this.queryParams.orderBy && { orderBy: this.queryParams.orderBy }), this.queryParams.IsDesc && { IsDesc: this.queryParams.IsDesc }), this.queryParams.startDate && { startDate: this.queryParams.startDate }), this.queryParams.endDate && { endDate: this.queryParams.endDate }), this.queryParams.productTileId && { productTileId: this.queryParams.productTileId }), this.queryParams.read !== undefined && { isRead: this.queryParams.read }), this.selectedItem !== null && this.selectedItem.isShow === true && { id: this.selectedItem !== null && this.selectedItem.isShow === true ? this.selectedItem.id : undefined });
    };
    class_22.prototype.allNotificationsSelected = function () {
        if (this.queryParams.priority || this.queryParams.productIds || this.queryParams.productTileId ||
            this.queryParams.read || this.queryParams.searchKeyword || this.queryParams.startDate || this.queryParams.endDate) {
            return false;
        }
        else {
            return this.selectedNotificationsIds.length === this.notificationsCount;
        }
    };
    class_22.prototype.allVisibleNotificationsSelected = function () {
        var _this_1 = this;
        return this.notificationsIds().every(function (id) { return _this_1.selectedNotificationsIds.includes(id); });
    };
    class_22.prototype.someNotificationsSelected = function () {
        return this.selectedNotificationsIds.length && !this.allVisibleNotificationsSelected();
    };
    class_22.prototype.notificationsIds = function () {
        return this.notifications.map(function (n) { return n.id; });
    };
    class_22.createConfirmationToast = function (heading) {
        window.OMNIBAR.commands.toast({
            tagName: 'omnibar-snackbar',
            variant: 'success',
            dismissable: true,
            timeout: 3000,
            heading: heading,
        });
    };
    class_22.prototype.getNotifications = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, item, index;
            var _this_1 = this;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.notificationsApiClient.getFilteredNotifications(this.processedQueryParams())];
                    case 1:
                        response = _g.sent();
                        this.notificationsCount = response.paging.totalRecords;
                        this.queryParams.offset = response.paging.pageNumber;
                        this.notifications = response.notifications;
                        if (this.selectedItem !== null && this.selectedItem.isShow === true) {
                            item = this.notifications.find(function (data) { return data.id === _this_1.selectedItem.id; });
                            if (item) {
                                index = this.notifications.indexOf(item);
                                this.notifications[index].isShow = true;
                                this.selectedItem = null;
                            }
                        }
                        this.gridBodyId++;
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    class_22.prototype.getCategories = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, userProductList, result, uniqueData;
            var _this_1 = this;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, this.notificationsApiClient.getProductCategories()];
                    case 1:
                        response = _g.sent();
                        userProductList = [];
                        Object.keys(this.unityProducts).forEach(function (key) {
                            _this_1.unityProducts[key].forEach(function (k) {
                                userProductList.push(k);
                            });
                        });
                        this.unityResources.forEach(function (r) {
                            userProductList.push(r);
                        });
                        result = response.filter(function (n) {
                            return userProductList.find(function (item) { return item.productCode === n.productCode; });
                        });
                        uniqueData = this.uniqueBy(result, function (o1, o2) { return o1.productTileId === o2.productTileId; });
                        this.getProductCategoriesFinished = true;
                        return [2 /*return*/, uniqueData[0].productTileId];
                }
            });
        });
    };
    class_22.prototype.uniqueBy = function (data, cond) {
        return data.filter(function (e, i) { return data.findIndex(function (e2) { return cond(e, e2); }) === i; });
    };
    class_22.prototype.getRealpageNotifications = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.notificationsApiClient.getPlatformAlertRealpageAlerts()];
                    case 1:
                        response = _g.sent();
                        this.realpageNotifications = response;
                        if (this.selectedItem !== null && this.selectedItem.isShow === true) {
                            if (this.realpageNotifications[this.selectedItem.index]) {
                                this.realpageNotifications[this.selectedItem.index].isShow = true;
                                this.selectedItem = null;
                            }
                        }
                        this.gridBodyId++;
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    class_22.prototype.getProductNames = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, products_1, groupInfo, _g, _h, key;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!!this.products.length) return [3 /*break*/, 2];
                        this.productsLoading = true;
                        this.noProductsFound = false;
                        return [4 /*yield*/, this.notificationsApiClient.geProductsByUser()];
                    case 1:
                        response = _j.sent();
                        products_1 = [{ text: 'All Products', value: '' }];
                        console.log('getProductNames', response);
                        groupInfo = response.reduce(function (r, a) {
                            r[a.productTileName] = __spreadArrays(r[a.productTileName] || [], [a]);
                            return r;
                        }, {});
                        for (_g = 0, _h = Object.entries(groupInfo); _g < _h.length; _g++) {
                            key = _h[_g][0];
                            products_1.push({ text: key, value: groupInfo[key].length > 0 ? 'parent_' + groupInfo[key][0].productTileId.toString() : '' });
                            groupInfo[key].forEach(function (element) {
                                products_1.push({ text: '\xA0\xA0\xA0\xA0' + element.name, value: element.id.toString(), isChild: true });
                            });
                        }
                        this.products = __spreadArrays(products_1);
                        this.noProductsFound = this.products.length === 0;
                        this.productsLoading = false;
                        if (this.queryParams.productIds) {
                            this.productsValue = this.queryParams.productIds.toString();
                        }
                        _j.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    class_22.prototype.deleteNotifications = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!this.toBeDeletedAllNotifications) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.notificationsApiClient.updateAllNotificationsStatus({ isDelete: true })];
                    case 1:
                        _g.sent();
                        this.selectedNotificationsIds = [];
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.notificationsApiClient.updateNotificationsStatus(this.updateRequest(true, this.toBeDeletedNotificationIds, 'isDelete'))];
                    case 3:
                        _g.sent();
                        this.selectedNotificationsIds = this.selectedNotificationsIds.filter(function (id) { return !_this_1.toBeDeletedNotificationIds.includes(id); });
                        _g.label = 4;
                    case 4:
                        OmnibarUnifiedNotificationsAside.createConfirmationToast("Notification" + (this.toBeDeletedAllNotifications || this.toBeDeletedNotificationIds.length !== 1 ? 's' : '') + " Deleted Successfully");
                        this.getNotifications();
                        this.closeDeleteConfirmationModal();
                        return [2 /*return*/];
                }
            });
        });
    };
    class_22.prototype.updateRequest = function (status, ids, type) {
        var request = [];
        ids.forEach(function (item) {
            var _g;
            request.push((_g = {},
                _g[type] = status,
                _g.notificationId = item,
                _g));
        });
        return request;
    };
    class_22.prototype.updateNotificationsStatus = function (status, notificationsIds, showConfirmation) {
        if (showConfirmation === void 0) { showConfirmation = true; }
        return __awaiter(this, void 0, void 0, function () {
            var _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        this.loading = true;
                        if (!this.allNotificationsSelected()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.notificationsApiClient.updateAllNotificationsStatus({ isRead: status })];
                    case 1:
                        _g = _h.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.notificationsApiClient.updateNotificationsStatus(this.updateRequest(status, notificationsIds, 'isRead'))];
                    case 3:
                        _g = _h.sent();
                        _h.label = 4;
                    case 4:
                        _g;
                        this.loading = false;
                        if (showConfirmation) {
                            OmnibarUnifiedNotificationsAside.createConfirmationToast("Notification" + (this.allNotificationsSelected() || notificationsIds.length !== 1 ? 's' : '') + " Updated Successfully");
                        }
                        this.notifications.forEach(function (n) {
                            if (notificationsIds.includes(n.id))
                                n.isRead = status;
                        });
                        this.notifications = __spreadArrays(this.notifications);
                        return [2 /*return*/];
                }
            });
        });
    };
    class_22.prototype.bulkUpdateNotificationsStatus = function (status, notificationsIds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, this.updateNotificationsStatus(status, notificationsIds)];
                    case 1:
                        _g.sent();
                        this.selectedNotificationsIds = [];
                        return [2 /*return*/];
                }
            });
        });
    };
    class_22.prototype.openDeleteConfirmationModal = function (notificationIds, toBeDeletedAllNotifications) {
        if (toBeDeletedAllNotifications === void 0) { toBeDeletedAllNotifications = false; }
        this.toBeDeletedNotificationIds = notificationIds;
        this.toBeDeletedAllNotifications = toBeDeletedAllNotifications;
        this.deleteConfirmationModalOpened = true;
    };
    class_22.prototype.closeDeleteConfirmationModal = function () {
        this.toBeDeletedNotificationIds = [];
        this.toBeDeletedAllNotifications = false;
        this.deleteConfirmationModalOpened = false;
    };
    class_22.prototype.selectAllNotifications = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, response, notificationsIds;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        this.loading = true;
                        queryParams = Object.assign({}, this.processedQueryParams());
                        queryParams.pageSize = this.notificationsCount;
                        queryParams.pageNumber = 1;
                        return [4 /*yield*/, this.notificationsApiClient.getFilteredNotifications(queryParams)];
                    case 1:
                        response = _g.sent();
                        notificationsIds = response.notifications.map(function (n) { return n.id; });
                        this.selectedNotificationsIds = __spreadArrays(notificationsIds);
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    class_22.prototype.deselectAllNotifications = function () {
        this.selectedNotificationsIds = [];
    };
    class_22.prototype.handleAllVisibleNotificationsChange = function (e) {
        var _this_1 = this;
        e.preventDefault();
        this.selectedNotificationsIds = e.target.checked || this.someNotificationsSelected()
            ? Array.from(new Set(__spreadArrays(this.selectedNotificationsIds, this.notificationsIds())))
            : this.selectedNotificationsIds.filter(function (id) { return !_this_1.notificationsIds().includes(id); });
    };
    class_22.prototype.handleNotificationChange = function (e) {
        e.detail.selected
            ? this.selectedNotificationsIds = __spreadArrays(this.selectedNotificationsIds, [e.target.uuid])
            : this.selectedNotificationsIds = this.selectedNotificationsIds.filter(function (id) { return id !== e.target.uuid; });
    };
    class_22.prototype.changePage = function (e) {
        var offset = e.detail.currentPage;
        this.queryParams = Object.assign(Object.assign({}, this.queryParams), { limit: e.detail.rowsPerPage, offset: offset });
    };
    class_22.prototype.handleSearchKeywordChange = function (e) {
        var _this_1 = this;
        this.selectedNotificationsIds = [];
        var ignoredKeys = __spreadArrays(NAVIGATION_KEYS, [TAB_KEY]);
        if (!ignoredKeys.includes(e.key)) {
            clearTimeout(this.searchKeywordTimeout);
            this.searchKeywordTimeout = setTimeout(function () {
                _this_1.searchValue = e.target.value;
                _this_1.queryParams = Object.assign(Object.assign({}, _this_1.queryParams), { offset: 1, searchKeyword: e.target.value });
            }, 500);
        }
    };
    class_22.prototype.handlePriorityChange = function (e) {
        this.selectedNotificationsIds = [];
        this.draftPriorityValue = e.detail.value;
        this.draftQueryParams = Object.assign(Object.assign({}, this.queryParams), { offset: 1, priority: e.detail.value.find(function (item) { return item === 'true'; }) ? 'true' : undefined, read: e.detail.value.find(function (item) { return item === 'false'; }) ? false : undefined });
        if (this.screenSize !== 'sm') {
            this.priorityValue = this.draftPriorityValue;
            this.queryParams = Object.assign({}, this.draftQueryParams);
        }
    };
    class_22.prototype.handleProductsChange = function (e) {
        this.selectedNotificationsIds = [];
        var selectedRecord = this.products.find(function (item) { return item.value === e.detail.value; });
        this.draftProductsValue = e.detail.value;
        this.draftQueryParams = Object.assign(Object.assign({}, this.queryParams), { offset: 1, productIds: selectedRecord.isChild ? e.detail.value : undefined, productTileId: !selectedRecord.isChild ? e.detail.value.split('parent_')[1] : undefined //.map(product => parseInt(product))
        });
        if (this.screenSize !== 'sm') {
            this.productsValue = this.draftProductsValue;
            this.queryParams = Object.assign({}, this.draftQueryParams);
        }
    };
    class_22.prototype.handleSortChange = function (e) {
        this.selectedNotificationsIds = [];
        var sortItems = e.detail.value.split('_');
        var orderBy = sortItems[0];
        var IsDesc = sortItems[1];
        this.draftSortValue = e.detail.value;
        this.draftQueryParams = Object.assign(Object.assign({}, this.queryParams), { offset: 1, orderBy: orderBy, IsDesc: IsDesc });
        if (this.screenSize !== 'sm') {
            this.sortValue = this.draftSortValue;
            this.queryParams = Object.assign({}, this.draftQueryParams);
        }
    };
    class_22.prototype.handleDateChange = function (e) {
        var _g = e.detail, startDate = _g.startDate, endDate = _g.endDate;
        if ((startDate && endDate) || (!startDate && !endDate)) {
            this.selectedNotificationsIds = [];
            this.draftDateValue = [startDate, endDate];
            this.draftQueryParams = Object.assign(Object.assign({}, this.queryParams), { offset: 1, startDate: startDate ? startDate.getFullYear() + "-" + ('0' + (startDate.getMonth() + 1)).slice(-2) + "-" + ('0' + startDate.getDate()).slice(-2) : null, endDate: endDate ? endDate.getFullYear() + "-" + ('0' + (endDate.getMonth() + 1)).slice(-2) + "-" + ('0' + endDate.getDate()).slice(-2) : null });
            this.draftQueryParams.startDate = this.draftQueryParams.startDate !== null ?
                hooks(this.draftQueryParams.startDate + 'T00:00:00').utc().format('YYYY-MM-DDTHH:mm:ss') : this.draftQueryParams.startDate;
            this.draftQueryParams.endDate = this.draftQueryParams.endDate !== null ?
                hooks(this.draftQueryParams.endDate + 'T23:59:59').utc().format('YYYY-MM-DDTHH:mm:ss') : this.draftQueryParams.startDate;
            if (this.screenSize !== 'sm') {
                this.dateValue = this.draftDateValue;
                this.queryParams = Object.assign({}, this.draftQueryParams);
            }
        }
    };
    class_22.prototype.cancelFilters = function () {
        this.draftQueryParams = Object.assign({}, this.queryParams);
        this.filtersAsideEl.close();
    };
    class_22.prototype.applyFilters = function () {
        this.selectedNotificationsIds = [];
        this.queryParams = Object.assign({}, this.draftQueryParams);
        this.filtersAsideEl.close();
    };
    class_22.prototype.formattedNotificationDate = function (date) {
        var utcDate = hooks.utc(date).toDate();
        return hooks(utcDate).format('MM/DD/YYYY hh:mm A');
    };
    class_22.prototype.notificationsTabChange = function (e) {
        this.selectedTab = e.detail;
        if (this.selectedTab == 'myNotification') {
            this.queryParams.limit = 10;
            this.queryParams.offset = 1;
            this.getNotifications();
        }
        else if (this.selectedTab == 'realpage') {
            this.getRealpageNotifications();
        }
    };
    class_22.prototype.navigateToUserPrefrenceLink = function () {
        var productId = this.firstPreferrenceProductId ? this.firstPreferrenceProductId : '';
        window.open(environments[this.api.environment].unityHome + '/people/manage-profile/' + this.realpageId + '/preferences/notifications/' + productId, '_blank');
    };
    class_22.prototype.render = function () {
        var _this_1 = this;
        var renderNotifications = function () {
            if (_this_1.notifications.length) {
                return [
                    h("omnibar-grid", null, h("omnibar-grid-body", null, h("omnibar-grid-row", null, h("omnibar-grid-cell", null, h("omnibar-checkbox", { "label-text": "Select All" }, h("input", { type: "checkbox", checked: _this_1.allVisibleNotificationsSelected(), onClick: function (e) { return _this_1.handleAllVisibleNotificationsChange(e); }, ref: function (el) { return el && (el.indeterminate = _this_1.someNotificationsSelected()); } })))))),
                    h("omnibar-bulk-action-bar", { open: !!_this_1.selectedNotificationsIds.length, selectedCount: _this_1.selectedNotificationsIds.length, totalRecords: _this_1.notificationsCount, onBulkActionsSelectAll: function () { _this_1.selectAllNotifications(); }, onBulkActionsClose: function () { _this_1.deselectAllNotifications(); } }, h("omnibar-button", { variant: "reverse", size: "small", onClick: function () { return _this_1.bulkUpdateNotificationsStatus(true, _this_1.selectedNotificationsIds); } }, "Mark as Read"), h("omnibar-button", { variant: "reverse", size: "small", onClick: function () { return _this_1.bulkUpdateNotificationsStatus(false, _this_1.selectedNotificationsIds); } }, "Mark as Unread"), h("omnibar-button", { variant: "reverse", size: "small", onClick: function () {
                            _this_1.openDeleteConfirmationModal(_this_1.selectedNotificationsIds, _this_1.allNotificationsSelected());
                        } }, "Delete ")),
                    h("omnibar-grid", null, h("omnibar-grid-body", { key: _this_1.gridBodyId }, _this_1.notifications.map(function (notification) { return h("omnibar-unified-notifications-aside-notification", { uuid: notification.id, name: notification.title, message: notification.message, date: _this_1.formattedNotificationDate(notification.createdDate), product: notification.productName, severity: notification.priority, selected: _this_1.selectedNotificationsIds.includes(notification.id), read: notification.isRead, screenSize: _this_1.screenSize, actions: notification.actions, isShow: notification.isShow, onOmnibarChange: function (e) { return _this_1.handleNotificationChange(e); }, onOmnibarStatusUpdate: function (e) {
                            _this_1.updateNotificationsStatus(e.detail['read'], [e.target['uuid']], e.detail['showConfirmation']);
                        }, onOmnibarDelete: function (e) { return _this_1.openDeleteConfirmationModal([e.target['uuid']]); }, key: notification.id }); }))),
                    h("omnibar-paging-bar", { rowsPerPage: _this_1.queryParams.limit, totalRows: _this_1.notificationsCount, currentPage: _this_1.queryParams.offset, onPagingChange: function (e) { return _this_1.changePage(e); } })
                ];
            }
            else {
                return (h("div", { class: "o-text-center o-mt-5" }, "No results were found"));
            }
        };
        var renderRealpageNotifications = function () {
            if (_this_1.realpageNotifications.length) {
                return [
                    h("omnibar-grid", null, h("omnibar-grid-body", { key: _this_1.gridBodyId }, _this_1.realpageNotifications.map(function (notification) { return h("omnibar-unified-notifications-aside-realpagealerts", { name: notification.title, message: notification.message, date: _this_1.formattedNotificationDate(notification.createdDate), selected: _this_1.selectedNotificationsIds.includes(notification.id), screenSize: _this_1.screenSize, isShow: notification.isShow }); })))
                ];
            }
            else {
                return (h("div", { class: "o-text-center o-mt-5" }, "No results were found"));
            }
        };
        var renderDeleteConfirmationModal = function () {
            if (_this_1.deleteConfirmationModalOpened) {
                var notificationsLength = _this_1.toBeDeletedAllNotifications
                    ? _this_1.notificationsCount
                    : _this_1.toBeDeletedNotificationIds.length;
                return (h("omnibar-modal", { ref: function (el) { return _this_1.deleteModal = el; } }, h("h3", { class: "o-heading-xl o-text-center o-pb-2" }, "Delete Notification", notificationsLength > 1 && 's'), h("p", { class: "o-paragraph o-text-center o-pb-3" }, "Do you want to delete ", notificationsLength === 1 ? 'this ' : notificationsLength + " ", "notification", notificationsLength > 1 && 's', " permanently?"), h("p", { class: "o-paragraph o-text-center o-pb-3" }, "Note: All notifications will be deleted after three months from the date received."), h("div", { class: "o-flex o-flex-wrap o--mx-2" }, h("omnibar-button", { variant: "secondary", size: "small", class: "o-flex-1 o-px-2", onClick: function () { return _this_1.closeDeleteConfirmationModal(); } }, "Cancel"), h("omnibar-button", { variant: "primary", size: "small", class: "o-flex-1 o-px-2", onClick: function () { return _this_1.deleteNotifications(); } }, "Delete"))));
            }
        };
        var renderFiltersAside = function () {
            return (h("omnibar-aside", { slot: "secondary-aside", ref: function (el) { return _this_1.filtersAsideEl = el; } }, h("omnibar-aside-header", null, h("omnibar-aside-title", null, "Filter Notifications")), h("omnibar-aside-body", null, h("div", { class: "o-mb-3" }, h("omnibar-select", { searchable: true, placeholder: "Select", label: "Products", loading: _this_1.productsLoading, options: _this_1.products, value: _this_1.productsValue, showNoOptionsMessage: _this_1.noProductsFound, onOmnibarChange: function (e) { return _this_1.handleProductsChange(e); }, onOmnibarSelectOpen: function () { return _this_1.getProductNames(); } })), _this_1.priorityOptions.length > 0 ?
                h("div", { class: "o-mb-3" }, h("omnibar-select", { options: _this_1.priorityOptions, placeholder: "Status", multiple: true, label: "Status", value: _this_1.priorityValue, onOmnibarChange: function (e) { return _this_1.handlePriorityChange(e); } }))
                : '', h("div", { class: "o-mb-3" }, h("omnibar-select", { options: _this_1.sortOptions, placeholder: "Sort", label: "Sort", value: _this_1.sortValue, onOmnibarChange: function (e) { return _this_1.handleSortChange(e); } })), h("div", { class: "o-mb-3" }, h("omnibar-date-picker", { range: true, placeholder: "Select a Date Range", label: "Date Range", onOmnibarChange: function (e) { return _this_1.handleDateChange(e); } }))), h("omnibar-aside-footer", null, h("omnibar-aside-actions", { class: "o--mx-2" }, h("omnibar-button", { class: "o-flex-1 o-px-2", variant: "secondary", onClick: function () { return _this_1.cancelFilters(); } }, "Cancel"), h("omnibar-button", { class: "o-flex-1 o-px-2", variant: "primary", onClick: function () { return _this_1.applyFilters(); } }, "Apply")))));
        };
        return (h(Host, null, h("omnibar-aside", { class: "o-unified-notifications__aside", size: "large", onOmnibarAsideClose: function (e) { return e.target === e.currentTarget ? _this_1.omnibarNotificationsAsideClose.emit() : null; }, ref: function (el) { return _this_1.notificationsAsideEl = el; } }, h("omnibar-aside-header", { class: "o-unified-notifications__aside_header" }, h("omnibar-aside-title", { class: "o-unified-notifications__aside_header__title" }, "Notifications", this.getProductCategoriesFinished && h("button", { type: "button", class: "o-unified-notifications__aside_header_link", onClick: function () { return _this_1.navigateToUserPrefrenceLink(); } }, "Manage Notifications Preferences")), h("omnibar-tabs", { onOmnibarTabChange: function (e) { return _this_1.notificationsTabChange(e); }, activeTab: this.selectedTab, tabs: this.tabs })), h("omnibar-aside-body", null, this.selectedTab === 'myNotification' &&
            h("div", { class: "o-flex o-flex-wrap o--mx-3 o-mb-3 o-mt-4" }, h("div", { class: "o-flex-1 o-px-3 md:o-flex-initial md:o-w-4/12" }, h("omnibar-input", { type: "search" }, h("input", { type: "text", placeholder: "Search...", value: this.searchValue, onKeyDown: function (e) { return _this_1.handleSearchKeywordChange(e); } }))), this.screenSize === 'sm' && (h("div", { class: "o-px-3" }, h("omnibar-button", { variant: "control", icon: "content-filter", onClick: function () { return _this_1.filtersAsideEl.open(); } }, "Filters"))), this.screenSize !== 'sm' && [
                h("div", { class: "o-w-2/12 o-px-3" }, h("omnibar-select", { searchable: true, placeholder: "All Products", loading: this.productsLoading, options: this.products, value: this.productsValue, showNoOptionsMessage: this.noProductsFound, onOmnibarChange: function (e) { return _this_1.handleProductsChange(e); }, onOmnibarSelectOpen: function () { return _this_1.getProductNames(); } })),
                h("div", { class: "o-w-2/12 o-px-3" }, h("omnibar-select", { options: this.priorityOptions, multiple: true, placeholder: "Status", value: this.priorityValue, onOmnibarChange: function (e) { return _this_1.handlePriorityChange(e); } })),
                h("div", { class: "o-w-2/12 o-px-3" }, h("omnibar-select", { options: this.sortOptions, placeholder: "Sort", value: this.sortValue, onOmnibarChange: function (e) { return _this_1.handleSortChange(e); } })),
                h("div", { class: "o-w-2/12 o-px-3" }, h("omnibar-date-picker", { range: true, placeholder: "Select a Date Range", onOmnibarChange: function (e) { return _this_1.handleDateChange(e); } }))
            ]), this.selectedTab === 'myNotification' && renderNotifications(), this.selectedTab === 'realpage' && renderRealpageNotifications(), this.loading && h("omnibar-container-loader", null)), this.screenSize !== 'xl' && (h("omnibar-aside-footer", null, h("omnibar-aside-actions", null, h("omnibar-button", { variant: "primary", class: {
                'o-w-full': this.screenSize === 'sm',
                'o-opacity-0 o-invisible': !!this.selectedNotificationsIds.length,
            }, onClick: function () { return _this_1.notificationsAsideEl.close(); } }, "Close")))), this.selectedTab === 'myNotification' && renderFiltersAside()), this.selectedTab === 'myNotification' && renderDeleteConfirmationModal()));
    };
    Object.defineProperty(class_22.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_22, "watchers", {
        get: function () {
            return {
                "opened": ["openedChanged"],
                "queryParams": ["queryParamsChanged"],
                "deleteConfirmationModalOpened": ["deleteConfirmationModalOpenedChange"],
                "api": ["apiConfigChanged"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_22, "style", {
        get: function () { return "omnibar-unified-notifications-aside{display:block;color:#37474f}.o-unified-notifications__aside_header{background:#f7f8f9;padding-bottom:0;padding-left:2rem}.o-unified-notifications__aside_header__title{padding-left:1rem;margin-bottom:2rem}.o-unified-notifications__aside_header_link{float:right;font-size:14px;color:#0076cc;margin-right:.5rem;font-weight:400}"; },
        enumerable: true,
        configurable: true
    });
    return class_22;
}());
ShellTunnel.injectProps(OmnibarUnifiedNotificationsAside, ['api', 'unityUser', 'screenSize', 'unityProducts', 'unityResources']);
var OmnibarUnifiedNotificationsAsideNotification = /** @class */ (function () {
    function OmnibarUnifiedNotificationsAsideNotification(hostRef) {
        registerInstance(this, hostRef);
        this.omnibarChange = createEvent(this, "omnibarChange", 7);
        this.omnibarStatusUpdate = createEvent(this, "omnibarStatusUpdate", 7);
        this.omnibarDelete = createEvent(this, "omnibarDelete", 7);
    }
    OmnibarUnifiedNotificationsAsideNotification.prototype.componentDidLoad = function () {
        if (this.notificationTextContentEl)
            this.textOverflowing = this.notificationTextContentEl.clientHeight > 25;
        if (this.isShow) {
            this.handleToggleButtonClick();
        }
    };
    OmnibarUnifiedNotificationsAsideNotification.prototype.handleToggleButtonClick = function () {
        this.textExpanded = !this.textExpanded;
        if (!this.read && this.textExpanded)
            this.omnibarStatusUpdate.emit({ read: true, notificationsIds: this.uuid, showConfirmation: false });
    };
    OmnibarUnifiedNotificationsAsideNotification.prototype.handleChange = function (e) {
        this.omnibarChange.emit({ selected: e.target.checked });
    };
    OmnibarUnifiedNotificationsAsideNotification.prototype.handleStatusUpdate = function () {
        this.closeActionMenu();
        this.omnibarStatusUpdate.emit({ read: !this.read, notificationsIds: this.uuid, showConfirmation: true });
    };
    OmnibarUnifiedNotificationsAsideNotification.prototype.handleDelete = function () {
        this.closeActionMenu();
        this.omnibarDelete.emit();
    };
    OmnibarUnifiedNotificationsAsideNotification.prototype.closeActionMenu = function () {
        this.screenSize !== 'sm' ? this.desktopActionMenuEl.closeMenu() : this.mobileActionMenuEl.closeMenu();
    };
    OmnibarUnifiedNotificationsAsideNotification.prototype.viewaction = function (action) {
        window.open(action.properties[0].propertyValue, '_blank');
    };
    OmnibarUnifiedNotificationsAsideNotification.prototype.render = function () {
        var _this_1 = this;
        var renderGridRow = function () {
            return (h("omnibar-grid-row", { active: _this_1.selected, class: {
                    'o-unified-notifications__aside__notification--unread': !_this_1.read,
                    'o-unified-notifications__aside__notification--expanded': _this_1.textExpanded,
                    'o-unified-notifications__aside__notification--truncate': _this_1.textOverflowing && !_this_1.textExpanded,
                    'highlight-border': _this_1.isShow
                } }, h("omnibar-grid-cell", { class: "o-unified-notifications__aside__notification__checkbox" }, h("omnibar-checkbox", null, h("input", { type: "checkbox", checked: _this_1.selected, onChange: function (e) { return _this_1.handleChange(e); } }))), h("omnibar-grid-cell", { class: "o-unified-notifications__aside__notification__text" }, h("div", { class: "o-unified-notifications__aside__notification__text__content", ref: function (el) { return _this_1.notificationTextContentEl = el; } }, h("div", { class: "o-unified-notifications__aside__notification__details o-cursor-pointer", onClick: function () { return _this_1.handleToggleButtonClick(); } }, h("span", { class: "o-unified-notifications__aside__notification__title" }, _this_1.name), !_this_1.textExpanded && h("span", null, " - "), h("span", { class: "o-unified-notifications__aside__notification__message" }, _this_1.isShow, " ", _this_1.message)), h("button", { type: "button", class: "o-unified-notifications__aside__notification__toggle-button", onClick: function () { return _this_1.handleToggleButtonClick(); } }, _this_1.textExpanded ? 'View Less' : _this_1.textOverflowing ? 'View More' : 'View'), h("div", { class: "o-flex" }, _this_1.textExpanded && _this_1.actions.map(function (action) {
                return (h("omnibar-button", { variant: "secondary", size: "small", class: "o-px-2 o-py-2", onClick: function () { return _this_1.viewaction(action); } }, action.actionName));
            })))), h("omnibar-grid-cell", { class: "o-unified-notifications__aside__notification__date o-whitespace-no-wrap" }, _this_1.date), h("omnibar-grid-cell", { class: "o-unified-notifications__aside__notification__product o-pl-10" }, _this_1.product), h("omnibar-grid-cell", { class: "o-unified-notifications__aside__notification__priority" }, _this_1.severity === true && h("omnibar-status", { variant: "destructive" }, "High")), h("omnibar-grid-cell", { class: "o-unified-notifications__aside__notification__actions" }, h("omnibar-action-menu", { ref: function (el) { return _this_1.desktopActionMenuEl = el; } }, h("omnibar-action-menu-item", { onClick: function () { return _this_1.handleStatusUpdate(); } }, "Mark as ", _this_1.read ? 'Unread' : 'Read'), h("omnibar-action-menu-item", { onClick: function () { return _this_1.handleDelete(); } }, "Delete")))));
        };
        var renderListItem = function () {
            return (h("div", { class: {
                    'o-relative o-border-b o-border-gray-light o-py-3 o-px-2 o-w-full': true,
                    'o-bg-primary-highlight': _this_1.selected,
                } }, h("div", { class: "o-pl-12" }, _this_1.product && h("div", { class: "o-text-sm o-mb-3" }, _this_1.product), h("div", { class: "o-relative o-mb-3" }, h("div", { class: {
                    'o-relative': true,
                    'o-font-semibold o--ml-4': !_this_1.read,
                } }, !_this_1.read && h("div", { class: "o-inline-block o-bg-secondary o-w-2 o-h-2 o-rounded-full o-mr-2" }), _this_1.name), h("div", { class: "o-text-sm" }, _this_1.date), h("div", { class: "o-absolute o-top-half o-right-full o--translate-y-half o-pr-7" }, h("omnibar-checkbox", null, h("input", { type: "checkbox", checked: _this_1.selected, onChange: function (e) { return _this_1.handleChange(e); } })))), h("div", { class: {
                    'o-mb-3': _this_1.severity === true,
                    'o-truncate': !_this_1.textExpanded,
                }, onClick: function () { return _this_1.handleToggleButtonClick(); } }, h("span", { class: "o-cursor-pointer" }, " ", _this_1.message, " ")), h("div", { class: "o-flex" }, _this_1.textExpanded && _this_1.actions.map(function (action) {
                return (h("omnibar-button", { variant: "secondary", size: "small", class: "o-px-2 o-py-2", onClick: function () { return _this_1.viewaction(action); } }, action.actionName));
            })), _this_1.severity === true && h("omnibar-status", { variant: "destructive" }, "High")), h("div", { class: "o-absolute o-top-0 o-right-0 o-pt-3" }, h("omnibar-action-menu", { class: "o-inline-block o-px-2", ref: function (el) { return _this_1.mobileActionMenuEl = el; } }, h("omnibar-action-menu-item", { onClick: function () { return _this_1.handleStatusUpdate(); } }, "Mark as ", _this_1.read ? 'Unread' : 'Read'), h("omnibar-action-menu-item", { onClick: function () { return _this_1.handleDelete(); } }, "Delete")), h("button", { type: "button", class: "o-px-2", onClick: function () { return _this_1.handleToggleButtonClick(); } }, h("omnibar-icon", { class: "o-text-gray-dark", icon: "arrow-down-v" })))));
        };
        return (h(Host, null, this.screenSize !== 'sm' ? renderGridRow() : renderListItem()));
    };
    Object.defineProperty(OmnibarUnifiedNotificationsAsideNotification, "style", {
        get: function () { return "omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification{display:-ms-flexbox;display:flex;width:100%}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .highlight-border{-webkit-animation:cssAnimation 0s 10s forwards;animation:cssAnimation 0s 10s forwards;background:#f5f9fc}\@-webkit-keyframes cssAnimation{to{background:transparent}}\@keyframes cssAnimation{to{background:transparent}}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification__checkbox{width:auto}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification__text{width:50%}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification__text__content{position:relative;padding-left:1rem}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification__details{display:inline}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification__title{display:inline-block;max-width:100%;overflow:hidden;vertical-align:top;text-overflow:ellipsis}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification__toggle-button{font-size:.75rem;color:#0076cc;margin-left:.25rem}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification__toggle-button:hover{text-decoration:underline}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification__date,omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification__product{font-size:.75rem;width:auto}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification__date,omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification__priority,omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification__product{-ms-flex:1 1 0%;flex:1 1 0%}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification__priority{-ms-flex-pack:center;justify-content:center}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification__actions{width:auto;-ms-flex-pack:end;justify-content:flex-end}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification--expanded .o-unified-notifications__aside__notification__title{display:block;margin-bottom:.5rem}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification--expanded omnibar-grid-cell{-ms-flex-align:baseline;align-items:baseline;padding-top:1.1875rem}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification--truncate .o-unified-notifications__aside__notification__text__content{display:-ms-flexbox;display:flex;-ms-flex-align:baseline;align-items:baseline;white-space:pre}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification--truncate .o-unified-notifications__aside__notification__details,omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification--truncate .o-unified-notifications__aside__notification__text .o-grid__cell{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification--unread .o-unified-notifications__aside__notification__title{font-weight:600}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-notification .o-unified-notifications__aside__notification--unread .o-unified-notifications__aside__notification__text__content:before{position:absolute;background-color:#f06000;width:.5rem;height:.5rem;border-radius:9999px;left:0;content:\"\";top:calc(.75rem/2)}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarUnifiedNotificationsAsideNotification;
}());
var OmnibarUnifiedNotificationsAsideRealpagealerts = /** @class */ (function () {
    function OmnibarUnifiedNotificationsAsideRealpagealerts(hostRef) {
        registerInstance(this, hostRef);
        this.omnibarChange = createEvent(this, "omnibarChange", 7);
        this.omnibarStatusUpdate = createEvent(this, "omnibarStatusUpdate", 7);
    }
    OmnibarUnifiedNotificationsAsideRealpagealerts.prototype.componentDidLoad = function () {
        if (this.notificationTextContentEl) {
            this.notificationTextContentEl.innerHTML = this.message;
            var singleLineDivInfo = this.notificationTextContentEl.childNodes;
            if (singleLineDivInfo.length > 1 || (this.message.indexOf('<ol>')) > -1) {
                this.textOverflowing = true;
                this.htmlText = singleLineDivInfo[0]['innerHTML'];
            }
            else {
                this.htmlText = singleLineDivInfo[0]['innerHTML'];
                this.notificationTextContentEl.innerHTML = this.name + this.htmlText;
                this.textOverflowing = this.notificationTextContentEl.clientHeight > 25;
            }
            var count = this.getCharacterCount();
            var contentText = this.extractContent(this.notificationTextContentEl.innerHTML);
            if (contentText.length > count) {
                this.notificationTextContentEl.innerHTML = contentText.substr(0, count) + '...';
                this.textOverflowing = true;
            }
            if (this.textExpanded) {
                this.notificationTextContentEl.innerHTML = this.message;
            }
            if (!this.textOverflowing) {
                var contentNormalText = this.extractContent(this.message);
                this.notificationTextContentEl.innerHTML = this.screenSize == 'sm' ? this.message : contentNormalText;
            }
            if (this.screenSize !== 'sm') {
                this.notificationTextContentEl.className = 'o-inline';
            }
            var divInfo = this.notificationTextContentEl.childNodes;
            divInfo.forEach(function (item, index) {
                if (index !== 0) {
                    item.style.display = "none";
                }
                else {
                    item.className = "o-truncate";
                    if (item.tagName === 'OL' || item.tagName === 'UL') {
                        item.childNodes.forEach(function (subitem, subindex) {
                            if (subindex !== 0) {
                                subitem.style.display = "none";
                            }
                        });
                    }
                }
            });
        }
        if (this.isShow && this.textOverflowing) {
            this.handleToggleButtonClick();
        }
    };
    OmnibarUnifiedNotificationsAsideRealpagealerts.prototype.extractContent = function (s) {
        var span = document.createElement('span');
        span.innerHTML = s;
        return span.textContent || span.innerText;
    };
    ;
    OmnibarUnifiedNotificationsAsideRealpagealerts.prototype.getCharacterCount = function () {
        var count = 0;
        if (this.screenSize == "sm") {
            count = 55;
        }
        else {
            count = 75;
        }
        return count;
    };
    OmnibarUnifiedNotificationsAsideRealpagealerts.prototype.handleToggleButtonClick = function () {
        var _this_1 = this;
        this.textExpanded = !this.textExpanded;
        if (this.textExpanded) {
            this.notificationTextContentEl.innerHTML = this.message;
        }
        else {
            var count = this.getCharacterCount();
            var contentText = this.extractContent(this.notificationTextContentEl.innerHTML);
            if (contentText.length > count) {
                this.notificationTextContentEl.innerHTML = contentText.substr(0, count) + '...';
                this.textOverflowing = true;
            }
        }
        if (this.textExpanded && this.textOverflowing) {
            this.notificationTextContentEl.style.display = 'inline-block';
            this.notificationTextContentEl2.style.display = 'inline';
        }
        else if (!this.textExpanded && this.textOverflowing) {
            this.notificationTextContentEl.style.display = 'inline';
            this.notificationTextContentEl2.style.display = 'inline-block';
            if (this.screenSize == 'sm') {
                this.notificationTextContentEl.className = 'o-inline';
            }
        }
        var divInfo = this.notificationTextContentEl.childNodes;
        divInfo.forEach(function (item, index) {
            if (index !== 0) {
                item.style.display = _this_1.textExpanded ? 'block' : 'none';
            }
            else {
                item.className = _this_1.textExpanded ? "" : "o-truncate";
                if (item.tagName === 'P') {
                    item.className = _this_1.textExpanded ? 'o-mr-2' : 'o-truncate';
                }
                else {
                    item.className = _this_1.textExpanded ? '' : 'o-truncate';
                }
            }
            if (item.tagName === 'OL' || item.tagName === 'UL') {
                item.childNodes.forEach(function (subitem, subindex) {
                    if (subindex !== 0) {
                        subitem.style.display = item.className === 'o-truncate' ? "none" : 'list-item';
                    }
                });
            }
        });
    };
    OmnibarUnifiedNotificationsAsideRealpagealerts.prototype.render = function () {
        var _this_1 = this;
        var renderGridRow = function () {
            return (h("omnibar-grid-row", { active: _this_1.selected, class: {
                    'o-unified-notifications__aside__realpagealerts--expanded': _this_1.textExpanded,
                    'o-unified-notifications__aside__realpagealerts--truncate': _this_1.textOverflowing && !_this_1.textExpanded,
                    'highlight-border': _this_1.isShow
                } }, h("omnibar-grid-cell", { class: "o-unified-notifications__aside__realpagealerts__text" }, h("div", { class: "o-unified-notifications__aside__realpagealerts__text__content" }, h("div", { class: { "o-unified-notifications__aside__realpagealerts__details o-cursor-pointer": true, "o-truncate": !_this_1.textExpanded && _this_1.textOverflowing }, onClick: function () { return _this_1.textOverflowing ? _this_1.handleToggleButtonClick() : ''; }, ref: function (e2) { return _this_1.notificationTextContentEl2 = e2; } }, h("span", { class: "o-unified-notifications__aside__realpagealerts__title" }, _this_1.name), !_this_1.textExpanded && h("span", { class: "o-inline-block o-unified-notifications__aside__realpagealerts__btn-overflow-none" }, " \u00A0 - \u00A0"), h("div", { class: { "o-unified-notifications__aside__realpagealerts__message": true, "o-inline": _this_1.textExpanded && _this_1.textOverflowing }, ref: function (el) { return _this_1.notificationTextContentEl = el; } }, _this_1.isShow, _this_1.message)), h("button", { type: "button", class: { "o-unified-notifications__aside__realpagealerts__toggle-button": true,
                    "o-unified-notifications__aside__realpagealerts__butn-overflow": _this_1.textExpanded == false,
                    "o-unified-notifications__aside__realpagealerts__butn-overflow-none": _this_1.textExpanded == true }, onClick: _this_1.textOverflowing && (function () { return _this_1.handleToggleButtonClick(); }) }, _this_1.textExpanded ? 'View Less' : _this_1.textOverflowing ? 'View More' : ''))), h("omnibar-grid-cell", { class: "o-unified-notifications__aside__realpagealerts__date o-whitespace-no-wrap" }, _this_1.date)));
        };
        var renderListItem = function () {
            return (h("div", { class: {
                    'o-relative o-border-b o-border-gray-light o-py-3 o-px-2 o-w-full': true,
                } }, h("div", { class: "o-pl-12" }, h("div", { class: "o-relative o-mb-3" }, h("div", { class: {
                    'o-relative': true,
                } }, _this_1.name), h("div", { class: "o-text-sm" }, _this_1.date)), h("div", { ref: function (el) { return _this_1.notificationTextContentEl = el; }, class: { "o-unified-notifications__aside__realpagealerts__details": true,
                    'o-truncate': !_this_1.textExpanded,
                }, onClick: function () { return _this_1.handleToggleButtonClick(); } }, h("span", { class: "o-cursor-pointer" }, " ", _this_1.message, " "))), h("div", { class: "o-absolute o-top-0 o-right-0 o-pt-3" }, h("button", { type: "button", class: "o-px-2", onClick: function () { return _this_1.handleToggleButtonClick(); } }, h("omnibar-icon", { class: "o-text-gray-dark", icon: "arrow-down-v" })))));
        };
        return (h(Host, null, this.screenSize !== 'sm' ? renderGridRow() : renderListItem()));
    };
    Object.defineProperty(OmnibarUnifiedNotificationsAsideRealpagealerts, "style", {
        get: function () { return "omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts{width:100%}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .highlight-border{-webkit-animation:cssAnimation 0s 10s forwards;animation:cssAnimation 0s 10s forwards;background:#f5f9fc}\@-webkit-keyframes cssAnimation{to{background:transparent}}\@keyframes cssAnimation{to{background:transparent}}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__text{width:75%}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__text__content{position:relative;overflow:hidden}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__text .o-grid__cell{width:100%}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__text ol,omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__text ul{list-style:revert;margin:revert;padding:revert}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__details{display:inline-block}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__details ol,omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__details ul{list-style:revert!important;margin:revert!important;padding:revert!important;padding-left:15px!important}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__details.o-truncate{max-width:calc(100% - 80px)}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__details.o-truncate *{all:unset;margin:0!important;padding:0!important;white-space:no-wrap!important}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__title{display:inline-block;max-width:100%;overflow:hidden;vertical-align:top;text-overflow:ellipsis}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__toggle-button{font-size:.75rem;color:#0076cc;position:relative;bottom:.5rem;left:5px}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__toggle-button:hover{text-decoration:underline}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__butn-overflow{position:relative}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__butn-overflow-none{position:relative;top:.25rem;left:0!important}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__date{font-size:.75rem;width:auto;width:25%}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__date .o-grid__cell{width:100%;text-align:right}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts__priority{-ms-flex-pack:center;justify-content:center}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts--expanded .o-unified-notifications__aside__realpagealerts__title{display:block;margin-bottom:.5rem;font-weight:600}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts--expanded omnibar-grid-cell{-ms-flex-align:baseline;align-items:baseline;padding-top:1.1875rem}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts--truncate .o-unified-notifications__aside__realpagealerts__text .o-grid__cell{width:100%}omnibar-unified-notifications-aside omnibar-unified-notifications-aside-realpagealerts .o-unified-notifications__aside__realpagealerts--truncate .o-unified-notifications__aside__realpagealerts__details{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarUnifiedNotificationsAsideRealpagealerts;
}());
var OmnibarUnifiedNotificationsFooter = /** @class */ (function () {
    function OmnibarUnifiedNotificationsFooter(hostRef) {
        registerInstance(this, hostRef);
        this.url = '#';
        this.isShowDismiss = false;
        this.viewNotifications = createEvent(this, "viewNotifications", 7);
        this.trackClickEvent = createEvent(this, "trackClickEvent", 7);
        this.dismissNotifications = createEvent(this, "dismissNotifications", 7);
    }
    OmnibarUnifiedNotificationsFooter.prototype.emitClickEvent = function () {
        this.viewNotifications.emit({ selectedTab: this.selectedTab });
        this.trackClickEvent.emit({ button_name: 'Notifications View All' });
        if (['sm'].includes(this.screenSize)) {
            document.querySelector('omnibar-unified-menu').closeUserMenu();
        }
    };
    OmnibarUnifiedNotificationsFooter.prototype.handleItemsChange = function () {
        this.isShowDismiss = this.items && this.items.length > 0 ? true : false;
    };
    OmnibarUnifiedNotificationsFooter.prototype.dismissAllNotifications = function () {
        this.dismissNotifications.emit();
    };
    OmnibarUnifiedNotificationsFooter.prototype.render = function () {
        var _this_1 = this;
        return (h("div", { class: "o-unified-notifications__footer o-flex" }, h("div", { class: "o-font-bold", onClick: function () { return _this_1.emitClickEvent(); } }, "View All"), this.isShowDismiss === true && this.selectedTab === 'myNotification' ?
            h("div", { class: "o-font-bold o-text-right", onClick: function () { return _this_1.dismissAllNotifications(); } }, "Dismiss All") : ''));
    };
    Object.defineProperty(OmnibarUnifiedNotificationsFooter, "watchers", {
        get: function () {
            return {
                "items": ["handleItemsChange"]
            };
        },
        enumerable: true,
        configurable: true
    });
    return OmnibarUnifiedNotificationsFooter;
}());
ShellTunnel.injectProps(OmnibarUnifiedNotificationsFooter, ['screenSize']);
var img = 'data:image/svg+xml;base64,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';
var OmnibarUnifiedNotificationsItems = /** @class */ (function () {
    function OmnibarUnifiedNotificationsItems(hostRef) {
        registerInstance(this, hostRef);
        this.loading = true;
        this.viewNotifications = createEvent(this, "viewNotifications", 7);
        this.dismissNotifications = createEvent(this, "dismissNotifications", 7);
        this.updateStatus = createEvent(this, "updateStatus", 7);
        this.optionSelected = createEvent(this, "optionSelected", 7);
    }
    OmnibarUnifiedNotificationsItems.prototype.convertDate = function (date) {
        date = hooks.utc(date).toDate();
        var diffDate = hooks.duration(hooks().diff(date)).asMinutes();
        var days = hooks.duration(hooks().diff(date)).asDays();
        if (diffDate < 10) {
            return 'Just now';
        }
        else if (days < 1 && diffDate >= 10 && diffDate < 15) {
            return '10 mins ago';
        }
        else if (days < 1 && diffDate >= 15 && diffDate < 20) {
            return '15 mins ago';
        }
        else if (days < 1 && diffDate >= 20 && diffDate < 30) {
            return '20 mins ago';
        }
        else if (hooks(date).format('MM-DD-YYYY') === hooks().add(-1, 'days').format('MM-DD-YYYY')) {
            return 'Yesterday at ' + hooks(date).format('hh:mm A');
        }
        else if (hooks(date).format("YYYY-MM-DD") === hooks().format("YYYY-MM-DD")) {
            return 'Today at ' + hooks(date).format('hh:mm A');
        }
        else {
            return hooks(date).format('MM/DD/YYYY hh:mm A');
        }
    };
    OmnibarUnifiedNotificationsItems.prototype.handleItemsChange = function () {
        this.loading = !this.items;
    };
    OmnibarUnifiedNotificationsItems.prototype.viewProductNotifications = function (item, flag) {
        item.isShow = flag ? true : false;
        item.selectedTab = this.selectedTab;
        this.viewNotifications.emit(item);
    };
    OmnibarUnifiedNotificationsItems.prototype.viewaction = function (action, item, status) {
        this.updateStatus.emit(item);
        window.open(action.properties[0].propertyValue, '_blank');
        if (status) {
            var el = this.actionMenuEl;
            el.click();
        }
    };
    OmnibarUnifiedNotificationsItems.prototype.dismissNotification = function (item) {
        this.dismissNotifications.emit(item);
    };
    OmnibarUnifiedNotificationsItems.prototype.getInfo = function (item, id) {
        document.getElementById(id).innerHTML = item;
        if (document.getElementById(id).innerText.length > 150) {
            document.getElementById(id).innerText = document.getElementById(id).innerText.substr(0, 150);
        }
        var divInfo = document.getElementById(id).childNodes;
        divInfo.forEach(function (item, index) {
            if (index !== 0) {
                item.style.display = "none";
            }
            else {
                item.className = "o-truncate";
                if (item.tagName === 'OL' || item.tagName === 'UL') {
                    item.childNodes.forEach(function (subitem, subindex) {
                        if (subindex !== 0) {
                            subitem.style.display = "none";
                        }
                    });
                }
            }
        });
    };
    OmnibarUnifiedNotificationsItems.prototype.render = function () {
        var _this_1 = this;
        return (h("div", { class: "o-unified-notifications__items" }, h("div", { class: "o-section" }, this.loading
            ? h("omnibar-container-loader", null)
            : '', ((!this.loading && this.items && this.items.length === 0 && this.selectedTab === 'myNotification') || (!this.loading && this.realpageItems && this.realpageItems.length === 0 && this.selectedTab === 'realpage'))
            ? h("div", { class: "o-px-4 o-py-6 o-text-center" }, h("div", { class: "o-ml-12 o-pl-8" }, h("img", { src: img, srcset: img })), h("h2", { class: "o-text-lg o-font-medium o-my-2" }, "Looks like you're all caught up!"), h("div", { class: "o-item__text-message o-text-sm" }, " There are no new notifications"))
            : '', !this.loading && this.items && this.items.length > 0 && this.selectedTab === 'myNotification' && this.items.map(function (item) { return (h("div", { class: "o-item__row" }, h("div", { class: "o-item__status-wrapper" }, h("div", { class: "o-flex o-relative", onClick: function () { return _this_1.viewProductNotifications(item, true); } }, h("omnibar-icon", { icon: item.iconClass, class: "type-icon icon-color", slot: "toggle" }), h("div", { class: {
                'o-item__status': true,
                'o-item__status--unread': item.isRead === false,
                'o-mt-6 o-absolute': true
            } }))), h("div", { class: "o-item__body o-pl-2" }, h("div", { class: "o-item__header", onClick: function () { return _this_1.viewProductNotifications(item, true); } }, h("div", { class: "o-item__header-product" }, item.productName), h("div", { class: "o-item__header-time-stamp" }, _this_1.convertDate(item.createdDate)), h("div", { class: "o-item__header-arrow", onClick: function (event) { _this_1.dismissNotification(item); event.stopPropagation(); } }, h("div", { class: "o-toast__dismiss dismiss-icon" }, h("omnibar-icon", { icon: "arrow-right-1" })))), h("div", { class: "o-item__text", onClick: function () { return _this_1.viewProductNotifications(item, true); } }, h("div", { class: "o-item__text-subject" }, item.title), h("div", { class: "o-item__text-message" }, h("div", null, item.message))), h("div", { onClick: function () { return _this_1.viewProductNotifications(item, true); } }, item.priority === true
            ? h("omnibar-status", { variant: "destructive" }, "High")
            : ''), h("div", { class: "o-flex" }, item.actions.map(function (action) {
            return (h("div", { class: "o-unified-notifications__items o-pr-7" }, h("div", { class: "o-unified-notifications__items__action o-py-2 o-font-bold", onClick: function (event) { _this_1.viewaction(action, item, false); event.stopPropagation(); } }, action.actionName)));
        }), item.moreActions && item.moreActions.length > 0 ?
            (h("div", { class: "o-unified-notifications__items o-pr-7" }, h("div", { class: "o-unified-notifications__items__action o-py-2 o-font-bold" }, h("omnibar-dropdown-menu", { class: "o-inline-block o-px-2", ref: function (el) { return _this_1.actionMenuEl = el; } }, h("div", { slot: "toggle" }, "More"), h("slot", null), item.moreActions.map(function (moreAction) {
                return (h(MenuItem, { title: moreAction.actionName, event: _this_1.optionSelected, onClickCallback: function (event) { _this_1.viewaction(moreAction, item, true); event.stopPropagation(); } }, h("slot", null)));
            }))))) : ''), (item.total - 1) > 0
            ?
                h("div", { class: "o-unified-notifications__items o-pt-1" }, h("div", { class: "o-unified-notifications__items__action", onClick: function (event) { _this_1.viewProductNotifications(item, false); event.stopPropagation(); } }, (item.total - 1), " more notifications"))
            : ''))); }), !this.loading && this.realpageItems && this.realpageItems.length > 0 && this.selectedTab === 'realpage' && this.realpageItems.map(function (item, index) { return (h("div", { class: "o-item__row", onClick: function () { item.index = index; _this_1.viewProductNotifications(item, true); } }, h("div", { class: "o-item__body o-pl-2" }, h("div", { class: "o-item__header" }, h("div", { class: "o-item__header-product" }, "RealPage"), h("div", { class: "o-item__header-time-stamp" }, _this_1.convertDate(item.startDate))), h("div", { class: "o-item__text" }, h("div", { class: "o-item__text-subject" }, item.title), h("div", { class: "o-item__text-message" }, h("div", { id: "divMessage" + index, class: "o-item__render-text o-truncate" }, setTimeout(function () {
            _this_1.getInfo(item.message, "divMessage" + index);
        }), ";")))))); }))));
    };
    Object.defineProperty(OmnibarUnifiedNotificationsItems, "watchers", {
        get: function () {
            return {
                "items": ["handleItemsChange"]
            };
        },
        enumerable: true,
        configurable: true
    });
    return OmnibarUnifiedNotificationsItems;
}());
var OmnibarUnifiedSwitcher = /** @class */ (function () {
    function OmnibarUnifiedSwitcher(hostRef) {
        var _this_1 = this;
        registerInstance(this, hostRef);
        this.authenticated = false;
        this.unityProducts = null;
        this.unityResources = null;
        this.searchQuery = "";
        this.updateSearchQuery = function (e) {
            _this_1.searchQuery = e.target.value;
        };
        this.searchProducts = function (product) {
            var name = product.name, familyName = product.familyName;
            var query = _this_1.searchQuery.toLowerCase();
            if (!query)
                return true;
            return (name.toLowerCase() + " " + familyName.toLowerCase()).includes(query);
        };
        this.searchResources = function (product) {
            var name = product.name;
            var query = _this_1.searchQuery.toLowerCase();
            if (!query)
                return true;
            return ("" + name.toLowerCase()).includes(query);
        };
        this.returnToHomePage = createEvent(this, "returnToHomePage", 7);
        this.omnibarPlatformAlertAsideOpen = createEvent(this, "omnibarPlatformAlertAsideOpen", 7);
    }
    OmnibarUnifiedSwitcher.prototype.onMenuClick = function (ev) {
        var body = document.querySelector('body');
        if (ev.detail.name === 'App Switcher' && !['lg', 'xl'].includes(this.screenSize)) {
            body.classList.add('no-scroll');
        }
        else {
            body.classList.remove('no-scroll');
        }
    };
    OmnibarUnifiedSwitcher.prototype.onItemClick = function (ev) {
        if (!this.authenticated) {
            var parent = document.querySelectorAll('.o-unified-switcher__app');
            parent.forEach(function (item) {
                console.log(item.contains(ev.target));
                if (item.contains(ev.target))
                    document.querySelector('omnibar-unified-menu-item').close();
            });
        }
    };
    OmnibarUnifiedSwitcher.prototype.productFamilies = function () {
        return Object.keys(this.unityProducts || {});
    };
    OmnibarUnifiedSwitcher.prototype.anyFamiliesPresent = function () {
        // API always returns at least favorites (even if empty)
        return this.productFamilies().length > 1 || this.resourceFamilies().length > 0;
    };
    OmnibarUnifiedSwitcher.prototype.products = function (family) {
        return this.unityProducts[family].filter(this.searchProducts);
    };
    OmnibarUnifiedSwitcher.prototype.anyProductsPresent = function (family) {
        var hasProducts = this.products(family).length > 0;
        var hasShownProducts = this.products(family).filter(function (product) { return product.showInAppSwitcher; }).length > 0;
        return hasProducts && hasShownProducts;
    };
    OmnibarUnifiedSwitcher.prototype.anyResourcesPresent = function () {
        var hasResources = this.unityResources.length > 0;
        var hasShownResources = this.unityResources.filter(function (resource) { return resource.showInAppSwitcher; }).length > 0;
        return hasResources && hasShownResources;
    };
    OmnibarUnifiedSwitcher.prototype.resources = function () {
        return this.unityResources.filter(this.searchResources);
    };
    OmnibarUnifiedSwitcher.prototype.resourceFamilies = function () {
        return Object.keys(this.unityResources || []);
    };
    OmnibarUnifiedSwitcher.prototype.productLinkTarget = function (product) {
        return product.isNewTab ? product.id : '_self';
    };
    OmnibarUnifiedSwitcher.prototype.viewPlatformAlerts = function (product) {
        this.omnibarPlatformAlertAsideOpen.emit(product);
    };
    OmnibarUnifiedSwitcher.prototype.render = function () {
        var _this_1 = this;
        var renderApplications = function (path, iconKind) {
            return (h("div", { class: "o-unified-switcher__apps" }, path.map(function (product) {
                return product.showInAppSwitcher ? (h("div", { class: "o-unified-switcher__products" }, h("a", { href: product.url, target: _this_1.productLinkTarget(product), class: "o-unified-switcher__app", onClick: function () {
                        if (!product.isNewTab)
                            clearSession();
                        _this_1.unifiedMenuItem.close();
                    } }, h("span", { class: "o-unified-switcher__icon" }, h("omnibar-icon", { kind: iconKind, icon: product.label })), h("span", { class: "o-unified-switcher__name" }, product.name)), product.alertsCount ?
                    (h("omnibar-tooltip", { text: product.alertsCount + " product alert" + (product.alertsCount > 1 ? 's' : ''), placement: "left" }, h("omnibar-icon", { class: "o-unified-switcher__icon__alert", onClick: function (event) { event.stopPropagation(); _this_1.viewPlatformAlerts(product); }, icon: "interface-alert-triangle" }))) : '')) : null;
            })));
        };
        var renderUnifiedAppSwitcher = function () {
            var _a;
            return (h("div", null, h("div", { class: "o-unified-switcher__search" }, h("input", { type: "text", class: "o-unified-switcher__search-input", placeholder: "Search", value: _this_1.searchQuery, onInput: _this_1.updateSearchQuery }), h("omnibar-icon", { icon: "search" })), _this_1.productFamilies().map(function (family) {
                if (_this_1.anyProductsPresent(family)) {
                    return (h("div", { class: "o-unified-switcher__family-group" }, h("div", { class: "o-unified-switcher__family" }, family), renderApplications(_this_1.products(family), 'product')));
                }
            }), _this_1.anyResourcesPresent() &&
                h("div", { class: "o-unified-switcher__family-group" }, h("div", { class: "o-unified-switcher__family" }, "Resources"), renderApplications(_this_1.resources(), 'resource')), (_this_1.authenticated && ((_a = _this_1.api) === null || _a === void 0 ? void 0 : _a.productCode) !== 'UL') && h("div", { class: "o-unified-switcher__footer" }, h("button", { type: "button", onClick: function () { return _this_1.returnToHomePage.emit(); } }, "Return to Unified Platform"))));
        };
        var renderNavItem = function () {
            if (_this_1.authenticated) {
                if (_this_1.anyFamiliesPresent()) {
                    return (h("omnibar-unified-menu-item", { "menu-name": "App Switcher", icon: "omnibar-switcher", ref: function (el) { return _this_1.unifiedMenuItem = el; } }, renderUnifiedAppSwitcher()));
                }
            }
            else {
                return h("slot", { name: "unauthenticated" });
            }
        };
        return (h("div", { class: "o-unified-switcher" }, renderNavItem()));
    };
    Object.defineProperty(OmnibarUnifiedSwitcher.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OmnibarUnifiedSwitcher, "style", {
        get: function () { return "omnibar-unified-switcher{z-index:20}.o-omnibar .o-unified-switcher{height:100%;font-size:.75rem}.o-omnibar .o-unified-switcher__search{position:relative}.o-omnibar .o-unified-switcher__search-input{font-size:.625rem;outline:0;width:100%;padding-left:2rem;padding-right:.75rem;border-width:1px;border-color:transparent;height:2.5rem}.o-omnibar .o-unified-switcher__search-input:focus{outline:0;border-color:#0076cc;border-width:1px}.o-omnibar .o-unified-switcher__search omnibar-icon{font-size:.875rem;color:#afb3b6;position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);left:10px}.o-omnibar .o-unified-switcher__family{display:-ms-flexbox;display:flex;padding-top:1.5rem;padding-bottom:.75rem;padding-left:1rem;padding-right:1rem;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;background-color:#f7f8f9;font-size:.75rem;font-weight:500;text-transform:capitalize;border-top:1px solid #e4e6e7}.o-omnibar .o-unified-switcher__footer{border-top:1px solid #e4e6e7}.o-omnibar .o-unified-switcher__footer button{border-width:0;font-size:.75rem;color:#0076cc;padding-left:1rem;padding-right:1rem;padding-top:.75rem;padding-bottom:.75rem;font-weight:500;line-height:1;text-align:left;width:100%}.o-omnibar .o-unified-switcher__app{display:-ms-flexbox;display:flex;cursor:pointer;-ms-flex-align:center;align-items:center;padding-top:1rem;padding-bottom:1rem;padding-left:1.25rem;padding-right:1.25rem;text-decoration:none;width:100%;color:#303436;border-top:1px solid #e4e6e7;margin-top:-1px}.o-omnibar .o-unified-switcher__app omnibar-icon{font-size:1rem;color:#9ba3a7}.o-omnibar .o-unified-switcher .omnibar-unified-menu-item .o-dropdown{height:calc(100vh - 56px)}\@media (min-width:768px){.o-omnibar .o-unified-switcher .omnibar-unified-menu-item .o-dropdown{height:auto;max-height:calc(100vh - 56px)}.o-omnibar .o-unified-switcher .omnibar-unified-menu-item .o-dropdown>div{max-height:600px}}.o-omnibar .o-unified-switcher__icon{border-radius:9999px;background-color:#ebedee;margin-right:1rem;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:32px;height:32px}.o-omnibar .o-unified-switcher__icon__alert{padding-right:.5rem;padding-top:1.5rem;font-size:17px;color:#fec12d!important}.o-omnibar .o-unified-switcher__products{display:-webkit-box;display:-ms-flexbox;display:flex;border-top:1px solid #e4e6e7;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}\@media (max-width:640px){.o-omnibar .o-unified-switcher .o-unified-menu-item.active{position:fixed;width:100vw;max-width:100vw;min-width:100vw;right:0;-webkit-transition:.3s ease;transition:.3s ease}.o-omnibar .o-unified-switcher .o-unified-menu-item.active .menu-name{display:inline-block!important;font-size:1rem!important;padding-left:.75rem!important}.o-omnibar .o-unified-switcher .o-unified-menu-item.active .menu-close{display:inline-block!important}.o-omnibar .o-unified-switcher .o-unified-menu-item.active .menu-close omnibar-icon{font-size:1rem}.o-omnibar .o-unified-switcher .o-unified-menu-item.active .toggle{-ms-flex-pack:justify;justify-content:space-between;padding-left:1rem;padding-right:1rem;height:56px}}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarUnifiedSwitcher;
}());
ShellTunnel.injectProps(OmnibarUnifiedSwitcher, ['api', 'screenSize', 'authenticated', 'unityProducts', 'unityResources']);
var OmnibarUnifiedVendors = /** @class */ (function () {
    function OmnibarUnifiedVendors(hostRef) {
        var _this_1 = this;
        registerInstance(this, hostRef);
        this.authenticated = false;
        this.goToVendorMarketplace = function () {
            window.open(_this_1.generateVendorMarketplaceLink(), '_blank');
        };
    }
    OmnibarUnifiedVendors.prototype.generateVendorMarketplaceLink = function () {
        var _g = this, userName = _g.userName, userTitle = _g.userTitle, company = _g.company, companyId = _g.companyId, productCode = _g.api.productCode;
        var client = createClient('vendor', this.api);
        return client.getVendorMarketplaceLinkForUser(userName, userTitle, company, companyId, productCode);
    };
    OmnibarUnifiedVendors.prototype.render = function () {
        if (!this.authenticated) {
            return (h("div", { onClick: this.goToVendorMarketplace, class: "omnibar-unified-vendors" }, h("omnibar-unified-menu-item", { slot: "unauthenticated", "menu-name": "Vendor Marketplace", icon: "store" })));
        }
    };
    Object.defineProperty(OmnibarUnifiedVendors.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OmnibarUnifiedVendors, "style", {
        get: function () { return ".omnibar-unified-vendors{height:100%}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarUnifiedVendors;
}());
ShellTunnel.injectProps(OmnibarUnifiedVendors, ['authenticated', 'api']);
UserTunnel.injectProps(OmnibarUnifiedVendors, ['userName', 'userTitle']);
var OmnibarUserMenuItem = /** @class */ (function () {
    function OmnibarUserMenuItem(hostRef) {
        var _this_1 = this;
        registerInstance(this, hostRef);
        this.emitClickEvent = function () {
            _this_1.userMenuClick.emit({
                name: _this_1.menuName
            });
        };
        this.userMenuClick = createEvent(this, "userMenuClick", 7);
    }
    OmnibarUserMenuItem.prototype.render = function () {
        var _this_1 = this;
        return (this.url ?
            h("a", { href: this.url, onClick: this.emitClickEvent, class: 'omnibar-user-menu-item', title: this.menuName }, h("slot", null))
            :
                h("div", { role: "button", tabindex: 0, class: 'omnibar-user-menu-item', "aria-label": "menu-item", title: this.menuName, onClick: this.emitClickEvent, onKeyPress: function (e) {
                        if (e.key === 'Enter')
                            _this_1.emitClickEvent();
                    } }, h("slot", null)));
    };
    Object.defineProperty(OmnibarUserMenuItem, "style", {
        get: function () { return ".o-omnibar .omnibar-user-menu-item{background-color:transparent;border:0;color:inherit;margin:0;outline:none;padding:0;text-align:left;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;white-space:nowrap;height:43px;border-bottom:1px solid #e4e6e7;padding:15px}.o-omnibar .omnibar-user-menu-item:hover{background:#f7f6f6}.o-omnibar .omnibar-user-menu-item:focus{background:#e5f4ff}.o-omnibar .omnibar-user-menu-item>toggle{display:block;text-decoration:none;color:#303436;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:auto;width:100%}"; },
        enumerable: true,
        configurable: true
    });
    return OmnibarUserMenuItem;
}());
export { ContextConsumer as context_consumer, DemoShell as demo_shell, OmnibarActionMenu as omnibar_action_menu, OmnibarActionMenuItem as omnibar_action_menu_item, OmnibarAside as omnibar_aside, OmnibarAsideActions as omnibar_aside_actions, OmnibarAsideBody as omnibar_aside_body, OmnibarAsideFooter as omnibar_aside_footer, OmnibarAsideHeader as omnibar_aside_header, OmnibarAsideSubtitle as omnibar_aside_subtitle, OmnibarAsideTitle as omnibar_aside_title, RaulBulkActionBar as omnibar_bulk_action_bar, OmnibarButton as omnibar_button, OmnibarChangeCompanyModal as omnibar_change_company_modal, OmnibarCheckbox as omnibar_checkbox, OmnibarContainerLoader as omnibar_container_loader, OmnibarContextHelp as omnibar_context_help, OmnibarDatePicker as omnibar_date_picker, OmnibarDropdownMenu as omnibar_dropdown_menu, OmnibarGrid as omnibar_grid, OmnibarGridBody as omnibar_grid_body, OmnibarGridCell as omnibar_grid_cell, OmnibarGridRow as omnibar_grid_row, RaulIcon as omnibar_icon, OmnibarInput as omnibar_input, OmnibarModal as omnibar_modal, OmnibarModalBody as omnibar_modal_body, OmnibarModalFooter as omnibar_modal_footer, OmnibarModal$1 as omnibar_modal_header, OmnibarNavigation as omnibar_navigation, OmnibarNavigationItem as omnibar_navigation_item, OmnibarOption as omnibar_option, OmnibarPageCrumb as omnibar_page_crumb, OmnibarPageHeader as omnibar_page_header, OmnibarPageLoader as omnibar_page_loader, OmnibarPagingBar as omnibar_paging_bar, OmnibarProductAlerts as omnibar_product_alerts, OmnibarProductAlertsAsideNotification as omnibar_product_alerts_aside_notification, OmnibarScope as omnibar_scope, OmnibarSearch as omnibar_search, OmnibarSelect as omnibar_select, OmnibarShell as omnibar_shell, OmnibarSimpleSelect as omnibar_simple_select, OmnibarStatus as omnibar_status, OmnibarSwitch as omnibar_switch, OmnibarTabs as omnibar_tabs, OmnibarThemeToggle as omnibar_theme_toggle, OmnibarTooltip as omnibar_tooltip, OmnibarUnifiedHelp as omnibar_unified_help, OmnibarUnifiedHelpArticles as omnibar_unified_help_articles, OmnibarUnifiedHelpCenter as omnibar_unified_help_center, OmnibarUnifiedHelpKnowledgebase as omnibar_unified_help_knowledgebase, OmnibarUnifiedHelpUpdates as omnibar_unified_help_updates, OmnibarUnifiedHelpVideos as omnibar_unified_help_videos, OmnibarUnifiedMenu as omnibar_unified_menu, OmnibarUnifiedMenuItem as omnibar_unified_menu_item, OmnibarUnifiedNotifications as omnibar_unified_notifications, OmnibarUnifiedNotificationsAside as omnibar_unified_notifications_aside, OmnibarUnifiedNotificationsAsideNotification as omnibar_unified_notifications_aside_notification, OmnibarUnifiedNotificationsAsideRealpagealerts as omnibar_unified_notifications_aside_realpagealerts, OmnibarUnifiedNotificationsFooter as omnibar_unified_notifications_footer, OmnibarUnifiedNotificationsItems as omnibar_unified_notifications_items, OmnibarUnifiedSwitcher as omnibar_unified_switcher, OmnibarUnifiedVendors as omnibar_unified_vendors, OmnibarUserMenuItem as omnibar_user_menu_item };
